const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "Tsukuyomi Background",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "Failed to publish due to excessive scene assets. Please delete some assets and try again.",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "Currently no permission to access membership-related features",
  T_12_I_GIFT_SENDER_BELL: "Glocke",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: `Jetzt sehen Sie ihn, jetzt nicht mehr. 
t. [FFB300](verbirgt Helm)[-]`,
  T_12_L_ACCESSORY_COS_SANTAHEAD: "Maske des alten Mannes",
  T_12_L_COS_PINKMAN: "Rosa Dino",
  T_12_L_COS_POLAR: "Eisbär",
  T_12_L_COS_RENDER: "Regenbogen Dino",
  T_12_L_COS_TIGER: "Tigeranzug",
  T_12_L_MALE_BOTTOM_COS_ELF: "Winterelf (Unterteil)",
  T_12_L_MALE_COS_SANTA: "Mürrischer Alter Mann",
  T_12_L_MALE_HAIR_COS_ELF: "Winterelf (Kopf)",
  T_12_L_MALE_SHOE_COS_ELF: "Winterelf (Schuhe)",
  T_12_L_MALE_TOP_COS_ELF: "Winterelf (Oberteil)",
  T_12_O_CAT_NAME: "Kitty",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014-Winterland",
  T_12_O_MACHETE_GOLD_NAME: "Goldene Klinge",
  T_12_O_PET_TITLE: "HAUSTIER",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "Springende Schuhe",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "Schuhe mit moderner Technologie hergestellt. Ermöglicht Menschen Doppelsprünge durchzuführen",
  T_12_Q_ITEM_FLYSHOE: "Jet Pack Schuhe",
  T_12_Q_ITEM_FLYSHOE_DESC: "Schuhe, die dem Benutzer das Fliegen ermöglichen.",
  T_12_Q_ITEM_STOCK1: "Lager Lv 1",
  T_12_Q_ITEM_STOCK2: "Lager Lv 2",
  T_12_Q_ITEM_STOCK3: "Lager Lv 3",
  T_12_Q_ITEM_TREATMENTGUN: "Behandlungspistole",
  T_12_Q_ITEM_VEST4: "Weste Lv4",
  T_12_R_CHARACTER_GANGLEADER_NAME: "Antonio",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "Wukong",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "Tanz schießen",
  T_12_R_EMOTE_WAVE_NAME: "Armwelle",
  T_12_R_SKILL_NAME_GANGLEADER: "Gangsters Geist",
  T_12_R_SKILL_NAME_MONKEYGOD: "Tarnung",
  T_13_I_COLLECTION_V_AMPHIBIAN: "Amphibienauto",
  T_13_I_COLLECTION_V_JEEP: "Jeep",
  T_13_I_COLLECTION_V_MONSTER: "Monster Truck",
  T_13_I_COLLECTION_V_MOTOBIKE: "Motorrad",
  T_13_I_COLLECTION_V_ROADSTER: "Sportwagen",
  T_13_I_COLLECTION_V_SUV: "Pickup",
  T_13_I_COLLECTION_V_TUTU: "Tu Tu Auto",
  T_13_L_MALE_ACCESSORY_COS_BJD: "Arktisches Blau (Maske)",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "Liebe in der Luft (Unterteil)",
  T_13_L_MALE_HAIR_COS_BJD: "Arktisches Blau (Kopf)",
  T_13_L_MALE_TOP_COS_VALENTINE: "Liebe in der Luft (Oberteil)",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "Waffen",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "Haustierhaut: Detektiv Kitty",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR- Amor",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "Moco",
  T_13_R_EMOTE_BABYSHARK_NAME: "Babyhai",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "Hochdrücken",
  T_13_R_EMOTE_EGYPT_NAME: "Mumietanz",
  T_13_R_PVE_WEAPON_SLOT: "Waffenschlitz",
  T_13_R_PVE_WEAPONSKIN_RANGE: "Effektive Reichweite",
  T_13_R_PVE_WEAPONSKIN_SPEED: "Schussrate",
  T_13_R_SKILL_DESC_HACKERGIRL: "Markiere den Schuss von Gegner {0} Sekunden lang. Informationen werden mit Teamkollegen geteilt",
  T_13_R_SKILL_NAME_HACKERGIRL: "Hackers Auge",
  T_13_Z_KICKOFF_BAN: "VERBOT",
  T_13_Z_ROOM_MORNING: "Tag",
  T_13_Z_ROOM_NIGHT: "Nacht",
  T_14_G_ITEM_KATANA: "Katana",
  T_14_I_HEADPIC_SONGKRAN_NAME: "SPRITZEN!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "Kubischer Hase",
  T_14_L_COS_EASTER: "Beobachter 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "Dame der Flamme (Schuhe)",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "Bunny Warrior (Maske)",
  T_14_O_AK_WATERSPLASHING_NAME: "AK- Wasserballon",
  T_14_O_DOG_NAME: "Mechanischer Welpe",
  T_14_O_PETSKIN_IRON_DOG_NAME: "Haustierhaut: Vollstahlwelpe",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "Haustierhaut: Blitz Welpe",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "Haustierhaut: Magnetischer Welpe",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "Haustierhaut: Nacht Kitty",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR-Blutmond",
  T_14_O_SCAR_SHARK_NAME: "SCAR - Hai-Angriff",
  T_14_Q_ITEM_RGS50: "Anti-Material-Gewehr",
  T_14_R_CHARACTER_SAMURAI_NAME: "Hayato",
  T_14_R_SKILL_DESC_SAMURAI: "Wenn die maximale LP um {0}% verringert wird, erhöht die Rüstungsdurchdringung von {1}%",
  T_14_R_SKILL_NAME_SAMURAI: "Rüstungsdurchdringung",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "Hungerstreik (Maske)",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "Venom Touch (Maske)",
  T_15_L_MALE_BOTTOM_COS_FAIM: "Hungerstreik (Unterteil)",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "Venom Touch (Unterteil)",
  T_15_L_MALE_SHOE_COS_FAIM: "Hungerstreik (Schuhe)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "Venom Touch (Schuhe)",
  T_15_L_MALE_TOP_COS_FAIM: "Hungerstreik (Obereteil)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "Venom Touch (Oberteil)",
  T_15_L_TOP_COS_MOTHERSDAY: "Beste Mutter",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94 - Katastrophe",
  T_15_O_BASEBALLBAT_VIKING_NAME: "Der Wikinger",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014 - Katastrophe",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1 - Katastrophe",
  T_15_O_PANTHER_NAME: "Nachtpanther",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "Kapitän",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "Goldener Leopard",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "Herrschaft",
  T_15_O_SKS_DEATH_NAME: "SKS - Todeswunsch",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP - Katastrophe",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "GATLING",
  T_15_R_CHARACTER_AGENT_NAME: "Laura",
  T_15_R_EMOTE_LETSGROOVE_NAME: "Mit mir schütteln",
  T_15_R_SKILL_DESC_AGENT: "Erhöht die Genauigkeit um {0}% während Zielen",
  T_15_R_SKILL_NAME_AGENT: "Scharfer Schütze",
  T_15_W_BACKPACK_MECHGIRL_NAME: "Lila Flügel",
  T_16_B_ITEM_GRAPPLINGHOOK: "Greiferhaken",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "Greiferpistole",
  T_16_L_MALE_COS_LEGO: "Verrückter Ziegelmann",
  T_16_L_MALE_SHOE_COS_SUMMER: "Sommerferien (Schuhe)",
  T_16_P_MANUAL_MONSTER: "Monster Truck",
  T_16_P_MANUAL_MUSHROOM1: "Pilze Lv1",
  T_16_P_MANUAL_MUSHROOM2: "Pilze Lv2",
  T_16_P_MANUAL_MUSHROOM3: "Pilze Lv3",
  T_16_P_MANUAL_MUSHROOM4: "Pilze Lv4",
  T_16_P_MANUAL_ROADSTER_DESC: "Stilvoller Sportwagen. Niedrige LP, aber verrückte Höchstgeschwindigkeit. Kann bis zu 2 Spieler tragen.",
  T_16_P_MANUAL_STROP: "Seilrutsche",
  T_16_P_MANUAL_SUV: "Pickup",
  T_16_P_MANUAL_SUV_DESC: "Das Signature-Fahrzeug von Free Fire. Mittlere Rüstung und Höchstgeschwindigkeit. Kann bis zu 2 Spieler tragen.",
  T_16_P_MANUAL_TUTU_DESC: "Ein Fahrzeug mit niedrigen LP und langsamer Bewegung. Kann bis zu 3 Spieler tragen.",
  T_16_P_MANUAL_WEAPON_AR: "Gewehr",
  T_16_P_MANUAL_WEAPON_BOMB: "Granaten",
  T_16_P_MANUAL_WEAPON_PISTOL: "Pistole",
  T_16_P_MANUAL_WEAPON_SG: "Schrotflinte",
  T_16_P_MANUAL_WEAPON_SMG: "SMG",
  T_16_P_MANUAL_WEAPON_SR: "Scharfschütze",
  T_16_Q_MINISENTRY: "Mini Türme",
  T_16_Q_MINISENTRY_DESC: "Autoturm aus moderner Technologie. Es scannt und greift Gegner in der Nähe an.",
  T_16_R_EMOTE_DESERT_NAME: "Wütender Schlag",
  T_16_R_EMOTE_EPHUNTER_NAME: "Kampftanz",
  T_16_R_EMOTE_EPHUNTER2_NAME: "Gib mir fünf",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "Mond Flip",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "Wackelspaziergang",
  T_16_W_AK_FIRE_NAME: "AK- Flammendes Rot",
  T_16_W_SCAR_LLENN_NAME: "SCAR- Rosa Teufel",
  T_16_W_SCAR_WATER_NAME: "SCAR- Wasserelementar",
  T_16_Y_CHARACTER_HITMAN_NAME: "Rafael",
  T_16_Y_PANDA_NAME: "Detektiv Panda",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "Haustier Skin: Wilder Panda",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "Schädel Penda",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "Blitz Panda",
  T_17_B_CS_MODE_NAME: "Clash Squad",
  T_17_C_SKILL_NAME_PLAYBOY: "Nussige Bewegung",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "Königsspaßvogel (Maske)",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "Blutige Frau (Maske)",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "Blutige Frau (Unterteil)",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "Magischer Fuchs (Kopf)",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "Blutige Frau (Schuhe)",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "Blutige Frau (Oberteil)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "Vampirs Rache (Maske)",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "Straßengangster (Unterteil)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "Vampirs Rache (Unterteil)",
  T_17_L_MALE_HAIR_COS_FFUNIT: "Lila Schatten (Kopf)",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "Ehrenmann (Schuhe)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "Vampirs Rache (Schuhe)",
  T_17_L_MALE_TOP_COS_VAMPIRE: "Vampirs Rache (Oberteil)",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "Goldener Schatten (Oberteil)",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "Haustierhaut: Miau Prinzessin",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "Haustierhaut: Goldene Geschichte",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "Haustierhaut: Dunkelblau",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "Haustierhaut: Glückliches Grün",
  T_17_O_SHIBA_NAME: "Shiba",
  T_17_Q_FOLDWINGS: "Gleiter",
  T_17_Q_FOLDWINGS_DESC: "Ermöglicht das Herabgleiten aus erhöhtem Gelände.",
  T_17_Q_SUPERHEAT: "PLASMA",
  T_17_R_EMOTE_PARTYDANCE_NAME: "Partytanz",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS- Vampir",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR- Phantom Attentäter",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR- Altmodisch",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "Joseph",
  T_17_Z_CS_NAME: "Name",
  T_17_Z_ROOM_JUMP_SWITCH: "Sprunghöhe",
  T_17_Z_ROOM_SPEED_SWITCH: "Geschwindigkeit",
  T_18_B_THROWINGKNIFE_NAME: "FF Messer",
  T_18_C_DUMMY_NAME: "Köder Granate",
  T_18_C_SKILL_DESC_DJMALE: "Erstellt eine {1}m große Aura, die die Bewegungsgeschwindigkeit um {3}% erhöht und {2} HP pro Sekunde für {0}s. wiederherstellt. Die Effekte sind nicht stapelbar. CD: {4}s.",
  T_18_C_SKILL_NAME_DJMALE: "Gibt den Takt an",
  T_18_C_SKILL_NAME_JUNKENGINEER: "Ausrüstung recyceln",
  T_18_L_COS_INDIANEWYEAR: "Diwali Dino",
  T_18_L_HAIR_COS_HALLOWEEN2019: "Stirnrunzelndes Gesicht",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "Flammendes Rot (Maske)",
  T_18_O_FOX_NAME: "Silberfuchs",
  T_18_O_PETSKIN_BLACKFOX_NAME: "Haustier Skin: Kampffuchs",
  T_18_O_PETSKIN_BLUEFOX_NAME: "Haustier Skin: Blaufuchs",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "Haustierhaut: Lava-Kürbis",
  T_18_O_PETSKIN_PINKFOX_NAME: "Haustier Skin: Rotfuchs",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "Haustierhaut: Geist",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1- Flammender Schädel",
  T_18_W_UMP_GEISHA_N: "UMP- Kunst des Krieges",
  T_18_Y_CHARACTER_DJMALE_N: "Alok",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "Shani",
  T_19_B_HB_NAME: "Elektrosurfbrett",
  T_19_C_ICE_GUN_NAME: "Eiswaffe",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "Explosiver Waffenschaden erhöht sich um {0}%, Schadensreichweite um {1}%",
  T_19_C_SKILL_DESC_TOMBOY: "Wenn im Wagen,wird alle {0} Sekunden {1} LP wiederherstellt , bis zu {2} Sekunden. Effekte sind nicht stapelbar",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "Kunst von Explosion",
  T_19_C_SKILL_NAME_TOMBOY: "Segen von Rennfahrer",
  T_19_I_EVENT_INFI_ITEM: "Unbegrenzt",
  T_19_L_A_ICEFESTIVAL19_B: "Letzte Lache",
  T_19_L_F_S_ICEFESTIVAL: "Schneedienerin (Schuhe)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "Disco Fiasco (Unterteil)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "Disco Fiasco (Kopf)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "Disco Fiasco (Oberteil)",
  T_19_O_PETSKIN_NAME: "Haustierhaut: Standard",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "Haustierhaut: Hiphop Panda",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "Haustierhaut:Polarpanda",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "Haustierhaut: Pharaos Robo",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "Haustierhaut: Frühlingsfest Robo",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "Haustier Skin: Snowy Robo",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "Haustierhaut: Hiphop Schiba",
  T_19_O_ROBOT_NAME: "Robo",
  T_19_O_TDM_NAME: "Team Deathmatch",
  T_19_R_EMOTE_MIGUEL_NAME: "Breakdance",
  T_19_S_SECOND_WEAPON_TITLE: "Sekundärwaffe",
  T_19_S_VEST_TITLE: "Kugelsichere Weste",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "Doppelmagazin",
  T_19_W_GROZA_TAGGERCREW_N: "GROZA- Aufstand",
  T_19_W_M60_ICEFESTIVAL_N: "M60- Santas Entscheidung",
  T_19_W_MP40_PARK_N: "MP40- Karneval Gemetzel",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR- Goldener Drache",
  T_19_X_PVE_SAMURAINAME: "Wächter-Samurai",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "Alvaro",
  T_19_Y_CHARACTER_TOMBOY_N: "Notora",
  T_20_C_INHALER_NAME: "Inhalator",
  T_20_C_SKILL_DESC_PARKOURGUY: "Wenn du eine Waffe benutzt, erhältst du, wenn du einen Gegner triffst, einige HP zurück, wenn du einen Gegner niederschlägst, erhältst du {0}% HP zurück.",
  T_20_C_SKILL_NAME_GRAFFITIST: "Gemalter Schutzort",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "Tödliches Tempo",
  T_20_C_SKILL_NAME_PARKOURGUY: "Anhaltende Angriffe",
  T_20_L_A_APRILFOOL2020: "Hund",
  T_20_L_F_A_METALHEAD_RED: "Frau Feuerrot Kobold-Kopf (Maske)",
  T_20_L_F_B_THAIGIRL: "Phönix (Unterteil)",
  T_20_L_F_H_KILLERCUPID: "Schatz Amor (Kopf)",
  T_20_L_F_H_THAIGIRL: "Phönix (Kopf)",
  T_20_L_F_S_THAIGIRL: "Phönix (Schuhe)",
  T_20_L_F_T_METALHEAD_RED: "Frau Feuerrot Kobold-Kopf  (Oberteil)",
  T_20_L_F_T_THAIGIRL: "Phönix (Oberteil)",
  T_20_L_JEANDINO: "Denim Dino",
  T_20_L_M_A_METALHEAD_RED: "Herr Feuerrot Kobold-Kopf (Maske)",
  T_20_L_M_T_METALHEAD_RED: "Herr Feuerrot Kobold-Kopf  (Oberteil)",
  T_20_L_M_T_STOCKING: "Gentleman (Oberteil)",
  T_20_O_PETSKIN_LOVERFOX_NAME: "Haustierhaut: Valentinsfuchs",
  T_20_P_CHANNEL_G: "Gilde",
  T_20_P_WORLD_SSPEAKER: "Lautsprecher",
  T_20_S_CSROOM_COIN: "Standardmünze",
  T_20_U_SHIELD_GUN_NAME: "Schildpistole",
  T_20_W_AN94_METALHEAD_N: "AN94- Karotte Kobold-Kopf",
  T_20_W_P90_EVILBONE_N: "P90- Rächer",
  T_20_Y_CHARACTER_GRAFFITIST_N: "Steffie",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: 'Kelly " Der Blitz "',
  T_20_Y_CHARACTER_PARKOURGUY_N: "Jota",
  T_21_B_SMOKEGRENADE_DESC: "Erzeugt Rauch, der sich hervorragend zum Abschirmen und für flankierende Manöver eignet",
  T_21_B_SMOKEGRENADE_NAME: "Rauchgranate",
  T_21_C_AUTOPICKUP_AVERAGE: "Standard",
  T_21_C_SKILL_DESC_KPOPSINGER: "Erhöht die Wirkung von Heilungsgegenständen um {0}% und die Heilfähigkeiten um {1}%. Reduziert den LP-Verlust von niedergeschlagenen Teammitgliedern um {2}%.  Effekte werden nicht gestapelt",
  T_21_C_SKILL_DESC_SOCCERSTAR: "Jede Tötung erhöht die maximale LP um {0}, bis zu {1}",
  T_21_C_SKILL_NAME_KPOPSINGER: "Heilungslied",
  T_21_C_SKILL_NAME_SOCCERSTAR: "Hattrick",
  T_21_L_ANGELICAL: "Engel Dino",
  T_21_L_S_VNSLIPPER: "Vietnam-Hausschuhe",
  T_21_O_OTTER_NAME: "Ottero",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "Haustierhaut: Radioaktiver Ottero",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "Haustierhaut: Sakura Ottero",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "Haustierhaut: Neon Ottero",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "Haustier Skin: Meister vom Tod",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "Haustierhaut: Blitz",
  T_21_R_EMOTE_SORROW_NAME: "Warum? Oh warum?",
  T_21_U_WEAPON_THOMPSON_NAME: "Thompson",
  T_21_W_BACKPACK_SPINE_N: "Punker Rucksack",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "Der letzte Schlag des Todes",
  T_21_W_M79_RABBITKILLER_N: "M79- Hipster Kaninchen",
  T_21_W_PAN_VOLCANO_N: "Pfanne- Vulkanwut",
  T_21_W_XM8_RAINBOW_N: "XM8- Songkran",
  T_21_Y_CHARACTER_KPOPSINGER_N: "Kapella",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "Luqueta",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "Suche Positionen von Gegnern innerhalb von {0}m, die sich nicht in Bauchlage oder Couch befinden. Letzte für {1}s, CD{2}s, Feindliche Positionen werden mit Teamkollegen geteilt.",
  T_22_C_SKILL_NAME_DETECTIVE: "Verfolgende Schritte",
  T_22_C_SKILL_NAME_STREAMERGUY: "Kalklicht",
  T_22_L_F_H_COLLEGE: "Blutiger Junior (Kopf)",
  T_22_L_F_S_SUMMER20: "Sommer-Schätzchen (Schuhe)",
  T_22_L_M_A_GREENCOAT: "Üppiger Clubber (Maske)",
  T_22_L_M_A_PINKFUR: "Sakura Clubber (Maske)",
  T_22_L_M_A_PLAGUE2: "Pestphantom (Maske)",
  T_22_L_M_B_FAIM2: "Hungerverbrecher (Unterteil)",
  T_22_L_M_B_GREENCOAT: "Üppiger Clubber (Unterteil)",
  T_22_L_M_B_PINKFUR: "Sakura Clubber (Unterteil)",
  T_22_L_M_B_PLAGUE2: "Pestphantom (Unterteil)",
  T_22_L_M_B_REDPANTS: "Modischer Clubber (Unterteil)",
  T_22_L_M_B_TIGERSTRIPE: "Tiger Clubber (Unterteil)",
  T_22_L_M_H_COLLEGE: "Blutiger Senior (Kopf)",
  T_22_L_M_H_FAIM2: "Hungerverbrecher (Kopf)",
  T_22_L_M_H_GREENCOAT: "Üppiger Clubber (Kopf)",
  T_22_L_M_H_PINKFUR: "Sakura Clubber (Kopf)",
  T_22_L_M_H_PLAGUE2: "Pestphantom (Kopf)",
  T_22_L_M_H_REDPANTS: "Modischer Clubber (Kopf)",
  T_22_L_M_H_TIGERSTRIPE: "Tiger Clubber (Kopf)",
  T_22_L_M_S_FAIM2: "Hungerverbrecher (Schuhe)",
  T_22_L_M_S_PLAGUE2: "Pestphantom (Schuhe)",
  T_22_L_M_T_FAIM2: "Hungerverbrecher (Oberteil)",
  T_22_L_M_T_GREENCOAT: "Üppiger Clubber (Oberteil)",
  T_22_L_M_T_PINKFUR: "Sakura Clubber (Oberteil)",
  T_22_L_M_T_PLAGUE2: "Pestphantom (Oberteil)",
  T_22_L_M_T_REDPANTS: "Modischer Clubber (Oberteil)",
  T_22_L_M_T_TIGERSTRIPE: "Tiger Clubber (Oberteil)",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98K- Rebellenakademie",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "Pan- Wassermelone",
  T_22_LC_SCAR_HERMIT_N: "SCAR- Geheimnisvoller Verfolger",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "Behandlungspistole- Lifebeam",
  T_22_O_HAWK_NAME: "Falco",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "Haustier Skin: Apokalypse-Fuchs",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "Haustierhaut: Höllenfeuer Falco",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "Haustierhaut: Immergrün Falco",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "Haustier Skin: Sonnenschein Shiba",
  T_22_Q_BOMB_PLIERS: "Entschärfungszange",
  T_22_R_EMOTE_SHIMMY_NAME: "Shimmy",
  T_22_U_GOLD_AWM_N: "AWM-Y",
  T_22_U_WPNSKN_BITE: "Rüstungsdurchdringung",
  T_22_U_WPNSKN_SPEED_RUN: "Bewegungsgeschwindigkeit",
  T_22_Y_CHARACTER_DETECTIVE_N: "Clu",
  T_22_Y_CHARACTER_STREAMERGUY_N: "Wolfrahh",
  T_23_B_CARDIAC_NAME: "Horizalin",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "Kunst der Klingen",
  T_23_C_SKILL_NAME_SWATGUY: "Raging Reload",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: 'Hayato "Feuerbrand"',
  T_23_D_CHARACTER_SWATGUY_N: "Jai",
  T_23_L_F_B_GANGSTERRAP_GOLD: "Stimmung von Reichtum (Unterteil)",
  T_23_L_F_B_MIKOGIRL: "Polarlicht-Priesterin (Unterteil)",
  T_23_L_F_B_NAVYGIRL: "Marine-Mädchen (Unterteil)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "Stimmung von Reichtum (Kopf)",
  T_23_L_F_H_MIKOGIRL: "Polarlicht-Priesterin (Kopf)",
  T_23_L_F_H_NAVYGIRL: "Marine-Mädchen (Kopf)",
  T_23_L_F_S_MIKOGIRL: "Polarlicht-Priesterin (Schuhe)",
  T_23_L_F_S_ORDERCHALLENGER: "Raub-Genie (Schuhe)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "Stimmung von Reichtum (Oberteil)",
  T_23_L_F_T_MIKOGIRL: "Polarlicht-Priesterin (Oberteil)",
  T_23_L_F_T_NAVYGIRL: "Marine-Mädchen (Oberteil)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "Reicher Rapper (Maske)",
  T_23_L_M_B_FOXGUY: "Polarlicht-Priester (Unterteil)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "Reicher Rapper (Unterteil)",
  T_23_L_M_H_FOXGUY: "Polarlicht-Priester (Kopf)",
  T_23_LC_SKS_GEMINI_N: "SKS- Hysterischer Verrückter",
  T_23_O_PENGUIN_NAME: "Herr Waggor",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "Haustier Skin: Party Waggor",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "Haustier Skin: Cyber Waggor",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "Haustier Skin: Gold Waggor",
  T_23_T_ANNI3_LOBBY_NODENAME20: "Clash Squad",
  T_23_T_ANNI3_LOBBY_NODENAME5: "Charakter",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "UID",
  T_24_AD_ADSPACE_WARNING: "Warnung",
  T_24_C_FLAMETHROWER_NAME: "Flammenwerfer",
  T_24_C_SKILL_DESC_PROFESSOR: "Die maximale EP erhöht sich um {0}. Jiu-Jitsu-Modus: Verbündete innerhalb von {2}m erhalten eine {1}% Erhöhung der EP-Conversion-Rate. Psychologiemodus: Wiederherstellen von {5} EP alle {4}s bis zu {6} EP. Moduswechsel-CD: {3}s",
  T_24_C_SKILL_NAME_PARTYGIRL: "Feiern auf",
  T_24_C_SKILL_NAME_PROFESSOR: "Meister von allem",
  T_24_D_CHARACTER_PARTYGIRL_N: "Dasha",
  T_24_D_CHARACTER_PROFESSOR_N: "K",
  T_24_L_B_MAXPANTS: "Max Hose",
  T_24_L_H_PUMPKIN2020_A: "Twisted Kürbis (Kopf)",
  T_24_L_T_TSHIRT_COMEDIAN: "Letzter Schuss Held",
  T_24_LC_MP5_RICHBOXER_N: "MP5- Boxer Meister",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR- Tierparty",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD- Legendäre Schwertkämpfer",
  T_24_U_M21A5: "Woodpecker",
  T_24_U_PARAFAL: "FN-FAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "Gesamtpunktzahl",
  T_24_V_TRAINING_BOX_ATTACH: "Zusatzteile",
  T_24_V_TRAINING_BOX_WEAPON: "Waffen",
  T_24_W_ARMORY: "Waffen",
  T_24_W_ARMOTY_MELEE: "Nahkampf",
  T_24_W_ARMOTY_PISTOL: "Pistolen",
  T_24_W_ARMOTY_RIFLE: "Gewehre",
  T_24_W_ARMOTY_SHOTGUN: "Schrotflinten",
  T_24_W_ARMOTY_SNIPER: "Scharfschützen",
  T_24_W_ARMOTY_SPECIAL: "Andere",
  T_24_W_ARMOTY_SUBMACHINE: "Maschinenpistole",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "Haustier Skin: Booyah Panda",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "Haustier Skin: Skeleton Rockie",
  T_24_W_PETSKIN_RACCOON_MECH_N: "Haustier Skin: Party Rockie",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "Haustier Skin: Undead Rockie",
  T_24_W_RACCOON_N: "Rockie",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "Time Turner",
  T_25_D_CHARACTER_BOUNTY_N: "Chrono",
  T_25_E_HUD_01: "Voreinstellung 1",
  T_25_E_HUD_02: "Voreinstellung 2",
  T_25_L_F_B_DEMONKILLER: "Raserei Hochschule (Unterteil)",
  T_25_L_F_H_DEMONKILLER: "Raserei Hochschule (Kopf)",
  T_25_L_F_S_DEMONKILLER: "Raserei Hochschule (Schuhe)",
  T_25_L_F_T_DEMONKILLER: "Raserei Hochschule (Oberteil)",
  T_25_L_HA_FP_EVIL: "Böse (Gesichtsfarbe)",
  T_25_L_M_H_ANIMEHAIR: "Luftig (Haar)",
  T_25_L_S_MAXSNEAKERS: "MAX Turnschuhe",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "Cyber Swing",
  T_25_LC_GLOO_WINTERFEST2020_N: "Gloo Wand- Winterland 2020",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887- Winterland 2020",
  T_25_LC_MACHETE_BOUNTY_N: "Cyber Blade",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90- Tune Blaster Grün",
  T_25_LC_P90_MUSICFALL_RED_N: "P90- Tune Blaster Rot",
  T_25_LC_PAN_BOUNTY_N: "Pan- Cyber Kopfgeldjäger",
  T_25_R_LEGEND_REMIND: "Erinnerung",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "Sense",
  T_25_U_VECTOR: "Vector",
  T_25_W_BABOON_N: "Beaston",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "Haustier Skin: Gletscher Beaston",
  T_25_W_PETSKIN_BABOON_HELL_N: "Haustier Skin: Blazing Beaston",
  T_25_W_PETSKIN_BABOON_PURE_N: "Haustier Skin: Great White Beaston",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "Haustier Skin: Schneepanther",
  T_25_Z_R_SIMULATOR_OFF: "Nicht zulassen",
  T_26_C_SKILL_DESC_SUPERSTAR: "Löse eine Schallwelle nach vorne, beschädige {1} Gloo Wand innerhalb von {0} m, CD {2} s. Außerdem führt jede bereitgestellte Gloo Wand zu einer Erhöhung der HP-Wiederherstellung ab {3} Punkten. Wiederherstellungseffekte werden nicht gestapelt.",
  T_26_C_SKILL_NAME_SUPERSTAR: "Riptide Rhythmus",
  T_26_D_CHARACTER_DELIVERY_N: "Shirou",
  T_26_D_CHARACTER_SUPERSTAR_N: "Skyler",
  T_26_ET_CELLPHONE_NAME: "UAV-Lite",
  T_26_L_A_FLAMING_PREM: "Höllischer Soldat (Maske)",
  T_26_L_A_SANTAMODE: "Snowman Bob (Maske)",
  T_26_L_B_SANTAMODE: "Snowman Bob (Unterteil)",
  T_26_L_F_B_WATERFEST21_A: "Sommer Brise (Unterteil)",
  T_26_L_F_H_WATERFEST21_A: "Sommer Brise (Kopf)",
  T_26_L_F_S_WATERFEST21_A: "Sommer Brise (Schuhe)",
  T_26_L_F_T_WATERFEST21_A: "Sommer Brise (Oberteil)",
  T_26_L_M_A_EGGDAY2021: "Cyber Bunny (Maske)",
  T_26_L_M_B_EGGDAY2021: "Cyber Bunny (Unterteil)",
  T_26_L_M_B_PAIRING: "Dynamisches Duo M (Unterteil)",
  T_26_L_M_B_WATERFEST21_A: "Sommer Welle (Unterteil)",
  T_26_L_M_H_EGGDAY2021: "Cyber Bunny (Kopf)",
  T_26_L_M_H_PAIRING: "Dynamisches Duo M (Kopf)",
  T_26_L_M_H_WATERFEST21_A: "Sommer Welle (Kopf)",
  T_26_L_M_S_EGGDAY2021: "Cyber Bunny (Schuhe)",
  T_26_L_M_S_PAIRING: "Dynamisches Duo M (Schuhe)",
  T_26_L_M_S_WATERFEST21_A: "Sommer Welle (Schuhe)",
  T_26_L_M_T_EGGDAY2021: "Cyber Bunny (Oberteil)",
  T_26_L_M_T_PAIRING: "Dynamisches Duo M (Oberteil)",
  T_26_L_M_T_WATERFEST21_A: "Sommer Welle (Oberteil)",
  T_26_L_S_SANTAMODE: "Snowman Bob (Schuhe)",
  T_26_L_T_SANTAMODE: "Snowman Bob (Oberteil)",
  T_26_LC_AWM_KOICARP_N: "AWM- Lucky Koi",
  T_26_LC_KATANA_VALENTINE2021_N: "Katana- Season of Pink",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "Sportwagen- Kobra",
  T_26_P_SKILL_NAME_DELIVERY: "Schaden geliefert",
  T_26_V_TRAINING_BHH: "Kunstvoller Hammer",
  T_26_V_TRAINING_DICE: "Riesenwürfel",
  T_26_W_DRAGON_N: "Dreki",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "Haustier Skin: Splashy Dreki",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "Haustier Skin: Zapping Dreki",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "Haustier Skin: Galaxis Dreki",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "Haustier Skin: Waggor in Love",
  T_26_XL_SETTING_TEAMMATE_INFO: "Teamkollege Info",
  T_26_YP_HISTORY_WIN: "Sieg",
  T_26_YP_SOCIAL_GENDER_FEMALE: "Weiblich",
  T_26_YP_SOCIAL_GENDER_MALE: "Männlich",
  T_26_YP_SOCIAL_NAME: "Spitzname",
  T_27_C_SKILL_DESC__RACERGIRL: "Die Fahrgeschwindigkeit erhöht sich um {0}%. Im Fahrzeug ist es schwieriger, auf den Charakter zu zielen, und der erlittene Schaden verringert sich um {1}%.",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "Erzeugt ein undurchdringliches Kraftfeld, das {0} Schaden blockiert. Es ist nicht möglich, Feinde außerhalb des Feldes anzugreifen. Alle Effekte halten {1}s lang an. CD {2}s.",
  T_27_C_SKILL_DESC_FALCONER: "Der Schaden steigt mit der Entfernung um bis zu {0}%. Der Schaden markierter Gegner erhöht sich um {1}%",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "Erwachen: Reduziert den Frontalschaden um {1}% pro {0}% des maximalen HP-Verlust",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "Erwachen: Sprint für {0}s, um aktiviert zu werden. Bei Aktivierung verursacht der erste {2} Schuss auf das Ziel {1}% Schaden. Hält {3} Sekunden an.",
  T_27_C_SKILL_NAME_FALCONER: "Falke Leidenschaft",
  T_27_C_SKILL_NAME_XTREME: "Xtreme Begegnung",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: 'Andrew "The Fierce"',
  T_27_D_CHARACTER_FALCONER_N: "Maro",
  T_27_D_CHARACTER_XTREME_N: "Xayne",
  T_27_F_EAP_PKG3_D: "Battle in style!",
  T_27_HYL_SKILLBOARD_HP: "HP",
  T_27_L_A_CARDBOARD_MID2: "Tiger Papercut (Maske)",
  T_27_L_B_CARDBOARD_REG: "Graubär Papercut (Unterteil)",
  T_27_L_M_S_KAZAKHSTAN: "Der Baghatur (Schuhe)",
  T_27_L_S_CARDBOARD_REG: "Graubär Papercut (Schuhe)",
  T_27_L_T_CARDBOARD_REG: "Graubär Papercut (Oberteil)",
  T_27_LC_VECTOR_FFWS2021_N: "Vector- FFWS 2021",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "Monster Truck- FFWS 2021",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "Motorrad- K.O. Night",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "Sportwagen- Smaragdblitz",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "Pickup- Flamme Draco",
  T_27_P_SKILL_NAME_HITMAN_RE: "Dead Silent",
  T_27_R_EMOTE_GREETING_NAME: "Schöne Grüße",
  T_27_R_VEHICLE_ACCELERATION: "Beschleunigung",
  T_27_R_VEHICLE_HP: "Haltbarkeit",
  T_27_R_VEHICLE_SPEED: "Höchstgeschwindigkeit",
  T_27_U_KORD: "Kord",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "Erwachen: Reduzierung des Rüstungsschadens um {0}% erhöht. Zusätzliche 15% Schadensreduzierung mit jedem zusätzlichen Teamkollegen, der diese Fertigkeit trägt.",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "Wolf Pack",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "Moony",
  T_27_W_ARMOTY_DMR: "Marksmangewehr",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "Haustier Skin: Crystal Moony",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "Haustier Skin: Gamer Moony",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "Haustier Skin: Hipster Moony",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "Haustier Skin: FFWS 2021 Pup",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "Haustier Skin: FFWS 2021 Panda",
  T_27_XC_REPLAY_DIE: "Tod",
  T_27_XC_REPLAY_KILL: "Kill",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "Reparatur",
  T_28_C_G_ICE_NAME: "Flash Freeze",
  T_28_C_SKILL_DESC_STREETBEAT: "Beim Schießen während der Bewegung erhöht sich die Bewegungsgeschwindigkeit um {0}%, die Genauigkeit um {1}%.",
  T_28_C_SKILL_NAME_STREETBEAT: "Bullet Beats",
  T_28_D_CHARACTER_STREETBEAT_N: "D-Bee",
  T_28_HI_UZI: "Mini Uzi",
  T_28_L_B_BRJERSEY_A: "Nr.23 Fußball-Trikot (Unterteil)",
  T_28_L_B_BRJERSEY_B: "Nr.10 Fußball-Trikot (Unterteil)",
  T_28_L_B_BRJERSEY_C: "Nr.24 Fußball-Trikot (Unterteil)",
  T_28_L_B_BRJERSEY_D: "Nr.30 Fußball-Trikot (Unterteil)",
  T_28_L_B_BRJERSEY_E: "Nr.1 Fußball-Trikot (Unterteil)",
  T_28_L_B_BRJERSEY_F: "Nr.20 Fußball-Trikot (Unterteil)",
  T_28_L_F_B_FOURSYMBOLS_C: "Zinnoberrot Wirbelwind (Unterteil)",
  T_28_L_F_H_FOURSYMBOLS_C: "Zinnoberrot Wirbelwind (Kopf)",
  T_28_L_F_HA_FOURSYMBOLS_C: "Zinnoberrot Wirbelwind (Gesichtsfarbe)",
  T_28_L_F_S_FOURSYMBOLS_C: "Zinnoberrot Wirbelwind (Schuhe)",
  T_28_L_F_T_FOURSYMBOLS_C: "Zinnoberrot Wirbelwind (Oberteil)",
  T_28_L_HA_THUNDER: "Blitzauge (Gesichtsfarbe)",
  T_28_L_M_A_SPORTSUIT: "Ballsy Skaterboi (Maske)",
  T_28_L_M_B_FOURSYMBOLS_D: "Shadow Earthshaker (Unterteil)",
  T_28_L_M_B_SPORTSUIT: "Ballsy Skaterboi (Unterteil)",
  T_28_L_M_H_FOURSYMBOLS_D: "Shadow Earthshaker (Kopf)",
  T_28_L_M_H_SPORTSUIT: "Ballsy Skaterboi (Kopf)",
  T_28_L_M_S_FOURSYMBOLS_D: "Shadow Earthshaker (Schuhe)",
  T_28_L_M_S_SPORTSUIT: "Ballsy Skaterboi (Schuhe)",
  T_28_L_M_T_FALLWINTER: "Sauce Swagger (Oberteil)",
  T_28_L_M_T_FOURSYMBOLS_D: "Shadow Earthshaker (Oberteil)",
  T_28_L_M_T_SPORTSUIT: "Ballsy Skaterboi (Oberteil)",
  T_28_L_T_BRJERSEY_A: "Nr.23 Fußball-Trikot (Oberteil)",
  T_28_L_T_BRJERSEY_B: "Nr.10 Fußball-Trikot (Oberteil)",
  T_28_L_T_BRJERSEY_C: "Nr.24 Fußball-Trikot (Oberteil)",
  T_28_L_T_BRJERSEY_D: "Nr.30 Fußball-Trikot (Oberteil)",
  T_28_L_T_BRJERSEY_E: "Nr.1 Fußball-Trikot (Oberteil)",
  T_28_L_T_BRJERSEY_F: "Nr.20 Fußball-Trikot (Oberteil)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94- Ruby Bride",
  T_28_LC_GLOO_FALLWINTER_N: "Gloo Wand- Sauce Swagger",
  T_28_LC_GLOO_FOURSYMBOLS_N: "Gloo Wand- Sturmbringer",
  T_28_LC_KORD_SHINOBI_N: "Kord- Killspark Shinobi",
  T_28_LC_M21A5_FANTASYEYE_N: "Woodpecker- Gnadenloser Nekromant",
  T_28_LC_MAG7_WHITESHARK_N: "MAG-7 Lethal Finstooth",
  T_28_LC_PAN_FOURSYMBOLS_N: "Pfanne- Earthshaker-Stampfen",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "Jeep- Sturmbringer",
  T_28_T_WS_ITEM1: "Quatratische Kiste",
  T_28_T_WS_ITEM10: "Hütte",
  T_28_T_WS_ITEM11: "Wachturm",
  T_28_T_WS_ITEM12: "Außenposten",
  T_28_T_WS_ITEM13: "Haus A",
  T_28_T_WS_ITEM14: "Haus B",
  T_28_T_WS_ITEM15: "Haus C",
  T_28_T_WS_ITEM16: "Sandstruktur",
  T_28_T_WS_ITEM17: "Brunnen",
  T_28_T_WS_ITEM18: "Kirschblüte",
  T_28_T_WS_ITEM19: "Bananenbaum",
  T_28_T_WS_ITEM2: "Lang Kiste",
  T_28_T_WS_ITEM20: "Toilettenschüssel",
  T_28_T_WS_ITEM21: "Zaun",
  T_28_T_WS_ITEM3: "Busch",
  T_28_T_WS_ITEM4: "Heuhaufen",
  T_28_T_WS_ITEM5: "Auto",
  T_28_T_WS_ITEM6: "Bus",
  T_28_T_WS_ITEM7: "Container A",
  T_28_T_WS_ITEM8: "Container B",
  T_28_T_WS_ITEM9: "Container C",
  T_28_T_WS_TYPE1: "Objekte",
  T_28_T_WS_TYPE4: "Dekorationen",
  T_28_W_DUCK_N: "Dr. Beanie",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "Haustier Skin: Mythos Dreki",
  T_28_W_PETSKIN_DUCK_ARMY_N: "Haustier Skin: Sgt. Beanie",
  T_28_W_PETSKIN_DUCK_BLACK_N: "Haustier Skin: Gangster Beanie",
  T_28_W_PETSKIN_DUCK_SHINY_N: "Haustier Skin: DJ Beanie",
  T_28_YF_AR15: "Kingfisher",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "Erwachen: Markierungen auf getroffenen Feinden halten länger an, wenn Feinde sich bewegen, bis zu {0}s.",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "Enigma Auge",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "Vital Vibes",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "Healing Heartbeat",
  T_29_D_CHARACTER_AMOCO_N: 'Moco "Enigma"',
  T_29_D_CHARACTER_MUSICBRO1_N: "Dimitri",
  T_29_D_CHARACTER_MUSICBRO2_N: "Thiva",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "Gestreiftes Fußballtrikot (Unterteil)",
  T_29_L_M_A_FALCONER_C: "Moody Lavisher (Maske)",
  T_29_L_M_A_JUNGLE_GREEN: "Camou Kriegsschildkröte (Maske)",
  T_29_L_M_B_FALCONER_C: "Moody Lavisher (Unterteil)",
  T_29_L_M_B_JUNGLE_GREEN: "Camou Kriegsschildkröte (Unterteil)",
  T_29_L_M_H_FALCONER_C: "Moody Lavisher (Kopf)",
  T_29_L_M_H_JUNGLE_GREEN: "Camou Kriegsschildkröte (Kopf)",
  T_29_L_M_S_FALCONER_C: "Moody Lavisher (Schuhe)",
  T_29_L_M_S_JUNGLE_GREEN: "Camou Kriegsschildkröte (Schuhe)",
  T_29_L_M_T_FALCONER_C: "Moody Lavisher (Oberteil)",
  T_29_L_M_T_JUNGLE_GREEN: "Camou Kriegsschildkröte (Oberteil)",
  T_29_L_T_TRJERSEY: "Gestreiftes Fußballtrikot (Oberteil)",
  T_29_M_WS_ITEM22: "Robuster Container",
  T_29_M_WS_ITEM23: "Robuster Zaun",
  T_29_M_WS_ITEM24: "Spawnpunkt A",
  T_29_M_WS_ITEM25: "Spawnpunkt B",
  T_29_M_WS_TYPE5: "Interaktiv",
  T_29_W_PETSKIN_BROWN_TIGER_N: "Haustier Skin: Erde Sensei Tig",
  T_29_W_PETSKIN_FIRE_TIGER_N: "Haustier Skin: Feuer Sensei Tig",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "Haustier Skin: Cyber Falco",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "Haustier Skin: Party Panda",
  T_29_W_PETSKIN_WHITE_TIGER_N: "Haustier Skin: Eis Sensei Tig",
  T_29_W_TIGER_NINJA_N: "Sensei Tig",
  T_29_YF_MACHETE_MUSICFEST_N: "Soundwave Thrasher",
  T_29_YF_MAGEZINE_CHAIN_N: "AR Magazin",
  T_29_YF_MUZZLE_CRASH_N: "SMG Mündung",
  T_29_YF_MUZZLE_WIDE_N: "Schrotflinte Mündung",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12- Kosmisch Teleportia",
  T_29_YF_UZI_GOLDENWING_N: "Mini Uzi- Amber Megacypher",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "Monster Truck- Gnawing Rager",
  T_30_AD_RP_ROUNDEND: "ENDE DER RUNDE",
  T_30_AD_TRAINING_SNOWBALL: "Schneeball",
  T_30_AD_TRAINING_SNOWBALL_DES: "Lasst uns eine Schneeballschlacht machen!",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0}s[-] after being attacked, recover [FFB300]{1}HP[-]/s for [FFB300]{2}s[-]",
  T_30_C_SKILL_NAME_BOOYAHGUY: "Buzzer Beater",
  T_30_C_SKILL_NAME_MUERTOGUY: "Memory Mist",
  T_30_D_CHARACTER_BOOYAHGUY_N: "Leon",
  T_30_D_CHARACTER_MUERTOGUY_N: "Otho",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "Jai Mikrochip",
  T_30_L_A_BRMASCOT_ADULT: "Angry Chick Kopf",
  T_30_L_A_BRMASCOT_KIDS: "Adorable Chick Kopf",
  T_30_L_A_SUGARSKULL21_BANDANA: "Todesbiss Maske",
  T_30_L_B_BRFOOTBALL_BLACK: "CBF Fußball-Trikot - Schwarz (Unterteil)",
  T_30_L_B_BRFOOTBALL_GREEN: "CBF Fußball-Trikot - Grün (Unterteil)",
  T_30_L_B_BRFOOTBALL_GREY: "CBF Fußball-Trikot - Grau (Unterteil)",
  T_30_L_B_BRUNIFORM: "Little Canary (Unterteil)",
  T_30_L_F_A_SUGARSKULL21: "Goldrim-Königin (Maske)",
  T_30_L_F_B_SUGARSKULL21: "Goldrim-Königin (Unterteil)",
  T_30_L_F_B_THASIAN: "Coral Trouble (Unterteil)",
  T_30_L_F_H_CATEARS: "Kawaii Ears",
  T_30_L_F_H_SUGARSKULL21: "Goldrim-Königin (Kopf)",
  T_30_L_F_H_THASIAN: "Coral Trouble (Kopf)",
  T_30_L_F_S_SUGARSKULL21: "Goldrim-Königin (Schuhe)",
  T_30_L_F_S_THASIAN: "Coral Trouble (Schuhe)",
  T_30_L_F_T_SUGARSKULL21: "Goldrim-Königin (Oberteil)",
  T_30_L_F_T_THASIAN: "Coral Trouble (Oberteil)",
  T_30_L_H_CHILDRENSDAY_BLUE: "Delphinkopf",
  T_30_L_H_CHILDRENSDAY_RED: "Elefantenkopf",
  T_30_L_H_CLOWNHAT: "Zirkus Hut - Gelb",
  T_30_L_H_ZASCARF: "Bold Gold Schal",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "Desi Gangster (Maske)",
  T_30_L_M_A_SUGARSKULL21: "Goldrim King (Maske)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "Desi Gangster (Unterteil)",
  T_30_L_M_B_PKCRICKET: "Champ In Green (Unterteil)",
  T_30_L_M_B_SUGARSKULL21: "Goldrim King (Unterteil)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "Wind Racer (Unterteil)",
  T_30_L_M_B_THASIAN: "Coral Rebel (Unterteil)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "Desi Gangster (Kopf)",
  T_30_L_M_H_SUGARSKULL21: "Goldrim King (Kopf)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "Wind Racer (Kopf)",
  T_30_L_M_H_THASIAN: "Coral Rebel (Kopf)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "Alpha Bone-Rager (Gesichtsfarbe)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "Desi Gangster (Schuhe)",
  T_30_L_M_S_PKCRICKET: "Champ In Green (Schuhe)",
  T_30_L_M_S_SUGARSKULL21: "Goldrim King (Schuhe)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "Wind Racer (Schuhe)",
  T_30_L_M_S_THASIAN: "Coral Rebel (Schuhe)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "Desi Gangster (Oberteil)",
  T_30_L_M_T_PKCRICKET: "Champ In Green (Oberteil)",
  T_30_L_M_T_SUGARSKULL21: "Goldrim King (Oberteil)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "Wind Racer (Oberteil)",
  T_30_L_M_T_THASIAN: "Coral Rebel (Oberteil)",
  T_30_L_S_BRUNIFORM: "Little Canary (Schuhe)",
  T_30_L_T_BRFOOTBALL_BLACK: "CBF Fußball-Trikot - Schwarz (Oberteil)",
  T_30_L_T_BRFOOTBALL_GREEN: "CBF Fußball-Trikot - Grün (Oberteil)",
  T_30_L_T_BRFOOTBALL_GREY: "CBF Fußball-Trikot - Grau (Oberteil)",
  T_30_L_T_BRUNIFORM: "Little Canary (Oberteil)",
  T_30_M_WS_PARTY_MODE: "Spielplatz",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "BATTLE IN STYLE",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "Herausforderer",
  T_30_R_EMOTE_MAX_NAME: "Rap Swag",
  T_30_R_LEGEND_HALO_NAME: "Kreis der Wärme",
  T_30_T_WS_DEFAULTDESCRIPTION: "Eine aufregende Karte im Free Fire Craftland",
  T_30_T_WS_ITEM26: "Reifen",
  T_30_T_WS_ITEM27: "Unordentliche Reifen A",
  T_30_T_WS_ITEM28: "Unordentliche Reifen B",
  T_30_T_WS_ITEM29: "Unordentliche Reifen C",
  T_30_T_WS_ITEM30: "Bumper Wagen",
  T_30_T_WS_ITEM31: "Amphibienwagen",
  T_30_T_WS_ITEM32: "Jeep",
  T_30_T_WS_ITEM33: "Mülleimer",
  T_30_T_WS_ITEM34: "Schatten",
  T_30_T_WS_ITEM35: "Sanitätszelt",
  T_30_T_WS_ITEM36: "Garage",
  T_30_T_WS_ITEM37: "Gemalte Wände",
  T_30_T_WS_ITEM38: "Torii",
  T_30_T_WS_ITEM39: "Eisenplattform",
  T_30_T_WS_ITEM40: "Baubude",
  T_30_T_WS_ITEM41: "LKW",
  T_30_T_WS_ITEM42: "Mauer A",
  T_30_T_WS_ITEM43: "Mauer B",
  T_30_T_WS_ITEM44: "Mauer C",
  T_30_T_WS_ITEM45: "Mauer D",
  T_30_T_WS_ITEM46: "Mauer E",
  T_30_T_WS_ITEM47: "Mauer F",
  T_30_U_ATTACHMENT_1: "Weste HP Booster",
  T_30_U_ATTACHMENT_4: "Westenvergrößerer",
  T_30_U_ATTACHMENT_5: "Helm-Verdicker",
  T_30_U_ATTACHMENT_6: "Weste-Verdicker",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "Haustier Skin: Skull Beaston",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "Haustier Skin: Punk Waggor",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "Haustier Skin: Bullseye Agent Hop",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "Haustier Skin: Carnival Agent Hop",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "Haustier Skin: Cyber Agent Hop",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "Haustier Skin: Nazar Robo",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "Haustier Skin: Grüner Freeze Robo",
  T_30_W_RABBIT_N: "Agent Hop",
  T_30_XH_PCMAP_P17: "Fabrik",
  T_30_YF_GLOO_BOOYAHDAY21_N: "Gloo Wand- BOOYAH DAY 2021",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "Granate- BOOYAH DAY 2021",
  T_30_YF_Healinggun_Sniper_N: "Behandlung Scharfschütze",
  T_30_YF_MINI_LIGHTFEST_N: "AC80- Königlicher Krieger",
  T_30_YF_PARAFAL_ZATRIBAL_N: "PARAFAL- Crimson Heir",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR- Königlicher Krieger",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "Thompson- Goldrim Tribut",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "Sportwagen- Skull Punker",
  T_31_C_SKILL_NAME_WINTERGUY: "Ice Iron",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "Winter Basher",
  T_31_HQ_GLOO_EAGLE_N: "Gloo Wand- Heatbound Desert",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "Behandlung Scharfschütze- Ice Bones",
  T_31_HQ_KATANA_WINTERFEST21_N: "Katana- Snow Doom",
  T_31_HQ_PAN_WINTERFEST21_N: "Pfanne- Snow Doom",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "Haustier Skin: Snow Ottero",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "Haustier Skin: Waggor On Ice",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "Haustier Skin: Tribal Yeti",
  T_31_HQ_PETSKIN_YETI_RED_N: "Haustier Skin: Fiery Yeti",
  T_31_HQ_SICKLE_WINTERFEST21_N: "Sense des Schnees",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "Motorrad- Ice Blossoms",
  T_31_HQ_YETI_N: "Yeti",
  T_31_KK_WINTER_BUJIX: "Versorgungskiste",
  T_31_KK_WINTER_SANJITOU: "Helm",
  T_31_L_A_BDCRICKET: "Victory Batter (Maske)",
  T_31_L_A_WINTERFEST21: "Rentier Cover",
  T_31_L_B_BDCRICKET: "Victory Batter (Unterteil)",
  T_31_L_B_MEJERSEY_10: "Nr. 10 Ruby Jersey (Unterteil)",
  T_31_L_B_MEJERSEY_11: "Nr. 11 Red Jersey (Unterteil)",
  T_31_L_B_MEJERSEY_13: "Nr. 13 White Jersey (Unterteil)",
  T_31_L_B_MEJERSEY_18G: "Nr. 18 Green Jersey (Unterteil)",
  T_31_L_B_MEJERSEY_18R: "Nr. 18 Maroon Jersey (Unterteil)",
  T_31_L_B_MEJERSEY_7: "Nr. 7 Basil Jersey (Unterteil)",
  T_31_L_F_B_RUMUSICIAN: "Strapped Trance (Unterteil)",
  T_31_L_F_B_THAGENT: "Night Provocateur (Unterteil)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "Tie Dye Eimer",
  T_31_L_F_H_RUMUSICIAN: "Strapped Trance (Kopf)",
  T_31_L_F_H_THAGENT: "Night Provocateur (Kopf)",
  T_31_L_F_HA_RUMUSICIAN: "Strapped Trance (Gesichtfarbe)",
  T_31_L_F_S_RUMUSICIAN: "Strapped Trance (Schuhe)",
  T_31_L_F_S_THAGENT: "Night Provocateur (Schuhe)",
  T_31_L_F_T_RUMUSICIAN: "Strapped Trance (Oberteil)",
  T_31_L_F_T_THAGENT: "Night Provocateur (Oberteil)",
  T_31_L_HA_RUMUSICIAN_MU: "Strap Trap (Gesichtsfarbe)",
  T_31_L_HA_WINTERFEST21_BLUE: "Frozen Clown Gesichtsfarbe",
  T_31_L_HA_WINTERFEST21_PINK: "Pink Firesparks Gesichtsfarbe",
  T_31_L_M_A_REGGAETON_B: "Neon Reggaeton (Maske)",
  T_31_L_M_A_REGGAETON_P: "Vibrant Vanity (Maske)",
  T_31_L_M_A_RUMUSICIAN: "Strapped Trap (Maske)",
  T_31_L_M_A_THAGENT: "Night Scouter (Maske)",
  T_31_L_M_B_PKCOSTUME: "Smart in Green (Unterteil)",
  T_31_L_M_B_REGGAETON_B: "Neon Reggaeton (Unterteil)",
  T_31_L_M_B_REGGAETON_P: "Vibrant Vanity (Unterteil)",
  T_31_L_M_B_RUMUSICIAN: "Strapped Trap (Unterteil)",
  T_31_L_M_B_THAGENT: "Night Scouter (Unterteil)",
  T_31_L_M_H_GREENCAP: "Gewinner Kappe",
  T_31_L_M_H_PKCOSTUME: "Smart in Green (Kopf)",
  T_31_L_M_H_REGGAETON_B: "Neon Reggaeton (Kopf)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "Tie Dye Hut",
  T_31_L_M_H_REGGAETON_P: "Vibrant Vanity (Kopf)",
  T_31_L_M_H_RUMUSICIAN: "Strapped Trap (Kopf)",
  T_31_L_M_H_THAGENT: "Night Scouter (Kopf)",
  T_31_L_M_S_PKCOSTUME: "Smart in Green (Schuhe)",
  T_31_L_M_S_REGGAETON_B: "Neon Reggaeton (Schuhe)",
  T_31_L_M_S_REGGAETON_P: "Vibrant Vanity (Schuhe)",
  T_31_L_M_S_RUMUSICIAN: "Strapped Trap (Schuhe)",
  T_31_L_M_S_THAGENT: "Night Scouter (Schuhe)",
  T_31_L_M_T_PKCOSTUME: "Smart in Green (Oberteil)",
  T_31_L_M_T_REGGAETON_B: "Neon Reggaeton (Oberteil)",
  T_31_L_M_T_REGGAETON_P: "Vibrant Vanity (Oberteil)",
  T_31_L_M_T_REGGAETON_TATOO: "Familia Ink",
  T_31_L_M_T_RUMUSICIAN: "Strapped Trap (Oberteil)",
  T_31_L_M_T_THAGENT: "Night Scouter (Oberteil)",
  T_31_L_S_BDCRICKET: "Victory Batter (Schuhe)",
  T_31_L_T_BDCRICKET: "Victory Batter (Oberteil)",
  T_31_L_T_BRBANK: "Maroon Bomber",
  T_31_L_T_MEJERSEY_10: "Nr. 10 Ruby Jersey (Oberteil)",
  T_31_L_T_MEJERSEY_11: "Nr. 11 Red Jersey (Oberteil)",
  T_31_L_T_MEJERSEY_13: "Nr. 13 White Jersey (Oberteil)",
  T_31_L_T_MEJERSEY_18G: "Nr. 18 Green Jersey (Oberteil)",
  T_31_L_T_MEJERSEY_18R: "Nr. 18 Maroon Jersey (Oberteil)",
  T_31_L_T_MEJERSEY_7: "Nr. 7 Basil Jersey (Oberteil)",
  T_31_L_T_PKMOBILE: "Infinix T-Shirt",
  T_31_L_T_REGGAETON_HOOD: "Gang Smile Kapuzenpullover",
  T_31_MF_CHARACTER_WINTERGUY_N: "Nairi",
  T_31_R_EMOTE_FALCONER_NAME: "Nummer 1",
  T_31_RW_COMBINEMACHINE_2: "Akimbo Activator (Advanced)",
  T_31_RW_VIBRATION_EXPLOSION: "Explosionen",
  T_31_RW_VIBRATION_MELEEWEAPONS: "Waffen mit geringer Reichweite",
  T_31_RW_VIBRATION_OTHERWEAPONS: "Andere Waffen",
  T_31_T_WS_1PLAYERTEAM: "Solo",
  T_31_T_WS_2PLAYERTEAM: "Duo",
  T_31_T_WS_3PLAYERTEAM: "Trio",
  T_31_T_WS_4PLAYERTEAM: "Squad",
  T_31_T_WS_5PLAYERTEAM: "Versus 5",
  T_31_T_WS_6PLAYERTEAM: "Versus 6",
  T_31_T_WS_BUFFTIME_TITLE: "Aktualisierungszeit",
  T_31_T_WS_BUFFTYPE_AMMO: "Munition",
  T_31_T_WS_BUFFTYPE_ARMOR: "Rüstung",
  T_31_T_WS_BUFFTYPE_HP: "HP",
  T_31_T_WS_BUFFTYPE_RANDOM: "Zufällig",
  T_31_T_WS_BUFFTYPE_TITLE: "Buff Typ",
  T_31_T_WS_DESC48: "Bringt dich an einen anderen Ort, innerhalb von Millisekunden",
  T_31_T_WS_DESC49: "Erzeugt den Klang eines Klaviers",
  T_31_T_WS_DESC51: "Erzeugt den Klang einer Trommel",
  T_31_T_WS_DESC53: "Erzeugt den Klang eines Synthesizers",
  T_31_T_WS_DESC59: "Ein Gerät, das in regelmäßigen Abständen einen Buff erzeugt. Nimm es auf, um eine entsprechende Verbesserung zu erhalten.",
  T_31_T_WS_DRUMTYPE_CLAPS: "Clap",
  T_31_T_WS_DRUMTYPE_HIHATS: "Hi-Hat",
  T_31_T_WS_DRUMTYPE_KICK: "Kick Drum",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "Eröffnung Hi-Hat",
  T_31_T_WS_DRUMTYPE_RIDES: "Ride Cymbal",
  T_31_T_WS_DRUMTYPE_SNARES: "Snare Drum",
  T_31_T_WS_EARLYSHRINK: "Schnelle Schrumpfung",
  T_31_T_WS_ITEM48: "Portal",
  T_31_T_WS_ITEM49: "Klavierschlüssel",
  T_31_T_WS_ITEM51: "Trommelschlüssel",
  T_31_T_WS_ITEM53: "Combo Key A",
  T_31_T_WS_ITEM55: "Combo Key B",
  T_31_T_WS_ITEM57: "Combo Key C",
  T_31_T_WS_ITEM59: "Buff-Generator",
  T_31_T_WS_LATESHRINK: "Späte Schrumpfung",
  T_31_T_WS_ME_DAMAGE: "Verursachter Schaden",
  T_31_T_WS_ME_DAMAGED: "Genommener Schaden",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "Ursprünglicher EP-Anteil",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "Radius der ersten sicheren Zone",
  T_31_T_WS_ME_EPQUICKRESTORE: "Schnelle EP Wiederherstellung",
  T_31_T_WS_ME_FLOW: "Modus",
  T_31_T_WS_ME_GENERALSETTING: "Allgemein",
  T_31_T_WS_ME_INRANDOMSPAWN: "Zufälliger Spawn-Punkt",
  T_31_T_WS_ME_KILLSCORE: "Kill Bonus",
  T_31_T_WS_ME_MAXEP: "Maximale EP",
  T_31_T_WS_ME_MAXHP: "Maximale HP",
  T_31_T_WS_ME_NEARTEAM: "Teamkollegen in der Nähe",
  T_31_T_WS_ME_REBIRTH: "Respawn-Wartezeit",
  T_31_T_WS_ME_REBIRTHLOCATION: "Ort von Respawn",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "Startzeit der Zonenschrumpfung",
  T_31_T_WS_ME_WINSCORE: "Gewonnene Punkte",
  T_31_T_WS_MINIZONE: "Mini Zone",
  T_31_T_WS_MUSICTYPE_TITLE: "Musik Typ",
  T_31_T_WS_UNLIMITEDAMMO: "Unbegrenzte Munition",
  T_31_WT_WS_DESC1: "Eine quadratische Holzkiste, die gestapelt werden kann",
  T_31_WT_WS_DESC10: "Eine heruntergekommene Hütte mit einer Holztreppe, zu der man hinaufsteigen muss",
  T_31_WT_WS_DESC11: "Gebaut mit mehreren Fenstern für Aufnahmezwecke",
  T_31_WT_WS_DESC12: "Aus Metall und enthält Türen und Fenster",
  T_31_WT_WS_DESC13: "Enthält Türen und Fenster",
  T_31_WT_WS_DESC14: "Ein zweistöckiges Haus mit einer Terrasse",
  T_31_WT_WS_DESC15: "Ein zweistöckiges Haus mit einem geschlossenen Dach",
  T_31_WT_WS_DESC16: "Dekoration - eine herzförmige Sandstatue",
  T_31_WT_WS_DESC17: "Dekoration - ein Springbrunnen mit kristallklarem Wasser",
  T_31_WT_WS_DESC18: "Dekoration - ein Baum mit rosa Blumen",
  T_31_WT_WS_DESC19: "Dekoration - ein kleiner Bananenbaum ohne Bananen",
  T_31_WT_WS_DESC2: "Eine rechteckige Holzkiste, die gestapelt werden kann",
  T_31_WT_WS_DESC20: "Ein weißes Badmöbel, das im Innenbereich aufgestellt werden kann",
  T_31_WT_WS_DESC21: "Ein kleiner Zaun, der zur Abgrenzung von Bereichen verwendet werden kann",
  T_31_WT_WS_DESC22: "Dieses Holzbrett an der Containerseite kann mit Gewalt gebrochen werden",
  T_31_WT_WS_DESC23: "Ein kleiner Zaun, der mit Gewalt niedergerissen werden kann",
  T_31_WT_WS_DESC24: "Spawnbereich für Team A",
  T_31_WT_WS_DESC25: "Spawnbereich für Team B",
  T_31_WT_WS_DESC26: "Lass Spieler für eine kurze Strecke in die Richtung abprallen, in die sie schauen.",
  T_31_WT_WS_DESC27: "Lass Spieler für eine kurze Distanz in die voreingestellte Richtung abprallen",
  T_31_WT_WS_DESC28: "Lass Spieler in die vorgegebene Richtung abprallen, über eine mittlere Distanz",
  T_31_WT_WS_DESC29: "Lass Spieler über eine lange Distanz in die voreingestellte Richtung abprallen",
  T_31_WT_WS_DESC3: "Geschmückt mit roten und gelben Blüten, die dein Schlachtfeld erleuchten können",
  T_31_WT_WS_DESC30: "Ein Bumper Auto, das gefahren werden kann",
  T_31_WT_WS_DESC31: "Ein amphibisches Auto, das gefahren werden kann",
  T_31_WT_WS_DESC32: "Ein Jeep, der gefahren werden kann",
  T_31_WT_WS_DESC33: "Gefüllt mit Müll. Kürzer als ein Mensch, kann aber eine gewisse Deckung bieten",
  T_31_WT_WS_DESC34: "Open-Air, Metallunterstand für die Rennstrecke",
  T_31_WT_WS_DESC35: "Ein mittelgroßes Zelt mit zwei Türen, aber ohne Fenster",
  T_31_WT_WS_DESC36: "Eine große, aus Ziegeln gebaute Garage",
  T_31_WT_WS_DESC37: "Eine große Backsteinmauer, die zur Unterteilung von Bereichen verwendet werden kann",
  T_31_WT_WS_DESC38: "Ein nützliches Landmark",
  T_31_WT_WS_DESC39: "Eine große Metallplattform, die als Hauptkampfplatz genutzt werden kann",
  T_31_WT_WS_DESC4: "Größer als ein Mensch und kann daher als Deckung dienen",
  T_31_WT_WS_DESC40: "Sieht aus wie ein Wohnmobil und hat mehrere Türen und Fenster",
  T_31_WT_WS_DESC41: "Sieht aus wie ein Wohnmobil und hat eine Tür und mehrere Fenster",
  T_31_WT_WS_DESC42: "Eine einseitige Wand mit einem Eingang",
  T_31_WT_WS_DESC43: "Eine normale einseitige Wand",
  T_31_WT_WS_DESC44: "Eine Wandecke",
  T_31_WT_WS_DESC45: "Eine unebene Wandecke",
  T_31_WT_WS_DESC46: "Eine unebene Wandecke",
  T_31_WT_WS_DESC47: "Eine Wandecke mit Fenstern",
  T_31_WT_WS_DESC5: "Ein verlassenes Auto, das etwas kürzer als ein Mensch ist, aber eine gewisse Deckung bieten kann",
  T_31_WT_WS_DESC6: "Größer als ein Mensch und kann daher als Deckung dienen",
  T_31_WT_WS_DESC7: "Beidseitig offen und zur Bildung von Wegen oder zur Unterteilung von Bereichen anordenbar",
  T_31_WT_WS_DESC8: "An einem Ende offen, kann zur Unterteilung von Bereichen verwendet werden",
  T_31_WT_WS_DESC9: "An beiden Enden versiegelt und zur Unterteilung von Bereichen verwendbar",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "Fahrzeug",
  T_31_Z_OB_UAV: "UAV",
  T_32_C_SKILL_DESC_YAKUZA: "Dashes forward at a rapid speed for [FFB300]{0}s[-]. This skill can be accumulated for up to [FFB300]{2} uses[-], with a [FFB300]{3}s[-] cooldown between each use. Dash replenish time: [FFB300]{1}s[-].",
  T_32_C_SKILL_NAME_YAKUZA: "Rebel Rush",
  T_32_HQ_AUG_VNSTREET_N: "AUG- Roaring Gunfighter",
  T_32_HQ_BACKPACK_REDDRAGON_N: "Dawnlit Drago Rucksack",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B- Vampire Malevolence",
  T_32_HQ_GLOO_DUNHUANG_N: "Gloo Wall - Frozen Platinum",
  T_32_HQ_GLOO_HURRICANE_2_N: "Gloo Wall - Aurora Core",
  T_32_HQ_GRENADE_HURRICANE_N: "Grenade - Brassy Mic",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10 - Frozen Platinum",
  T_32_HQ_PETSKIN_DUCK_RED_N: "Pet skin: Red Beanie",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "Pet Skin: Cyber Flash",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "Pet Skin: Gamer Flash",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "Pet Skin: Festive Flash",
  T_32_HQ_TORTOISE_N: "Flash",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "Sports Car - Buried Purpledust",
  T_32_L_F_A_PHARAOH: "Goldcoated Cleo (Maske)",
  T_32_L_F_B_PHARAOH: "Goldcoated Cleo (Unterteil)",
  T_32_L_F_H_PHARAOH: "Goldcoated Cleo (Kopf)",
  T_32_L_F_HA_PHARAOH: "Goldcoated Cleo (Gesichtsfarbe)",
  T_32_L_F_S_PHARAOH: "Goldcoated Cleo (Schuhe)",
  T_32_L_F_T_PHARAOH: "Goldcoated Cleo (Oberteil)",
  T_32_L_M_A_JUNKFOOD: "Burger Lad (Mask)",
  T_32_L_M_A_PHARAOH: "Goldlined Mummy (Maske)",
  T_32_L_M_B_JUNKFOOD: "Burger Lad (Bottom)",
  T_32_L_M_B_PHARAOH: "Goldlined Mummy (Unterteil)",
  T_32_L_M_H_JUNKFOOD: "Burger Lad (Head)",
  T_32_L_M_H_PHARAOH: "Goldlined Mummy (Kopf)",
  T_32_L_M_S_JUNKFOOD: "Burger Lad (Shoes)",
  T_32_L_M_S_PHARAOH: "Goldlined Mummy (Schuhe)",
  T_32_L_M_T_JUNKFOOD: "Burger Lad (Top)",
  T_32_L_M_T_PHARAOH: "Goldlined Mummy (Oberteil)",
  T_32_L_T_WHITESWEATER: "White Turtleneck",
  T_32_LC_NEWVAULT_EMOTE: "Emote",
  T_32_LO_WS_IMMORTAL: "Immortal Zone",
  T_32_LO_WS_ITEM60: "Pipe",
  T_32_LO_WS_ITEM60_DESC: "A walkable tunnel",
  T_32_LO_WS_ITEM61: "T Pipe",
  T_32_LO_WS_ITEM61_DESC: "A walkable T tunnel",
  T_32_LO_WS_ITEM62: "Pipe Intersection",
  T_32_LO_WS_ITEM62_DESC: "A walkable intersecting tunnel",
  T_32_LO_WS_ITEM63: "Pipe Corner",
  T_32_LO_WS_ITEM63_DESC: "A walkable angled tunnel",
  T_32_LO_WS_ITEM64: "Food Truck",
  T_32_LO_WS_ITEM64_DESC: "Stop here to grab a bite",
  T_32_LO_WS_ITEM65: "Mush Shade",
  T_32_LO_WS_ITEM65_DESC: "A large mushroom that can carry a human",
  T_32_LO_WS_ITEM66: "Hanger",
  T_32_LO_WS_ITEM66_DESC: "Commonly seen in residential areas",
  T_32_LO_WS_ITEM67: "Wooden Plank",
  T_32_LO_WS_ITEM67_DESC: "Use to make a simple wooden bridge",
  T_32_LO_WS_ITEM68: "Lattice Screen",
  T_32_LO_WS_ITEM68_DESC: "An oriental feel",
  T_32_LO_WS_ITEM69: "Pillar",
  T_32_LO_WS_ITEM69_DESC: "Commonly seen on construction sites",
  T_32_LO_WS_ITEM70: "Cactus",
  T_32_LO_WS_ITEM70_DESC: "Mighty big but doesn't sting",
  T_32_LO_WS_ITEM71: "Leafless Tree",
  T_32_LO_WS_ITEM71_DESC: "A tree that has lived for centuries",
  T_32_LO_WS_ITEM72: "Stone Lantern",
  T_32_LO_WS_ITEM72_DESC: "Scenic decoration in imperial gardens",
  T_32_LO_WS_ITEM73: "Streetlamp",
  T_32_LO_WS_ITEM73_DESC: "Commonly seen on the streets",
  T_32_LO_WS_ITEM74: "Solar Panel",
  T_32_LO_WS_ITEM74_DESC: "Absorbs energy from sunlight",
  T_32_LO_WS_ITEM75: "Air Conditioner A",
  T_32_LO_WS_ITEM75_DESC: "Stay cool in the heat",
  T_32_LO_WS_ITEM76: "Fan",
  T_32_LO_WS_ITEM77: "Fly Pan",
  T_32_LO_WS_ITEM78: "Cube",
  T_32_LO_WS_ITEM79: "Ring",
  T_32_LO_WS_ITEM80: "Hammer",
  T_32_LO_WS_ITEM81: "Board",
  T_32_LO_WS_ITEM82: "Shooting Target",
  T_32_LO_WS_ITEM83: "Flex Wall",
  T_32_LO_WS_ITEM84AMMO: "Ammo Loot Point",
  T_32_LO_WS_ITEM84AMMO_DESC: "When placed, selected ammo type(s) will spawn there",
  T_32_LO_WS_ITEM84AR: "Armor Loot Point",
  T_32_LO_WS_ITEM84AR_DESC: "When placed, selected armor type(s) will spawn there",
  T_32_LO_WS_ITEM84ARLV1: "Armor Lv. 1",
  T_32_LO_WS_ITEM84ARLV2: "Armor Lv. 2",
  T_32_LO_WS_ITEM84ARLV3: "Armor Lv. 3",
  T_32_LO_WS_ITEM84CO: "Consumables Loot Point",
  T_32_LO_WS_ITEM84CO_DESC: "When placed, selected consumable type(s) will spawn there",
  T_32_LO_WS_ITEM84JA: "Throwables Loot Point",
  T_32_LO_WS_ITEM84JA_DESC: "When placed, selected throwable type(s) will spawn there",
  T_32_LO_WS_ITEM84TE: "Scopes Loot Point",
  T_32_LO_WS_ITEM84TE_DESC: "When placed, selected scope type(s) will spawn there",
  T_32_LO_WS_ITEM84W: "Weapon Loot Point",
  T_32_LO_WS_ITEM84W_DESC: "When placed, selected weapon type(s) will spawn there",
  T_32_LO_WS_ITEM85: "Doom/Immortal Zone",
  T_32_LO_WS_ITEM85_DESC: "(Nur in benutzerdefinierten Spielmodi) Wenn sie platziert werden, erfahren Spieler, die darauf treten, einen bestimmten Effekt (unsterblich oder doom)",
  T_32_LO_WS_ITEM85CP: "Checkpoint",
  T_32_LO_WS_ITEM85CP_DESC: "(Nur in benutzerdefinierten Spielmodi) Ein obligatorisches Element im Speed-Modus. Die Spieler müssen jeden Kontrollpunkt nacheinander passieren. Wenn der Spieler ausgeschieden ist, wird er am letzten Kontrollpunkt, den er passiert hat, wieder auftauchen.",
  T_32_LO_WS_ITEM85TM: "Finishing Point",
  T_32_LO_WS_ITEM85TM_DESC: "(Nur in benutzerdefinierten Spielmodi) Ein obligatorisches Element im Speed-Modus. Die Spieler müssen innerhalb des Bereichs dieses Gegenstandes ankommen, um das Spiel zu beenden.",
  T_32_LO_WS_ITEM86: "Spawn Point",
  T_32_LO_WS_ITEM86_DESC: "(Nur in benutzerdefinierten Spielmodi) Diesem Punkt wird kein bestimmtes Team zugewiesen. Wenn er platziert wird, spawnt dort ein zufälliges Team. Wenn es mehr Teams als Spawn-Punkte gibt, spawnen mehr als 1 Team an einem einzigen Punkt.",
  T_32_LO_WS_ITEM86L: "Large Spawn Point",
  T_32_LO_WS_ITEM86L_DESC: "(Nur in benutzerdefinierten Spielmodi) Geschwindigkeitsmodus großer Spawnpunkt, an dem alle Spieler spawnen",
  T_32_LO_WS_ITEM87: "Block",
  T_32_LO_WS_ITEM87_DESC: "Enables size customization",
  T_32_LO_WS_ITEM88: "Cuboid & Slope",
  T_32_LO_WS_ITEM88_DESC: "A cuboid or slope whose size can be adjusted",
  T_32_LO_WS_ITEMLINE: "Shift",
  T_32_LO_WS_ITEMMOVE: "Trigger Settings",
  T_32_LO_WS_ITEMROT: "Transform",
  T_32_LO_WS_ITEMSCALE: "Scale",
  T_32_LO_WS_KILLZONE: "Doom Zone",
  T_32_LO_WS_LOOT_AMMOTYPE: "Bullet",
  T_32_LO_WS_LOOT_ARTYPE: "Armor",
  T_32_LO_WS_LOOT_COTYPE: "Consumable",
  T_32_LO_WS_LOOT_JATYPE: "Throwable",
  T_32_LO_WS_LOOT_RANDOM: "Random",
  T_32_LO_WS_LOOT_TETYPE: "Scope",
  T_32_LO_WS_LOOT_WEAPONTYPE: "Weapon",
  T_32_LO_WS_SCALEX: "Length",
  T_32_LO_WS_SCALEY: "Height",
  T_32_LO_WS_SCALEZ: "Width",
  T_32_LO_WS_TRIGGERH: "Hide",
  T_32_LO_WS_TRIGGERHORP: "Show/Hide Triggers",
  T_32_LO_WS_TRIGGERP: "Show",
  T_32_LO_WS_TRIGGERTYPE: "Trigger Type",
  T_32_M_WS_MODE_ANNIHILATE: "Wipe Out",
  T_32_M_WS_MODE_SCORE: "Points Grab",
  T_32_M_WS_MODE_SPEED: "Parkour",
  T_32_M_WS_MULTIPLETEAMS: "Multi-Team Combat",
  T_32_M_WS_ROUNDS: "Rounds",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "Switching Steps",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "Danger Zone",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "Damage",
  T_32_T_WS_ME_BLUECIRCLESETTING: "Danger Zone",
  T_32_T_WS_ME_CUSTOM: "Customize",
  T_32_T_WS_ME_ENDTYPE1: "Wipe Out",
  T_32_T_WS_ME_ENDTYPE2: "Points Grab",
  T_32_T_WS_ME_ENDTYPE3: "Parkour",
  T_32_T_WS_ME_ENDTYPEDESC1: "Be the last team to survive",
  T_32_T_WS_ME_ENDTYPEDESC2: `A point-based mode where the first team to hit the target score wins.
You can set the gameplay rules and edit the gameplay parameters as you like, including setting the score awarded for eliminations.`,
  T_32_T_WS_ME_ENDTYPEDESC3: `A parkour mode where the first team to have all members reach the finishing point wins.
You can set the gameplay rules and the objects of the paths and the finishing line as you like.`,
  T_32_T_WS_ME_MATCHTIME: "Round Match Time",
  T_32_T_WS_ME_MECHANIC: "Mechanism",
  T_32_T_WS_ME_NEARCHECKPOINT: "Near checkpoint",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "Unable to have more than 12 players in total",
  T_32_T_WS_ME_PREGAMETIME: "Round Preparation Time",
  T_32_T_WS_ME_RESPAWN: "Respawns",
  T_32_T_WS_ME_RESPAWNSETTING: "Respawns",
  T_32_T_WS_ME_ROUNDNUM: "Number of rounds",
  T_32_T_WS_ME_ROUNDOPEN: "Enable multiple rounds",
  T_32_T_WS_ME_ROUNDRESET: "Round Resets",
  T_32_T_WS_ME_ROUNDSETTING: "Rounds",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "Zoneschrumpfung Dauer",
  T_32_T_WS_ME_SCORESETTING: "Score",
  T_32_T_WS_ME_TEAMMATENUM: "Members per team",
  T_32_T_WS_ME_TEAMNUM: "Number of teams",
  T_32_T_WS_ME_TEAMSETTING: "Team",
  T_32_U_ATTACHMENT_8: "Bag Pouch",
  "T_32_U_GOLD_FAMAS-I": "Famas-I",
  "T_32_U_GOLD_FAMAS-II": "Famas-II",
  "T_32_U_GOLD_FAMAS-III": "Famas-III",
  T_32_U_GOLD_HEATGUN_I: "PLASMA-I",
  T_32_U_GOLD_HEATGUN_II: "PLASMA-II",
  T_32_U_GOLD_HEATGUN_III: "PLASMA-III",
  T_32_U_GOLD_KAR98K_I: "Kar98K-I",
  T_32_U_GOLD_KAR98K_II: "Kar98K-II",
  T_32_U_GOLD_KAR98K_III: "Kar98K-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "Upgrade Chip",
  T_32_WT_WS_BARRIER: "Barriers",
  T_32_WT_WS_BDS: "Buildings",
  T_32_WT_WS_MMINVALIDERROR: "Invalid map code",
  T_32_WT_WS_TRGS: "Triggers",
  T_32_YF_CHARGESHOT_N: "Charge Buster",
  T_32_YF_GOLD_GROZA_N: "Groza-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "Zusätzlicher Schaden",
  T_32_YS_WEAPON_TAG_3: "Feuerrate",
  T_32_YS_WEAPON_TAG_36: "Panzerung durchdringen",
  T_32_YS_WEAPON_TAG_39: "Supports Akimbo",
  T_32_YS_WEAPON_TAG_42: "Ice Wall",
  T_33_C_SKILL_DESC_GRAFFITIST: "Creates a [FFB300]{0}m[-] area, where throwables are invalid. Allies in the area will restore [FFB300]{1}%[-]  armor durability per second and damage from ammo will reduce by [FFB300]{2}%[-] . Lasts for [FFB300]{3}s[-] . Effects do not stack. Cooldown: [FFB300]{4}s[-] .",
  T_33_C_SKILL_DESC_HITMAN: "When using Snipers and Marksman Rifles, firing sound is silenced and enemies knocked down by the user bleed [FFB300]{0}%[-] faster.",
  T_33_C_SKILL_DESC_KENTA: "Forms a shield of [FFB300]{0}m[-] width that reduces [FFB300]{1}%[-] weapon damage coming from the front. When firing, the shield's damage reduction reduces to [FFB300]{2}%[-]. Lasts for [FFB300]{3}s[-]. Cooldown: [FFB300]{4}s[-].",
  T_33_C_SKILL_DESC_MADEMANA: "Unleashes an electromagnetic wave with a diameter of [FFB300]{0}m[-] that disables enemies' skill activation, inflicts [FFB300]{3} DMG[-], and interrupts their interaction countdown. Lasts for [FFB300]{1}s[-]. Cooldown: [FFB300]{2}s[-].",
  T_33_C_SKILL_NAME_BODYGUARD: "Firearms Expert",
  T_33_C_SKILL_NAME_KENTA: "Swordsman's Wrath",
  T_33_C_SKILL_NAME_MADEMANA: "Thrill of Battle",
  T_33_DY_AXOLOTL_N: "Zasil",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "Pet Skin: Fruity Zasil",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "Pet skin: FFWS Beanie",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "Pet skin: Blooming Falco",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "Bat - Deadly Baguette",
  T_33_HQ_EMOTE_SONGKRAN_N: "Come and Dance",
  T_33_HQ_G18_CYBERTHIEF_N: "G18 - Hypercore Blues",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "Grenade - Hypercore Blues",
  T_33_HQ_M14_SPIDERLILY_N: "M14 - Burning Lily",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7 - Shadow Rogue",
  T_33_HQ_MP40_FFWS03_N: "MP40 - Haven Warrior",
  T_33_HQ_SCAR_FFWS03_N: "SCAR - Haven Warrior",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "Scythe - Emerald Power",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "Dagger - Haven Warrior",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "Vector - Hypercore Blues",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "Jeep - Emerald Shimmer",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "Monster Truck - Bonebruiser Scorch",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "Pickup Truck - Haven Guardian",
  T_33_LO_WS_BHPARA_A: "Active",
  T_33_LO_WS_BHPARA_ATKMODE: "Attack type",
  T_33_LO_WS_BHPARA_GROUP: "Faction",
  T_33_LO_WS_BHPARA_NA: "No attack",
  T_33_LO_WS_BHPARA_P: "Passive",
  T_33_LO_WS_DICE_DESC: "A dice that enhances your jumps and can be used in various gameplay",
  T_33_LO_WS_DICEVXZ: "Horizontal Speed",
  T_33_LO_WS_DICEVY: "Vertical Speed",
  T_33_LO_WS_DTOWER: "Tower",
  T_33_LO_WS_DTOWER_DESC: "Automatically attacks enemies who are within a certain distance from the defensive structure. Destroyed if its HP reaches zero. (Not valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_33_LO_WS_FORT: "Fortress",
  T_33_LO_WS_FORT_DESC: "Automatically attacks enemies who are within a certain distance from the critical structure. Destroyed if its HP reaches zero. (Not valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_33_LO_WS_ITEM89: "Refinery Tank",
  T_33_LO_WS_ITEM89_DESC: "A water-storing structure",
  T_33_LO_WS_ITEM90: "Dog House",
  T_33_LO_WS_ITEM90_DESC: "A home for puppies",
  T_33_LO_WS_ITEM91: "Bus Stop",
  T_33_LO_WS_ITEM91_DESC: "A common bus stop",
  T_33_LO_WS_ITEM92: "Graffiti Wall",
  T_33_LO_WS_ITEM92_DESC: "A wall adorned with spraypaint",
  T_33_LO_WS_ITEM93: "Stable",
  T_33_LO_WS_ITEM93_DESC: "Basic hay-made structure",
  T_33_LO_WS_ITEM94: "Bench",
  T_33_LO_WS_ITEM94_DESC: "A park bench",
  T_33_LO_WS_ITEM95: "Stone Bridge",
  T_33_LO_WS_ITEM95_DESC: "A bridge built with stones",
  T_33_LO_WS_ITEM96: "Sun Shade",
  T_33_LO_WS_ITEM96_DESC: "Prevent sun-burn under the umbrella",
  T_33_LO_WS_ITEM97: "Finish Line Arch",
  T_33_LO_WS_ITEM97_DESC: "Indicate the finishing line",
  T_33_LO_WS_ITEM98: "Ad Board",
  T_33_LO_WS_ITEM98_DESC: "A regular banner for ads",
  T_33_LO_WS_PARA_DM: "Damage",
  T_33_LO_WS_PARA_HP: "HP",
  T_33_LO_WS_PARA_RANGE: "Enemy scan distance",
  T_33_LO_WS_PARA_SP: "Speed",
  T_33_LO_WS_ZBPARA_AMOUNT: "Zombies per wave",
  T_33_LO_WS_ZBPARA_INTERVAL: "Wave interval (s)",
  T_33_LO_WS_ZBPARA_ROUND: "# of waves",
  T_33_LO_WS_ZBSPAWNER: "Zombie Spawn",
  T_33_LO_WS_ZBSPAWNER_DESC: "Automatically spawns zombies according to configurations. Their behavior can be configured using the drop-down menu. (Not valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_33_MF_CHARACTER_BLACKSMITH_N: "Kenta",
  T_33_PD_ZOMBIE_LEVELUP: "Level up",
  T_33_RW_SKILL_DESC_GANGGIRL: "Increases firing rate by [FFB300]{0}%[-]. When user hits an enemy, a maximum of [FFB300]{1}%[-] of the firing rate converts into movement speed, and the conversion resets when user survives the combat.",
  T_33_RW_SKILL_NAME_GANGGIRL: "Fight-or-Flight",
  T_33_WT_WS_BASICSET1: "Basic",
  T_33_WT_WS_QCEPRTIP: "Convert EP into HP faster",
  T_33_WT_WS_SKILLSET_TAG: "Unlimited skill",
  T_33_WT_WS_SKILLSET1: "Skills Settings",
  T_33_WT_WS_SKILLSET10: "Time Turner (Chrono)",
  T_33_WT_WS_SKILLSET11: "Riptide Rhythm (Skyler)",
  T_33_WT_WS_SKILLSET12: "Xtreme Encounter (Xayne)",
  T_33_WT_WS_SKILLSET13: "Healing Heartbeat (Dimitri)",
  T_33_WT_WS_SKILLSET2: "Passive Skills",
  T_33_WT_WS_SKILLSET2_TIP: "Turn on/off passive skills",
  T_33_WT_WS_SKILLSET3: "Active Skills (turn on to adjust cooldown time below)",
  T_33_WT_WS_SKILLSET3_TIP: "Turn active skills on/off. If on, cooldown time of various active skills can be configured below.",
  T_33_WT_WS_SKILLSET4: "Camouflage (Wukong)",
  T_33_WT_WS_SKILLSET5: "Thrill of Battle (A124)",
  T_33_WT_WS_SKILLSET6: "Drop the Beat (Alok)",
  T_33_WT_WS_SKILLSET7: "Painted Refuge (Steffie)",
  T_33_WT_WS_SKILLSET8: "Tracing Steps (Clu)",
  T_33_WT_WS_SKILLSET9: "Master of All (K)",
  T_33_WT_WS_UNIT_HPSECOND: "HP/s",
  T_33_WT_WS_UNIT_METER: "m",
  T_33_WT_WS_UNIT_SECOND: "sec",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "Raindoll (Bottom)",
  T_33_YS_H_ONIGIRI: "Onigiri Hood",
  T_33_YS_H_RAINCOAT: "Raindoll (Head)",
  T_33_YS_HA_CRYINGFACE: "Crying Emote (Facepaint)",
  T_33_YS_M_H_FROGKING: "Frog King Cap",
  T_33_YS_S_RAINCOAT: "Raindoll (Shoes)",
  T_33_YS_T_BLACKHOLE: "The Doppler Shift Hoodie",
  T_33_YS_T_RAINCOAT: "Raindoll (Top)",
  T_33_YS_T_SOCCER_GREEN: "Electrified Kick (Jersey)",
  T_33_YS_T_SOCCER_YELLOW: "Energized Kick (Jersey)",
  T_33_YS_T_WIFI: "Net n' Next T-shirt",
  T_34_C_SKILL_DESC_STREAMERGUY: "Every elimination or spectator grants one stack of the effect. Each stack reduces headshot damage received by [FFB300]{0}%[-] (max. [FFB300]{1}%[-] in total) and increases headshot damage to enemies by [FFB300]{2}%[-] (max. [FFB300]{3}%[-] in total).",
  T_34_C_SKILL_DESC_TRACKER: "Releases a drone towards the nearest enemy within a [FFB300]100m[-] frontal distance, creating a [FFB300]{5}m-diameter[-] pulse explosion which reduces movement speed by [FFB300]{0}%[-] and firing speed by [FFB300]{1}%[-]. Lasts for [FFB300]{3}s[-]. Deals [FFB300]{2} DMG[-]. Cooldown: [FFB300]{4}s[-].",
  T_34_C_SKILL_NAME_TRACKER: "Senses Shockwave",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "Pet Skin: Angry Surfer Finn",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "Pet Skin: Deep Ocean Finn",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "Pet Skin: Thunderstorm Finn",
  T_34_DY_PETSKIN_TIGER_BIS_N: "Pet Skin: Digital Tig",
  T_34_DY_SURFSHARK_N: "Finn",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "Great Conductor",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "Energetic",
  T_34_HQ_EMOTE_RIDICULE_N: "Ridicule",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "Pickup Truck - Evil Engineer",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "Tuk Tuk - Husky Pup",
  T_34_JL_EAGLE_RAMPAGE4_N: "Desert Eagle - Hybrid Explosion",
  T_34_JL_G36_MADBIONIC_N: "G36 - Flaring Bionica",
  T_34_JL_GRENADE_BIS_N: "Grenade - Soldier Pixel",
  T_34_JL_MACHETE_RAMPAGE4_N: "Parang - Night Blade",
  T_34_JL_THROWINGKNIFE_BANANA_N: "Dagger - Banana",
  T_34_JL_UMP45_BIS_N: "UMP - Digital Dasher",
  T_34_LY_WS_ABS_DESC: "Get the absolute value of this number",
  T_34_LY_WS_ADD_DESC: "Add a new element to the end of a list",
  T_34_LY_WS_AUTO_A: "Auto Scan Enemies",
  T_34_LY_WS_BOT: "Regular",
  T_34_LY_WS_BOT_PATH: "Path",
  T_34_LY_WS_BOT_TYPE: "Type",
  T_34_LY_WS_BOT4: "Axe",
  T_34_LY_WS_BOT5: "Tossing",
  T_34_LY_WS_BOT6: "Self-explode",
  T_34_LY_WS_BOT8: "Shielded",
  T_34_LY_WS_COL_DESC: "Select a color",
  T_34_LY_WS_DEL_DESC: "Delete the corresponding element of a designated index in a list",
  T_34_LY_WS_DF_PER: "Defense %",
  T_34_LY_WS_FORT_INTERVAL: "Attack interval time (s)",
  T_34_LY_WS_GET: "Obtain",
  T_34_LY_WS_GET_DESC: "Get the corresponding element of a designated index in a list",
  T_34_LY_WS_GLEN_ARR_DESC: "Get the number of elements in the current list",
  T_34_LY_WS_GLEN_DESC: "Obtain the length of this string of text",
  T_34_LY_WS_GVX: "Get x vector component",
  T_34_LY_WS_GVX_DESC: "Get the first component of a vector",
  T_34_LY_WS_GVY: "Get y vector component",
  T_34_LY_WS_GVY_DESC: "Get the second component of a vector",
  T_34_LY_WS_GVZ: "Obtain z vector component",
  T_34_LY_WS_GVZ_DESC: "Get the third component of a vector",
  T_34_LY_WS_INDEX: "Index",
  T_34_LY_WS_JOIN: "Connect",
  T_34_LY_WS_NEG_DESC: "Get the negative value of this number",
  T_34_LY_WS_PATH: "Path Setter",
  T_34_LY_WS_PATH_DESC: "Use to add/delete traveling paths of special living items. (Not valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_34_LY_WS_POINT: "Marker",
  T_34_LY_WS_POINT_DESC: "Use to mark out the coordinates of the current location. (Not valid in Clash Squad, Team Deathmatch, and Playground modes)",
  T_34_LY_WS_RANGE_F: "Far",
  T_34_LY_WS_RANGE_M: "Medium",
  T_34_LY_WS_RANGE_N: "Near",
  T_34_LY_WS_RNDF_DESC: "Generate a random float from an interval",
  T_34_LY_WS_RNDI_DESC: "Generate a random integer from an interval",
  T_34_LY_WS_SET: "Set",
  T_34_LY_WS_SET_DESC: "Set the corresponding element of a designated index in a list",
  T_34_LY_WS_SQRT_DESC: "Obtain the square root of this number",
  T_34_LY_WS_STRC_DESC: "Connect two strings of texts",
  T_34_LY_WS_SVX: "Set x vector component",
  T_34_LY_WS_SVX_DESC: "Set the first component of a vector",
  T_34_LY_WS_SVY: "Set y vector component",
  T_34_LY_WS_SVY_DESC: "Set the second component of a vector",
  T_34_LY_WS_SVZ: "Set z vector component",
  T_34_LY_WS_SVZ_DESC: "Set the third component of a vector",
  T_34_LY_WS_VADD: "Vector addition",
  T_34_LY_WS_VADD_DESC: "Add two vectors",
  T_34_LY_WS_VAL_DESC: "Input an integer or float according to the scenario",
  T_34_LY_WS_VANG_DESC: "Calculate the angle between two vectors",
  T_34_LY_WS_VCP: "Cross product",
  T_34_LY_WS_VCP_DESC: "Calculate the cross product of two vectors",
  T_34_LY_WS_VDIS_DESC: "Calculate the distance between two vectors",
  T_34_LY_WS_VDP: "Dot product",
  T_34_LY_WS_VDP_DESC: "Calculate the dot product of two vectors",
  T_34_LY_WS_VFX1: "Spherical",
  T_34_LY_WS_VFX2: "Cylindrical",
  T_34_LY_WS_VFX3: "Ring",
  T_34_LY_WS_VFX4: "Boom",
  T_34_LY_WS_VFX5: "Pixels",
  T_34_LY_WS_VFX6: "Sparks",
  T_34_LY_WS_VMOD_DESC: "Calculate the magnitude of a vector",
  T_34_LY_WS_VMUL: "Vector multiplication",
  T_34_LY_WS_VMUL_DESC: "Multiply two vectors",
  T_34_LY_WS_VNOR_DESC: "Normalize a vector",
  T_34_LY_WS_VSUB: "Vector subtraction",
  T_34_LY_WS_VSUB_DESC: "Subtract two vectors",
  T_34_M_WS_ANGLE: "Rotate angle",
  T_34_M_WS_ARRAY: "List",
  T_34_M_WS_ATT: "Property",
  T_34_M_WS_BOOL: "Boolean",
  T_34_M_WS_COLORARRAY: "Color array",
  T_34_M_WS_COLOUR: "Color",
  T_34_M_WS_CONFRONBANNER: "Battle banner",
  T_34_M_WS_COORDINATE: "Coordinates",
  T_34_M_WS_CUSTOMINF: "Custom HUD",
  T_34_M_WS_CUSTOMMODEDESC: `An empty and fully customizable mode with no preset gameplay, where you can create and play by your own rules.
A little tricky for beginner map creators.`,
  T_34_M_WS_DAMAGETYPE: "Damage type",
  T_34_M_WS_DAMAGETYPEDESC: "The type of damage currently set by the system",
  T_34_M_WS_DESCTEXT: "Descriptive text",
  T_34_M_WS_DURACTION: "Duration",
  T_34_M_WS_ECAMODE: "Customize Mode",
  T_34_M_WS_ENDPHASEDESC: "Immediately end the current phase and proceed to the next one",
  T_34_M_WS_ENTITY: "Entity",
  T_34_M_WS_FLOAT: "Float",
  T_34_M_WS_GAME: "Game",
  T_34_M_WS_GAMERESULTS: "Match result",
  T_34_M_WS_GETCONTROL2: "Get a control entity from players interface to edit the entity's properties (including design, color, content, etc.)",
  T_34_M_WS_HEIGHT: "Height",
  T_34_M_WS_HUDBUTTONWIDGET: "Button control",
  T_34_M_WS_HUDEMPTYWIDGET: "Empty pivot",
  T_34_M_WS_HUDIMAGEWIDGET: "Image control",
  T_34_M_WS_HUDINPUTWIDGET: "Text box control",
  T_34_M_WS_HUDLABELWIDGET: "Text control",
  T_34_M_WS_ICON: "Icon",
  T_34_M_WS_ICON_AIM: "Aim",
  T_34_M_WS_ICON_ARROW: "Arrow",
  T_34_M_WS_ICON_BLAST: "Blast",
  T_34_M_WS_ICON_CIRCULAR: "Circle",
  T_34_M_WS_ICON_CLOTH: "Palm",
  T_34_M_WS_ICON_COLLIMATION: "Crosshair",
  T_34_M_WS_ICON_CORPSE: "Zombie",
  T_34_M_WS_ICON_CROSS: "Cross",
  T_34_M_WS_ICON_DAY: "Sun",
  T_34_M_WS_ICON_DEFENSE: "Shield",
  T_34_M_WS_ICON_DIALOGUE: "Dialogue",
  T_34_M_WS_ICON_DIAMONDS: "Diamond",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "Exclamation mark",
  T_34_M_WS_ICON_FLAG: "Flag",
  T_34_M_WS_ICON_FOLDER: "Folder",
  T_34_M_WS_ICON_GLASSES: "Eye",
  T_34_M_WS_ICON_GUN: "Gun",
  T_34_M_WS_ICON_HEART: "Heart",
  T_34_M_WS_ICON_HEXAGON: "Hexagon",
  T_34_M_WS_ICON_HOURGLASS: "Hourglass",
  T_34_M_WS_ICON_HOUSE: "House",
  T_34_M_WS_ICON_KEY: "Key",
  T_34_M_WS_ICON_LIGHTNING: "Lightning",
  T_34_M_WS_ICON_LOCK: "Lock",
  T_34_M_WS_ICON_LOOP: "Loop",
  T_34_M_WS_ICON_MAGNIFIER: "Magnifying glass",
  T_34_M_WS_ICON_MONEY: "Money",
  T_34_M_WS_ICON_MONTH: "Moon",
  T_34_M_WS_ICON_OPENFOLDER: "Open folder",
  T_34_M_WS_ICON_PLUS: "Plus",
  T_34_M_WS_ICON_QUADRI: "Quadrilateral",
  T_34_M_WS_ICON_QUESTIONMARK: "Question mark",
  T_34_M_WS_ICON_RECYCLING: "Recycle",
  T_34_M_WS_ICON_REFRESH: "Refresh",
  T_34_M_WS_ICON_REST: "Rest",
  T_34_M_WS_ICON_RETURN: "Back",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "Right trapezoid",
  T_34_M_WS_ICON_SCISSORS: "Scissors",
  T_34_M_WS_ICON_SETUP: "Setting",
  T_34_M_WS_ICON_SIGN: "Mark",
  T_34_M_WS_ICON_SIGNOUT: "Exit",
  T_34_M_WS_ICON_SQUARE: "Square",
  T_34_M_WS_ICON_STAR: "Star",
  T_34_M_WS_ICON_STONE: "Stone",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "Swim ring",
  T_34_M_WS_ICON_TAGGING: "Pin",
  T_34_M_WS_ICON_THESWORD: "Sword",
  T_34_M_WS_ICON_TRAPEZOID: "Trapezoid",
  T_34_M_WS_ICON_TRASHCAN: "Trash can",
  T_34_M_WS_ICON_TRIANGLE: "Triangle",
  T_34_M_WS_ICON_TROPHY: "Trophy",
  T_34_M_WS_ICON_UP: "Thumbs up",
  T_34_M_WS_ICON_WRONG: "Wrong",
  T_34_M_WS_ICON_YES: "Right",
  T_34_M_WS_ICONNAME: "Icon name",
  T_34_M_WS_INT: "Integer",
  T_34_M_WS_KILLZONE: "Doom Zone",
  T_34_M_WS_LEFTCOLOR: "Left color",
  T_34_M_WS_LEFTTEAMINDEX: "Left team index",
  T_34_M_WS_LEFTTEAMSCORE: "Left team score",
  T_34_M_WS_LOCSWITCH: "Localization switch",
  T_34_M_WS_MAX: "Maximum",
  T_34_M_WS_MIN: "Minimum",
  T_34_M_WS_NUMBER: "Number",
  T_34_M_WS_OBJECT: "Entity",
  T_34_M_WS_OPEN: "On",
  T_34_M_WS_OPENSATUS: "Turn on status",
  T_34_M_WS_PICTURE: "Graphics",
  T_34_M_WS_RANKARRAY: "Rank array",
  T_34_M_WS_RESULTS: "Results",
  T_34_M_WS_RIGHTCOLOR: "Right color",
  T_34_M_WS_RIGHTTEAMINDEX: "Right team index",
  T_34_M_WS_RIGHTTEAMSCORE: "Right team score",
  T_34_M_WS_ROUNDBANNER: "Round banner",
  T_34_M_WS_ROUNDDESC: "Round description",
  T_34_M_WS_ROUNDHUD: "Round number",
  T_34_M_WS_ROUNDPARAMS: "Round number array",
  T_34_M_WS_SAME_NAME: "Repeated name. Please try a new one.",
  T_34_M_WS_SCOREARRAY: "Score array",
  T_34_M_WS_SCORINGTYPE: "Score type",
  T_34_M_WS_SCORINGTYPEDECS: "The type of score players could get. Supports score customization.",
  T_34_M_WS_SCUFFLESCORING: "Multi-team score",
  T_34_M_WS_SETATTRIBUTES: "Property settings",
  T_34_M_WS_SHUT: "Off",
  T_34_M_WS_SOUND: "Sound effects",
  T_34_M_WS_SOUNDCLICK: "Clicking",
  T_34_M_WS_SOUNDDD: "Countdown",
  T_34_M_WS_SOUNDFEMALEA: "Injured (Female)",
  T_34_M_WS_SOUNDM: "Gunfire",
  T_34_M_WS_SOUNDMALEA: "Injured (Male)",
  T_34_M_WS_SOUNDUAV: "Explosion",
  T_34_M_WS_ST_ASSISTCOUNT: "Assists",
  T_34_M_WS_ST_CHECKPROGRESS: "Checkpoint progress",
  T_34_M_WS_ST_DAMAGESUM: "Damage",
  T_34_M_WS_ST_FINISHCOUNT: "Amount of goals achieved",
  T_34_M_WS_ST_FINISHORDER: "Order of goals achieved",
  T_34_M_WS_ST_FINISHTIME: "Time of goals achieved",
  T_34_M_WS_ST_KILLCOUNT: "Eliminations",
  T_34_M_WS_ST_MAINSCORE: "Target score",
  T_34_M_WS_ST_RANKSCORE: "Rank score",
  T_34_M_WS_ST_SURVIVALDURACTION: "Survival time",
  T_34_M_WS_ST_UNKOWN: "Unknown",
  T_34_M_WS_STARTBANNER: "Start banner",
  T_34_M_WS_STARTTIME: "Start time",
  T_34_M_WS_STRING: "Text",
  T_34_M_WS_STUDIO: "STUDIO",
  T_34_M_WS_TEAMARRAY: "Team array",
  T_34_M_WS_TEXTCONTENT: "Content",
  T_34_M_WS_THEMECOLOR: "Theme color",
  T_34_M_WS_TIME: "Countdown HUD",
  T_34_M_WS_TITLETEXT: "Title text",
  T_34_M_WS_TYPE: "Type",
  T_34_M_WS_UODATETYPE: "Update type",
  T_34_M_WS_VARNAME: "Variable name",
  T_34_M_WS_VECTOR: "Vector",
  T_34_M_WS_VFX: "Visual effects",
  T_34_M_WS_WIDTH: "Width",
  T_34_MF_CHARACTER_TRACKER_N: "Homer",
  T_34_PD_FlagBattle_HYPE_1: "Fire",
  T_34_SP_WS_BLOCK1_NAME: "Switch phase",
  T_34_SP_WS_BLOCK1_NAMEDESC: "Switch the phase of a match to enter into a desired phase (or round). Rounds also have phase indices and are a special type of phase.",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "The index of the target phase",
  T_34_SP_WS_BLOCK10_NAME: "Create visual effects",
  T_34_SP_WS_BLOCK10_NAMEDESC: "Create an icon using designated visual effects. More properties of the visual effect can be configured by adjusting the properties of the visual effects entity.",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "Visual effect",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "The kinds of visual effects that can be applied",
  T_34_SP_WS_BLOCK12_NAME: "Delete visual effects",
  T_34_SP_WS_BLOCK12_NAMEDESC: "Delete the designated visual effect",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "Visual effects entity",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "The visual effect entity to be deleted",
  T_34_SP_WS_BLOCK13_NAMEDESC: "Order the client to play the visual effect",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "Players list",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "The players who will receive the message",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "Resource path",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "System resource path is in:path. Custom resource path is out:path. Empty by default.",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "RGBA channel, with each channel taking a value between 0 and 255 saved in int32. Default color is white (255,255,255,255).",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "Zoom",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "Zoom scale; default is 1",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "Position of display expressed in global coordinates. Vector3(0) by default.",
  T_34_SP_WS_BLOCK14_NAME: "Play sound effect",
  T_34_SP_WS_BLOCK14_NAMEDESC: "Order the client to play the sound effect",
  T_34_SP_WS_BLOCK15_NAME: "Output log",
  T_34_SP_WS_BLOCK15_NAMEDESC: "Output content onto the log interface",
  T_34_SP_WS_BLOCK2_NAMEDESC: "Turn on to enable damage to players outside the Safe Zone",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "The center point of the Safe Zone",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "Radius",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "The radius of the Safe Zone",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "The countdown for the Safe Zone to start shrinking",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "The duration of the Safe Zone shrink",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "The amount of damage taken when outside the Safe Zone",
  T_34_SP_WS_BLOCK3_NAMEDESC: "When Danger Zone is turned off, players outside the Safe Zone will not receive damage",
  T_34_SP_WS_BLOCK4_NAMEDESC: "Use to delay a subsequent action for a designated time",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "The duration of the wait, measured in milleseconds",
  T_34_SP_WS_BLOCK5_NAMEDESC: "Use to postpone a subsequent action to the next frame",
  T_34_SP_WS_BLOCK6_NAME: "Create custom HUD",
  T_34_SP_WS_BLOCK6_NAMEDESC: "Create a designated custom HUD",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "A name that is used for creating a HUD entity. The local variable it corresponds to is the entity of the HUD being created.",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "Player",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "The entity of a specific player. Only visible to said player.",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "The unique index of a HUD",
  T_34_SP_WS_BLOCK7_NAMEDESC: "Create a default HUD, which is only visible for designated players",
  T_34_SP_WS_BLOCK8_NAMEDESC: "When deleted, the default HUD will not be seen on the client (either hidden or discarded)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "HUD entity",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "The HUD entity to be deleted",
  T_34_SP_WS_BLOCK9_NAMEDESC: "When deleted, the custom HUD will not be seen on the client (either hidden or discarded)",
  T_34_T_WS_BLOCK1_NAMEDESC: "Incident triggers when the match begins",
  T_34_T_WS_BLOCK10_NAMEDESC: "Incident triggers when a player is eliminated",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "The eliminated player who will trigger the incident",
  T_34_T_WS_BLOCK13_NAMEDESC: "Incident triggers when a player assists another player",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "The player who is eliminated",
  T_34_T_WS_BLOCK14_NAMEDESC: "Incident triggers when a player deals damage",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "The player who receives the damage",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "The type of damage being inflicted",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "The amount of damage inflicted",
  T_34_T_WS_BLOCK15_NAMEDESC: "Incident triggers when a player eliminates another player",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "The player who is eliminated",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "The type of damage that cause the elimination",
  T_34_T_WS_BLOCK16_NAMEDESC: "Incident triggers when a player joins the match",
  T_34_T_WS_BLOCK17_NAMEDESC: "Incident triggers when a player is revived",
  T_34_T_WS_BLOCK18_NAMEDESC: "Incident triggers when a team is removed",
  T_34_T_WS_BLOCK19_NAMEDESC: "Incident triggers when a team is added",
  T_34_T_WS_BLOCK2_NAMEDESC: "Incident triggers when the match ends",
  T_34_T_WS_BLOCK20_NAMEDESC: "Incident triggers when a team is wiped out",
  T_34_T_WS_BLOCK3_NAMEDESC: "Incident triggers when each round begins",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "The round number starts from 0",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "Round index",
  T_34_T_WS_BLOCK4_NAMEDESC: "Incident triggers when each round ends",
  T_34_T_WS_BLOCK5_NAMEDESC: "Incident triggers when the phase begins",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "The phase number starts from 0",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "Phase entity",
  T_34_T_WS_BLOCK6_NAMEDESC: "Incident triggers when the phase ends",
  T_34_T_WS_BLOCK7_NAMEDESC: "Incident triggers when a player exits the match",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "The player who will trigger the incident",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "Triggering player",
  T_34_T_WS_BLOCK8_NAMEDESC: "Incident triggers when a player's score changes",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "The type of the changed score",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "The score value after the change",
  T_34_T_WS_BLOCK9_NAMEDESC: "Incident triggers when a team's score changes",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "The team who will trigger the incident",
  T_34_WT_WS_BORNENTITY_PARAM1: "Spawn point",
  T_34_WT_WS_BORNENTITY_PARAM2: "Available coordinates",
  T_34_WT_WS_BORNENTITY_PARAM3: "Set as default spawn point",
  T_34_WT_WS_BORNENTITY_PARAM4: "Glowing boundaries",
  T_34_WT_WS_BORNENTITY_PARAM5: "In use or not",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "Checkpoint HUD",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "Open status",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "Status trigger",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "Elimination trigger or not",
  T_34_WT_WS_ENTITY_PARAM1: "Game entity",
  T_34_WT_WS_ENTITY_PARAM10: "# of teams",
  T_34_WT_WS_ENTITY_PARAM11: "# of team members",
  T_34_WT_WS_ENTITY_PARAM12: "Equipment reset each round",
  T_34_WT_WS_ENTITY_PARAM13: "Enable out-of-zone damage",
  T_34_WT_WS_ENTITY_PARAM14: "Zone size",
  T_34_WT_WS_ENTITY_PARAM15: "Zone shrink start time",
  T_34_WT_WS_ENTITY_PARAM16: "Zone shrink duration",
  T_34_WT_WS_ENTITY_PARAM17: "Out-of-zone damage",
  T_34_WT_WS_ENTITY_PARAM18: "Target score",
  T_34_WT_WS_ENTITY_PARAM19: "Elimination score",
  T_34_WT_WS_ENTITY_PARAM2: "Invalid status",
  T_34_WT_WS_ENTITY_PARAM20: "Revival type",
  T_34_WT_WS_ENTITY_PARAM21: "Round score ranking criteria (player)",
  T_34_WT_WS_ENTITY_PARAM22: "Criteria importance (player)",
  T_34_WT_WS_ENTITY_PARAM23: "Round score ranking criteria (team)",
  T_34_WT_WS_ENTITY_PARAM24: "Criteria importance (team)",
  T_34_WT_WS_ENTITY_PARAM25: "Score ranking criteria (MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "Criteria importance (MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "Round ranking score",
  T_34_WT_WS_ENTITY_PARAM28: "Show criteria on results page",
  T_34_WT_WS_ENTITY_PARAM29: "Total # of rounds",
  T_34_WT_WS_ENTITY_PARAM3: "Game time",
  T_34_WT_WS_ENTITY_PARAM4: "Current round index",
  T_34_WT_WS_ENTITY_PARAM5: "Current phase index",
  T_34_WT_WS_ENTITY_PARAM6: "Mode template ID",
  T_34_WT_WS_ENTITY_PARAM7: "Enable player revival",
  T_34_WT_WS_ENTITY_PARAM8: "Enable bot revival",
  T_34_WT_WS_ENTITY_PARAM9: "Revival time",
  T_34_WT_WS_ENTITY1_NAME: "Current entity",
  T_34_WT_WS_ENTITY1_NAMEDESC: "Return to current entity",
  T_34_WT_WS_ENTITY10_NAME: "Remove icon",
  T_34_WT_WS_ENTITY10_NAMEDESC: "Remove a designated icon",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "Select the icon you wish to remove",
  T_34_WT_WS_ENTITY11_NAME: "Remove text",
  T_34_WT_WS_ENTITY11_NAMEDESC: "Remove a text entity",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "Select the text you wish to remove",
  T_34_WT_WS_ENTITY12_NAMEDESC: "Add an item for a designated player",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "Player(s) who will receive the item",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "The specific item ID to be got",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "The amount of items to be given",
  T_34_WT_WS_ENTITY12_PARAM3: "Quantity",
  T_34_WT_WS_ENTITY13_PARAM1: "Type",
  T_34_WT_WS_ENTITY13_PARAM2: "Location",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "The coordinates of the object's spawn location",
  T_34_WT_WS_ENTITY13_PARAM4: "Object",
  T_34_WT_WS_ENTITY14_NAME: "Remove object",
  T_34_WT_WS_ENTITY14_NAMEDESC: "Remove a designated object",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "Delete the object",
  T_34_WT_WS_ENTITY15_NAMEDESC: "Acquire all player entities",
  T_34_WT_WS_ENTITY16_NAMEDESC: "Acquire all team entities",
  T_34_WT_WS_ENTITY17_NAMEDESC: "Recover a designated amount of HP for designated players. If the recovery amount exceeds the maximum HP, the HP will only recover to the maximum.",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "Player(s) whose HP fluctuation(s) are being configured",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "The designated amount of HP to be recovered",
  T_34_WT_WS_ENTITY18_NAME: "Get random spawn coordinates",
  T_34_WT_WS_ENTITY18_NAMEDESC: "Configure the location for designated players to spawn from and return to",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "Player(s) who will randomly spawn from this location",
  T_34_WT_WS_ENTITY18_RETURNDESC: "The coordinates of the location where the player will be assigned",
  T_34_WT_WS_ENTITY19_NAME: "Get player score",
  T_34_WT_WS_ENTITY19_NAMEDESC: "Acquire certain scores of designated players",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "Acquire the score entity of this player(s)",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "Acquire the type of score",
  T_34_WT_WS_ENTITY19_RETURNDESC: "The specific score value to be got",
  T_34_WT_WS_ENTITY2_NAME: "Set property",
  T_34_WT_WS_ENTITY2_NAMEDESC: "Configure the value of a property, where the property type has already been selected",
  T_34_WT_WS_ENTITY2_PARAM1: "Entity",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "The property value of the game entity",
  T_34_WT_WS_ENTITY2_PARAM3: "Property",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "A certain property of this game entity",
  T_34_WT_WS_ENTITY2_PARAM4: "Value",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "A specific value of a property. Make sure that the property type aligns with the one selected and matches the type  configured in related blocks.",
  T_34_WT_WS_ENTITY20_NAMEDESC: "Configure certain scores of designated players",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "Configure the score entity of this player(s)",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "Configure the type of score",
  T_34_WT_WS_ENTITY20_PARAM3: "Score",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "The specific score value being set",
  T_34_WT_WS_ENTITY21_NAME: "Get team total score",
  T_34_WT_WS_ENTITY21_NAMEDESC: "Acquire a certain kind of total scores of designated teams",
  T_34_WT_WS_ENTITY21_PARAM1: "Team",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "Get the score entity of this team(s)",
  T_34_WT_WS_ENTITY22_NAME: "Set team current round score",
  T_34_WT_WS_ENTITY22_NAMEDESC: "Configure a certain kind of current round scores of designated teams",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "Configure the score(s) of this team(s)",
  T_34_WT_WS_ENTITY23_NAME: "Obtain player round score",
  T_34_WT_WS_ENTITY23_NAMEDESC: "Acquire certain scores of a certain round for designated players",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "Acquire the round score(s) of this player(s)",
  T_34_WT_WS_ENTITY23_PARAM2: "Round",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "Get the score from this round",
  T_34_WT_WS_ENTITY24_NAME: "Get team round score",
  T_34_WT_WS_ENTITY24_NAMEDESC: "Acquire certain scores of a certain round for designated teams",
  T_34_WT_WS_ENTITY25_NAME: "Teleport",
  T_34_WT_WS_ENTITY25_NAMEDESC: "Teleport designated players to a designated location",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "Player(s) who will be teleported",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "Coordinates of where the player(s) will be teleported",
  T_34_WT_WS_ENTITY26_NAMEDESC: "Enable designated players to cause damage to designated targets. If no attacking player is selected, designated targets will receive damage from the system.",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "Entities who will receive the damage",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "The amount of damage dealt",
  T_34_WT_WS_ENTITY28_NAMEDESC: "Revive designated players",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "Player entities who can be revived",
  T_34_WT_WS_ENTITY3_NAMEDESC: "Configure the type of the block",
  T_34_WT_WS_ENTITY3_PARAM1: "as",
  T_34_WT_WS_ENTITY4_NAME: "Get property",
  T_34_WT_WS_ENTITY4_NAMEDESC: "Get a specific property of an entity",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "Get the specific game entity of the property value",
  T_34_WT_WS_ENTITY4_RETURNDESC: "The specific property value to be got",
  T_34_WT_WS_ENTITY5_NAMEDESC: "Configure the ability to move for all players",
  T_34_WT_WS_ENTITY6_NAME: "Create Icon",
  T_34_WT_WS_ENTITY6_PARAM1: "Icon",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "An image displayed on the HUD. Select from various designs.",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "Select the icon on which the design should be applied",
  T_34_WT_WS_ENTITY7_NAMEDESC: "Create a HUD icon for designated players. If no player entity is selected, the HUD will be created for all players.",
  T_34_WT_WS_ENTITY7_PARAM1: "Player",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "Create a HUD icon for select player(s)",
  T_34_WT_WS_ENTITY8_NAME: "Create text",
  T_34_WT_WS_ENTITY8_PARAM1: "Text",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "The specific text content to be created from this command",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "The text entity that is currently being created",
  T_34_WT_WS_ENTITY9_NAMEDESC: "Add a line of HUD text for designated players. If no player entity is selected, the text will be created on the HUD of all players.",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "Add a HUD text for select player(s)",
  T_34_WT_WS_ICONENTITY_PARAM1: "Icon entity",
  T_34_WT_WS_ICONENTITY_PARAM2: "Design",
  T_34_WT_WS_ICONENTITY_PARAM3: "Color",
  T_34_WT_WS_ICONENTITY_PARAM4: "Scale",
  T_34_WT_WS_ICONENTITY_PARAM5: "Position of display",
  T_34_WT_WS_ICONENTITY_PARAM6: "Follow target",
  T_34_WT_WS_ICONENTITY_PARAM7: "Visible through walls",
  T_34_WT_WS_ICONENTITY_PARAM8: "Always on screen",
  T_34_WT_WS_ONETEAM_TAG: "Single Team",
  T_34_WT_WS_PHASEENTITY_PARAM1: "Phase entity",
  T_34_WT_WS_PHASEENTITY_PARAM2: "Phase index",
  T_34_WT_WS_PHASEENTITY_PARAM3: "Start time",
  T_34_WT_WS_PHASEENTITY_PARAM4: "End time",
  T_34_WT_WS_PHASEENTITY_PARAM5: "Duration",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "Player entity",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "Revival point",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "Damage ratio",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "Character 3D model",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "Identity",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "Current HP",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "Max. HP",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "AI",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "Player status",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "Survival time",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "Invulnerable",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "Team",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "Target checkpoint ID",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "Spawn point",
  T_34_WT_WS_PROCIRCLE_ICON: "Icon",
  T_34_WT_WS_PVEDESC1: "If at least one player reaches the finishing line before time runs out, team wins. If all players are eliminated at the same time, game over.",
  T_34_WT_WS_PVEDESC2: "Survive for a designated time to win. If all players are eliminated at the same time, game over.",
  T_34_WT_WS_PVENAME1: "Rush",
  T_34_WT_WS_PVENAME2: "Endurance",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "Current checkpoint ID",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "Parkour mode checkpoint number",
  T_34_WT_WS_SKILLSET14: "Swordsman's Wrath (Kenta)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "Team entity",
  T_34_WT_WS_TEAMENTITY_PARAM2: "Ace",
  T_34_WT_WS_TEAMENTITY_PARAM3: "All members",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "Regular trigger",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "Appearance type",
  T_34_WT_WS_TXTENTITY_PARAM1: "Text entity",
  T_34_WT_WS_TXTENTITY_PARAM2: "Content",
  T_34_WT_WS_VFXENTITY_PARAM1: "Visual effects entity",
  T_34_WZ_WS_LOGIC10_NAME: "Continue to next",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "Skip the current loop iteration and execute the next",
  T_34_WZ_WS_LOGIC11_NAME: "Return",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "Terminates the current execution and returns to the main program. Allows sending back data when returning.",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "Return value",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "The data to be sent back to the main program",
  T_34_WZ_WS_LOGIC2_NAME: "Compare",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "Compare 2 values using a designated operator",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "Left value",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "The left side value used for the comparison",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "Comparison function",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "Select how you want the values compared. Supported operators are: >, ≥, ==, ≠, ≤, <, AND (Boolean only), OR (Boolean only)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "Right value",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "The right side value used for the comparison",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "Result of the comparison",
  T_34_WZ_WS_LOGIC3_NAME: "NOT",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "Gives the reverse of a logical value",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "The value you wish to use the NOT operator on",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "Result of the NOT operation",
  T_34_WZ_WS_LOGIC4_NAME: "Check null",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "Check whether an entity is null",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "Entity",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "The entity to check emptiness for",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "Whether or not the entity is empty",
  T_34_WZ_WS_LOGIC5_NAME: "If",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "Executes according to whether conditions are being met. The sub-processes are the same as the subsequent logic branches.",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "Value",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "The number of conditions and the number of sub-processes (logic branches) must be the same",
  T_34_WZ_WS_LOGIC6_NAME: "Loop of integer range",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "Loop from x to y by a step of z. The sub-process is the loop itself.",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "The name of the loop index that can be used to extract the value of a local variable's loop index",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "Start value",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "The value at which the loop begins",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "End value",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "The value at which the loop ends",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "Step",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "The step of each loop. When the start value is less than the end value, step should be greater than 0. When the start value is greater than the end value, step should be less than 0.",
  T_34_WZ_WS_LOGIC7_NAME: "Loop every element",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "Enables traversal of a data container to extract each sub-element in it. The sub-process is the loop itself.",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "Element",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "Traversing to this name will extract the value of the local variable's sub-element",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "Data container",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "The data container to traverse. Currently supports list types.",
  T_34_WZ_WS_LOGIC8_NAME: "Conditional loop",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "A conditional loop repeats until a condition is met. The loop stops when condition is False.",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "Condition",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "Repeats loop if condition is True and stops until condition is False",
  T_34_WZ_WS_LOGIC9_NAME: "Break loop",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "Stops the current loop process and jumps out of the loop",
  T_34_Y_B_DINOSAURS: "Dinosaur Illusion (Bottom)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "Pure Angel (F)",
  T_34_YS_F_B_PANDACATTLE: "Moo Zoo (Bottom)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "Aqua Rogue (Bottom)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "Aqua Rogue (Head)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "Aqua Rogue (Facepaint)",
  T_34_YS_F_S_PANDACATTLE: "Moo Zoo (Shoes)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "Aqua Rogue (Shoes)",
  T_34_YS_F_T_PANDACATTLE: "Moo Zoo (Top)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "Aqua Rogue (Top)",
  T_34_YS_M_B_ANGEL_BW: "Pure Angel (M)",
  T_34_YS_M_B_PANDACATTLE: "Panda Pyjamas (Bottom)",
  T_34_YS_M_H_PANDACATTLE: "Panda Pyjamas (Head)",
  T_34_YS_M_S_PANDACATTLE: "Panda Pyjamas (Shoes)",
  T_34_YS_M_T_PANDACATTLE: "Panda Pyjamas (Top)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "A-Patroa",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "Gain [FFB300]{0} EP[-] by knocking down an enemy.",
  T_35_DY_PET_OWL_N: "Hoot",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "Pet Skin: Spaceship Moony",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "Pet Skin: Azulcrema Trace Zasil",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "Pet Skin: Agui Blue",
  T_35_DY_PETSKIN_OWL_FIRE_N: "Pet Skin: Hoot On Fire",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "Pet Skin: Nocturnal Hoot",
  T_35_DY_PETSKIN_OWL_STORM_N: "Pet Skin: Frosty Hoot",
  T_35_JL_KNOCKEDDOWN: "is knocked down",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "For [FFB300]{1}s[-], successfully firing at a Gloo Wall will mark enemies within [FFB300]{3}m[-] of it and penetrate the Gloo Wall to cause damage to marked enemies (damage inflicted will be lower than usual). Effective on [FFB300]{0}[-] Gloo Walls max. Cooldown: [FFB300]{2}s[-].",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "Wall Brawl",
  T_35_KY_INFECTION_MAPNAME: "Wasteland",
  T_35_M_WS_BUTTONCLICKDESC: "Triggers this incident when the corresponding button is tapped. The trigger player can be obtained using parameters.",
  T_35_M_WS_GETTEAMMATEPOS: "Obtain nearby teammates' locations",
  T_35_M_WS_ROUND2: "Current wave",
  T_35_PD_Infection_HUMANSELECT: "Select a weapon",
  T_35_PD_INFECTION_MODENAME: "Droid Apocalypse",
  T_35_QX_WS_ICONTYPE_ITEM: "Object",
  T_35_QX_WS_ICONTYPE_NATURE: "Shapes of Nature",
  T_35_QX_WS_ICONTYPE_SHAPE: "Geometric",
  T_35_QX_WS_ICONTYPE_SYMBOL: "Symbol",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "Weapon",
  T_35_R_EMOTE_TAG_MUSIC_N: "Music",
  T_35_RW_SKILL_DESC_Singers: "Skill user and allies within [FFB300]{0}m[-] can block [FFB300]{1}%[-] DMG using EP. In this case, the amount of EP deducted from allies will be added to the skill user's EP.",
  T_35_RW_SKILL_NAME_Singers: "Silent Sentinel",
  T_35_SP_WS_COMMENTKEY_01: "Suitable Difficulty",
  T_35_SP_WS_COMMENTKEY_02: "Creative",
  T_35_SP_WS_COMMENTKEY_03: "Interesting Gameplay",
  T_35_SP_WS_COMMENTKEY_04: "Can Be Played Repeatedly",
  T_35_SP_WS_COMMENTKEY_05: "Intriguing storyline",
  T_35_SP_WS_COMMENTKEY_06: "Well-Balanced",
  T_35_SP_WS_COMMENTKEY_07: "Pleasant Experience",
  T_35_SP_WS_COMMENTKEY_08: "Flexible",
  T_35_SP_WS_COMMENTKEY_09: "Aesthetically pleasing",
  T_35_SP_WS_COMMENTKEY_10: "Too Difficult",
  T_35_SP_WS_COMMENTKEY_11: "Too Easy",
  T_35_SP_WS_COMMENTKEY_12: "Boring",
  T_35_SP_WS_COMMENTKEY_13: "Too Long",
  T_35_SP_WS_COMMENTKEY_14: "Imbalanced",
  T_35_SP_WS_COMMENTKEY_15: "Unpleasant Experience",
  T_35_SP_WS_IMAGE03: "Texture",
  T_35_SP_WS_IMAGE04: "Frame",
  T_35_SY_CHARGESHOT_TEARS_N: "Charge Buster - Lava Lustre",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "Grenade - Crystal Eerie",
  T_35_SY_GRENADE_PIRATES_N: "Grenade - Rowdy Searuler",
  T_35_SY_GRENADE_RIDERS_N: "Grenade - Grim Rider",
  T_35_SY_M24_KUN_N: "M24 - Riverdust Splasher",
  T_35_SY_SCAR_PARKOUR_N: "SCAR - Gusto Freerunner",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "Jeep - Monochrome Jigsaw",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "Enjoy the celebration!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "Motorbike - Crystal Symmetry",
  T_35_WT_WS_PREFAB_MENUBAR_1: "Structure & Decor",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "Structures",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "Others",
  T_35_WT_WS_PREFAB_MENUBAR_2: "Architecture",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "Large Buildings",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "Mid-Sized Buildings",
  T_35_WT_WS_PREFAB_MENUBAR_3: "Functional Objects",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "Mode Essentials",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "Music",
  T_35_WT_WS_PVEMODE_TAG: "Survival Mode",
  T_35_WZY_WS_BECRE_NAMEDESC: "Triggers when this entity is created",
  T_35_WZY_WS_BEKILL_NAMEDESC: 'Triggers when this entity is eliminated. The source of attack can be identified using "Trigger Entity" and the type of attack can be identified using "Damage Type".',
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "The entity who triggers the incident",
  T_35_WZY_WS_CREPROP_NAMEDESC: "Create a type of item or a set of items at a specific location. When creating one type of item, the amount is the number of that item. When creating a set of items, the amount is the amount list that corresponds to the item list. The created items will depend on the map's units.",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "A list that contains the items that will be created. It can also consist of a single item.",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "An amount list that corresponds to the item list. It may only contain the amount of one item type.",
  T_35_WZY_WS_DAMTYPE_CAR: "Vehicle",
  T_35_WZY_WS_DAMTYPE_FALL: "Fall",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "Gun",
  T_35_WZY_WS_DAMTYPE_GRENADE: "Grenade",
  T_35_WZY_WS_DAMTYPE_MELEE: "Melee",
  T_35_WZY_WS_DAMTYPE_ZONE: "Out-of-zone",
  T_35_WZY_WS_DELPROP_NAMEDESC: "Delete a specified number of items of specific players",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "Enter trigger area",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: 'Triggers when a "Trigger Entity" enters a trigger area',
  T_35_WZY_WS_ENTITYPLAYER_DESC: "The player to get the entity. When linked with the player, the entity's info will only be updated for said player. When no player is linked, all players will receive the entity info.",
  T_35_WZY_WS_FIGHTENTITY_NAME: "Battle Entity",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "Get all objects of a specified type. The result returned is a list.",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "Object type",
  T_35_WZY_WS_HUDWIDGET_NAME: "UI Control",
  T_35_WZY_WS_HURT_NAMEDESC: 'Triggers when this entity takes damage. The source of attack can be identified using "Trigger Entity".',
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "The type of item",
  T_35_WZY_WS_LEVELOBJECT_NAME: "Level Object",
  T_35_WZY_WS_OBKILL_NAMEDESC: 'Triggers when this entity eliminates another entity. The type of entity being eliminated can be identified using "Eliminated Entity".',
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "The entity who is eliminated",
  T_35_WZY_WS_ONHURT_NAMEDESC: "Triggers when an entity causes damage",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "The entity that is dealing damage",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "Target entity",
  T_35_WZY_WS_PREFABID_NAME: "Template ID",
  T_35_WZY_WS_PROPERTY_EPNOW: "Current EP",
  T_35_WZY_WS_PROPERTY_JUMP: "Jump height",
  T_35_WZY_WS_QUITTRIGGER_NAME: "Exit trigger area",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: 'Triggers when a "Trigger Entity" exits a trigger area',
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "Remove a specific element from an list. [List] is the list in which the element lies. [Element] is the element to be removed.",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "Element value",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "The value of the element to be removed",
  T_35_WZY_WS_ROUNDENTITY_NAME: "Round Entity",
  T_35_WZY_WS_TOWER_PARAM1: "Tower and Fortress",
  T_35_WZY_WS_TOWER_PARAM2: "Team ID",
  T_35_WZY_WS_TOWER_PARAM3: "Current HP",
  T_35_WZY_WS_TOWER_PARAM4: "Max. HP",
  T_35_WZY_WS_TOWER_PARAM5: "Damage",
  T_35_WZY_WS_TOWER_PARAM6: "Attack interval",
  T_35_WZY_WS_TOWER_PARAM7: "Range of attack",
  T_35_WZY_WS_TOWER_PARAM8: "Defense %",
  T_35_XYL_PDM_REVENGE: "Avenged",
  T_35_XYL_WS_BISPARTERRE: "Graffiti Flowerbed",
  T_35_XYL_WS_BISPARTERRE_DESC: "A Battle-In-Style-themed stone flowerbed",
  T_35_XYL_WS_BISWALL: "Graffiti Wall",
  T_35_XYL_WS_BISWALL_DESC: "A Battle-In-Style-themed wall that can be combined",
  T_35_XYL_WS_BOTDROP: "Turn on/off loot drop",
  T_35_XYL_WS_CUSTOMTRIGGER: "Custom trigger",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "Place an object that triggers a certain customized special effect when a player activates it. The effect must be configured in the script. (Only in Customize mode.)",
  T_35_XYL_WS_DOUBLEDOOR: "Gate",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "A gate that's cracked open",
  T_35_XYL_WS_RESET: "Reset every round",
  T_35_XYL_WS_RESETN: "No",
  T_35_XYL_WS_RESETY: "Yes",
  T_35_XYL_WS_ROADBLOCK: "Roadblock A",
  T_35_XYL_WS_ROADBLOCK_DESC: "Prevents from passing through",
  T_35_XYL_WS_STAIRS: "Stairs",
  T_35_XYL_WS_STAIRS_DESC: "Stairs that can be combined with landings",
  T_35_XYL_WS_STAIRSL: "Landing B",
  T_35_XYL_WS_STAIRSL_DESC: "A platform that can be combined with stairs",
  T_35_XYL_WS_STAIRSZ: "Landing A",
  T_35_XYL_WS_STAIRSZ_DESC: "A platform that can be combined with stairs",
  T_35_XYL_WS_TBOOTH: "Phone Booth",
  T_35_XYL_WS_TBOOTH_DESC: "Commonly seen on the streets",
  T_35_YF_PP19_N: "Bizon",
  T_35_YS_A_CATEAM_HW: "Agui",
  T_35_YS_A_CUBBY: "Cub Mask",
  T_35_YS_F_A_PANTOMIME: "Two-toned Grief (Mask)",
  T_35_YS_F_A_RIDERS: "Fatal Rider (Mask)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "Beauty Reuniter (Bottom)",
  T_35_YS_F_B_GOLDCHAIN: "Armor of Riches (Bottom)",
  T_35_YS_F_B_PANTOMIME: "Two-toned Grief (Bottom)",
  T_35_YS_F_B_RIDERS: "Fatal Rider (Bottom)",
  T_35_YS_F_H_BEAR_HW: "Cub Cap",
  T_35_YS_F_H_DIGITALUNIVERSE2: "Beauty Reuniter (Head)",
  T_35_YS_F_H_GOLDCHAIN: "Armor of Riches (Head)",
  T_35_YS_F_H_PANTOMIME: "Two-toned Grief (Head)",
  T_35_YS_F_H_RIDERS: "Fatal Rider (Head)",
  T_35_YS_F_HA_GOLDCHAIN: "Armor of Riches (Facepaint)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "Beauty Reuniter (Shoes)",
  T_35_YS_F_S_GOLDCHAIN: "Armor of Riches (Shoes)",
  T_35_YS_F_S_PANTOMIME: "Two-toned Grief (Shoes)",
  T_35_YS_F_S_RIDERS: "Fatal Rider (Shoes)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "Beauty Reuniter (Top)",
  T_35_YS_F_T_GOLDCHAIN: "Armor of Riches (Top)",
  T_35_YS_F_T_PANTOMIME: "Two-toned Grief (Top)",
  T_35_YS_F_T_RIDERS: "Fatal Rider (Top)",
  T_35_YS_ITEM_SUPERFAK: "Super Med",
  T_35_YS_M_A_GOLDCHAIN: "Chainz of Lux (Mask)",
  T_35_YS_M_A_RIDERS: "Grim Rider (Mask)",
  T_35_YS_M_B_GOLDCHAIN: "Chainz of Lux (Bottom)",
  T_35_YS_M_B_RIDERS: "Grim Rider (Bottom)",
  T_35_YS_M_H_BEAR_HW: "Cub Cap",
  T_35_YS_M_H_GOLDCHAIN: "Chainz of Lux (Head)",
  T_35_YS_M_H_RIDERS: "Grim Rider (Head)",
  T_35_YS_M_S_GOLDCHAIN: "Chainz of Lux (Shoes)",
  T_35_YS_M_S_RIDERS: "Grim Rider (Shoes)",
  T_35_YS_M_T_GOLDCHAIN: "Chainz of Lux (Top)",
  T_35_YS_M_T_RIDERS: "Grim Rider (Top)",
  T_35_YS_T_CHAMPION: "Champion Tee",
  T_35_YS_T_PAINTING: "Squeeze Tee",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "Iris",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "Get coins when match begins",
  T_36_JH_WS_CESAYCLOSE: "Disable manual closing or not",
  T_36_JH_WS_CHOOSEEDITSHOP: "Select a store to edit",
  T_36_JH_WS_CHOOSESHOP: "Select a store",
  T_36_JH_WS_COINCOUNT: "Currency amount",
  T_36_JH_WS_COINHUD: "Display coin amount or not",
  T_36_JH_WS_CRAFTSHOP: "Edit store",
  T_36_JH_WS_CREATEGOLD: "Coin Generator",
  T_36_JH_WS_CSHOPENTITY: "Bind store entity",
  T_36_JH_WS_CSHOPHUD: "Store interface",
  T_36_JH_WS_CURRENTLIMIT: "Remaining purchase limit",
  T_36_JH_WS_ECONOMIC: "Economy",
  T_36_JH_WS_INGAMEECONOMI: "Game economy",
  T_36_JH_WS_ITEMINDEXID: "Merchandise number",
  T_36_JH_WS_KILLMONEY: "Get coins for eliminating",
  T_36_JH_WS_KILLMONEYTIP: "The amount of coins to earn for eliminating zombies in Rush mode and Endurance mode",
  T_36_JH_WS_LISTINDEX: "List of merchandise types",
  T_36_JH_WS_NULL: "Null",
  T_36_JH_WS_NUMBER: "Amount",
  T_36_JH_WS_OPTIONNAME: "Droid Apocalypse Mode Exclusive",
  T_36_JH_WS_REALSHOPENTITY: "Store entity",
  T_36_JH_WS_SEEORHIDE: "Display vending machine",
  T_36_JH_WS_SHOPFRONT: "Store",
  T_36_JH_WS_SHOPITEMLIST: "Merchandise type",
  T_36_JH_WS_SHOPOPENCON: "Open status",
  T_36_JH_WS_SSHOPNAME: "Store name",
  T_36_JH_WS_TOTALLIMIT: "Purchase limit",
  T_36_JH_WS_TRIGGERWIDE: "Trigger range",
  T_36_JH_WS_VENDMACHINE: "Vending Machine",
  T_36_JH_WS_WINMONEY: "Get coins for victory",
  T_36_JH_WS_WORTH: "Worth",
  T_36_JL_FOREGRIP_MR_N: "Marksman Grip",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "Shotgun Stock",
  T_36_JL_STOCK_SR_N: "Sniper Stock",
  T_36_KK_WS_MONTSTERDES: "A 4-seater truck with high durability and can travel through tough terrains",
  T_36_M_WS_SETTEMPVAR: "Set temporary variable",
  T_36_M_WS_TEMPVAR: "Temporary variable",
  T_36_SY_AK47_MAMBAS_N: "AK47 - Mamba Gnaw",
  T_36_SY_AN94_MAMBAS_N: "AN94 - Mamba Gnaw",
  T_36_SY_AR15_MAMBAS_N: "Kingfisher - Mamba Gnaw",
  T_36_SY_AUG_MAMBAS_N: "AUG - Mamba Gnaw",
  T_36_SY_AWM_MAMBAS_N: "AWM - Mamba Gnaw",
  T_36_SY_BLT_MAMBAS_N: "M82B - Mamba Gnaw",
  T_36_SY_CHARGESHOT_MAMBAS_N: "Charge Buster - Mamba Gnaw",
  T_36_SY_EAGLE_MAMBAS_N: "Desert Eagle - Mamba Gnaw",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS - Mamba Gnaw",
  T_36_SY_G18_MAMBAS_N: "G18 - Mamba Gnaw",
  T_36_SY_G36_MAMBAS_N: "G36 - Mamba Gnaw",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "Grenade - Navy Festivity",
  T_36_SY_GROZA_MAMBAS_N: "Groza - Mamba Gnaw",
  T_36_SY_HAND_CANNON_MAMBAS_N: "Hand Cannon - Mamba Gnaw",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "Heal Sniper - Mamba Gnaw",
  T_36_SY_ICE_GUN_MAMBAS_N: "Ice Gun - Mamba Gnaw",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k - Mamba Gnaw",
  T_36_SY_KORD_MAMBAS_N: "Kord - Mamba Gnaw",
  T_36_SY_M1014_MAMBAS_N: "M1014 - Mamba Gnaw",
  T_36_SY_M14_MAMBAS_N: "M14 - Mamba Gnaw",
  T_36_SY_M1873_MAMBAS_N: "M1873 - Mamba Gnaw",
  T_36_SY_M1887_MAMBAS_N: "M1887 - Mamba Gnaw",
  T_36_SY_M1917_MAMBAS_N: "M1917 - Mamba Gnaw",
  T_36_SY_M21A5_MAMBAS_N: "Woodpecker - Mamba Gnaw",
  T_36_SY_M24_MAMBAS_N: "M24 - Mamba Gnaw",
  T_36_SY_M249_MAMBAS_N: "M249 - Mamba Gnaw",
  T_36_SY_M4A1_MAMBAS_N: "M4A1 - Mamba Gnaw",
  T_36_SY_M500_MAMBAS_N: "M500 - Mamba Gnaw",
  T_36_SY_M60_MAMBAS_N: "M60 - Mamba Gnaw",
  T_36_SY_M79_MAMBAS_N: "M79 - Mamba Gnaw",
  T_36_SY_MAC10_MAMBAS_N: "MAC10 - Mamba Gnaw",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7 - Mamba Gnaw",
  T_36_SY_MINI_MAMBAS_N: "AC80 - Mamba Gnaw",
  T_36_SY_MP40_MAMBAS_N: "MP40 - Mamba Gnaw",
  T_36_SY_MP5_MAMBAS_N: "MP5 - Mamba Gnaw",
  T_36_SY_P90_MAMBAS_N: "P90 - Mamba Gnaw",
  T_36_SY_PARAFAL_MAMBAS_N: "PARAFAL - Mamba Gnaw",
  T_36_SY_PP19_MAMBAS_N: "Bizon - Mamba Gnaw",
  T_36_SY_PP19_POLICEMAN_N: "Bizon - Wraith Patrol",
  T_36_SY_SCAR_MAMBAS_N: "SCAR - Mamba Gnaw",
  T_36_SY_SKS_MAMBAS_N: "SKS - Mamba Gnaw",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12 - Mamba Gnaw",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "PLASMA - Mamba Gnaw",
  T_36_SY_SVD_MAMBAS_N: "SVD - Mamba Gnaw",
  T_36_SY_THOMPSON_MAMBAS_N: "Thompson - Mamba Gnaw",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "Dagger - Mamba",
  T_36_SY_THROWINGKNIFE_MENA_N: "Dagger - Boho",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "Heal Pistol - Mamba Gnaw",
  T_36_SY_UMP45_MAMBAS_N: "UMP - Mamba Gnaw",
  T_36_SY_USP45_MAMBAS_N: "USP - Mamba Gnaw",
  T_36_SY_UZI_MAMBAS_N: "Mini Uzi - Mamba Gnaw",
  T_36_SY_VECTOR_MAMBAS_N: "Vector - Mamba Gnaw",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "Monster Truck - Blinding Gold",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "Motorbike - Spectral Ride",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "Sports Car - Speed Acer",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "Tuk Tuk - Netherworld Ride",
  T_36_SY_VSS_MAMBAS_N: "VSS - Mamba Gnaw",
  T_36_SY_XM8_MAMBAS_N: "XM8 - Mamba Gnaw",
  T_36_WZY_AFTERACCUMULATOR: "Back accumulator",
  T_36_WZY_AVAILAB: "Enabled",
  T_36_WZY_BACKANDFORTH: "Round-trip",
  T_36_WZY_BASEMULTIPLIER: "Basic multiplier",
  T_36_WZY_BASIC: "Basic type",
  T_36_WZY_BEFORACCUMULATOR: "Front accumulator",
  T_36_WZY_CYLIC: "Circle-back",
  T_36_WZY_GUNPRO_PARAM1: "Basic damage",
  T_36_WZY_GUNPRO_PARAM10: "Bullet spread start",
  T_36_WZY_GUNPRO_PARAM11: "Max. spread area",
  T_36_WZY_GUNPRO_PARAM12: "Burst",
  T_36_WZY_GUNPRO_PARAM2: "Bullets in magazine",
  T_36_WZY_GUNPRO_PARAM3: "Initial magazine number",
  T_36_WZY_GUNPRO_PARAM4: "Firing interval",
  T_36_WZY_GUNPRO_PARAM7: "Distance for max. damage",
  T_36_WZY_GUNPRO_PARAM8: "Distance for min. damage",
  T_36_WZY_GUNPRO_PARAM9: "Minimum damage",
  T_36_WZY_MULTIPLIR: "Multiplier",
  T_36_WZY_PRICE: "Price",
  T_36_WZY_SUMMULTIPLIER: "Multiplier accumulator",
  T_36_WZY_WS_3DZOOM: "3D Zoom",
  T_36_WZY_WS_ABSRES: "Absolute value result",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "Add all the elements from the [Source list] to the bottom of the [Target list]",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "The target list to add the elements",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "The list that contains the elements to be added",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "Add a certain amount of designated currency into a designated wallet",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "Wallet",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "The wallet to add currency into",
  T_36_WZY_WS_ADDSUB: "Add or subtract values",
  T_36_WZY_WS_AIENTITY: "AI entity",
  T_36_WZY_WS_ALLSHOP_DESC: "A list that consists of store entities",
  T_36_WZY_WS_ANGLE_DESC: "The measurement of the angle",
  T_36_WZY_WS_ANYTYPE: "Any type",
  T_36_WZY_WS_ARILEFT: "Left value in the operation",
  T_36_WZY_WS_ARIRES: "Operation result",
  T_36_WZY_WS_ARIRIGHT: "Right value in the operation",
  T_36_WZY_WS_ARITHMETIC_NAME: "4 arithmetic operations",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "The basic integer operations support addition, subtraction, multiplication, division, and remainder. The float operations support addition, subtraction, multiplication, and division.",
  T_36_WZY_WS_ARRAY_DESC: "The target list",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "Check whether a list contains a designated element. The value returned is Boolean.",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "The designated list",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "The element to look for in the list",
  T_36_WZY_WS_ARRCONELERES: "The result of whether a designated element exists in a list. The value is Boolean.",
  T_36_WZY_WS_ATTACK: "Patrol and attack",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "Triggers when the player is knocked down",
  T_36_WZY_WS_BIGFLOAT: "Big decimal",
  T_36_WZY_WS_BIGTOYBALL: "Dice",
  T_36_WZY_WS_BOOLLIST: "Boolean list",
  T_36_WZY_WS_CEIL_NAME_DESC: "Round a value to the smallest integer larger than itself",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "The value to round up",
  T_36_WZY_WS_CEILRES: "Result of rounding up",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "The selected AI will chase this entity regardless of distance. [Chased entity] can be any entity. When the [Chased entity] does not have a HP property, then the AI entity will not inflict any damage.",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "The entity that is doing the chasing",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "The target entity that is being chased. It can be any entity.",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "The template for cloning objects. Select using the cursor. The property and script of the clone will be the same as those of the object chosen.",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "The object entity to be cloned",
  T_36_WZY_WS_CONDITION: "Condition",
  T_36_WZY_WS_CONDITIONLIST: "Condition list",
  T_36_WZY_WS_CONOFHUD: "The HUD entity that the control exists in",
  T_36_WZY_WS_CONTROL_DESC: "The only index of a control",
  T_36_WZY_WS_COS_NAMEDESC: "Find the cosine of an angle",
  T_36_WZY_WS_COSRES: "Cosine of the angle",
  T_36_WZY_WS_CREABLEOB: "Creatable object",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "Create an object entity at a designated location. (Test version)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "The coordinates of the object to be created",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "The type of the object to be created",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "The entity of the object to be created",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "Currency",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "Merchandise entity",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "Create a merchandise entity",
  T_36_WZY_WS_CREWALL_NAMEDESC: "Create a wallet entity. [Bind player] is the player who can see this wallet. [Owner] is the player to whom the wallet belongs. Invalid if a wallet already exists.",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "Bound player",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "The player to which the wallet is visible. If no settings are configured, the wallet will be visible to all.",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "The owner of the wallet",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "Wallet entity",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "The wallet entity created",
  T_36_WZY_WS_CURRAMT: "Currency amount",
  T_36_WZY_WS_DATA_TYPE1: "Added parameter",
  T_36_WZY_WS_DATA_TYPE2: "Basic and logic calculation",
  T_36_WZY_WS_DATA_TYPE3: "List manipulation",
  T_36_WZY_WS_DATA_TYPE4: "Vector calculation",
  T_36_WZY_WS_DESTITEM_NAME: "Destroy player item",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "Destroy a designated type of item for a designated player",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "Items that can be destroyed are weapons, vests, and helmets",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "The slot index of the type of item selected. Weapon index is [1,3] and Vest and Helmet is 1 by default.",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "Lose equipment upon elimination",
  T_36_WZY_WS_DESTOBJ: "Destroyable objects",
  T_36_WZY_WS_DIRPOINT: "Direction point",
  T_36_WZY_WS_DIRPOINTDESC: "The direction point to be created",
  T_36_WZY_WS_ELEFINDRES: "Index of an element's first position",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: 'Obtain the index of the first position of an element in a list. If the target element does not exist in the list, the result will return "-1".',
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "The element to look for in the list",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: 'Get the index of the last position of an element in a list. If the target element does not exist in the list, the result will return "-1".',
  T_36_WZY_WS_ELELINDRES: "Index of an element's last position",
  T_36_WZY_WS_ELEMENTSNUM: "# of elements in the list",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "Triggers when the [Triggering entity] collides with this trigger",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "The entity that this trigger collides with",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "Triggers when a [Triggering entity] drives the vehicle",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "The entity that is driving the vehicle",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "Triggers when the player enters the trigger",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "The trigger to enter",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "Triggers when a [Triggering entity] exits the vehicle",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "The entity that exits the vehicle",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "Triggers when a [Triggering entity] enters the vehicle",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "The entity that enters the vehicle",
  T_36_WZY_WS_ENTITY_TYPE1: "Commonly used",
  T_36_WZY_WS_ENTITY_TYPE2: "Properties",
  T_36_WZY_WS_ENTITY_TYPE3: "Objects and items",
  T_36_WZY_WS_ENTITY_TYPE4: "AI",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "The element value to be changed",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "Target player",
  T_36_WZY_WS_ENTITYLIST: "Entity list",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "Triggers when a [Triggering entity] bounces off the tire",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "The entity that bounces off the tire",
  T_36_WZY_WS_ENTTP_NAMEDESC: "Triggers when a [Triggering entity] enters the portal and is teleported",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "The entity that is teleported",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "The type of armor equipped, including vest, helmet, and backpack",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "Triggers when a player successfully equips a weapon. [Triggering player] is the player who successfully equips a weapon. [Weapon entity] is the weapon entity that the player equipped.",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "The weapon entity equipped",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "Weapon type",
  T_36_WZY_WS_EULERANGLE: "Euler angles",
  T_36_WZY_WS_FACECAMERA: "Always face camera",
  T_36_WZY_WS_FLOATLIST: "Float list",
  T_36_WZY_WS_FLOOR_NAME_DESC: "Round a value to the largest integer smaller than itself",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "The value to round down",
  T_36_WZY_WS_FLOORRES: "Result of rounding down",
  T_36_WZY_WS_FORMUENT: "Property formulate-able entity",
  T_36_WZY_WS_FORMUFACT: "Type of property formula factor",
  T_36_WZY_WS_GAME_TYPE2: "Gameplay",
  T_36_WZY_WS_GAME_TYPE3: "Special effects",
  T_36_WZY_WS_GENENT_NAMEDESC: "Triggers when a generator spawns units. [Unit entity list] is the list of units spawned by the generator. [# of waves] is the number of waves spawned by the generation.",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "Unit entity",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "A list that consists of unit entities spawned by a generator",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "The number of waves that a generator spawns",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "Obtain all the stores in the match. The value returned is a list that consists of store entities.",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "Use the RGB to obtain a color",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "Get the amount of a certain currency in a specific wallet",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "The wallet from which to get the currency amount",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "The currency type of the currency amount to be obtained",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "Get the entity type of a target entity",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "The entity whose type to get",
  T_36_WZY_WS_GETENTTYPERES: "Entity type of target entity",
  T_36_WZY_WS_GETFOR_NAME: "Get direction coordinates",
  T_36_WZY_WS_GETFOR_NAMEDESC: "Get the vector of a designated direction point",
  T_36_WZY_WS_GETFORRES: "Vector of direction point",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "Obtain the currency entity of a certain currency type in the wallet",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "The wallet in which the currency entity is",
  T_36_WZY_WS_GETPOS_NAME: "Get coordinates",
  T_36_WZY_WS_GETPOS_NAMEDESC: "Get the coordinates of a designated direction point",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "The designated direction point",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "Equipment type",
  T_36_WZY_WS_GETWALLET_NAME: "Obtain wallet",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "Obtain the wallet of the selected owner",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "Whether a bound wallet exists",
  T_36_WZY_WS_GETWALLETRES: "Owner's wallet entity",
  T_36_WZY_WS_HUDCONTROL_DESC: "The control entity of a HUD",
  T_36_WZY_WS_HUDTYPE: "HUD type",
  T_36_WZY_WS_INCIDENT_TYPE1: "Global incident",
  T_36_WZY_WS_INCIDENT_TYPE2: "Entity incident",
  T_36_WZY_WS_INDEX_DESC: "An index value of a list. Starts from 0.",
  T_36_WZY_WS_INTLIST: "Integer list",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "Check whether an entity type belongs to a certain sub-category. The result returned is Boolean.",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "The parent category to check whether the entity belongs in",
  T_36_WZY_WS_JENTSUBCLRES: "Result of parent category check",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "Check whether an entity belongs to a certain entity type. The result returned is Boolean.",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "The entity to check",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "Means that it is the same as the entity type",
  T_36_WZY_WS_JENTTYPERES: "Result of entity check",
  T_36_WZY_WS_JUSTPATROL: "Patrol only",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "Triggers when the player exits the trigger",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "The trigger to exit",
  T_36_WZY_WS_LEVELOBLIST: "Object list",
  T_36_WZY_WS_LEVOBJSLIST: "A list of all the map objects in this match",
  T_36_WZY_WS_LEVOBTYPE: "Object type",
  T_36_WZY_WS_LISTT: "Any list",
  T_36_WZY_WS_LOGCONTEXT_DESC: "The content to be printed",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "The left string to be connected",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "The right string to be connected",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "The element value to be added",
  T_36_WZY_WS_LOGOPER: "When conducting logic operations (and & or): if using the and operation and the two Boolean values are TRUE, the result is TRUE, and if using the or operation and one of the Boolean values is TRUE, the result is TRUE.",
  T_36_WZY_WS_LOOTPOINT: "Loot point",
  T_36_WZY_WS_MAINWEAP: "Current weapon",
  T_36_WZY_WS_MAX_DESC: "The upper range of the generated integer (open interval)",
  T_36_WZY_WS_MIN_DESC: "The lower range of the generated integer (closed interval)",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "Weapon entity",
  T_36_WZY_WS_MONENT: "Currency entity",
  T_36_WZY_WS_MONTYPE: "Currency type",
  T_36_WZY_WS_MOVETO_NAMEDESC: "Make the AI move towards a target point. Use [Return or not] to select whether the AI will return to its original position. Use [Attack or not] to select whether the AI will scan for enemies on its way.",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "The AI entity that will travel",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "The destination",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "Use to set whether the AI will return to original location after arriving to the destination. TRUE means return; FALSE means do not return.",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "Attack or not",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "Use to set whether the AI will attack nearby enemies along the way. TRUE means scan for enemies; FALSE means do not scan for enemies.",
  T_36_WZY_WS_MULVALUE: "Scalar",
  T_36_WZY_WS_MULVEC: "Scalar multiplication vector",
  T_36_WZY_WS_NEGRES: "Negative value result",
  T_36_WZY_WS_NEUTRAL: "Neutral",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "Forces the designated generator to spawn the next wave. Generators include Zombie Spawns and item spawns.",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "Generator entity",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "The designated generator entity, such as Zombie Spawns and item spawns",
  T_36_WZY_WS_OBJENT: "Object entity",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "Triggers when an item is obtained. [Item type] is the type of item that is obtained.",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "Triggers when a weapon is got. [Weapon entity] is the weapon obtained.",
  T_36_WZY_WS_ONEWAY: "One-way",
  T_36_WZY_WS_OPENSTATE: "Status",
  T_36_WZY_WS_OPERMETHOD_NAME: "Operation",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "The basic arithmetic operations. Currently, integer operations include addition, subtraction, multiplication, division, and remainder, and the float operations include addition, subtraction, multiplication, and division. ",
  T_36_WZY_WS_OWNERENT_DESC: "The entity whose wallet to obtain",
  T_36_WZY_WS_PERCENTAGE: "Percentage adjustment",
  T_36_WZY_WS_PLACOLLIDE_NAME: "When player collides with trigger",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "Triggers when the [Triggering player] collides with the trigger",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "The player that collides with the trigger",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "The object entity that the player collides with",
  T_36_WZY_WS_PLADRIVEH_NAME: "When player drives vehicle",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "Triggers when the [Triggering player] drives a vehicle",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "The player that is driving the vehicle",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "The vehicle entity that the player is driving",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "When player exits vehicle",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "Triggers when the [Triggering player] exits a vehicle",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "The player that is exiting the vehicle",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "The vehicle entity that the player is exiting",
  T_36_WZY_WS_PLAGETONVEH_NAME: "When player enters vehicle",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "Triggers when the [Triggering player] enters a vehicle",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "The vehicle entity that the player is entering",
  T_36_WZY_WS_PLAKNOFLY_NAME: "When player bounces off tire",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "Triggers when the [Triggering player] bounces off a tire",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "The player that bounces off a tire",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "The object entity on which the player bounces off",
  T_36_WZY_WS_PLATP_NAME: "After player is teleported",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "The player that uses a portal",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "The portal entity that the player used",
  T_36_WZY_WS_PLAYERLIST_DESC: "A list of all the players in this match",
  T_36_WZY_WS_POINTPICKER: "Path pivot",
  T_36_WZY_WS_PORTALENT: "Portal entity",
  T_36_WZY_WS_PREFAB: "Template",
  T_36_WZY_WS_PRODLIST: "Merchandise list",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "Sort order",
  T_36_WZY_WS_PROPMOD: "Method of property change",
  T_36_WZY_WS_RANKABLEE: "Rank-able entity",
  T_36_WZY_WS_REDCURR_NAMEDESC: "Consume a certain amount of designated currency in a designated wallet",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "The wallet that spends the currency",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "The type of currency consumed",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "The amount of currency consumed",
  T_36_WZY_WS_RNDFRES: "Generated random float",
  T_36_WZY_WS_RNDIRES: "Result of random integer generation",
  T_36_WZY_WS_ROUND_NAME_DESC: "Round a value to the nearest integer",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "The value to round",
  T_36_WZY_WS_ROUNDRES: "Result of rounding",
  T_36_WZY_WS_RUNAI_NAMEDESC: "The behavior tree that the selected AI will execute",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "The unit entity that stops/runs a default behavior tree",
  T_36_WZY_WS_SCOREABLEE: "Score-able entity",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "Triggers when score changes. [Score type] is the type of score that changed. [Score] is the new score.",
  T_36_WZY_WS_SETDIRPOINT_NAME: "Create a direction point",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "Get a newly created direction point. Use [Location] to set the point's coordinates and [Direction] to set the vector of the direction.",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "The coordinates of the direction point",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "Direction",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "The vector of the direction point",
  T_36_WZY_WS_SETPATH_NAMEDESC: "AI entities will travel according to the order set here. Available travel types are circle-back, one-way, and round-trip. You can also select whether the AI will scan for enemies on its way.",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "A list that consists of the points to which the AI should travel",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "Travel type",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "These are the travel types. One-way is for the AI to stop traveling once it arrives at the destination. Circle-back is for the AI to search for a way back once it arrives at the destination. Round-trip is for the AI the return to original location according to the backwards order of the path list.",
  T_36_WZY_WS_SHOPECON: "Store and economy",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "Use to display notifications that float on the screen. Configure the content using [Text], the text color using [Color], and the display duration using [Duration] (the unit is milleseconds).",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "The content of the floating notification",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "The color of the floating notification",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "The display duration of the floating notification, in milleseconds",
  T_36_WZY_WS_SIN_NAMEDESC: "Find the sine of an angle",
  T_36_WZY_WS_SINRES: "Sine of the angle",
  T_36_WZY_WS_SKIPKNODOWN: "Whether eliminate upon knockdown",
  T_36_WZY_WS_SQRTRES: "Square root result",
  T_36_WZY_WS_STRCONRES: "Result of string connection",
  T_36_WZY_WS_STRINGLIST: "String list",
  T_36_WZY_WS_STRLEN: "String length",
  T_36_WZY_WS_STRVAL: "String result",
  T_36_WZY_WS_TAN_NAMEDESC: "Find the tangent of an angle",
  T_36_WZY_WS_TANRES: "Tangent of the angle",
  T_36_WZY_WS_TEAMLIST: "Team list",
  T_36_WZY_WS_TEAMLIST_DESC: "A list of all the teams in this match",
  T_36_WZY_WS_TIMETWEENTIPS: "Countdown notification entity",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "Convert the target value into a string",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "The target value to convert into a string",
  T_36_WZY_WS_TOSTRINGRES: "Result of string conversion",
  T_36_WZY_WS_TOWERCAMP_DESC: "The side number and team number are the same. Neutral towers and fortresses attack all players and AIs within range.",
  T_36_WZY_WS_TRACURR_NAMEDESC: "Tranfer a certain amount of designated currency from one wallet to another",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "The wallet to transfer the currency out of",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "The type of currency in the transaction",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "The amount of currency in the transaction",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "The wallet to transfer the currency into",
  T_36_WZY_WS_TWEENTIPS: "Floating notification entity",
  T_36_WZY_WS_TYPEENUM: "Enum type",
  T_36_WZY_WS_USEPROP_NAMEDESC: "Triggers when a player uses an item. [Triggeri player] is the player who uses an item. [Item type] is the item that the player used.",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "The type of item used by the player",
  T_36_WZY_WS_VECADDLEFT: "Left value of vector addition",
  T_36_WZY_WS_VECADDRES: "Vector addition result",
  T_36_WZY_WS_VECADDRIGHT: "Right value of vector addition",
  T_36_WZY_WS_VECANGLEFT: "Left value of vectors angle",
  T_36_WZY_WS_VECANGRES: "Angle between 2 vectors",
  T_36_WZY_WS_VECANGRIGHT: "Right value of vectors angle",
  T_36_WZY_WS_VECCROLEFT: "Left value of cross product",
  T_36_WZY_WS_VECCRORES: "Result of cross product",
  T_36_WZY_WS_VECCRORIGHT: "Right value of cross product",
  T_36_WZY_WS_VECDISLEFT: "Left value of vectors distance",
  T_36_WZY_WS_VECDISRES: "Distance between 2 vectors",
  T_36_WZY_WS_VECDISRIGHT: "Right value of vectors distance",
  T_36_WZY_WS_VECDOCLEFT: "Left value of dot product",
  T_36_WZY_WS_VECDOCRES: "Result of dot product",
  T_36_WZY_WS_VECDOCRIGHT: "Right value of dot product",
  T_36_WZY_WS_VECMULRES: "Result of scalar multiplication",
  T_36_WZY_WS_VECNORRES: "Normalized vector",
  T_36_WZY_WS_VECSIZERES: "Magnitude of a vector",
  T_36_WZY_WS_VECSUBLEFT: "Left value of vector subtraction",
  T_36_WZY_WS_VECSUBRES: "Vector subtraction result",
  T_36_WZY_WS_VECSUBRIGHT: "Right value of vector subtraction",
  T_36_WZY_WS_VECTORLIST: "Vector list",
  T_36_WZY_WS_VECX: "x component",
  T_36_WZY_WS_VECY: "y component",
  T_36_WZY_WS_VECZ: "z component",
  T_36_WZY_WS_VEHENT: "Vehicle entity",
  T_36_WZY_WS_WALLCONT: "Wallet content",
  T_36_WZY_WS_ZOMBIESPERWAVE: "Continuous",
  T_36_XYL_WS_AIBOT: "Unit",
  T_36_XYL_WS_AIGENERATOR: "Unit Generator",
  T_36_XYL_WS_AIGENERATOR_DESC: "A generator that can continuously generate designated units (e.g. zombies)",
  T_36_XYL_WS_AIWAVE: "# of units per wave",
  T_36_XYL_WS_ARROW: "Direction Sign",
  T_36_XYL_WS_ARROW_DESC: "A sign that points to a direction",
  T_36_XYL_WS_BREAKBOX: "Breakable Box",
  T_36_XYL_WS_BREAKBOX_DESC: "A wooden box that can be broken when attacked",
  T_36_XYL_WS_FENCE: "Iron Fence",
  T_36_XYL_WS_FENCE_DESC: "A fence that enables bullets to fly through",
  T_36_XYL_WS_STAIRI: "Landing C",
  T_36_XYL_WS_STAIRI_DESC: "A platform that can be combined with stairs",
  T_36_XYL_WS_ZOMBIEAI: "Zombie",
  T_36_XYL_WS_ZOMBIEAI_DESC: "A zombie that can be customized and be an obtained and duplicated subject in the Unit Generator",
  T_36_YF_CORRODE_GRENADE_N: "Gloo Melter",
  T_36_YF_SETTING_TYPE3: "Preset 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "CBF Ocean Jersey (Bottom)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "CBF Sunshine Jersey (Bottom)",
  T_36_YS_F_A_GHOSTHUNTER: "Fiendish Foxtail (Mask)",
  T_36_YS_F_B_GHOSTHUNTER: "Fiendish Foxtail (Bottom)",
  T_36_YS_F_H_GHOSTHUNTER: "Fiendish Foxtail (Head)",
  T_36_YS_F_S_GHOSTHUNTER: "Fiendish Foxtail (Shoes)",
  T_36_YS_SETTING_GRENADE: "Throwables",
  T_36_YS_SETTING_MOVE: "Movement",
  T_36_YS_T_BRFOOTBALL_BLUE01: "CBF Ocean Jersey (Top)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "CBF Sunshine Jersey (Top)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "Luna",
  T_36_YZY_CHARACTER_YAKUZA_N: "Tatsuya",
  T_36_YZY_PET_WOLF_N: "Fang",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "Pet skin: Purple Zasil",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "Pet skin: Lightning Falco",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "Pet skin: Lava Fang",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "Pet skin: Spectral Guide",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "Pet Skin: Arctic Fang",
  T_37_B_WS_HIDE: "Hide N Seek",
  T_37_HZ_WS_CATMODEDESC1: "Hide N Seek",
  T_37_JH_WS_CREATEGOLD_DESC: "A Vending Machine from which players can buy items. (Not valid in Clash Squad, Team Deathmatch, Playground, and Droid Apocalypse modes)",
  T_37_JH_WS_NAME1: "FF Knife (Droid Apocalypse)",
  T_37_JH_WS_NAME10: "M1887-X (Droid Apocalypse)",
  T_37_JH_WS_NAME11: "SPAS12 (Droid Apocalypse)",
  T_37_JH_WS_NAME12: "M1014 (Droid Apocalypse)",
  T_37_JH_WS_NAME13: "MP40 (Droid Apocalypse)",
  T_37_JH_WS_NAME14: "MP5-III (Droid Apocalypse)",
  T_37_JH_WS_NAME15: "P90 (Droid Apocalypse)",
  T_37_JH_WS_NAME16: "M60-III (Droid Apocalypse)",
  T_37_JH_WS_NAME17: "Thompson (Droid Apocalypse)",
  T_37_JH_WS_NAME18: "UMP (Droid Apocalypse)",
  T_37_JH_WS_NAME19: "SVD (Droid Apocalypse)",
  T_37_JH_WS_NAME2: "Groza (Droid Apocalypse)",
  T_37_JH_WS_NAME20: "AWM (Droid Apocalypse)",
  T_37_JH_WS_NAME21: "M82B (Droid Apocalypse)",
  T_37_JH_WS_NAME22: "M249-X (Droid Apocalypse)",
  T_37_JH_WS_NAME23: "Kar98k-III (Droid Apocalypse)",
  T_37_JH_WS_NAME3: "AK47 (Droid Apocalypse)",
  T_37_JH_WS_NAME4: "M4A1-III (Droid Apocalypse)",
  T_37_JH_WS_NAME5: "SCAR (Droid Apocalypse)",
  T_37_JH_WS_NAME6: "M14-III (Droid Apocalypse)",
  T_37_JH_WS_NAME7: "PARAFAL (Droid Apocalypse)",
  T_37_JH_WS_NAME8: "XM8 (Droid Apocalypse)",
  T_37_JH_WS_NAME9: "MAG-7 (Droid Apocalypse)",
  T_37_JH_WS_VENDMACHINE_DESC: "Gold that can be picked up around the map. (Not valid in Clash Squad, Team Deathmatch, Playground, and Droid Apocalypse modes)",
  T_37_JH_WS_X: "X Axis",
  T_37_JH_WS_Y: "Y Axis",
  T_37_JH_WS_Z: "Z Axis",
  T_37_JL_FOOTBALL_TIE: "Tie",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "Trogon",
  T_37_KK_WS_SNOWMAN: "Waggor Snowman",
  T_37_LC_BP_ENTRANCE_GIFT: "Gift!",
  T_37_M_WS_MISSING: "Missing source",
  T_37_M_WS_NAMEERROR: "Contains sensitive characters. Please change.",
  T_37_PD_HuntingGround_BOSSTITLE: "The Butcher",
  T_37_QL_JUMPPAD_DES: "Creates a jump pad on the ground. It can be used to jump high in the air and enables air firing.",
  T_37_QL_JUMPPAD_NAME: "Trampoline",
  T_37_R_TAILOR_LIMIT: "Limited Time",
  T_37_RW_LOADOUT_BORNFIRETAG: "Get 2 Bonfires at the start of the match. Bonfire [FFBA00]regenerates 5 HP and 20 EP per second[-] (up to 10 seconds) for you and your teammates within the area. Bonfire effects do not stack.",
  T_37_RW_PROPCATAPULT_DESC: "When inflated, the launch pad can be used to project a player into the air. But make sure to stay in the Safe Zone!",
  T_37_RW_PROPCATAPULT_NAME: "Launch Pad",
  T_37_SP_WS_COLOR_02: "Color",
  T_37_SP_WS_COLOR_03: "Appearance",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "The entity is null when getting or setting its property",
  T_37_SP_WS_LOG_PHASE_END: "Phase {0} ended.",
  T_37_SP_WS_LOG_PHASE_START: "Phase {0} begins",
  T_37_SP_WS_LOG_ROUND_END: "Round {0} ended.",
  T_37_SP_WS_LOG_ROUND_START: "Round {0} started.",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "Mismatched type when assigning a value to the variable. Required type: {0}. Current type: {1}.",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "Undefined or out-of-scope local variable {0}",
  T_37_SP_WS_MAPACCESS_08: "Edit",
  T_37_SP_WS_RACEMODE_01: "Countdown Mode",
  T_37_SP_WS_RACEMODE_02: "Countdown Time",
  T_37_SP_WS_RACEMODE_04: "When on, there will be a countdown when an entire team reaches the finishing point. The game ends when the countdown ends.",
  T_37_SY_AR15_KABUKI_N: "Kingfisher - Song of Hana",
  T_37_SY_BACKPACK_STRAW_N: "Backpack - Straw Hat",
  T_37_SY_GRENADE_FFWS2022_01_N: "Grenade - Navy Starsea",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "Black Hole",
  T_37_SY_M1216_MAMBAS_N: "Trogon - Mamba Gnaw",
  T_37_SY_PET_FLYINGCREATURE_N: "Arvon",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "Pet Skin: Glamstar Beanie",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "Pet Skin: Ash Arvon",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "Pet skin: Galaxy Arvon",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "Pet skin: Firemyth Arvon",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "Pet Skin: Footie Flash",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "Pet Skin: Winterlands Yeti",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "Jeep - Rockin' Festival Ride",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "Pickup Truck - Starsea Beast",
  T_37_WT_WS_PVE2DESC: `A zombie survival mode where players eliminate a certain number of zombies within time limit or survive till the end.
You can set the gameplay rules and adjust the settings of zombies as you like, including the target number of zombies to be eliminated.`,
  T_37_WT_WS_RULEDESC: "Eliminate the target number of zombies to win.",
  T_37_WT_WS_RULETITLE: "Goal",
  T_37_WT_WS_TXT1: "Eliminate zombies",
  T_37_WT_WS_TXT1DESC: "When on, players win by eliminating the specified number of zombies. When off, players win by surviving till the end.",
  T_37_WT_WS_TXT2: "Elimination amount",
  T_37_WZY_FRIDPLA: "Friendly player",
  T_37_WZY_FRIDSIDE: "Friendly faction",
  T_37_WZY_FRIDTEAM: "Friendly team",
  T_37_WZY_HOSTPLA: "Enemy player",
  T_37_WZY_HOSTSIDE: "Enemy faction",
  T_37_WZY_WS_ACCFRAMES: "Accumulated frames",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "Add items to a merchandise. You can add a single item or a group of items. The amount can be either the number of the individual items or a list that consists of items of this amount.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "The merchandise entity to add items to",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "The items to add. You can add a single item or a group of items.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "The amount of the individual items to add or a list that consists of items of this amount.",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "Add a tag for the selected entity",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "The entity to add the tag to",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "The text content to add",
  T_37_WZY_WS_AIMABLEENT: "Aim-able entity",
  T_37_WZY_WS_AIMASSISTTYPE: "Aim assist type",
  T_37_WZY_WS_ALLOWDROP_NAME: "Enable/disable item drop",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "Whether a player can drop items",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "The player entity to configure whether to drop items",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "Whether a player can drop items. This is Boolean value.",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "Enable/disable item pick up",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "Whether a player can pick up items",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "The player entity to configure whether to pick up items",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "Whether a player can pick up items. This is Boolean value.",
  T_37_WZY_WS_AMBIENTCOLOR: "Ambience light color",
  T_37_WZY_WS_AMRORTOOL: "Repair armor",
  T_37_WZY_WS_ATTACK: "Attack",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "Cancel the player's disguise so that they will return to their normal appearance",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "The player entity whose disguise to cancel",
  T_37_WZY_WS_BALLADDV_NAMEDES: "Boost the speed of a football",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "The football to boost speed for",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "The speed vector of the boost",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "Triggers when the football is hit by the Football Shooter. [Player entity] is the player who owns the Football Shooter. [Speed boost] is the added speed of the football after being hit.",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "The player who owns the Football Shooter",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "The speed vector of the football after it has been hit",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "Triggers when the football collides with an entity and the ball's speed increases. [Colliding entity] is the entity that collides with the football. [Speed boost] is the added speed of the football after the collision.",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "The entity that collides with the football",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "The speed vector that is added to the football upon collision",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "Triggers when the entity is being aimed at by a player",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "The player who is aiming at the entity",
  T_37_WZY_WS_BEHAVIORSTAT: "Player behavior status",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "The weapon entity that hits this entity",
  T_37_WZY_WS_BLOODBARENT: "Health bar entity",
  T_37_WZY_WS_BOMBEND: "Prior to explosion",
  T_37_WZY_WS_BOMBSTART: "Bomb indication",
  T_37_WZY_WS_CHANENT: "Channel entity",
  T_37_WZY_WS_CHEER: "Cheer",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "Check whether a selected entity contains designated tags",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "The entity to check whether it contains tags",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "The tag to check",
  T_37_WZY_WS_CHELABELRES: "The result of the tag check. This is a Boolean value.",
  T_37_WZY_WS_CJERSEY_NAME: "Change jersey",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "The player whose jersey to change",
  T_37_WZY_WS_CJERSEY_PARAM2: "Jersey design",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "The design to change to",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "The color of part 1 on the jersey",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "The color of part 2 on the jersey",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "The color of part 3 on the jersey",
  T_37_WZY_WS_CJERSEYTYPE1: "Design 1",
  T_37_WZY_WS_CJERSEYTYPE2: "Design 2",
  T_37_WZY_WS_CJERSEYTYPE3: "Design 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "Clear all the elements in the list",
  T_37_WZY_WS_CREABLEOB_DESC: "The object type that can be created using blocks",
  T_37_WZY_WS_CREPROD_NAMEDESC: "Create a customizable merchandise and return a merchandise entity. The merchanise content can be configured through property settings.",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "Create a customizable merchandise list and return a merchandise list entity. The content of this list can be changed through property settings.",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "The merchandise list entity to be created",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "Create a faction entity",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "The faction entity to be created",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "Create a customizable store and return a store entity. The content of the store can be changed through property settings.",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "The store entity created",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "Change the environment of the sky in the game. Options include day, dusk, and night.",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "The type of sky to change to. Options include day, dusk, and night.",
  T_37_WZY_WS_DARKNESS: "Overall darkness",
  T_37_WZY_WS_DELENT_NAMEDESC: "Delete a designated entity. Currently supports icon entity, text entity, HUD entity, visual effects entity, weapon entity, and other object entities.",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "The entity to delete",
  T_37_WZY_WS_DROP: "Mistake",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "Triggers when the player drops an item. [Item type] is the ID of the item type dropped.",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "The type ID of the dropped item",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "Triggers when the player drops a weapon. [Weapon entity] is the weapon being dropped.",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "The weapon that is dropped",
  T_37_WZY_WS_DUMMYLEOBJ: "Regular level object",
  T_37_WZY_WS_DUST: "Dusk",
  T_37_WZY_WS_EMPTYCH: "Default empty channel",
  T_37_WZY_WS_EMPTYCH1: "Empty channel 1",
  T_37_WZY_WS_EMPTYCH2: "Empty channel 2",
  T_37_WZY_WS_EMPTYCH3: "Empty channel 3",
  T_37_WZY_WS_EMPTYCH4: "Empty channel 4",
  T_37_WZY_WS_EMPTYCH5: "Empty channel 5",
  T_37_WZY_WS_EMPTYCH6: "Empty channel 6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: 'Obtain a list that contains all entities that satisfy the 3 conditions. The content inserted for "Includes all", "Excludes", and "Includes" is a single component type or a list of component types. The result returned is a list of entities that satisfy the conditions.',
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "The entities filtered out must contain all the components from this array",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "The entities filtered out must not contain designated component(s) from this array",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "The entities filtered out must contain at least one component from this array",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "The property type of this entity to change",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "The property value to change to",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "Let the player leave the current channel so that they will not be in any channel",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "The player to leave the channel",
  T_37_WZY_WS_FAKEENT: "Disguise entity",
  T_37_WZY_WS_FIND_STR_DESC: "Find the location of a designated text within a string",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "The character to find",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "Find a string from the starting location, which begins from 0.",
  T_37_WZY_WS_FINDSTRRES: "The first location that the string appears. Starts from 0.",
  T_37_WZY_WS_FOGCOLOR: "Fog color",
  T_37_WZY_WS_FRICTIONCON: "Regular friction multiplier",
  T_37_WZY_WS_FRICTIONIMP: "Collision friction multiplier",
  T_37_WZY_WS_FROMDEATH: "Revival",
  T_37_WZY_WS_FROMKNODOWN: "Help up",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "Get the channel that the designated player is in",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "The player entity whose channel to get",
  T_37_WZY_WS_GETCHANRES: "The channel that the player is currently in",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "According channel ID 1 to 8, get the empty channel that was created by default at the start of the game",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "ID of the default empty channel",
  T_37_WZY_WS_GETEMPTYCH_RES: "The obtained channel entity",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "Obtain the disguise entity of a player",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "The object whose disguise entity to obtain",
  T_37_WZY_WS_GETGAMEENT_NAME: "Get global",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "Get the game entity of this match",
  T_37_WZY_WS_GETHOSTPLA_NAME: "Get attackable player",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "Faction entity",
  T_37_WZY_WS_GOAL_NAMEDESC: "Triggers when a football enters the goal. [Goal] is the goal that this football enters. [Scorer] is the last player to have come in contact with the ball. [Assist] is the second-to-last player to have come in contact with the ball.",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "The goal that this football enters",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "The last player to have come in contact with the ball",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "The second-to-last player to have come in contact with the ball",
  T_37_WZY_WS_HEARTBEAT: "Heartbeat",
  T_37_WZY_WS_HEAVYWEAPON: "Heavy weapon",
  T_37_WZY_WS_HIHGSHOOTANGLE: "Smallest volley angle",
  T_37_WZY_WS_HOSTPLA: "A list of attackable players",
  T_37_WZY_WS_HOSTSIDE: "A list of attackable factions",
  T_37_WZY_WS_HOSTTEAM: "A list of attackable teams",
  T_37_WZY_WS_ICON_CLOCK: "Countdown",
  T_37_WZY_WS_ICON_CLOTHES: "Clothes",
  T_37_WZY_WS_ICON_QUIT: "Exit",
  T_37_WZY_WS_INSERT_ARR_DESC: "Insert a new element to a designated location in the list",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "Extract a string of a designated length, starting from the index location. If extraction length exceeds string length, it will extract content until the end of the string.",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "Length of the extraction",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "The string that was extracted",
  T_37_WZY_WS_INTORINTL: "Integer or integer list",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "Let a player join a designated faction",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "The faction for the player to join",
  T_37_WZY_WS_JUMP: "Jump",
  T_37_WZY_WS_LABEL: "Tag",
  T_37_WZY_WS_LENSFLARE: "Lens flare",
  T_37_WZY_WS_LENTH: "Length",
  T_37_WZY_WS_LIGHTATTACK: "Successful hit",
  T_37_WZY_WS_LIGHTCOLOR: "Light source color",
  T_37_WZY_WS_LIGHTINTENSITY: "Light source brightness",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "Load a new scenery",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "The name of the scenery to load",
  T_37_WZY_WS_MOROBJECT: "Disguise object",
  T_37_WZY_WS_MOVEAXISX: "Move along x axis",
  T_37_WZY_WS_MOVEAXISY: "Move along y axis",
  T_37_WZY_WS_MOVEAXISZ: "Move along z axis",
  T_37_WZY_WS_MOVEDISTITLE: "Distance of movement",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "Quick messages on-off toggle",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "Turn quick messages on or off. When off, the quick message HUD cannot be used and players will not be able to send or receive quick messages.",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "The player to turn on/off quick messages for",
  T_37_WZY_WS_MUTEVOICE_NAME: "Voice chat on-off toggle",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "Turn voice chat on or off. When off, the voice HUD cannot be used and players will not be able to send or receive voice messages.",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "The player to turn on/off voice chat for",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "Boolean. True means off; False means on.",
  T_37_WZY_WS_NIGHTMODE: "Night mode",
  T_37_WZY_WS_ONAIM_NAMEDESC: "Triggers when the player is aiming at an aim-able entity. [Target entity] is the entity being aimed. When there is no entity being aimed, the return value is null.",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "Aimed entity",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "The entity that the weapon has hit",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "Triggers when the scenery successfully loads",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "The name of the scenery to load. This is a string.",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "Triggers when the scenery successfully switches",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "The name of the new scenery. This is a string.",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "Restore the player's clothing to its default look",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "The player whose default clothing to restore",
  T_37_WZY_WS_PETSET: "Pet settings",
  T_37_WZY_WS_PETSKILL: "Pet skills",
  T_37_WZY_WS_PETSWITCH2: "Whether pet skills can be used",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "Whether to enable player movement. This is a Boolean value.",
  T_37_WZY_WS_PLAYERBEHAVIOR: "Player behavior type",
  T_37_WZY_WS_PRESS: "Gentle click",
  T_37_WZY_WS_PROGRESS: "Current progress",
  T_37_WZY_WS_PROGRESSBAR: "Progress HUD entity",
  T_37_WZY_WS_RANKDOWN: "Rank down",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "Remove a tag for the selected entity",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "The text content to remove",
  T_37_WZY_WS_REPLACE_STR_DESC: "Replace the content of a string with a designated content",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "The character to be replaced",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "The new character to replace with",
  T_37_WZY_WS_REVERSE_ARR_DESC: "Reverse all the elements in this list",
  T_37_WZY_WS_REVIVEHERE: "The player who is reviving teammates at this revival point",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "Triggers when a player is reviving teammates at this revival point",
  T_37_WZY_WS_REVIVEWAYDESC: "The method by which a player is revived or helped up from being eliminated or knocked down",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "Configure the status of different behaviors for players. When disabled, the corresponding buttons on the HUD cannot be used, and manual and automatic movements are not allowed. When hidden, the corresponding buttons will not be displayed on the HUD, and manual movements are not allowed while automatic movements are allowed. When enabled, the corresponding buttons will be displayed on the HUD, and manual and automatic movements are allowed.",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "The player to set behavior status for",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "The player's behavior, including moving, attacking, jumping, and sprinting",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "Status includes disabled, hidden, and enabled. When hidden, the corresponding buttons will not be displayed on the HUD, and manual movements are not allowed while automatic movements are allowed. When enabled, the corresponding buttons will be displayed on the HUD, and manual and automatic movements are allowed.",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "The coordinates of the football",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "Whether the football should maintain its pre-configuration speed. This is a Boolean value.",
  T_37_WZY_WS_SETPLAHOST_NAME: "Player attack setting",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "Configure whether [Setting player] can attack [Target player]. The default setting is based on whether the target player belongs to a team and faction that can be attacked. This setting is of a higher priority than the team/faction setting.",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "The player to configure enemies for",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "The player who is the enemy",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "Attackable or not",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: '"Yes" means attackable; "No" means not attackable. The default setting is based on whether the target player belongs to a team and faction that can be attacked.',
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: '"Yes" means attackable; "No" means not attackable',
  T_37_WZY_WS_SHADOWSTRENGTH: "Shadows",
  T_37_WZY_WS_SHOOTANGLE: "Smallest shooting angle",
  T_37_WZY_WS_SKYBOX: "Sky",
  T_37_WZY_WS_SKYBOXENT: "Sky entity",
  T_37_WZY_WS_SKYBOXTYPE: "Basic sky types",
  T_37_WZY_WS_STEPPED: "Step on trigger",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "Switch the voice chat channel of the player",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "The player to switch channels for",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "The channel to switch to",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "Switch to a designated scenery",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "The name of the scenery to switch to",
  T_37_WZY_WS_TARGETSTR_DESC: "Target string",
  T_37_WZY_WS_TEAMASIDE: "Team and Faction",
  T_37_WZY_WS_TELEPORTN_AUTO: "Automatic",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "Teleportable or not",
  T_37_WZY_WS_TELEPORTN_MANUAL: "Manual",
  T_37_WZY_WS_TELEPORTN_NO: "No",
  T_37_WZY_WS_TELEPORTN_TITLE: "Teleport method",
  T_37_WZY_WS_TELEPORTN_YES: "Yes",
  T_37_WZY_WS_TERRAINWET: "Terrain moisture",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "Substitute the appearance of a [Player entity] with the appearance of a [Scenery object]",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "The player entity whose appearance to change",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "The player whose disguise entity to obtain",
  T_37_WZY_WS_TRANSP: "Transparency",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "Uninstall a designated scenery",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "The name of the scenery to uninstall",
  T_37_WZY_WS_VFX1: "Symbolic",
  T_37_WZY_WS_VFX2: "Smokey",
  T_37_WZY_WS_VFX3: "Curse Explosion",
  T_37_WZY_WS_VFX5: "Frozen",
  T_37_WZY_WS_VFX6: "Spotlight",
  T_37_WZY_WS_VFX7: "Upward Turbulence",
  T_37_WZY_WS_VFX8: "Atmosphere Explosion",
  T_37_WZY_WS_VISABLE: "Visibility",
  T_37_WZY_WS_WEAOPEN: "Show or not",
  T_37_WZY_WS_WEAPONENT: "Weapon entity",
  T_37_WZY_WS_WEATARGETED: "Whether can be targetted by aim assist",
  T_37_XYL_CUSTOMJERSEY: "Jersey Machine",
  T_37_XYL_CUSTOMJERSEY_DESC: "Use the Jersey Machine to create your ideal jersey",
  T_37_XYL_FOOTGUN: "Football Shooter",
  T_37_XYL_SOCCER: "Football",
  "T_37_XYL_SOCCER_ RADIUS": "Radius",
  T_37_XYL_SOCCER_DESC: "A football whose properties can be customized",
  T_37_XYL_SOCCER_HIGHT1: "Regular angle",
  T_37_XYL_SOCCER_HIGHT2: "Volley angle",
  T_37_XYL_SOCCER_RESET: "Reset time after a goal (s)",
  T_37_XYL_SOCCER_RESIST1: "Friction (Kick Mode)",
  T_37_XYL_SOCCER_RESIST2: "Friction (Gun Mode)",
  T_37_XYL_SOCCERGOAL: "Goal",
  T_37_XYL_SOCCERGOAL_DESC: "This is the goal. Shoot the football into the goal to score. (Only valid in Points Grab.)",
  T_37_XYL_SOCCERITEM: "Item Spawn",
  T_37_XYL_SOCCERITEM_DESC: "When placed, it will generate the selected item",
  T_37_XYL_SPAWN_PEOPLE: "# of players",
  T_37_XYL_WS_AIRCONDITIONER001: "Air Conditioner B",
  T_37_XYL_WS_AMMUCHEST: "War Chest A",
  T_37_XYL_WS_BAFFLE001: "Barrier A",
  T_37_XYL_WS_BARREL001: "Barrels",
  T_37_XYL_WS_BARREL001_DES: "Commonly seen circular wooden barrels",
  T_37_XYL_WS_BOARD001: "Ad Board B",
  T_37_XYL_WS_BOOK001: "Pile of Books A",
  T_37_XYL_WS_BOOK002: "Board Game A",
  T_37_XYL_WS_BOUGAINVILLEA: "Bougainvillea",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "Decor - brightens up the place!",
  T_37_XYL_WS_BOX001: "Pile of Boxes A",
  T_37_XYL_WS_BOX002: "Small Box",
  T_37_XYL_WS_BUSHCOVER: "Bush",
  T_37_XYL_WS_BUSHCOVER_DES: "A bush that can be used to hide in",
  T_37_XYL_WS_CABINET001: "Drawers A",
  T_37_XYL_WS_CHAIR001: "Chair A",
  T_37_XYL_WS_COCONUTTREE: "Coconut Tree",
  T_37_XYL_WS_COCONUTTREE_DES: "Decor - For a beachy vibe!",
  T_37_XYL_WS_COMPUTER001: "Computer A",
  T_37_XYL_WS_DAMAGERATIO: "Damage Ratio",
  T_37_XYL_WS_FIREEX: "Fire Extinguisher",
  T_37_XYL_WS_GUIDEPOSE: "Direction Post",
  T_37_XYL_WS_HUGEHOUSE001: "3-Story House B",
  T_37_XYL_WS_HUGEHOUSE002: "2-Story House B",
  T_37_XYL_WS_JACKSTRAW: "Scarecrow",
  T_37_XYL_WS_LADDER001: "Ladder A",
  T_37_XYL_WS_OILDRUM: "Jerry Can",
  T_37_XYL_WS_ORNAMENT001: "Vase A",
  T_37_XYL_WS_PACKBOX: "Supply Container",
  T_37_XYL_WS_PILLA001: "Concrete Pillar",
  T_37_XYL_WS_PRESENT: "Gift Box",
  T_37_XYL_WS_PRESENT_DES: "Contains holiday gifts",
  T_37_XYL_WS_PUMPKIN: "Square Jack-O'-Lantern",
  T_37_XYL_WS_PUMPKINCUT: "Jack-O'-Lantern",
  T_37_XYL_WS_PUMPKINCUT_DES: "A commonly decoration for a spooky festival",
  T_37_XYL_WS_ROADBLOCK001: "Roadblock B",
  T_37_XYL_WS_SHELF001: "Bookshelf A",
  T_37_XYL_WS_SOFA001: "Sofa A",
  T_37_XYL_WS_SPAWNTEAM: "All teams",
  T_37_XYL_WS_SUPPLYBOX: "Ammo Crate",
  T_37_XYL_WS_TABLE001: "Table A",
  T_37_XYL_WS_TABLE002: "Table B",
  T_37_XYL_WS_TARGET001: "Target",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "Portal Finish Point",
  T_37_XYL_WS_TELEPORTNEW: "Portal A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "A portal that can teleport the player to the finishing point of the portal",
  T_37_XYL_WS_TIRES001: "Tire A",
  T_37_XYL_WS_TOOLRACK: "Tool Shelf",
  T_37_XYL_WS_WALL001: "Wall",
  T_37_XYL_WS_WOOD001: "Chopped Wood",
  T_37_XYL_WS_YELLOWDUCK001: "Ducky Float",
  T_37_XYL_WS_YELLOWDUCK001_DES: "An inflated swim ring in the shape of a duck",
  T_37_YM_BOMBSQUAD_DEFUSER: "Defuser",
  T_37_YS_B_BRFOOTBALL_WHITE: "CBF White Jersey (Bottom)",
  T_37_YS_F_B_VN_STREET: "Crimson Auspicion (Bottom)",
  T_37_YS_F_H_VN_STREET: "Crimson Auspicion (Head)",
  T_37_YS_F_S_VN_STREET: "Crimson Auspicion (Shoes)",
  T_37_YS_F_T_VN_STREET: "Crimson Auspicion (Top)",
  T_37_YS_M_A_CRICKET_BLACK: "Bumblebee Cricketer (Mask)",
  T_37_YS_M_A_THKOL: "Blaze Banish (Mask)",
  T_37_YS_M_B_CRICKET_BLACK: "Bumblebee Cricketer (Bottom)",
  T_37_YS_M_B_SILVERERA: "Fearless Greyguard (Bottom)",
  T_37_YS_M_B_THKOL: "Blaze Banish (Bottom)",
  T_37_YS_M_H_SILVERERA: "Fearless Greyguard (Head)",
  T_37_YS_M_H_THKOL: "Blaze Banish (Head)",
  T_37_YS_M_S_CRICKET_BLACK: "Bumblebee Cricketer (Shoes)",
  T_37_YS_M_S_SILVERERA: "Fearless Greyguard (Shoes)",
  T_37_YS_M_S_THKOL: "Blaze Banish (Shoes)",
  T_37_YS_M_T_CRICKET_BLACK: "Bumblebee Cricketer (Top)",
  T_37_YS_M_T_SILVERERA: "Fearless Greyguard (Top)",
  T_37_YS_M_T_THKOL: "Blaze Banish (Top)",
  T_37_YS_T_BRFOOTBALL_WHITE: "CBF White Jersey (Top)",
  T_37_ZF_ROOM_UGC_MINPLAYER: "Minimum players",
  T_38_BQ_SKILL_NAME_DUMMY1: "Stunt Double",
  T_38_BQ_SKILL_NAME_DUMMY2: "Shape Splitter",
  T_38_CJ_F_B_STREAMER_MUSIC: "e-Heartseeker (Bottom)",
  T_38_CJ_F_H_STREAMER_MUSIC: "e-Heartseeker (Head)",
  T_38_CJ_F_S_STREAMER_MUSIC: "e-Heartseeker (Shoes)",
  T_38_CJ_F_T_STREAMER_MUSIC: "e-Heartseeker (Top)",
  T_38_JH_WS_CM1: "Clear Rules",
  T_38_JH_WS_CM2: "Unclear Rules",
  T_38_JH_WS_CM3: "Frequent Quit Outs",
  T_38_JL_M79_AMMO_N: "M79 Ammo",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "J.Biebs' Microchip",
  T_38_M_WS_VECTOR2: "2D Vector",
  T_38_R_TACTICS_N: "Preset",
  T_38_RW_NIW_NIWNAME: "Gloo Maker",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "Too many layers of blocks. Current: {0}. Max.: {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "Number of items you've created ({0}) has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "Number of incidents received in the same frame ({0}) has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "Per-frame dynamic entity creation limit reached ({0}); {1} creation attempt(s) refused.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "Length of the initialized list ({0}) has exceeded the limit ({1}). Auto-creates a max capacity list.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "Number of loops ({0}) has exceeded the limit ({1}). Loop interrupted",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "The number of concurrent coroutines  ({0}) in the coroutine scope has exceeded the limit ({1}).",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "Failed to add element to the list. List {0} is empty",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "Mismatched value types when executing the basic arithmetic operation. The left value type is {0} and the right value type is {1}.",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "Repeated temporary variable definition. Variable name: {0}.",
  T_38_SP_WS_REVIEW_01: "Toxic",
  T_38_SP_WS_REVIEW_02: "Vulgar",
  T_38_SP_WS_REVIEW_03: "Insulting",
  T_38_SP_WS_REVIEW_04: "Extremely Toxic",
  T_38_SP_WS_REVIEW_05: "Threatening",
  T_38_SP_WS_REVIEW_06: "Disrespectful",
  T_38_SP_WS_REVIEW_07: "Under Review",
  T_38_SP_WS_REVIEW_08: "{0} name {1} does not comply with the rules. {2}.",
  T_38_SP_WS_REVIEW_09: "String",
  T_38_SP_WS_REVIEW_10: "Store",
  T_38_SP_WS_REVIEW_11: "Variable",
  T_38_SP_WS_REVIEW_12: "Function",
  T_38_SP_WS_REVIEW_13: "Object",
  T_38_SP_WS_REVIEW_14: "Go to definition.",
  T_38_SP_WS_REVIEW_15: "Go to Manage Objects.",
  T_38_SP_WS_REVIEW_16: "No redirection.",
  T_38_SP_WS_REVIEW_17: "Map Name",
  T_38_SP_WS_REVIEW_18: "Description",
  T_38_SP_WS_REVIEW_19: "Cover Image",
  T_38_SP_WS_REVIEW_20: "Text contains sensitive words.",
  T_38_SP_WS_REVIEW_21: "Save failed. Unable to be reviewed.",
  T_38_SP_WS_REVIEW_22: "Review under cooldown.",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "Bat - Mayhem",
  T_38_SY_CHARACTER_DESIGNER_N: "Santino",
  T_38_SY_PET_CACTUS_N: "Kactus",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "Pet Skin: Ghost Kactus",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "Pet Skin: Neon Kactus",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "Pet Skin: Palm Dream Kactus",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "Pet Skin: Party Arvon",
  T_38_SY_PETSKIN_RACCOON_MO_N: "Pet Skin: Trendy Rockie",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR - Nightfire Kami",
  T_38_SY_SICKLE_ES_N: "Scythe - Pop-Pow",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "Pickup Truck - Mochi Food Truck",
  T_38_WT_WS_MUITLEVEL: "Multi-Level",
  T_38_WT_WS_SKILLSET15: "Thrill of Battle (A124)",
  T_38_WT_WS_SKILLSET16: "Senses Shockwave (Homer)",
  T_38_WT_WS_SKILLSET17: "Wall Brawl (Iris)",
  T_38_WT_WS_SKILLSET18: "Rebel Rush (Tatsuya)",
  T_38_WZY_WS_ACTIVEA: "Active in scenery or not",
  T_38_WZY_WS_ACTIVEB: "Turn on logic refresh or not",
  T_38_WZY_WS_ACTIVEVALUE: "Activity status",
  T_38_WZY_WS_AIR: "Air",
  T_38_WZY_WS_ALLOWMOVE: "Moveable or not",
  T_38_WZY_WS_AMMOAMOUNT: "Ammo amount",
  T_38_WZY_WS_AMMONAME: "Ammo Entity",
  T_38_WZY_WS_ARMOR_DAMRED: "DMG reduction multiplier",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "Explosion DMG reduction multiplier",
  T_38_WZY_WS_ARMOR_DURABILITY: "Current durability",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "Max. durability",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "Damageable or not",
  T_38_WZY_WS_ARMOR_ISDESTROY: "Destructible or not",
  T_38_WZY_WS_ARMOR_LEVEL: "Level",
  T_38_WZY_WS_ASSCONZOM: "Zombie elimination assist.",
  T_38_WZY_WS_BAGNAME: "Backpack Entity",
  T_38_WZY_WS_BAGSPACEEX: "Additional backpack space",
  T_38_WZY_WS_BRIDGING: "Bridge render component",
  T_38_WZY_WS_BUBBLE: "Bubble",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "Clear all items in the [player entity's] backpack",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "Clear the unwanted items lying around the map, such as loot, throwable residue, and loot boxes",
  T_38_WZY_WS_CLEARPRO: "Clear single property factor",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "Clone a [scenery object] entity at the location of a [player entity] and return the [disguise entity]",
  T_38_WZY_WS_COMPONENT: "Component",
  T_38_WZY_WS_COSTAMMO: "Consume ammo",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "Create a camera and return a [camera entity], whose properties can be modified through property settings",
  T_38_WZY_WS_CYCLES: "Times played",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "Check whether an [entity] is inside the scope of a circular pole. The [center] is the center of the pole, the [radius] is the radius of the circular surface, the [height] is the height of the pole, the [Euler angles] are the angles of the 3D orientation of the pole.",
  T_38_WZY_WS_CYLINDERJUD_RES: "The result of the circular pole scope check. This is a Boolean value.",
  T_38_WZY_WS_DAMSUMZOM: "DMG to zombies",
  T_38_WZY_WS_DARKNESS: "Darkness",
  T_38_WZY_WS_DIFCOLOR: "Surface color",
  T_38_WZY_WS_DIFTEXTURE: "Surface texture",
  T_38_WZY_WS_DRUMMUSIC: "Component type: drums",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "The player that was disconnected",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "The player that is reconnecting",
  T_38_WZY_WS_EUIANCHOR: "HUD anchor type enumeration",
  T_38_WZY_WS_FEATHER: "Feather",
  T_38_WZY_WS_FLAMEAMMO: "Flamethrower Ammo",
  T_38_WZY_WS_FLOWER: "Flower",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "Set the [entity] to always follow the [followed entity]. [Offset coordinates] is the distance between the two entities.",
  T_38_WZY_WS_FOLLOWENT: "Followed entity",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "Get the camera entity that is currently being used by a [player entity]",
  T_38_WZY_WS_GETCURCAMDESC: "The camera that is currently being used by the player",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "Get the amount of an item in the [designated item type] that a [player] owns",
  T_38_WZY_WS_GETITEMNUM_RES: "The amount of the designated item that the player owns",
  T_38_WZY_WS_GETVEC_NAME: "Get vector",
  T_38_WZY_WS_GETVEC_NAMEDESC: "Get a vector using the x, y, and z components of a set of coordinates",
  T_38_WZY_WS_GETVECRES: "The vector got from the x, y, and z components",
  T_38_WZY_WS_GHOST: "Ghost",
  T_38_WZY_WS_GRENADEFROZENNAME: "Flash Freeze Entity",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "Freeze zone radius",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "Freeze duration",
  T_38_WZY_WS_GRENADENAME: "Grenade Entity",
  T_38_WZY_WS_GRENADEPARAM1: "Min. DMG",
  T_38_WZY_WS_GRENADEPARAM2: "Max. DMG",
  T_38_WZY_WS_GRENADEPARAM4: "Explosion range",
  T_38_WZY_WS_GRENADEPARAM5: "Throwing speed",
  T_38_WZY_WS_GRENADEPARAM6: "Explosion delay",
  T_38_WZY_WS_GRENADEPARAM7: "Self DMG multiplier",
  T_38_WZY_WS_GRENADEPARAM8: "Ally DMG multiplier",
  T_38_WZY_WS_GRENADEPARAM9: "Vehicle DMG multiplier",
  T_38_WZY_WS_GUNFIRE: "Gunfire",
  T_38_WZY_WS_GUNPRO_PARAM2: "Reload Speed",
  T_38_WZY_WS_GUNPRO_PARAM3: "Body shots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM4: "Headshots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM5: "Limb shots DMG ratio",
  T_38_WZY_WS_GUNPRO_PARAM7: "Extra DMG",
  T_38_WZY_WS_HELMET_NAME: "Helmet Entity",
  T_38_WZY_WS_ICON1: "Crown",
  T_38_WZY_WS_ICON2: "Duel",
  T_38_WZY_WS_INITPOS: "Initial location",
  T_38_WZY_WS_ISRESET: "Reciprocating Motion",
  T_38_WZY_WS_KILLCONZOM: "No. of zombies eliminated",
  T_38_WZY_WS_KILLENT_NAMEDESC: "Eliminate the chosen [entity], which must be a battle entity type. Ignores the invulnerable status.",
  T_38_WZY_WS_LABELPARAM: "Text content parameter list",
  T_38_WZY_WS_LEADMUSICA: "Component type: piano (treble)",
  T_38_WZY_WS_LEADMUSICB: "Component type: piano (alto)",
  T_38_WZY_WS_LEADMUSICC: "Component type: piano (bass)",
  T_38_WZY_WS_LINE: "Line",
  T_38_WZY_WS_LIQUID: "Liquid",
  T_38_WZY_WS_LOCALKEY: "Localized key",
  T_38_WZY_WS_LOCALPOS: "Relative location",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "Set an [entity] to aways face the [aimed entity]. [Offset coordinates] is the difference in coordinates of the aimed point and the entity's position.",
  T_38_WZY_WS_MAINWEAPONA: "Main Weapon 1",
  T_38_WZY_WS_MAINWEAPONB: "Main Weapon 2",
  T_38_WZY_WS_MOTIONTIME: "Movement duration",
  T_38_WZY_WS_MOTIONTYPE: "Movement method",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "Modified EP",
  T_38_WZY_WS_MUSHROOMNAME: "Mushroom Entity",
  T_38_WZY_WS_OBFACTION: "Spectating faction",
  T_38_WZY_WS_OBGLOBAL: "Spectate all",
  T_38_WZY_WS_OBSERVER: "Spectator Options",
  T_38_WZY_WS_OBTEAM: "Spectating team",
  T_38_WZY_WS_OFFSETVEC: "Offset coordinates",
  T_38_WZY_WS_ONBUY_NAMEDESC: "Triggers when a player is buying items from this Vending Machine. [Player entity] is the player that makes the purchase. [Merchandise entity] is the item bought.",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "Triggers when equipped by a [player entity]",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "Triggers when the player completes the jumping action",
  T_38_WZY_WS_ONLIE_NAMEDESC: "Triggers when the player completes the prone position",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "Triggers when the weapon reloads",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "Triggers when the player completes the sprinting action",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "Triggers when the player completes the crouching action",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "Triggers when the weapon eliminates a unit. [Eliminated entity] is the unit that was eliminated.",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "Triggers when the weapon inflicts damage to a battle entity. [Hit target] is the battle entity that damage was inflicted on. [Damage] is the damage being inflicted.",
  T_38_WZY_WS_OWNER: "Owner",
  T_38_WZY_WS_PARAMLIST: "Parameter list",
  T_38_WZY_WS_PARTICALMAP: "Particle Mapping",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: 'Pause or resume the current emote for a [player entity]. [Pause or not] is a Boolean value. "Yes" means pause. "No" means resume.',
  T_38_WZY_WS_PLAENTTRI_DESC: "Activated by player entering the trigger",
  T_38_WZY_WS_PLAQUITTRI_DESC: "Activated by player leaving the trigger",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "Force the [player entity] to play the designated [emote] once and return to original position when finished",
  T_38_WZY_WS_PLAYSPEED: "Playback speed percentage",
  T_38_WZY_WS_PREHUD_NAME: "Preset icon",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "Let the [player entity] leave its current faction",
  T_38_WZY_WS_RESETENT: "Reset components every round",
  T_38_WZY_WS_RESUUID: "Resource UUID",
  T_38_WZY_WS_RIMCOLOR: "Border color",
  T_38_WZY_WS_RIMTEXTURE: "Border texture",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "Check whether an [entity] is inside a cone. The [center] and [radius] are the center and radius of the cone. The [extracted radius] is the radius of the smaller sector within the cone. The height is the height of the 3D structure. The [angle] is the central angle of the cone. The [direction angle] is the direction vector of the central axis.",
  T_38_WZY_WS_SECTORJUD_RES: "The result of the fan-shaped scope check. This is a Boolean value.",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "Set the activity status of a [target entity]. [Activity status] is a Boolean value and affects the availability, visibility, and collidability of the entity.",
  T_38_WZY_WS_SETROUNDSCORE: "Set player's round score",
  T_38_WZY_WS_SHOOTANGMAX: "Max. shooting angle",
  T_38_WZY_WS_SHOWMAPINFO: "Display map info for same faction",
  T_38_WZY_WS_SHOWNAMEHUD: "Display name HUD for same faction",
  T_38_WZY_WS_SOUND1: "Acceleration",
  T_38_WZY_WS_SOUND10: "Phase Start",
  T_38_WZY_WS_SOUND11: "Zombies",
  T_38_WZY_WS_SOUND12: "Horror",
  T_38_WZY_WS_SOUND13: "Transformation",
  T_38_WZY_WS_SOUND14: "Pounding Heart",
  T_38_WZY_WS_SOUND15: "Medium Heartbeat",
  T_38_WZY_WS_SOUND16: "Slow Heartbeat",
  T_38_WZY_WS_SOUND17: "Rush Time",
  T_38_WZY_WS_SOUND18: "Click",
  T_38_WZY_WS_SOUND19: "Skill Recover",
  T_38_WZY_WS_SOUND2: "Disappear Notification",
  T_38_WZY_WS_SOUND20: "Join A Game",
  T_38_WZY_WS_SOUND3: "Visual Effects",
  T_38_WZY_WS_SOUND4: "Night Chirps",
  T_38_WZY_WS_SOUND5: "Hit (Blunt)",
  T_38_WZY_WS_SOUND6: "Reaction",
  T_38_WZY_WS_SOUND7: "Surprise Find",
  T_38_WZY_WS_SOUND8: "Apparition",
  T_38_WZY_WS_SOUNDENT: "Music entity",
  T_38_WZY_WS_SPAWNPOS: "Old Spawn Point",
  T_38_WZY_WS_SPHERENAME: "Basic sphere",
  T_38_WZY_WS_SPHERERADIUS: "Sphere radius",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "Check whether an [entity] is inside a spherical scope. The [center] and [radius] is the center and radius of the spherical structure.",
  T_38_WZY_WS_SPHERICALJUD_RES: "The result of the spherical scope check. This is a Boolean value.",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "Check whether an [entity] is inside the scope of a cube. The [center] is the center of the cube, the [length], [width], and [height] are the length, width, and height of the cube, and the [Euler angles] are the angles of the 3D orientation of the cube.",
  T_38_WZY_WS_SQUAREJUD_RES: "The result of the cubic scope check. This is a Boolean value.",
  T_38_WZY_WS_STARTGENTIME: "Spawn start time",
  T_38_WZY_WS_STAYTIME: "Pause duration",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "Switch a player's camera to the [camera entity]. [Switch mode] can be either no animation or progressive movement. [Switch time] is the time of switching during progressive mode.",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "Switch the camera mode. You can select between No Animation and Progressive Movement.",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: 'The switch time during progressive movement mode. When selected "no animation", this setting is void.',
  T_38_WZY_WS_TEXTHUD: "HUD text component",
  T_38_WZY_WS_TEXTTYPE: "Font Size",
  T_38_WZY_WS_TEXTUREID: "Texture type",
  T_38_WZY_WS_TRANDIST: "Max. distance",
  T_38_WZY_WS_TWEENERENABLED: "Turn on UITweener script or not",
  T_38_WZY_WS_TYPELIST: "Type list",
  T_38_WZY_WS_TYPELISTORLIST: "Type or type list",
  T_38_WZY_WS_VEST_NAME: "Vest Entity",
  T_38_WZY_WS_VFX1: "Hider Elimination",
  T_38_WZY_WS_VFX10: "Cyclic Combustion",
  T_38_WZY_WS_VFX11: "Poison Gas",
  T_38_WZY_WS_VFX13: "Heart",
  T_38_WZY_WS_VFX15: "Door",
  T_38_WZY_WS_VFX2: "Rampage",
  T_38_WZY_WS_VFX3: "Clone Elimination",
  T_38_WZY_WS_VFX4: "Hit Feedback",
  T_38_WZY_WS_VFX5: "Clone",
  T_38_WZY_WS_VFX6: "Disguise",
  T_38_WZY_WS_VFX7: "Flashbang Sparks",
  T_38_WZY_WS_VFX8: "Motion Trail",
  T_38_WZY_WS_VFX9: "Fire Charge",
  T_38_WZY_WS_VFXENT: "VFX Instance",
  T_38_WZY_WS_VFXTYPEA_NAME: "Customizable mapping VFX",
  T_38_WZY_WS_VFXTYPEB_NAME: "Non-customizable mapping VFX",
  T_38_WZY_WS_VISIBILITY: "Visibility type",
  T_38_WZY_WS_VOLUME: "Volume",
  T_38_WZY_WS_WEAPONGEN: "Weapon Generator",
  T_38_WZY_WS_WHECYCLE: "Replay",
  T_38_XXJ_WS_BLOCKMODE: "Blocked Mode",
  T_38_XXJ_WS_CUSTOMCAMARA: "Custom Camera",
  T_38_XXJ_WS_FFCLASSIC: "Classic FF (Shooting)",
  T_38_XXJ_WS_FOV: "Field of View",
  T_38_XXJ_WS_FOVDESC: "The field of view is the observable range of the camera.",
  T_38_XXJ_WS_FPS: "First Person (Shooting)",
  T_38_XXJ_WS_HORIZONTALANGLE: "Horizontal Angle",
  T_38_XXJ_WS_INVISICAM: "Semi-Transparent",
  T_38_XXJ_WS_OFFSET: "Offset",
  T_38_XXJ_WS_ORTHOGRAPHIC: "Orthographic",
  T_38_XXJ_WS_PERSPECTIVE: "Perspective",
  T_38_XXJ_WS_PROJECTIONMODE: "Projection Mode",
  T_38_XXJ_WS_STABLE: "Fixed",
  T_38_XXJ_WS_STARTCAMERA: "Default Camera",
  T_38_XXJ_WS_STARTCAMERAMODE: "Default Camera Mode",
  T_38_XXJ_WS_THIRD: "Chase Camera",
  T_38_XXJ_WS_TOPVIEW: "High Angle",
  T_38_XXJ_WS_TPS: "Third Person",
  T_38_XXJ_WS_TRANSVERSE: "Horizontal Movement",
  T_38_XXJ_WS_VERTICALANGLE: "Vertical Angle",
  T_38_XXJ_WS_ZOOM: "Zoom",
  T_38_XYL_WS_AISTARTTIME: "Start time (s)",
  T_38_XYL_WS_ARMORDESTROY: "Armor DMG multiplier",
  T_38_XYL_WS_BONFIRE: "Bonfire",
  T_38_XYL_WS_CANDLE01: "Candle A",
  T_38_XYL_WS_CANNON01: "Mechanical Cannon",
  T_38_XYL_WS_CLIPAMMOSIZE: "Magazine Storage",
  T_38_XYL_WS_DAMAGEDTRUCK: "Damaged Truck",
  T_38_XYL_WS_DOLL01: "Eerie Doll",
  T_38_XYL_WS_ENTERANCEHOUSE01: "Brick House A",
  T_38_XYL_WS_FENCE002: "Iron Fence B",
  T_38_XYL_WS_FIREWORK01: "Fireworks A",
  T_38_XYL_WS_GENERATOR: "Generator",
  T_38_XYL_WS_GRAVITY: "Gravitational Acceleration",
  T_38_XYL_WS_GRAVITYAREA: "Abnormal Grav Zone",
  T_38_XYL_WS_GRAVITYAREA_DESC: "A zone where players can change gravity",
  T_38_XYL_WS_HOLDWEAPON: "Weapon Hold",
  T_38_XYL_WS_INDOORFURNITURE: "Indoor Furniture",
  T_38_XYL_WS_LIGHTTUBE001: "Tube Light A",
  T_38_XYL_WS_LOVEBALLOON01: "Valentine Balloon A",
  T_38_XYL_WS_LOVELAMP01: "Heart Streetlight",
  T_38_XYL_WS_LOVESIGN01: "Love Neonlights",
  T_38_XYL_WS_OILDRUM_DAMAGE: "Oil Barrel Damage Ratio",
  T_38_XYL_WS_OUTDOORPROPS: "Outdoor Items",
  T_38_XYL_WS_PIPEANDBOX: "Pipes and Containers",
  T_38_XYL_WS_PLANT: "Plants",
  T_38_XYL_WS_ROSE01: "Rose",
  T_38_XYL_WS_ROSEN: "Rose Bouquet",
  T_38_XYL_WS_SMALLBUILDING: "Small Buildings",
  T_38_XYL_WS_SOFA002: "Sofa B",
  T_38_XYL_WS_TOWNHOUSE01: "Old 2-Story House",
  T_38_XYL_WS_TV001: "Old TV",
  T_38_ZP_CC_EXCHANGESTATUS: "Status",
  T_39_BQ_SKILL_NAME_VILLAIN: "Crimson Crush",
  T_39_CJ_A_BURN: "Victory Glintmark",
  T_39_HJ_WS_Arrow002: "Arrow 2",
  T_39_HJ_WS_LIKERATE2: "{0} min",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} min",
  T_39_HJ_WS_SOUND10: "Step",
  T_39_HJ_WS_SOUND11: "Mission Complete 1",
  T_39_HJ_WS_SOUND13: "Danger Alert 1",
  T_39_HJ_WS_SOUND14: "Danger Alert 2",
  T_39_HJ_WS_SOUND15: "Countdown 3",
  T_39_HJ_WS_SOUND16: "Tips Sound",
  T_39_HJ_WS_SOUND17: "Crow Caw",
  T_39_HJ_WS_SOUND18: "Sound of teleporting to a wrong area",
  T_39_HJ_WS_SOUND19: "Sound of teleporting to a correct area",
  T_39_HJ_WS_SOUND2: "Countdown 1",
  T_39_HJ_WS_SOUND20: "Teleport",
  T_39_HJ_WS_SOUND21: "Electric Shock",
  T_39_HJ_WS_SOUND23: "Get Item",
  T_39_HJ_WS_SOUND24: "Electronic & Cute BGM",
  T_39_HJ_WS_SOUND25: "Casual Game BGM",
  T_39_HJ_WS_SOUND4: "Mechanical Device Echo",
  T_39_HJ_WS_SOUND5: "Mosquito",
  T_39_HJ_WS_SOUND6: "Ding Ding Ding 1",
  T_39_HJ_WS_SOUND7: "Ding Ding Ding 2",
  T_39_HJ_WS_SOUND8: "Gear Switched On",
  T_39_HJ_WS_SOUND9: "Charge 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "Unlimited Gloo Walls",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "Unlimited Throwables",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "Special Firing Sound",
  T_39_HQ_UGC_CUSTOMRES: "Custom Resources",
  T_39_M_ACCOUNTID: "Account",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "Execute after double click",
  T_39_MF_SKILLTAG_4: "Movement",
  T_39_PD_HuntingGroundSnow_MYNAME: "Mr. V",
  T_39_QL_SKILL_OTHO_DES: "After knocking down an enemy, marks their teammates within [FFB300]{0}m[-] from them and slows down their movement speed by [FFB300]{1}%[-]. Lasts for [FFB300]{2}s[-]. When knocked down by a nearby enemy, marks and slows down the attacker and their teammates.",
  T_39_QL_SKILL_WOLFRAHH_DES: "After knocking down an enemy, enter Highlight mode, which increases rate of fire by [FFB300]{0}%[-] and movement speed by [FFB300]{1}%[-] but then decays quickly. Lasts for [FFB300]{2}s[-]. During Highlight mode, consecutively knocking down enemies will reset countdown and further boost rate of fire by [FFB300]{3}%[-] and movement speed by [FFB300]{4}%[-].",
  T_39_QL_SKILL_XAYNE_DES1: "Xtreme Mode: Get [FFB300]{0} temporary HP[-] for [FFB300]{1}s[-]. During this time, HP-healing effects are enhanced by [FFB300]{2}%[-]. Cooldown: [FFB300]{3}s[-].",
  T_39_RW_GM_DEFEAT: "Failed",
  T_39_RW_SKILL_DESC_FORD: "Gain [FFB300]{1} HP/s[-] for [FFB300]{0}s[-] when taking damage. After releasing an active skill, this passive skill will reset immediately. Cooldown: [FFB300]{2}s[-].",
  T_39_SP_WS_ITEMENTITY_01: "Item entity",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: 'Alvaro "Rageblast"',
  T_39_SY_CHARACTER_VILLAIN_N: "Orion",
  T_39_SY_KATANA_FASTBREAKING23_N: "Katana - 1001 Nights",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "Pet skin: Green Imp Arvon",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "Pet Skin: Royal Tig",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "Pet Skin: Scorpio Fang",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "Monster Truck - Green Giant",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "Tuk Tuk - Floral Chariot",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "Awakening: [FFB300]{0}s[-] before detonating, grenade produces [FFB300]{1}[-] extra grenades, which can cause [FFB300]{2}%[-] damage of their original.",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "Split Blitz",
  T_39_WT_WS_EMPTYMAP_TAG: "Empty space",
  T_39_WT_WS_FEMAPMODE: "Mode Title",
  T_39_WT_WS_FEMAPTAG: "Map Tag",
  T_39_WT_WS_MAPPLAYER: "Number of Players",
  T_39_WT_WS_MEDENTERNUM: "Mid-game joining player limit",
  T_39_WT_WS_MIDENTER: "Mid-game joining",
  T_39_WT_WS_MIDENTERCOUNT: "Quota of joining mid-game",
  T_39_WT_WS_MIDENTERTIME1: "Time limit of mid-game joining",
  T_39_WT_WS_MIDENTERTIME2: "Duration of mid-game joining",
  T_39_WT_WS_MIDENTERTIMETIP: "When the map player number limit is not reached, enable players to join in within N sec after match starts. Players cannot join in after N sec.",
  T_39_WT_WS_MIDENTERTIP: "When enabled, players can join this map mid-game.",
  T_39_WT_WS_PLAYERCOUNT: "Initial player number",
  T_39_WT_WS_PLAYERCOUNTTIP: "The player number when the match starts. More players can join mid-game until it reaches the map's limit.",
  T_39_WT_WS_TAG1: "Free For All",
  T_39_WT_WS_TAG10: "Easy",
  T_39_WT_WS_TAG11: "Medium",
  T_39_WT_WS_TAG12: "Hard",
  T_39_WT_WS_TAG13: "Very Challenging",
  T_39_WT_WS_TAG14: "Escape",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "Custom Resources",
  T_39_WT_WS_TAG18: "Puzzles",
  T_39_WT_WS_TAG19: "Racing",
  T_39_WT_WS_TAG2: "Gun Fight",
  T_39_WT_WS_TAG20: "Music",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "Adventure",
  T_39_WT_WS_TAG23: "Zombie Hunt",
  T_39_WT_WS_TAG24: "PvP",
  T_39_WT_WS_TAG25: "Party Game",
  T_39_WT_WS_TAG26: "Team Deathmatch",
  T_39_WT_WS_TAG27: "Turret Defense",
  T_39_WT_WS_TAG28: "Training",
  T_39_WT_WS_TAG3: "Gun King",
  T_39_WT_WS_TAG4: "Respawn",
  T_39_WT_WS_TAG5: "Sniper",
  T_39_WT_WS_TAG6: "Survival",
  T_39_WT_WS_TAG7: "Solo",
  T_39_WT_WS_TAG8: "Horror",
  T_39_WT_WS_TAG9: "Casual",
  T_39_WT_WS_TAGMAXTIP: "Select up to {0} tags",
  T_39_WT_WS_TAGTYPE1: "Gameplay Type",
  T_39_WT_WS_TAGTYPE2: "Map Type",
  T_39_WT_WS_TAGTYPE3: "Mode Type",
  T_39_WT_WS_TAGTYPE4: "Team Size",
  T_39_WZY_WS_ACCSPEED: "Acceleration",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "Add script [Script Name] for [Entity]",
  T_39_WZY_WS_ASC: "Ascending",
  T_39_WZY_WS_ASCIGZERO: "Ignore zero using Ascending",
  T_39_WZY_WS_BALLISTMOVENT: "Ballistic Motion Entity",
  T_39_WZY_WS_BEUSED_NAMEDESC: "Triggers incident when the item is used by [Player Entity]",
  T_39_WZY_WS_BODYSCALE: "Body scale",
  T_39_WZY_WS_BRAKETORQUE: "Brake Horsepower",
  T_39_WZY_WS_CAMTRANTYPE: "Camera transition type",
  T_39_WZY_WS_CARVEHICLE: "4-Wheeler",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "Check if a specified script [Script Name] exists in [Entity]. (The returned value should be Boolean)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "Check if the entity has a result of the specified script (Boolean)",
  T_39_WZY_WS_COMBINEALL: "Dual-wielding (Different guns)",
  T_39_WZY_WS_COMBINESELF: "Dual-wielding (Same gun)",
  T_39_WZY_WS_CONENAME: "Basic Cone",
  T_39_WZY_WS_COORSYS: "Coordinate system",
  T_39_WZY_WS_CRASHMAXD: "Max Crash Damage",
  T_39_WZY_WS_CRASHMIND: "Minimum Crash Damage",
  T_39_WZY_WS_CRAWLSPEED: "Mvmt. spd. percentage (Prone)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "Create Ballistic Motion for [Target Entity]. Can edit [Initial Speed], [Acceleration], and [Max Distance] accumulated in the direction of initial speed for the target entity, and return [Ballistic Motion Entity]",
  T_39_WZY_WS_CRETWEEN_NAME: "Create Interpolation Motion",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "Create an Interpolation Motion for [Entity], with [Attributes] of the entity moving smoothly from [Start Value] to [Target Value] within [Time]. [Method] represents the way of motion, including [One-way], [PingPong], [Cycle]. [Curve] is the curve of motion. And [Interpolation Motion Entity] will be returned after creating the motion.",
  T_39_WZY_WS_CURVE: "Curve",
  T_39_WZY_WS_CUSTRESULT: "Custom Match Result",
  T_39_WZY_WS_CYLINDERNAME: "Basic Cylinder",
  T_39_WZY_WS_DEFAULT: "No animation (Default)",
  T_39_WZY_WS_DESC: "Descending",
  T_39_WZY_WS_DIFFUSEALPHA: "Surface Transparency",
  T_39_WZY_WS_DISCONNECT: "Disconnect",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "Energy recovery per sec",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "Consume Energy",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "Max second jump height",
  T_39_WZY_WS_ENABLEJOIN: "Allow joining midway",
  T_39_WZY_WS_ENDPOS: "End point coordinates",
  T_39_WZY_WS_ENGINETORQUE: "Engine Horsepower",
  T_39_WZY_WS_EXPLODED: "Explosion Damage",
  T_39_WZY_WS_FEELDSPEED: "Mvmt. spd. percentage (Downed)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "Center flash time",
  T_39_WZY_WS_FLASH_CRANGE: "Center range",
  T_39_WZY_WS_FLASH_EFLASHTIME: "Edge flash time",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "Flashbomb hit effect",
  T_39_WZY_WS_FLASH_RANGE: "Explosion range",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "Descending speed",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "Max. altitude",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "Horizontal glide speed",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "Vertical glide speed",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "Minimum end height",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "Minimum takeoff height",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "Descent speed after super high",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "Turning speed",
  T_39_WZY_WS_FOLMOVENT: "Position Following Motion Entity",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "Get Skill List of [Player Entity]",
  T_39_WZY_WS_HB_BOOSTCD: "Sprint cooldown",
  T_39_WZY_WS_HB_BOOSTDURATION: "Sprint duration",
  T_39_WZY_WS_HB_BOOSTINITIAL: "Sprint cooldown on Skyboard",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "Sprint cooldown on Skyboard",
  T_39_WZY_WS_HB_BOOSTSPEED: "Sprint speed",
  T_39_WZY_WS_HB_HOVERBCD: "Skyboard cooldown",
  T_39_WZY_WS_HB_JUMPCD: "Jump cooldown",
  T_39_WZY_WS_HB_JUMPH: "Skyboard jump height",
  T_39_WZY_WS_HEADSCALE: "Head scale",
  T_39_WZY_WS_HEADSHOTDESCALE: "Headshot damage reduction",
  T_39_WZY_WS_INTITALSPEED: "Initial Speed",
  T_39_WZY_WS_INVENTORYBASE: "Basic item types",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "Energy cost per sec",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "Basic horizontal speed",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "Basic vertical speed",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "Dash energy cost per sec",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "Sprint horizontal speed",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "Sprint distance",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "Rush energy cost per sec",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "Sprint vertical speed",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "Upward energy cost per sec",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "Attackable",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "Self-triggerable",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "Whether can be triggered by allies",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "Triggerable by vehicle",
  T_39_WZY_WS_LANDMINE_LIFETIME: "Duration",
  T_39_WZY_WS_LANDMINE_STARTTIME: "Activation time",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "Trigger radius",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "Trigger time",
  T_39_WZY_WS_LEAVE: "Quit",
  T_39_WZY_WS_LIMBSCALE: "Limbs scale",
  T_39_WZY_WS_LISTLOCSTR: "Localized text list",
  T_39_WZY_WS_LOADRESULT_NAME: "Upload battle result",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "Upload battle result of [Player], including [Rank], [Result], [Score Name], [Score Value]. The result type is an integer. 1 for victory, 2 for defeat, 3 for Booyah, and 4 for a draw.",
  T_39_WZY_WS_LOOKMOVENT: "Gaze-following Motion Entity",
  T_39_WZY_WS_MAXCOUNT: "Maximum Quantity",
  T_39_WZY_WS_MAXDISTANCE: "Max. Distance",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "Turret Depression Angle",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "Turret Angular Speed",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "Turret Elevation Angle",
  T_39_WZY_WS_MINISENTRY_DAM: "Turret Damage",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "Damage Reduction Rate",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "Firing Angle",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "Turret Hit Rate",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "Turret Attack Interval",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "Max Turret Number",
  T_39_WZY_WS_MINISENTRY_RANGE: "Turret Attack Range",
  T_39_WZY_WS_MOVEENT: "Motion Entity",
  T_39_WZY_WS_NOCOMBINE: "Not dual-wieldable",
  T_39_WZY_WS_ONCE: "Once",
  T_39_WZY_WS_ONDROP_NAMEDESC: "Triggers incident when the item is discarded by [Player Entity]",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "Triggers incident when the item is equipped by [Player Entity]",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "Triggers incident when Hook Gun fires",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "Triggers incident when Landmine is activated",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "Triggers incident when Landmine is triggered by [Player Enitity]",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "Triggers when entity motion pauses",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "Triggers when entity restarts moving from pause",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "Triggers when entity starts moving",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "Triggers incident when the item is picked up by [Player Entity]",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "Triggers incident when Throwable hits target",
  T_39_WZY_WS_OPENATTACK: "Whether to enable the attack",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "Pause Motion Entity or Motion Entity List",
  T_39_WZY_WS_PAUSESOUND_NAME: "Pause sound effect",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "Pause Sound Entity or Sound Entity List",
  T_39_WZY_WS_PIANOTYPE: "Music Component Type",
  T_39_WZY_WS_PINGPONG: "PingPong",
  T_39_WZY_WS_PLAYABLELIST: "Motion Entity List",
  T_39_WZY_WS_PLAYINGSTATUE: "Status",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "Restore the paused Motion Entity or Motion Entity List. Can choose to resume or restart.",
  T_39_WZY_WS_PLAYSOUND_NAME: "Play sound effect",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "Restore the paused Sound Entity or Sound Entity List. Can choose to resume or restart.",
  T_39_WZY_WS_PROCIRCLE_NAME: "Progress Circle",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "Emits a ray along [Direction] from [Initial Coordinates], detects the first entity hit within [Distance], and returns [List of Entities Hit] and [List of Coordinates Hit]",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "Emits a ray along [Direction] from [Initial Coordinates], detects the first entity hit within [Distance], and returns [Entity Hit] and [Coordinates Hit]",
  T_39_WZY_WS_REAHEALHP: "Armor recovery value",
  T_39_WZY_WS_REAHEALTIME: "In-effect time interval",
  T_39_WZY_WS_RELATCOORSYS: "Relative coordinate system",
  T_39_WZY_WS_REPAIRARM: "Repair Kit",
  T_39_WZY_WS_REVERSE: "Reverse",
  T_39_WZY_WS_RIMALPHA: "Edge Transparency",
  T_39_WZY_WS_SCORENAME: "Score Name",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "Send a signal to Target Entity, the parameters uploaded are defined by predefined signal parameters. The selection of the entity type at the time of definition will generate the corresponding signal accepting event.",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "Create a position following motion for [Target Entity]. [Target Entity] follows [Following Entity]. [Offset Coordinates] is the coordinate offset between [Target Entity] and [Following Entity]. [Coordinate System] can select World Coordinate System and Relative Coordinate System based on the orientation of Following Entity. [Position Following Motion Entity] will be returned after creating the motion.",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "Create a Gaze-following Motion for [Target Entity]. [Target Entity] follows [Following Entity]. [Offset Coordinates] is the coordinate offset between [Target Entity] and [Following Entity]. [Coordinate System] can select World Coordinate System and Relative Coordinate System based on the orientation of Following Entity. [Gaze-following Motion Entity] will be returned after creating the motion.",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "Falling damage percentage",
  T_39_WZY_WS_SHOE_MAXENERGY: "Max. Energy",
  T_39_WZY_WS_SKILLLIST: "Skill List",
  T_39_WZY_WS_SKILLTYPE: "Character skill",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "Smoke effect duration",
  T_39_WZY_WS_SMOOTH: "Camera switch",
  T_39_WZY_WS_SOUNDENTL: "Sound Effect Entity List",
  T_39_WZY_WS_SOUNDENTLORSENT: "Sound Effect Entity or List",
  T_39_WZY_WS_SPRINTSPEED: "Sprint speed percentage",
  T_39_WZY_WS_SQUATSPEED: "Mvmt. spd. percentage (Squat)",
  T_39_WZY_WS_STARTCOO: "Initial Coordinates",
  T_39_WZY_WS_STATE: "Play status",
  T_39_WZY_WS_TARGETVAL: "Target value",
  T_39_WZY_WS_THROWSPEED: "Hook flying speed",
  T_39_WZY_WS_TOWER_PARAM10: "Rotation angle",
  T_39_WZY_WS_TOWER_PARAM11: "Turret status",
  T_39_WZY_WS_TOWER_PARAM12: "Entity ID",
  T_39_WZY_WS_TOWER_PARAM9: "Attack Target",
  T_39_WZY_WS_TOWSPEED: "Player traveling speed",
  T_39_WZY_WS_TWEENCURVE_NAME: "Custom Curve",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "Custom Curve can be used for Interpolation Motion",
  T_39_WZY_WS_TWEENENT: "Interpolation Motion Entity",
  T_39_WZY_WS_TWEENPLAYST_NAME: "Motion Methods",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "Methods of Interpolation Motion",
  T_39_WZY_WS_TWEENSTYLE: "Method",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "Delete script [Script Name] for [Entity]",
  T_39_WZY_WS_UPSET_NAMEDESC: "Randomize listed elements ",
  T_39_WZY_WS_VISIBLEONBACK: "Visible on back",
  T_39_WZY_WS_WEAPCOMBINET: "Dual-Wielding Weapon Type",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "Extra damage on the downed",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "Single shot bullet number",
  T_39_WZY_WS_WEAREPLAY: "Restart motion?",
  T_39_WZY_WS_WORLDCOORSYS: "World coordinate system",
  T_39_XXJ_WS_ADDFRIEND: "Add friend",
  T_39_XXJ_WS_ALLOWZ: "Enable player x-axis movement",
  T_39_XXJ_WS_BLOCKMODEDESC: "Camera's motion when there's an object between the camera and target",
  T_39_XXJ_WS_CAMERADISTANCE: "Distance from target",
  T_39_XXJ_WS_CAMERATYPEDESC: "Multiple types of preset and custom camera are provided",
  T_39_XXJ_WS_CAMERAUSER: "Camera user",
  T_39_XXJ_WS_CURENTCAMERA: "Camera used",
  T_39_XXJ_WS_DETAILS: "Match Details",
  T_39_XXJ_WS_FFECONOMY: "Economy",
  T_39_XXJ_WS_FOCUSTARGET: "Target observed",
  T_39_XXJ_WS_FOLLOWTARGET: "Target followed",
  T_39_XXJ_WS_GAMERESULT: "Match Result",
  T_39_XXJ_WS_GAMETITLE1: "Match 1",
  T_39_XXJ_WS_GAMETITLE2: "Match 2",
  T_39_XXJ_WS_GIFT: "Gift",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "Camera's horizontal rotation angle",
  T_39_XXJ_WS_INVISICAM: "Translucent",
  T_39_XXJ_WS_INVISICAMDESC: "Object between the camera and target becomes translucent",
  T_39_XXJ_WS_LEFTSCORE: "Left Team Score",
  T_39_XXJ_WS_LIKE: "Like",
  T_39_XXJ_WS_LOBBY: "Lobby",
  T_39_XXJ_WS_MAINSCORENAME: "Total Score Name",
  T_39_XXJ_WS_MAINSCORENUM: "Total Score Number",
  T_39_XXJ_WS_MAPEVALUATE: "Map Rating",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "Result of Multiple Teams",
  T_39_XXJ_WS_MVP1: "MVP 1",
  T_39_XXJ_WS_MVP2: "MVP 2",
  T_39_XXJ_WS_OFFSET2: "Observation point offset",
  T_39_XXJ_WS_OFFSET2DESC: "Typically refers to the offset of camera focus point relative to the player's original position. (Meaning varies by camera type)",
  T_39_XXJ_WS_OFFSETDESC: "Typically refers to the offset of camera position relative to the player's original position. (Meaning varies by camera type)",
  T_39_XXJ_WS_ORTHOGONAL: "Orthogonal",
  T_39_XXJ_WS_ORTHOGONALDESC: "Camera portrays distant and nearer targets as the same size",
  T_39_XXJ_WS_PERSPECTIVE: "Perspective",
  T_39_XXJ_WS_PERSPECTIVEDESC: "Camera uses perspective projection to observe the target",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "Camera's image formation when rendering",
  T_39_XXJ_WS_RANK1: "Team Rank",
  T_39_XXJ_WS_RANK2: "Player Rank",
  T_39_XXJ_WS_REPORT: "Report",
  T_39_XXJ_WS_REVIEW: "Replay",
  T_39_XXJ_WS_RIGHTSCORE: "Right Team Score",
  T_39_XXJ_WS_SCORENUM1: "Score 1",
  T_39_XXJ_WS_SCORENUM2: "Score 2",
  T_39_XXJ_WS_SCORENUM3: "Score 3",
  T_39_XXJ_WS_SCORENUM4: "Score 4",
  T_39_XXJ_WS_SCORENUM5: "Score 5",
  T_39_XXJ_WS_SCORETITLELIST: "Score Name List",
  T_39_XXJ_WS_SHARE: "Share",
  T_39_XXJ_WS_SPECTATORSWITCH: "Spectator",
  T_39_XXJ_WS_STABLE: "Stable",
  T_39_XXJ_WS_STABLEDESC: "Camera remains stable if there's an object in between the camera and the followed entity",
  T_39_XXJ_WS_TEAMNAME1: "Left Team Name",
  T_39_XXJ_WS_TEAMNAME2: "Right Team Name",
  T_39_XXJ_WS_TEAMRANK: "Team Rank",
  T_39_XXJ_WS_TRANSITIONTIME: "Camera transition time",
  T_39_XXJ_WS_TRANSITIONTYPE: "Camera transition type",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "Result of 2 Teams",
  T_39_XXJ_WS_VERTICALANGLEDESC: "Camera's vertical rotation angle",
  T_39_XXJ_WS_ZOOM: "Zoom",
  T_39_XXJ_WS_ZOOMDESC: "Camera zooms in if there's an object in between the camera and the followed entity",
  T_39_XYL_WS_LIGHTINTENSITY: "Light intensity",
  T_39_XYL_WS_LIGHTRANGE: "Light range",
  T_39_XYL_WS_POINTLIGHT: "Pointlight",
  T_39_XYL_WS_WATERZONE: "Custom water zone",
  T_40_B_DISABLE_RECONNECT: "Disable Auto-reconnection",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "Midnight Jersey",
  T_40_CJ_T_SHUTTLECOCK_RED2: "Arctic Blaze Jersey",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "Cherry Coal Jersey",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "Sunny Sky Jersey",
  T_40_CJ_T_SPORTSWEAR_FIRE: "Flame Up Jersey",
  T_40_DYEING_CLEAR: "Clear Coloring Status",
  T_40_HJ_WS_EFFECT32: "Sneakers",
  T_40_HJ_WS_EFFECT33: "Explosion",
  T_40_HJ_WS_EFFECT34: "Spawnpoint",
  T_40_HJ_WS_EFFECT35: "Laser",
  T_40_HJ_WS_EFFECT36: "Ammo",
  T_40_HJ_WS_EFFECT37: "Hit Effect",
  T_40_HJ_WS_EFFECT38: "Firing Effect",
  T_40_HJ_WS_EFFECT43: "Spider Web",
  T_40_HJ_WS_EFFECT44: "Releasing a Skill",
  T_40_HJ_WS_SOUND69: "Opening a Box",
  T_40_HJ_WS_SOUND70: "Level Up",
  T_40_HJ_WS_SOUND71: "Level Maxed",
  T_40_HJ_WS_SOUND72: "Tapping a Button",
  T_40_HJ_WS_SOUND73: "Countdown 1",
  T_40_HJ_WS_SOUND74: "Whistle",
  T_40_HJ_WS_SOUND75: "Game Over",
  T_40_HJ_WS_SOUND76: "Forward",
  T_40_HJ_WS_SOUND77: "Booyah",
  T_40_HJ_WS_SOUND78: "Checkpoint",
  T_40_HJ_WS_SOUND79: "Countdown 2",
  T_40_HJ_WS_SOUND80: "Game Starts",
  T_40_HJ_WS_SOUND81: "Obtained Many Coins",
  T_40_HJ_WS_SOUND82: "Obtained Coins",
  T_40_HJ_WS_SOUND83: "Obtained Some Coins",
  T_40_HJ_WS_SOUND84: "Joined the Game",
  T_40_HJ_WS_SOUND85: "Opening Guild Supply",
  T_40_HJ_WS_SOUND86: "Horn",
  T_40_HJ_WS_SOUND87: "Eliminated a Boss",
  T_40_HJ_WS_SOUND88: "Opening War Chest",
  T_40_HJ_WS_SOUND89: "Explosive Paint Skill",
  T_40_HJ_WS_SOUND90: "Bullet Hitting",
  T_40_HJ_WS_SOUND91: "Paint Shield Skill",
  T_40_HJ_WS_SOUND92: "Tapping a Disabled Button",
  T_40_HJ_WS_SOUND93: "Skill Charging Complete",
  T_40_HJ_WS_SOUND95: "Laser Skill",
  T_40_HJ_WS_SOUND96: "Get Item 2",
  T_40_HJ_WS_SOUND97: "Game Over 2",
  T_40_HJ_WS_SOUND98: "Elimination Notification",
  T_40_HJ_WS_SOUNDTYPE_BMG: "Background Music",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "In-Match Sound Effect",
  T_40_HJ_WS_SOUNDTYPE_UI: "UI Widget Sound Effect",
  T_40_JH_WS_MAPTAG1: "Color Game",
  T_40_JH_WS_MAPTAG10: "Color Hide N Seek",
  T_40_JH_WS_MAPTAG11: "Anniversary",
  T_40_JH_WS_MAPTAG12: "Role Play",
  T_40_JH_WS_MAPTAG13: "Simulation",
  T_40_JH_WS_MAPTAG14: "Asymmetrical",
  T_40_JH_WS_MAPTAG15: "Resource Battle",
  T_40_JH_WS_MAPTAG16: "Cart Escort",
  T_40_JH_WS_MAPTAG17: "Official Map",
  T_40_JH_WS_MAPTAG18: "Mini Game",
  T_40_JH_WS_MAPTAG19: "Speed Challenge",
  T_40_JH_WS_MAPTAG2: "Color Spray",
  T_40_JH_WS_MAPTAG20: "Roguelike",
  T_40_JH_WS_MAPTAG3: "Color Fight",
  T_40_JH_WS_MAPTAG4: "Color Fight",
  T_40_JH_WS_MAPTAG5: "Color Playground",
  T_40_JH_WS_MAPTAG6: "Playground Color",
  T_40_JH_WS_MAPTAG7: "Color Party",
  T_40_JH_WS_MAPTAG8: "Color Parkour",
  T_40_JH_WS_MAPTAG9: '"Spider-Verse" Parkour',
  T_40_JH_WS_TAG30: "Tycoon",
  T_40_JH_WS_TAG31: "Home-Wreck Havoc",
  T_40_JH_WS_TAG32: "Mystery Town",
  T_40_JH_WS_TAG33: "Dawn Crisis",
  T_40_JH_WS_TAG34: "Death Uprising",
  T_40_JH_WS_TAG35: "Fist Fight",
  T_40_JH_WS_TAG36: "Old Factory Roof",
  T_40_JH_WS_UGCTOKENNAME: "Craftland Token",
  T_40_L_QUICKMESSAGE_MODE2: "Clash Squad",
  T_40_M_WS_HIS: "of",
  T_40_SP_WS_DYEING: "Color",
  T_40_SP_WS_DYEING_AREA: "Area Coloring",
  T_40_SP_WS_DYEING_COLOR: "Color number",
  T_40_SP_WS_DYEING_COUNT: "Coloring Count",
  T_40_SP_WS_DYEING_DIR: "Coloring Direction",
  T_40_SP_WS_DYEING_DIS: "Coloring Distance",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "Fixed Coloring Area",
  T_40_SP_WS_DYEING_NORMAL: "Normal",
  T_40_SP_WS_DYEING_PLANE: "Plane Area Coloring",
  T_40_SP_WS_DYEING_POSITION: "Coordinate",
  T_40_SP_WS_DYEING_RANDOMDECAY: "Random Coloring Rate Decay",
  T_40_SP_WS_DYEING_RANDOMRATIO: "Random Coloring Rate",
  T_40_SP_WS_DYEING_RANGE: "Coloring Area",
  T_40_SP_WS_DYEING_STATE: "Coloring Status",
  T_40_SP_WS_FACTIONTIPS_11: "Purple",
  T_40_SP_WS_SHOE_CURENERGY: "Current Energy",
  T_40_SW_SKILL_Name_Nanoscientist: "Nano Lifeshield",
  T_40_SY_AK47_PENGUIN_W_N: "AK47 - Waggor's Wonder",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Awakened Alok",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "Sonia",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS - Waggor's Wonder",
  T_40_SY_M1014_PENGUIN_W_N: "M1014 - Waggor's Wonder",
  T_40_SY_M24_PENGUIN_W_N: "M24 - Waggor's Wonder",
  T_40_SY_MINI_PENGUIN_W_N: "AC80 - Waggor's Wonder",
  T_40_SY_PET_PUG_N: "Pug",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: 'Pet Skin: "Spider-Verse" Moony',
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "Pet Skin: Electric Arvon",
  T_40_SY_PETSKIN_PUG_BLACK_N: "Pet Skin: Laser Eyes Pug",
  T_40_SY_PETSKIN_PUG_GREEN_N: "Pet Skin: Aloha Pug",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "Pet Skin: Tigerstripe Pug",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR - Waggor's Wonder",
  T_40_SY_THOMPSON_PENGUIN_W_N: "Thompson - Waggor's Wonder",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP - Waggor's Wonder",
  T_40_SY_USP45_PENGUIN_W_N: "USP - Waggor's Wonder",
  T_40_SY_UZI_PENGUIN_W_N: "Mini Uzi - Waggor's Wonder",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "Activate Text Content",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "Placeholder Text Content",
  T_40_W_DJMALE_AWAKENING_D: "Awakening: While the aura is active, music notes that last for [FFB300]{2}s[-] will be dropped [FFB300]{1}m[-] behind the skill user every [FFB300]{0}s[-]. Teammates who pick up the music note will receive the same effect as the aura.",
  T_40_W_DJMALE_AWAKENING_N: "Party Remix",
  T_40_W_NURSE_D: "Spread [FFB300]{0}%[-] of the user's single-target healing effects (skill, Med Kit, heal gun, etc.) to teammates within [FFB300]{1}m[-] of the user.",
  T_40_WH_MP_BOXING_NAME: "Boxing Match",
  T_40_WH_MP_C_PACK: "Unlawful Backpack",
  T_40_WH_MP_EXCH_COIN: "Cash",
  T_40_WH_MP_EXCH_TEMPCOIN: "Unlawful Money",
  T_40_WH_MP_PAYCHECK: "Wages",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "The speed of helping up teammates is increased by [FFB300]{0}%[-]. Cooldown: [FFB300]{3}s[-]. The helped up teammate recovers [FFB300]{2} HP[-] in [FFB300]{1}s[-].",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "Creates a [FFB300]{0}m-radius[-] healing zone. Inside, user and allies recover [FFB300]{1} HP/s[-]. Help up will be automatically triggered when needed. Zone lasts for [FFB300]{2}s[-]. The effects of helping up teammates can be enhanced by other skills. Cooldown: [FFB300]{3}s[-].",
  T_40_WT_WS_ICONENTITY_PARAM6: "Method of display",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "Capsule",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "Height",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "Radius",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "Sphere",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "Simplified Arabic",
  T_40_WZY_WS_FONT_SUPERMARKET: "Supermarket",
  T_40_WZY_WS_ICONENTITY_COLOR: "Color",
  T_40_WZY_WS_ICONENTITY_FILLED: "Progressive",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "Image Resources",
  T_40_WZY_WS_ICONENTITY_NAME: "Icon object",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "Method of display",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "Simple",
  T_40_WZY_WS_ICONENTITY_SLICED: "9-Grid",
  T_40_WZY_WS_ICONENTITY_TILED: "Tiles",
  T_40_WZY_WS_NEWMAPTAG: "New Map Icon",
  T_40_WZY_WS_NEWVFX1: "Halo",
  T_40_WZY_WS_NEWVFX10: "Curse",
  T_40_WZY_WS_NEWVFX11: "Freeze Zone",
  T_40_WZY_WS_NEWVFX12: "Cold Air",
  T_40_WZY_WS_NEWVFX13: "Snowflake",
  T_40_WZY_WS_NEWVFX14: "Flame",
  T_40_WZY_WS_NEWVFX15: "Light Beam",
  T_40_WZY_WS_NEWVFX16: "Spread of Poison Gas",
  T_40_WZY_WS_NEWVFX17: "Poison Gas",
  T_40_WZY_WS_NEWVFX18: "Explosive Blaze",
  T_40_WZY_WS_NEWVFX19: "Light Effect",
  T_40_WZY_WS_NEWVFX2: "Bubble",
  T_40_WZY_WS_NEWVFX20: "Star",
  T_40_WZY_WS_NEWVFX3: "Ash",
  T_40_WZY_WS_NEWVFX4: "Stone Splash",
  T_40_WZY_WS_NEWVFX5: "Line",
  T_40_WZY_WS_NEWVFX6: "Flicker",
  T_40_WZY_WS_NEWVFX7: "Ring",
  T_40_WZY_WS_NEWVFX8: "Rising Particle",
  T_40_WZY_WS_NEWVFX9: "Smoke",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "Font Size",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "Font Style",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "Font",
  T_40_WZY_WS_TEXTENTITY_NAME: "Text object",
  T_40_WZY_WS_UIFONT_LATIN: "Agency FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "Interaction button HUD component",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: 'Whether it can be used in the scenery. This is read only and depends on "Parent available or not" and "Activity status".',
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "Whether all parents are active. This is read only and not visible to players.",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "Parent available or not",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "Display when the open status is true, otherwise closed",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: 'Whether it can be active on self. To use in the scenery, you must use "Active in scenery or not". This is read only and configured using an API.',
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "Whether the camera's cullingMask is visible to a certain layer",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "Generate tokens at a certain place",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "The lootable item to give to the player",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "Current orientation of the player",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "Direction",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "The AI is attacking the entity",
  T_40_XXJ_WS_AITARGET_DESCKEY: "The attacking AI",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "The align style",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "Horizontal align",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "Vertical align",
  T_40_XXJ_WS_ALPHA_DESCKEY: "Transparency",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "The remaining ammo count",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "Remaining ammo",
  T_40_XXJ_WS_ANCHORMAX: "Maximum Anchor",
  T_40_XXJ_WS_ANCHORMIN: "Minimum Anchor",
  T_40_XXJ_WS_APOSITION_DESCKEY: "Current position of the player",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "Position",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "Armor HUD switch",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "Configured asset ID",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "Asset ID",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "Target of attack",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "Attack throwables",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "The entity that is being attacked by the AI",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "Target attacked",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "The available coordinates of spawnpoints",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "Available coordinates",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "The bottom image",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "Background",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "Backpack",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "Background transparency",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "Background color",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "Background color",
  T_40_XXJ_WS_BGFILL_DESCKEY: "Whether to fill the background",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "Background fill",
  T_40_XXJ_WS_BGNAME_DESCKEY: "Background name",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "Background name",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "Background size delta",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "Background size delta",
  T_40_XXJ_WS_BLUE: "Blue",
  T_40_XXJ_WS_BODY_DESCKEY: "Torso",
  T_40_XXJ_WS_BODY_NAMEKEY: "Torso",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "Skeleton scale",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "The player's spawnpoint",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "Spawn point",
  T_40_XXJ_WS_BOTH: "Either",
  T_40_XXJ_WS_BUTTONNAME: "Button component name",
  T_40_XXJ_WS_CAMERA_DESCKEY: "Camera",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "The direction that the client camera is facing",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "The location of the client camera",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "Detect the camera line of the client",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "Camera ray detection",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "Stop dragging when coinciding with the viewport",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "Exit drag after fit",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "The distance between the center of the semicircles of the pill shape. It cannot be smaller than twice the radius of the sphere.",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "Cell size",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "Child cell height",
  T_40_XXJ_WS_CELLVALUE: "Read the content of a certain cell and return an object",
  T_40_XXJ_WS_CENTER_DESCKEY: "The world coordinates that corresponds to the minimap's center. 0 by default.",
  T_40_XXJ_WS_CENTER_NAMEKEY: "Minimap center",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "The offset of the button's position",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "Position offset",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "The center of mass relative to the local coordinates",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "Center of mass",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "Whether to display the middle line",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "Display middle line or not",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "Middle line position [0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "Middle line position",
  T_40_XXJ_WS_CHASERANGE: "Chase Vicinity",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "The entity that is being chased by the AI",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "Target chased",
  T_40_XXJ_WS_CHILD_DESCKEY: "Child entity",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "Parent's children",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "The point that is hit by the camera line",
  T_40_XXJ_WS_CHOOSECARHUD: "Select card HUD entity",
  T_40_XXJ_WS_CLAMP_DESCKEY: "If the parameter is within the numerical range between the minimum and maximum values, the function will return the value of the parameter; if the parameter is greater than the range, the function will return the maximum value; if the argument is less than the range, the function will return the minimum value",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "The size of the click area",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "Click size",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "Clipping type",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "Clipping type",
  T_40_XXJ_WS_CLONEENT_D: "Clone the selected entity and its attributes while keeping the original parent. If Level Object is selected, it will be based on Create Level Object.",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "The list of outfits",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "The outfit ID",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "Outfit ID",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "The outfit ID",
  T_40_XXJ_WS_COL_DESC: "The column to read.",
  T_40_XXJ_WS_COLNAME_DESC: "The name of the column to be read.",
  T_40_XXJ_WS_COLOR_DESCKEY: "Color",
  T_40_XXJ_WS_COLOR_NAMEKEY: "Value",
  T_40_XXJ_WS_COLOR1_DESCKEY: "Add color layers using the RGBA color channel. A channel value lies in between 0 and 255 and is stored in an Int32. White (255, 255, 255, 255) by default.",
  T_40_XXJ_WS_COLOR2_DESCKEY: "Color of the progress bar",
  T_40_XXJ_WS_COLOR3_DESCKEY: "The type of the RGBA color channel, which ranges from 0 to 255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "The color of the text",
  T_40_XXJ_WS_COLOR5_DESCKEY: "The color of the HUD",
  T_40_XXJ_WS_COLOR6_DESCKEY: "The color of the lighting",
  T_40_XXJ_WS_COLORA_DESCKEY: "The A color value",
  T_40_XXJ_WS_COLORB_DESCKEY: "The B color value",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "Progress bar color",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "Color barrel",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "Color Barrel",
  T_40_XXJ_WS_COLORG_DESCKEY: "The G color value",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "Obtain the RGBA channel",
  T_40_XXJ_WS_COLORGUN: "Rainbow Spray Rifle",
  T_40_XXJ_WS_COLORGUN_01: "Rainbow Spray Rifle (Red)",
  T_40_XXJ_WS_COLORGUN_02: "Rainbow Spray Rifle (Yellow)",
  T_40_XXJ_WS_COLORGUN_03: "Rainbow Spray Rifle (Blue)",
  T_40_XXJ_WS_COLORGUN_04: "Rainbow Spray Rifle (Green)",
  T_40_XXJ_WS_COLORGUN_05: "Rainbow Spray Rifle (Purple)",
  T_40_XXJ_WS_COLORR_DESCKEY: "The R color value",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "Text color",
  T_40_XXJ_WS_COLVALUE: "Column Content",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "The HUD entity of a general HUD switch",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "HUD entity of general HUD switch",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "Constraint",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "Constraint",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "The number of constraints",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "Constraint count",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "Original content",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "Default direction",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "The starting point of the scroll. Upper left corner by default.",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "Generate a static pixel for a certain object in the map. The pixel will not move with the object.",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "Create a minimap icon",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "Define a localized string for a timestamp",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "Create a custom UI component at the designated custom HUD and parent component",
  T_40_XXJ_WS_CREEP_NAMEKEY: "Crawl",
  T_40_XXJ_WS_CROUCH_DESCKEY: "Display when true, otherwise closed",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "Crouch",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "This is the camera's cullingMask render layer. You can filter the render entity using the level of the visible layer.",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "CullingMask",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "The top ID",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "Top",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "Facepaint ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "The shoes ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "Shoes",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "The head ID",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "Head",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "The facepaint ID",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "Mask",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "The bottom ID",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "Bottom",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "Facepaint",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "The bundle ID",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "Onesie",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "The drag amount in the xy direction",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "XY drag",
  T_40_XXJ_WS_DB: "Read Table Value",
  T_40_XXJ_WS_DB_DESC: "Read the corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DBDELETE_DESC: "Delete a corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DBKEY_DESCKEY: "A custom name used to identify data",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "Identifier",
  T_40_XXJ_WS_DBTABLENAME: "Database Table Name",
  T_40_XXJ_WS_DBTABLENAME_DESC: "The name of a table in a database.",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "The value to write",
  T_40_XXJ_WS_DBWRITE: "Write Table Value",
  T_40_XXJ_WS_DBWRITE_DESC: "Write a corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "Defense throwables",
  T_40_XXJ_WS_DEFULT: "Default",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "Delete a corresponding value of a certain key on a certain leaderboard table in the database.",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "Delete a corresponding value of a certain rank on a certain leaderboard table in the database.",
  T_40_XXJ_WS_DEPTH: "HUD layer",
  T_40_XXJ_WS_DEPTH_D: "The basic layer of the HUD",
  T_40_XXJ_WS_DICTANDLIST: "List and Dictionary",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "The value of the targeted dictionary",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "The transparency of the surface",
  T_40_XXJ_WS_DIR_DESCKEY: "Vector",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "A point that is provided and can be used as a revival points, etc.",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "Coordinates",
  T_40_XXJ_WS_DISABLEALL: "Deselect All",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "Disabled color",
  T_40_XXJ_WS_DISTANT_DESCKEY: "The distance of the camera line detection",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "Projecting distance",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "Supports multiple dragging directions",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "Drag effect",
  T_40_XXJ_WS_DRIVER_DESCKEY: "The driver of the vehicle",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "Driver",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "Modify a value",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "Display special effects",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "Display special effects",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "Effects color",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "The special effects entity represents the special effect to be displayed",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "The special effects object",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "Emoji HUD switch",
  T_40_XXJ_WS_ENABLEALL: "Select all",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "Whether to turn on logic update. When off, the blocks on this entity will stop updating every frame.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "When written into the weapon attributes, the weapon's basic statistics will be affected by the weapon skin",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "Write weapon skin attribute",
  T_40_XXJ_WS_ENTITY_DESCKEY: "An entity is a vessel that holds all components, which must be added to entities in order to be activated",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "Entity type",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "The basic component of an entity. All components will combine this component.",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "The entity to transform into",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "The parameter name used in the code to represent the entity of the newly added custom UI control. Its corresponding local variable value is the entity of the newly added custom UI control.",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "The name of the entity variable",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "The parameter name used in the code to represent the entity of the created icon. Its corresponding local variable value is the entity of the created icon.",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "EP bar HUD switch",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "Euler angles",
  T_40_XXJ_WS_FACINFECTION: "Faction (Droid Apocalyse)",
  T_40_XXJ_WS_FACINFECTION_DESC: "Faction of the player. 1 = Human, 2 = Droid.",
  T_40_XXJ_WS_FEMALE: "Female",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "Fill direction",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "Sort direction",
  T_40_XXJ_WS_FIRE_NAMEKEY: "Fire",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "The value of the float",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "The target entity to follow. Empty by default.",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "The size of the text",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "Font size",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "The font style",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "Football Gloo Wall",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "The formatting style",
  T_40_XXJ_WS_FORWARD_DESCKEY: "The direction of the player",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "The direction to teleport",
  T_40_XXJ_WS_FREE_DESCKEY: "A camera that is controllable by the player and can be moved freely",
  T_40_XXJ_WS_FREE_NAMEKEY: "Free Camera",
  T_40_XXJ_WS_GENDER: "Gender",
  T_40_XXJ_WS_GENDER_DESCKEY: "Gender",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "Gender enum",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "Obtain the camera's cullingMask",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Obtain the player's outfit ID",
  T_40_XXJ_WS_GETPLAYERRANK: "Get Player Rank",
  T_40_XXJ_WS_GETPLAYERRANK_D: "Get Player Total Rank",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "Get Player Round Rank",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "Get Player Specific Round Rank",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "Search for data of the player's token",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Obtain the player's weapon skin",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "Obtain a set of coordinates that has not been occupied by random spawnpoints",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "Obtain the sky box of a scenery",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "Obtain the region of a server",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "Obtain the timestamp of a server",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "Obtain a location near the teammate, avoiding areas where players cannot stand on",
  T_40_XXJ_WS_GETTEAMRANK: "Get Team Rank",
  T_40_XXJ_WS_GETTEAMRANK_D: "Get Team Total Rank",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "Get Team Round Rank",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "Get Team Specific Round Rank",
  T_40_XXJ_WS_GREEN: "Green",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "Half of the dimensions of a 3-dimensional shape",
  T_40_XXJ_WS_HEAD_DESCKEY: "Head",
  T_40_XXJ_WS_HEAD_NAMEKEY: "Head",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "The heartbeat effect entity",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "Heartbeat effect entity",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "The height",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "Hint button",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "Tips button",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "The entity to be displayed at the target location",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "Entity targeted",
  T_40_XXJ_WS_HITPOS_DESCKEY: "The spot that is hit",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "The horizontal display type",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "Horizontal display type",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "The entity that is following another entity",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "The entity that is looking at another entity",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "Health bar HUD switch",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "The HUD insertion entity. This is the HUD that players modify from the editor.",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "Empty HUD panel component",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "The HUD entity it belongs to",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "HUD grid component",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "HUD panel component",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "HUD scroll view component",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "Human model ID",
  T_40_XXJ_WS_ICON_DESCKEY: "The resource name of the icon",
  T_40_XXJ_WS_ICON_NAMEKEY: "Icon",
  T_40_XXJ_WS_ICON1_DESCKEY: "Select an icon",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "The icon entity represents the icon to be displayed",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "A resource path. Built-in resource is in:path. Custom resource is out:path. Empty by default.",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "Icon name",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "Icon name",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "The resource path. Empty by default.",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "Whether it can scan for triggers",
  T_40_XXJ_WS_INDEX_DESCKEY: "The child's index under the parent",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "Initial value [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "The value of the integer",
  T_40_XXJ_WS_IS3D: "3D sound effect",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "Always facing the camera",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "Bold",
  T_40_XXJ_WS_ISBYORDER_D: "Detect whether players should trigger level objects in chronological order",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "Is FirEditor button",
  T_40_XXJ_WS_ISHIT_DESCKEY: "Whether the camera line has hit the entity",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "Whether it is visible to a certain layer",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "Italic",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "Whether marked by scan",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "Scanned or not",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "Whether marked by the pin button",
  T_40_XXJ_WS_ISTRIGGER: "Is trigger",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "Underlined",
  T_40_XXJ_WS_ITEMID_DESCKEY: "The entity's corresponding item ID",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "Item ID",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "The item ID (only weapon ID available in the current version)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "The item ID of the weapon",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "Item ID",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "Metropolis area",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "Metropolis area",
  T_40_XXJ_WS_JUMP_NAMEKEY: "Jump",
  T_40_XXJ_WS_KEY_DESCKEY: "The value of the key",
  T_40_XXJ_WS_KEY_NAMEKEY: "Key",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "The name of the key to traverse. You can use this to obtain the value of a key in a local variable.",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "Elimination announcement",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "Text color",
  T_40_XXJ_WS_LANDMINEOBJ: "Entity after landmine creation",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "The mask of the collide layer. Layers not selected will not be included in the scan. When empty, all layers will be included in the scan.",
  T_40_XXJ_WS_LAYERSEDIT: "Edit Layers",
  T_40_XXJ_WS_LAYERSETTING: "Visible layer settings",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "The collision layer of the camera line detection",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "Layer",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "Layout type",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "Layout type",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "Scoreboard HUD component",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "The HUD entity of the scoreboard. Modifying the entity's properties will affect the content to be displayed on the corresponding UI.",
  T_40_XXJ_WS_LEADERBOARDNAME: "Leaderboard Name",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "The name of the leaderboard table in the database.",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "The acceleration upon swinging",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "Leave acceleration",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "Left arm",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "Left arm",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "The left color",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "Left color",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "Whether to display the special effects on the left",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "Display left effect or not",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "Left foot",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "Left foot",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "Left hand",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "Left hand",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "Left icon",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "Left icon",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "Left leg",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "Left leg",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "Left score text",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "Left score text",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "Left text",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "Left text",
  T_40_XXJ_WS_LERP_DESCKEY: 't lies in between 0 and 1. When t=0, return "from". When t=1, return "to". When t=0.5, return the average of the values of "from" and "to".',
  T_40_XXJ_WS_LEVELOBJECT: "Level Object",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "Line spacing",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "Compare the values in a list and return the largest one",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "Compare the values in a list and return the smallest one",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "List or Dict",
  T_40_XXJ_WS_LOCALPOSITION: "Local position",
  T_40_XXJ_WS_LOCALROTA: "Local Euler angles",
  T_40_XXJ_WS_LOCALROTATIONQ: "Local quaternion rotation",
  T_40_XXJ_WS_LOCALSACLE: "Local scale",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "Localization switch",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "The container to traverse",
  T_40_XXJ_WS_MALE: "Male",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "Remove the dictionary",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "Obtain the length of the dictionary",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "Obtain the value of the designated key in the dictionary element",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "Remove the designated key-value pair in the dictionary",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "Configure the value of a designated key in the dictionary",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "The size of the minimap. Its width and height are equal.",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "Map size",
  T_40_XXJ_WS_MAPT: "Dict template",
  T_40_XXJ_WS_MAPT_D: "The data template for dict. You may designate the content type through T1 and T2.",
  T_40_XXJ_WS_MAPVALUE_D: "A data container for dict. The element is a pair that consists of a key and a value.",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "The target dictionary",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "Dict",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "The mask type is the image name used when masking",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "Mask name",
  T_40_XXJ_WS_MASS_DESCKEY: "Mass (in kg)",
  T_40_XXJ_WS_MASS_NAMEKEY: "Mass (kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "Compare 2 values and return the larger one",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "Max. length",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "The maximum value",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "The biggest component ID",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "Max. widget ID",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "Healing items",
  T_40_XXJ_WS_MIN_DESCKEY: "Compare 2 values and return the smaller one",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "Minimap component",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "Minimap pixel",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "Minimap icon",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "Minimap",
  T_40_XXJ_WS_MINNUM_DESCKEY: "The minimum value",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "The factor of the momentum. The larger the value, the bigger the momentum while scrolling.",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "Momentum factor",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "Movement joystick",
  T_40_XXJ_WS_MRESULT_DESCKEY: "Match result",
  T_40_XXJ_WS_NEWENTITY_D: "The new item entity after creation (may be null)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "Create a new dictionary",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "New Dict",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "The normal of the hit",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "HUD position [0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "HUD position",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "The list to convert indices into numbers",
  T_40_XXJ_WS_OBJECT_DESCKEY: "The object that the spray gun hits",
  T_40_XXJ_WS_OBSOLETE: "Deleted, for safety reasons please replace this block.",
  T_40_XXJ_WS_OFFSET_DESCKEY: "The display position. When there is a followed target, it is the offset between the new position and the original position. When there is no followed target, it is the screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "The screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "The display position. When there is a followed target, it is the offset between the new position and the original position. When there is no followed target, it is the screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "Display position (the anchor is on the top right corner)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "Horizontal offset",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "Horizontal offset",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "The vertical offset",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "Vertical offset",
  T_40_XXJ_WS_OK_DESCKEY: "Conversion successful",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "Trigger this event when the entity enters the attack vicinity",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "Trigger this event when the entity enters the chase vicinity",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "Trigger this event when the entity leaves the attack vicinity",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "Trigger this event when the entity leaves the chase vicinity",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "Trigger a camera line detection through the client",
  T_40_XXJ_WS_ONCOLLISION_D: "Only entities with the Collider component attached support this event",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "Trigger this event when the spray gun hits an entity",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "When the firing stops",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "When a player switches the scenery area",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "Display when the open status is true, otherwise closed",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "Open status",
  T_40_XXJ_WS_ORANGE: "Orange",
  T_40_XXJ_WS_ORDER_DESC: "The rank on the leaderboard",
  T_40_XXJ_WS_ORDER1: "Starting Rank",
  T_40_XXJ_WS_ORDER2: "Finishing Rank",
  T_40_XXJ_WS_ORIGINAL: "Keep original logic",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "Overflow method",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "When prioritized, the attributes of the player's weapon will replace the weapon's original attributes",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "Prioritize player weapon skin",
  T_40_XXJ_WS_OWNER_DESCKEY: "The player that owns this entity",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "The global UID of the child scenery it belongs to",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "GUID of child scenery",
  T_40_XXJ_WS_PARENT_DESCKEY: "Parent entity",
  T_40_XXJ_WS_PARENT_NAMEKEY: "Parent",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "Parent component entity ID",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "The file ID of the parent component",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "All the passengers in the vehicle",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "Passenger",
  T_40_XXJ_WS_PHYSICALLAYER: "Physical Layer",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "Physical Layer Matrix",
  T_40_XXJ_WS_PHYSICALTIP1: "Name Already Exists",
  T_40_XXJ_WS_PHYSICALTIP2: "Remove a layer name and make it invisible in the Physical Layer Matrix and Layer Enum, but the entity objects within that layer will not be affected.",
  T_40_XXJ_WS_PHYSICS: "Physics",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "Loot list HUD switch",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "A playable entity",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "An entity always faces another entity",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "An entity follows another entity",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "The bullet trail animation is a simulated animation of a bullet trail",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "The player to receive the message",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "The avatar used by the player",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "The outfit equipped by the player",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "Player outfit",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "The player's HUD type",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "Player HUD type",
  T_40_XXJ_WS_PLAYERIDINFAC: "Faction Serial No.",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "The player to record in the log",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "Consume a certain player's token",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "The list of skills of the player",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "The status of a player: alive, knocked down, or eliminated",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "Playback speed",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "Playback speed",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "For example, 1.25 means 25% faster than the original speed",
  T_40_XXJ_WS_POS_DESCKEY: "The coordinates to teleport to",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "The type of special effects sticker",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "Color on press",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "Executes a traversal of a container to obtain the key-value pair. Includes a child process, which is the loop.",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "Loop dict visit",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "Progress [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "Progress [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "The button for the skill progress",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "Skill progress button",
  T_40_XXJ_WS_QUATERNION: "Quaternion rotation",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "Quick msg HUD switch",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "Msgs beside team list",
  T_40_XXJ_WS_RADIUS_DESCKEY: "The radius of the two semicircles of a pill shape",
  T_40_XXJ_WS_READCELL: "Read A Cell",
  T_40_XXJ_WS_READCSV: "Read Table Content",
  T_40_XXJ_WS_READCSV_DESC: "Read the content on the entire table. Return a two-dimensional array.",
  T_40_XXJ_WS_READCSVCELL: "Read by row # and column name",
  T_40_XXJ_WS_READCSVCOL_DESC: "Read a certain column's content on the table. Returns an array.",
  T_40_XXJ_WS_READCSVROW_DESC: "Read a certain row's content on the table. Returns an array.",
  T_40_XXJ_WS_READLEADERBOARD: "Read Leaderboard Value",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "Read a corresponding value of a certain identifier on a leaderboard table in the database.",
  T_40_XXJ_WS_READLEADERBOARD2: "Read By Rank Range",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "Read the value of the difference between a certain rank to a certain rank on the leaderboard in a database.",
  T_40_XXJ_WS_RED: "Red",
  T_40_XXJ_WS_RELOAD: "Reload",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "Method of display",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "Restore the player's default outfit",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "Restore the player's default weapon skin",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "Whether the dragging is constrained to the viewport. Selected by default.",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "Constrain drag or not",
  T_40_XXJ_WS_RESULT_DESCKEY: "The result of the read",
  T_40_XXJ_WS_RESULT_NAMEKEY: "Result",
  T_40_XXJ_WS_RESULT1_DESCKEY: "Whether to find the largest number in the list",
  T_40_XXJ_WS_RESULT2_DESCKEY: "Whether to find the smallest number in the list",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "Find the smallest number in a list",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "Find the largest number in a list",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "The revival point of a player. If there are no checkpoints, use a spawnpoint. Otherwise use checkpoints.",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "Revival point",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "Right arm",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "Right arm",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "The right color",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "Right color",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "Whether to display the special effects on the right",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "Display right effect or not",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "Right foot",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "Right foot",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "Right hand",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "Right hand",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "Right icon",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "Right icon",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "Right leg",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "Right leg",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "Right score text",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "Right score text",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "Right text",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "Right text",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "The component of the rigid body type",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "Rigid body component",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "The enum of the rigid body type",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "Rigid body type enum",
  T_40_XXJ_WS_ROW_DECS: "The row to read.",
  T_40_XXJ_WS_ROWVALUE: "Row Content",
  T_40_XXJ_WS_SCALE_DESCKEY: "Configure the zoom scale of the object",
  T_40_XXJ_WS_SCALE_NAMEKEY: "Scale",
  T_40_XXJ_WS_SCALE0_DESCKEY: "The zoom scale of the coordinate series in the world",
  T_40_XXJ_WS_SCALE1_DESCKEY: "The zoom scale. 1 by default.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "The scale value",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "The name of the area",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "Scorebar",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "Score bar",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "Supports multiple scrolling directions",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "Scroll direction",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "The factor of the scroll. The larger the value, the faster the scrolling.",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "Scroll factor",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "Configure the camera's cullingMask",
  T_40_XXJ_WS_SETGLOBAL: "Set Global",
  T_40_XXJ_WS_SETPARENT_D: "Only supports entities that have the Transform component",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Configure the player's outfit ID",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "Modify multiple player outfits",
  T_40_XXJ_WS_SETPLAYERFORWAR: "Set Player Direction",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "Configure a player's HUD switch",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Configure the player's weapon skin",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "Whether to display entities at the target location",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "Display entity on target",
  T_40_XXJ_WS_SHOWPLAYER: "Display entity",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "Single-player match details HUD entity",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "A HUD entity for single-player matches. Modifying the entity's properties will affect the content to be displayed on the corresponding UI.",
  T_40_XXJ_WS_SIZEDELTA: "Size delta of anchor box and component",
  T_40_XXJ_WS_SKELETON: "Skeleton",
  T_40_XXJ_WS_SKELETON_D: "The pivot used to access the skeleton mask",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "Skeleton part",
  T_40_XXJ_WS_SKILLBUTTONHUD: "Skill button HUD entity",
  T_40_XXJ_WS_SLOT_DESCKEY: "The weapon's slot",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "When selected, there will be a slow movement upon dragging. When unselected, the dragging corresponds to the speed of the mouse.",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "Smooth motion or not",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "Softness",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "Softness",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "Sound entity",
  T_40_XXJ_WS_SPACE_DESCKEY: "Space",
  T_40_XXJ_WS_SPACE_NAMEKEY: "Child cell spacing",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "The coordinates of the AI's spawnpoint",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "Spawn point coordinates",
  T_40_XXJ_WS_SPEED_DESCKEY: "Speed",
  T_40_XXJ_WS_SPEED_NAMEKEY: "Speed",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "Sprint",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "The radius of the sphere",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "The color of the spray",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "Spray color",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "The spray result",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "Spray result",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "The spray gun (assault rifle)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "Spray Rifle",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "Initial Velocity",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "Flip sticker",
  T_40_XXJ_WS_SPRITEID: "Sprite asset ID",
  T_40_XXJ_WS_SPRITEID_D: "The ID used to describe the sprite asset",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "Sticker type",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "The target entity to generate into a static pixel",
  T_40_XXJ_WS_STARTPOSITION_D: "The coordinates of the shape's geometrical center",
  T_40_XXJ_WS_STAY_D: "Retain the current world position, rotation, and scaling of the child? This is generally set to true, and UI settings are ineffective for this option.",
  T_40_XXJ_WS_STRING_NAMEKEY: "String",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "Convert a string to a float",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "Convert a string to an integer",
  T_40_XXJ_WS_STYLE_DESCKEY: "The play method of the interpolation. Options include play once, loop, and play again.",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "Switch the player's area",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "Switch value",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "Switch weapons according to the player's slot",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "Switch the item slot",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "Item switch",
  T_40_XXJ_WS_TABLENAME_DESC: "Displayed as the table name but is actually the UID",
  T_40_XXJ_WS_TABLEVALUE: "Table content",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "The list of tags",
  T_40_XXJ_WS_TARGET_DESCKEY: "The target entity to generate map pixel. Empty by default.",
  T_40_XXJ_WS_TARGET_NAMEKEY: "Entity to create map pixel",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "Attack target",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "The target entity",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "Entity",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "The entity where the customized function is at",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "The entity that is attacked by the AI",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "The target entity to follow",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "The item entity (can be empty)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "The target entity to look at",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "The sound entity to pause",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "The sound entity to play after the pause",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "The sound entity to delete",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "Teammates info",
  T_40_XXJ_WS_TELEPORTA_D: "Teleport the player to a designated spot with a set direction",
  T_40_XXJ_WS_TEXT_NAMEKEY: "Tip text",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "Notification text color",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "The text entity represents the text to be displayed",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "The text keys to display",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "Text key",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "The timestamp",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "The display style of a localized string",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "Timestamp display style",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "The localized string for a timestamp",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "Loc string timestamp",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "Hint",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "Tip",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "The amount of lootable item",
  T_40_XXJ_WS_TOKENID_DESCKEY: "The ID of a lootable item",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "The tow speed of a player",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "Translation type",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "The interpolation animation entity",
  T_40_XXJ_WS_TYPE_DESCKEY: 'This is the type of the description. Using "typeof" will return its type.',
  T_40_XXJ_WS_TYPE_NAMEKEY: "Rigid body type",
  T_40_XXJ_WS_TYPE2_DESCKEY: "Different types of rigid bodies have different functions",
  T_40_XXJ_WS_TYPE3_DESCKEY: "Only basic currencies supported in the current version",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "Whether to enable minimap depth display",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "Use depth map",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "Whether it follows the gravitational law",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "Gravitational or not",
  T_40_XXJ_WS_UUID_DESCKEY: "The unique identifier of a player",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "The value",
  T_40_XXJ_WS_VALUE_NAMEKEY: "Value",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "Value [0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "The first value",
  T_40_XXJ_WS_VALUE2_DESCKEY: "The second value",
  T_40_XXJ_WS_VALUE6_DESCKEY: "Value [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "The starting value",
  T_40_XXJ_WS_VALUEB_DESCKEY: "The target value",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "The name of the value to traverse. You can use this to obtain the value in a local variable.",
  T_40_XXJ_WS_VALUET_DESCKEY: "The interpolation progress. Lies in between 0 and 1.",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "Variable type",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "The vertical display type",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "Vertical display type",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "The level of an object's visibility",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "Visible layer",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "Outfits include bundle, head, mask, facepaint, top, bottom, and shoes",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "Outfit type",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "Outfit slot",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "Weapons",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "The weapon skin ID",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "Weapon skin ID",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "The ID of the weapon skin",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "The player's weapon skin",
  T_40_XXJ_WS_WIDGETTYPEENUM: "Component type enum",
  T_40_XXJ_WS_WIDTH_DESCKEY: "The width",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "Word Wrap",
  T_40_XXJ_WS_WRITELEADERBOARD: "Write Leaderboard Value",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "Write a corresponding value of a certain key on a certain leaderboard table in the database.",
  T_40_XYL_WS_BUMPERFACTORY: "Bumper Car Factory",
  T_40_XYL_WS_BURNDAMAGE: "Combustion Damage",
  T_40_XYL_WS_BURNINTERVAL: "Combustion Damage Interval (s)",
  T_40_XYL_WS_BURNTIME: "Combustion Time After Explosion",
  T_40_XYL_WS_COLORFULSKY: "Colorful Sky",
  T_40_XYL_WS_CRANEMACHINE: "Claw Crane",
  T_40_XYL_WS_CRASHMAXDAMAGE: "Maximum Crash Damage",
  T_40_XYL_WS_CRASHMAXSPEED: "Maximum Crash Damage Speed Limit",
  T_40_XYL_WS_CRASHMESS: "Mass Parameter During Crash",
  T_40_XYL_WS_CRASHMINDAMAGE: "Min. Crash Damage",
  T_40_XYL_WS_DISPLAYBOARD: "Billboard",
  T_40_XYL_WS_EXPLODEDAMAGE: "Explosion Damage",
  T_40_XYL_WS_EXPLODEDELAY: "Explosion Delay Time",
  T_40_XYL_WS_EXPLODERANGE: "Explosion Range",
  T_40_XYL_WS_FERRISWHEEL: "Ferris Wheel",
  T_40_XYL_WS_FOODTRUCK002: "Food Truck B",
  T_40_XYL_WS_GEARSHIFTDELAY: "Gear Changing Time (s)",
  T_40_XYL_WS_ICAROUSEL001: "Merry-Go-Round Component A",
  T_40_XYL_WS_ICAROUSEL002: "Merry-Go-Round Component B",
  T_40_XYL_WS_ICAROUSEL003: "Merry-Go-Round",
  T_40_XYL_WS_ICEDANCEDOOL: "Blue Doll",
  T_40_XYL_WS_IDLEBRAKEINPUT: "Uncontrolled Parking Horsepower Ratio",
  T_40_XYL_WS_LOLLIPOP: "Giant Lollipop",
  T_40_XYL_WS_NEWHOOKGUN: "Super Hook Gun",
  T_40_XYL_WS_OPENSWING: "Swing button",
  T_40_XYL_WS_OPENTRACTION: "Tow button",
  T_40_XYL_WS_PODIUM: "Podium",
  T_40_XYL_WS_SKYCITY: "City",
  T_40_XYL_WS_SKYSCRAPER_A001: "Skyscraper A Component A",
  T_40_XYL_WS_SKYSCRAPER_A002: "Skyscraper A Component B",
  T_40_XYL_WS_SKYSCRAPER_A003: "Skyscraper A Component C",
  T_40_XYL_WS_SKYSCRAPER_B001: "Skyscraper B Component A",
  T_40_XYL_WS_SKYSCRAPER_B002: "Skyscraper B Component B",
  T_40_XYL_WS_SKYSCRAPER_B003: "Skyscraper B Component C",
  T_40_XYL_WS_SKYSCRAPER_C001: "Skyscraper C Component A",
  T_40_XYL_WS_SKYSCRAPER_C002: "Skyscraper C Component B",
  T_40_XYL_WS_SKYSCRAPER_C003: "Skyscraper C Component C",
  T_40_XYL_WS_SKYSCRAPER_D001: "Skyscraper D Component A",
  T_40_XYL_WS_SKYSCRAPER_D002: "Skyscraper D Component B",
  T_40_XYL_WS_SKYSCRAPER_D003: "Skyscraper D Component C",
  T_40_XYL_WS_SKYSCRAPER_E001: "Skyscraper E Component A",
  T_40_XYL_WS_SKYSCRAPER_E002: "Skyscraper E Component B",
  T_40_XYL_WS_SKYSCRAPER_E003: "Skyscraper E Component C",
  T_40_XYL_WS_STEERANGLE: "High-speed Turning Radius",
  T_40_XYL_WS_STEERSPEED: "Maximum Speed During High-speed Turning",
  T_40_XYL_WS_SWINGSPEED: "Swing speed",
  T_40_XYL_WS_TARGETOBJECT: "Motion Anchor",
  T_40_XYL_WS_TRACTIONSPEED: "Tow speed",
  T_40_XYL_WS_TRIGGERCAPSULE: "Custom Capsule Trigger",
  T_40_XYL_WS_TRIGGERSPHERE: "Custom Sphere Trigger",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "Custom Object",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "An empty object component that can be used with the render component and collision component.",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "Custom Render Component",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "A custom rendering component, used for rendering with custom model resources.",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "Your enemy markings have bounty value. Anyone on ally team who eliminates a marked enemy will earn [FFB300]{0} in-match currency[-]. You will earn an extra [FFB300]100[-] for eliminating an enemy. Receive extra [FFB300]{1} FF Coins[-] from Coin Machines in BR matches.",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "Money Mark",
  T_41_CJ_A_ESPORTS_TH: "FFTC The Pro (Mask)",
  T_41_CJ_B_ESPORTS_TH: "FFTC The Pro (Bottom)",
  T_41_CJ_H_ESPORTS_TH: "FFTC The Pro (Head)",
  T_41_CJ_S_ESPORTS_TH: "FFTC The Pro (Shoes)",
  T_41_CJ_T_ESPORTS_TH: "FFTC The Pro (Top)",
  T_41_CJ_T_FFSI: "FFSI Champion Jersey",
  T_41_CJ_T_FOOTBALL_EU01: "Sunburst Jersey",
  T_41_CJ_T_FOOTBALL_EU02: "Bold Red Jersey",
  T_41_CJ_T_FOOTBALL_EU03: "Majestic Crown Jersey",
  T_41_CJ_T_FOOTBALL_EU04: "Regal Titan Jersey",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "Suzy",
  T_41_LXW_TabName_Items: "Item",
  T_41_R_CD_COIL: "Zone Shrink",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "Whether to activate this device",
  T_41_SJ_WS_SPECIALITEM_NAME: "Device",
  T_41_SW_SKILL_DESC_DELIVERY: "When hit by an enemy from within [FFB300]{0}m[-], said attacker is marked for [FFB300]{1}s[-] (intel is shared with teammates). Max. [FFB300]{2} markings[-].",
  T_41_SW_SKILL_DESC_GANGLEADER: "Get [FFB300]{0} extra Shield Points[-] at the start of the match. Recovers Shield Points after surviving combat.",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "When using an active skill, gives [FFB300]{1} Shield Points[-] to self and teammates within [FFB300]{0}m[-]. The Shield Points decay after [FFB300]{2}s[-], after which players can obtain the effects again. Cooldown: [FFB300]{3}s[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "Deployed Gloo Walls restore [FFB300]{0}[-] durability per second when hit, during which teammates within [FFB300]{1}m[-] restore [FFB300]{2} HP/s[-]. Max. [FFB300]{3} HP[-] per teammate from each Gloo Wall.",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "Pet Skin: Recollective Kactus",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "Pet Skin: Inked Falco",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "Type",
  T_41_WT_SKILL_DESC_FIREBOY: "Deploys a [FFB300]{1}m[-]-wide flaming screen that lasts [FFB300]{0}s[-] and moves forward at [FFB300]{2}m/s[-] for up to [FFB300]{3}s[-]. While in effect, use the skill again to stop the screen. [FFB300]Enemies (or Gloo Walls)[-] that get in touch with it will instantly take [FFB300]{4} (or {5}) DMG[-], and then take [FFB300]{6} (or {7}) DMG/s[-]. Lasts [FFB300]{8}s[-]. Cooldown: [FFB300]{9}s[-]. Up to [FFB300]{10}[-] skill uses can be stored, with a [FFB300]{11}s[-] cooldown between each use.",
  T_41_WT_SKILL_NAME_FIREBOY: "Flame Mirage",
  T_41_WZY_WS_CHARGEMAX: "Max. Gloo Maker charge",
  T_41_WZY_WS_CROSSBOWNAME: "Crossbow",
  T_41_WZY_WS_DECELERATIONRATIO: "Deceleration % in water",
  T_41_WZY_WS_DEICEWALLPARAM1: "Radius of melt area",
  T_41_WZY_WS_DEICEWALLPARAM2: "Duration of melt",
  T_41_WZY_WS_EXPPERCHIP: "EXP from Gloo Chip",
  T_41_WZY_WS_EXPPERDAMAGE: "EXP from dealing DMG",
  T_41_WZY_WS_EXPPERMOVEMILE: "EXP from each meter traveled",
  T_41_WZY_WS_EXPPERSECOND: "EXP per second",
  T_41_WZY_WS_GRENADEEXPTIME: "Explosion delay",
  T_41_WZY_WS_GRENADELAUNCHNAME: "Explosives",
  T_41_WZY_WS_GRENADEMAX: "Maximum DMG",
  T_41_WZY_WS_GRENADEMIN: "Minimum DMG",
  T_41_WZY_WS_GRENADERANGE: "Explosion range",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "DMG coefficient on vehicles",
  T_41_WZY_WS_GRENADERATIOSELF: "DMG coefficient on self",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "DMG coefficient on teammates",
  T_41_WZY_WS_GRENADTHROWSPEED: "Explosive travel speed",
  T_41_WZY_WS_HANDCANNONNAME: "Hand Cannon",
  T_41_XXJ_WS_ACCELERATION: "Acceleration",
  T_41_XXJ_WS_ACCELERATION_D: "Create a designated acceleration effect",
  T_41_XXJ_WS_ACTION: "Action node",
  T_41_XXJ_WS_ACTION_D: "Action Pivot",
  T_41_XXJ_WS_ADDHP: "Healing Items",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "Add max. HP",
  T_41_XXJ_WS_AICASTSKILL_D: "AI release skill",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "Aim assist center offset",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "Aim assist distance",
  T_41_XXJ_WS_AIMASSISTENTITY: "Aim assist entity",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "Entity that can be aim assisted",
  T_41_XXJ_WS_AISKILLTYPE: "Zombie skill type",
  T_41_XXJ_WS_AISKILLTYPE_D: "Zombie skill type",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "All items",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "All items",
  T_41_XXJ_WS_AMMOCLIPSIZE: "Modify magazine size",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "Bullets in the magazine",
  T_41_XXJ_WS_ANCHORPOSITION_D: "The anchor coordinates in relation to the parent",
  T_41_XXJ_WS_ANGLE_D: "The z axis rotation angle",
  T_41_XXJ_WS_ANGULARDRAG: "Angular drag",
  T_41_XXJ_WS_ANGULARVELOCITY: "Angular velocity",
  T_41_XXJ_WS_ANIMATIONCLIP: "Animation state",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "Animation Controller",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "Animation entity",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "The file and resource used to manage the animation controller",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "Animation controller resource UUID",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "Loop type enum",
  T_41_XXJ_WS_ANIMATIONSTATE: "Animation state",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "Operation, where all types of value assignment are supported, and digital types also support self-increment, self-subtraction, self-multiplication, and self-division",
  T_41_XXJ_WS_ATTACHMENT: "Attachment",
  T_41_XXJ_WS_ATTACHMENT_D: "Attachment",
  T_41_XXJ_WS_ATTACHTARGET: "Linked entity",
  T_41_XXJ_WS_BAG: "Backpack",
  T_41_XXJ_WS_BAG_D: "Backpack Component",
  T_41_XXJ_WS_BANNERID: "Banner ID",
  T_41_XXJ_WS_BANNERID_D: "Banner ID",
  T_41_XXJ_WS_BEHAVIOURTREE: "Behavior tree",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "Behavior Tree",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "Behavior-mountable tree entity",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "A behavior tree entity that can be mounted",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "Behavior tree custom node",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "Behavior Tree Custom Pivot",
  T_41_XXJ_WS_BODY: "Body",
  T_41_XXJ_WS_BORDERLR: "Border (left & right)",
  T_41_XXJ_WS_BORDERLR_D: "The left and right border",
  T_41_XXJ_WS_BORDERTB: "Border (top & bottom)",
  T_41_XXJ_WS_BORDERTB_D: "The top and bottom border",
  T_41_XXJ_WS_BRPEAKRANK: "Highest BR rank",
  T_41_XXJ_WS_BRPEAKRANK_D: "Highest BR rank",
  T_41_XXJ_WS_BRRANK: "BR rank",
  T_41_XXJ_WS_BRRANK_D: "BR Rank",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "Behavior tree node type",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "Behavior Tree Pivot Type",
  T_41_XXJ_WS_BTREE: "Behavior tree",
  T_41_XXJ_WS_BTREENODESTATE: "Behavior tree node state",
  T_41_XXJ_WS_BTREENODESTATE_D: "Behavior Tree Pivot Operating Status",
  T_41_XXJ_WS_BUFFABLEENTITY: "Buff-enabled entity",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "Enables adding buffs, removing buffs, and getting added buff lists",
  T_41_XXJ_WS_BUILDINGICEWALL: "Gloo Wall",
  T_41_XXJ_WS_CAMOUFLAGE: "Functional items",
  T_41_XXJ_WS_CAMOUFLAGE_D: "Skyboard, Camouflage...",
  T_41_XXJ_WS_CAPICITY_D: "Initial Capacity",
  T_41_XXJ_WS_CENTERINVISIBLE: "Invisible to center",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "Not visible to center",
  T_41_XXJ_WS_COLOR: "Color",
  T_41_XXJ_WS_COLOR_D: "The color",
  T_41_XXJ_WS_CONDITION: "Condition node",
  T_41_XXJ_WS_CONDITION_D: "Conditions are a special Boolean type",
  T_41_XXJ_WS_CONDITION1_D: "Condition Pivot",
  T_41_XXJ_WS_CONSTRAIN: "RigidBody constraint",
  T_41_XXJ_WS_CONSTRAIN_D: "Add constraints to the RigidBody. This is a compilation of RigidBody Constraint Type.",
  T_41_XXJ_WS_COUNT_D: "Amount",
  T_41_XXJ_WS_CROSSBOW_D: "Crossbow",
  T_41_XXJ_WS_CSPEAKRANK: "Highest CS rank",
  T_41_XXJ_WS_CSPEAKRANK_D: "Highest CS rank",
  T_41_XXJ_WS_CSRANK: "CS rank",
  T_41_XXJ_WS_CSRANK_D: "CS Rank",
  T_41_XXJ_WS_CSVNAME_D: "The csv file under SceneData that corresponds to the mode. Ends in .csv. Headers are written in lower case letters.",
  T_41_XXJ_WS_CURCAPACITY: "Used capacity",
  T_41_XXJ_WS_CURPROGRESS: "Current progress",
  T_41_XXJ_WS_CURRENTCLIP: "Current clip",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "Current clip progress",
  T_41_XXJ_WS_CURRENTSTATE: "Current state",
  T_41_XXJ_WS_CUSTOMHUDID: "Custom HUD ID",
  T_41_XXJ_WS_CUSTOMHUDID_D: "The ID used to describe a custom HUD asset",
  T_41_XXJ_WS_DASHATTACK: "Dash attack",
  T_41_XXJ_WS_DEBUG: "Start debugging",
  T_41_XXJ_WS_DEBUG_D: "Fix",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "Deceleration %: The deceleration when an object is in the water (range temporarily set as 0-100)",
  T_41_XXJ_WS_DEPTH_D: "The depth",
  T_41_XXJ_WS_DRAG: "Drag coefficient",
  T_41_XXJ_WS_DRAG_D: "The larger the coefficient, the faster the movement speed deceleration",
  T_41_XXJ_WS_DUMMY: "Dummy",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "Enable low-graphics mode",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "When low fps is on, the game will run on 15 fps; or else 30 fps",
  T_41_XXJ_WS_ENTITYLIST: "Return entity list created",
  T_41_XXJ_WS_ENTITYNAME: "Object name",
  T_41_XXJ_WS_ENTITYNAME_D: "The object name customized by the player",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "Logical Entity or Prefab ID",
  T_41_XXJ_WS_EQUIPANDBAG: "Armor and Backpack",
  T_41_XXJ_WS_EQUIPMENTSLOT: "Equipment slot enum",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "Equipment Slot Enum",
  T_41_XXJ_WS_EXPLODE: "Self-explode",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "Explosive Weapon",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "Auto reload speed",
  T_41_XXJ_WS_FILEID: "Internal ID",
  T_41_XXJ_WS_FILEID_D: "The internal ID of the control in the prefab",
  T_41_XXJ_WS_FILLAMOUNT: "Fill amount",
  T_41_XXJ_WS_FILLAMOUNT_D: "The fill value",
  T_41_XXJ_WS_FILLDIR: "Fill direction",
  T_41_XXJ_WS_FILLDIR_D: "The direction of the fill",
  T_41_XXJ_WS_FILLDIR_D1: "Fill direction enum",
  T_41_XXJ_WS_FILLTYPE: "Fill type",
  T_41_XXJ_WS_FILLTYPE_D: "The fill type",
  T_41_XXJ_WS_FILLTYPE_D1: "Fill type enum",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "Find path",
  T_41_XXJ_WS_FINISH: "Complete",
  T_41_XXJ_WS_FIREINTERVAL: "Firing interval",
  T_41_XXJ_WS_FIREINTERVAL_D: "Attack Interval",
  T_41_XXJ_WS_FLIP: "Flip method",
  T_41_XXJ_WS_FLIP_D: "The flip method",
  T_41_XXJ_WS_FLYBOMBBEE: "Flying Zombie",
  T_41_XXJ_WS_FORCE: "Force",
  T_41_XXJ_WS_FORCE_D: "Create a force of a designated intensity",
  T_41_XXJ_WS_FORCETYPE: "Force type",
  T_41_XXJ_WS_FORCETYPE_D: "The different types of forces on the RigidBody. P.S. Only effective on dynamic RigidBody types.",
  T_41_XXJ_WS_FREEZEALL: "Freeze movement and rotation",
  T_41_XXJ_WS_FREEZEPOSITION: "Freeze linear movement",
  T_41_XXJ_WS_FREEZEPOSITIONX: "Freeze x axis",
  T_41_XXJ_WS_FREEZEPOSITIONY: "Freeze y axis",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "Freeze z axis",
  T_41_XXJ_WS_FREEZEROTATION: "Freeze all rotation",
  T_41_XXJ_WS_FREEZEROTATIONX: "Freeze x rotation",
  T_41_XXJ_WS_FREEZEROTATIONY: "Freeze y rotation",
  T_41_XXJ_WS_FREEZEROTATIONZ: "Freeze z rotation",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "Distance for max. damage",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "Distance for max. damage",
  T_41_XXJ_WS_GAMEID_D: "Mission ID",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "Give a Metropolis item",
  T_41_XXJ_WS_GRADIENT: "Gradient",
  T_41_XXJ_WS_GRADIENT_D: "The gradient",
  T_41_XXJ_WS_GRADIENTBOTTOM: "Gradient at bottom",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "The gradient at the bottom",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "Transparency at bottom",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "Bottom Transparency",
  T_41_XXJ_WS_GRADIENTTOP: "Gradient at top",
  T_41_XXJ_WS_GRADIENTTOP_D: "The gradient at the top",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "Transparency at top",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "Top Transparency",
  T_41_XXJ_WS_GRAPHID: "Script ID",
  T_41_XXJ_WS_GRAPHID_D: "The ID used to describe a script asset",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "Gloo Melter Component",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "Explosion Delay",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "Throwable",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "Max. DMG",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "Min. DMG",
  T_41_XXJ_WS_GRENADERANGE_D: "Explosion Range",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "Self DMG multiplier",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "Ally DMG multiplier",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "Vehicle DMG multiplier",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "Throwing Speed",
  T_41_XXJ_WS_GRENADEWEAPON: "Throwable category",
  T_41_XXJ_WS_GRENADEWEAPON_D: "Basic Throwable Types",
  T_41_XXJ_WS_HANDCANNON_D: "Throwables",
  T_41_XXJ_WS_HEAD: "Head",
  T_41_XXJ_WS_HEADID: "Avatar ID",
  T_41_XXJ_WS_HEADID_D: "Avatar ID",
  T_41_XXJ_WS_HEAVYWEAPON_D: "Heavy Weapon",
  T_41_XXJ_WS_HELMET_D: "The current helmet",
  T_41_XXJ_WS_HELMET1_D: "Helmet",
  T_41_XXJ_WS_HELMET2_D: "Helmet Entity",
  T_41_XXJ_WS_HITBODYPART_D: "The body part that is hit",
  T_41_XXJ_WS_HITBPDYPART: "Hit body part",
  T_41_XXJ_WS_HITENTITY_D: "Hit Entity",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "The HUD entity it belongs to",
  T_41_XXJ_WS_HUD3DCONTAINER: "3D content container",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "The HUD 3D container entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDGRID: "Custom Layout(Panel) control",
  T_41_XXJ_WS_HUDLAYOUT: "Layout control",
  T_41_XXJ_WS_HUDLAYOUT_D: "The HUD insertion entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDPROFILEINFO: "Custom avatar control",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "The HUD profile info entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDTEXTURE: "Texture control",
  T_41_XXJ_WS_HUDTEXTURE_D: "The HUD texture entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDTRANSFORM: "UITransform control component",
  T_41_XXJ_WS_HUDTRANSFORM_D: "The UITransform control entity",
  T_41_XXJ_WS_IMPULSE: "Strike",
  T_41_XXJ_WS_IMPULSE_D: "Create a strike of a designated intensity",
  T_41_XXJ_WS_INITIALWORLDPOS: "Initial world coordinates",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "Buff enum",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "Corresponds to the ID column in the BuffData.csv. Before adding new content, please first check compatability with GPP.",
  T_41_XXJ_WS_INVERTFILL: "Invert fill",
  T_41_XXJ_WS_INVERTFILL_D: "Invert the fill",
  T_41_XXJ_WS_ISLOOP: "Is loop",
  T_41_XXJ_WS_ISLOOP_D: "Whether or not to loop. Default is false.",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "Static NavMesh generation",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "Only used to check for static NavMesh generation when static loading objects",
  T_41_XXJ_WS_ISSUCCESS_D: "Destructed or not",
  T_41_XXJ_WS_ITEMENTITY_D: "Item Entity",
  T_41_XXJ_WS_ITEMID: "Item ID",
  T_41_XXJ_WS_ITEMID_D: "Item ID",
  T_41_XXJ_WS_ITEMID_D1: "The corresponding item ID of the attachment",
  T_41_XXJ_WS_ITEMLIST: "Item list",
  T_41_XXJ_WS_ITEMTYPE_D: "Item Type",
  T_41_XXJ_WS_JUMPATTACK: "Jump attack",
  T_41_XXJ_WS_LANDMINE: "Landmine",
  T_41_XXJ_WS_LENGTH: "Clip length",
  T_41_XXJ_WS_LENGTH_D: "The length of the progress bar. The default value is the length on the prefab UI.",
  T_41_XXJ_WS_LIMB: "Limbs",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "Failed to add element since list length has exceeded capacity",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "Buff list",
  T_41_XXJ_WS_LOOP: "Loop",
  T_41_XXJ_WS_LOOP_D: "Loop",
  T_41_XXJ_WS_MAXCAPACITY: "Capacity",
  T_41_XXJ_WS_MAXCAPACITY_D: "The backpack capacity",
  T_41_XXJ_WS_MAXPROGRESS: "Max. progress",
  T_41_XXJ_WS_MELEEWEAPON_D: "Melee Weapon",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "Distance for min. damage",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "Distance for min. damage",
  T_41_XXJ_WS_MINISENTRY: "Auto Turret",
  T_41_XXJ_WS_NAME: "Name",
  T_41_XXJ_WS_NAME_D: "The name of the skill button. Used for parameter sending during OnClick incidents, so uniqueness must be guaranteed.",
  T_41_XXJ_WS_NAME1_D: "Merchandise Name",
  T_41_XXJ_WS_NAME2_D: "Merchandise List Name",
  T_41_XXJ_WS_NAME3_D: "Vending Machine Name",
  T_41_XXJ_WS_NICKNAME: "Nickname",
  T_41_XXJ_WS_NICKNAME_D: "Player Name",
  T_41_XXJ_WS_NOCHANGE: "No changes",
  T_41_XXJ_WS_NONE: "No constraints",
  T_41_XXJ_WS_NONE1: "None",
  T_41_XXJ_WS_OFFSET: "Offset",
  T_41_XXJ_WS_OFFSET_D: "Offset",
  T_41_XXJ_WS_OFFSET1_D: "Written Offset Value",
  T_41_XXJ_WS_ONCE: "Once",
  T_41_XXJ_WS_ONCE_D: "Once",
  T_41_XXJ_WS_ONHIDE: "When interface is closed",
  T_41_XXJ_WS_ONHIDE_D: "When the interface is closed",
  T_41_XXJ_WS_ONNODEENTER_D: "When the pivot is entering",
  T_41_XXJ_WS_ONSHOW: "When interface is open",
  T_41_XXJ_WS_ONSHOW_D: "When the interface is open",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "Triggers when the text box has changed",
  T_41_XXJ_WS_PERSONALUAV: "UAV-Lite",
  T_41_XXJ_WS_PINID: "Pin ID",
  T_41_XXJ_WS_PINID_D: "Pin ID",
  T_41_XXJ_WS_PLAYERBAG: "Player backpack entity",
  T_41_XXJ_WS_PLAYERBAG_D: "The player's backpack entity",
  T_41_XXJ_WS_PLAYERBAGENTITY: "Player backpack",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "Player's backpack",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "Modified coefficient of speed while scoped in",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "Impact of movement speed while firing",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "Impact of movement speed while firing",
  T_41_XXJ_WS_PREFABID: "Prefab ID",
  T_41_XXJ_WS_PREFABID_D: "The ID used to describe a prefab asset",
  T_41_XXJ_WS_PREFABID1_D: "The HUD template entity that this ID represents",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "Main Weapon 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "Main Weapon 2",
  T_41_XXJ_WS_PROFILEINFO: "Player profile",
  T_41_XXJ_WS_PROFILEINFO_D: "Player bio",
  T_41_XXJ_WS_PROGRESSICON_D: "The progress icon",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "Progress icon name",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "Quit the Metropolis minigame",
  T_41_XXJ_WS_RANGE: "Firing range",
  T_41_XXJ_WS_RANGE_D: "Attack Range",
  T_41_XXJ_WS_RANGE_D1: "Explosion Range",
  T_41_XXJ_WS_RANGE_D2: "Turret Range",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "Read the content on the entire table. Return a two-dimensional array.",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "Read the content of a certain cell",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "Read a certain column's content. Returns an array.",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "Read a certain row's content. Returns an array.",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "Read accumulated database",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "Read the value corresponding to a key in a table in the accumulated database",
  T_41_XXJ_WS_RECOVERPLAYERHP: "Continuously recover HP",
  T_41_XXJ_WS_RELOADSPEED: "Reload speed",
  T_41_XXJ_WS_RELOADSPEED_D: "Reload Speed (Basic Speed x Multiplier)",
  T_41_XXJ_WS_RESOURCEID: "Resource UUID",
  T_41_XXJ_WS_RESOURCEID_D: "Resource UUID",
  T_41_XXJ_WS_RESUUID: "Resource ID",
  T_41_XXJ_WS_RESUUID_D: "The designated resource UUID to render",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "RigidBody constraint type",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "Each constraint is defined by a bit marking and can be used as a combination",
  T_41_XXJ_WS_ROTATION: "Rotation",
  T_41_XXJ_WS_ROTATION_D: "The rotation angle in the world coordinates. x, y, z refers to the yaw, pitch, and roll, respectively.",
  T_41_XXJ_WS_ROTATION1_D: "The rotation",
  T_41_XXJ_WS_RUNNING: "Running",
  T_41_XXJ_WS_SCALE: "Scale",
  T_41_XXJ_WS_SCALE_D: "Scale",
  T_41_XXJ_WS_SCALE1_D: "Scales along a certain axis. Can be a combination of three axes.",
  T_41_XXJ_WS_SCATTERMAX: "Max. bullet scatter",
  T_41_XXJ_WS_SCATTERMAX_D: "The value at which bullet spread begins",
  T_41_XXJ_WS_SCATTERMOVE1: "Spread size when moving",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "Speed of spread recovery",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "Speed of spread recovery",
  T_41_XXJ_WS_SCATTERSPEED: "Speed of spread increase",
  T_41_XXJ_WS_SCATTERSPEED_D: "Speed of spread increase (0.1 = The crosshair enlarges 10% for every one burst increase)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "Less spread on prone and crouch",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "Secondary Weapon",
  T_41_XXJ_WS_SHADERNAME: "Shader name",
  T_41_XXJ_WS_SHADERNAME_D: "The shader name",
  T_41_XXJ_WS_SHIELDBROKEN: "Shield-shatter attack",
  T_41_XXJ_WS_SHIELDUP: "Shield attack",
  T_41_XXJ_WS_SHOCKWAVE: "Shockwave",
  T_41_XXJ_WS_SHOWNAME: "Display nickname",
  T_41_XXJ_WS_SHOWNAME_D: "Display Nickname",
  T_41_XXJ_WS_SHOWPIN: "Display pin",
  T_41_XXJ_WS_SHOWPIN_D: "Display Pin",
  T_41_XXJ_WS_SHOWRANK: "Display rank",
  T_41_XXJ_WS_SHOWRANK_D: "Display Rank",
  T_41_XXJ_WS_SHOWTYPE: "Design",
  T_41_XXJ_WS_SHOWTYPE_D: "Type",
  T_41_XXJ_WS_SHRINKSPEED: "Shrink speed",
  T_41_XXJ_WS_SIGHTAIMASSIST: "Enable aim assist on scope",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "Aim assist crosshair sensitivity with distance (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "Coefficient when prioritizing distance for aim assist (≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "Max. distance to prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "Min. distance to prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "Prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "Aim assist crosshair sensitivity (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "Scope zoom in factor",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "FOV zoom in factor",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "Scope rotation sensitivity coefficient",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "Modified coefficient x of min. scoped in DMG",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "Scoped in firing UI zoom in time (s)",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "Scoped in firing UI zoom in factor",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "Scoped in firing UI resume time (s)",
  T_41_XXJ_WS_SPEED: "Playback speed",
  T_41_XXJ_WS_SPEEQUIP: "Functional equipment",
  T_41_XXJ_WS_SPEITEM: "Devices",
  T_41_XXJ_WS_STATICGRAPHID: "Static script ID",
  T_41_XXJ_WS_STATICGRAPHID_D: "The ID used to describe a static script asset",
  T_41_XXJ_WS_STATICWAINING: "Failed to modify static Rigidbody type",
  T_41_XXJ_WS_TARGETTREE: "Behavior tree entity",
  T_41_XXJ_WS_TARGETTREE_D: "The behavior tree entity",
  T_41_XXJ_WS_TEAMINDEX: "Team serial no.",
  T_41_XXJ_WS_TEAMINDEX_D: "The team index, which coincides with the team index in the room",
  T_41_XXJ_WS_TEAMINDEX_D1: "Team Faction Number",
  T_41_XXJ_WS_TEMPLATEPREFABID: "Template prefab ID",
  T_41_XXJ_WS_TEXT_D: "Content",
  T_41_XXJ_WS_TEXTURENAME: "Texture name",
  T_41_XXJ_WS_TEXTURENAME_D: "The texture name",
  T_41_XXJ_WS_THROWATTACK: "Grenade",
  T_41_XXJ_WS_TICKINTERVAL: "Refresh interval",
  T_41_XXJ_WS_TICKINTERVAL_D: "Refresh interval. The larger the number, the longer the refresh takes.",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "Enable special devices in the player's backpack",
  T_41_XXJ_WS_UVRECTWH: "UV width & height",
  T_41_XXJ_WS_UVRECTWH_D: "The UV width and height",
  T_41_XXJ_WS_UVRECTXY: "UV offset",
  T_41_XXJ_WS_UVRECTXY_D: "The UV offset",
  T_41_XXJ_WS_VELOCITY: "Velocity",
  T_41_XXJ_WS_VELOCITY_D: "Refrain from directly changing the RigidBody's speed. You may change it using related APIs.",
  T_41_XXJ_WS_VEST_D: "The current vest",
  T_41_XXJ_WS_VEST1_D: "Vest",
  T_41_XXJ_WS_WIDGETID: "Control ID",
  T_41_XXJ_WS_WIDGETID_D: "The ID used to describe a control in the interface assets. It must be paired with a custom HUD ID in order to ensure that it corresponds to a unique control ID.",
  T_41_XXJ_WS_WINDATTACK: "Tornado attack",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "Write accumulated database offset",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "Write the offset corresponding to a key in a table in the accumulated database",
  T_41_XXJ_WS_ZONEDURATION_D: "Freeze duration",
  T_41_XXJ_WS_ZONEDURATION1_D: "Gloo Melter Duration",
  T_41_XXJ_WS_ZONERADIUS_D: "Freeze zone radius",
  T_41_XXJ_WS_ZONERADIUS1_D: "Gloo Melter Radius",
  T_41_XYL_WS_BOT12: "Earth Driller",
  T_41_XYL_WS_BOT9: "Mutated Tossing Zombie",
  T_41_XYL_WS_ITEM262: "Frozen Steel Panel A",
  T_41_XYL_WS_ITEM263: "Frozen Container A",
  T_41_XYL_WS_ITEM264: "Frozen Supply Container",
  T_41_XYL_WS_ITEM265: "Frozen Metal Gate",
  T_41_XYL_WS_ITEM266: "Frozen Container B",
  T_41_XYL_WS_ITEM267: "Frozen Stone A",
  T_41_XYL_WS_ITEM268: "Frozen Stone B",
  T_41_XYL_WS_ITEM269: "Frozen Stone C",
  T_41_XYL_WS_ITEM270: "Frozen Stone D",
  T_41_XYL_WS_ITEM271: "Abandoned Subway Car",
  T_41_XYL_WS_MODELMATCHNAME: "Contest Canvas",
  T_41_XYL_WS_NAVMESH: "Dynamic navmesh",
  T_41_XYL_WS_REFCUBE: "Reflective Cube",
  T_41_XYL_WS_SNOWSKY: "Frost Galaxy",
  T_41_XYL_WS_TOYCUBE: "Play Cube",
  T_42_CJ_F_B_VOCATIONAL: "Gearing Blueprint (Bottom)",
  T_42_CJ_F_H_VOCATIONAL: "Gearing Blueprint (Head)",
  T_42_CJ_F_S_VOCATIONAL: "Gearing Blueprint (Shoes)",
  T_42_CJ_F_T_VOCATIONAL: "Gearing Blueprint (Top)",
  T_42_CJ_HA_THUNDER_GOLD: "Lightning Facepaint",
  T_42_CJ_M_B_VOCATIONAL: "Mechanic Masterplan (Bottom)",
  T_42_CJ_M_H_VOCATIONAL: "Mechanic Masterplan (Head)",
  T_42_CJ_M_S_VOCATIONAL: "Mechanic Masterplan (Shoes)",
  T_42_CJ_M_T_VOCATIONAL: "Mechanic Masterplan (Top)",
  T_42_H_CHARACTER_SUPERTEEN_N: "Ignis",
  T_42_H_GLOO_EVOTIGER_N: "Gloo Wall - Tiger's Fury",
  T_42_H_GRENADE_SMUDGE_N: "Grenade - Feline Shadow",
  T_42_H_M1917_EMPIRE_N: "M1917 - Crowned Conqueror",
  T_42_HJ_WS_VFX_INK: "Ink",
  T_42_JH_WS_BANMATCHMAKING: "Matchmaking not allowed for this map",
  T_42_JH_WS_BANROOMCREATE: "Unable to create a room",
  T_42_JH_WS_FPS: "FPS",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "Party Remix (Alok)",
  T_42_JH_WS_SKILLSETFIREWALL: "Wall of Flame (Ignis)",
  T_42_JH_WS_SKILLSETSANTINO: "Shape Splitter (Santino)",
  T_42_JH_WS_SKILLSETSONIA: "Nano Lifeshield (Sonia)",
  T_42_JH_WS_TAG1: "Frost Brawl",
  T_42_JH_WS_TAG10: "Infinity Racer",
  T_42_JH_WS_TAG11: "Race Rush",
  T_42_JH_WS_TAG12: "Car Racing",
  T_42_JH_WS_TAG13: "Exclude from Popular",
  T_42_JH_WS_TAG14: "Frontline",
  T_42_JH_WS_TAG15: "Zombie War",
  T_42_JH_WS_TAG16: "Legacy Legend",
  T_42_JH_WS_TAG2: "Social Island 1.0",
  T_42_JH_WS_TAG3: "Social Island 2.0",
  T_42_JH_WS_TAG4: "Play Together",
  T_42_JH_WS_TAG5: "Ruin Survivor",
  T_42_JH_WS_TAG6: "Preying Party",
  T_42_JH_WS_TAG7: "Preying Party",
  T_42_JH_WS_TAG8: "Fort Feud 2.0",
  T_42_JH_WS_TAG9: "Bounty Hunting",
  T_42_RW_PORTALSFORPERSONAL_DESC: "Place a portal anywhere and teleport away!",
  T_42_RW_PORTALSPERSONAL_NAME: "Portal Go",
  T_42_SJ_WS_ACCESSORIESITEM: "Equip attachment",
  T_42_SJ_WS_AUTOPLAY: "Auto play",
  T_42_SJ_WS_CLIMB: "Climb over",
  T_42_SJ_WS_CLOCK_EVENTS: "Event compilation",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "Countdown or not",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "Loops",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "Pause event",
  T_42_SJ_WS_CLOCK_START_EVENT: "Start event",
  T_42_SJ_WS_CLOCK_START_TIME: "Countdown start time",
  T_42_SJ_WS_CLOCK_STATE: "Stopwatch status",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "Stop event",
  T_42_SJ_WS_DAMRATIOHEAD: "Headshot DMG coefficient change",
  T_42_SJ_WS_DAMRATIOLIMB: "Limb DMG coefficient change",
  T_42_SJ_WS_DAMREDUCEXPLODE: "Reduction coefficient from explosive DMG",
  T_42_SJ_WS_DRIVE: "Drive",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "Display layers",
  T_42_SJ_WS_EXTRABAGCAPACITY: "Extra backpack capacity",
  T_42_SJ_WS_EXTRAHPRATIO: "HP ratio",
  T_42_SJ_WS_GETOFF_DRIVE: "Exit vehicle",
  T_42_SJ_WS_GETON_DRIVE: "Enter vehicle",
  T_42_SJ_WS_KNIFEITEM: "Dagger",
  T_42_SJ_WS_KNIFEITEMPICK: "Dagger (ground loot)",
  T_42_SJ_WS_MARKBTNHUD: "The pin button on the HUD",
  T_42_SJ_WS_MARKBTNHUD_D: "You can enable or disable the pin button",
  T_42_SJ_WS_MAXDISTANCE: "Max. distance",
  T_42_SJ_WS_MAXDURARATIO: "Max. durability ratio",
  T_42_SJ_WS_MICBTNHUD: "The mic switch on the HUD",
  T_42_SJ_WS_MICBTNHUD_D: "You can enable or disable the mic button",
  T_42_SJ_WS_MINDISTANCE: "Min. distance",
  T_42_SJ_WS_OPE_VEHICLE: "Operate vehicle",
  T_42_SJ_WS_PLANE_DESC: "A basic mesh whose size can be freely adjusted",
  T_42_SJ_WS_PLANENAME: "Basic Plane",
  T_42_SJ_WS_PRIORITY: "Priority",
  T_42_SJ_WS_REPLACEPRIORITY: "Replace priority",
  T_42_SJ_WS_SETBTNHUD: "The settings button on the HUD",
  T_42_SJ_WS_SETBTNHUD_D: "You can enable or disable the settings button",
  T_42_SJ_WS_SIGNALBTNHUD: "The network connection button on the HUD",
  T_42_SJ_WS_SIGNALBTNHUD_D: "You can enable or disable the network connection button",
  T_42_SJ_WS_SPEAKERBTNHUD: "The horn button on the HUD",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "You can enable or disable the vehicle horn button",
  T_42_SJ_WS_START_TIME: "Start time (s)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "Get an additional [FFB300]{0}[-] backpack capacity for ammo, excluding Grenade Launcher. ([FFB300]{1}[-] AR Ammo, [FFB300]{2}[-] SMG Ammo, [FFB300]{3}[-] Sniper Ammo, [FFB300]{4}[-] SG Ammo)",
  T_42_SW_SKILL_DESC_Bodyguard: "Reload speed increases by [FFB300]{0}%[-]. Every time the skill user hits an enemy, said target will get a [FFB300]{1}%[-] healing deduction that lasts for [FFB300]{3}s[-] (max. deduction: [FFB300]{2}%[-]).",
  T_42_SW_SKILL_DESC_Playboy: "Become immune from disruptive effects (e.g. slowdown, marking, skill-silencing) and have a [FFB300]{1}%[-] movement speed boost for [FFB300]{2}s[-]. Cooldown: [FFB300]{0}s[-].",
  T_42_SW_SKILL_DESC_SwatGuy: "After knocking down an enemy or using an active skill, [FFB300]{0}%[-] of the gun's magazine reloads automatically.",
  T_42_SW_SKILL_NAME_Playboy: "Silver Spoon",
  T_42_SY_BACKPACK_EMPIRE_N: "Backpack - Crowned Roar",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "Pet Skin: Icy Hop",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "Motorbike - Urban Scooter",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Aventador Ultimae Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Aventador Ultimae Grigio Nimbus",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "Veneno Nero Nemesis",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "Veneno Rosso Efesto",
  T_42_TYC_CST_LOSE_MONEY_1: "Amount of CS Cash obtained after losing a round",
  T_42_TYC_CST_LOSE_MONEY_2: "Amount of CS Cash obtained upon a 2-round losing streak",
  T_42_TYC_CST_LOSE_MONEY_3: "Amount of CS Cash obtained upon a 3-round losing streak",
  T_42_WH_ITEM_HEALUAV: "Heal UAV-Lite",
  T_42_WH_ITEM_HEALUAV_DESC: "Deploys a UAV-Lite that flies forward and continuously heals teammates within the range below",
  T_42_WH_ITEM_SKILLCARD: "Skill: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `Use to release the active skill of [ffba00]{0}[-]: [ffba00]{1}[-].
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "Ammo Type",
  T_42_XXJ_WS_AMMOTYPE_D: "Ammo Type",
  T_42_XXJ_WS_ASSETCONFIGID: "Skin ID",
  T_42_XXJ_WS_ASSETCONFIGID_D: "Skin",
  T_42_XXJ_WS_ATTACKSTATUS: "Attack status",
  T_42_XXJ_WS_AUTOPLAY: "Auto play",
  T_42_XXJ_WS_AUTOPLAY_D: "Auto play",
  T_42_XXJ_WS_AVATARABLE: "Modifiable appearance component",
  T_42_XXJ_WS_AVATARABLE_D: "Change appearance according to the parts",
  T_42_XXJ_WS_AVATARRESUUID: "Appearance resource UUID",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "Convert the axis-angle representation of a rotation into Quaternions",
  T_42_XXJ_WS_B_D: "The B color value",
  T_42_XXJ_WS_BASEVALUE_D: "Base of logarithm",
  T_42_XXJ_WS_BEZIERCURVE: "Bézier curve",
  T_42_XXJ_WS_BEZIERCURVE_D: "The Bézier curve",
  T_42_XXJ_WS_BOTDIFFICULTY: "Bot Difficulty",
  T_42_XXJ_WS_BOUNCE_COMBINE: "Combination Method of Bounciness",
  T_42_XXJ_WS_BOUNCINES: "Bounciness",
  T_42_XXJ_WS_BTREEID: "Behavior tree ID",
  T_42_XXJ_WS_BTREEID_D: "Behavior tree ID",
  T_42_XXJ_WS_CANPURCHAS: "Purchasable or Not",
  T_42_XXJ_WS_CANPURCHAS_D: "Purchasable or not",
  T_42_XXJ_WS_CLIMBSTATUS: "Climbing behavior",
  T_42_XXJ_WS_CLOCK: "Timer Object",
  T_42_XXJ_WS_CLOCK_D: "Timer Object",
  T_42_XXJ_WS_CLOCK_D1: "Timer",
  T_42_XXJ_WS_CONTAINER: "Container",
  T_42_XXJ_WS_CONTROLPOINTS: "Control points",
  T_42_XXJ_WS_CONTROLPOINTS_D: "The control points",
  T_42_XXJ_WS_COROUTINEID: "Coroutine handle",
  T_42_XXJ_WS_COROUTINEID_D: "The Coroutine ID refers to the handle of a specific coroutine. It allows for various operations to be performed on the handle.",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "Create a self-relative",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "Create a self-relative",
  T_42_XXJ_WS_CREATESOUND: "Create Sound Effect",
  T_42_XXJ_WS_CREATESOUND_D: "Play the designated sound effect. If there are more properties to set, you can do so by configuring its entity properties.",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "Complete custom mission",
  T_42_XXJ_WS_DAMAGELIST_D: "DMG increment list",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "Headshot DMG ratio",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "Explosion DMG reduction multiplier",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "Default Physics Material",
  T_42_XXJ_WS_DEFAULTFIST_D: "Default fist",
  T_42_XXJ_WS_DELTA: "Delta",
  T_42_XXJ_WS_DELTA_D: "Delta",
  T_42_XXJ_WS_DELTATIME: "Logic frame interval",
  T_42_XXJ_WS_DELTATIME_D: "The interval between the 2 logic frame updates of the GS",
  T_42_XXJ_WS_DEPTH: "Layer",
  T_42_XXJ_WS_DEPTH_D: "Display layers on the icon",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "List of disabled ground loot",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "The list of items that are not ground loot",
  T_42_XXJ_WS_DRIVER: "Driver's seat",
  T_42_XXJ_WS_DRIVINGSTATUS: "Drive",
  T_42_XXJ_WS_DURATION_D1: "The countdown duration in seconds",
  T_42_XXJ_WS_DURATION_D2: "The duration in seconds",
  T_42_XXJ_WS_DURATION_D3: "The duration",
  T_42_XXJ_WS_DURATION_D4: "The duration of invulnerability in seconds",
  T_42_XXJ_WS_DURATIONTIMES: "Time Duration",
  T_42_XXJ_WS_DURATIONTIMES_D: "The duration in seconds",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "Dynamic Friction",
  T_42_XXJ_WS_EASY: "Very Easy",
  T_42_XXJ_WS_ENDTIMES: "End Time",
  T_42_XXJ_WS_ENDTIMES_D: "The end time on the timer in seconds",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "Global Energy Threshold",
  T_42_XXJ_WS_ENTITYVARNAME_D: "The self-relative entity",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "Equip attachment",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "Convert the given Euler angles into Quaternions",
  T_42_XXJ_WS_EXPONENTIATION_D: "Exponentiation",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "Extra backpack capacity",
  T_42_XXJ_WS_FIST: "Fist",
  T_42_XXJ_WS_FONTTYPE: "Font enum",
  T_42_XXJ_WS_FONTTYPE_D: "Font enum",
  T_42_XXJ_WS_FORCESYNCVALUE: "Force sync GS status",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "The force sync value",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "The location info. from the GS force sync",
  T_42_XXJ_WS_FORCESYNCVALUE1: "Location info from force sync",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "An entity that can formulate properties",
  T_42_XXJ_WS_FORWARD_D: "Direction vector",
  T_42_XXJ_WS_FRICTION_COMBINE: "Method of Friction Combination",
  T_42_XXJ_WS_FUNCPOINT: "Function Pointer",
  T_42_XXJ_WS_FUNCPOINT_D: "A pointer that points to an instance of a function. It is used to implement virtual functions or delegate mechanisms.",
  T_42_XXJ_WS_GETMAPID_D: "Get Map ID",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "Exit vehicle",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "Enter vehicle (driver)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "Enter vehicle (passenger)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "Search for today's player token data",
  T_42_XXJ_WS_GRAVITY: "Global Gravity",
  T_42_XXJ_WS_HANDHELDITEM: "Current handheld",
  T_42_XXJ_WS_HANDHELDITEM_D: "The current handheld",
  T_42_XXJ_WS_HARD: "Hard",
  T_42_XXJ_WS_HASCOMPONENT_D: "Whether there exists a component",
  T_42_XXJ_WS_HEIGHTLIST_D: "Height increment list",
  T_42_XXJ_WS_INDEXLIST_D: "Access the index list of the string",
  T_42_XXJ_WS_INSCENE: "In scene",
  T_42_XXJ_WS_INSCENE_D: "In scene",
  T_42_XXJ_WS_IS3D_D: "Whether it is a 3D music",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "Countdown or stopwatch",
  T_42_XXJ_WS_ISLOOP: "Loop or not",
  T_42_XXJ_WS_ISLOOP_D: "The IsLoop command",
  T_42_XXJ_WS_ISREPLAY_D: "Whether or not to start from the beginning",
  T_42_XXJ_WS_ISSWITCH_D: "When set to true, it can be combined with relative motion. When set to false, it can be combined with absolute motion.",
  T_42_XXJ_WS_JEEP: "Jeep",
  T_42_XXJ_WS_JUMPSTATUS: "Jump status",
  T_42_XXJ_WS_LEFTVALUE: "Left Value",
  T_42_XXJ_WS_LEFTVALUE_D: "Base",
  T_42_XXJ_WS_LOGARITHM_D: "Logarithm",
  T_42_XXJ_WS_LOOPABLE: "Loopable",
  T_42_XXJ_WS_LOOPABLE_D: "Loopable",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "Get all keys from the dict",
  T_42_XXJ_WS_MAPVALUE_D: "Target Dict",
  T_42_XXJ_WS_MARKBTNHUD: "The pin button on the HUD",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "The maximum distance",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "The mic switch on the HUD",
  T_42_XXJ_WS_MINDISTANCE_D: "The minimum distance",
  T_42_XXJ_WS_MISSIONID_D: "Mission ID",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "Progress (cannot be a negative number)",
  T_42_XXJ_WS_MODERATE: "Moderate",
  T_42_XXJ_WS_MONSTERTRUCK: "Monster Truck",
  T_42_XXJ_WS_MOTORBIKE: "Motor Bike",
  T_42_XXJ_WS_MOVEMENTSTATUS: "Movement status",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "Multiplication of two quaternions (representing rotation superposition)",
  T_42_XXJ_WS_NORMAL: "Normal",
  T_42_XXJ_WS_OBSOLETE: "Discarded",
  T_42_XXJ_WS_OPENPLAYERVIEW: "Enable player perspective",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "Enable player perspective",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "Weapon Type",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "Weapon Type",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "Prioritize Player Config.",
  T_42_XXJ_WS_PARAMSARRAY: "Parameters Array",
  T_42_XXJ_WS_PARAMSARRAY_D: "Parameters Array is a list of parameters involved in output. It needs to match the number of %v in the format description.",
  T_42_XXJ_WS_PARAMSARRAY_D1: "The list of actual parameters passed to the custom functions.",
  T_42_XXJ_WS_PARTVISABLEMASK1: "Part visibility mask 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "Part visibility mask 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "Part visibility mask 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "Part visibility mask 4",
  T_42_XXJ_WS_PASSENGER1: "Passenger seat 1",
  T_42_XXJ_WS_PASSENGER2: "Passenger seat 2",
  T_42_XXJ_WS_PASSENGER3: "Passenger seat 3",
  T_42_XXJ_WS_PHYMAT: "Physical Material",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "Entity",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "Self-relative motion in each frame",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "Self-relative motion every frame",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "Self-relative motion",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "The self-relative motion",
  T_42_XXJ_WS_PLAYER_D: "The player that needs to enter the vehicle",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "Entity of player behavior property sync",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "The entity of the player behavior property sync",
  T_42_XXJ_WS_PRIORITY_D: "Priority",
  T_42_XXJ_WS_PROPID_D: "The property ID",
  T_42_XXJ_WS_QUATERNION: "Quaternion",
  T_42_XXJ_WS_QUATERNION_D: "Quaternion is a special four-dimensional vector used only to represent a rotation",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "Convert the given Quaternions to axis-angle representation",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "Convert the given Quaternions to Euler angles. If the Quaternions do not meet the standard, return (0,0,0).",
  T_42_XXJ_WS_REPEATTIMES_D: "The number of times played. Default is 1.",
  T_42_XXJ_WS_RESETPLAYABLE_D: "Reset",
  T_42_XXJ_WS_RIGHTVALUE: "Right Value",
  T_42_XXJ_WS_RIGHTVALUE_D: "Power",
  T_42_XXJ_WS_SEATTYPE: "Vehicle seat enum",
  T_42_XXJ_WS_SEPSTR_D: "String used for separation",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "Set player fall DMG",
  T_42_XXJ_WS_SETTINGSBTNHUD: "The settings button on the HUD",
  T_42_XXJ_WS_SHOWPOSITION: "Show Location",
  T_42_XXJ_WS_SHOWPOSITION_D: "Show Location",
  T_42_XXJ_WS_SIGNALICOHUD: "The network connection button on the HUD",
  T_42_XXJ_WS_SIMPLE: "Easy",
  T_42_XXJ_WS_SLERPQUATERNION_D: "Spherical quaternion interpolation from A to B",
  T_42_XXJ_WS_SOUNDENTITY_D: "The sound effect entity represents a sound effect that is being played",
  T_42_XXJ_WS_SPEAKERBTNHUD: "The horn button on the HUD",
  T_42_XXJ_WS_SPLITSTRING_D: "Use a certain string as a delimiter to split the string into a slice",
  T_42_XXJ_WS_SPORTSCAR: "Sports Car",
  T_42_XXJ_WS_SPRINTSTATUS: "Sprint status",
  T_42_XXJ_WS_SRCVAL_D: "The source value",
  T_42_XXJ_WS_STARTTICKCOUNT: "The moment when the GS starts to tick",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "The moment when GS starts to tick",
  T_42_XXJ_WS_STARTTIME_D: "Time of start",
  T_42_XXJ_WS_STARTTIME_D1: "Time of start",
  T_42_XXJ_WS_STATE_D: "A player's status: active, knocked down, or eliminated",
  T_42_XXJ_WS_STATE_D1: "Check whether this sound effect is playing",
  T_42_XXJ_WS_STATIC_FRICTION: "Static Friction",
  T_42_XXJ_WS_STRELEMS_D: "Target string set",
  T_42_XXJ_WS_STRINGFINDAT_D: "Return the final combined string according to the index list",
  T_42_XXJ_WS_STRINGJOIN_D: "Join strings using a specified identifier",
  T_42_XXJ_WS_STRINGLOWER_D: "Convert all characters in the string to lowercase",
  T_42_XXJ_WS_STRINGSTRIP_D: "Remove whitespace characters from both sides of the string",
  T_42_XXJ_WS_STRINGUPPER_D: "Convert all characters in the string to uppercase",
  T_42_XXJ_WS_STYLE_D: "How it is played",
  T_42_XXJ_WS_SUV: "Pickup Truck",
  T_42_XXJ_WS_SWITCH: "Switch",
  T_42_XXJ_WS_SWITCH_D: "When set to true, it can be combined with relative motion. When set to false, it must be combined with absolute motion, otherwise the properties won't take effect correctly.",
  T_42_XXJ_WS_TARGETENTITY_D: "The target entity",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "Team Round Score Banner",
  T_42_XXJ_WS_TEAMSEQ_D: "The team serial number that corresponds to the serial number property of the team entity",
  T_42_XXJ_WS_TEMPORARYSHIELD: "Temporary shield points",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "Temporary shield points",
  T_42_XXJ_WS_TEXT_D: "The original text to perform a profanity filter on",
  T_42_XXJ_WS_THREESTATESWITCH: "3-Status Switch",
  T_42_XXJ_WS_THROWINGKNIFE_D: "Dagger (ground loot)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "Dagger",
  T_42_XXJ_WS_TUKTUK: "Tuk Tuk",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "Teams Match Details",
  T_42_XXJ_WS_UNIQUEID: "Unique ID",
  T_42_XXJ_WS_UNIQUEID_D: "Unique ID",
  T_42_XXJ_WS_VALUE_D: "The value",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "Direction vector to Euler angles",
  T_42_XXJ_WS_VEHICLEID: "Vehicle ID",
  T_42_XXJ_WS_VEHICLESKINID: "Vehicle skin ID",
  T_42_XXJ_WS_VERYHARD: "Very Hard",
  T_42_XXJ_WS_VOLUME_D: "The sound volume. Default is 50.",
  T_42_XXJ_WS_WEAPONTYPE_D: "Weapon's Main Type",
  T_42_XXJ_WS_WORKSHOPCODE: "Map code",
  T_42_XXJ_WS_WORKSHOPCODE_D: "The map code that corresponds to a data in the database",
  T_42_XXJ_WS_WORLDPOSITION: "World coordinates",
  T_42_XXJ_WS_WORLDPOSITION_D: "World coordinates",
  T_42_XYL_WS_ITEM275: "Fuel Tank",
  T_42_XYL_WS_ITEM276: "Sand Bag A",
  T_42_XYL_WS_ITEM277: "Sand Bag B",
  T_42_XYL_WS_ITEM278: "Sand Bag C",
  T_42_XYL_WS_ITEM279: "Sand Bag",
  T_42_XYL_WS_ITEM280: "Double Deck Villa",
  T_42_XYL_WS_ITEM281: "Arms Factory",
  T_42_XYL_WS_ITEM282: "Stone Wall A",
  T_42_XYL_WS_ITEM283: "Stone Wall B",
  T_42_XYL_WS_ITEM284: "Stone Wall C",
  T_42_XYL_WS_ITEM285: "Stone Wall D",
  T_42_XYL_WS_ITEM286: "Military Supply Box A",
  T_42_XYL_WS_ITEM287: "Copper Coin",
  T_42_XYL_WS_ITEM288: "Silver Coin",
  T_42_XYL_WS_ITEM289: "Gold Coin",
  T_42_XYL_WS_ITEM290: "Diamond",
  T_42_XYL_WS_ITEM291: "Diamond Shards",
  T_42_XYL_WS_ITEM292: "Ruby",
  T_42_XYL_WS_ITEM293: "Emerald",
  T_42_XYL_WS_ITEM294: "Sapphire",
  T_42_XYL_WS_ITEM295: "Warning Sign",
  T_42_XYL_WS_ITEM297: "Ruin",
  T_42_XYL_WS_ITEM297TRUE: "Control Device",
  T_42_XYL_WS_ITEM298: "Supply Container B",
  T_42_XYL_WS_ITEM299: "Snow Pile",
  T_42_XYL_WS_ITEM300: "High-Tech Wall A",
  T_42_XYL_WS_ITEM301: "High-Tech Wall B",
  T_42_XYL_WS_ITEM302: "Frozen Stone F",
  T_42_XYL_WS_ITEM303: "Frozen Stone E",
  T_42_XYL_WS_ITEM304: "High-Tech Platform A",
  T_42_XYL_WS_ITEM305: "High-Tech Staircase A",
  T_42_XYL_WS_ITEM306: "Exploration Lamp A",
  T_42_XYL_WS_ITEM307: "Ruin Baffle A",
  T_42_XYL_WS_ITEM308: "Ruin Baffle B",
  T_42_XYL_WS_ITEM309: "Ruin Steel Bracket A",
  T_42_XYL_WS_ITEM310: "Ruin Stone A",
  T_42_XYL_WS_ITEM311: "Ruin Stone B",
  T_42_XYL_WS_ITEM312: "Ruin Stone C",
  T_42_XYL_WS_ITEM313: "Flashlight A",
  T_42_XYL_WS_ITEM314: "Ruin Rebar A",
  T_42_XYL_WS_LOGICALOBJECT: "Logic",
  T_42_XYL_WS_THEMEHIGHTECH: "Futuristic",
  T_42_XYL_WS_THEMEICE: "Icy",
  T_42_XYL_WS_THEMEMILITARY: "Military",
  T_42_XYL_WS_THEMEOBJECTS: "Themed Object",
  T_42_XYL_WS_TIMERCONTINUE: "Timer Resuming Incident",
  T_42_XYL_WS_TIMERCYCLE: "Loop Count",
  T_42_XYL_WS_TIMERDOWN: "Countdown",
  T_42_XYL_WS_TIMEREND: "Timer ending incident",
  T_42_XYL_WS_TIMEREVENT: "Customized Timer Incident",
  T_42_XYL_WS_TIMEREVENT1: "Control Timer",
  T_42_XYL_WS_TIMEREVENT2: "Set Timer Incidents",
  T_42_XYL_WS_TIMERORDER: "Timing Method",
  T_42_XYL_WS_TIMERPAUSE: "Timer Pausing Incident",
  T_42_XYL_WS_TIMERSTART1: "Timer Start Time",
  T_42_XYL_WS_TIMERSTART2: "Timer Starting Incident",
  T_42_XYL_WS_TIMERUP: "Count Up",
  T_42_XYL_WS_TRIGGERTIME_MS: "Trigger Time (in milliseconds)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "A skywing that can hold multiple players.",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "Individual Score",
  T_42_ZZ_GUILDWAR_SCORE: "Score",
  T_43_B_SKILL_DESC_MONKEYGOD: "Transforms into a bush for [FFB300]{1}s[-] . Cooldown: [FFB300]{0}s[-]. Attacking others or being attacked will return Wukong to his original state. CD resets when taking down an enemy.",
  T_43_B_SKILL_DESC_Nanoscientist: "After taking fatal damage, enter an invulnerable and immobile state for [FFB300]{0}s[-]. Then, gain a [FFB300]{1} HP shield[-] that lasts for [FFB300]{2}s[-]. The skill user will be eliminated when the shield disappears. Cooldown: [FFB300]{3}s[-].",
  T_43_B_SKILL_DESC_ORION: "Replaces EP with [FFB300]{0} Crimson Energy[-]. Consumes [FFB300]{1} Crimson Energy[-] to activate its protection, during which you cannot take damage or attack enemies and will absorb [FFB300]{4} HP[-] (ignoring enemy Shield Points) from foes within [FFB300]{3}m[-]. Lasts for [FFB300]{2}s[-], during which your movement speed will decrease by [FFB300]{6}%[-]. Cooldown: [FFB300]{5}s[-].",
  T_43_CJ_F_A_RACER: "Velocity Racer (Mask)",
  T_43_CJ_F_B_RACER: "Velocity Racer (Bottom)",
  T_43_CJ_F_H_RACER: "Velocity Racer (Head)",
  T_43_CJ_F_HA_RACER: "Velocity Racer (Facepaint)",
  T_43_CJ_F_S_RACER: "Velocity Racer (Shoes)",
  T_43_CJ_F_T_RACER: "Velocity Racer (Top)",
  T_43_CJ_M_A_RACER: "Turbo Racer (Mask)",
  T_43_CJ_M_B_MACHINERY: "Turquoise Tech (Bottom)",
  T_43_CJ_M_B_RACER: "Turbo Racer (Bottom)",
  T_43_CJ_M_H_MACHINERY: "Turquoise Tech (Head)",
  T_43_CJ_M_H_RACER: "Turbo Racer (Head)",
  T_43_CJ_M_HA_MACHINERY: "Turquoise Tech (Facepaint)",
  T_43_CJ_M_S_MACHINERY: "Turquoise Tech (Shoes)",
  T_43_CJ_M_S_RACER: "Turbo Racer (Shoes)",
  T_43_CJ_M_T_MACHINERY: "Turquoise Tech (Top)",
  T_43_CJ_M_T_RACER: "Turbo Racer (Top)",
  T_43_H_CHARACTER_GEEK_N: "Ryden",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - Mamba Gnaw",
  T_43_HJ_WS_OPTION8: "Other",
  T_43_HJ_WS_TEXTURE_BAMBOO: "Bamboo",
  T_43_HJ_WS_TEXTURE_BEACH: "Beach",
  T_43_HJ_WS_TEXTURE_BRICK1: "Brick Wall A",
  T_43_HJ_WS_TEXTURE_BRICK2: "Brick Wall B",
  T_43_HJ_WS_TEXTURE_BRICK3: "Brick Wall C",
  T_43_HJ_WS_TEXTURE_CEMENT: "Concrete Floor",
  T_43_HJ_WS_TEXTURE_CEMENT2: "Concrete",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "Crystal",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "Grass A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "Grass B",
  T_43_HJ_WS_TEXTURE_ICE: "Ice Block",
  T_43_HJ_WS_TEXTURE_IRON: "Metal Floor",
  T_43_HJ_WS_TEXTURE_IRON2: "Container",
  T_43_HJ_WS_TEXTURE_LAVA: "Lava",
  T_43_HJ_WS_TEXTURE_MARBLE: "Marble Floor",
  T_43_HJ_WS_TEXTURE_NONE: "Empty",
  T_43_HJ_WS_TEXTURE_STONE: "Stone",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "Tablecloth A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "Tablecloth B",
  T_43_HJ_WS_TEXTURE_WOOD: "Wood",
  T_43_HJ_WS_TEXTURE_WOODEN: "Wooden Floor A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "Wooden Floor B",
  T_43_JH_WS_MAPTAG1: "Newbie-Friendly",
  T_43_JH_WS_MAPTAG10: "Boring new content",
  T_43_JH_WS_MAPTAG11: "Little sense of reward",
  T_43_JH_WS_MAPTAG12: "Reward imbalance",
  T_43_JH_WS_MAPTAG13: "Weak sense of progress",
  T_43_JH_WS_MAPTAG14: "Newbie-Unfriendly",
  T_43_JH_WS_MAPTAG15: "Confusing tutorial",
  T_43_JH_WS_MAPTAG16: "Lack of tutorials",
  T_43_JH_WS_MAPTAG17: "Players quit a lot",
  T_43_JH_WS_MAPTAG18: "Complicated controls",
  T_43_JH_WS_MAPTAG19: "Cluttered UI",
  T_43_JH_WS_MAPTAG2: "Preferred new content",
  T_43_JH_WS_MAPTAG20: "Poor map design",
  T_43_JH_WS_MAPTAG21: "Thrilling Shooter",
  T_43_JH_WS_MAPTAG22: "Fast-paced",
  T_43_JH_WS_MAPTAG23: "Open World",
  T_43_JH_WS_MAPTAG24: "Story-rich",
  T_43_JH_WS_MAPTAG25: "Progression",
  T_43_JH_WS_MAPTAG26: "Sports Simulation",
  T_43_JH_WS_MAPTAG27: "Co-op Mission",
  T_43_JH_WS_MAPTAG28: "Social",
  T_43_JH_WS_MAPTAG29: "Diverse Instances",
  T_43_JH_WS_MAPTAG3: "Active players",
  T_43_JH_WS_MAPTAG30: "Free Exploration",
  T_43_JH_WS_MAPTAG31: "Ranking Challenge",
  T_43_JH_WS_MAPTAG32: "Achievement",
  T_43_JH_WS_MAPTAG33: "Currency Redeem",
  T_43_JH_WS_MAPTAG4: "Well-Designed Map",
  T_43_JH_WS_MAPTAG40: "Numerous rewards",
  T_43_JH_WS_MAPTAG41: "Satisfying progression",
  T_43_JH_WS_MAPTAG42: "Popular Training Grounds",
  T_43_JH_WS_MAPTAG43: "Popular Solo Tower",
  T_43_JH_WS_MAPTAG44: "Popular War Zone",
  T_43_JH_WS_MAPTAG5: "Stuttering",
  T_43_JH_WS_MAPTAG6: "Hard co-op",
  T_43_JH_WS_MAPTAG7: "Buggy",
  T_43_JH_WS_MAPTAG8: "Few updates",
  T_43_JH_WS_MAPTAG9: "Boring in-match events",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "Spider Trap (Ryden)",
  T_43_SJ_WS_AIRDROP_ITEMS: "Drop Items",
  T_43_SJ_WS_AIRDROP_NAME: "Airdrop",
  T_43_SJ_WS_AIRDROP_TIME: "Start Drop Time",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "Drop Items",
  T_43_SJ_WS_ANITRIGGER_AUTO: "Is Auto-Play",
  T_43_SJ_WS_ANITRIGGER_CENTER: "Is Center Position",
  T_43_SJ_WS_ANITRIGGER_CLIP: "Animation Clip ID",
  T_43_SJ_WS_ANITRIGGER_LOOP: "Is Loop",
  T_43_SJ_WS_ANITRIGGER_NAME: "Animation Trigger HUD",
  T_43_SJ_WS_RESET_ROUND: "Reset per Round",
  T_43_SJ_WS_START_DROPTIME: "Start Drop Time (ms)",
  T_43_SJ_WS_TRIGGER_ANIMA: "Animation Trigger",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "Pet Skin: Meow Meow Zasil",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "Motorbike - Incarnational Speed",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "Contains essential battle supplies such as ammo and medical items",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "Supply Box",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "Spawn a [FFB300]{1} HP[-] mannequin that autonomously travels for [FFB300]{0}s[-]. When the mannequin is within [FFB300]{3}m[-], use the skill again to switch positions with it. You can only switch once within [FFB300]{4}s[-], up to [FFB300]{2} time(s)[-] in total. The player who destroys the mannequin will be marked for [FFB300]{5}s[-]. Cooldown: [FFB300]{6}s[-].",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "Active Skill",
  T_43_XXJ_WS_AIRDROP: "Airdrop and Zombie",
  T_43_XXJ_WS_ALPHA: "Alpha",
  T_43_XXJ_WS_ALPHA_D: "The overall transparency of the HUD, with a range from 0 to 1.",
  T_43_XXJ_WS_ANIMATIONCTRLID: "Animation Controller ID",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "The ID used to describe an animation controller asset",
  T_43_XXJ_WS_AUDIOID: "Audio ID",
  T_43_XXJ_WS_AUDIOID_D: "The ID used to describe an audio asset",
  T_43_XXJ_WS_BACKGRCOLOR: "Background Color",
  T_43_XXJ_WS_BACKGRCOLOR_D: "The color of the health bar boarder and the blurred background",
  T_43_XXJ_WS_BURNING: "Burning",
  T_43_XXJ_WS_CSVID: "CSV ID",
  T_43_XXJ_WS_CSVID_D: "The ID used to describe a configuration table asset",
  T_43_XXJ_WS_CURRENTHP: "Current HP",
  T_43_XXJ_WS_CURRENTHP_D: "Current HP value",
  T_43_XXJ_WS_DAMAGEMAKER_D: "The game entity that deals damage",
  T_43_XXJ_WS_DAMAGEZONE: "Damage Zone",
  T_43_XXJ_WS_DEFAULT: "Default",
  T_43_XXJ_WS_DEFAULT_D: "Default",
  T_43_XXJ_WS_EFFECTID: "Effect ID",
  T_43_XXJ_WS_EFFECTID_D: "The ID used to describe a special effect asset",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "An entity that can fight (e.g. launch attacks, be attacked, or get eliminated)",
  T_43_XXJ_WS_FOLLOWTARGET: "Follow Target",
  T_43_XXJ_WS_FOLLOWTARGET_D: "Must follow an entity with a Transform component",
  T_43_XXJ_WS_GAINHPCOLOR: "Gain HP Color",
  T_43_XXJ_WS_GAINHPCOLOR_D: "The increased portion of HP will show in this color for a short time",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "Is No Fall Damage",
  T_43_XXJ_WS_ISOPENTWEEN: "Is Open Tween",
  T_43_XXJ_WS_ISOPENTWEEN_D: "Enable this to show HP changes in different colors",
  T_43_XXJ_WS_KNOCKDOWN_D1: "The player is in the knockdown state",
  T_43_XXJ_WS_KNOCKDOWN_D2: "Settings for the response to the knockdown state when eliminated",
  T_43_XXJ_WS_KNOCKDOWN_D3: "The revival source type. A player can be revived while  knocked down.",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "Knockdown State",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "Knockdown State Type",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "The response to the knockdown state: maintain default logic, skip the knockdown state, or force into knockdown.",
  T_43_XXJ_WS_LEVEL: "Level",
  T_43_XXJ_WS_LEVEL_D: "Level",
  T_43_XXJ_WS_LEVEL_D1: "The current zombie level",
  T_43_XXJ_WS_LINESPACING: "Line Spacing",
  T_43_XXJ_WS_LINESPACING_D: "Does not display when the segmented HP between two dividers ≤ 0",
  T_43_XXJ_WS_LOSEHPCOLOR: "Lose HP Color",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "The reduced portion of HP will show in this color for a short time",
  T_43_XXJ_WS_MAINCOLOR: "Main Color",
  T_43_XXJ_WS_MAINCOLOR_D: "The color for HP, levels, and outlines",
  T_43_XXJ_WS_MINISENTRY: "Turret",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "The enum for the types of targets a turret can attack",
  T_43_XXJ_WS_MISSILEEXPLODE: "Missile Explode",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "Must Knockdown",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "Forced knockdown",
  T_43_XXJ_WS_OFFSET: "Offset",
  T_43_XXJ_WS_OFFSET_D: "Offset relative to the target followed",
  T_43_XXJ_WS_OILDRUMEXPLODE: "Oil Drum Explode",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "Only triggered when the controller initiates movement",
  T_43_XXJ_WS_PLAYER_D: "The in-game player entity. Each player has one.",
  T_43_XXJ_WS_PLAYERHEADHUD: "Player Head HUD",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "The information displayed above the player's head",
  T_43_XXJ_WS_PLAYERNAME: "Player Name",
  T_43_XXJ_WS_PLAYERNAME_D: "Displays the name of the current health bar owner",
  T_43_XXJ_WS_PLAYERORVEHICLE: "Player or Vehicle",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "The alias for the player/vehicle entity type",
  T_43_XXJ_WS_SCALE: "Scale",
  T_43_XXJ_WS_SCALE_D: "Determines the overall HUD scale size, with the font scaled to match.",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "Show Damage Number",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "True by default. Displays damage number.",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "Skip Knockdown",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "Skip the knockdown state and get eliminated instantly",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "Is Skip Stagger Animation",
  T_43_XXJ_WS_TEAM_D: "(Deprecated. Please use Team ID.)",
  T_43_XXJ_WS_TERRAIN: "Terrain",
  T_43_XXJ_WS_TERRAIN_D: "A terrain component of which attributes cannot be modified. Used to test functions only.",
  T_43_XXJ_WS_TOTALHP: "Total HP",
  T_43_XXJ_WS_TOTALHP_D: "Total HP value",
  T_43_XXJ_WS_TWEENENTITY: "Tween Entity",
  T_43_XXJ_WS_VEHICLEEXPLODE: "Vehicle Explode",
  T_43_XXJ_WS_WIDTH: "Width",
  T_43_XXJ_WS_WIDTH_D: "The width of the displayed health bar",
  T_43_XXJ_WS_ZOMBIE: "Zombie",
  T_43_XYL_WS_DROIDFIST: "Fist (Droid Apocalypse)",
  T_43_XYL_WS_DROIDFLAME: "Flamethrower (Droid Apocalypse)",
  T_43_XYL_WS_JAPANESE: "Japanese-Style",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "Customize match event logs. Used for user experience analysis.",
  T_43_YU_WS_AIRDROPSTATE: "Airdrop State",
  T_43_YU_WS_AIRDROPSTATE_D: "Airdrop state (1: ready, 2: dropping, 3: landed)",
  T_43_YU_WS_ANIMATIONCLIPID: "Animation Clip ID",
  T_43_YU_WS_ANIMATIONCLIPID_D: "Customize animation clip ID",
  T_43_YU_WS_ASKBUYTARGET: "Ask Buy Target",
  T_43_YU_WS_ASKBUYTARGET_D: "Specifies the target and sends purchase request",
  T_43_YU_WS_ASKEDLIST: "Asked List",
  T_43_YU_WS_ASKEDLIST_D: "The list of requested items",
  T_43_YU_WS_BACKGROUNDCOLOR1: "Background Color 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "The upper background color",
  T_43_YU_WS_BACKGROUNDCOLOR2: "Background Color 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "The bottom background color",
  T_43_YU_WS_BATCHCOMBINERENDER: "Batch Combine Render",
  T_43_YU_WS_BINDMONEYENTITYLIST: "Bind Money Entity List",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "The list of bound currency entities",
  T_43_YU_WS_BINDWALLETENTITYID: "Bind Wallet Entity ID",
  T_43_YU_WS_BINDWALLETENTITYID_D: "The ID of the bound wallet entity",
  T_43_YU_WS_CENTEROFFSET: "Center Offset",
  T_43_YU_WS_CENTEROFFSET_D: "The offset value for the capsule collider",
  T_43_YU_WS_COLLECTIONID: "Collection ID",
  T_43_YU_WS_COLLECTIONID_D: "The Collection ID used for asset information collection",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "Create an airdrop",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "Create a damage number",
  T_43_YU_WS_CROSSPLATFORM_D: "When selected, send to the client if called on the server and vice versa.",
  T_43_YU_WS_CSROUNDRESULTHUD: "CS Round Result HUD",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "Results displayed at the end of each round",
  T_43_YU_WS_CURRENTEMOTECLIP: "Current Emote Clip",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "ID of the current emote clip",
  T_43_YU_WS_DAMAGE_D: "The out-of-zone damage",
  T_43_YU_WS_DICTIONARY: "Dictionary",
  T_43_YU_WS_DIRECTIONRULERHUD: "Direction Ruler HUD",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "The compass on the top",
  T_43_YU_WS_DOTWEEN_D: "Whether to perform tween animations",
  T_43_YU_WS_DROPITEMS_D: "Items in the airdrop",
  T_43_YU_WS_DURATION: "Duration",
  T_43_YU_WS_ENERGY: "Energy",
  T_43_YU_WS_ENERGY_D: "EP modification value",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "Prone",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "Crouch",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "Sprinting",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "Stand",
  T_43_YU_WS_EVENTID: "Event ID",
  T_43_YU_WS_EVENTID_D: "Represents an event",
  T_43_YU_WS_FACTION: "Faction",
  T_43_YU_WS_FACTION_D: "The faction entity",
  T_43_YU_WS_FACTION_D1: "Ask the faction for help with purchase",
  T_43_YU_WS_FINALRADIUS_D: "The final radius of the safe zone",
  T_43_YU_WS_FIRSTAIDKIT: "MedKit",
  T_43_YU_WS_FIRSTAIDKIT_D: "Med Kit",
  T_43_YU_WS_FIRSTPERSONMODEL: "First Person Model",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "The first-person camera",
  T_43_YU_WS_FONTCOLOR_D: "The font color",
  T_43_YU_WS_FONTSIZE_D: "The font size",
  T_43_YU_WS_FORBIDEN: "Forbidden",
  T_43_YU_WS_FORBIDEN_D: "Disable the HUD for purchase request",
  T_43_YU_WS_FREEZINGTIME: "Freezing Time",
  T_43_YU_WS_FREEZINGTIME_D: "The duration for which the hit target stays frozen",
  T_43_YU_WS_GRAVITY: "Gravity",
  T_43_YU_WS_GRAVITY_D: "The gravitational acceleration. Only affects the player controller.",
  T_43_YU_WS_HANDCATAPULT: "Launch Pad",
  T_43_YU_WS_HANDCATAPULT_D: "Launch Pad",
  T_43_YU_WS_HEALTH: "Health",
  T_43_YU_WS_HEALTH_D: "The recovery value of armor durability",
  T_43_YU_WS_HEIGHT: "Height",
  T_43_YU_WS_HELPEDPLAYER_D: "The player who is helped",
  T_43_YU_WS_HELPPLAYER_D: "The player who helps with the purchase",
  T_43_YU_WS_HORIZONTALMAXANGLE: "Horizontal Max. Angle",
  T_43_YU_WS_HORIZONTALMINANGLE: "Horizontal Min Angle",
  T_43_YU_WS_HUDTOGGLE: "HUD Toggle",
  T_43_YU_WS_HUDTOGGLE_D: "The HudToggle entity that players can edit in the HUD editor",
  T_43_YU_WS_INHALER: "Inhaler",
  T_43_YU_WS_INHALER_D: "Inhaler",
  T_43_YU_WS_INITRADIUS_D: "The initial radius of the safe zone",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "A 64-bit signed integer",
  T_43_YU_WS_ISAPPLYSHADOW: "Is Apply Shadow",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "Is Bottom Colliding",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "Is Current Emote Loop",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "Whether to set the current Emote animation to loop",
  T_43_YU_WS_ISSIDECOLLIDING: "Is Side Colliding",
  T_43_YU_WS_ISSLIDING: "Is Sliding",
  T_43_YU_WS_ISTOPCOLLIDING: "Is Top Colliding",
  T_43_YU_WS_ITEM331: "Futuristic Device A",
  T_43_YU_WS_ITEM332: "Glowing Rock A",
  T_43_YU_WS_ITEM333: "Futuristic Screen A",
  T_43_YU_WS_ITEM334: "Futuristic Container A",
  T_43_YU_WS_ITEM335: "Futuristic Container A",
  T_43_YU_WS_ITEM336: "Stone Sofa A",
  T_43_YU_WS_ITEM337: "Futuristic Switch A",
  T_43_YU_WS_ITEM338: "Futuristic Pipe A",
  T_43_YU_WS_ITEM339: "Metal Platform A",
  T_43_YU_WS_ITEM340: "Futuristic Table A",
  T_43_YU_WS_ITEM341: "Futuristic Table B",
  T_43_YU_WS_ITEM342: "Futuristic Table C",
  T_43_YU_WS_ITEM343: "Futuristic Computer A",
  T_43_YU_WS_ITEM344: "Stone A",
  T_43_YU_WS_ITEM345: "Stone B",
  T_43_YU_WS_ITEM346: "Stone C",
  T_43_YU_WS_ITEM347: "Stone D",
  T_43_YU_WS_ITEM348: "Stone E",
  T_43_YU_WS_ITEM349: "Stone F",
  T_43_YU_WS_ITEM350: "Stone G",
  T_43_YU_WS_ITEM351: "Japanese-Style Curtain A",
  T_43_YU_WS_ITEM352: "Japanese-Style Curtain B",
  T_43_YU_WS_ITEM353: "Japanese-Style Curtain C",
  T_43_YU_WS_ITEM354: "Japanese-Style Stairs A",
  T_43_YU_WS_ITEM355: "Japanese-Style Fence A",
  T_43_YU_WS_ITEM356: "Japanese-Style Fence B",
  T_43_YU_WS_ITEM357: "Japanese-Style Fence C",
  T_43_YU_WS_ITEM358: "Japanese-Style Platform A",
  T_43_YU_WS_ITEM359: "Japanese-Style Wall B",
  T_43_YU_WS_ITEM360: "Japanese-Style Gate B",
  T_43_YU_WS_ITEM361: "Futuristic Wall D",
  T_43_YU_WS_ITEM362: "Futuristic Wall B",
  T_43_YU_WS_ITEM363: "Futuristic Angled Baseboard",
  T_43_YU_WS_LEFTCOLOR: "Left Color",
  T_43_YU_WS_LEFTCOLOR_D: "The left side color",
  T_43_YU_WS_LEFTPLAYERARRAY: "Left Player Array",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "The left player array",
  T_43_YU_WS_LEFTSCORE: "Left Score",
  T_43_YU_WS_LEFTSCORE_D: "The left side score",
  T_43_YU_WS_LEFTSCOREAFTER: "Left Score After",
  T_43_YU_WS_LEFTSCOREAFTER_D: "The final score of the left side. Used in score transition animations.",
  T_43_YU_WS_LEVELOBJECTID: "Level Object ID",
  T_43_YU_WS_LEVELOBJECTID_D: "Describes the object type. Requires parsing through the SceneEditPrefab configuration table before loading.",
  T_43_YU_WS_LOCALPOSITION_D: "Coordinates in the local coordinate system",
  T_43_YU_WS_LOCALPOSITION_D1: "The relative position",
  T_43_YU_WS_LOCALPOSITION_D2: "The position relative to the bottom right anchor",
  T_43_YU_WS_LOCALPOSITION_D3: "The position relative to the anchor",
  T_43_YU_WS_LOCALROTATION_D: "Rotation angles in the local coordinate system (X: yaw, Y: pitch, and Z: roll)",
  T_43_YU_WS_LOCALROTATIONQ_D: "The quaternion in the local coordinate system",
  T_43_YU_WS_LOCALSCALE_D: "The scale size in the world coordinate system",
  T_43_YU_WS_MASS: "Mass",
  T_43_YU_WS_MATERIALS: "Materials",
  T_43_YU_WS_MATERIALS_D: "The list of materials used for rendering",
  T_43_YU_WS_MAXSPEED: "Max. Speed",
  T_43_YU_WS_MAXSPEED_D: "No more horsepower will be generated after the max speed is reached, but the vehicle speed may go over the limit (e.g. through acceleration when going down a hill).",
  T_43_YU_WS_MESHID: "Mesh ID",
  T_43_YU_WS_MESHID_D: "Describes the mesh type",
  T_43_YU_WS_MESHID1: "Mesh ID",
  T_43_YU_WS_MESHID1_D: "The mesh to be used for rendering",
  T_43_YU_WS_MINMOVEDISTANCE: "Min. Move Distance",
  T_43_YU_WS_MINMOVEDISTANCE_D: "Movement with a distance shorter than this value will not be executed. It is recommended to set it to 0 unless there are special requirements.",
  T_43_YU_WS_MODULE_AI: "AI",
  T_43_YU_WS_MODULE_AIRDROP: "Airdrop",
  T_43_YU_WS_MODULE_ANIMATION: "Animation",
  T_43_YU_WS_MODULE_AVATAR: "Avatar",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "Base Attributes",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "Behavior Tree",
  T_43_YU_WS_MODULE_BUFF: "Buff",
  T_43_YU_WS_MODULE_CAMERA: "Camera",
  T_43_YU_WS_MODULE_CHATCHANNEL: "Chat Channel",
  T_43_YU_WS_MODULE_CHECKPOINT: "Checkpoint",
  T_43_YU_WS_MODULE_COLLECTION: "Collection",
  T_43_YU_WS_MODULE_COMBAT: "Combat",
  T_43_YU_WS_MODULE_COMPONENT: "Component",
  T_43_YU_WS_MODULE_CONVERT: "Convert",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "Customize Room Parameters",
  T_43_YU_WS_MODULE_DATABASE: "Data Storage",
  T_43_YU_WS_MODULE_DYEING: "Dyeing",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "Dynamic NavMesh",
  T_43_YU_WS_MODULE_ECONOMY: "Economy",
  T_43_YU_WS_MODULE_FF_PLATFORM: "FF Platform",
  T_43_YU_WS_MODULE_FOOTBALL: "Football",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "Frame Rate Mode",
  T_43_YU_WS_MODULE_GAMERESULT: "Game Results",
  T_43_YU_WS_MODULE_GLOBAL: "Global",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "Global Scripts",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK & Cheating",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "Input System",
  T_43_YU_WS_MODULE_ITEMS: "Items",
  T_43_YU_WS_MODULE_LEVELOBJECT: "Level Object",
  T_43_YU_WS_MODULE_LIST: "List",
  T_43_YU_WS_MODULE_MAP: "Map",
  T_43_YU_WS_MODULE_MATCHING: "Match",
  T_43_YU_WS_MODULE_MATH: "Math",
  T_43_YU_WS_MODULE_MECHANISM: "Mechanism Parameters",
  T_43_YU_WS_MODULE_MINIMAP: "Minimap",
  T_43_YU_WS_MODULE_MORPH: "Morph",
  T_43_YU_WS_MODULE_OTHER: "Other",
  T_43_YU_WS_MODULE_PET: "Pet",
  T_43_YU_WS_MODULE_PHYSICS: "Physics",
  T_43_YU_WS_MODULE_PLAYABLE: "Playable",
  T_43_YU_WS_MODULE_PLAYER: "Player",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "Player Scripts",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "Preset Character",
  T_43_YU_WS_MODULE_PROFILE: "Profile",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "Property Formula",
  T_43_YU_WS_MODULE_SAFEZONE: "Safe Zone",
  T_43_YU_WS_MODULE_SCENE: "Scene",
  T_43_YU_WS_MODULE_SKILL: "Skill",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "Static Scripts",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "Report",
  T_43_YU_WS_MODULE_STDLIBRARY: "STD Library",
  T_43_YU_WS_MODULE_STRINGS: "Strings",
  T_43_YU_WS_MODULE_TEAM: "Team",
  T_43_YU_WS_MODULE_WORKFLOW: "Workflow",
  T_43_YU_WS_MONEYICON: "Money Icon",
  T_43_YU_WS_MONEYICON_D: "The currency icon",
  T_43_YU_WS_MONEYICONCOLOR: "Money Icon Color",
  T_43_YU_WS_MONEYICONCOLOR_D: "The currency icon color",
  T_43_YU_WS_MOVESAFEZONE_D: "Smoothly moves the safe zone from its start position to the end position. Players outside the zone will take a certain amount of damage.",
  T_43_YU_WS_NEWVECTOR2: "New Vector2",
  T_43_YU_WS_NEWVECTOR2_D: "Gets a new 2D vector",
  T_43_YU_WS_OFFSET_D: "The world position offset relative to the target entity",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "When the player purchase request is met",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "When a player requests for help with purchase in the store",
  T_43_YU_WS_ONTOGGLECHANGE_D: "Trigger when the Toggle component state changes",
  T_43_YU_WS_OPENSTATE: "Open State",
  T_43_YU_WS_OPENSTATE_D: "Displays when set to true and hides if not",
  T_43_YU_WS_PACEMAKER: "Horizaline",
  T_43_YU_WS_PACEMAKER_D: "Horizaline",
  T_43_YU_WS_PARAMS_D: "The list of parameters",
  T_43_YU_WS_PARENT_D: "The entity ID recorded during serialization",
  T_43_YU_WS_PHYSICALCCT: "Physical CCT",
  T_43_YU_WS_PHYSICALCCT_D: "The player controller with physical effects",
  T_43_YU_WS_PLAYER_D: "The purchasing player",
  T_43_YU_WS_PLAYERDATAID: "Player Data ID",
  T_43_YU_WS_PLAYERDATAID_D: "Customize character asset ID",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "Player PhysX Pose Type",
  T_43_YU_WS_POSITION: "Position",
  T_43_YU_WS_POSITION_D: "Coordinates in the world coordinate system",
  T_43_YU_WS_POSITION_D1: "Coordinates in the world coordinate system. Only effective for 3D music.",
  T_43_YU_WS_PRESSEDSPRITE: "Pressed Sprite",
  T_43_YU_WS_PRESSEDSPRITE_D: "The pressed sprite",
  T_43_YU_WS_PRESSEDSPRITETYPE: "Pressed Sprite Type",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "The pressed sprite type",
  T_43_YU_WS_PRETIME: "Pretime",
  T_43_YU_WS_RADIUS: "Radius",
  T_43_YU_WS_RANDOMRANGE_D: "Correct the set position based on a random range",
  T_43_YU_WS_REQUESTPURCHASETYPE: "Request Purchase Type",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "Purchase request in the store",
  T_43_YU_WS_REQUESTTYPE: "Request Type",
  T_43_YU_WS_REQUESTTYPE_D: "The type of the target requested by the current HUD player",
  T_43_YU_WS_RESPLAYERUUID: "Preset Player Type",
  T_43_YU_WS_RESPLAYERUUID_D: "The player asset ID",
  T_43_YU_WS_RESUUID: "Asset UUID",
  T_43_YU_WS_RESUUID_D: "Specifies the UUID of the Batch asset to be rendered",
  T_43_YU_WS_RIGHTCOLOR: "Right Color",
  T_43_YU_WS_RIGHTCOLOR_D: "The right side color",
  T_43_YU_WS_RIGHTPLAYERARRAY: "Right Player Array",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "The right player array",
  T_43_YU_WS_RIGHTSCORE: "Right Score",
  T_43_YU_WS_RIGHTSCORE_D: "The right side score",
  T_43_YU_WS_RIGHTSCOREAFTER: "Right Score After",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "The final score of the right side. Used in score transition animations.",
  T_43_YU_WS_ROTATIONQ_D: "The quaternion in the world coordinate system",
  T_43_YU_WS_ROUNDINFOHUD: "Round Info HUD",
  T_43_YU_WS_ROUNDINFOHUD_D: "Information displayed at the start of a round",
  T_43_YU_WS_SELECTEDCOLOR: "Selected Color",
  T_43_YU_WS_SELECTEDCOLOR_D: "The selected sprite color",
  T_43_YU_WS_SELECTEDSPRITE: "Selected Sprite",
  T_43_YU_WS_SELECTEDSPRITE_D: "The selected sprite",
  T_43_YU_WS_SELECTEDTYPE: "Selected Type",
  T_43_YU_WS_SELECTEDTYPE_D: "The selected sprite type",
  T_43_YU_WS_SHADOWCOLOR: "Shadow Color",
  T_43_YU_WS_SHADOWOFFSET: "Shadow Offset",
  T_43_YU_WS_SHOWTAG: "Show Tag",
  T_43_YU_WS_SHOWTAG_D: "Show team/faction markings",
  T_43_YU_WS_SHRINKDURATION_D: "The shrinking duration of the safe zone",
  T_43_YU_WS_SIMPLERENDER_D: "The bridging rendering component used for rendering with built-in models",
  T_43_YU_WS_SKINWIDTH: "Skin Width",
  T_43_YU_WS_SKINWIDTH_D: "The depth of penetration into the capsule to prevent the character from getting stuck or jittering",
  T_43_YU_WS_SLOPELIMIT: "Slope Limit",
  T_43_YU_WS_SLOPELIMIT_D: "Objects placed on the slope exceeding this angle will slide down",
  T_43_YU_WS_SPEED: "Speed",
  T_43_YU_WS_STARTDROPTIME_D: "The airdrop arrival time in milliseconds",
  T_43_YU_WS_STARTPOS_D: "The start position of the safe zone",
  T_43_YU_WS_STATICICONCOLORS: "Static Icon Colors",
  T_43_YU_WS_STATICICONCOLORS_D: "Icon colors shown on the ruler",
  T_43_YU_WS_STATICICONS: "Static Icons",
  T_43_YU_WS_STATICICONS_D: "The icons shown on rulers",
  T_43_YU_WS_STEPOFFSET: "Step Offset",
  T_43_YU_WS_STEPOFFSET_D: "Only obstacles exceeding this height will have a blocking effect",
  T_43_YU_WS_SUBTITLE: "SubTitle",
  T_43_YU_WS_SUBTITLE_D: "The subtitle",
  T_43_YU_WS_TARGET: "Target",
  T_43_YU_WS_TARGET_D: "The target entity for the displayed damage number",
  T_43_YU_WS_TARGETICONCOLORS: "Target Icon Colors",
  T_43_YU_WS_TARGETICONCOLORS_D: "Colors of the icon shown by the marked target",
  T_43_YU_WS_TARGETICONS: "Target Icons",
  T_43_YU_WS_TARGETICONS_D: "The icons shown by the marked targets",
  T_43_YU_WS_TARGETPOS_D: "The target end position of the safe zone",
  T_43_YU_WS_TEAM: "Team",
  T_43_YU_WS_TEAM_D: "The team entity in the game. Each team has one entity.",
  T_43_YU_WS_TEAM_D1: "Ask the team for help with purchase",
  T_43_YU_WS_TIMEOFSTAY_D: "The display duration in milliseconds",
  T_43_YU_WS_TITLE: "Title",
  T_43_YU_WS_TITLE_D: "The main title",
  T_43_YU_WS_TRANSFORM_D: "Rotation, scaling, and parent-child record",
  T_43_YU_WS_UNSELECTEDCOLOR: "Unselected Color",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "The unselected sprite color",
  T_43_YU_WS_UNSELECTEDSPRITE: "Unselected Sprite",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "The unselected sprite",
  T_43_YU_WS_UNSELECTEDTYPE: "Unselected Type",
  T_43_YU_WS_UNSELECTEDTYPE_D: "Unselected sprite type",
  T_43_YU_WS_USEPHYSICALCCT: "Use Physical CCT",
  T_43_YU_WS_VALUE_D: "The displayed content",
  T_43_YU_WS_VECTOR2ADD: "Vector2 Add",
  T_43_YU_WS_VECTOR2GETX: "Vector2 Get X",
  T_43_YU_WS_VECTOR2GETY: "Vector2 Get Y",
  T_43_YU_WS_VECTOR2SCALE: "Vector2 Scale",
  T_43_YU_WS_VECTOR2SETX: "Vector2 Set X",
  T_43_YU_WS_VECTOR2SETY: "Vector2 Set Y",
  T_43_YU_WS_VECTOR2SUB: "Vector2 Sub",
  T_43_YU_WS_VELOCITY: "Velocity",
  T_43_YU_WS_VERTICALMAXANGLE: "Vertical Max Angle",
  T_43_YU_WS_VERTICALMINANGLE: "Vertical Min. Angle",
  T_43_YU_WS_VISIBILITY_D: "Indicates whether visibility can be set",
  T_43_YU_WS_VISIBLE_D: "The visibility setting. If set to invisible, the client stops rendering the target.",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "Futuristic Wall A",
  T_43_ZY_WS_ITEM320: "Futuristic Wall C",
  T_43_ZY_WS_ITEM321: "Futuristic Window",
  T_43_ZY_WS_ITEM322: "Futuristic Door",
  T_43_ZY_WS_ITEM323: "Futuristic Angled Roof",
  T_43_ZY_WS_ITEM324: "Futuristic Circular Roof",
  T_43_ZY_WS_ITEM325: "Futuristic Baseboard",
  T_43_ZY_WS_ITEM326: "Futuristic Circular Baseboard",
  T_43_ZY_WS_ITEM327: "Futuristic Stairs",
  T_43_ZY_WS_ITEM328: "Futuristic Decoration A",
  T_43_ZY_WS_ITEM329: "Futuristic Building A",
  T_43_ZY_WS_ITEM330: "Futuristic Building B",
  T_44_CJ_M_B_SPORT_TH: "Gym Uniform (Bottom)",
  T_44_CJ_M_H_SPORT_TH: "Gym Uniform (Head)",
  T_44_CJ_M_S_SPORT_TH: "Gym Uniform (Shoes)",
  T_44_CJ_M_T_SPORT_TH: "Gym Uniform (Top)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "Kairos",
  T_44_H_M24_ONIMUSHA_N: "M24 - Attack-o'-the-Wisp",
  T_44_H_USP45_CARNIVORE_N: "USP - Poison Tooth",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "Motorbike - Thunderstrokes",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "Force Start with Min. Players",
  T_44_JH_WS_HALFWAYKEY1: "Prioritize Start with Full Team",
  T_44_PD_PVE_DRAGON_NAME: "Mechadrake",
  T_44_QL_GRENADE_DRAGON: "Dragon Freeze",
  T_44_QL_GRENADE_DRAGON_DES: "An upgraded Flash Freeze that will detonate three times consecutively upon impact",
  T_44_QL_JUMPSHOESX: "Dragon Sprinters",
  T_44_QL_JUMPSHOESX_DES: "A pair of special jumping shoes that allow for sprinting in the air during a double jump",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "Safe Zone Close Time",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "Time when the Safe Zone disappears. If the Safe Zone Close Time is less than Safe Zone Start Time, no Safe Zone will be generated.",
  T_44_SJ_WS_SAFEZONE_COLOR: "Safe Zone Color",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "Damage Interval",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "Damage interval",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "Damage Value",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "The damage dealt to a player out-of-zone in a single instance",
  T_44_SJ_WS_SAFEZONE_DESC: "A placeable out-of-zone object",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "Out-of-Zone End Radius",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "End radius of the out-of-zone area",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "Safe Zone Player List",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "Get the list of players in the Safe Zone",
  T_44_SJ_WS_SAFEZONE_NAME: "The out-of-zone area",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "Shrink Duration (s)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "Length of time the zone shrinking takes",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "Out-of-Zone Initial Radius",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "Initial radius of the out-of-zone area",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "Start Shrink Time",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "Time when the zone shrinking starts",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "Safe Zone Start Time",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "Time when the safe zone appears each round in-match. Default is 0.",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "PLASMA-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "Activated Alpha",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "Activated alpha",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "Active Skill Button HUD",
  T_44_XXJ_WS_ADDCOMPONENT_D: "Add a component to an entity. Only supports custom components. (A component will not be added again if it already exists.)",
  T_44_XXJ_WS_ALLMEMBERS: "All Members",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "Allow Pressed Outside",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "Allow triggering outside the designated area",
  T_44_XXJ_WS_ARROWIMAGE: "Arrow Image",
  T_44_XXJ_WS_ARROWIMAGE_D: "Arrow image",
  T_44_XXJ_WS_ARROWOFFSET: "Arrow Offset",
  T_44_XXJ_WS_ARROWOFFSET_D: "Arrow offset",
  T_44_XXJ_WS_ARROWSIZE: "Arrow Size",
  T_44_XXJ_WS_ARROWSIZE_D: "Arrow size",
  T_44_XXJ_WS_AUTOPLAY_D: "Automatically play upon creation",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "Background Image",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "Base image",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "Background Radius",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "Base radius",
  T_44_XXJ_WS_BAGSKINID: "Backpack Skin ID",
  T_44_XXJ_WS_BAGSKINID_D: "The backpack skin ID",
  T_44_XXJ_WS_BONEPOSITION: "Bone Position",
  T_44_XXJ_WS_BONEPOSITION_D: "World coordinates of the bone node",
  T_44_XXJ_WS_CCTMOVE: "Move CCT",
  T_44_XXJ_WS_COLLIDER: "Collider",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "Collider Collection",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "The component used to describe the collision shape",
  T_44_XXJ_WS_COLOR: "Color",
  T_44_XXJ_WS_CONTENT: "Content",
  T_44_XXJ_WS_CONTENT_D: "Wallet content is a collection of currencies",
  T_44_XXJ_WS_CONTEXT_D: "Content to be printed",
  T_44_XXJ_WS_CROSSHAIRSHUD: "Crosshairs HUD",
  T_44_XXJ_WS_CURVE_D: "Curve",
  T_44_XXJ_WS_EFFECTCOLOR_D: "Color of the surface texture",
  T_44_XXJ_WS_ENABLE: "Enable",
  T_44_XXJ_WS_ENTITY_D: "Entity",
  T_44_XXJ_WS_GETBAGSKINID_D: "Get player backpack skin configuration",
  T_44_XXJ_WS_GETFACTION_D: "Get faction",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "Get the loaded scenes that have not been uninstalled",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "Get the local player",
  T_44_XXJ_WS_GROUPID: "Group ID",
  T_44_XXJ_WS_GROUPID_D: "For internal logic",
  T_44_XXJ_WS_HUDJOYSTICK: "HUD Joystick Widget",
  T_44_XXJ_WS_HUDJOYSTICK_D: "Joystick entity. Players can edit the HUD via the HUD Editor.",
  T_44_XXJ_WS_HUDTOUCHPAD: "HUD Touchpad Widget",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "The HUD Touchpad widget that players can edit in the HUD editor",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "Custom HUD or HUD Widget",
  T_44_XXJ_WS_ICON: "Icon",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "Always Show Mark",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "Always show marks on the compass",
  T_44_XXJ_WS_INACTIVATEDALPHA: "Unactivated Alpha",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "Unactivated alpha",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "When calling, the number of actual parameters does not match that of formal parameters. The expected number is {0}, while the actual is {1}.",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "Is Dynamic Obstacle",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "Is a dynamic obstacle for NavMesh",
  T_44_XXJ_WS_ISEND: "Is End",
  T_44_XXJ_WS_ISEND_D: "IsEnd",
  T_44_XXJ_WS_ISSERVERDRIVEN: "Is Server-Driven",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "If false, then custom objects cannot be controlled by the APIs.",
  T_44_XXJ_WS_ISSUC_D: "Return execution result",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "Joystick Drag Radius",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "Joystick drag radius",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "Joystick Image",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "Joystick image",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "Joystick Radius",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "Joystick radius",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "Character Skill ID List",
  T_44_XXJ_WS_LOOPTYPE_D: "Loop type",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "Quit Midway Config",
  T_44_XXJ_WS_MOUNTABLE: "Hierarchical",
  T_44_XXJ_WS_MOUNTABLE_D: "Entity capable of mounting child nodes",
  T_44_XXJ_WS_MOVEMENT: "Movement",
  T_44_XXJ_WS_NAME_D: "Name",
  T_44_XXJ_WS_NATURALCONST: "Natural Constant",
  T_44_XXJ_WS_NATURALCONST_D: "Enum of natural constants to reduce redundant definitions",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "Play icon animation",
  T_44_XXJ_WS_OFFSET_D: "Default base offset",
  T_44_XXJ_WS_ONFIRE_D: "Triggers the event each time the player shoots, attacks with fists, or attacks with melee weapons.",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "Trigger the event when the player stands up from prone/crouching",
  T_44_XXJ_WS_ONSTARTFIRE_D: "Trigger the event when the player taps the fire button",
  T_44_XXJ_WS_OPTION: "Options",
  T_44_XXJ_WS_PASSIVESKILLHUD: "Passive Skill HUD",
  T_44_XXJ_WS_PHYSICALMOVER: "Physical Mover",
  T_44_XXJ_WS_PHYSICALMOVER_D: "Players on this platform will automatically follow movement and rotation",
  T_44_XXJ_WS_PHYSICALOBJECT: "Physical Object",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "Can apply force to it",
  T_44_XXJ_WS_PI: "Pi",
  T_44_XXJ_WS_PI_D: "The mathematical constant π (Pi) ",
  T_44_XXJ_WS_PLAYERS: "Player List",
  T_44_XXJ_WS_PLAYERS_D: "Player list",
  T_44_XXJ_WS_PLAYERSKILLID: "Character Skill ID",
  T_44_XXJ_WS_PLAYERSKILLID_D: "The character skill ID in AvatarSkill.csv",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "The previous pose before the player stands up",
  T_44_XXJ_WS_PRINT: "Print",
  T_44_XXJ_WS_PRINTERROR: "Print Error",
  T_44_XXJ_WS_PRINTERROR_D: "Print target data as an error to the console",
  T_44_XXJ_WS_PRINTWARNING: "Print Warning",
  T_44_XXJ_WS_PRINTWARNING_D: "Print target data as a warning to the console",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "Prioritize Player Skin Config",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "Prioritize the out-of-match player skin configuration",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "Read the content in cells of a  row by the column number and key",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "Clear player backpack skin configuration",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "Remove a component from an entity. Only supports custom components.",
  T_44_XXJ_WS_RESETBAGSKINID_D: "Reset player backpack skin configuration to its out-of-match configuration",
  T_44_XXJ_WS_SETBAGSKINID_D: "Set player backpack skin configuration",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "Entity supporting the Transform, SkeletonPart, Player, and MountPoint components",
  T_44_XXJ_WS_SHOWBACKGROUND: "Show Background",
  T_44_XXJ_WS_SKINID_D: "Backpack skin ID and skin configuration",
  T_44_XXJ_WS_SPEED_D: "Playback speed",
  T_44_XXJ_WS_TARGET: "Target",
  T_44_XXJ_WS_TARGET_D: "Target object",
  T_44_XXJ_WS_TITLE: "Title",
  T_44_XXJ_WS_TYPEID_D: "Component type ID. Only supports custom components.",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "Upload custom match results",
  T_44_XXJ_WS_WARNINGCSVTYPE: "Type mismatch. Unable to read the table content.",
  T_44_XXJ_WS_X_D: "X-axis coordinate",
  T_44_XXJ_WS_Y_D: "Y-axis coordinate",
  T_44_XYL_WS_CTZSAFEZONE: "Custom Safe Zone",
  T_44_XYL_WS_CTZSAFEZONEDESC: "Generates the start and end point of a Safe Zone based on the set positions and properties",
  T_44_XYL_WS_HEMISPHERICALSHELL: "Hemispherical Shell",
  T_44_XYL_WS_QUARTERCYLINDER: "Quarter Cylinder",
  T_44_XYL_WS_SQUAREPYRAMID: "Square Pyramid",
  T_44_XYL_WS_TORUS: "Torus",
  T_44_XYL_WS_TRIANGULARPYRAMID: "Triangular Pyramid",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "Add Game Event Log Map",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "Add User Event Log",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "The custom match event log used for UX data analysis",
  T_44_YU_WS_ITEM366: "Military Wall A",
  T_44_YU_WS_ITEM367: "Military Wall B",
  T_44_YU_WS_ITEM368: "Military Wall C",
  T_44_YU_WS_ITEM369: "Military Wall D",
  T_44_YU_WS_ITEM370: "Military Window A",
  T_44_YU_WS_ITEM371: "Military Window B",
  T_44_YU_WS_ITEM372: "Military Window C",
  T_44_YU_WS_ITEM373: "Military Door A",
  T_44_YU_WS_ITEM374: "Military Door B",
  T_44_YU_WS_ITEM375: "Military Angled Roof A",
  T_44_YU_WS_ITEM376: "Military Angled Roof B",
  T_44_YU_WS_ITEM377: "Military Stairs A",
  T_44_YU_WS_ITEM378: "Military Stairs B",
  T_44_YU_WS_ITEM379: "Military Pillar A",
  T_44_YU_WS_ITEM380: "Military Handrail A",
  T_45_C_WEAPON_CUST_ENTRANCE: "Customize",
  T_45_CJ_TREATMENTGUN_Y_N: "Heal Pistol-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "Kassie",
  T_45_H_EMOTE_MVPDANCE_N: "Champion's Walk",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "Inspect",
  T_45_HL_Moderation_fail_1: "Unfortunately, your submitted project did not pass the review.",
  T_45_HL_Moderation_fail_2: "involves",
  T_45_HL_Moderation_fail_3: "Reasons included:",
  T_45_HL_Moderation_fail_Location_1: "Game Content",
  T_45_HL_Moderation_fail_reason_1: "Toxic Content",
  T_45_HL_Moderation_fail_reason_10: "Community Guideline Violation",
  T_45_HL_Moderation_fail_reason_11: "Negative Impacts on In-Game Economies and Virtual Property Infringement",
  T_45_HL_Moderation_fail_reason_2: "Inappropriate Content",
  T_45_HL_Moderation_fail_reason_3: "Politically Sensitivity",
  T_45_HL_Moderation_fail_reason_4: "False Information",
  T_45_HL_Moderation_fail_reason_5: "Copyright Infringement",
  T_45_HL_Moderation_fail_reason_6: "Privacy Violation",
  T_45_HL_Moderation_fail_reason_7: "Security Concerns",
  T_45_HL_Moderation_fail_reason_8: "Hate Speech",
  T_45_HL_Moderation_fail_reason_9: "Spam",
  T_45_HL_Moderation_fail_reason_999: "Other Issues",
  T_45_JH_WS_CLEMPTYOBJECT: "Object Group",
  T_45_JH_WS_PETSWITCH1: "Whether to show pets in the match",
  T_45_QL_CSFPP_DES: "Eliminate all opponents through the first-person perspective in this special CS mode!",
  T_45_QL_CSFPP_NAME: "Clash Squad: FPP",
  T_45_QL_CSFPP_RANKNAME: "First-Person",
  T_45_SJ_WS_REVIEW_23: "Game Content",
  T_45_SJ_WS_REVIEW_24: "{0} involves {1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1} involves {2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]Tap to view details >>[-]",
  T_45_SJ_WS_REVIEW_27: "Not Approved",
  T_45_SJ_WS_REVIEW_28: "Review Feedback",
  T_45_SJ_WS_REVIEW_29: "The content involves {0} violation(s)",
  T_45_SJ_WS_REVIEW_31: "Not Approved",
  T_45_SJ_WS_REVIEW_32: "The review failed due to server exceptions",
  T_45_SJ_WS_REVIEW_TITLE: "Details of Violation",
  T_45_SJ_WS_VAULTTRIGGER_DES: "Triggers vaulting (jumping over obstacles)",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "Vault Distance",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "Modifies the distance of vaulting",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "Vault Height",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "Controls the height of moving up and down when vaulting",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "Vault Trigger",
  T_45_TYC_CL_TEMPLATE_WS: `An elimination mode where players take out all opposing teams in a chaotic battle to win.
You can set the gameplay rules and edit the gameplay parameters as you like.`,
  T_45_W_SPEEDMODE_FLIGHT_N: "Skyblaster",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = auto attack, 1 = defensive attack, 2 = do not attack",
  T_45_XXJ_WS_ADDFRIEND: "Add Friend",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "Auto",
  T_45_XXJ_WS_BASEDATA: "Base Data",
  T_45_XXJ_WS_BOTH: "Both",
  T_45_XXJ_WS_BYHIERARCHY: "By Hierarchy",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "By Priority High to Low",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "By Priority Low to High",
  T_45_XXJ_WS_CAMERA: "Camera",
  T_45_XXJ_WS_CAMERATYPE: "Camera Type",
  T_45_XXJ_WS_CENTERINVISIBLE: "Center Invisible",
  T_45_XXJ_WS_CLIENT: "Client",
  T_45_XXJ_WS_COLLIDERID: "Collider ID",
  T_45_XXJ_WS_COLLIDERID_D: "The collider ID",
  T_45_XXJ_WS_COMPONENT: "Component",
  T_45_XXJ_WS_CURRENTCAMERA: "Current Camera",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "Custom Push Force",
  T_45_XXJ_WS_DOUBLE: "Double",
  T_45_XXJ_WS_DUMP: "Throw",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "Enable Move in Midair",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "Enable Rotate with Gravity",
  T_45_XXJ_WS_ENUM: "Enum",
  T_45_XXJ_WS_EVENT: "Event",
  T_45_XXJ_WS_FILLAMOUNT: "Fill Amount",
  T_45_XXJ_WS_FILLDIR: "Fill Direction",
  T_45_XXJ_WS_FIRETYPE: "Fire Type",
  T_45_XXJ_WS_FIRETYPE_D: "The firing type",
  T_45_XXJ_WS_FIXEDDELTATIME: "Fixed Delta Time",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "The fixed time interval for frame updates in milliseconds",
  T_45_XXJ_WS_FORWARD: "Forward",
  T_45_XXJ_WS_FORWARD_D: "The direction of the z-axis in the local coordinate system",
  T_45_XXJ_WS_FUNCTIONTYPE: "Function Type",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "The function type",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "The aiming direction of the local player",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "Get the local timestamp",
  T_45_XXJ_WS_GRADIENT: "Gradient",
  T_45_XXJ_WS_GRADIENTBOTTOM: "Gradient Bottom",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "Gradient Bottom Alpha",
  T_45_XXJ_WS_GRADIENTTOP: "Gradient Top",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "Gradient Top Alpha",
  T_45_XXJ_WS_HITPOSITION_D: "The world position of the target hit by bullets",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "UI Social Button Widget",
  T_45_XXJ_WS_INVERTFILL: "Invert Fill",
  T_45_XXJ_WS_ISGROUNDED: "Is Grounded",
  T_45_XXJ_WS_ISSILENCE: "Is Silence",
  T_45_XXJ_WS_ISSILENCE_D: "If it is silenced or not",
  T_45_XXJ_WS_ISSINGLESHOT: "Is Single Shot",
  T_45_XXJ_WS_ISSINGLESHOT_D: "If it is single-shot or not",
  T_45_XXJ_WS_JUMPHEIGHT: "Jump Height",
  T_45_XXJ_WS_JUMPHEIGHT_D: "The jump height",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "Layout Sort Type",
  T_45_XXJ_WS_LIGHT_D: "Lights",
  T_45_XXJ_WS_LOCAL: "Local",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "Max. Jump Count",
  T_45_XXJ_WS_MODULE: "Module",
  T_45_XXJ_WS_NONE: "None",
  T_45_XXJ_WS_ONBEFOREHURT_D: "Execute the command each time before the entity deals damage",
  T_45_XXJ_WS_ONDISABLE_D: "Execute when the entity is disabled",
  T_45_XXJ_WS_ONEACHLOOP_D: "Execute each time Playable is looped. Only effective on the client side for entities such as Sound Effect and Special Effect.",
  T_45_XXJ_WS_ONENABLE_D: "Execute when the entity is enabled",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "When entering a frame at a fixed rate of 30 FPS",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "Trigger the client event when the player adds or deletes a friend",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "Trigger the event when the game is paused due to the called API",
  T_45_XXJ_WS_ONGAMERESUME_D: "Trigger the event when the game resumes due to the called API",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "When the player stops sprinting",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "When the player stops surfing",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "When the player is surfing",
  T_45_XXJ_WS_PHYSICALLAYER_D: "The custom physical layer within a range of 0 to 31",
  T_45_XXJ_WS_PLATFORMTYPE: "Platform Type",
  T_45_XXJ_WS_PLATFORMTYPE_D: "The platform type",
  T_45_XXJ_WS_PLAYER: "Player",
  T_45_XXJ_WS_PLAYERCCT: "Player CCT",
  T_45_XXJ_WS_PLAYERCCT_D: "A character controller with physical effects and used for Free Fire characters only",
  T_45_XXJ_WS_PRIORITY: "Priority",
  T_45_XXJ_WS_REMAINMULTINUM: "Remain Jump Count",
  T_45_XXJ_WS_REPORT: "Report",
  T_45_XXJ_WS_RIGHT: "Right",
  T_45_XXJ_WS_RIGHT_D: "The direction of the x-axis in the local coordinate system",
  T_45_XXJ_WS_SERVER: "Server",
  T_45_XXJ_WS_SINGLE: "Single",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "Social Button Style Type",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "The social button style",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "Social Button Type",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "The social button type",
  T_45_XXJ_WS_SORTTYPE_D: "Sort types: non-zero ascending, descending, and ascending",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "Move Speed While ADS",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "The movement speed while aiming down sight",
  T_45_XXJ_WS_STRINGORLOCSTRING: "String or Localized String",
  T_45_XXJ_WS_TRIPLE: "Triple",
  T_45_XXJ_WS_UP: "Up",
  T_45_XXJ_WS_UP_D: "The direction of the y-axis in the local coordinate system",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "Use Custom Push Force",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "Throw a signal flare towards the designated area to summon a random vehicle",
  T_45_ZD_VEHICLEDROP_R_NAME: "Mystery Vehicle",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "Lila",
  T_46_HJ_SHARE_GAMEDURATION: "Time Played",
  T_46_HJ_WS_SHAREBY: "By {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "Game Mode",
  T_46_HJ_WS_SHARETEAM: "Team",
  T_46_HJ_WS_SHARETEAMVS: "{0} vs {1}",
  T_46_HX_B_SCHOOL_VN: "Top of Class (Bottom)",
  T_46_HX_H_SCHOOL_VN: "Top of Class (Head)",
  T_46_HX_S_SCHOOL_VN: "Top of Class (Shoes)",
  T_46_HX_T_SCHOOL_VN: "Top of Class (Top)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "Tutorial",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "Others",
  T_46_XXJ_WS_ACTUALPOSITION: "Actual Position",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "Add the object to monitor with AOI synchronization beyond line of sight",
  T_46_XXJ_WS_APPEARANCE: "Appearance",
  T_46_XXJ_WS_APPEARANCERES: "Appearance Resource",
  T_46_XXJ_WS_BECOME: "Activate",
  T_46_XXJ_WS_BRAKETORQUE_D: "The horsepower given to the vehicle when Brake/Reverse is used",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Camera Rotate Angle Restriction Type",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "Clear all monitored objects of the target",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "The maximum crash damage used for damage calculation",
  T_46_XXJ_WS_CRASHMAXSPEED: "Crash Max. Speed",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "Used for crash damage calculation. Once exceeding this speed, no more damage will be added.",
  T_46_XXJ_WS_CRASHMESSFACTOR: "Crash Mass Factor",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "A parameter used in the damage formula for crash damage calculation",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "The minimum crash damage used for damage calculation",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "Read and write limit of data storage has been exceeded",
  T_46_XXJ_WS_DB_PARAMERROR_D: "Parameter exception",
  T_46_XXJ_WS_DB_TIMEOUT_D: "Data storage timeout. Mainly applies to read and write now.",
  T_46_XXJ_WS_DELTA: "Delta",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "Edit Appearance",
  T_46_XXJ_WS_ENDVALUE_D: "The destination value",
  T_46_XXJ_WS_ENGINETORQUE_D: "The horsepower given to the vehicle when the gas pedal is used",
  T_46_XXJ_WS_ERRORCODE_D: "The error code enum",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "Euler Angle to Vector3",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "Convert the Eular angle to a 3D vector",
  T_46_XXJ_WS_EXPIRE: "Expire",
  T_46_XXJ_WS_FEMALEAVATAR: "Female Character",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "Get Membership Expire Date",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "If the observer is monitoring an object or not",
  T_46_XXJ_WS_HELICOPTER: "Skyblaster",
  T_46_XXJ_WS_HELICOPTER_D: "A type of flying vehicle",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "High-Speed Steer Restriction",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "The maximum steering angle while in a high-speed state",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "High-Speed Steer Angle at Speed",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "The speed threshold for the maximum high-speed steering angle",
  T_46_XXJ_WS_IDLE: "Idle Animation",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "Idle Brake Input",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "When not driving a vehicle, decelerate it by (Idle Brake Input) x (Brake Torque).",
  T_46_XXJ_WS_INTTOFLOAT: "Int to Float",
  T_46_XXJ_WS_INTTOFLOAT_D: "Convert an integer to a floating-point number",
  T_46_XXJ_WS_ISPREMIUM: "Is Membership",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "The leaderboard name in the database",
  T_46_XXJ_WS_MALEAVATAR: "Male Character",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "AI Persona",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "New UMA Appearance",
  T_46_XXJ_WS_NONE_D: "No error",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "The NPC object",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "Tips: Humanoid NPCs usually have a collision model with a capsule that is 1.4m tall and 0.25m in radius. Pet NPCs usually have a collision model with a capsule that is 1m tall and 0.4m in radius.",
  T_46_XXJ_WS_OBSERVER_D: "The observer that is monitoring objects",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "On Enter Craftland Membership",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "On Quit Craftland Membership",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "Open Craftland Membership",
  T_46_XXJ_WS_PERSONA: "Persona",
  T_46_XXJ_WS_PERSONACENTER: "Persona Center",
  T_46_XXJ_WS_PET: "Pet",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "Player or Transform",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "An alias for the Player and Transform entity",
  T_46_XXJ_WS_PREMIUM: "Membership",
  T_46_XXJ_WS_PREMIUMSTATUS: "Membership Status",
  T_46_XXJ_WS_PROXYOBSERVER: "Proxy Observer",
  T_46_XXJ_WS_PROXYOBSERVER_D: "The proxy observer",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "Remove the monitored object and cancel the AOI synchronization beyond line of sight",
  T_46_XXJ_WS_RENEWAL: "Renew",
  T_46_XXJ_WS_ROTATEVECTOR: "Rotate Vector",
  T_46_XXJ_WS_ROTATEVECTOR_D: "Rotate a vector based on quaternions",
  T_46_XXJ_WS_SKIN: "Gear",
  T_46_XXJ_WS_STARTVALUE_D: "The source value",
  T_46_XXJ_WS_STATUS: "Status",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "Switch the proxy observer of the User",
  T_46_XXJ_WS_TARGET_D: "The target that is monitored",
  T_46_XXJ_WS_USER_D: "The user",
  T_46_XXJ_WS_VALUE: "Value",
  T_46_XXJ_WS_VALUE_D: "Vector",
  T_46_XYL_WS_CTZSAFEZONEEND: "Safe Zone End Point",
  T_46_XYL_WS_RESOURCETYPE1: "Basic Structures",
  T_46_XYL_WS_RESOURCETYPE1_1: "Geometrics",
  T_46_XYL_WS_RESOURCETYPE1_2: "Visual & Audio",
  T_46_XYL_WS_RESOURCETYPE2: "Scene Items",
  T_46_XYL_WS_RESOURCETYPE2_2: "Battle Supplies",
  T_46_XYL_WS_RESOURCETYPE3: "Nature",
  T_46_XYL_WS_RESOURCETYPE4: "Modular Component",
  T_46_XYL_WS_TYPEOTHERPROP: "Miscellaneous",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "Containers & Boxes",
  T_47_CJ_FOREGRIP_SOFT_N: "Light Foregrip",
  T_47_CJ_MAGEZINE_FAST_N: "Fast Mag",
  T_47_CJ_STOCK_FAST_N: "Power Stock",
  T_47_GT_WS_USERMANUAL: "User Manual",
  T_47_HJ_WS_VFX_FOG: "Fog VFX",
  T_47_HJ_WS_VFX_LIGHTING: "Lighting VFX",
  T_47_HJ_WS_VFX_TRAILING: "Trailing VFX",
  T_47_HL_CL_CREATOR_LABEL1: "Community Talent",
  T_47_HL_CL_MAP_LABEL1: "Selected Works by Community Talents",
  T_47_JH_WS_MODERATION_REASON12: "Gambling-related",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "NARUTO SHIPPUDEN collaboration",
  T_47_SD_RES_MATERIAL: "Material file",
  T_47_SD_RES_MESH: "Mesh",
  T_47_SD_WS_MAPTAG_AI: "AI Map Generate",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "A special knife that sticks to the point of impact after being thrown, triggering a fiery explosion after a short delay to deal burn damage.",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "Fiery Kunai",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "A special knife that sticks to the point of impact after being thrown, triggering a Lightning strike after a short delay to paralyze the target.",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "Lightning Kunai",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "A special knife that sticks to the point of impact after being thrown, triggering a windstorm after a short delay to slow down the target moving towards its center.",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "Wind Kunai",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "A type of shuriken suitable for mid-to-long-range combat. One throw launches one piece quickly, dealing a great amount of damage.",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "Heavy Shuriken",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "A type of shuriken suitable for close-to-mid-range combat with two attack modes. One throw launches three pieces, dealing a small amount of damage.",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "Light Shuriken",
  T_47_XXJ_WS_ACTION: "Action",
  T_47_XXJ_WS_AOISETTING: "AOI Setting",
  T_47_XXJ_WS_BAGSKINTYPE: "Backpack Skin Type",
  T_47_XXJ_WS_CLEARMEMORY: "Clear Memory",
  T_47_XXJ_WS_CLNPC: "Advanced NPC",
  T_47_XXJ_WS_CLOTHTYPE: "Outfit Skin Type",
  T_47_XXJ_WS_COMMON_ERROR: "Common Error",
  T_47_XXJ_WS_CONTENT: "Content",
  T_47_XXJ_WS_CREATERANDOMSEED: "Create Random Seed",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "Elapsed Percentage",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "Enable Fog Feature",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "Enable Light Rotation Feature",
  T_47_XXJ_WS_ERRORCODE: "Error Code",
  T_47_XXJ_WS_EXPONENTIAL: "Exponential",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "Exponential Squared",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "Failed to create room: no valid Persona IDs",
  T_47_XXJ_WS_FOG: "Fog",
  T_47_XXJ_WS_FOGDENSITY: "Fog Density",
  T_47_XXJ_WS_FOGENDDISTANCE: "Fog End Distance",
  T_47_XXJ_WS_FOGMODE: "Fog Mode",
  T_47_XXJ_WS_FOGMODETYPE: "Fog Mode Type",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "Fog Start Distance",
  T_47_XXJ_WS_HEIGHTSCALE: "Height Scale",
  T_47_XXJ_WS_ISVISIBLE: "Is Visible",
  T_47_XXJ_WS_JOINNEWTEAM: "Join New Team",
  T_47_XXJ_WS_JOINTEAM: "Join Team",
  T_47_XXJ_WS_LIGHTROTATE: "Light Rotation",
  T_47_XXJ_WS_LINEAR: "Linear",
  T_47_XXJ_WS_LLMCHATHUD: "UI Persona Chat",
  T_47_XXJ_WS_NEWTEAM: "New Team",
  T_47_XXJ_WS_NEXT: "Next",
  T_47_XXJ_WS_NPC_TIP: "You can edit NPC's appearance and make NPC play animation",
  T_47_XXJ_WS_OBSERVERS: "Observers",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "On Player Send Message by UI Persona Chat",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "On Membership Status Changed",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "On Receive Action From Persona",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "On Receive Content From Persona",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "On Receive Finish From Persona",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "On Receive Status From Persona",
  T_47_XXJ_WS_PARTICLESID: "Particles ID",
  T_47_XXJ_WS_PERSONAAVATAR: "Persona Avatar",
  T_47_XXJ_WS_PERSONAID: "Persona ID",
  T_47_XXJ_WS_PERSONANICKNAME: "Persona Nickname",
  T_47_XXJ_WS_PLAYERORNPC: "Player or NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "Membership Closed",
  T_47_XXJ_WS_RANDOM: "Random",
  T_47_XXJ_WS_SEED: "Seed",
  T_47_XXJ_WS_SENDER: "Sender",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "Set Persona Observer",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "Set Player Can Quit Midway",
  T_47_XXJ_WS_SHOULDREPLY: "Should Reply",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "Show System Reply",
  T_47_XXJ_WS_SPOTANGLE: "Spot Angle",
  T_47_XXJ_WS_SPOTLIGHT: "Spotlight",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "Send System Message To Persona",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "Stream System Messages to Persona",
  T_47_XXJ_WS_TARGETTEAM: "Target Team",
  T_47_XXJ_WS_THISENTITY: "This Entity",
  T_47_XXJ_WS_USERAVATAR: "User Avatar",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "Send User Message To Persona",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "Stream User Messages to Persona",
  T_47_XXJ_WS_USERNICKNAME: "User Nickname",
  T_47_XXJ_WS_VEHICLESKINTYPE: "Vehicle Skin Type",
  T_47_XXJ_WS_WEAPONSKINTYPE: "Weapon Skin Type",
  T_47_XYL_NB_UGC_EFFECT001: "Rasengan VFX",
  T_47_XYL_NB_UGC_EFFECT002: "Chidori VFX",
  T_47_XYL_NB_UGC_EFFECT003: "Cherry Blossom Clash VFX",
  T_47_XYL_NB_UGC_EFFECT004: "Fireball Jutsu VFX",
  T_47_XYL_NB_UGC_EFFECT005: "Water Dragon Jutsu VFX",
  T_47_XYL_NB_UGC_EFFECT006: "Great Breach VFX",
  T_47_XYL_NB_UGC_EFFECT007: "Tailed Beast Bomb VFX",
  T_47_XYL_NB_UGC_EFFECT008: "Reanimation Curse Mark VFX",
  T_47_XYL_UGC_CRAFTLANDSHOP: "Asset Store",
  T_47_XYL_UGC_DONKEYCART: "Donkey Cart",
  T_47_XYL_UGC_SPOTLIGHT: "Spotlight",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "Spotlight Angle",
  T_48_H_EMOTE_WATERFEST25_N: "Swift Steps",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "Motorbike - Sea Foam",
  T_48_HJ_AC_STATENOTEXIST: "The state {0} does not exist in the animation controller",
  T_48_HL_CODESCRIPT: "Code Script",
  T_48_HL_GLOBAL_VAR: "Global Variable Name",
  T_48_HL_GRAPH: "Block",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "Leaderboard",
  T_48_HL_LOCAL_VAR: "Local Variable Name",
  T_48_HL_LOCALIZATION: "Localization Name",
  T_48_HL_OPEN_ATTRIBUTES: "Open Attribute Name",
  T_48_HX_A_WATERFEST25: "Sea Foam (Mask)",
  T_48_HX_B_WATERFEST25: "Sea Foam (Bottom)",
  T_48_HX_F_B_BLACKDRESS: "Antimatter (Bottom)",
  T_48_HX_F_H_BLACKDRESS: "Antimatter (Head)",
  T_48_HX_F_HA_BLACKDRESS: "Antimatter (Facepaint)",
  T_48_HX_F_S_BLACKDRESS: "Antimatter (Shoes)",
  T_48_HX_F_T_BLACKDRESS: "Antimatter (Top)",
  T_48_HX_H_WATERFEST25: "Sea Foam (Head)",
  T_48_HX_HA_WATERFEST25: "Sea Foam (Facepaint)",
  T_48_HX_M_A_BLACKDRESS: "Dark Matter (Mask)",
  T_48_HX_M_B_BLACKDRESS: "Dark Matter (Bottom)",
  T_48_HX_M_H_BLACKDRESS: "Dark Matter (Head)",
  T_48_HX_M_HA_BLACKDRESS: "Dark Matter (Facepaint)",
  T_48_HX_M_S_BLACKDRESS: "Dark Matter (Shoes)",
  T_48_HX_M_T_BLACKDRESS: "Dark Matter (Top)",
  T_48_HX_S_WATERFEST25: "Sea Foam (Shoes)",
  T_48_HX_T_WATERFEST25: "Sea Foam (Top)",
  T_48_JH_WS_STRINGDESC: "Enter a paragraph of text or other strings. Some widgets can display rich text. Add color to text with rich text using the following format: [#XXXXXX] text text [-]. “#XXXXXX” is the color you wish to display. Please note that the text color of the related widget must be set to white.",
  T_48_M_WS_P_ICON: "Avatar",
  T_48_META_API_10001: "Find Entity by ID",
  T_48_META_API_10001_P0: "Entity ID",
  T_48_META_API_1098: "Batch Read Database Sheet Value",
  T_48_META_API_1098_D: "Batch read multiple data entries from a specified database sheet, where the entries of the unique player ID list correspond one-to-one with those of the key list.",
  T_48_META_API_1098_P1: "Account IDs",
  T_48_META_API_1098_P1_D: "The list of unique player IDs, which reads the data corresponding to the keys at the same index in the key list.",
  T_48_META_API_1098_P2: "Keys",
  T_48_META_API_1098_P2_D: "The list of keys, which reads the data corresponding to the unique player IDs at the same index in the ID list.",
  T_48_META_API_1098_P5: "Status Codes",
  T_48_META_API_1098_P5_D: "The list of status codes",
  T_48_META_API_1105: "Notify Start Plot",
  T_48_META_API_1105_D: "Start playing the specified plot for the triggering player",
  T_48_META_API_1105_P1_D: "The plot ID",
  T_48_META_API_1108: "Get Local Language",
  T_48_META_API_1500_P0: "Vector",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "Set Body Part Weight",
  T_48_META_API_3300_D: "Set the weight of the target body part when blending it with other lower-priority animations",
  T_48_META_API_3300_P0_D: "The addable animation controller component that the body part belongs to",
  T_48_META_API_3300_P1: "Body Part Name",
  T_48_META_API_3300_P1_D: "The body part name",
  T_48_META_API_3300_P2: "Weight",
  T_48_META_API_3300_P2_D: "Weight with a value range of [0, 1], representing the degree of blending with lower-priority animations.",
  T_48_META_API_3315: "Play Character Animation Clip Override",
  T_48_META_API_3315_D: "Play a character animation clip with the option to override the game's default animation",
  T_48_META_API_3315_P3: "Override Gameplay Control",
  T_48_META_API_3315_P3_D: "Whether to override the default animation of the game",
  T_48_META_API_3316: "Stop Animation",
  T_48_META_API_3316_D: "Stop playing the animation for the target in the specified status",
  T_48_META_API_90_P1: "Can Quit Midway",
  T_48_META_API_93: "Create Along Path Motion",
  T_48_META_API_93_D: "Create an interpolated movement along a path to make the object move along the specified path",
  T_48_META_API_93_P1: "Path",
  T_48_META_API_93_P1_D: "The path of motion",
  T_48_META_API_93_P3_D: "The magnitude of velocity",
  T_48_META_API_93_P4: "Tangent Facing",
  T_48_META_API_93_P4_D: "Whether the object is facing the direction of movement. This property remains unchanged even if the object's orientation is forcibly modified by other means.",
  T_48_META_API_96: "Instantiate Prefab",
  T_48_META_API_96_D: "Create a prefab instance with the option to process it asynchronously",
  T_48_META_API_96_P2: "Async Load",
  T_48_META_API_96_P2_D: "Whether loading is asynchronous",
  T_48_META_EVT_3140: "On Change Team",
  T_48_META_EVT_3140_D: "Triggers when the team of the current entity changes",
  T_48_META_EVT_3140_P0: "Former Team",
  T_48_META_EVT_3140_P0_D: "The team one belonged to before the change",
  T_48_META_EVT_3140_P1: "Current Team",
  T_48_META_EVT_3140_P1_D: "The team one belongs to after the change",
  T_48_META_EVT_3141: "On Plot Start",
  T_48_META_EVT_3141_D: "Triggers when the plot starts to play",
  T_48_META_EVT_3141_P1: "Plot ID",
  T_48_META_EVT_3141_P1_D: "The plot ID",
  T_48_META_EVT_3142: "On Plot End",
  T_48_META_EVT_3142_D: "Triggers when the plot ends",
  T_48_META_EVT_3142_P0_D: "The triggering player",
  T_48_META_EVT_3142_P1_D: "The plot ID",
  T_48_META_EVT_3143: "On Trigger Plot Option",
  T_48_META_EVT_3143_D: "Triggers when an option is selected in the plot",
  T_48_META_EVT_3143_P1_D: "The plot ID",
  T_48_META_EVT_3143_P2: "Option ID",
  T_48_META_EVT_3143_P2_D: "The ID of the option selected",
  T_48_META_TYP_409_I10: "Change Team Failed_Invalid Team",
  T_48_META_TYP_409_I11: "Change Team Failed_Eliminated",
  T_48_META_TYP_409_I12: "Change Team Failed_In Vehicle",
  T_48_META_TYP_409_I7: "Change Team Failed_Not Supported",
  T_48_META_TYP_409_I8: "Change Team Failed_Already In Team",
  T_48_META_TYP_409_I9: "Change Team Failed_Invalid Target",
  T_48_META_TYP_41_I19: "Disable Collider",
  T_48_META_TYP_417: "Particles",
  T_48_META_TYP_428: "Player Transform or NPC Outfit",
  T_48_META_TYP_431: "Along Path Motion",
  T_48_META_TYP_431_I1: "Path",
  T_48_META_TYP_432: "Custom Curve Path Waypoint",
  T_48_META_TYP_432_I0: "Roll",
  T_48_META_TYP_432_I1: "Tangent",
  T_48_META_TYP_433: "Custom Curve Path Type",
  T_48_META_TYP_433_I0: "Linear",
  T_48_META_TYP_433_I1: "Smooth",
  T_48_META_TYP_433_I2: "Custom",
  T_48_META_TYP_434: "Custom Curve Path",
  T_48_META_TYP_434_I2: "Closed Loop",
  T_48_META_TYP_434_I3: "Waypoints",
  T_48_META_TYP_437_I5: "Score Type Names",
  T_48_META_TYP_437_I6: "Left Score Content",
  T_48_META_TYP_437_I7: "Right Score Content",
  T_48_META_TYP_438_I1: "Players",
  T_48_META_TYP_438_I2: "Ranks",
  T_48_META_TYP_438_I3: "Total Scores",
  T_48_META_TYP_438_I4: "Score Type Names",
  T_48_META_TYP_438_I5: "Colors",
  T_48_META_TYP_438_I6: "Scores",
  T_48_META_TYP_439: "Group",
  T_48_META_TYP_442_I1: "Left Score",
  T_48_META_TYP_442_I10: "Right Eliminated Icon",
  T_48_META_TYP_442_I2: "Right Score",
  T_48_META_TYP_442_I3: "Left Alive Number",
  T_48_META_TYP_442_I4: "Right Alive Number",
  T_48_META_TYP_442_I5: "Left Eliminated Number",
  T_48_META_TYP_442_I6: "Right Eliminated Number",
  T_48_META_TYP_442_I7: "Left Alive Icon",
  T_48_META_TYP_442_I8: "Right Alive Icon",
  T_48_META_TYP_442_I9: "Left Eliminated Icon",
  T_48_META_TYP_444: "Language Type",
  T_48_META_TYP_444_I0: "English",
  T_48_META_TYP_444_I1: "Simplified Chinese",
  T_48_META_TYP_444_I10: "French",
  T_48_META_TYP_444_I11: "German",
  T_48_META_TYP_444_I12: "Turkish",
  T_48_META_TYP_444_I13: "Hindi",
  T_48_META_TYP_444_I14: "Japanese",
  T_48_META_TYP_444_I15: "Romanian",
  T_48_META_TYP_444_I16: "Arabic",
  T_48_META_TYP_444_I17: "Burmese",
  T_48_META_TYP_444_I18: "Urdu",
  T_48_META_TYP_444_I19: "Bengali",
  T_48_META_TYP_444_I2: "Traditional Chinese",
  T_48_META_TYP_444_I3: "Thai",
  T_48_META_TYP_444_I4: "Vietnamese",
  T_48_META_TYP_444_I5: "Indonesian",
  T_48_META_TYP_444_I6: "Portuguese",
  T_48_META_TYP_444_I7: "Spanish",
  T_48_META_TYP_444_I8: "Russian",
  T_48_META_TYP_444_I9: "Korean",
  T_48_SD_ERROR_DIVISOR: "Divisor cannot be 0",
  T_48_SD_ERROR_KEY_NOTINMAP: "The specified key does not exist in map: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "List index out of range: {0}",
  T_48_SD_SK_WARNING: "Did not found {1} in {0}",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: 'Since the attribute "IsServerDriven" of the Craftland character controller {0} is disabled, the related server API does not take effect.',
  T_48_XXJ_WS_PARENTERROR: "Failed to set parent",
  T_48_XXJ_WS_PERFORMANCE: "Performance",
  T_48_XXJ_WS_TANGENT: "Tangent",
  T_48_XXJ_WS_WAYPOINT: "Waypoint",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "List of objects",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "Use Custom Minimap",
  T_48_XYL_UGC_HIDEMINIMAP: "Hide Minimap HUD",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "Basic Custom Surface",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "Cylinder Cutout",
  T_48_XYL_WS_BASICHEMISPHERE: "Basic Hemisphere",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "Quarter Torus",
  T_48_XYL_WS_BASICQUARTERTORUS: "Quarter Square Torus",
  T_48_XYL_WS_BASICROUNDEDTORUS: "Torus",
  T_48_XYL_WS_BASICTRIANGLE: "Triangle Surface",
  T_48_XYL_WS_MAPPLAYERSTIPS: "Match players = Number of teams x Number of players per team. The more match players, the longer the matchmaking time",
  T_48_XYL_WS_MAPPLAYERSWARNING: "A high number of match players may lead to longer matchmaking time",
  T_49_HL_CL_CREATOR_LABEL2: "Craftland Community Talent",
  T_49_HL_CL_MAPS_LABEL2: "Map Winner",
  T_49_HL_CL_MAPS_LABEL3: "Gameplay Winner",
  T_49_HX_T_TUNG: "Tung Tung Tung",
  T_49_HZY_CONTROLLER_TRAJECTORY: "Trajectory",
  T_49_JH_WS_SKILLKASSIE: "Electro Therapy (Kassie)",
  T_49_JH_WS_SKILLKODA: "Aurora Vision (Koda)",
  T_49_JH_WS_SKILLOSCAR: "Valiant Dash (Oscar)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "Generate with AI",
  T_49_META_API_10065: "Switch Custom Camera",
  T_49_META_API_10067: "Get Current Custom Camera",
  T_49_META_API_10069: "Create Custom Camera",
  T_49_META_API_10070: "Set Custom Camera Culling Mask",
  T_49_META_API_10070_D: "Set the culling mask of the target camera to control visibility across all layers",
  T_49_META_API_10071: "Get Custom Camera Culling Mask",
  T_49_META_API_10071_D: "Get the culling mask of the target camera",
  T_49_META_API_10072: "Set Custom Camera Culling Mask Layer",
  T_49_META_API_10072_D: "Set the visibility of the target camera for a specific layer",
  T_49_META_API_10073: "Capture Screenshot",
  T_49_META_API_10073_D: "Capture screenshot (for internal testing)",
  T_49_META_API_106: "Get Server Timestamp (ms)",
  T_49_META_API_106_D: "Get the server timestamp with millisecond precision",
  T_49_META_API_107: "Timestamp to Localized String (ms)",
  T_49_META_API_107_D: "Convert timestamps (in ms) into strings based on certain formats",
  T_49_META_API_107_P0: "Timestamp (ms)",
  T_49_META_API_107_P0_D: "A timestamp in millisecond",
  T_49_META_API_108: "Lerp Vector3",
  T_49_META_API_108_D: "Perform linear interpolation from the 3D vector A to vector B",
  T_49_META_API_1089_P2: "Request ID",
  T_49_META_API_109: "Update Context to Persona",
  T_49_META_API_109_D: "Update the model context of a specified persona in the current room and overwrite the original context after execution.The context will influence the persona's interpretation of the background, history, or certain parameters for the current dialogue.",
  T_49_META_API_109_P1: "Context",
  T_49_META_API_109_P1_D: "Details of the context",
  T_49_META_API_110: "Feedback on Persona Response",
  T_49_META_API_110_D: "Submit feedback on the response content of a persona, which will be used to optimize our model.",
  T_49_META_API_110_P1: "Is Liked",
  T_49_META_API_110_P1_D: "Whether the response is liked or not. True = like.",
  T_49_META_API_1109: "Set Local Player Position",
  T_49_META_API_1109_D: "When the player is using classic game characters, this API can set the player's position.",
  T_49_META_API_1109_P0_D: "The target position",
  T_49_META_API_111: "Slerp Vector3",
  T_49_META_API_111_D: "Perform spherical interpolation from the 3D vector A to vector B for smooth rotation",
  T_49_META_API_1110: "Set Local Player Forward",
  T_49_META_API_1110_D: "When the player is using classic game characters, this API can set the direction the player is facing.",
  T_49_META_API_1110_P0_D: "The forward vector",
  T_49_META_API_112: "Roll Back Persona Memory",
  T_49_META_API_112_D: "Roll back the memory of a persona to before the specific response ID. All memory of the dialogues including and after the response will be cleared.",
  T_49_META_API_113: "Play One-Shot Sound",
  T_49_META_API_113_D: "Play a one-shot sound effect with adjustable volume",
  T_49_META_API_113_P0_D: "The sound effect resource ID to be played",
  T_49_META_API_113_P1: "Volume",
  T_49_META_API_113_P1_D: "The playback volume for the sound effect, ranging from 0 to 1.",
  T_49_META_API_97: "Create Skeleton Part Look-at Controller",
  T_49_META_API_97_D: "After creating a skeleton part look-at controller entity, you can use this entity to control the specified skeleton part and make it always face a specific target.",
  T_49_META_API_97_P0_D: "The skeleton part look-at controller entity. If the entity is destroyed, the look-at functionality will cease.",
  T_49_META_API_97_P1_D: "The skeleton part that is being controlled",
  T_49_META_API_97_P2_D: "The target that is being looked at",
  T_49_META_API_98: "Projection",
  T_49_META_API_98_D: "Calculate the projection of vector A onto vector B",
  T_49_META_API_99: "Get Local Timestamp (ms)",
  T_49_META_API_99_D: "Get the local timestamp with millisecond precision",
  T_49_META_EVT_16_P1_D: "Starting from 0, each outgoing request will consume a sequential numeric ID, such as for creating a room and clearing memory.",
  T_49_META_EVT_16_P2: "Response ID",
  T_49_META_EVT_16_P2_D: "Each complete response will have a unique ID",
  T_49_META_TYP_122_I19: "Custom Material",
  T_49_META_TYP_122_I19_D: "Allow for replacing the skybox with a custom material",
  T_49_META_TYP_14_I78_D: "Get or set the camera entity that is currently rendering the scene on the player's client. Note: The camera entity essentially represents the configuration data for controlling the client-side camera.",
  T_49_META_TYP_335_I9: "Elapsed Time (ms)",
  T_49_META_TYP_335_I9_D: "The playback duration of the sound effect in milliseconds. This property can only be accessed on the client side.",
  T_49_META_TYP_409_I13: "LLM_OK",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_Failed",
  T_49_META_TYP_409_I14_D: "LLM_Failed",
  T_49_META_TYP_409_I15: "LLM_Timeout",
  T_49_META_TYP_409_I15_D: "LLM_Timeout",
  T_49_META_TYP_409_I16: "LLM_Invalid_Persona",
  T_49_META_TYP_409_I16_D: "LLM_Invalid_PersonaOrRoom",
  T_49_META_TYP_409_I17: "LLM_Token_Limit",
  T_49_META_TYP_409_I17_D: "LLM_Token_Limit",
  T_49_META_TYP_409_I18: "LLM_Violation",
  T_49_META_TYP_409_I18_D: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19_D: "LLM_Frequent_Request",
  T_49_META_TYP_441: "Performance ID",
  T_49_META_TYP_445: "Playable Controller ID",
  T_49_META_TYP_446: "Playable Controller Attachable",
  T_49_META_TYP_446_I0: "Playable Controller",
  T_49_META_TYP_447: "Skeleton Part Controller",
  T_49_META_TYP_448: "Skeleton Part Look-at Controller",
  T_49_META_TYP_448_I0: "Controlled Target",
  T_49_META_TYP_448_I1: "Look-at Target",
  T_49_META_TYP_449: "Custom Camera",
  T_49_META_TYP_449_I2: "Orthographic Size",
  T_49_META_TYP_449_I2_D: "Control the size of the area visible to the camera",
  T_49_META_TYP_450: "Timestamp Localized String (ms)",
  T_49_META_TYPE_449_D: "A custom camera is fully controlled by the developer and determines what the player sees during gameplay",
  T_49_META_TYPE_450_D: "Format a millisecond-level timestamp into a readable text format",
  T_49_SD_SEARCH_ICONDESC: "Smart Association",
  T_49_SD_SEARCHKEY_ACTION: "Action",
  T_49_SD_SEARCHKEY_ANICLIPID: "Animation clip ID",
  T_49_SD_SEARCHKEY_AS: "As",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "Attachment ID",
  T_49_SD_SEARCHKEY_AUDIOENUM: "Sound effect type",
  T_49_SD_SEARCHKEY_BAGSKINID: "Backpack skin ID",
  T_49_SD_SEARCHKEY_BEZIER: "Bezier curve",
  T_49_SD_SEARCHKEY_BOOL: "Boolean",
  T_49_SD_SEARCHKEY_BREAK: "Break",
  T_49_SD_SEARCHKEY_BTREEID: "Behavior Tree ID",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "On button clicked",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "On button double clicked",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "On Button pressed",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "On button release",
  T_49_SD_SEARCHKEY_CLOTHENUM: "Outfit type",
  T_49_SD_SEARCHKEY_COLOR: "Color",
  T_49_SD_SEARCHKEY_COMMENT: "Comment note",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "Component enum",
  T_49_SD_SEARCHKEY_CONCANT: "Connect",
  T_49_SD_SEARCHKEY_CONTINUE: "Continue",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "Custom HUD",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "Custom hud widget",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "dynamic create level object type",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "Visual effects type",
  T_49_SD_SEARCHKEY_ENTITY: "Select scene object",
  T_49_SD_SEARCHKEY_FLOAT: "Float",
  T_49_SD_SEARCHKEY_FOR: "For index",
  T_49_SD_SEARCHKEY_FOREACH: "For each",
  T_49_SD_SEARCHKEY_FUNCTION: "Function",
  T_49_SD_SEARCHKEY_GETCSV: "Get CSV",
  T_49_SD_SEARCHKEY_GETREGISTERED: "Get registered asset by key",
  T_49_SD_SEARCHKEY_GETVALUE: "Get property value",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "Get global variable",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "Set Global Variable",
  T_49_SD_SEARCHKEY_IF: "If",
  T_49_SD_SEARCHKEY_IFELSE: "If else",
  T_49_SD_SEARCHKEY_IMGENUM: "Sprite Type",
  T_49_SD_SEARCHKEY_INT: "Integer",
  T_49_SD_SEARCHKEY_INTERNALHUD: "HUD type",
  T_49_SD_SEARCHKEY_ITEMENUM: "Item Type",
  T_49_SD_SEARCHKEY_LISTAPPEND: "List append",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "List append range",
  T_49_SD_SEARCHKEY_LISTCLEAR: "List clear",
  T_49_SD_SEARCHKEY_LISTCLONE: "List clone",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "List contain",
  T_49_SD_SEARCHKEY_LISTCREATE: "List create",
  T_49_SD_SEARCHKEY_LISTDELETE: "Delete List",
  T_49_SD_SEARCHKEY_LISTGET: "Get list",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "List index of",
  T_49_SD_SEARCHKEY_LISTINSERT: "List insert",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "List last index of",
  T_49_SD_SEARCHKEY_LISTLENGTH: "List length",
  T_49_SD_SEARCHKEY_LISTREVERSE: "List reverse",
  T_49_SD_SEARCHKEY_LISTSET: "Set list",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "List shuffle",
  T_49_SD_SEARCHKEY_LOCALKEY: "Localized key",
  T_49_SD_SEARCHKEY_LOCALVAR: "Local variable",
  T_49_SD_SEARCHKEY_LOGICAL: "And or",
  T_49_SD_SEARCHKEY_LOGINFO: "Log info print",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "dict get all keys map get all keys",
  T_49_SD_SEARCHKEY_MAPCLEAR: "clear dict clear map",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "dict contain key map contain key",
  T_49_SD_SEARCHKEY_MAPCREATE: "create dict create map",
  T_49_SD_SEARCHKEY_MAPGET: "get dict value by key get map value by key",
  T_49_SD_SEARCHKEY_MAPLENGTH: "dict length map length",
  T_49_SD_SEARCHKEY_MAPREMOVE: "remove dict remove map",
  T_49_SD_SEARCHKEY_MAPSET: "set dict value set map value",
  T_49_SD_SEARCHKEY_MATH: "add subtract multiply divide",
  T_49_SD_SEARCHKEY_NEWLIST: "New list",
  T_49_SD_SEARCHKEY_NULL: "Null",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "Number to string",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "Particles properties",
  T_49_SD_SEARCHKEY_PERSONA: "Persona",
  T_49_SD_SEARCHKEY_PI: "PI",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "Player Data ID",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "Character skill type",
  T_49_SD_SEARCHKEY_PREEFFECT: "Special sticker type",
  T_49_SD_SEARCHKEY_PREFAB: "Prefab",
  T_49_SD_SEARCHKEY_RAWID: "Raw ID",
  T_49_SD_SEARCHKEY_READSTATIS: "Read accumulated data",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "Resource uuid",
  T_49_SD_SEARCHKEY_RETURN: "Return",
  T_49_SD_SEARCHKEY_SCENEENUM: "Scene file",
  T_49_SD_SEARCHKEY_SCRIPTID: "Script",
  T_49_SD_SEARCHKEY_SETVALUE: "Set property value",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "Special item ID type",
  T_49_SD_SEARCHKEY_TEXT: "Text",
  T_49_SD_SEARCHKEY_TEXTUREID: "Texture type",
  T_49_SD_SEARCHKEY_THISENTITY: "This Entity",
  T_49_SD_SEARCHKEY_TIMELINE: "Timeline",
  T_49_SD_SEARCHKEY_TYPEENUM: "Any type",
  T_49_SD_SEARCHKEY_V2VCREATE: "Create Vector2",
  T_49_SD_SEARCHKEY_V2VGET: "Get Vector2 components",
  T_49_SD_SEARCHKEY_V2VOPERATION: "Vector2 operation add subtract multiply dot product  distance angle",
  T_49_SD_SEARCHKEY_V2VSET: "Set Vector2 components",
  T_49_SD_SEARCHKEY_V3VCREATE: "Create Vector3",
  T_49_SD_SEARCHKEY_V3VGET: "Get Vector3 components",
  T_49_SD_SEARCHKEY_V3VOPERATION: "Vector3 operation add subtract multiply dot product cross product distance angle",
  T_49_SD_SEARCHKEY_V3VSET: "Set Vector3 components",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "Vehicle skin ID",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "Weapon Skin ID",
  T_49_SD_SEARCHKEY_WHILE: "While",
  T_49_SD_SEARCHKEY_WRITESTATIS: "Write accumulated database offset",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "Write accumulated database offset by map code",
  T_49_XXJ_WS_DURATIONS: "Duration (s)",
  T_49_XXJ_WS_EDITPERFORMANCE: "Edit Performance",
  T_49_XXJ_WS_PERFORMANCE: "Performance",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "Delete Performance",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "Deleted performance cannot be restored, continue?",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "Editing {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "This name has already been used, please change it and try again",
  T_49_XXJ_WS_PERFORMANCENAME: "Performance Name",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "Add Key Frame",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "Add Sub-Track",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "Add Track",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "Delete Track",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "Actor Track",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "Event Track",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "Key Frame already exists",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "The corresponding actor track already exists",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "Content",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "Duplicate track names detected. Please change them and try again.",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "Please start recording or choose a key frame first",
  T_49_XXJ_WS_TIMELINE_RECORDING: "Recording...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "Delete Key Frame",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "Scene View",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "Select an object to create a track or tap the add-track button directly",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "Tap the add-track button to create a new track",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "Sub-Track",
  T_49_XXJ_WS_TIMELINE_TRACK: "Track",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "Track View",
  T_49_XYL_WS_DAILYPROPS: "Basic",
  T_49_XYL_WS_STOREGAMPLAY: "Gameplay",
  T_49_YU_QCITEM_ALL_11: "Tung Tung Tung Sahur!",
  T_50_H_M4A1_VA_N: "M4A1 - Trouble Academy",
  T_50_H_MACHETE_VA_N: "Parang - Trouble Academy",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "Leaderboard Fields",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "Overflow",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "Wrap around",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "Shrink font",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "Create Tuple",
  T_50_HJ_SEARCHKEY_TUPLEGET: "Get Tuple",
  T_50_HJ_SEARCHKEY_TUPLESET: "Set Tuple",
  T_50_HJ_TEXTOBGJ_H: "Height",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "Overflow Options",
  T_50_HJ_TEXTOBGJ_W: "Width",
  T_50_HZY_REVIEW_TEXTOBJ: "Text object content",
  T_50_JH_WS_HIDEMAPERROR: "Cannot hide minimap without a custom cover image",
  T_50_JH_WS_HIDEMAPTIP: "When minimap is hidden, it will no longer be used as the cover image",
  T_50_JH_WS_HIDEMINIMAP: "Hide Minimap",
  T_50_META_API_10073_P0: "File Name",
  T_50_META_API_10073_P0_D: "The file name",
  T_50_META_API_10073_P1_D: "The result of the execution. Check the Status Code enum.",
  T_50_META_API_1102: "Read Database Sheet Column Value",
  T_50_META_API_1102_D: "Read the value of a specific column for a given key from a standard database table",
  T_50_META_API_1102_P3: "Column Index",
  T_50_META_API_1102_P3_D: "The column index of the database table (0 = the first column)",
  T_50_META_API_1106: "Create Performance",
  T_50_META_API_1106_D: "Create a performance entity",
  T_50_META_API_1106_P0_D: "The performance asset",
  T_50_META_API_1111: "Read Database Leaderboard Association Value",
  T_50_META_API_1111_D: "Read the combination of values from a leaderboard table and its associated table in the database",
  T_50_META_API_1111_P5: "Association Status Code",
  T_50_META_API_1111_P5_D: "Association Error Code",
  T_50_META_API_1112: "Read Database Leaderboard Association Values by Range",
  T_50_META_API_1112_D: "Read values from the leaderboard table within a specified rank range, read the corresponding values by retrieved keys from the associated table, and combine them.",
  T_50_META_API_1112_P6: "Association Status Code",
  T_50_META_API_1112_P6_D: "Association Error Code",
  T_50_META_API_1113: "Write Database Leaderboard Association Value",
  T_50_META_API_1113_D: "Write the value for a given key into the leaderboard table and its related table in the database",
  T_50_META_API_1113_P5: "Association Status Code",
  T_50_META_API_1113_P5_D: "Association Error Code",
  T_50_META_API_114_D: "Create custom UI",
  T_50_META_API_114_P0_D: "The code is used as the parameter name for creating a UI entity, and its corresponding local variable value represents the created UI entity.",
  T_50_META_API_114_P1_D: "The player entity it belongs to, only visible to the player.",
  T_50_META_API_114_P2: "UI Asset ID",
  T_50_META_API_114_P2_D: "The custom UI asset ID",
  T_50_META_API_115_D: "Create the specified custom UI",
  T_50_META_API_116: "Set Level Object Highlight",
  T_50_META_API_116_D: "Set the highlight status of the object. It may be affected by other in-game logics.",
  T_50_META_API_116_P0_D: "Target Object",
  T_50_META_API_116_P1_D: "Highlight status",
  T_50_META_API_117: "Bitwise Common",
  T_50_META_API_117_D: "Bitwise and/or/xor/left shift/right shift",
  T_50_META_API_117_P0_D: "Left value",
  T_50_META_API_117_P1_D: "Right value",
  T_50_META_API_117_P2_D: "Operation Type",
  T_50_META_API_118: "Bitwise Not",
  T_50_META_API_118_D: "Bitwise NOT, also known as bitwise complement.",
  T_50_META_API_118_P0_D: "Value",
  T_50_META_API_119: "Bitwise List to Int",
  T_50_META_API_119_D: "Perform bitwise OR operation on all list elements and transform the output to an integer value.",
  T_50_META_API_119_P0: "Bit Array",
  T_50_META_API_119_P0_D: "Bitwise array",
  T_50_META_API_120: "Bitwise Int to List",
  T_50_META_API_120_D: "Covert the decimal values represented by bits at position 1 of an integer in its binary form to a list",
  T_50_META_API_120_P0_D: "Integer",
  T_50_META_API_121: "Quaternion Angle",
  T_50_META_API_121_D: "Calculate the angle between two quaternions",
  T_50_META_API_121_P0_D: "Quaternion 1",
  T_50_META_API_121_P1_D: "Quaternion 2",
  T_50_META_API_122: "Quaternion Dot",
  T_50_META_API_122_D: "Calculate the dot product of two quaternions",
  T_50_META_API_123: "Quaternion Inverse",
  T_50_META_API_123_D: "Calculate the inverse of a quaternion",
  T_50_META_API_123_P0_D: "Quaternion",
  T_50_META_API_124: "Quaternion From To Rotation",
  T_50_META_API_124_D: 'Calculate rotation quaternion from "from" to "to"',
  T_50_META_API_124_P0_D: "The start point",
  T_50_META_API_124_P1_D: "The end point",
  T_50_META_API_125: "Quaternion Rotate Towards",
  T_50_META_API_125_D: 'Calculate the rotation quaternion from "from" to "to". Max Degrees Delta is the max. rotation angle.',
  T_50_META_API_125_P0: "From",
  T_50_META_API_125_P0_D: "Initial quaternion",
  T_50_META_API_125_P1: "To",
  T_50_META_API_125_P1_D: "The target quaternion",
  T_50_META_API_125_P2: "Max. Degree Delta",
  T_50_META_API_125_P2_D: "The max. rotation angle",
  T_50_META_API_126: "Get Gyroscope Orientation",
  T_50_META_API_126_D: "Device orientation in 3D space, representing rotation angles around the three axes.",
  T_50_META_API_127: "Get Gyroscope Gravity",
  T_50_META_API_127_D: "The gravity component detected by the sensor on your device",
  T_50_META_API_128: "Get Gyroscope Rotation Rate",
  T_50_META_API_128_D: "This refers to the rotation rate of a device. It is a term related to the gyroscope sensors that describes the device's rotational movement speed in a three-dimensional space.",
  T_50_META_API_129: "Get Gyroscope Rotation Unbiased",
  T_50_META_API_129_D: "Describes the device's rotation rate and provides a more precise result by compensating for the noise or bias of the device's sensors.",
  T_50_META_API_130: "Get Gyroscope User Acceleration",
  T_50_META_API_130_D: "The part of the device's acceleration with the gravity component removed, which is the acceleration caused by user actions or external forces.",
  T_50_META_API_131: "Get Touch Info",
  T_50_META_API_131_D: "Get the specified index screen touch information (including position,  displacement, and change time).",
  T_50_META_API_131_P0_D: "Distribute touch point IDs, starting from 0",
  T_50_META_API_131_P1_D: "Touch position",
  T_50_META_API_131_P2: "Delta Position",
  T_50_META_API_131_P2_D: "The shift in position compared to the last frame",
  T_50_META_API_131_P3: "Delta Time",
  T_50_META_API_131_P3_D: "Time elapsed since last frame",
  T_50_META_API_132: "Get Screen Touch Count",
  T_50_META_API_132_D: "Get the current number of touch points on the screen",
  T_50_META_API_133: "Vibrate Device",
  T_50_META_API_133_D: "Make the device vibrate once",
  T_50_META_API_134_D: "Notify the target player device to play the audio",
  T_50_META_API_134_P0_D: "The target player",
  T_50_META_API_134_P1_D: "The audio asset",
  T_50_META_API_134_P2_D: "The playback speed (valid range: 0.1~3.0; 1 = normal, <1 = slow down, >1 = speed up)",
  T_50_META_API_135_D: "Play the one-time audio file",
  T_50_META_API_135_P0_D: "Audio resources",
  T_50_META_API_135_P1_D: "Play Speed",
  T_50_META_API_136: "Format String",
  T_50_META_API_136_D: "Format the strings",
  T_50_META_API_136_P0_D: "Formatted strings that use Go formatting verb controls",
  T_50_META_API_136_P1: "Parameters Array",
  T_50_META_API_136_P1_D: "Parameter List",
  T_50_META_API_137: "Paste Component",
  T_50_META_API_137_D: "Copy or add component data",
  T_50_META_API_137_P0: "Source",
  T_50_META_API_137_P0_D: "The source entity",
  T_50_META_API_137_P1_D: "Target Entity",
  T_50_META_API_137_P2: "Component Type",
  T_50_META_API_137_P2_D: "Component Type",
  T_50_META_API_137_P3: "Is Success",
  T_50_META_API_137_P3_D: "Whether it is successful or not",
  T_50_META_API_138: "Revive At Next Frame",
  T_50_META_API_138_D: "Revive at the next frame",
  T_50_META_API_139: "Eliminate at Next Frame",
  T_50_META_API_139_D: "Eliminate the battle entity at the next frame",
  T_50_META_API_139_P0_D: "The battle entity",
  T_50_META_API_140: "Quit Game at Next Frame",
  T_50_META_API_140_D: "Exit the game at the next frame",
  T_50_META_API_141: "Get Microphone Volume",
  T_50_META_API_141_D: "Get the microphone volume. Return the status when the player's microphone is off or no access is granted.",
  T_50_META_API_141_P0: "Volume",
  T_50_META_API_141_P0_D: "The microphone volume",
  T_50_META_API_141_P1_D: "Microphone is turned on or off",
  T_50_META_API_142: "Get Render Quality",
  T_50_META_API_142_D: "Get the current rendering quality (enum: Low/Medium/High/Ultra)",
  T_50_META_API_143: "Get Render Resolution",
  T_50_META_API_143_D: "Get the current render resolution",
  T_50_META_API_144: "Bind Custom Player",
  T_50_META_API_144_D: "Dynamically set the target that this player binds to that will override existing bindings. Returns false if failed.",
  T_50_META_API_144_P0: "Custom Player",
  T_50_META_API_144_P0_D: "After binding this Custom Player to the player, data such as position and direction will be automatically synced",
  T_50_META_API_144_P1_D: "Target Player",
  T_50_META_API_145: "Unbind Custom Player",
  T_50_META_API_145_D: "Cancel the binding. Returns false if failed.",
  T_50_META_API_145_P0: "Custom Player",
  T_50_META_API_145_P0_D: "Clear all bindings for this target. After unbinding, data such as position and direction will no longer be automcatically synced.",
  T_50_META_API_146_P0_D: "A custom player",
  T_50_META_API_147: "Set Custom Player State",
  T_50_META_API_147_D: "Automatically upload to the sever and sync with all clients. Returns false if failed.",
  T_50_META_API_147_P0: "Custom Player",
  T_50_META_API_147_P1: "State",
  T_50_META_API_147_P1_D: "Usually used to save the animation states. Get the synced state with Get Custom Player State.",
  T_50_META_API_148: "Get Custom Player State",
  T_50_META_API_148_D: "The state data is automatically synced to the server. Returns false if failed.",
  T_50_META_API_148_P0: "Custom Player",
  T_50_META_API_148_P1: "State",
  T_50_META_API_148_P1_D: "Set the state with Set Custom Player State",
  T_50_META_API_149: "Set Distance Volumes",
  T_50_META_API_149_D: "Set the distance ranges between players to dynamically set audio volume.",
  T_50_META_API_149_P0: "Distance List",
  T_50_META_API_149_P0_D: "A list of distance ranges, each corresponding to an element in the volume list.",
  T_50_META_API_149_P1: "Volume List",
  T_50_META_API_149_P1_D: "A list of volumes, each corresponding to an element in the distance list.",
  T_50_META_API_150: "Get Friends",
  T_50_META_API_150_D: "Get the list of the player's friend IDs",
  T_50_META_API_151: "Get Default UI Info",
  T_50_META_API_151_D: "Get the default UI location of the player",
  T_50_META_API_151_P0_D: "The default interface",
  T_50_META_API_151_P1_D: "Status",
  T_50_META_API_151_P2_D: "UI Position",
  T_50_META_API_151_P3: "Size",
  T_50_META_API_151_P3_D: "UI Size",
  T_50_META_API_152: "Broadcast Custom Event",
  T_50_META_API_152_D: "Broadcast a custom event for any entity to receive (listen to) this event",
  T_50_META_API_153: "Dispatch Event to Entity",
  T_50_META_API_153_D: "Send the custom event to the target entity",
  T_50_META_EVT_17: "On Screen Touch Begin",
  T_50_META_EVT_17_D: "Start the event when the screen is touched",
  T_50_META_EVT_17_P0: "Touch Index",
  T_50_META_EVT_17_P0_D: "Touch point index",
  T_50_META_EVT_17_P1_D: "Touch position",
  T_50_META_EVT_18: "On Screen Touch End",
  T_50_META_EVT_18_D: "End the event when the screen is touched",
  T_50_META_EVT_18_P0: "Touch Index",
  T_50_META_EVT_18_P0_D: "Touch point index",
  T_50_META_EVT_18_P1_D: "Touch positions on the screen",
  T_50_META_EVT_19: "On Receive Persona Create Room Result",
  T_50_META_EVT_19_D: "Receive the corresponding result when failed to create the persona chat room",
  T_50_META_EVT_19_P1: "Room ID",
  T_50_META_EVT_19_P1_D: "The room ID",
  T_50_META_EVT_20: "On User Quit or User Match End",
  T_50_META_EVT_20_D: "Trigger when the user quits the match or when the match ends",
  T_50_META_TYP_11_I44: "Distance Volumes",
  T_50_META_TYP_11_I44_D: "Dynamically adjust the audio volume based on the distance between players",
  T_50_META_TYP_22_I9_D: "The asset ID used to create the UI",
  T_50_META_TYP_244_I12_D: "The text box width",
  T_50_META_TYP_244_I13_D: "The text box height",
  T_50_META_TYP_244_I14_D: "The overflow type",
  T_50_META_TYP_335_I10_D: "The playback speed (valid value > 0, default = 1)",
  T_50_META_TYP_409_I20: "IO_Create_File_Failed",
  T_50_META_TYP_409_I20_D: "IO operation failed: an error occurred while creating the file.",
  T_50_META_TYP_409_I21: "IO_Invalid_File_Name",
  T_50_META_TYP_409_I21_D: "IO operation failed. Invalid file name.",
  T_50_META_TYP_448_I0_D: "The controlled skeleton part",
  T_50_META_TYP_448_I1_D: "The target that the skeleton part is looking at",
  T_50_META_TYP_451: "Overflow Type",
  T_50_META_TYP_451_D: "The method for handling text overflow",
  T_50_META_TYP_452: "Custom UI Asset ID",
  T_50_META_TYP_452_D: "The ID that describes the custom HUD asset",
  T_50_META_TYP_453: "Render Quality Type",
  T_50_META_TYP_453_D: "The rendering quality enum",
  T_50_META_TYPE_448_D: "This entity is used to control the skeleton part to look at a target",
  T_50_SD_WS_MAPTAG_AI3DGEN: "3D Object Generate Map",
  T_50_SD_WS_MAPTAG_AIRACING: "Racing AI Generate Map",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "Animation state name enum",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "Disable Footsteps Vibration",
  T_50_XXJ_WS_NOPERFORMANCE: "No performance file yet",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "Beta version",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "Dear creators, the performance editor is still in the testing phase. It may contain bugs or lack essential features. Please use it with caution.",
  T_50_XXJ_WS_PERFORMANCE_NEW: "Add Performance",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "Add Key Clip",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "Along Path Track",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "Animation",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "Animation Track",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "Audio Track",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "Hold",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "Loop Forever",
  T_50_XXJ_WS_TIMELINE_DURATION: "Duration: {0}s",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "Mismatch between animation and model",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "Key clip overlap",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "Bound entity missing",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "The track name cannot be empty",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "NPC Track",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "Property Track",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "Remove Key Clip",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0}s",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "Track count limit exceeded",
  T_50_XYL_WS_AIGETERATESHOW: "Building Blocks",
  T_50_YU_F_B_VA_WITCH: "Mystic Trouble (Bottom)",
  T_50_YU_F_H_VA_WITCH: "Mystic Trouble (Head)",
  T_50_YU_F_HA_VA_WITCH: "Mystic Trouble (Facepaint)",
  T_50_YU_F_S_VA_WITCH: "Mystic Trouble (Shoes)",
  T_50_YU_F_T_VA_WITCH: "Mystic Trouble (Top)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "Custom Event",
  T_51_GT_WS_BASIC: "Basic",
  T_51_GT_WS_GLOBALEVENT: "Global Event",
  T_51_GT_WS_PRIVATEEVENT: "Private Event",
  T_51_GT_WS_STORY: "Story",
  T_51_GT_WS_UI: "UI",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "User Message To Persona Voice Response",
  T_51_META_API_1114_D: "Send persona user's message and get a voice response from persona",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "System Message To Persona Voice Response",
  T_51_META_API_1115_D: "Send persona system message and get a voice response from persona",
  T_51_META_API_1116: "Play Stored Voice From Persona",
  T_51_META_API_1116_D: "Play stored voice reponses from persona. Can store up to 10 responses.",
  T_51_META_API_144_P2_D: "Whether the execution is successful",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Return the name of the target object's type",
  T_51_META_API_154_P0_D: "The target object to get type name for",
  T_51_META_API_155: "Get Bounding Box",
  T_51_META_API_155_D: "Get the Bounding Box of the scene object",
  T_51_META_API_155_P0_D: "The scene object to get the bounding box for",
  T_51_META_API_155_P1_D: "The center of the bounding box",
  T_51_META_API_155_P2: "Size",
  T_51_META_API_155_P2_D: "The size of the bounding box",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "The target entity to be created",
  T_51_META_API_156_P1_D: "The type of the created custom component",
  T_51_META_API_156_P2_D: "The owner of the entity",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Set Material Property",
  T_51_META_API_157_D: "This API allows you to modify certain properties of an object's material.",
  T_51_META_API_157_P0_D: "The target object to get the material property for",
  T_51_META_API_157_P1: "Property Name",
  T_51_META_API_157_P1_D: "Set the name of the property",
  T_51_META_API_157_P2: "Property Value",
  T_51_META_API_157_P2_D: "Set the value of the property",
  T_51_META_API_157_P3: "Success",
  T_51_META_API_157_P3_D: "Set whether it's successful or not",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "The target object to clear the material property for",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "When a monitored custom property changes, this event will trigger. Note: if a custom property is modified multiple times within a single frame, this event is only triggered once. When the server modifies a custom property, the event is sent to both endpoints; when a client modifies a local entity's custom property, the event is only delivered locally.",
  T_51_META_EVT_21_P0: "Property Index",
  T_51_META_EVT_21_P0_D: "The property's index",
  T_51_META_EVT_21_P1_D: "The property's new value",
  T_51_META_EVT_22: "On Custom Player State Changed",
  T_51_META_EVT_22_D: "This event will trigger when the state of the custom player changes",
  T_51_META_EVT_22_P0: "Custom Player State",
  T_51_META_EVT_22_P0_D: "The state of the custom player",
  T_51_META_EVT_23: "On Receive Voice Response From Persona",
  T_51_META_EVT_23_D: "Trigger this event when persona's voice response is received",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "Trigger this event when persona's voice response has finished playing",
  T_51_META_TYP_14_I79: "Bound Custom Player",
  T_51_META_TYP_14_I79_D: "When bound to a Custom Player, the classic character model is hidden, and the target object's position, rotation (facing), and other data are synchronized to it.",
  T_51_META_TYP_15_I6: "Is Show Teammate Name",
  T_51_META_TYP_15_I6_D: "Whether to show teammates' names on the top of their heads",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "Give Up",
  T_51_META_TYP_247_I32_D: "Give Up",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Out-of-zone damage per second",
  T_51_META_TYP_409_I22: "Parameter Error",
  T_51_META_TYP_409_I22_D: "Parameter error",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "Use to set the material property for an object",
  T_51_META_TYP_455: "Entity Flag",
  T_51_META_TYP_455_D: "The property flag for a specific entity, can be used in combination",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "Static",
  T_51_META_TYP_455_I1_D: "Static entity",
  T_51_META_TYP_455_I2: "Local",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "Render Only",
  T_51_META_TYP_455_I3_D: "Render only",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Raining",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Lightning",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Unboxing",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Set Entity Outline",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value between 0 and 1 (0 = fully transparent,1 = fully opaque)",
  T_51_TYC_API_OUTLINE_COLOR: "Outline Color",
  T_51_TYC_API_OUTLINE_COLOR_D: "The color used for drawing the outline",
  T_51_TYC_API_OUTLINE_D: "Specifies an entity to highlight its edges. Supported types include Player, Custom Render, NPC, Appearance, and Basic Appearance.",
  T_51_TYC_API_OUTLINE_TARGET: "Target Entity",
  T_51_TYC_API_OUTLINE_TARGET_D: "The entity to be outlined",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value between 0 and 1 (0 = no outline, 1 = max. outline thickness)",
  T_51_XJ_WS_BASIC_SETTING: "Basic Settings",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Second",
  T_51_XJ_WS_GMSTART_TIME: "Preparation time before game starts",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "Read-only Property",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "Schwarze Lederjacke (weiblich)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "Pilzjäger",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "Unbenannte Schwarz (Schuhe)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "GW2018 Hotpants (weiblich)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "GW2018 Rock (weiblich)",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "Unbenannte Schwarz (Hoodie)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "Typische Songkran Oberteil",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "Rosen und Pilze",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "GW2018 Weste (weiblich)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "Herzlichen Glückwunsch zum Geldverdienen",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "schwarze Sporthose (Männlich)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "Wilderer",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "Hose im Freien",
  TXT_AVATAR_MALE_PANTS_MARIO: "Mamamia",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "Segeltuchschuhe",
  TXT_AVATAR_MALE_SHOE_RED: "rote Boots (m)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "Blühender Wohlstand",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "Schwarze Sportjacke (Male)",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "Hoodie (Ziegelrot)",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "Kühles Schwarz(Hoodie)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "Mafia-Boss Hemd",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "Shirt im Freien",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "Romantisches Hemd eines Klempners",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "Racer Jacke (Weiblich)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "Nachtclown (Kopf)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "Racer Jacke (Männlich)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "Ärmellose Jacke (Grün)",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "Herr Squido",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "Zombified Samurai (Maske)",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "Voller Arm Tattoo",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "Selbst freigeben",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "Viktoria",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Flügel der PSI-Energien",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "Rosarot",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "Hong Ying",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "Eisgekühlt",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "Blaues Loch",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "Qian Benying",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "Delta",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Angelic Pant",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "Schattentänzer",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "Kriegselefant",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "Kalkstein",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "Schwarze Katastrophe",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "Xuan Tiexing",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "Aquamarin",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "Krieg endet",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "Aufsteigender Stern",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "Tenka",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "Weißer Hurrikan",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "Baseballspieler (Strumpfhose)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "Fahrer Jacke (Weiblich)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "Baseballspieler (Jacke)",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "Cooler Kapitän (Hose)",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "Die Straßen (Kopf)",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "Cooler Kapitän (Schuhe)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "Fahrer Jacke (Männlich)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "Cooler Kapitän (Jacke)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "Dino",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "Silberner Stiefel",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "Drei Löwen",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "Smoking (Maske)",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "Smoking (Kopf)",
  TXT_AVATAR_PARACHUTE_8: "Smiley",
  TXT_AVATAR_SHIRT_PLAID_2: "Programmierer Lieblings (Rot)",
  TXT_AVATAR_SHOES_1: "Turnschuhe (Weiß)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "Schuluniform (Begonia)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "Matrosenuniform (Rose)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "Schuluniform (Chrysantheme)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "Schuluniform (violett)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "Schuluniform (Jasmin)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "Schuluniform(grünblau)",
  TXT_AVATAR_TSHIRT_WEEK_007: "Leidenschaftlicher Sonntag",
  TXT_BANNER_NAME_MISHA: "Tempo",
  TXT_CHARACTER_ADAM_NAME: "Adam",
  TXT_CHARACTER_BODYGUARD_NAME: "Nikita",
  TXT_CHARACTER_COP_NAME: "Andrew",
  TXT_CHARACTER_EVA_NAME: "Eve",
  TXT_CHARACTER_NURSE_NAME: "Olivia",
  TXT_CHARACTER_RACERGIRL_NAME: "Misha",
  TXT_CHARACTER_RUNNER_NAME: "Kelly",
  TXT_CHARACTER_SEAMAN_NAME: "Ford",
  TXT_CLAN_NAME: "Name",
  TXT_COLLECTION_DESCRIPTION: "Beschreibung",
  TXT_COLLECTION_HEADPORTRAIT: "Avatar",
  TXT_INVENTORY_TITLE_EQUIPMENT: "Ausrüstung",
  TXT_ITEM_AK: "AK",
  TXT_ITEM_ARAMMO: "AR-Munition",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "Tasche Lv1",
  TXT_ITEM_BAG2: "Tasche Lv2",
  TXT_ITEM_BAG3: "Tasche Lv3",
  TXT_ITEM_BASEBALLPOLE: "Schläger",
  TXT_ITEM_BOWAMMO: "Armbrust Pfeil",
  TXT_ITEM_CHANGUO: "Pfanne",
  TXT_ITEM_CROSSBOW: "Armbrust",
  TXT_ITEM_DESC_FLASH: "Ein Sprengkörper, der die Sinne des Gegners vorübergehend desorientieren kann.",
  TXT_ITEM_EAGLE: "Desert Eagle",
  TXT_ITEM_FAK: "Erste-Hilfe-Ausrüstung",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "Faust",
  TXT_ITEM_FLASH: "Flashbang",
  TXT_ITEM_FOREGRIP1: "Handgriffe Lv1",
  TXT_ITEM_FOREGRIP2: "Handgriffe Lv2",
  TXT_ITEM_FOREGRIP3: "Handgriffe Lv3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "Granate",
  TXT_ITEM_GROZA: "GROZA",
  TXT_ITEM_HANDCANNON: "Hand Kanone",
  TXT_ITEM_HEATSIGHT: "Thermischer Scope",
  TXT_ITEM_HELMET1: "Helm Lv1",
  TXT_ITEM_HELMET2: "Helm Lv2",
  TXT_ITEM_HELMET3: "Helm Lv3",
  TXT_ITEM_HGAMMO: "HG-Munition",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "M79 Munition",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "Buschmesser",
  TXT_ITEM_MAGEZINE1: "Magazin Lv1",
  TXT_ITEM_MAGEZINE2: "Magazin Lv2",
  TXT_ITEM_MAGEZINE3: "Magazin Lv3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "Mündung Lv1",
  TXT_ITEM_MUZZLE2: "Mündung Lv2",
  TXT_ITEM_MUZZLE3: "Mündung Lv3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "SG Ammo",
  TXT_ITEM_SIGHT2: "2x Visier",
  TXT_ITEM_SIGHT4: "4x Visier",
  TXT_ITEM_SILENCER1: "Silencer",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "SMG Munition",
  TXT_ITEM_SNAMMO: "Scharfschütze Munition",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "Weste Lv1",
  TXT_ITEM_VEST2: "Weste Lv2",
  TXT_ITEM_VEST3: "Weste Lv3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "Ergebnis",
  TXT_MESSAGEBOX_ERROR: "Fehler",
  TXT_OB10_HQW_ITEM_BIPOD: "Zweibein",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "Öltank",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "Miguel",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "Verrückte Jägerin",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "Mexikanischer gegrillter Mais",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "Explosion Rechweite",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "Der Scharfrichter",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "Landmine",
  TXT_OB11_HQW_LANDMINE_DESC: "Eine Mine, die auf dem Boden eingesetzt werden kann. Achtung, treten Sie nicht selbst drauf!",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "Caroline",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "Beifall",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "Tupfen",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "Huhn",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "Hallo!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "LOL",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "Provozieren",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "Beim Halten einer Schrotflinte erhöht sich die Bewegungsgeschwindigkeit um {0}%",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "Sehr agil",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "Gepard: Fang",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "Futuristisch",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "Reparatursatz",
  TXT_OB5_HISTORY_HEADSHOOT: "Kopfschuss",
  TXT_OB5_HISTORY_LIVE: "am Leben",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "Maksim",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "{0}% Zeit für Essen der Pilze und medizinisches Paket reduzieren",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "Völlerei",
  TXT_OB7_ZC_CLAN_NICKNAME: "Kosename",
  TXT_OB7_ZJS_HISTORY_TIME: "Zeit",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "Lagerfeuer",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "Blitz",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "Kla",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "Faustschaden erhöht {0}%",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "Muay Thai",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "Lila Wiesen",
  TXT_OB8_ZXR_G18_CAMO_NAME: "Atom-Splitter",
  TXT_OB8_ZXR_M249_CAMO_NAME: "Withered",
  TXT_OB8_ZXR_M79_CAMO_NAME: "Skysplitter",
  TXT_OB8_ZXR_USP_CAMO_NAME: "Schneeleopard",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "Paloma",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "Waffenhandel",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "Grüner Star",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "Gloo Wand",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "Digitale Tarnung",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "Bloody Mary",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "Wüstenjäger",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "Blaue Flamme",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "Lila Parade",
  TXT_OB9_ZXR_M14_CAMO_NAME: "Lebensquelle",
  TXT_OB9_ZXR_M1873_NAME: "Tief blaues Meer",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "Schwertfisch",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "Erntearbeiter",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "Lila Quarz",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "Verbrannte Erde",
  TXT_OPTION_HIGH_BRIGHTNESS: "Bright",
  TXT_PLAYER_RANK: "RANG",
  TXT_ROOM_LOBBY_ID: "ID",
  TXT_ROOM_MAP_PARADISE: "Bermuda",
  TXT_SETTING_CHANGEWEAPON: "Quick Weapon Switch Button",
  TXT_SETTING_OB4_NOTREAL: "Dunkel",
  TXT_SKILL_DESC_COP: "Kugelsichere Ausrüstung reduziert um einen Prozentsatz von {0}%",
  TXT_SKILL_DESC_RUNNER: "Sprint Geschwindigkeitssteigerung um {0} %",
  TXT_SKILL_NAME_COP: "Rüstungsspezialist",
  TXT_SKILL_NAME_NURSE: "Heilende Berührung",
  TXT_SKILL_NAME_RACERGIRL: "Blitzschnell",
  TXT_SKILL_NAME_RUNNER: "Dashlauf",
  TXT_SKILL_NAME_SEAMAN: "Eiserner Wille",
  TXT_TUTORIAL_HUD: "Schnittstellen",
  TXT_TUTORIAL_HUD_LABEL10: "Sprinten",
  TXT_TUTORIAL_PICKUP_LABEL0: "Waffe",
  T_34_M_WS_VFXTYPE: "VFX-Typ",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "Angriffs-Ziel",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "Spielertyp-UI",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "Monstertyp-Fähigkeit",
  T_45_META_WS_DESCRIPTIVECOLOR: "Descriptive Color",
  T_45_META_WS_GAMETIME: "Game Time",
  T_45_META_WS_PROPERTY: "Property",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "Button-Stil-Typ",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "Button-Typ",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "Auslöser",
  T_46_META_WS_A_ACCOUNTID: "Ressource",
  T_46_META_WS_A_ACTIONTYPE: "Rechter Wert",
  T_46_META_WS_A_ACTIVE: "Position",
  T_46_META_WS_A_ANGLE: "Winkel",
  T_46_META_WS_A_ANY: "Beliebig",
  T_46_META_WS_A_APPEARANCEGROUP: "Zielposition",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "Assertion-Ausdruck",
  T_46_META_WS_A_ATTACHMENT: "Höhe",
  T_46_META_WS_A_ATTACHMENTS: "Länge",
  T_46_META_WS_A_ATTACKABLE: "Objekt",
  T_46_META_WS_A_ATTACKER: "Angreifer",
  T_46_META_WS_A_ATTACKTARGET: "Angriffszie",
  T_46_META_WS_A_AUTOPLAY: "Normal",
  T_46_META_WS_A_AXIS: "Beliebig",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "Basis",
  T_46_META_WS_A_BOUNDTARGET: "Gebundenes Ziel",
  T_46_META_WS_A_BTREE: "Verhaltensbaum",
  T_46_META_WS_A_BUFF: "Index",
  T_46_META_WS_A_CAMERA: "Missions-ID",
  T_46_META_WS_A_CAPICITY: "Kapazität",
  T_46_META_WS_A_CENTER: "Zentrum",
  T_46_META_WS_A_CHANGEROTATION: "Wert finden",
  T_46_META_WS_A_CHANNEL: "Kanal",
  T_46_META_WS_A_CHASEENEMY: "Linker Wert",
  T_46_META_WS_A_CHILD: "B",
  T_46_META_WS_A_COLOR: "Farbe",
  T_46_META_WS_A_COLUMN: "Links",
  T_46_META_WS_A_COLUMNNAME: "Rechts",
  T_46_META_WS_A_COMEBACK: "Zurückkehren",
  T_46_META_WS_A_COMPONENT: "Komponente",
  T_46_META_WS_A_CONTENT: "Inhalt",
  T_46_META_WS_A_COORDINATESYSTEM: "Filtertyp",
  T_46_META_WS_A_COUNT: "Anzahl",
  T_46_META_WS_A_COUNTS: "Anzahl",
  T_46_META_WS_A_CREATEDENTITY: "Erstellte Entität",
  T_46_META_WS_A_CROSSPLATFORM: "Plattformübergreifend",
  T_46_META_WS_A_CULLINGMASK: "Culling-Maske",
  T_46_META_WS_A_CURVE: "Richtung",
  T_46_META_WS_A_CUSTOMTAG: "Anzahl",
  T_46_META_WS_A_CUTRADIUS: "Schnittradius",
  T_46_META_WS_A_DAMAGE: "Schaden",
  T_46_META_WS_A_DAMAGESEGMENTS: "Schadensabschnitte",
  T_46_META_WS_A_DEGREE: "Grad",
  T_46_META_WS_A_DELTA: "Wert B",
  T_46_META_WS_A_DEPTH: "Tiefe",
  T_46_META_WS_A_DESTVAL: "R",
  T_46_META_WS_A_DIFFICULTY: "Schwierigkeit",
  T_46_META_WS_A_DIRECTION: "Richtung",
  T_46_META_WS_A_DISABLE: "Radius",
  T_46_META_WS_A_DISPLACEMENT: "Brieftasche",
  T_46_META_WS_A_DISTANCE: "Inhalt",
  T_46_META_WS_A_DIVINGMAXSPEED: "Maximale Geschwindigkeit beim Tauchen",
  T_46_META_WS_A_DOTWEEN: "Tween ausführen",
  T_46_META_WS_A_DURATION: "Dauer (s)",
  T_46_META_WS_A_EMOTE: "Emote",
  T_46_META_WS_A_ENABLE: "Aktivieren",
  T_46_META_WS_A_ENDAREACENTER: "Endbereich-Mittelpunkt",
  T_46_META_WS_A_ENDAREARANGE: "Endbereich-Reichweite",
  T_46_META_WS_A_ENDPOSITION: "Endposition",
  T_46_META_WS_A_ENDRANK: "End-Rang",
  T_46_META_WS_A_EQUIPMENTS: "Rotation",
  T_46_META_WS_A_EVENTID: "Ereignis-ID",
  T_46_META_WS_A_EXPONENT: "Exponent",
  T_46_META_WS_A_FACTION: "Ziel",
  T_46_META_WS_A_FACTORTYPE: "Faktor-Typ",
  T_46_META_WS_A_FILTERTYPE: "Filtertyp",
  T_46_META_WS_A_FINALRADIUS: "Endradius",
  T_46_META_WS_A_FINDVALUE: "Wert finden",
  T_46_META_WS_A_FIXEDRANGE: "Tipps",
  T_46_META_WS_A_FOLLOWTARGET: "Ziel folgen",
  T_46_META_WS_A_FONTCOLOR: "Schriftfarbe",
  T_46_META_WS_A_FONTSIZE: "Schriftgröße",
  T_46_META_WS_A_FOOTBALL: "Objektniveau",
  T_46_META_WS_A_FORCE: "Eigenschaft",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "Zwangsfallschirmhöhe",
  T_46_META_WS_A_FORCEMODE: "Änderungsart",
  T_46_META_WS_A_FORWARD: "Richtung",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "Widget-ID",
  T_46_META_WS_A_HALFEXTENTS: "Eigenschafts-ID",
  T_46_META_WS_A_HEIGHT: "Höhe",
  T_46_META_WS_A_HEIGHTSEGMENTS: "Höhenabschnitte",
  T_46_META_WS_A_HITDISTANCE: "Trefferabstand",
  T_46_META_WS_A_HITDISTANCES: "Komponente",
  T_46_META_WS_A_HITENTITIES: "Stil",
  T_46_META_WS_A_HITENTITY: "Getroffene Entität",
  T_46_META_WS_A_HITNORMAL: "Treffer-Normalen",
  T_46_META_WS_A_HITNORMALS: "Ereignis-ID",
  T_46_META_WS_A_HITPOINTS: "Positionen",
  T_46_META_WS_A_HITPOSITION: "Getroffene Position",
  T_46_META_WS_A_INCLUDETRIGGER: "Zurückkommen",
  T_46_META_WS_A_INDEX: "Index",
  T_46_META_WS_A_INDEXS: "Indizes",
  T_46_META_WS_A_INITIALVELOCITY: "Offset",
  T_46_META_WS_A_INITRADIUS: "Anfangsradius",
  T_46_META_WS_A_INWALLET: "Eingabewallet",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "In die Brieftasche",
  T_46_META_WS_A_ISEXIST: "Existiert",
  T_46_META_WS_A_ISLOOP: "Startposition",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "Auf dem Bildschirm abgebildet",
  T_46_META_WS_A_ISPAUSE: "Pause",
  T_46_META_WS_A_ISSIDECOLLIDING: "Aus der Brieftasche",
  T_46_META_WS_A_ISSUCCESS: "Erfolg",
  T_46_META_WS_A_ISTOPCOLLIDING: "Geldtyp",
  T_46_META_WS_A_ITEM: "Gegenstand",
  T_46_META_WS_A_ITEMID: "Ist Pause",
  T_46_META_WS_A_ITEMS: "Gegenstände",
  T_46_META_WS_A_ITEMTYPE: "Emote",
  T_46_META_WS_A_JERSEYTYPE: "Trikottyp",
  T_46_META_WS_A_KEEPVELOCITY: "Token-ID",
  T_46_META_WS_A_KEY: "Schlüssel",
  T_46_META_WS_A_KEYCOLUMN: "Wert A",
  T_46_META_WS_A_KEYS: "Breite",
  T_46_META_WS_A_LAYER: "Ebene",
  T_46_META_WS_A_LAYERMASK: "Steckplatz",
  T_46_META_WS_A_LEFT: "Links",
  T_46_META_WS_A_LEFTVALUE: "Linker Wert",
  T_46_META_WS_A_LENGTH: "Länge",
  T_46_META_WS_A_LEVELOBJECT: "Level-Objekt",
  T_46_META_WS_A_LOG: "Winkel",
  T_46_META_WS_A_LOOKATTARGET: "Gegenstände",
  T_46_META_WS_A_LOOPTYPE: "Schaden",
  T_46_META_WS_A_MAINCOLOR1: "Phasenindex",
  T_46_META_WS_A_MAINCOLOR2: "Status",
  T_46_META_WS_A_MAPCODE: "Farbe",
  T_46_META_WS_A_MAPPEDPOSITION: "Abgebildete Position",
  T_46_META_WS_A_MAX: "Maximum",
  T_46_META_WS_A_MAXDISPLACEMENT: "Angreifer",
  T_46_META_WS_A_MAXDISTANCE: "Faktor-Typ",
  T_46_META_WS_A_MIN: "Minimum",
  T_46_META_WS_A_MISSIONID: "Missions-ID",
  T_46_META_WS_A_MISSIONPROGRESS: "Missionsfortschritt",
  T_46_META_WS_A_MODIFYTYPE: "Modifikationstyp",
  T_46_META_WS_A_MONEYTYPE: "Währungstyp",
  T_46_META_WS_A_MUST: "Muss",
  T_46_META_WS_A_NAME: "Eigentümer",
  T_46_META_WS_A_NEWVALUE: "Neuer Wert",
  T_46_META_WS_A_NODE: "Knoten",
  T_46_META_WS_A_NORMAL: "Normale",
  T_46_META_WS_A_NOT: "Nicht",
  T_46_META_WS_A_OBSERVER: "Beobachter",
  T_46_META_WS_A_OFFSET: "Offset",
  T_46_META_WS_A_OLDVALUE: "Alter Wert",
  T_46_META_WS_A_OPERATIOMETHOD: "Operation Methode",
  T_46_META_WS_A_OPTIONS: "Optionen",
  T_46_META_WS_A_OTHERCOLOR: "Erstellte Entität",
  T_46_META_WS_A_OUTFIT: "Startindex",
  T_46_META_WS_A_OUTFITS: "Trennung",
  T_46_META_WS_A_OUTWALLET: "Ausgabewallet",
  T_46_META_WS_A_OWNER: "Besitzer",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "Maximale Geschwindigkeit beim Fallschirmspringen",
  T_46_META_WS_A_PARAMS: "Parameter",
  T_46_META_WS_A_PARENT: "G",
  T_46_META_WS_A_PARENTWIDGET: "Angriffsziel",
  T_46_META_WS_A_PATH: "Anfangsradius",
  T_46_META_WS_A_PATHPOINTS: "Wegpunkte",
  T_46_META_WS_A_PHASEINDEX: "Phasenindex",
  T_46_META_WS_A_PLATFORM: "Plattform",
  T_46_META_WS_A_PLAYER: "Position",
  T_46_META_WS_A_PLAYSPEED: "Dauer (s)",
  T_46_META_WS_A_POSITION: "Position",
  T_46_META_WS_A_POSITIONS: "Positionen",
  T_46_META_WS_A_POSTION: "Position",
  T_46_META_WS_A_PREFAB: "Szenen-ID",
  T_46_META_WS_A_PROPERTY: "Eigenschaft",
  T_46_META_WS_A_PROPERTYID: "Eigenschafts-ID",
  T_46_META_WS_A_PURSUITTARGET: "Verfolgungsziel",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "Radius",
  T_46_META_WS_A_RANDOMDECAY: "Schlüssel",
  T_46_META_WS_A_RANDOMRANGE: "Zufallsbereich",
  T_46_META_WS_A_RANDOMRATIO: "Parameter",
  T_46_META_WS_A_RANGE: "Ausdruck für die Behauptung",
  T_46_META_WS_A_RANK: "Skalierung",
  T_46_META_WS_A_REALCOIN: "UI-ID",
  T_46_META_WS_A_REALNUMBER: "Reelle Zahl",
  T_46_META_WS_A_RESET: "Ziel verfolgen",
  T_46_META_WS_A_RESOURCE: "Ressource",
  T_46_META_WS_A_RESULT: "Muss",
  T_46_META_WS_A_RIGHT: "Rechts",
  T_46_META_WS_A_RIGHTVALUE: "Rechter Wert",
  T_46_META_WS_A_ROTATION: "Drehung",
  T_46_META_WS_A_ROW: "Maximum",
  T_46_META_WS_A_SAMPLEPOINT: "Stichprobepunkt",
  T_46_META_WS_A_SCALE: "Skalierung",
  T_46_META_WS_A_SCENEID: "Szenen-ID",
  T_46_META_WS_A_SCORE: "Punktzahl",
  T_46_META_WS_A_SCORENAME: "Punktzahlname",
  T_46_META_WS_A_SCREENPOSITION: "Bildschirmposition",
  T_46_META_WS_A_SCRIPT: "Endradius",
  T_46_META_WS_A_SEAT: "Sitz",
  T_46_META_WS_A_SEP: "Trennzeichen",
  T_46_META_WS_A_SEPSTR: "Trennzeichen",
  T_46_META_WS_A_SHEETNAME: "Minimum",
  T_46_META_WS_A_SHOPITEM: "Erfolg",
  T_46_META_WS_A_SHOWBACKGROUND: "Hintergrund anzeigen",
  T_46_META_WS_A_SHOWMATCHRESULT: "Zählungen",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "Nachricht bei Stornierung anzeigen",
  T_46_META_WS_A_SKILL: "Fähigkeit",
  T_46_META_WS_A_SKILLS: "Wert",
  T_46_META_WS_A_SKILLTARGET: "Fähigkeitsziel",
  T_46_META_WS_A_SKIN: "Haut",
  T_46_META_WS_A_SLOT: "Slot",
  T_46_META_WS_A_SRCVAL: "Grad",
  T_46_META_WS_A_SRCVALUE: "Ausgangswert",
  T_46_META_WS_A_STARTAREACENTER: "Startbereich-Mittelpunkt",
  T_46_META_WS_A_STARTAREARANGE: "Startbereich-Reichweite",
  T_46_META_WS_A_STARTINDEX: "Startindex",
  T_46_META_WS_A_STARTPOSITION: "Startposition",
  T_46_META_WS_A_STARTRANK: "Start-Rang",
  T_46_META_WS_A_STATE: "Wartezeit (s)",
  T_46_META_WS_A_STATUS: "Status",
  T_46_META_WS_A_STATUSCODE: "Statuscode",
  T_46_META_WS_A_STYLE: "Stil",
  T_46_META_WS_A_SURFINGMAXSPEED: "Maximale Geschwindigkeit beim Surfen",
  T_46_META_WS_A_TARGET: "Ziel",
  T_46_META_WS_A_TARGETPOSITION: "Zielposition",
  T_46_META_WS_A_TEAMSEQ: "Vorwärts",
  T_46_META_WS_A_THRESHOLD: "Kanal",
  T_46_META_WS_A_TIMESTAMP: "Zeitstempel",
  T_46_META_WS_A_TIPS: "Tipps",
  T_46_META_WS_A_TITLE: "Titel",
  T_46_META_WS_A_TOKENCOUNT: "Tokenanzahl",
  T_46_META_WS_A_TOKENID: "Token-ID",
  T_46_META_WS_A_TORQUE: "Existiert",
  T_46_META_WS_A_TOUCHPOINT: "Berührungspunkt",
  T_46_META_WS_A_TRANSITIONTIME: "Tokenanzahl",
  T_46_META_WS_A_TRANSITIONTYPE: "Missionsfortschritt",
  T_46_META_WS_A_TRIGGER: "Auslöser",
  T_46_META_WS_A_TYPE: "Typ",
  T_46_META_WS_A_UI: "Verfolgungsziel",
  T_46_META_WS_A_UIID: "UI-ID",
  T_46_META_WS_A_UPWARD: "Trikottyp",
  T_46_META_WS_A_VALUE: "Wert",
  T_46_META_WS_A_VALUEA: "Wert A",
  T_46_META_WS_A_VALUEB: "Wert B",
  T_46_META_WS_A_VALUES: "Schneidradius",
  T_46_META_WS_A_VALUET: "Nicht",
  T_46_META_WS_A_VALUETYPE: "Werttyp",
  T_46_META_WS_A_VEHICLE: "Fahrzeug",
  T_46_META_WS_A_VEHICLESKIN: "Fahrzeug-Haut",
  T_46_META_WS_A_VELOCITY: "Zentrum",
  T_46_META_WS_A_VELOCITYXZ: "Neuer Wert",
  T_46_META_WS_A_VELOCITYY: "Alter Wert",
  T_46_META_WS_A_VISIBLE: "Sichtbar",
  T_46_META_WS_A_WAITTIME: "Wartezeit (s)",
  T_46_META_WS_A_WALLET: "Brieftasche",
  T_46_META_WS_A_WEAPON: "Trennzeichen",
  T_46_META_WS_A_WEAPONSKIN: "Indizes",
  T_46_META_WS_A_WIDGETID: "Widget-ID",
  T_46_META_WS_A_WIDGETTYPE: "Aktivieren",
  T_46_META_WS_A_WIDTH: "Breite",
  T_46_META_WS_A_WORLDPOSITION: "Weltposition",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "Typ",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "Absolutwert",
  T_46_META_WS_ACOS: "Acos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "AOI Spezialfolge hinzufügen",
  T_46_META_WS_ADDATTACHMENTS: "Anhänge hinzufügen",
  T_46_META_WS_ADDBUFF: "Buff hinzufügen",
  T_46_META_WS_ADDCOMPONENT: "Komponente hinzufügen",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "Fußballgeschwindigkeit hinzufügen",
  T_46_META_WS_ADDFORCE: "Kraft hinzufügen",
  T_46_META_WS_ADDFORCEATPOSITION: "Kraft an Position hinzufügen",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "Formel-Property-Faktor hinzufügen",
  T_46_META_WS_ADDGAMEEVENTLOG: "Spielereignisprotokoll hinzufügen",
  T_46_META_WS_ADDHP: "HP hinzufügen",
  T_46_META_WS_ADDITEM: "Item hinzufügen",
  T_46_META_WS_ADDITEMINSCENE: "Item in Szene erstellen",
  T_46_META_WS_ADDITEMTOSHOPITEM: "Artikel zu Artikel hinzufügen",
  T_46_META_WS_ADDMONEY: "Geld hinzufügen",
  T_46_META_WS_ADDSCRIPT: "Script hinzufügen",
  T_46_META_WS_ADDTAG: "Tag hinzufügen",
  T_46_META_WS_ADDTOKEN: "Token hinzufügen",
  T_46_META_WS_ADDTORQUE: "Drehmoment hinzufügen",
  T_46_META_WS_ADDUSEREVENTLOG: "Benutzerereignisprotokoll hinzufügen",
  T_46_META_WS_ANGEL: "Winkel",
  T_46_META_WS_APPEND: "Anfügen",
  T_46_META_WS_APPENDRANGE: "Bereich hinzufügen",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "Konfiguration für vorzeitigen Ausstieg anwenden",
  T_46_META_WS_ASIN: "Asin",
  T_46_META_WS_ASSERT: "Überprüfen",
  T_46_META_WS_ASSISTPLAYER: "Assist-Spieler",
  T_46_META_WS_ATAN2: "ATan2",
  T_46_META_WS_ATTACKER: "Angreifer",
  T_46_META_WS_ATTACKTARGET: "Angriffsziel",
  T_46_META_WS_AXISANGLETOQUATERNION: "Achswinkel in Quaternion umwandeln",
  T_46_META_WS_BOXCAST: "Box-Cast",
  T_46_META_WS_BOXOVERLAP: "Box-Überlappung",
  T_46_META_WS_BUTTONNAME: "Tastenname",
  T_46_META_WS_C_ACTIONTYPE: "Aktionstyp",
  T_46_META_WS_C_AIMABLE: "Zielbarer Bestandteil",
  T_46_META_WS_C_AIMASSISTABLE: "Zielhilfe-fähiger Bestandteil",
  T_46_META_WS_C_AIMASSISTTYPE: "Zielhilfe-Typ",
  T_46_META_WS_C_AIRDROP: "Luftabwurf",
  T_46_META_WS_C_AMMO: "Munition",
  T_46_META_WS_C_AMMOTYPE: "Munitionstyp",
  T_46_META_WS_C_AMPHIBIAN: "Amphibienfahrzeug",
  T_46_META_WS_C_ANIMATIONCLIP: "Animations-Clip",
  T_46_META_WS_C_ANIMATIONCLIPID: "Animationsclip-ID",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "Animations-Controller",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "Anordnungskontroller anbringbar",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "Animationscontroller-ID",
  T_46_META_WS_C_ANIMATIONSTATE: "Animationszustand",
  T_46_META_WS_C_ANIMATIONTRIGGER: "Animationsauslöser",
  T_46_META_WS_C_APPEARENCE: "Erscheinung",
  T_46_META_WS_C_ASSETCONFIGID: "Asset-Konfigurations-ID",
  T_46_META_WS_C_ASSETID: "Asset-ID",
  T_46_META_WS_C_ATTACHMENT: "Anbaugerät",
  T_46_META_WS_C_ATTACKABLETYPE: "Angreifbarer Typ",
  T_46_META_WS_C_AUDIOID: "Audio-ID",
  T_46_META_WS_C_BACKPACK: "Rucksack",
  T_46_META_WS_C_BACKPACKSKINID: "Rucksack-Skin-ID",
  T_46_META_WS_C_BASEDATAALIAS: "Basisdaten-Alias",
  T_46_META_WS_C_BASICAPPEARANCE: "Grundaussehen",
  T_46_META_WS_C_BASICCYLINDER: "Basis-Zylinder",
  T_46_META_WS_C_BASICSCALABLE: "Basis-Skalierbar",
  T_46_META_WS_C_BASICSPHERE: "Basis-Sphäre",
  T_46_META_WS_C_BATCHCOMBINERENDER: "Batch-Kombinieren-Renderer",
  T_46_META_WS_C_BEVTREE: "Verhalten-Baum",
  T_46_META_WS_C_BEVTREEATTACHABLE: "Verhalten-Baum-Anschließbar",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "Verhalten-Baum-Benutzerdefinierter Knoten",
  T_46_META_WS_C_BEVTREEID: "Verhalten-Baum-ID",
  T_46_META_WS_C_BEVTREENODESTATUS: "Verhalten-Baum-Knotenstatus",
  T_46_META_WS_C_BEVTREENODETYPE: "Verhalten-Baum-Knotentyp",
  T_46_META_WS_C_BEZIERCURVE: "Bezier-Kurve",
  T_46_META_WS_C_BOOL: "Bool",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "Bot-Schwierigkeitsgrad",
  T_46_META_WS_C_BOUNCINGTIRE: "Sprungreifen",
  T_46_META_WS_C_BUFFABLE: "Buffbar",
  T_46_META_WS_C_BUFFGENERATOR: "Buff-Generator",
  T_46_META_WS_C_BUFFTYPE: "Buff-Typ",
  T_46_META_WS_C_BUILTINRENDER: "Eingebautes Rendern",
  T_46_META_WS_C_BUILTINUI: "Eingebaute UI",
  T_46_META_WS_C_BUILTINUITYPE: "Eingebaute UI-Typ",
  T_46_META_WS_C_CAMERA: "Kamera",
  T_46_META_WS_C_CAMERABLOCKMODE: "Kamera Blockmodus",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "Kameraprojektionsmodus",
  T_46_META_WS_C_CAMERARAYCASTUI: "Kamera RayCast UI",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "Kamera-Übergangstyp",
  T_46_META_WS_C_CAMERATYPE: "Kameratyp",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Kamera-Sichtwinkel-Beschränkungstyp",
  T_46_META_WS_C_CAPSULETRIGGER: "Kapselauslöser",
  T_46_META_WS_C_CAR: "Auto",
  T_46_META_WS_C_CHARACTERCONTROLLER: "Charakter-Controller",
  T_46_META_WS_C_CHATCHANNEL: "Chat-Kanal",
  T_46_META_WS_C_CHATCHANNELTYPE: "Chat-Kanal-Typ",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "Checkpoint-Trigger",
  T_46_META_WS_C_COINGENERATOR: "Münz-Generator",
  T_46_META_WS_C_COLLECTIONID: "Sammlungs-ID",
  T_46_META_WS_C_COLLIDER: "Kollisionsobjekt",
  T_46_META_WS_C_COLLIDERCOLLECTION: "Collider-Form",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "Collider-Sammlung-ID",
  T_46_META_WS_C_COLORDRUM: "Farbdrommel",
  T_46_META_WS_C_COMBATABLE: "Kampffähig",
  T_46_META_WS_C_COMPONENT: "Komponente",
  T_46_META_WS_C_CONDITION: "Bedingung",
  T_46_META_WS_C_CONTAINER: "Container",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "Koordinatensystemtyp",
  T_46_META_WS_C_CROSSBOW: "Granatenarmbrust",
  T_46_META_WS_C_CSVID: "CSV-ID",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "Anpassbarer Trigger",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "Benutzerdefiniertes Objekt",
  T_46_META_WS_C_CUSTOMPATH: "Benutzerdefinierter Pfad",
  T_46_META_WS_C_CUSTOMUI: "Benutzerdefinierte UI",
  T_46_META_WS_C_CUSTOMUIID: "Benutzerdefiniertes UI-ID",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "Benutzerdefinierte UI oder Widget",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "Benutzerdefinierter UI-Widget-ID",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "Beschädigte Körperteilart",
  T_46_META_WS_C_DAMAGETYPE: "Schadensart",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "Tod- oder Unverwundbarkeits-Trigger",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "Zerstörbares Objekt",
  T_46_META_WS_C_DICE: "Würfel",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "Doppelsprung-Schuhe",
  T_46_META_WS_C_DRUMMUSIC: "Trommelmusik",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "Doppelwaffentyp",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "Allgemeines Level-Objekt",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "Dynamisch erstellbarer Level-Objekt-Typ",
  T_46_META_WS_C_DYNAMICFENCE: "Dynamischer Zaun",
  T_46_META_WS_C_EFFECT: "Effekt",
  T_46_META_WS_C_EFFECTCONTAINER: "Effekt-Container",
  T_46_META_WS_C_EFFECTID: "Effekt-ID",
  T_46_META_WS_C_EMOTETYPE: "Emote-Typ",
  T_46_META_WS_C_ENDPOINTTRIGGER: "Endpunkt-Trigger",
  T_46_META_WS_C_ENTITY: "Entität",
  T_46_META_WS_C_ENTITYORPREFABID: "Entität oder Prefab-ID",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "Ausrüstungszubehör",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "Ausrüstungsplatztyp",
  T_46_META_WS_C_EQUIPMENTTYPE: "Ausrüstungsart",
  T_46_META_WS_C_EVENTID: "Ereignis-ID",
  T_46_META_WS_C_FACTION: "Fraktion",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "Füllrichtung-Typ",
  T_46_META_WS_C_FILLTYPE: "Fülltyp",
  T_46_META_WS_C_FIRETYPE: "Feuerart",
  T_46_META_WS_C_FLOAT: "Gleitkommazahl",
  T_46_META_WS_C_FOLDWING: "Klappflügel",
  T_46_META_WS_C_FOLLOW: "Folgen",
  T_46_META_WS_C_FONTTYPE: "Schriftarttyp",
  T_46_META_WS_C_FOOTBALL: "Fußball",
  T_46_META_WS_C_FORCETYPE: "Kraft-Typ",
  T_46_META_WS_C_FORMULABLE: "Formulierbar",
  T_46_META_WS_C_FRAMESELFRELATIVE: "Selbst-bezogen pro Frame",
  T_46_META_WS_C_GAMERESULTTYPE: "Spielresultat-Typ",
  T_46_META_WS_C_GENDERTYPE: "Geschlecht",
  T_46_META_WS_C_GENERALSPAWNPOINT: "Allgemeiner Spawn-Punkt",
  T_46_META_WS_C_GRENADEDEICEWALL: "DeIce-Wand-Granate",
  T_46_META_WS_C_GRENADEFLASHBANG: "Blendgranate",
  T_46_META_WS_C_GRENADEFROZEN: "Frostgranate",
  T_46_META_WS_C_GRENADELAUNCHER: "Granatenwerfer",
  T_46_META_WS_C_GRENADESMOKE: "Rauchgranate",
  T_46_META_WS_C_GRENADEWEAPON: "Granatenbasis",
  T_46_META_WS_C_GRID: "Raster",
  T_46_META_WS_C_HANDCANNON: "Handkanone-Granate",
  T_46_META_WS_C_HELMET: "Helm",
  T_46_META_WS_C_HIERARCHICAL: "Hierarchisch",
  T_46_META_WS_C_HOOKGUN: "Hakenpistole",
  T_46_META_WS_C_HORIZALINE: "Horizontale Linie",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "UI-Transformator",
  T_46_META_WS_C_HUMANMODELID: "Menschenmodell-ID",
  T_46_META_WS_C_ICEWALL: "Eismauer",
  T_46_META_WS_C_ICEWALLCREATED: "Erstellte Eismauer",
  T_46_META_WS_C_ICEWALLMAKER: "Eiswand-Ersteller",
  T_46_META_WS_C_ICON: "Icon-Entität",
  T_46_META_WS_C_ICONTYPE: "Symboltyp",
  T_46_META_WS_C_INHALER: "Inhalator",
  T_46_META_WS_C_INT: "Ganzzahl",
  T_46_META_WS_C_INT64: "Ganzzahl 64 Bit",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "Ganzzahl-Kartenvorlage",
  T_46_META_WS_C_INTORINTLIST: "Ganzzahl oder Ganzzahlliste",
  T_46_META_WS_C_INVENTORYTYPE: "Inventartyp",
  T_46_META_WS_C_ITEMBASE: "Basisobjekt",
  T_46_META_WS_C_ITEMCONTAINER: "Artikelbehälter",
  T_46_META_WS_C_ITEMID: "Objekt-ID",
  T_46_META_WS_C_ITEMIDTYPE: "Artikel-ID-Typ",
  "T_46_META_WS_C_JERSEY STYLE": "Trikot-Stil",
  T_46_META_WS_C_JERSEYMACHINE: "Trikotsmaschine",
  T_46_META_WS_C_JETSHOES: "Jet-Schuhe",
  T_46_META_WS_C_KEYBOARD: "Tastatur",
  T_46_META_WS_C_KNOCKDOWNTYPE: "Knockdown-Typ",
  T_46_META_WS_C_LANDMINE: "Landmine",
  T_46_META_WS_C_LANDMINECREATED: "Erstellte Mine",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "Startplatz-Level-Objekt",
  T_46_META_WS_C_LAUNCHPAD: "Startplatz",
  T_46_META_WS_C_LAYOUTSORTTYPE: "Layout-Sortierungstyp",
  T_46_META_WS_C_LEAD1MUSIC: "Lead1 Musik",
  T_46_META_WS_C_LEAD2MUSIC: "Lead2 Musik",
  T_46_META_WS_C_LEAD3MUSIC: "Lead3 Musik",
  T_46_META_WS_C_LEVELOBJECTID: "Level-Objekt-ID",
  T_46_META_WS_C_LEVELOBJECTTYPE: "Level-Objekt-Typ",
  T_46_META_WS_C_LIST: "Liste",
  T_46_META_WS_C_LISTORMAP: "Liste oder Karte",
  T_46_META_WS_C_LISTT: "Listen-Vorlage",
  T_46_META_WS_C_LISTT_BOOL: "Bool-Liste",
  T_46_META_WS_C_LISTT_CONDITION: "Bedingungen-Liste",
  T_46_META_WS_C_LISTT_ENTITY: "Entitätenliste",
  T_46_META_WS_C_LISTT_FLOAT: "Gleitkomma-Liste",
  T_46_META_WS_C_LISTT_INT: "Ganzzahl-Liste",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "Gegenstandsliste",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "Level-Objekt Liste",
  T_46_META_WS_C_LISTT_LOCKEY: "Lokalisierungsschlüssel-Liste",
  T_46_META_WS_C_LISTT_PLAYABLE: "Spielbare Liste",
  T_46_META_WS_C_LISTT_PLAYER: "Spielerliste",
  T_46_META_WS_C_LISTT_SKILLID: "Fähigkeit-ID-Liste",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "Soundeffektliste",
  T_46_META_WS_C_LISTT_STRING: "Zeichenfolgen-Liste",
  T_46_META_WS_C_LISTT_TEAM: "Teams-Liste",
  T_46_META_WS_C_LISTT_TYPE: "Typenliste",
  T_46_META_WS_C_LISTT_VECTOR3: "Vector3-Liste",
  T_46_META_WS_C_LOCKEY: "Lokalisierungsschlüssel",
  T_46_META_WS_C_LOOKAT: "Anschauen",
  T_46_META_WS_C_LOOPABLE: "Schleifenfähig",
  T_46_META_WS_C_LOOPTYPE: "Loop-Typ",
  T_46_META_WS_C_LOOTAMMOTYPE: "Beute-Patronen-Typ",
  T_46_META_WS_C_LOOTARMOR: "Beute-Rüstung",
  T_46_META_WS_C_LOOTARMORTYPE: "Beute-Rüstungs-Typ",
  T_46_META_WS_C_LOOTCONSUMABLE: "Beute-Verbrauchsmaterial",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "Beute-Verbrauchsmaterial-Typ",
  T_46_META_WS_C_LOOTIAMMO: "Beute-Patronen",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "Loot-Fußball-Box",
  T_46_META_WS_C_LOOTSCOPE: "Beute-Visier",
  T_46_META_WS_C_LOOTSCOPETYPE: "Beute-Visier-Typ",
  T_46_META_WS_C_LOOTSOCCERTYPE: "Loot-Fußballtyp",
  T_46_META_WS_C_LOOTTHROWABLE: "Beute-Wurfgegenstand",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "Beute-Wurfgegenstand-Typ",
  T_46_META_WS_C_LOOTWEAPON: "Beute-Waffe",
  T_46_META_WS_C_LOOTWEAPONTYPE: "Beute-Waffen-Typ",
  T_46_META_WS_C_LOWGRAVITY: "Niedrig-Schwerkraft-Bereich",
  T_46_META_WS_C_MAP: "Karte",
  T_46_META_WS_C_MAPT: "Karten-Vorlage",
  T_46_META_WS_C_MATERIALID: "Material-ID",
  T_46_META_WS_C_MEDKIT: "MedKit",
  T_46_META_WS_C_MESHID: "Mesh-ID",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "Spiel-Mitte-Austrittskonfiguration",
  T_46_META_WS_C_MINIMAP: "Mini-Map",
  T_46_META_WS_C_MINIMAPICON: "Mini-Map-Symbol",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "Minikarten-Pixel-Renderer",
  T_46_META_WS_C_MINISENTRY: "Mini-Sentry",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "Mini-Sentry-Angriffsreichweiten-Typ",
  T_46_META_WS_C_MINISENTRYCREATED: "Mini-Sentry erstellt",
  T_46_META_WS_C_MONEY: "Währung",
  T_46_META_WS_C_MONEYTYPE: "Währungs-Typ",
  T_46_META_WS_C_MONSTER: "Monster",
  T_46_META_WS_C_MONSTERSPAWN: "Monster-Spawn",
  T_46_META_WS_C_MONSTERTYPE: "Monstertyp",
  T_46_META_WS_C_MORPHABLEOBJECT: "Morphbares Objekt",
  T_46_META_WS_C_MORPHOBJECT: "Morphbares Objekt",
  T_46_META_WS_C_MOTOBIKE: "Motorrad",
  T_46_META_WS_C_MOVEPLATFORM: "Bewegliche Plattform",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "Bewegliche Plattform-Typ",
  T_46_META_WS_C_MUSHROOM: "Pilz",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "Natürliche Konstante",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "Zahl",
  T_46_META_WS_C_OBJECT: "Objekt",
  T_46_META_WS_C_OILDRUM: "Ölfass",
  T_46_META_WS_C_OUTFITID: "Outfit-ID",
  T_46_META_WS_C_OUTFITSLOTTYPE: "Outfit-Slot-Typ",
  T_46_META_WS_C_PATHPOINT: "Wegpunkt",
  T_46_META_WS_C_PATROLSTYLETYPE: "Patrouillenstil-Typ",
  T_46_META_WS_C_PATROLTYPE: "Patrouillentyp",
  T_46_META_WS_C_PERSONA: "Persona",
  T_46_META_WS_C_PHASE: "Phase",
  T_46_META_WS_C_PHYSICALMOVER: "Physikalischer Beweger",
  T_46_META_WS_C_PHYSICALOBJECT: "Physikalisches Objekt",
  T_46_META_WS_C_PLATFORMTYPE: "Plattformtyp",
  T_46_META_WS_C_PLAYABLE: "Spielbar",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "Spielbar oder Array von Spielbaren",
  T_46_META_WS_C_PLAYER: "Spieler",
  T_46_META_WS_C_PLAYERBACKPACK: "Spieler-Rucksack",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "Spielerverhaltensstatus-Typ",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "Spielerverhaltenstyp",
  T_46_META_WS_C_PLAYERCCT: "Charakter-Controller für FF",
  T_46_META_WS_C_PLAYERDATAID: "Vorgestellter Charaktertyp",
  T_46_META_WS_C_PLAYERORTRANSFORM: "Spieler oder Transform",
  T_46_META_WS_C_PLAYERORVEHICLE: "Spieler oder Fahrzeug",
  T_46_META_WS_C_PLAYEROUTFIT: "Spieler-Outfit",
  T_46_META_WS_C_PLAYERPOSETYPE: "Spielerpose-Typ",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "Spieler-Wiederbelebungsquelle Typ",
  T_46_META_WS_C_PLAYERSTATETYPE: "Spielerstatus-Typ",
  T_46_META_WS_C_POINTLIGHT: "Punktlicht",
  T_46_META_WS_C_PORTAL: "Portal",
  T_46_META_WS_C_PREFABID: "Prefab-ID",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "Effekt-Generator",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "Effekt-Textur-Typ",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "Profilbild-Widget",
  T_46_META_WS_C_PROPERTY: "Eigenschaft",
  T_46_META_WS_C_PROPERTYFORMULA: "Eigenschaftsformel",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "Eigenschaftsformel-Faktor-Typ",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "Eigenschaftsänderungs-Typ",
  T_46_META_WS_C_QUATERNION: "Quaternion",
  T_46_META_WS_C_RANKABLE: "Einstufbar",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "Raycast-Schicht-Typ",
  T_46_META_WS_C_REPAIRKIT: "Reparaturset",
  T_46_META_WS_C_RESETABLE: "Zurücksetzbar",
  T_46_META_WS_C_RIGIDBODY: "RigidBody",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "RigidBody-Einschränkungstyp",
  T_46_META_WS_C_RIGIDBODYTYPE: "RigidBody-Typ",
  T_46_META_WS_C_ROUND: "Runde",
  T_46_META_WS_C_SAFEZONE: "Sicherheitszone",
  T_46_META_WS_C_SCOREABLE: "Bewertbar",
  T_46_META_WS_C_SCRIPTID: "Script-ID",
  T_46_META_WS_C_SEATTYPE: "Sitztyp",
  T_46_META_WS_C_SELFRELATIVE: "Selbst-bezogen",
  T_46_META_WS_C_SHOP: "Laden",
  T_46_META_WS_C_SHOPITEM: "Laden-Artikel",
  T_46_META_WS_C_SHOPSHELF: "Laden-Regal",
  T_46_META_WS_C_SKATEBOARD: "Skateboard",
  T_46_META_WS_C_SKELETON: "Skelett",
  T_46_META_WS_C_SKELETONPART: "Skelettteil",
  T_46_META_WS_C_SKILLID: "Fähigkeit-ID",
  T_46_META_WS_C_SKYBLASTER: "Fluggerät",
  T_46_META_WS_C_SKYBOX: "Skybox",
  T_46_META_WS_C_SKYBOXTYPE: "Skybox-Typ",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "Soziale Insel Schneeball",
  T_46_META_WS_C_SORTTYPE: "Sortierart",
  T_46_META_WS_C_SOUNDDRUMTYPE: "Trommel-Soundtyp",
  T_46_META_WS_C_SOUNDEFFECT: "Soundeffekt",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "Soundeffekt oder Soundeffektliste",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "Soundeffect-Typ",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "Sound Lead1 Typ",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "Sound Lead2 Typ",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "Sound Lead3 Typ",
  T_46_META_WS_C_SOUNDPIANOTYPE: "Klavier-Soundtyp",
  T_46_META_WS_C_SPAWN: "Spawn",
  T_46_META_WS_C_SPAWNABLE: "Spawning",
  T_46_META_WS_C_SPAWNBOX: "Spawn-Box",
  T_46_META_WS_C_SPAWNPOSITION: "Spawn-Punkt",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "Sonderartikel-ID-Typ",
  T_46_META_WS_C_SPHERETRIGGER: "Kugelauslöser",
  T_46_META_WS_C_SPORTSCAR: "Sportwagen",
  T_46_META_WS_C_SPRAYCOLOR: "Sprühfarbe",
  T_46_META_WS_C_SPRAYGUN: "Sprühpistole",
  T_46_META_WS_C_SPRAYRESULTUI: "Sprüh-Ergebnis-UI",
  T_46_META_WS_C_SPRAYRIFLE: "Sprühgewehr",
  T_46_META_WS_C_SPRITEID: "Sprite-ID",
  T_46_META_WS_C_STATICSCRIPTID: "Statisches Skript-ID",
  T_46_META_WS_C_STRING: "Zeichenkette",
  T_46_META_WS_C_STRINGORLOCSTRING: "Zeichenfolge oder Lokalisierungszeichenfolge",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "Versorgungsbox-Trigger",
  T_46_META_WS_C_SWINGGUN: "Schwungwaffe",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "Ausrüstungsplatz wechseln",
  T_46_META_WS_C_TEAM: "Team",
  T_46_META_WS_C_TERRAIN: "Gelände",
  T_46_META_WS_C_TEXT: "Text-Entität",
  T_46_META_WS_C_TEXTUREID: "Textur-ID",
  T_46_META_WS_C_TEXTURETYPE: "Objekttextur",
  T_46_META_WS_C_TIMER: "Timer",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "Zeitstempel-Formatstiltyp",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "Zeitstempel-Lokalisierungszeichen",
  T_46_META_WS_C_TRAJECTORY: "Trajektorie",
  T_46_META_WS_C_TRANSFORM: "Transformieren",
  T_46_META_WS_C_TUKTUK: "Tuk Tuk",
  T_46_META_WS_C_TURRET: "Turm",
  T_46_META_WS_C_TWEEN: "Tween",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "Tween-Kurve",
  T_46_META_WS_C_TWEENSTYLE: "Tween-Stil-Typ",
  T_46_META_WS_C_TYPE: "Typ",
  T_46_META_WS_C_TYPEENUM: "Typ-Enum",
  T_46_META_WS_C_TYPEORTYPELIST: "Typ oder Typenliste",
  T_46_META_WS_C_UIADDSCORE: "UI-Punktzahl hinzufügen",
  T_46_META_WS_C_UIANITRIGGERHUD: "UI-Animationstrigger-HUD",
  T_46_META_WS_C_UIBUILTINSWITCH: "Eingebauter UI-Schalter",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "Eingebauter UI-Schalter-Controller",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "UI-Kartenauswahl-Panel",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "UI-Checkpoint-Anzeige",
  T_46_META_WS_C_UICOMPASS: "UI-Kompass",
  T_46_META_WS_C_UICOUNTDOWN5: "UI-5-Sekunden-Countdown",
  T_46_META_WS_C_UICOUNTDOWNHINT: "UI-Countdown-Hinweis",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "UI-Countdown-Erinnerung",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "Lebensanzeige über dem Kopf des Charakters",
  T_46_META_WS_C_UIHEALTHBAR: "UI-Gesundheitsbalken",
  T_46_META_WS_C_UIHEARTBEAT: "UI-Herzschlag",
  T_46_META_WS_C_UIICONNOTIFICATION: "UI-Symbolbenachrichtigung",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "UI-Identitätsbenachrichtigung",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "UI-Interaktionsschaltfläche",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "UI-Bestenliste-Schaltfläche",
  T_46_META_WS_C_UIMATCHSUBTITLE: "UI-Match-Untertitel",
  T_46_META_WS_C_UIMONSTERLEVEL: "UI-Monster-Level",
  T_46_META_WS_C_UIMONSTERUI: "UI-Monster-UI",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "UI-Multi-Team-Bestenliste",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "UI-Multi-Team-Ergebnis-Panel",
  T_46_META_WS_C_UIOPENINGBANNER: "UI-Öffnungsbanner",
  T_46_META_WS_C_UIPANEL: "UI-Panel",
  T_46_META_WS_C_UIPANELEMPTY: "Leeres UI-Panel",
  T_46_META_WS_C_UIPHASETIMER: "UI-Phasen-Timer",
  T_46_META_WS_C_UIPROGRESSBAR: "UI-Fortschrittsbalken",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "UI-Fortschrittskreis",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "UI-Fortschritts-Fähigkeitsschaltfläche",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "UI-Kaufanforderungstyp",
  T_46_META_WS_C_UIROUNDINFOBANNER: "UI-Runden-Info-Banner",
  T_46_META_WS_C_UIROUNDNUMBER: "UI-Rundenzahl",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "UI-Runden-Ergebnis-Banner",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "UI-Rundenstart-Banner",
  T_46_META_WS_C_UIROUNDTRANSITION: "UI-Rundenübergang",
  T_46_META_WS_C_UISCOREBAR: "UI-Punktleiste",
  T_46_META_WS_C_UISCROLLPANEL: "UI-Scroll-Panel",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "UI-Einfaches Rundenpunktestand-Banner",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "UI-Einfaches Rundenstart-Banner",
  T_46_META_WS_C_UISIMPLETIP: "Einfacher UI-Tipp",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "UI-Einfaches Versus-Banner",
  T_46_META_WS_C_UISKILLBUTTON: "UI-Fähigkeitsschaltfläche",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "Button-Widget für soziale Funktionen",
  T_46_META_WS_C_UISOLOLEADERBOARD: "UI-Solo-Bestenliste",
  T_46_META_WS_C_UISTORE: "UI-Store-UI",
  T_46_META_WS_C_UITEAMMATCHINFO: "UI-Team-Match-Info",
  T_46_META_WS_C_UITEXTTIP: "UI-Text-Tipp",
  T_46_META_WS_C_UITIMERINFO: "UI-Timer-Info",
  T_46_META_WS_C_UITIPBUTTON: "UI-Tippschaltfläche",
  T_46_META_WS_C_UITITLEBANNER: "UI-Titel-Banner",
  T_46_META_WS_C_UITWEENTIP: "UI-Tween-Tipp",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "UI-Zwei-Team-Kurzinformation",
  T_46_META_WS_C_UITWOTEAMINFO: "UI-Zwei-Team-Info",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "UI-Zwei-Team-Bestenliste",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "UI-Zwei-Team-Ergebnis-Panel",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "UI-Zwei-Team-Rundenpunktestand-Banner",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "UI-Zwei-Team-Punktestand-Panel",
  T_46_META_WS_C_UIVERSUSBANNER: "UI-Versus-Banner",
  T_46_META_WS_C_UIWIDGET: "UI-Widget",
  T_46_META_WS_C_UIWIDGETBUTTON: "UI-Widget-Schaltfläche",
  T_46_META_WS_C_UIWIDGETCONTAINER: "UI-Widget-Container",
  T_46_META_WS_C_UIWIDGETEMPTY: "Leeres UI-Widget",
  T_46_META_WS_C_UIWIDGETIMAGE: "UI-Widget-Bild",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "UI-Widget-Eingabefeld",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "UI-Widget-Joystick",
  T_46_META_WS_C_UIWIDGETLABEL: "UI-Widget-Beschriftung",
  T_46_META_WS_C_UIWIDGETLAYOUT: "UI-Widget-Layout",
  T_46_META_WS_C_UIWIDGETPROFILE: "UI-Widget-Profil",
  T_46_META_WS_C_UIWIDGETTEXTURE: "UI-Widget-Textur",
  T_46_META_WS_C_UIWIDGETTOGGLE: "UI-Widget-Umschalten",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "UI-Widget-Touchpad",
  T_46_META_WS_C_UIWINORLOSEBANNER: "UI-Sieg-oder-Niederlage-Banner",
  T_46_META_WS_C_UNITSPAWN: "Einheit-Spawn",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "Fensterkletterlogik-Objekt",
  T_46_META_WS_C_VECTOR2: "Vektor2",
  T_46_META_WS_C_VECTOR3: "Vektor3",
  T_46_META_WS_C_VEHICLE: "Fahrzeug",
  T_46_META_WS_C_VEHICLEIDTYPE: "Fahrzeug-ID-Typ",
  T_46_META_WS_C_VEHICLESKINID: "Fahrzeug-Skin-ID",
  T_46_META_WS_C_VENDINGMACHINE: "Verkaufsautomat",
  T_46_META_WS_C_VEST: "Weste",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "Ersetzbare Textur-VFX-Entität",
  T_46_META_WS_C_VFXTEXTURE: "VFX-Textur",
  T_46_META_WS_C_VISIBILITY: "Sichtbarkeit",
  T_46_META_WS_C_WALLET: "Geldbörse",
  T_46_META_WS_C_WALLETHUD: "Geldbörsen-UI",
  T_46_META_WS_C_WATERZONE: "Wasserzone",
  T_46_META_WS_C_WAVECOUNTTYPE: "Wellenzähltyp",
  T_46_META_WS_C_WAVEINTERVALTYPE: "Wellenintervalltyp",
  T_46_META_WS_C_WEAPON: "Waffe",
  T_46_META_WS_C_WEAPONGENERATOR: "Waffengenerator",
  T_46_META_WS_C_WEAPONSKINID: "Waffen-Skin-ID",
  T_46_META_WS_C_WEAPONTYPE: "Waffentyp",
  T_46_META_WS_C_WIDGETTYPE: "Widget-Typ",
  T_46_META_WS_C_ZIPLINE: "Seilbahn",
  T_46_META_WS_CAMERADIRECTION: "Kamerarichtung",
  T_46_META_WS_CAMERAPOSITION: "Kameraposition",
  T_46_META_WS_CAPSULECAST: "Kapsel-Cast",
  T_46_META_WS_CAPSULEOVERLAP: "Kapsel-Überlappung",
  T_46_META_WS_CEIL: "Aufrunden",
  T_46_META_WS_CHATCHANNEL: "Chat-Kanal",
  T_46_META_WS_CHECKTRIGGERBYORDER: "Trigger nach Reihenfolge überprüfen",
  T_46_META_WS_CLAMP: "Clamp",
  T_46_META_WS_CLEAR: "Leeren",
  T_46_META_WS_CLEARALLCHILDREN: "Alle Kinder löschen",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "AOI Spezialfolge löschen",
  T_46_META_WS_CLEARBACKPACK: "Rucksack leeren",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "Formel-Property-Faktor löschen",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "Übrig gebliebene Levelobjekte löschen",
  T_46_META_WS_CLIPNAME: "Clip-Name",
  T_46_META_WS_CLONE: "Klonen",
  T_46_META_WS_COLLIDEDENTITY: "Kollidierte Entität",
  T_46_META_WS_COLORGET: "Farbe abrufen",
  T_46_META_WS_COMPLETECUSTOMMISSION: "Benutzerdefinierte Mission abschließen",
  T_46_META_WS_CONNECT: "Verbinden",
  T_46_META_WS_CONSUMABLEID: "Gegenstands-ID",
  T_46_META_WS_CONTAIN: "Enthalten",
  T_46_META_WS_CONTAINKEY: "Schlüssel überprüfen",
  T_46_META_WS_COPYTOMORPH: "In Verwandlung kopieren",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "Geld kosten",
  T_46_META_WS_COSTTOKEN: "Token ausgeben",
  T_46_META_WS_CREATEAIRDROP: "Luftabwurf erstellen",
  T_46_META_WS_CREATEBOT: "Bot erstellen",
  T_46_META_WS_CREATEBUILTINUI: "Eingebaute UI erstellen",
  T_46_META_WS_CREATEBUILTINUICLIENT: "Eingebaute UI erstellen",
  T_46_META_WS_CREATECAMERA: "Kamera erstellen",
  T_46_META_WS_CREATECURVE: "Kurve erstellen",
  T_46_META_WS_CREATECUSTOMUI: "Benutzerdefinierte UI erstellen",
  T_46_META_WS_CREATECUSTOMUICLIENT: "Benutzerdefinierte UI erstellen",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "Benutzerdefiniertes UI-Widget erstellen",
  T_46_META_WS_CREATEDAMAGENUM: "Schadensnummer erstellen",
  T_46_META_WS_CREATEEFFECT: "Effekt erstellen",
  T_46_META_WS_CREATEEFFECTCLIENT: "Effekt erstellen",
  T_46_META_WS_CREATEFACTION: "Fraktion erstellen",
  T_46_META_WS_CREATEFOLLOW: "Folgen erstellen",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "Rahmen-Selbstbezug erstellen",
  T_46_META_WS_CREATEFROMPREFAB: "Aus Prefab erstellen",
  T_46_META_WS_CREATELEVELOBJECT: "Levelobjekt erstellen",
  T_46_META_WS_CREATELOOKAT: "Ansehen erstellen",
  T_46_META_WS_CREATEMINIMAPICON: "Mini-Map-Symbol erstellen",
  T_46_META_WS_CREATEMINIMAPPIXEL: "Mini-Map-Pixel erstellen",
  T_46_META_WS_CREATEMONSTER: "Monster erstellen",
  T_46_META_WS_CREATEMORPH: "Verwandlung erstellen",
  T_46_META_WS_CREATESELFRELATIVE: "Selbstbezug erstellen",
  T_46_META_WS_CREATESHOP: "Geschäft erstellen",
  T_46_META_WS_CREATESHOPITEM: "Artikel erstellen",
  T_46_META_WS_CREATESHOPSHELF: "Geschäftregal erstellen",
  T_46_META_WS_CREATESOUND: "Sound erstellen",
  T_46_META_WS_CREATESOUNDCLIENT: "Sound erstellen",
  T_46_META_WS_CREATETOKENINSCENE: "Token in der Szene erstellen",
  T_46_META_WS_CREATETRAJECTORY: "Trajektorie erstellen",
  T_46_META_WS_CREATETWEEN: "Tween erstellen",
  T_46_META_WS_CREATEWALLET: "Wallet erstellen",
  T_46_META_WS_CROSS: "Kreuz",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "CSV-Spaltenname in Ganzzahl umwandeln",
  T_46_META_WS_CURRENTAMMOCOUNT: "Aktuelle Munitionsanzahl",
  T_46_META_WS_DAMAGE: "Schaden",
  T_46_META_WS_DAMAGEDBODYPART: "Beschädigter Körperteil",
  T_46_META_WS_DAMAGEDPLAYERS: "Beschädigte Spieler",
  T_46_META_WS_DAMAGETYPE: "Schadensart",
  T_46_META_WS_DEALDAMAGE: "Schaden verursachen",
  T_46_META_WS_DELETE: "Löschen",
  T_46_META_WS_DELETEAT: "An bestimmten Position löschen",
  T_46_META_WS_DELETECUSTOMUI: "Benutzerdefinierte UI löschen",
  T_46_META_WS_DELETEFROMDATABASE: "Aus Datenbank löschen",
  T_46_META_WS_DELETEFROMDATASTORE: "Wert aus der Datenbank löschen",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "Aus Rangliste-Datenbank nach Schlüssel löschen",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "Aus Rangliste-Datenbank nach Rang löschen",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "Wert aus der Rangliste-Datenbank nach Schlüssel löschen",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "Wert aus der Rangliste-Datenbank nach Rang löschen",
  T_46_META_WS_DELETETAG: "Tag löschen",
  T_46_META_WS_DELTA: "Delta",
  T_46_META_WS_DESTROY: "Zerstören",
  T_46_META_WS_DESTROYBOT: "Bot zerstören",
  T_46_META_WS_DESTROYBUILTINUI: "Eingebaute UI zerstören",
  T_46_META_WS_DESTROYEQUIPMENT: "Ausrüstung zerstören",
  T_46_META_WS_DESTROYITEM: "Item zerstören",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "Richtung zu Euler-Winkel",
  T_46_META_WS_DISABLESAFEZONE: "Sicherheitszone deaktivieren",
  T_46_META_WS_DISPATCHEVENT: "Ereignis auslösen",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "Ereignis mit Plattform auslösen",
  T_46_META_WS_DISTANCE: "Abstand",
  T_46_META_WS_DOT: "Punkt",
  T_46_META_WS_DROPITEM: "Gegenstand fallen lassen",
  T_46_META_WS_DYEATAREA: "Auf Bereich färben",
  T_46_META_WS_DYEATPLANE: "Auf Fläche färben",
  T_46_META_WS_DYEATPOSITION: "An Position färben",
  T_46_META_WS_E_ABNORMALGRAVZONE: "Niedrig-Schwerkraft-Bereich",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "Beschleunigung",
  T_46_META_WS_E_ACTIONNODE: "Aktionsknoten",
  T_46_META_WS_E_ACTIVE: "Aktiv",
  T_46_META_WS_E_ACTIVESKILL: "Aktive Fähigkeit",
  T_46_META_WS_E_ADBOARD: "Werbetafel",
  T_46_META_WS_E_ADD: "Hinzufügen",
  T_46_META_WS_E_ADDFRIEND: "Freund hinzufügen",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "Zielen",
  T_46_META_WS_E_AIR: "Luft",
  T_46_META_WS_E_AIRCONDITIONERA: "Klimaanlage",
  T_46_META_WS_E_AIRDROP: "Luftabwurf, Zombie-Selbstmord",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "Lebendig",
  T_46_META_WS_E_AMMO: "Kugel VFX",
  T_46_META_WS_E_AMPHIBIANCAR: "Amphibienfahrzeug",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "Kinder Spielen",
  T_46_META_WS_E_AR: "Gewehr",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "AR-Munition",
  T_46_META_WS_E_ARMAGAZINE: "AR-Magazin",
  T_46_META_WS_E_ARMOR: "Rüstung",
  T_46_META_WS_E_ARMORBUFF: "Rüstungsbuff",
  T_46_META_WS_E_ARMORLV1: "Rüstung Lv1",
  T_46_META_WS_E_ARMORLV2: "Rüstung Lv2",
  T_46_META_WS_E_ARMORLV3: "Rüstung Lv3",
  T_46_META_WS_E_ARMORPIERCING: "Rüstung zerbrechen",
  T_46_META_WS_E_ARMORSPECIALIST: "Fähigkeit 1",
  T_46_META_WS_E_ARROW: "Pfeil",
  T_46_META_WS_E_ASC: "Aufsteigende Reihenfolge",
  T_46_META_WS_E_ASCIGNOREZERO: "Aufsteigende Reihenfolge Ohne Nullen",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "Gasexplosion",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "Aufsatz1 zur Kompatibilität",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "Aufsatz4 zur Kompatibilität",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "Aufsatz5 zur Kompatibilität",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "Aufsatz6 zur Kompatibilität",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "Aufsatz8 zur Kompatibilität",
  T_46_META_WS_E_ATTACK: "Angriff",
  T_46_META_WS_E_ATTACKGRENADE: "Angriffsgranate",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "Automatisch",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "Zurück",
  T_46_META_WS_E_BACKANDFORTH: "Hin und zurück",
  T_46_META_WS_E_BAG: "Tasche",
  T_46_META_WS_E_BAG1: "Tasche1",
  T_46_META_WS_E_BAG2: "Tasche2",
  T_46_META_WS_E_BAG3: "Tasche3",
  T_46_META_WS_E_BAMBOOA: "Bambus A",
  T_46_META_WS_E_BANANATREE: "Bananenbaum",
  T_46_META_WS_E_BASEBALLPOLE: "BaseballPole",
  T_46_META_WS_E_BASECOEFFICIENT: "Basis-Koeffizient",
  T_46_META_WS_E_BASIC: "Basis",
  T_46_META_WS_E_BASICCONE: "Grundlegender Kegel",
  T_46_META_WS_E_BASICCYLINDER: "Grundlegender Zylinder",
  T_46_META_WS_E_BASICSPHERE: "Grundlegende Kugel",
  T_46_META_WS_E_BATTLEINSTYLE: "Kampf im Stil",
  T_46_META_WS_E_BELL: "Glocke",
  T_46_META_WS_E_BENCH: "Bank",
  T_46_META_WS_E_BIGHEADHAMMER: "BigHeadHammer",
  T_46_META_WS_E_BILLBOARD: "Großbildschirm",
  T_46_META_WS_E_BIPOD: "Zweibein",
  T_46_META_WS_E_BISGRAFFITIWALL: "BIS-Themenwand",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "Schwarzes Loch Explosion VFX",
  T_46_META_WS_E_BLACKHOLEBOOM: "Kristallkugel VFX",
  T_46_META_WS_E_BLAST: "Explosion",
  T_46_META_WS_E_BLOCK: "Quadrat",
  T_46_META_WS_E_BLOODBALL: "Schwarzes Loch VFX",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "Blau",
  T_46_META_WS_E_BLUEDOLL: "Eiskugel",
  T_46_META_WS_E_BOARD: "Bewegliche Plattform",
  T_46_META_WS_E_BODY: "Körper",
  T_46_META_WS_E_BOMBINDICATION: "Bombenwarnung",
  T_46_META_WS_E_BOMBPLIERS: "Bombenzange",
  T_46_META_WS_E_BONFIRE: "Brennendes Lagerfeuer",
  T_46_META_WS_E_BOOM: "Boom",
  T_46_META_WS_E_BOOYAH: "Sieg",
  T_46_META_WS_E_BOTH: "Beides",
  T_46_META_WS_E_BOUNCETIRE: "Reifen",
  T_46_META_WS_E_BOWAMMO: "Bogenmunition",
  T_46_META_WS_E_BREAKABLEBOX: "Zerstörbarer Holzkasten",
  T_46_META_WS_E_BREAKABLECONTAINER: "Zerstörbarer Container",
  T_46_META_WS_E_BREAKABLEFENCE: "Zerstörbarer Zaun",
  T_46_META_WS_E_BRICKA: "Ziegel A",
  T_46_META_WS_E_BRICKB: "Ziegel B",
  T_46_META_WS_E_BRICKC: "Ziegel C",
  T_46_META_WS_E_BRICKHOUSEA: "Kleines Haus A",
  T_46_META_WS_E_BRIGHT: "Hell",
  T_46_META_WS_E_BUBBLE: "Blase",
  T_46_META_WS_E_BUFFGENERATOR: "Buff-Generator",
  T_46_META_WS_E_BULLETBUFF: "Kugelbuff",
  T_46_META_WS_E_BULLETHITTING: "Kugeltreffer",
  T_46_META_WS_E_BUMPERCAR: "Kettenkarre",
  T_46_META_WS_E_BUMPERCARFACTORY: "Bumper Car Hersteller",
  T_46_META_WS_E_BURNING: "Brandverletzungen bei Fahrzeugexplosion",
  T_46_META_WS_E_BUSHES: "Büsche",
  T_46_META_WS_E_BUSSTOP: "Bushaltestelle",
  T_46_META_WS_E_BUTTOM: "Unterkörperkleidung",
  T_46_META_WS_E_BUTTONWIDGET: "Button-Widget",
  T_46_META_WS_E_BYHIERARCHY: "Nach Hierarchie",
  T_46_META_WS_E_CABINET: "Schrank",
  T_46_META_WS_E_CACTUS: "Kaktus",
  T_46_META_WS_E_CAMOUFLAGE: "Fähigkeit 6",
  T_46_META_WS_E_CAPSULETRIGGER: "Kapsel-Auslöser",
  T_46_META_WS_E_CARDIOTONIC: "Kardiotonikum",
  T_46_META_WS_E_CASUALGAMEBGM: "Freizeitspiel BGM",
  T_46_META_WS_E_CEMENTA: "Zement A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "Kanal A",
  T_46_META_WS_E_CHANNELB: "Kanal B",
  T_46_META_WS_E_CHANNELC: "Kanal C",
  T_46_META_WS_E_CHANNELD: "Kanal D",
  T_46_META_WS_E_CHANNELE: "Kanal E",
  T_46_META_WS_E_CHANNELF: "Kanal F",
  T_46_META_WS_E_CHARACTERSKILL: "Charakterfähigkeiten",
  T_46_META_WS_E_CHARACTOR: "Charakter",
  T_46_META_WS_E_CHARGE: "Aufladen 1",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "Kontrollpunkt",
  T_46_META_WS_E_CHEER: "Jubel",
  T_46_META_WS_E_CHERRYBLOSSOM: "Kirschbaum",
  T_46_META_WS_E_CIRCLE: "Kreis",
  T_46_META_WS_E_CIRCLEBACK: "Schleife",
  T_46_META_WS_E_CIRCLEOFHEAT: "Fußstrahl",
  T_46_META_WS_E_CITY: "Stadt",
  T_46_META_WS_E_CLAPS: "Applaus",
  T_46_META_WS_E_CLEAR: "Löschen",
  T_46_META_WS_E_CLIENT: "Client",
  T_46_META_WS_E_CLONE: "Aussehen ändern",
  T_46_META_WS_E_CLONEKILL: "Klon-Tod",
  T_46_META_WS_E_CLOSE: "Schließen",
  T_46_META_WS_E_CLOTHES: "Kleidung",
  T_46_META_WS_E_COINGENERATOR: "Goldgenerator",
  T_46_META_WS_E_COLDAIR: "Nebel",
  T_46_META_WS_E_COLORBLOCK: "Gefärbter Block",
  T_46_META_WS_E_COLOROILBARREL: "Gefärbtes Ölfass",
  T_46_META_WS_E_COMBINEALL: "Alles kombinieren",
  T_46_META_WS_E_COMBINESELF: "Mit sich selbst kombinieren",
  T_46_META_WS_E_COMBOKEYA1: "Musikalische Noten - Synthesizer A",
  T_46_META_WS_E_COMBOKEYA2: "Musikalische Noten - Synthesizer A",
  T_46_META_WS_E_COMBOKEYB1: "Musikalische Noten - Synthesizer B",
  T_46_META_WS_E_COMBOKEYB2: "Musikalische Noten - Synthesizer B",
  T_46_META_WS_E_COMBOKEYC1: "Musikalische Noten - Synthesizer C",
  T_46_META_WS_E_COMBOKEYC2: "Musikalische Noten - Synthesizer C",
  T_46_META_WS_E_CONCRETEPILLAR: "Betonsäule",
  T_46_META_WS_E_CONDITIONNODE: "Bedingungsknoten",
  T_46_META_WS_E_CONTAINERA: "Container A",
  T_46_META_WS_E_CONTAINERB: "Versandcontainer B",
  T_46_META_WS_E_CONTAINERC: "Versandcontainer C",
  T_46_META_WS_E_CONTAINERWIDGET: "Container-Widget",
  T_46_META_WS_E_CONTINUOUS: "Kontinuierlich",
  T_46_META_WS_E_COUNTDOWN: "Countdown",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "Countdown",
  T_46_META_WS_E_COUNTDOWNDIDI: "Countdown-Piepen",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "Countdown",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "Countdown 3",
  T_46_META_WS_E_CROSS: "Kreuz",
  T_46_META_WS_E_CROSSBOW: "Armbrust",
  T_46_META_WS_E_CROSSHAIR: "Fadenkreuz",
  T_46_META_WS_E_CROSSHAIRS: "Fadenkreuz",
  T_46_META_WS_E_CROUCH: "Hocken",
  T_46_META_WS_E_CROUCHING: "Kauernd",
  T_46_META_WS_E_CROWCAW: "Krähenruf",
  T_46_META_WS_E_CROWN: "Krone",
  T_46_META_WS_E_CUBE: "Block-Mechanismus",
  T_46_META_WS_E_CURSE: "Talisman",
  T_46_META_WS_E_CURSEEXPLOSION: "Talisman-Explosion",
  T_46_META_WS_E_CUSTOM: "Benutzerdefinierte Kamera",
  T_46_META_WS_E_CUSTOMTRIGGER: "Benutzerdefinierter Trigger",
  T_46_META_WS_E_CUSTOMWATERZONE: "Benutzerdefinierter Wasserbereich",
  T_46_META_WS_E_CYCLICCOMBUSTION: "Brennen im Loop",
  T_46_META_WS_E_CYLIC: "Zyklisch",
  T_46_META_WS_E_DAGGER: "Wurfmesser",
  T_46_META_WS_E_DAMAGEDTRUCK: "Beschädigter Lkw",
  T_46_META_WS_E_DAMAGEZONE: "Schadenszone",
  T_46_META_WS_E_DANGERALARM: "Gefahr 2",
  T_46_META_WS_E_DANGERVIBRATING: "Gefahr 1",
  T_46_META_WS_E_DARK: "Dunkel",
  T_46_META_WS_E_DARKNESS: "Dunkelheit",
  T_46_META_WS_E_DASHATTACK: "Stoßangriff",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "Datenbankspeichergrenze überschritten",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "Datenbankspeicherparameterfehler",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "Datenbankspeicherzeitüberschreitung",
  T_46_META_WS_E_DATETIME: "Datum und Uhrzeit",
  T_46_META_WS_E_DAY: "Tag",
  T_46_META_WS_E_DEAD: "Tot",
  T_46_META_WS_E_DEATH: "Tot",
  T_46_META_WS_E_DEFAULT: "Standard",
  T_46_META_WS_E_DEFAULTFIST: "Faust",
  T_46_META_WS_E_DEFENCEGRENADE: "Verteidigungsgranate",
  T_46_META_WS_E_DESC: "Absteigende Reihenfolge",
  T_46_META_WS_E_DIALOGUE: "Dialog",
  T_46_META_WS_E_DIAMOND: "Diamant",
  T_46_META_WS_E_DIRECTIONSIGN: "Schild",
  T_46_META_WS_E_DIRVEVEHICLE: "Fahrzeug steuern",
  T_46_META_WS_E_DISABLE: "Deaktivieren",
  T_46_META_WS_E_DISABLED: "Deaktiviert",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "Verschwinden-Hinweis",
  T_46_META_WS_E_DISCONNECT: "Trennen",
  T_46_META_WS_E_DISGUISE: "Klon",
  T_46_META_WS_E_DOGHOUSE: "Hundehütte",
  T_46_META_WS_E_DOOR: "Tür",
  T_46_META_WS_E_DOUBLE: "Doppel",
  T_46_META_WS_E_DOUBLEDOOR: "Doppeltür",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "Doppelsprung-Schuhe",
  T_46_META_WS_E_DOUBLEMAGEZINE: "Doppelmagazin",
  T_46_META_WS_E_DRAW: "Unentschieden",
  T_46_META_WS_E_DRILLZOMBIE: "Bohrzombie",
  T_46_META_WS_E_DRIVE: "Fahren",
  T_46_META_WS_E_DRIVER: "Fahrer",
  T_46_META_WS_E_DROPBEAT: "Fähigkeit 4",
  T_46_META_WS_E_DRUMKEY1: "Musikalische Noten - Schlagzeug",
  T_46_META_WS_E_DRUMKEY2: "Musikalische Noten - Schlagzeug",
  T_46_META_WS_E_DUEL: "Kampf",
  T_46_META_WS_E_DUMMY: "Dummy",
  T_46_META_WS_E_DUMMYGRENADE: "Dummy-Granate",
  T_46_META_WS_E_DUMP: "Abwerfen",
  T_46_META_WS_E_DUSK: "Dämmerung",
  T_46_META_WS_E_DUST: "Rauch und Staub",
  T_46_META_WS_E_DYNAMIC: "Dynamisch",
  T_46_META_WS_E_E: "Natürliche Konstante",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "Einfach",
  T_46_META_WS_E_ELECTRICSHOCK: "Stromschlag",
  T_46_META_WS_E_ELECTRICSURFBOARD: "Elektrisches Surfbrett",
  T_46_META_WS_E_ELECTRICZONE: "Elektrische Zone",
  T_46_META_WS_E_ELECTRONICBGM: "Niedliches Elektronisches Fantasie BGM",
  T_46_META_WS_E_ELIMINATEDBOSS: "Gildenleiter Absetzen",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "Kill Hinweis",
  T_46_META_WS_E_EMOTE: "Emote",
  T_46_META_WS_E_ENABLE: "Aktivieren",
  T_46_META_WS_E_ENERGETIC: "Energetisch",
  T_46_META_WS_E_ENTERVEHICLE: "Fahrzeug betreten",
  T_46_META_WS_E_EP: "Energie (EP)",
  T_46_META_WS_E_EXCLAMATIONMARK: "Ausrufezeichen",
  T_46_META_WS_E_EXIT: "Ausgang",
  T_46_META_WS_E_EXITVEHICLE: "Fahrzeug verlassen",
  T_46_META_WS_E_EXPLODE: "Selbstexplosion",
  T_46_META_WS_E_EXPLOSION: "Explosion VFX",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "Explosionsflammen",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "Energie Orb Fertigkeit",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "Explosionszombie",
  T_46_META_WS_E_EYE: "Brille",
  T_46_META_WS_E_FACEPAINT: "Gesichtsbemalung",
  T_46_META_WS_E_FACTION: "Fraktion",
  T_46_META_WS_E_FALLING: "Fallend",
  T_46_META_WS_E_FALLINGSTAR: "Verbrauchsgegenstand Erhalten",
  T_46_META_WS_E_FALSE: "Nein",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "Propeller-Mechanismus",
  T_46_META_WS_E_FAR: "Weit",
  T_46_META_WS_E_FEATHER: "Feder",
  T_46_META_WS_E_FEMALE: "Weiblich",
  T_46_META_WS_E_FENCE: "Zaun",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "Kampfeinheit",
  T_46_META_WS_E_FILLED: "Gefüllt",
  T_46_META_WS_E_FINISH: "Beenden",
  T_46_META_WS_E_FINISHINGPOINT: "Endpunkt",
  T_46_META_WS_E_FINISHLINEARCH: "Zielbanner",
  T_46_META_WS_E_FIRE: "Feuer",
  T_46_META_WS_E_FIRECHARGE: "Feuerball",
  T_46_META_WS_E_FIREWORK: "Feuerwerk",
  T_46_META_WS_E_FIRINGEFFECT: "Schieß VFX",
  T_46_META_WS_E_FIRSTPERSON: "Erste-Person-Kamera",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "Erste-Person-Kamera (klassisch)",
  T_46_META_WS_E_FIST: "Faust",
  T_46_META_WS_E_FIT: "Passt",
  T_46_META_WS_E_FLAG: "Flagge",
  T_46_META_WS_E_FLAME: "Feuer",
  T_46_META_WS_E_FLAMEGUN: "Flammenwerfer",
  T_46_META_WS_E_FLAMETHROWER: "Flammenwerfer",
  T_46_META_WS_E_FLASH: "Blendgranate",
  T_46_META_WS_E_FLASHBANG: "Flashbang",
  T_46_META_WS_E_FLASHBANGSPARKS: "Blendgranatenrauch",
  T_46_META_WS_E_FLASHFREEZE: "Flash-Freeze",
  T_46_META_WS_E_FLEXWALL: "Verschiebbare Wand",
  T_46_META_WS_E_FLICKER: "Flimmern",
  T_46_META_WS_E_FLOWER: "Blume",
  T_46_META_WS_E_FLYBOMBBEE: "Fliegende Bombenbiene",
  T_46_META_WS_E_FLYPAN: "Bratpfannenmechanismus",
  T_46_META_WS_E_FLYSHOE: "Fliegerschuhe",
  T_46_META_WS_E_FOLDER: "Ordner",
  T_46_META_WS_E_FOLDWINGS: "Klappflügel",
  T_46_META_WS_E_FOODTRUCK: "Imbisswagen",
  T_46_META_WS_E_FOODTRUCKB: "Food Truck B",
  T_46_META_WS_E_FOOTBALL: "Fußball",
  T_46_META_WS_E_FOOTBALLGUN: "Fußball-Pistole",
  T_46_META_WS_E_FOOTBALLICE: "FootballIce",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "Fußballschütze",
  T_46_META_WS_E_FORCE: "Kraft",
  T_46_META_WS_E_FOREGRIP_MR: "Vordergriff MR",
  T_46_META_WS_E_FOREGRIP1: "Vordergriff1",
  T_46_META_WS_E_FOREGRIP2: "Vordergriff2",
  T_46_META_WS_E_FOREGRIP3: "Vordergriff3",
  T_46_META_WS_E_FORWARD: "Vorwärts",
  T_46_META_WS_E_FOUNTAIN: "Brunnen",
  T_46_META_WS_E_FREE: "Freie Kamera",
  T_46_META_WS_E_FREEZEALL: "Alles einfrieren",
  T_46_META_WS_E_FREEZEPOSITION: "Position einfrieren",
  T_46_META_WS_E_FREEZEPOSITIONX: "Position X einfrieren",
  T_46_META_WS_E_FREEZEPOSITIONY: "Position Y einfrieren",
  T_46_META_WS_E_FREEZEPOSITIONZ: "Position Z einfrieren",
  T_46_META_WS_E_FREEZEROTATION: "Rotation einfrieren",
  T_46_META_WS_E_FREEZEROTATIONX: "Rotation X einfrieren",
  T_46_META_WS_E_FREEZEROTATIONY: "Rotation Y einfrieren",
  T_46_META_WS_E_FREEZEROTATIONZ: "Rotation Z einfrieren",
  T_46_META_WS_E_FREEZEZONE: "Gefrierbereich",
  "T_46_META_WS_E_FROST GALAXY": "Frostgalaxie",
  T_46_META_WS_E_FROZEN: "Einfrieren",
  T_46_META_WS_E_FROZENGRENADE: "Gefriergranate",
  T_46_META_WS_E_FUNCTIONALITEMS: "Funktionale Gegenstände",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "Spiel",
  T_46_META_WS_E_GAMEOVER: "Spiel Beendet 2",
  T_46_META_WS_E_GAMESTART: "Spiel Starten",
  T_46_META_WS_E_GARAGE: "Garage",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "Mechanismus Aktiviert",
  T_46_META_WS_E_GENTLETAP: "Sanfter Tipp",
  T_46_META_WS_E_GETITEM: "Verbrauchsgegenstand 2 Erhalten",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "Geist",
  T_46_META_WS_E_GIANTDICE: "Würfel",
  T_46_META_WS_E_GIANTLOLLIPOP: "Riesen-Lutscher",
  T_46_META_WS_E_GIFT: "Geschenk",
  T_46_META_WS_E_GLOOWALL: "Gloo-Wand",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "BIS-Themenblumenbeet",
  T_46_META_WS_E_GRAFFITIWALL: "Graffiti-Wand",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "Hakenpistole",
  T_46_META_WS_E_GREATCONDUCTOR: "Großer Dirigent",
  T_46_META_WS_E_GREEN: "Grün",
  T_46_META_WS_E_GRENADE: "Granate",
  T_46_META_WS_E_GRID: "Raster",
  T_46_META_WS_E_GROZA: "GROZA",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "Wachturm",
  T_46_META_WS_E_GUILD: "Gilde",
  T_46_META_WS_E_GUN: "Waffe",
  T_46_META_WS_E_GUNFIRE: "Schuss",
  T_46_META_WS_E_HALO: "Halo",
  T_46_META_WS_E_HAMMER: "Riesenhammer-Mechanismus",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "Wäsche-Trockengestell",
  T_46_META_WS_E_HARD: "Schwer",
  T_46_META_WS_E_HATTRICK: "Fähigkeit 8",
  T_46_META_WS_E_HAYSTACK: "Heuhaufen",
  T_46_META_WS_E_HEAD: "Kopfbedeckung",
  T_46_META_WS_E_HEADSHOOT: "Kopfschuss",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "HealingPistol_X",
  T_46_META_WS_E_HEALPISTOL: "Heilwaffe",
  T_46_META_WS_E_HEART: "Herz",
  T_46_META_WS_E_HEARTBEAT: "Herzschlag",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "Schwerwaffe",
  T_46_META_WS_E_HELL: "Sehr schwer",
  T_46_META_WS_E_HELMET: "Helm",
  T_46_META_WS_E_HELMET1: "Helm1",
  T_46_META_WS_E_HELMET2: "Helm2",
  T_46_META_WS_E_HELMET3: "Helm3",
  T_46_META_WS_E_HEXAGON: "Sechseck",
  T_46_META_WS_E_HGAMMO: "HG-Munition",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "Verstecken-Flammenwerfer",
  T_46_META_WS_E_HIDERKILL: "Versteckter Getötet",
  T_46_META_WS_E_HIHATS: "Hi-Hat",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "Stumpfer Treffer",
  T_46_META_WS_E_HITEFFECT: "Kugeltreffer VFX",
  T_46_META_WS_E_HITFEEDBACK: "Schießfeedback",
  T_46_META_WS_E_HOOK: "Haken",
  T_46_META_WS_E_HOOKGUN: "HookGun",
  T_46_META_WS_E_HOOKGUNAMMO: "Hakenpistolen-Munition",
  T_46_META_WS_E_HORIZALINE: "Horizontlinie",
  T_46_META_WS_E_HORIZONTAL: "Horizontal",
  T_46_META_WS_E_HORN: "Lautsprecher",
  T_46_META_WS_E_HORROR: "Horror",
  T_46_META_WS_E_HOURGLASS: "Sanduhr",
  T_46_META_WS_E_HOUSE: "Haus",
  T_46_META_WS_E_HOUSEA: "Einfamilienhaus",
  T_46_META_WS_E_HOUSEB: "Zweistöckiges Haus",
  T_46_META_WS_E_HOUSEC: "Dreigeschossiges Haus",
  T_46_META_WS_E_HP: "Gesundheit (HP)",
  T_46_META_WS_E_HPBUFF: "HP Buff",
  T_46_META_WS_E_HUT: "Kabine",
  T_46_META_WS_E_ICEA: "Eis A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "Eiswandmacher",
  T_46_META_WS_E_ICONOBJECT: "Icon",
  T_46_META_WS_E_IMAGEWIDGET: "Bild-Widget",
  T_46_META_WS_E_IMPULSE: "Impuls",
  T_46_META_WS_E_INHALER: "Inhalator",
  T_46_META_WS_E_INJUREDFEMALE: "Schrei der Frau bei Treffer",
  T_46_META_WS_E_INJUREDMALE: "Schrei des Mannes bei Treffer",
  T_46_META_WS_E_INK: "Tinte VFX",
  T_46_META_WS_E_INPUTLABLEWIDGET: "Eingabebeschriftung-Widget",
  T_46_META_WS_E_INSECTCHIRPING: "Insektenzirpen",
  T_46_META_WS_E_INTERVAL10SECONDS: "10 Sekunden",
  T_46_META_WS_E_INTERVAL15SECONDS: "15 Sekunden",
  T_46_META_WS_E_INTERVAL30SECONDS: "30 Sekunden",
  T_46_META_WS_E_INTERVAL3SECONDS: "3 Sekunden",
  T_46_META_WS_E_INTERVAL5SECONDS: "5 Sekunden",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999 Sekunden",
  T_46_META_WS_E_INVISIBLE: "Unsichtbar",
  T_46_META_WS_E_IPIPE: "Rohr I",
  T_46_META_WS_E_IRONFENCE: "Zaun",
  T_46_META_WS_E_IRONFENCEB: "Zaun B",
  T_46_META_WS_E_IRONPLATFORM: "Eisenplattform",
  T_46_META_WS_E_ITEMENTITY: "Verbrauchsgegenstand-Generator",
  T_46_META_WS_E_JEEP: "Jeep",
  T_46_META_WS_E_JERRYCAN: "Ölfass",
  T_46_META_WS_E_JERSEYMACHINE: "Trikotmaschine",
  T_46_META_WS_E_JOINEDGAMEDULL: "In den Kampf Einsteigen",
  T_46_META_WS_E_JOINGAME: "Spiel Beitreten",
  T_46_META_WS_E_JOYSTICKWIDGET: "Joystick-Widget",
  T_46_META_WS_E_JUMP: "Springen",
  T_46_META_WS_E_JUMPATTACK: "Sprungangriff",
  T_46_META_WS_E_JUSTPATROL: "Nur patrouillieren",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "Schlüssel",
  T_46_META_WS_E_KICK: "Kick",
  T_46_META_WS_E_KILLINGTIPS: "Tötungstipps",
  T_46_META_WS_E_KILLZONE: "Todeszone",
  T_46_META_WS_E_KINEMATIC: "Kinematisch",
  T_46_META_WS_E_KNIFE: "Knife",
  T_46_META_WS_E_KNOCKDOWN: "Niedergeschlagen",
  T_46_META_WS_E_KNOCKEDDOWN: "Umgeworfen",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "Label-Widget",
  T_46_META_WS_E_LANDINGA: "Treppenpodest A",
  T_46_META_WS_E_LANDINGB: "Treppenpodest B",
  T_46_META_WS_E_LANDINGC: "Treppenpodest C",
  T_46_META_WS_E_LANDMINE: "Landmine",
  T_46_META_WS_E_LANUNCHERAMMO: "Granatwerfer-Munition",
  T_46_META_WS_E_LASER: "Laser VFX",
  T_46_META_WS_E_LASERSKILL: "Laserkraft",
  T_46_META_WS_E_LATTICESCREEN: "Bildschirm",
  T_46_META_WS_E_LAWNA: "Rasen A",
  T_46_META_WS_E_LAWNB: "Rasen B",
  T_46_META_WS_E_LAYOUTWIDGET: "Layout-Widget",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "Totes Holz",
  T_46_META_WS_E_LEVELMAXED: "Max. Level",
  T_46_META_WS_E_LEVELUP: "Rang Aufsteigen",
  T_46_META_WS_E_LEVELUPDISCARDED: "Aufstieg",
  T_46_META_WS_E_LIGHTBEAM: "Lichtstrahl",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "Lichtstrahl",
  T_46_META_WS_E_LIGHTEFFECT: "Lichteffekt",
  T_46_META_WS_E_LIGHTNING: "Blitz",
  T_46_META_WS_E_LIMB: "Gliedmaß",
  T_46_META_WS_E_LINE: "Linie",
  T_46_META_WS_E_LIQUID: "Flüssigkeit",
  T_46_META_WS_E_LOCAL: "Lokal",
  T_46_META_WS_E_LOCALPOSITION: "Lokale Position",
  T_46_META_WS_E_LOCK: "Schloss",
  T_46_META_WS_E_LONGBOX: "Lange Holzkiste",
  T_46_META_WS_E_LOOP: "Schleife",
  T_46_META_WS_E_LOOTITEMBOX: "Beute-Waffe",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "Beute-Munition",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "Beute-Rüstung",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "Beute-Verbrauchsmaterial",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "Beute-Wurfgegenstand",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "Beute-Scope",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Loot Soccer",
  T_46_META_WS_E_LOOTSOCCERICE: "Eishandgranate",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "Zufälliger Fußball-Loot",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "Fußball-Schild",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "Zufällige Waffenbeute",
  T_46_META_WS_E_LOSE: "Niederlage",
  T_46_META_WS_E_LOUDSPEAKER: "Lautsprecher",
  T_46_META_WS_E_LOWFALLING: "Niedrig fallend",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "M79-Granate",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "M79-Spezialgranate",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Machete",
  T_46_META_WS_E_MACHINEGUN: "SMG",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "Magazin1",
  T_46_META_WS_E_MAGEZINE2: "Magazin2",
  T_46_META_WS_E_MAGEZINE3: "Magazin3",
  T_46_META_WS_E_MAGMAA: "Magma A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "Lupe",
  T_46_META_WS_E_MALE: "Männlich",
  T_46_META_WS_E_MARK: "Markierung",
  T_46_META_WS_E_MARKER: "Markierung",
  T_46_META_WS_E_MASK: "Gesichtsschmuck",
  T_46_META_WS_E_MAXVALUE: "Höchstwert",
  T_46_META_WS_E_MECHANICAL: "Schnelles Klirren 2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "Mechanische Geräusche",
  T_46_META_WS_E_MEDICALPROPS: "Medizinische Requisiten",
  T_46_META_WS_E_MEDICALTENT: "Sanitätszelt",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "Mittleres Herzklopfen",
  T_46_META_WS_E_MEDKIT: "Medikit",
  T_46_META_WS_E_MELEE: "Nahkampfwaffe",
  T_46_META_WS_E_MELEEWEAPONS: "Nahkampfwaffe",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "Mikrofon",
  T_46_META_WS_E_MIDDLE: "Mittel",
  T_46_META_WS_E_MINIHANDLE: "Mini-Griff",
  T_46_META_WS_E_MINIMAP: "Minikarte",
  T_46_META_WS_E_MINISENTRY: "Mini-Sentry",
  T_46_META_WS_E_MINVALUE: "Mindestwert",
  T_46_META_WS_E_MISSILEEXPLODE: "Raketenwaffe",
  T_46_META_WS_E_MISSIONCOMPLETE: "Missionserfolg 1",
  T_46_META_WS_E_MISTAKE: "Fehler",
  T_46_META_WS_E_MODERATE: "Mittel",
  T_46_META_WS_E_MONEY: "Geld",
  T_46_META_WS_E_MONSTER: "Monster",
  T_46_META_WS_E_MONSTERSPAWN: "Monster-Spawn-Punkt",
  T_46_META_WS_E_MONSTERTRUCK: "Monster-Truck",
  T_46_META_WS_E_MOON: "Mond",
  T_46_META_WS_E_MOSQUITO: "Mücke",
  T_46_META_WS_E_MOTIONTRAIL: "Auffahrunfall",
  T_46_META_WS_E_MOTOBIKE: "Motorrad",
  T_46_META_WS_E_MOTORBIKE: "Motorrad",
  T_46_META_WS_E_MOVE: "Bewegen",
  T_46_META_WS_E_MOVEMENT: "Bewegen",
  T_46_META_WS_E_MOVINGJOYSTICK: "Bewegungs-Joystick",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "Herr V",
  T_46_META_WS_E_MULTIPLIER: "Multiplikator",
  T_46_META_WS_E_MULTIPLY: "Multiplizieren",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "Multiplizieren und Akkumulieren",
  T_46_META_WS_E_MUSHROOM1: "Pilz1",
  T_46_META_WS_E_MUSHROOM2: "Pilz2",
  T_46_META_WS_E_MUSHROOM3: "Pilz3",
  T_46_META_WS_E_MUSHROOM4: "Pilz4",
  T_46_META_WS_E_MUSHSHADE: "Riesiger Pilzcluster",
  T_46_META_WS_E_MUSIC: "Musik",
  T_46_META_WS_E_MUZZLE1: "Mündung1",
  T_46_META_WS_E_MUZZLE2: "Mündung2",
  T_46_META_WS_E_MUZZLE3: "Mündung3",
  T_46_META_WS_E_NEAR: "Nah",
  T_46_META_WS_E_NIGHT: "Nacht",
  T_46_META_WS_E_NOATTACK: "Kein Angriff",
  T_46_META_WS_E_NODUALWIELDING: "Kein beidhändiges Führen",
  T_46_META_WS_E_NOERROR: "Kein Fehler",
  T_46_META_WS_E_NONE: "Keine",
  T_46_META_WS_E_NORMAL: "Normal",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "Kein Umwerfen überspringen",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "Fähigkeit 7",
  T_46_META_WS_E_OBTAINEDCOINS: "Mittlere Goldmenge Erhalten",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "Große Goldmenge Erhalten",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "Kleine Goldmenge Erhalten",
  T_46_META_WS_E_OILDRUMEXPLODE: "Ölfass-Explosion",
  T_46_META_WS_E_ONCE: "Einmal",
  T_46_META_WS_E_ONEWAY: "Einweg",
  T_46_META_WS_E_OPENFOLDER: "Geöffneter Ordner",
  T_46_META_WS_E_OPENHIHATS: "Offene Hi-Hats",
  T_46_META_WS_E_OPENINGBOX: "Box Öffnen",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "Gildenversorgung",
  T_46_META_WS_E_OPENINGWARCHEST: "Lager Speichern",
  T_46_META_WS_E_ORANGE: "Orange",
  T_46_META_WS_E_ORTHOGONAL: "Orthogonal",
  T_46_META_WS_E_OUTPOST: "Wache",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "Gemalter Wand",
  T_46_META_WS_E_PAINTSHIELDSKILL: "Blutpfütze Fertigkeit",
  T_46_META_WS_E_PALM: "Papier",
  T_46_META_WS_E_PANEL: "Panel",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "Passagier A",
  T_46_META_WS_E_PASSENGERB: "Passagier B",
  T_46_META_WS_E_PASSENGERC: "Passagier C",
  T_46_META_WS_E_PASSIVE: "Passiv",
  T_46_META_WS_E_PASSIVESKILL: "Passive Fähigkeit",
  T_46_META_WS_E_PATROLWHILEATTACK: "Patrouillieren und angreifen",
  T_46_META_WS_E_PERSONALUAV: "Persönliche Drohne",
  T_46_META_WS_E_PERSPECTIVE: "Perspektive",
  T_46_META_WS_E_PETTABBG: "Haustier",
  T_46_META_WS_E_PHASESTART: "Phasenbeginn",
  T_46_META_WS_E_PHONEBOOTH: "Telefonzelle",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "Musikalische Noten - Klavier",
  T_46_META_WS_E_PIANOKEY2: "Musikalische Noten - Klavier",
  T_46_META_WS_E_PICKUPS: "Aufhebungen",
  T_46_META_WS_E_PICKUPTRUCK: "SUV",
  T_46_META_WS_E_PILLAR: "Betonsäule",
  T_46_META_WS_E_PIN: "Notiz",
  T_46_META_WS_E_PINGPONG: "Tischtennis",
  T_46_META_WS_E_PIPECORNER: "Winkelrohr",
  T_46_META_WS_E_PIPEINTERSECTION: "Kreuzrohr",
  T_46_META_WS_E_PISTOL: "Pistole",
  T_46_META_WS_E_PISTOLAMMO: "Pistolenmunition",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "Karierter Freizeitpark Block",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "Spieler",
  T_46_META_WS_E_PLUS: "Plus",
  T_46_META_WS_E_PODIUM: "Podium",
  T_46_META_WS_E_POISONGAS: "Giftgas",
  T_46_META_WS_E_POISONGASPREDISCARDED: "Giftgas",
  T_46_META_WS_E_PORTAL: "Portal",
  T_46_META_WS_E_POSTACCUMULATOR: "Nach-Accumulator",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "Schnelles Herzklopfen",
  T_46_META_WS_E_PREACCUMULATOR: "Vor-Accumulator",
  T_46_META_WS_E_PRIMARYWEAPONA: "Primärwaffe A",
  T_46_META_WS_E_PRIMARYWEAPONB: "Primärwaffe B",
  T_46_META_WS_E_PRIOREXPLOSION: "Vor der Bombenexplosion",
  T_46_META_WS_E_PROFILEWIDGET: "Profil-Widget",
  T_46_META_WS_E_PRONE: "Liegend",
  T_46_META_WS_E_PUMPKIN: "Kürbis",
  T_46_META_WS_E_PURPLE: "Lila",
  T_46_META_WS_E_QUADRILATERAL: "Viereck",
  T_46_META_WS_E_QUESTIONMARK: "Fragezeichen",
  T_46_META_WS_E_QUICKCHAT: "Schnellchat",
  T_46_META_WS_E_QUICKCHATSHOW: "Schnellchat-Anzeige",
  T_46_META_WS_E_RADIAL180: "Radial 180°",
  T_46_META_WS_E_RADIAL360: "Radial 360°",
  T_46_META_WS_E_RADIAL90: "Radial 90°",
  T_46_META_WS_E_RAMPAGE: "Raserei",
  T_46_META_WS_E_RANDOM: "Zufällig",
  T_46_META_WS_E_RANDOMBUFF: "Zufälliges Buff",
  T_46_META_WS_E_RANKDOWN: "Abstieg",
  T_46_META_WS_E_REACTION: "Reagieren",
  T_46_META_WS_E_RECOVER: "Wiederherstellen",
  T_46_META_WS_E_RECYCLE: "Recycling",
  T_46_META_WS_E_RED: "Rot",
  T_46_META_WS_E_REFINERYTANK: "Wasserkrug",
  T_46_META_WS_E_REFLECTIVECUBE: "Reflektierender Block 1",
  T_46_META_WS_E_REFRESH: "Aktualisieren",
  T_46_META_WS_E_RELEASINGSKILL: "Fähigkeitscast VFX",
  T_46_META_WS_E_RELOAD: "Nachladen",
  T_46_META_WS_E_REMINDER: "Erinnerung",
  T_46_META_WS_E_REPAIR: "Reparatur",
  T_46_META_WS_E_REPAIREQUIP: "Ausrüstung reparieren",
  T_46_META_WS_E_REPAIRKIT: "Reparaturset",
  T_46_META_WS_E_REPLACER: "Ersetzer",
  T_46_META_WS_E_REPORT: "Melden",
  T_46_META_WS_E_REST: "Pause",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "Ride",
  T_46_META_WS_E_RIDICULE: "Spott",
  T_46_META_WS_E_RIDICULEFUNNY: "Lustiger Spott",
  T_46_META_WS_E_RIFLE: "Gewehr",
  T_46_META_WS_E_RIFLEAMMO: "Gewehrmunition",
  T_46_META_WS_E_RIGHT: "Richtig",
  T_46_META_WS_E_RIGHTTRAPEZOID: "Rechteckiger Trapez",
  T_46_META_WS_E_RING: "Ring-Mechanismus",
  T_46_META_WS_E_RINGPREDISCARDED: "Ring",
  T_46_META_WS_E_RIPTIDERHYTHM: "Fähigkeit 9",
  T_46_META_WS_E_RISINGPARTICLE: "Aufsteigende Partikel",
  T_46_META_WS_E_ROADBLOCK: "Barrikade",
  T_46_META_WS_E_ROTATE: "Rotation",
  T_46_META_WS_E_RUNNING: "Laufen",
  T_46_META_WS_E_RUSHTIME: "Amoklauf",
  T_46_META_WS_E_SAMURAI: "Samurai",
  T_46_META_WS_E_SANDA: "Sand A",
  T_46_META_WS_E_SANDSTRUCTURE: "Sandkunst",
  T_46_META_WS_E_SCALE: "Maßstab",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "Scheune",
  T_46_META_WS_E_SCISSORS: "Schere",
  T_46_META_WS_E_SCOPE2X: "2x Visier",
  T_46_META_WS_E_SCOPE4X: "4x Visier",
  T_46_META_WS_E_SCROLLPANEL: "Scroll-Panel",
  T_46_META_WS_E_SECONDARYWEAPON: "Sekundärwaffe",
  T_46_META_WS_E_SENSESSHOCKWAVE: "Fähigkeit 10",
  T_46_META_WS_E_SERVER: "Server",
  T_46_META_WS_E_SET: "Overall",
  T_46_META_WS_E_SETTING: "Einstellungen",
  T_46_META_WS_E_SETTINGS: "Einstellungen",
  T_46_META_WS_E_SG: "Schrotflinte",
  T_46_META_WS_E_SGAMMO: "SN-Munition",
  T_46_META_WS_E_SHARPMECHANICAL: "Schnelles Klirren 1",
  T_46_META_WS_E_SHIELD: "Verteidigung",
  T_46_META_WS_E_SHIELDBROKEN: "Schild gebrochen",
  T_46_META_WS_E_SHIELDGUN: "ShieldGun",
  T_46_META_WS_E_SHIELDUP: "Schild hoch",
  T_46_META_WS_E_SHOCKWAVE: "Schockwelle",
  T_46_META_WS_E_SHOES: "Schuhe",
  T_46_META_WS_E_SHOOTINGTARGET: "Bewegliches Ziel",
  T_46_META_WS_E_SHORTDATE: "Kurzes Datum",
  T_46_META_WS_E_SHORTDATETIME: "Kurzes Datum und Uhrzeit",
  T_46_META_WS_E_SHORTTIME: "Kurzzeit",
  T_46_META_WS_E_SHOTGUN: "Schrotflinte",
  T_46_META_WS_E_SHOTGUNAMMO: "Schrotflinten-Munition",
  T_46_META_WS_E_SHOTGUNMUZZLE: "Schrotflinten-Mündung",
  T_46_META_WS_E_SHOW: "Anzeigen",
  T_46_META_WS_E_SHRUB: "Buschbedeckte lange Holzkiste",
  T_46_META_WS_E_SICKLE: "Sickle",
  T_46_META_WS_E_SIDESCROLLING: "Seitenansicht-Kamera",
  T_46_META_WS_E_SIGNAL: "Signal",
  T_46_META_WS_E_SIGNOUT: "Beenden",
  T_46_META_WS_E_SILENCER: "Schalldämpfer",
  T_46_META_WS_E_SIMPLE: "Einfach",
  T_46_META_WS_E_SIMPLEWIDGET: "Einfaches Widget",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "SimplifiedArabic",
  T_46_META_WS_E_SINGLE: "Einzel",
  T_46_META_WS_E_SITEHUT: "Containerhaus",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "Fertigkeit Aufladung Abgeschlossen",
  T_46_META_WS_E_SKILLRECOVER: "Fertigkeitserholung",
  T_46_META_WS_E_SKIPKNOCKDOWN: "Umwerfen überspringen",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "Geschnitten",
  T_46_META_WS_E_SLOPE: "Neigung",
  T_46_META_WS_E_SLOWHEARTBEAT: "Langsame Herzklopfen",
  T_46_META_WS_E_SMG: "SMG",
  T_46_META_WS_E_SMGAMMO: "SMG-Munition",
  T_46_META_WS_E_SMGMUZZLE: "SMG-Mündung",
  T_46_META_WS_E_SMILEY: "Lächelndes Gesicht",
  T_46_META_WS_E_SMOKE: "Rauch",
  T_46_META_WS_E_SMOKEGRENADE: "Rauchgranate",
  T_46_META_WS_E_SMOKEY: "Rauch",
  T_46_META_WS_E_SMOOTH: "Glatt",
  T_46_META_WS_E_SNAMMO: "SN-Munition",
  T_46_META_WS_E_SNARES: "Snare",
  T_46_META_WS_E_SNEAKERS: "Laufschuhe VFX",
  T_46_META_WS_E_SNIPER: "Scharfschützengewehr",
  T_46_META_WS_E_SNIPERAMMO: "Scharfschützengewehr-Munition",
  T_46_META_WS_E_SNOWA: "Schnee A",
  T_46_META_WS_E_SNOWFLAKE: "Schneeflocke",
  T_46_META_WS_E_SOCCER: "Fußball",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "Sozial-Button-Widget",
  T_46_META_WS_E_SOLARPANEL: "Solarpanel",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "Nach Priorität hoch zu niedrig",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "Nach Priorität niedrig zu hoch",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "Spawnpunkt VFX",
  T_46_META_WS_E_SPEAKER: "Lautsprecher",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "Spezialwaffengeräusch",
  T_46_META_WS_E_SPECIALGUN: "Spezialwaffe",
  T_46_META_WS_E_SPHERE: "Kugel",
  T_46_META_WS_E_SPHERETRIGGER: "Kugel-Kollisionsauslöser",
  T_46_META_WS_E_SPIDERWEB: "Fähigkeits VFX",
  T_46_META_WS_E_SPORTSCAR: "Sportwagen",
  T_46_META_WS_E_SPOTLIGHT: "Licht",
  T_46_META_WS_E_SPREADOFPOISONGAS: "Giftgas-Diffusion",
  T_46_META_WS_E_SPRINT: "Rennend",
  T_46_META_WS_E_SQUARE: "Quadrat",
  T_46_META_WS_E_SQUAREBOX: "Quadrat-Holzkiste",
  T_46_META_WS_E_SR: "Scharfschützengewehr",
  T_46_META_WS_E_STABLE: "Reetdachhütte",
  T_46_META_WS_E_STAIRS: "Treppe",
  T_46_META_WS_E_STANDING: "Stehend",
  T_46_META_WS_E_STAR: "Stern",
  T_46_META_WS_E_STATIC: "Statisch",
  T_46_META_WS_E_STATUSTRIGGER: "Tod- oder Unverwundbarkeit-Trigger",
  T_46_META_WS_E_STEP: "Schrittgeräusch",
  T_46_META_WS_E_STEPTRIGGER: "Mechanismus aktivieren",
  T_46_META_WS_E_STOCK_S: "Schaft S",
  T_46_META_WS_E_STOCK_SR: "Schaft SR",
  T_46_META_WS_E_STOCK1: "Schaft1",
  T_46_META_WS_E_STOCK2: "Schaft2",
  T_46_META_WS_E_STOCK3: "Schaft3",
  T_46_META_WS_E_STONE: "Stein",
  T_46_META_WS_E_STONEBRIDGE: "Steinbogenbrücke",
  T_46_META_WS_E_STONELANTERN: "Palastlaterne",
  T_46_META_WS_E_STONESPLASH: "Fliegende Trümmer",
  T_46_META_WS_E_STORE: "Geschäft",
  T_46_META_WS_E_STREETLAMP: "Straßenlaterne",
  T_46_META_WS_E_STYLEA: "Stil A",
  T_46_META_WS_E_STYLEB: "Stil B",
  T_46_META_WS_E_STYLEC: "Stil C",
  T_46_META_WS_E_SUBMACHINEGUN: "MP",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "MP-Munition",
  T_46_META_WS_E_SUCCESSFULHIT: "Treffer",
  T_46_META_WS_E_SUN: "Sonne",
  T_46_META_WS_E_SUNSHADE: "Patioset mit Schirm",
  T_46_META_WS_E_SUPERCAR: "Sportwagen",
  T_46_META_WS_E_SUPERMARKET: "Supermarkt",
  T_46_META_WS_E_SURPRISEFIND: "Überraschung Entdecken",
  T_46_META_WS_E_SUV: "SUV",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "Schnellwechsel-Waffe",
  T_46_META_WS_E_SWIMRING: "Schwimmring",
  T_46_META_WS_E_SWORD: "Schwert",
  T_46_META_WS_E_SYMBOLIC: "Bodenmarkierung",
  T_46_META_WS_E_TANKZOMBIE: "Panzerzombie",
  T_46_META_WS_E_TAP: "Tippen",
  T_46_META_WS_E_TAPPINGBUTTON: "Tippen Schaltfläche",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "Tippen Deaktivieren Schaltfläche",
  T_46_META_WS_E_TEAM: "Team",
  T_46_META_WS_E_TEAMMATESINFO: "Teamkollegen-Informationen",
  T_46_META_WS_E_TELEPORT: "Teleport",
  T_46_META_WS_E_TELEPORTCORRECT: "Richtiges Ziel Signal",
  T_46_META_WS_E_TELEPORTWRONG: "Falsches Ziel Signal",
  T_46_META_WS_E_TEXT: "Text",
  T_46_META_WS_E_TEXTOBJECT: "Text",
  T_46_META_WS_E_TEXTUREWIDGET: "Textur-Widget",
  T_46_META_WS_E_THERMALSCOPE: "Wärmevisier",
  T_46_META_WS_E_THIRDPERSON: "Dritte-Person-Kamera",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "Dritte-Person-Kamera (klassisch)",
  T_46_META_WS_E_THIRDPERSONLOCK: "Dritte-Person-Kamera (fest)",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "Wurfmesser2 zur Kompatibilität",
  T_46_META_WS_E_THRILLBATTLE: "Fähigkeit 5",
  T_46_META_WS_E_THROWATTACK: "Granate werfen",
  T_46_META_WS_E_THROWINGKNIFE: "ThrowingKnife",
  T_46_META_WS_E_THROWREDZOMBIE: "Roter Wurfzombie",
  T_46_META_WS_E_THROWZOMBIE: "Wurfzombie",
  T_46_META_WS_E_THUMBSUP: "Gefällt mir",
  T_46_META_WS_E_THUNDER: "Elektrischer Schlag",
  T_46_META_WS_E_TILEA: "Fliese A",
  T_46_META_WS_E_TILEB: "Fliese B",
  T_46_META_WS_E_TILEC: "Fliese C",
  T_46_META_WS_E_TILED: "Gefliest",
  T_46_META_WS_E_TIPSSOUND: "Tipps Anzeigen",
  T_46_META_WS_E_TOGGLEWIDGET: "Toggle-Widget",
  T_46_META_WS_E_TOILETBOWL: "Toilette",
  T_46_META_WS_E_TONEA: "Ton A",
  T_46_META_WS_E_TOP: "Oberkörperkleidung",
  T_46_META_WS_E_TOPDOWN: "Top-Down-Kamera",
  T_46_META_WS_E_TORII: "Torii",
  T_46_META_WS_E_TOUCHPADWIDGET: "Touchpad-Widget",
  T_46_META_WS_E_TOWER: "Festung",
  T_46_META_WS_E_TPIPE: "Rohr T",
  T_46_META_WS_E_TRACINGSTEPS: "Fähigkeit 3",
  T_46_META_WS_E_TRAILER: "Anhänger",
  T_46_META_WS_E_TRANSFORMATION: "Aussehen ändern",
  T_46_META_WS_E_TRANSPARENT: "Transparent",
  T_46_META_WS_E_TRAPEZOID: "Trapez",
  T_46_META_WS_E_TRASHCAN: "Mülleimer",
  T_46_META_WS_E_TRIANGLE: "Dreieck",
  T_46_META_WS_E_TRIGGERS: "Auslöser",
  T_46_META_WS_E_TRIPLE: "Dreifach",
  T_46_META_WS_E_TROPHY: "Trophäe",
  T_46_META_WS_E_TRUE: "Ja",
  T_46_META_WS_E_TUKTUK: "Tuk Tuk",
  T_46_META_WS_E_TUTUCAR: "Tuk-Tuk",
  T_46_META_WS_E_TYRANTZOMBIE: "Tyrannzombie",
  T_46_META_WS_E_UAVLITE: "Leichtes UAV",
  T_46_META_WS_E_UIFINISH: "Ende",
  T_46_META_WS_E_UITAP: "UI-Tipp",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "Einheitengenerator",
  T_46_META_WS_E_UPWARDTURBULENCE: "Aufwind",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "Überwinden",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "Fahrzeug",
  T_46_META_WS_E_VEHICLEEXPLODE: "Fahrzeugexplosion",
  T_46_META_WS_E_VELOCITY: "Geschwindigkeit",
  T_46_META_WS_E_VENDINGMACHINE: "Verkaufsautomat",
  T_46_META_WS_E_VERTICAL: "Vertikal",
  T_46_META_WS_E_VEST: "Weste",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Vest3",
  T_46_META_WS_E_VEST4: "Weste4",
  T_46_META_WS_E_VISUALEFFECTS: "Visuelle Effekte",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "Wand A",
  T_46_META_WS_E_WALLBRAWL: "Fähigkeit 2",
  T_46_META_WS_E_WARNING: "Warnung",
  T_46_META_WS_E_WATERRING: "Wasserspritzer",
  T_46_META_WS_E_WAVE1: "Welle1",
  T_46_META_WS_E_WAVE2: "Welle2",
  T_46_META_WS_E_WAVE3: "Welle3",
  T_46_META_WS_E_WEAPONGENERATOR: "Waffe",
  T_46_META_WS_E_WEAPONSLOT: "Waffenplatz",
  T_46_META_WS_E_WHISTLE: "Feind Besiegen",
  T_46_META_WS_E_WIDERANGE: "Breiter Bereich",
  T_46_META_WS_E_WIN: "Sieg",
  T_46_META_WS_E_WINDATTACK: "Windangriff",
  T_46_META_WS_E_WOODA: "Holz A",
  T_46_META_WS_E_WOODCUTZOMBIE: "Holzzombie",
  T_46_META_WS_E_WOODENPLANK: "Holzbrücke",
  T_46_META_WS_E_WORLDPOSITION: "Weltkoordinaten",
  T_46_META_WS_E_WRECKEDBUS: "Zerstörter Bus",
  T_46_META_WS_E_WRECKEDCAR: "Zerstörtes Auto",
  T_46_META_WS_E_WRONG: "Falsch",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "Zombie",
  T_46_META_WS_E_ZOMBIES: "Zombie",
  T_46_META_WS_E_ZOOM: "Zoom",
  T_46_META_WS_ELIMINATE: "Auslöschen",
  T_46_META_WS_ELIMINATEDENTITY: "Eliminierte Entität",
  T_46_META_WS_ELIMINATEDPLAYER: "Eliminierter Spieler",
  T_46_META_WS_ENABLEDEFAULTBTREE: "Standard-Verhaltensbaum aktivieren",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "Bewegliche Sicherheitszone aktivieren",
  T_46_META_WS_ENABLESAFEZONE: "Sicherheitszone aktivieren",
  T_46_META_WS_ENDCURRENTPHASE: "Aktuelle Phase beenden",
  T_46_META_WS_ENDMORPH: "Verwandlung beenden",
  T_46_META_WS_ENDPOSITION: "Endposition",
  T_46_META_WS_ENTERVEHICLE: "Fahrzeug betreten",
  T_46_META_WS_ENTITY: "Entität",
  T_46_META_WS_EQUIPMENTID: "Ausrüstungs-ID",
  T_46_META_WS_EULERANGLETOQUATERNION: "Euler-Winkel in Quaternion umwandeln",
  T_46_META_WS_EXITVEHICLE: "Fahrzeug verlassen",
  T_46_META_WS_EXPONENTIATION: "Exponentialfunktion",
  T_46_META_WS_FILTERENTITY: "Entität filtern",
  T_46_META_WS_FILTERLEVELOBJECTS: "Levelobjekte filtern",
  T_46_META_WS_FIND: "Finden",
  T_46_META_WS_FINDAT: "Finden bei",
  T_46_META_WS_FINDPATH: "Pfad finden",
  T_46_META_WS_FLOOR: "Abrunden",
  T_46_META_WS_FOOTBALLGOAL: "Fußballtor",
  T_46_META_WS_FORMAT: "Formatieren",
  T_46_META_WS_GETALLKEYS: "Alle Schlüssel abrufen",
  T_46_META_WS_GETALLPLAYERS: "Alle Spieler abrufen",
  T_46_META_WS_GETALLSHOPS: "Alle Geschäfte abrufen",
  T_46_META_WS_GETALLTEAMS: "Alle Teams abrufen",
  T_46_META_WS_GETATTACKABLEENTITY: "Angriffbare Entität abrufen",
  T_46_META_WS_GETATTACKABLEFACTIONS: "Angriffbare Fraktionen abrufen",
  T_46_META_WS_GETBACKPACKSKIN: "Rucksack-Skin abrufen",
  T_46_META_WS_GETBLACKBOARDVALUE: "Blackboard-Wert abrufen",
  T_46_META_WS_GETBUFFS: "Buffs abrufen",
  T_46_META_WS_GETCHATCHANNEL: "Chat-Kanal abrufen",
  T_46_META_WS_GETCHILDBYINDEX: "Kind nach Index abrufen",
  T_46_META_WS_GETCHILDBYNAME: "Kind nach Name abrufen",
  T_46_META_WS_GETCHILDREN: "Alle Kinder abrufen",
  T_46_META_WS_GETCOLORCHANNEL: "Farbkanal abrufen",
  T_46_META_WS_GETCONSUMABLES: "Verbrauchsgüter abrufen",
  T_46_META_WS_GETCULLINGMASK: "Culling-Maske abrufen",
  T_46_META_WS_GETCURRENTCAMERA: "Aktuelle Kamera abrufen",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "Aktuellen Chat-Kanal abrufen",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "Fortschritt der benutzerdefinierten Mission abrufen",
  T_46_META_WS_GETDYEDCOUNT: "Färbeanzahl abrufen",
  T_46_META_WS_GETDYEDSTATUS: "Färbestatus abrufen",
  T_46_META_WS_GETEQUIPMENTS: "Ausrüstung abrufen",
  T_46_META_WS_GETFACTION: "Fraktion abrufen",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "Globale Schlafschwelle abrufen",
  T_46_META_WS_GETITEMCOUNT: "Item-Anzahl abrufen",
  T_46_META_WS_GETLOADEDSCENES: "Geladene Szenen abrufen",
  T_46_META_WS_GETLOCALAIMDIRECTION: "Lokale Zielrichtung abrufen",
  T_46_META_WS_GETLOCALPLAYER: "Lokalen Spieler abrufen",
  T_46_META_WS_GETLOCALTIMESTAMP: "Lokalen Zeitstempel abrufen",
  T_46_META_WS_GETMAPID: "Karten-ID abrufen",
  T_46_META_WS_GETMINIMAP: "Mini-Map abrufen",
  T_46_META_WS_GETMONEY: "Geld abrufen",
  T_46_META_WS_GETMONEYCOUNT: "Geldanzahl abrufen",
  T_46_META_WS_GETMORPH: "Verwandlung abrufen",
  T_46_META_WS_GETNODEVARIABLE: "Knotenvariable abrufen",
  T_46_META_WS_GETOUTFIT: "Outfit abrufen",
  T_46_META_WS_GETOWNER: "Besitzer abrufen",
  T_46_META_WS_GETPARENT: "Elternteil abrufen",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "Position in der Nähe von Teamkollegen abrufen",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "Zufällige Spawn-Position abrufen",
  T_46_META_WS_GETRESULTFROMCURVE: "Ergebnis von Kurve abrufen",
  T_46_META_WS_GETSCENESKYBOX: "Himmelbox der Szene abrufen",
  T_46_META_WS_GETSERVERREGION: "Server-Region abrufen",
  T_46_META_WS_GETSERVERTIMESTAMP: "Server-Zeitstempel abrufen",
  T_46_META_WS_GETSKELETONPARTBYNAME: "Knochenteil nach Namen abrufen",
  T_46_META_WS_GETSKILLS: "Fähigkeiten abrufen",
  T_46_META_WS_GETSLEEPTHRESHOLD: "Schlafschwelle abrufen",
  T_46_META_WS_GETTOKENCOUNT: "Token-Anzahl abrufen",
  T_46_META_WS_GETTOKENCOUNTTODAY: "Token-Anzahl für heute abrufen",
  T_46_META_WS_GETTYPE: "Typ abrufen",
  T_46_META_WS_GETVEHICLESKIN: "Fahrzeug-Skin abrufen",
  T_46_META_WS_GETWALLET: "Wallet abrufen",
  T_46_META_WS_GETWEAPONSKIN: "Waffenskin abrufen",
  T_46_META_WS_GETWIDGETBYPATH: "Widget nach Pfad abrufen",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "Widget aus benutzerdefinierter UI abrufen",
  T_46_META_WS_GIVEJAILBREAKITEM: "Gefängnisausbruch-Gegenstand vergeben",
  T_46_META_WS_GIVEJAILBREAKREWARD: "Gefängnisausbruch-Belohnung vergeben",
  T_46_META_WS_HASAOISPECIALFOLLOW: "AOI Spezialfolge vorhanden",
  T_46_META_WS_HASCOMPONENT: "Hat Komponente",
  T_46_META_WS_HASSCRIPT: "Gibt es Script",
  T_46_META_WS_HASTAG: "Gibt es Tag",
  T_46_META_WS_HELPEDPLAYER: "Gehilfe-Spieler",
  T_46_META_WS_HELPPLAYER: "Assist-Spieler",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "Erscheinungsbild-Gruppe ausblenden",
  T_46_META_WS_HITENTITY: "Getroffene Entität",
  T_46_META_WS_HITFLY: "Wegfliegen",
  T_46_META_WS_HITNORMAL: "Treffernormale",
  T_46_META_WS_HITOBJECT: "Getroffenes Objekt",
  T_46_META_WS_HITPOSITION: "Trefferposition",
  T_46_META_WS_INDEXOF: "Erste Position des Elements abrufen",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "Infektionszombie wachsen",
  T_46_META_WS_INSERT: "Einfügen",
  T_46_META_WS_ISATTACKABLE: "Angriffbar",
  T_46_META_WS_ISCHATCHANNELEMPTY: "Ist der Chat-Kanal leer",
  T_46_META_WS_ISEQUAL: "Gleich",
  T_46_META_WS_ISFRIEND: "Freund sein überprüfen",
  T_46_META_WS_ISHIT: "Wurde getroffen",
  T_46_META_WS_ISINSIDEBOX: "In der Box enthalten",
  T_46_META_WS_ISINSIDECYLINDER: "In der Zylinder enthalten",
  T_46_META_WS_ISINSIDESECTOR: "Im Sektor enthalten",
  T_46_META_WS_ISINSIDESPHERE: "In der Kugel enthalten",
  T_46_META_WS_ISSLEEPING: "Schlafen prüfen",
  T_46_META_WS_ISSUBTYPEOF: "Ist Untertyp von",
  T_46_META_WS_ITEM: "Entität",
  T_46_META_WS_ITEMID: "Gegenstands-ID",
  T_46_META_WS_JOIN: "Verbinden",
  T_46_META_WS_JOINCHATCHANNEL: "Chat-Kanal betreten",
  T_46_META_WS_JOINFACTION: "Fraktion beitreten",
  T_46_META_WS_LASTINDEXOF: "Letzte Position des Elements abrufen",
  T_46_META_WS_LENGTH: "Länge",
  T_46_META_WS_LERP: "Lerp",
  T_46_META_WS_LOADSCENE: "Szene laden",
  T_46_META_WS_LOGARITHM: "Logarithmus",
  T_46_META_WS_LOGERROR: "Fehler protokollieren",
  T_46_META_WS_LOGINFO: "Informationen protokollieren",
  T_46_META_WS_LOGWARNING: "Warnung protokollieren",
  T_46_META_WS_LOOKROTATION: "Ausrichtungsdrehung",
  T_46_META_WS_MAGNITUDE: "Größe",
  T_46_META_WS_MAKER: "Schöpfer",
  T_46_META_WS_MAX: "Max",
  T_46_META_WS_MECHANISM: "Mechanismus",
  T_46_META_WS_MIN: "Min",
  T_46_META_WS_MONSTERUSESKILL: "Fertigkeit verwenden",
  T_46_META_WS_MORPHOBJECT: "Morph-Objekt",
  T_46_META_WS_MORPHTO: "Verwandeln in",
  T_46_META_WS_MORPHTOBYITEMID: "Verwandeln nach Item-ID",
  T_46_META_WS_MOVECCT: "CCT bewegen",
  T_46_META_WS_MOVEPOSITION: "Position bewegen",
  T_46_META_WS_MOVEROTATION: "Rotation bewegen",
  T_46_META_WS_MULTIPLYQUATERNION: "Quaternion multiplizieren",
  T_46_META_WS_MULTIRAYCAST: "Mehrfachstrahl-Raycast",
  T_46_META_WS_NEGATE: "Negativ",
  T_46_META_WS_NEW: "Neu",
  T_46_META_WS_NODENAME: "Knotenname",
  T_46_META_WS_NORMALIZE: "Normalisieren",
  T_46_META_WS_NOTIFYPLAYEFFECT: "Effekt abspielen benachrichtigen",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "Benachrichtigen, dass Symbolanimation abspielt",
  T_46_META_WS_NOTIFYPLAYSOUND: "Sound abspielen benachrichtigen",
  T_46_META_WS_NOTIFYSHOWTIPS: "Tipps anzeigen benachrichtigen",
  T_46_META_WS_NUMTOSTRING: "Nummer zu String",
  T_46_META_WS_ONACCESSEQUIPMENT: "Ausrüstung zugreifen",
  T_46_META_WS_ONACCESSITEM: "Gegenstand zugreifen",
  T_46_META_WS_ONACCESSWEAPON: "Waffe zugreifen",
  T_46_META_WS_ONACE: "ACE ausführen",
  T_46_META_WS_ONAIMED: "Gezielt",
  T_46_META_WS_ONAIMING: "Zielen",
  T_46_META_WS_ONASSIST: "Assistieren",
  T_46_META_WS_ONATTACK: "Angriff",
  T_46_META_WS_ONATTACKSTOP: "Angriff stoppt",
  T_46_META_WS_ONAWAKE: "Aufwachen",
  T_46_META_WS_ONBEKNOCKEDDOWN: "Niedergeschlagen",
  T_46_META_WS_ONBOUNCEDBYTIRE: "Von Reifen abprallen",
  T_46_META_WS_ONBOUNCEENTITY: "Entität abprallen",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "Integrierte UI-Schaltfläche wird gedrückt",
  T_46_META_WS_ONBULLETHIT: "Kugel trifft",
  T_46_META_WS_ONCAMERARAYCAST: "Kamera-Raycast",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "Charakterkontroller getroffen",
  T_46_META_WS_ONCHASE: "Verfolgung",
  T_46_META_WS_ONCHASESTOP: "Verfolgung stoppt",
  T_46_META_WS_ONCLIPEND: "Clip-Ende",
  T_46_META_WS_ONCOLLISIONENTER: "Kollision beginnt",
  T_46_META_WS_ONCOLLISIONEXIT: "Kollision endet",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "Countdown beendet",
  T_46_META_WS_ONCREEP: "Schleichen",
  T_46_META_WS_ONCROUCH: "Hocken",
  T_46_META_WS_ONDEALDAMAGE: "Schaden zufügen",
  T_46_META_WS_ONDESTROY: "Zerstören",
  T_46_META_WS_ONDISABLE: "Deaktivieren",
  T_46_META_WS_ONDISCONNECT: "Verbindung unterbrochen",
  T_46_META_WS_ONDOUBLETAPPED: "Doppelt getippt",
  T_46_META_WS_ONDRAG: "Ziehen",
  T_46_META_WS_ONDRAGEND: "Drag-Ende",
  T_46_META_WS_ONDRAGSTART: "Drag-Start",
  T_46_META_WS_ONDRIVED: "Gefahren",
  T_46_META_WS_ONDRIVEVEHICLE: "Fahrzeug fahren",
  T_46_META_WS_ONDROPCONSUMABLE: "Verbrauchsgut fallenlassen",
  T_46_META_WS_ONDROPPED: "Fallen gelassen",
  T_46_META_WS_ONDROPWEAPON: "Waffe fallenlassen",
  T_46_META_WS_ONEACHLOOP: "Jeder Durchlauf",
  T_46_META_WS_ONELIMINATE: "Eliminieren",
  T_46_META_WS_ONELIMINATED: "Eliminiert",
  T_46_META_WS_ONENABLE: "Aktivieren",
  T_46_META_WS_ONEND: "Ende",
  T_46_META_WS_ONENTERED: "Eingetreten",
  T_46_META_WS_ONENTERVEHICLE: "Fahrzeug betreten",
  T_46_META_WS_ONENTITYENTER: "Entität betritt",
  T_46_META_WS_ONENTITYEXIT: "Entität verlässt",
  T_46_META_WS_ONEQUIPARMOR: "Rüstung ausrüsten",
  T_46_META_WS_ONEQUIPED: "Ausrüstung angelegt",
  T_46_META_WS_ONEQUIPWEAPON: "Waffe ausrüsten",
  T_46_META_WS_ONEXPLODE: "Explosion",
  T_46_META_WS_ONFALL: "Beim Fallen",
  T_46_META_WS_ONFALLSTOP: "Beim Fallen stoppen",
  T_46_META_WS_ONFIRE: "Schießen",
  T_46_META_WS_ONFIXEDUPDATE: "Fixiertes Update",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "Mit Fußball kollidiert",
  T_46_META_WS_ONFRIENDSUPDATE: "Freundschaftsstatus aktualisieren ",
  T_46_META_WS_ONGAMEEND: "Spielende",
  T_46_META_WS_ONGAMEPAUSE: "Spielpause",
  T_46_META_WS_ONGAMERESUME: "Spiel fortsetzen",
  T_46_META_WS_ONGAMESTART: "Spielstart",
  T_46_META_WS_ONGOAL: "Tor",
  T_46_META_WS_ONHITBYBULLET: "Von Kugel getroffen",
  T_46_META_WS_ONHITFLY: "Fliegend treffen",
  T_46_META_WS_ONHITFLYENTITY: "Fliegende Entität treffen",
  T_46_META_WS_ONHOOKGUNFIRE: "Hakenpistole abgefeuert",
  T_46_META_WS_ONIDLE: "Leerlauf",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "Jail Break Area Begin",
  T_46_META_WS_ONJAILBREAKAREAEND: "Jail Break Area End",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "Jail Break Spieler beitreten",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "Jail Break Spieler verlässt",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "Erfolgreich Chat-Kanal beigetreten",
  T_46_META_WS_ONJOYSTICKMOVE: "Joystick bewegen",
  T_46_META_WS_ONJOYSTICKPRESSED: "Gedrückt",
  T_46_META_WS_ONJOYSTICKRELEASED: "Losgelassen",
  T_46_META_WS_ONJUMP: "Sprung",
  T_46_META_WS_ONJUMPSTOP: "Beim Sprung stoppen",
  T_46_META_WS_ONLANDMINEACTIVE: "Landmine aktiviert",
  T_46_META_WS_ONLANDMINETRIGGER: "Landmine ausgelöst",
  T_46_META_WS_ONLEAVECHATCHANNEL: "Chat-Kanal verlassen",
  T_46_META_WS_ONLEAVEVEHICLE: "Fahrzeug verlassen",
  T_46_META_WS_ONLEFT: "Verlassen",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "Levelobjekt wird transformiert",
  T_46_META_WS_ONMOVE: "Bewegen",
  T_46_META_WS_ONNODEENTER: "Knoten betreten",
  T_46_META_WS_ONNODEEXIT: "Knoten verlassen",
  T_46_META_WS_ONPAUSE: "Pause",
  T_46_META_WS_ONPHASEEND: "Phasenende",
  T_46_META_WS_ONPHASESTART: "Phasenbeginn",
  T_46_META_WS_ONPICKEDUP: "Aufgehoben",
  T_46_META_WS_ONPLAYERASSIST: "Spieler assistiert",
  T_46_META_WS_ONPLAYERBEELIMINATED: "Spieler wird eliminiert",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "Spieler wird niedergeschlagen",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "Spieler fügt Schaden zu",
  T_46_META_WS_ONPLAYERELIMINATE: "Spieler eliminiert",
  T_46_META_WS_ONPLAYERENTER: "Spieler betritt",
  T_46_META_WS_ONPLAYERJOIN: "Spieler beitritt",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "Chat-Kanalbeitritt fehlgeschlagen",
  T_46_META_WS_ONPLAYERLEAVE: "Spieler verlässt",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "Spieler fordert Kauf an",
  T_46_META_WS_ONPLAYERQUIT: "Spieler verlässt",
  T_46_META_WS_ONPLAYERRANKCHANGE: "Spielerrang ändern",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "Spieleranfrage für Kauf erfüllt",
  T_46_META_WS_ONPLAYERREVIVED: "Spieler wird wiederbelebt",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "Spieler wird an Spawn-Position wiederbelebt",
  T_46_META_WS_ONPLAYERSCORECHANGE: "Spielerpunktestand ändern",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "Spieler wechselt Szene",
  T_46_META_WS_ONPREDEALDAMAGE: "Vor dem Schaden zufügen",
  T_46_META_WS_ONPREPURCHASE: "Vor dem Kauf",
  T_46_META_WS_ONPRESSED: "Gedrückt",
  T_46_META_WS_ONPRETAKEDAMAGE: "Vor dem Schaden nehmen",
  T_46_META_WS_ONPURCHASE: "Kaufen",
  T_46_META_WS_ONRANKCHANGED: "Entitätsrang ändern",
  T_46_META_WS_ONRECONNECT: "Wiederverbunden",
  T_46_META_WS_ONRELEASED: "Losgelassen",
  T_46_META_WS_ONRELOAD: "Nachladen",
  T_46_META_WS_ONRESUME: "Fortsetzen",
  T_46_META_WS_ONREVIVED: "Wiederbelebt",
  T_46_META_WS_ONROUNDEND: "Rundenende",
  T_46_META_WS_ONROUNDSTART: "Rundenbeginn",
  T_46_META_WS_ONSCENELOAD: "Szene laden",
  T_46_META_WS_ONSCENESWITCH: "Szene wechseln",
  T_46_META_WS_ONSCORECHANGE: "Entitätspunktestand ändern",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "Vom Fußball-Schützen getroffen",
  T_46_META_WS_ONSLEEP: "Schlafen",
  T_46_META_WS_ONSPAWN: "Spawnen",
  T_46_META_WS_ONSPRAY: "Sprüh",
  T_46_META_WS_ONSPRAYED: "Versprüht",
  T_46_META_WS_ONSPRINT: "Sprinten",
  T_46_META_WS_ONSPRINTSTOP: "Sprint stoppt",
  T_46_META_WS_ONSTANDUP: "Aufstehen",
  T_46_META_WS_ONSTART: "Start",
  T_46_META_WS_ONSTARTFIRE: "Angriff",
  T_46_META_WS_ONSTATEEND: "Status-Ende",
  T_46_META_WS_ONSURFING: "Surfen",
  T_46_META_WS_ONSURFINGSTOP: "Surfen stoppt",
  T_46_META_WS_ONSWITCHHANDHELD: "Handgerät wechseln",
  T_46_META_WS_ONTAKEDAMAGE: "Schaden erleiden",
  T_46_META_WS_ONTAPPED: "Getippt",
  T_46_META_WS_ONTEAMACE: "Team vollständig eliminiert",
  T_46_META_WS_ONTEAMADD: "Team hinzufügen",
  T_46_META_WS_ONTEAMREMOVE: "Team entfernen",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "Team-Rundenrang ändern",
  T_46_META_WS_ONTEAMSCORECHANGE: "Team-Punktestand ändern",
  T_46_META_WS_ONTELEPORTENTITY: "Entität teleportieren",
  T_46_META_WS_ONTEXTCHANGE: "Text ändern",
  T_46_META_WS_ONTHROWABLEEXPLODE: "Wurfobjekt explodiert",
  T_46_META_WS_ONTOGGLE: "Umschalten",
  T_46_META_WS_ONTOUCHDOWN: "Touch-Down",
  T_46_META_WS_ONTOUCHUP: "Touch-Up",
  T_46_META_WS_ONUIHIDE: "UI ausblenden",
  T_46_META_WS_ONUISHOW: "UI anzeigen",
  T_46_META_WS_ONUPDATE: "Aktualisieren",
  T_46_META_WS_ONUSEAVATARSKILL: "Avatar-Fähigkeit verwenden",
  T_46_META_WS_ONUSECONSUMABLE: "Verbrauchsgut verwenden",
  T_46_META_WS_ONUSED: "Verwendet",
  T_46_META_WS_ONUSEPORTAL: "Portal verwenden",
  T_46_META_WS_ONWAKEUP: "Aufwachen",
  T_46_META_WS_ONWEAPONBEEQUIPED: "Waffe ausgerüstet",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "Schaden durch Waffe",
  T_46_META_WS_ONWEAPONELIMINATE: "Waffe eliminiert",
  T_46_META_WS_ONWEAPONSTOPFIRING: "Waffe hört auf zu schießen",
  T_46_META_WS_OWNER: "Besitzer",
  T_46_META_WS_P_ACCELERATE: "Beschleunigen",
  T_46_META_WS_P_ACCELERATION: "Beschleunigung",
  T_46_META_WS_P_ACCOUNTID: "Konto-ID",
  T_46_META_WS_P_ACCURACY: "Genauigkeit",
  T_46_META_WS_P_ACTIONTYPE: "Aktionsart",
  T_46_META_WS_P_ACTIVATEDALPHA: "Aktivierte Alpha",
  T_46_META_WS_P_ACTIVE: "Aktiv",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "Aktiv in Hierarchie",
  T_46_META_WS_P_ACTIVESELF: "Aktives Selbst",
  T_46_META_WS_P_ACTIVETEXT: "Aktiver Text",
  T_46_META_WS_P_ACTUALPOSITION: "Tatsächliche Position",
  T_46_META_WS_P_AFTERACCUMULATOR: "Nach-Akkumulator",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "Zielhilfecenter-Versatz",
  T_46_META_WS_P_AIMASSISTDISTANCE: "Zielhilfedistanz",
  T_46_META_WS_P_AIMASSISTTYPE: "Zielhilfe",
  T_46_META_WS_P_AIRDROPSTATE: "Air-Drop-Zustand",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "Horizontale Ausrichtung",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "Vertikale Ausrichtung",
  T_46_META_WS_P_ALLITEMS: "Alle Elemente",
  T_46_META_WS_P_ALLMEMBERS: "Alle Mitglieder",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "Durch Zielhilfe sperren",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "Drücken außerhalb zulassen",
  T_46_META_WS_P_ALLPLAYERS: "Alle Spieler",
  T_46_META_WS_P_ALLTEAMMATES: "Alle Teamkollegen",
  T_46_META_WS_P_ALPHA: "Alpha",
  T_46_META_WS_P_ALWAYSSHOWMARK: "Markierung immer anzeigen",
  T_46_META_WS_P_AMBIENTCOLOR: "Umgebungsfarbe",
  T_46_META_WS_P_AMMOCLIPSIZE: "Magazingröße",
  T_46_META_WS_P_AMMOMAGSIZE: "Munitionsmagazin Größe",
  T_46_META_WS_P_AMMOPERSHOT: "Munition pro Schuss",
  T_46_META_WS_P_AMMOTYPE: "Munitionstyp",
  T_46_META_WS_P_ANCHORMAX: "Anker-Max",
  T_46_META_WS_P_ANCHORMIN: "Anker-Min",
  T_46_META_WS_P_ANCHOROBJECT: "Ankerobjekt",
  T_46_META_WS_P_ANCHORPOSITION: "Ankerposition",
  T_46_META_WS_P_ANCHORTYPE: "UITweener-Skript aktiviert",
  T_46_META_WS_P_ANGLE: "Winkel",
  T_46_META_WS_P_ANGLEDOWN: "Winkel nach unten",
  T_46_META_WS_P_ANGLEUP: "Winkel nach oben",
  T_46_META_WS_P_ANGULARDRAG: "Winkelwiderstand",
  T_46_META_WS_P_ANGULARSPEED: "Winkelgeschwindigkeit",
  T_46_META_WS_P_ANGULARVELOCITY: "Winkelgeschwindigkeit (rad/s)",
  T_46_META_WS_P_ANIMATIONCLIP: "Animationsname",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "Animationscontroller",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "Animationscontroller-Ressourcen-ID",
  T_46_META_WS_P_ARMORPENETRATION: "Panzerungspenetration",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "Rüstungsdurchdringungsfaktor",
  T_46_META_WS_P_ARMORTYPE: "Rüstungstyp",
  T_46_META_WS_P_ARROWOFFSET: "Pfeil-Offset",
  T_46_META_WS_P_ARROWSIZE: "Pfeil-Größe",
  T_46_META_WS_P_ARROWSPRITE: "Pfeil-Sprite",
  T_46_META_WS_P_ASKBUYTARGET: "Kaufziel anfragen",
  T_46_META_WS_P_ATTACHTARGET: "Zielobjekt",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "Angreifbare Fraktionen",
  T_46_META_WS_P_ATTACKDAMAGE: "Angriffsschaden",
  T_46_META_WS_P_ATTACKINTERVAL: "Angriff-Intervall",
  T_46_META_WS_P_ATTACKRANGE: "Angriffsbereich",
  T_46_META_WS_P_ATTACKTARGET: "Angriffsziel",
  T_46_META_WS_P_ATTTACKABLETARGETS: "Angreifbare Ziele",
  T_46_META_WS_P_AUTOPLAY: "Automatischer Wiedergabestatus",
  T_46_META_WS_P_AVAILABLEPOINT: "Verfügbarer Punkt",
  T_46_META_WS_P_AVATAR: "Avatar",
  T_46_META_WS_P_AVATARID: "Avatar-ID",
  T_46_META_WS_P_BACKGROUND: "Hintergrund",
  T_46_META_WS_P_BACKGROUNDALPHA: "Hintergrund Alpha",
  T_46_META_WS_P_BACKGROUNDCOLOR: "Hintergrundfarbe",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "Hintergrundfarbe 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "Hintergrundfarbe 2",
  T_46_META_WS_P_BACKGROUNDFILL: "Hintergrundfüllung",
  T_46_META_WS_P_BACKGROUNDICONNAME: "Name des Hintergrundsymbols",
  T_46_META_WS_P_BACKGROUNDNAME: "Hintergrundname",
  T_46_META_WS_P_BACKGROUNDOFFSET: "Hintergrund-Offset",
  T_46_META_WS_P_BACKGROUNDRADIUS: "Hintergrund-Radius",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "Hintergrund Größe Delta",
  T_46_META_WS_P_BACKGROUNDSPRITE: "Hintergrund-Sprite",
  T_46_META_WS_P_BACKPACK: "Rucksack",
  T_46_META_WS_P_BACKPACKSKINID: "Rucksack-Skin-ID",
  T_46_META_WS_P_BACKWARDSPEED: "Rückwärtsgeschwindigkeit",
  T_46_META_WS_P_BANNERID: "Banner-ID",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "Basis Horizontale Geschwindigkeit",
  T_46_META_WS_P_BASEMULTIPLIER: "Basis-Multiplikator",
  T_46_META_WS_P_BASETIME: "Basiszeit",
  T_46_META_WS_P_BASEVERTICALSPEED: "Basis Vertikale Geschwindigkeit",
  T_46_META_WS_P_BEFOREACCUMULATOR: "Vor-Akkumulator",
  T_46_META_WS_P_BEVTREEID: "Verhaltensbaum-ID",
  T_46_META_WS_P_BINDPROPERTYID: "Bindungs-Eigenschafts-ID",
  T_46_META_WS_P_BODY: "Torso",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "Körper-Schadensfaktor",
  T_46_META_WS_P_BONEPOSITION: "Knochenposition",
  T_46_META_WS_P_BONESCALE: "Knochenskalierung",
  T_46_META_WS_P_BOOSTCD: "Boost CD",
  T_46_META_WS_P_BOOSTDURATION: "Boost Dauer",
  T_46_META_WS_P_BOOSTSPEED: "Boost Geschwindigkeit",
  T_46_META_WS_P_BORDERLR: "Rand Links Rechts",
  T_46_META_WS_P_BORDERTB: "Rand Oben Unten",
  T_46_META_WS_P_BOTTOMALPHA: "Unten Alpha",
  T_46_META_WS_P_BOUNDWALLET: "HUD-Anker-Typ",
  T_46_META_WS_P_BRAKEHORSEPOWER: "Brems-PS",
  T_46_META_WS_P_BRAKETORQUE: "Brems-Drehmoment",
  T_46_META_WS_P_BRRANK: "BR-Rang",
  T_46_META_WS_P_BUFFTYPE: "Buff-Typ",
  T_46_META_WS_P_BURNDAMAGE: "Brennschaden",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "Brennschaden-Intervall",
  T_46_META_WS_P_BURNTIME: "Brenndauer",
  T_46_META_WS_P_BUTTOM: "Unterteil",
  T_46_META_WS_P_BUTTONCOLORS: "Button-Farben",
  T_46_META_WS_P_BUTTONNAMES: "Button-Namen",
  T_46_META_WS_P_BUTTONSTYLE: "Schaltflächenstil",
  T_46_META_WS_P_CAMERABLOCKMODE: "Kamerablockmodus",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "Kameraprojektionsmodus",
  T_46_META_WS_P_CAMERATYPE: "Kamera",
  T_46_META_WS_P_CANCELDRAGIFFITS: "Ziehen abbrechen, wenn passt",
  T_46_META_WS_P_CANCOSTDURABILITY: "Kann Haltbarkeit kosten",
  T_46_META_WS_P_CANDAMAGED: "Kann beschädigt werden",
  T_46_META_WS_P_CANDESTROY: "Kann zerstört werden",
  T_46_META_WS_P_CANDESTROYED: "Kann zerstört werden",
  T_46_META_WS_P_CANSELFTRIGGER: "Selbst auslösbar",
  T_46_META_WS_P_CANTEAMTRIGGER: "Team auslösbar",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "Kann durch sich selbst ausgelöst werden",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "Kann durch Team ausgelöst werden",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "Kann durch Fahrzeug ausgelöst werden",
  T_46_META_WS_P_CANVEHICLETRIGGER: "Fahrzeug auslösbar",
  T_46_META_WS_P_CELLSIZE: "Zellgröße",
  T_46_META_WS_P_CELLSPACE: "Zellabstand",
  T_46_META_WS_P_CENTER: "Zentrum",
  T_46_META_WS_P_CENTERINVISIBLE: "Zentrum unsichtbar",
  T_46_META_WS_P_CENTEROFFSET: "Mittelpunktversatz",
  T_46_META_WS_P_CENTEROFMASS: "Schwerpunkt",
  T_46_META_WS_P_CENTERRANGE: "Zentralbereich",
  T_46_META_WS_P_CENTRALFLASHTIME: "Randblitzzeit",
  T_46_META_WS_P_CENTRALLINEACTIVE: "Mittellinie aktiv",
  T_46_META_WS_P_CENTRALLINEPOSITION: "Mittellinienposition",
  T_46_META_WS_P_CHANNELID: "Chat-Kanal-ID",
  T_46_META_WS_P_CHARGEMAX: "Maximale Ladung",
  T_46_META_WS_P_CHASETARGET: "Verfolgungsziel",
  T_46_META_WS_P_CHATCHANNEL: "Chat-Kanal",
  T_46_META_WS_P_CHECKPOINTID: "Checkpoint-ID",
  T_46_META_WS_P_CHILDINDEX: "Kind-Index",
  T_46_META_WS_P_CHIPEXP: "Chip-Erfahrung",
  T_46_META_WS_P_CLICKSIZE: "Klickgröße",
  T_46_META_WS_P_CLIPLENGTH: "Clip-Länge",
  T_46_META_WS_P_CLIPPINGTYPE: "Clipping-Typ",
  T_46_META_WS_P_COLLIDERID: "Collider-ID",
  T_46_META_WS_P_CONSTRAIN: "Einschränken",
  T_46_META_WS_P_CONSTRAINT: "Einschränkung",
  T_46_META_WS_P_CONSTRAINTCOUNT: "Einschränkungsanzahl",
  T_46_META_WS_P_CONSUMABLETYPE: "Verbrauchstyp",
  T_46_META_WS_P_CONTENT: "Inhalt",
  T_46_META_WS_P_CONTENTORIGIN: "Inhaltsursprung",
  T_46_META_WS_P_CONTROLPOINTS: "Kontrollpunkte",
  T_46_META_WS_P_COORDINATESYSTEM: "Koordinatensystem",
  T_46_META_WS_P_COUNT: "Anzahl",
  T_46_META_WS_P_COUNTDOWNENDTIME: "Countdown-Endzeit (s)",
  T_46_META_WS_P_COUNTDOWNKEY: "Countdown-Schlüssel",
  T_46_META_WS_P_COUNTDOWNTIME: "Countdown-Zeit",
  T_46_META_WS_P_COUNTPERWAVE: "Anzahl pro Welle",
  T_46_META_WS_P_CRASHMAXDAMAGE: "Maximaler Crash-Schaden",
  T_46_META_WS_P_CRASHMAXSPEED: "Crash-Maximalgeschwindigkeit",
  T_46_META_WS_P_CRASHMESSFACTOR: "Crash-Mass-Faktor",
  T_46_META_WS_P_CRASHMINDAMAGE: "Minimaler Crash-Schaden",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "Kriechgeschwindigkeit-Skalierung",
  T_46_META_WS_P_CREATEDENTITY: "Erstellte Entität",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "Bewegungspeed-Skalierung beim Hocken",
  T_46_META_WS_P_CSRANK: "CS-Rang",
  "T_46_META_WS_P_CURRENT AMMO": "Aktuelle Munition",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "Aktuelle Animationsressource",
  T_46_META_WS_P_CURRENTCLIP: "Aktueller Clip",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "Fortschritt des aktuellen Clips",
  T_46_META_WS_P_CURRENTDURABILITY: "Aktuelle Haltbarkeit",
  T_46_META_WS_P_CURRENTENERGY: "Aktuelle Energie",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "Aktueller Handheld-Gegenstand",
  T_46_META_WS_P_CURRENTHP: "Aktuelle HP",
  T_46_META_WS_P_CURRENTPHASEINDEX: "Aktueller Phasenindex",
  T_46_META_WS_P_CURRENTPROGRESS: "Aktueller Fortschritt",
  T_46_META_WS_P_CURRENTROUNDINDEX: "Aktueller Rundenzähler",
  T_46_META_WS_P_CURRENTSTATE: "Aktueller Zustand",
  T_46_META_WS_P_CURRENTVALUE: "Aktueller Wert",
  T_46_META_WS_P_CURRENTWAVE: "Aktuelle Welle",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "Benutzerdefinierte Charakterressource",
  T_46_META_WS_P_CUSTOMGAMERESULT: "Benutzerdefiniertes Spielergebnis",
  T_46_META_WS_P_CUSTOMGRAVITY: "Benutzerdefinierte Schwerkraft",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "Benutzerdefinierte Schubkraft",
  T_46_META_WS_P_CUSTOMXY: "Benutzerdefiniert XY",
  T_46_META_WS_P_DAMAGE: "Schaden",
  "T_46_META_WS_P_DAMAGE RANGE": "Reichweite",
  T_46_META_WS_P_DAMAGEFACTOR: "Schadensfaktor",
  T_46_META_WS_P_DAMAGEINTERVAL: "Schaden-Intervall (ms)",
  T_46_META_WS_P_DAMAGERADIUS: "Schadensradius",
  T_46_META_WS_P_DAMAGERATIOHEAD: "Kopfschadenverhältnis",
  T_46_META_WS_P_DAMAGERATIOLIMB: "Gliederschadenverhältnis",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "Schadensreduktionsfaktor",
  T_46_META_WS_P_DAMAGETAKENPCT: "Schadennehmen-Prozentsatz",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "Erhaltener Schaden Prozentsatz",
  T_46_META_WS_P_DAMAGEVALUE: "Schadenswert",
  T_46_META_WS_P_DARKNESS: "Dunkelheit",
  T_46_META_WS_P_DECELERATIONPERCENT: "Verzögerungsprozentsatz",
  T_46_META_WS_P_DEFAULTTEXT: "Standardtext",
  T_46_META_WS_P_DEFENSE: "Verteidigungsrate",
  T_46_META_WS_P_DEFENSERATE: "Verteidigungsrate",
  T_46_META_WS_P_DELTA: "Delta",
  T_46_META_WS_P_DELTATIME: "Delta-Zeit",
  T_46_META_WS_P_DELTAVALUE: "Delta-Wert",
  T_46_META_WS_P_DEPTH: "Tiefe",
  T_46_META_WS_P_DESC: "Beschreibung",
  T_46_META_WS_P_DESCRIPTION: "Beschreibung",
  T_46_META_WS_P_DESCRIPTIONKEY: "Beschreibungsschlüssel",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "Beschreibung der Tipps-Parameter",
  T_46_META_WS_P_DESTVAL: "Zielwert",
  T_46_META_WS_P_DETECTRANGE: "Erkennungsreichweite",
  T_46_META_WS_P_DIFFUSEALPHA: "Diffusalpha",
  T_46_META_WS_P_DIFFUSECOLOR: "Diffuserfarbe",
  T_46_META_WS_P_DIFFUSETEXTURE: "Diffusortextur",
  T_46_META_WS_P_DISABLECOLOR: "Deaktivierte Farbe",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "Fallschaden deaktivieren",
  T_46_META_WS_P_DISABLEITEMDROP: "Itemabwurf deaktivieren",
  T_46_META_WS_P_DISABLEITEMPICKUP: "Itemaufhebung deaktivieren",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "Manuelles Schließen deaktivieren",
  T_46_META_WS_P_DISABLEQUICKCHAT: "Schneller Chat deaktivieren",
  T_46_META_WS_P_DISABLERECIPROCATING: "Keine Hin- und Rückbewegung",
  T_46_META_WS_P_DISABLEVOICECHAT: "Voice-Chat deaktivieren",
  T_46_META_WS_P_DISTANCE: "Entfernung",
  T_46_META_WS_P_DOUBLEGUNTYPE: "Doppelwaffentyp",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "Kriechgeschwindigkeit-Skalierung",
  T_46_META_WS_P_DOWNSPEED: "Abwärtsgeschwindigkeit",
  T_46_META_WS_P_DRAG: "Luftwiderstand",
  T_46_META_WS_P_DRIVER: "Fahrer",
  T_46_META_WS_P_DROPITEMS: "Fallende Gegenstände",
  T_46_META_WS_P_DURABILITY: "Haltbarkeit",
  T_46_META_WS_P_DURABILITYRECOVERY: "Haltbarkeit Wiederherstellung",
  T_46_META_WS_P_DURATION: "Dauer",
  T_46_META_WS_P_EDGEFLASHTIME: "Blendgranat-Effekt-Schalter",
  T_46_META_WS_P_EFFECTACTIVE: "Effekt aktiv",
  T_46_META_WS_P_EFFECTCOLOR: "Effektfarbe",
  T_46_META_WS_P_EFFECTDURATION: "Auslösezeit",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "Effektives Zeitintervall",
  T_46_META_WS_P_EFFECTRESID: "Effektressourcenpfad",
  T_46_META_WS_P_ENABLE: "Aktivieren",
  T_46_META_WS_P_ENABLEATTACK: "Angriff aktivieren",
  T_46_META_WS_P_ENABLEBOTREVIVE: "Bot-Wiederbelebung aktivieren",
  T_46_META_WS_P_ENABLEDEPTHMAP: "Tiefenkarten aktivieren",
  T_46_META_WS_P_ENABLEDROPONDEATH: "Drop bei Tod aktivieren",
  T_46_META_WS_P_ENABLELOCALIZATION: "Lokalisierung aktivieren",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "In der Luft bewegen",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "Spieler-Wiederbelebung aktivieren",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "Spieleransicht aktivieren",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "Mit Schwerkraft rotieren",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "Hautattribute aktivieren",
  T_46_META_WS_P_ENABLESWINGING: "Schwung aktivieren",
  T_46_META_WS_P_ENABLETRACTION: "Traktion aktivieren",
  T_46_META_WS_P_ENDPOSITION: "Endposition",
  T_46_META_WS_P_ENDRADIUS: "End-Radius",
  T_46_META_WS_P_ENDTIME: "Endzeit (ms)",
  T_46_META_WS_P_ENDTIMES: "Endzeit",
  T_46_META_WS_P_ENDVALUE: "Endwert",
  T_46_META_WS_P_ENERGY: "Energie",
  T_46_META_WS_P_ENERGYCOST: "Energieverbrauch",
  T_46_META_WS_P_ENERGYRECOVERY: "Energieerholung",
  T_46_META_WS_P_ENGINEHORSEPOWER: "Motor-PS",
  T_46_META_WS_P_ENGINETORQUE: "Motor-Drehmoment",
  T_46_META_WS_P_EP: "EP",
  T_46_META_WS_P_EPMAX: "Max. EP",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "EP-Wiederherstellungsmenge",
  T_46_META_WS_P_EVENTS: "Ereignisse",
  T_46_META_WS_P_EXPLODEDAMAGE: "Explosionsschaden",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "Explosionsschadenreduktionsfaktor",
  T_46_META_WS_P_EXPLODEDELAY: "Explosionsverzögerung",
  T_46_META_WS_P_EXPLODERANGE: "Explosionsbereich",
  T_46_META_WS_P_EXPLOSIONDELAY: "Zentraler Blitzzeit",
  T_46_META_WS_P_EXPLOSIONRANGE: "Explosionsradius",
  T_46_META_WS_P_EXPLOSIONTIME: "Explosionsverzögerung",
  T_46_META_WS_P_EXPPERDAMAGE: "Erfahrung pro Schaden",
  T_46_META_WS_P_EXPPERMOVEMILE: "Erfahrung pro zurückgelegter Meile",
  T_46_META_WS_P_EXPPERSECOND: "Erfahrung pro Sekunde",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "Zusätzliche Rucksackkapazität",
  T_46_META_WS_P_EXTRABAGCAPACITY: "Zusätzlicher Rucksackplatz",
  T_46_META_WS_P_EXTRAHPRATIO: "Extra-HP-Verhältnis",
  T_46_META_WS_P_FACEPAINT: "Gesichtsbemalung",
  T_46_META_WS_P_FACTION: "Fraktion",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "Fallenschaden-Verhältnis",
  T_46_META_WS_P_FALLSPEED: "Fallgeschwindigkeit",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "Automatische Nachladegeschwindigkeit",
  T_46_META_WS_P_FILEID: "Datei-ID",
  T_46_META_WS_P_FILL: "Füllung",
  T_46_META_WS_P_FILLAMOUNT: "Füllwert",
  T_46_META_WS_P_FILLDIRECTION: "Füllrichtung",
  T_46_META_WS_P_FILLTYPE: "Fülltyp",
  T_46_META_WS_P_FIREANGLELIMIT: "Feuerwinkelbegrenzung",
  T_46_META_WS_P_FIRETYPE: "Feuertyp",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "Erster Punkt Parameter",
  T_46_META_WS_P_FIRSTSCORETITLE: "Erster Punkt Titel",
  T_46_META_WS_P_FIRSTSCOREVALUE: "Erster Punkt Wert",
  T_46_META_WS_P_FIXEDDELTATIME: "Feste Delta-Zeit",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "Effekt-Dauer",
  T_46_META_WS_P_FLIP: "Umkehren",
  T_46_META_WS_P_FLIPTYPE: "Flip-Typ",
  T_46_META_WS_P_FLYMAXHEIGHT: "Maximale Flughöhe",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "Horizontale Fluggeschwindigkeit",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "Vertikale Fluggeschwindigkeit",
  T_46_META_WS_P_FOGCOLOR: "Nebelfarbe",
  T_46_META_WS_P_FOLLOWTARGET: "Ziel verfolgen",
  T_46_META_WS_P_FONT: "Schriftart",
  T_46_META_WS_P_FONTSIZE: "Schriftgröße",
  T_46_META_WS_P_FONTSTYLE: "Schriftstil",
  T_46_META_WS_P_FONTTYPE: "Schriftart",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "Zwangssynchronisation mit Client",
  T_46_META_WS_P_FORWARD: "Vorwärts",
  T_46_META_WS_P_FORWARDSPEED: "Vorwärtsgeschwindigkeit",
  T_46_META_WS_P_FOV: "Sichtfeld",
  T_46_META_WS_P_FREEZEDURATION: "Einfrierdauer (s)",
  T_46_META_WS_P_FRIENDFACTIONS: "Freundliche Fraktionen",
  T_46_META_WS_P_FRIENDLYPLAYERS: "Freundliche Spieler",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "Vollschadenreichweite",
  T_46_META_WS_P_FUNCTIONTYPE: "Funktionstyp",
  T_46_META_WS_P_GAINHPCOLOR: "HP-Gewinnfarbe",
  T_46_META_WS_P_GAMEFRAMECOUNT: "Gesamtanzahl an Frames",
  T_46_META_WS_P_GAMETIMECOUNT: "Spielzeit",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "Verzögerung beim Gangwechsel",
  T_46_META_WS_P_GENDER: "Geschlecht",
  T_46_META_WS_P_GETONBOOSTCD: "Boost'e Binme CD",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "Boost'e Binme CD Anahtarı",
  T_46_META_WS_P_GETONSKATEBOARDCD: "Kaykay CD",
  T_46_META_WS_P_GRADIENT: "Verlauf",
  T_46_META_WS_P_GRADIENTBOTTOM: "Verlauf Unten",
  T_46_META_WS_P_GRADIENTTOP: "Verlauf Oben",
  T_46_META_WS_P_GRAVITY: "Schwerkraft",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "Granaten-Maximalschaden",
  T_46_META_WS_P_GRENADEMINDAMAGE: "Granaten-Minimalschaden",
  T_46_META_WS_P_GRENADERANGE: "Granaten-Reichweite",
  T_46_META_WS_P_GROUPID: "Gruppen-ID",
  T_46_META_WS_P_HEAD: "Kopf",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "Kopf-Schadensfaktor",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "Kopfschuss-Schadenreduktion",
  T_46_META_WS_P_HEIGHT: "Höhe",
  T_46_META_WS_P_HELMET: "Helm",
  T_46_META_WS_P_HIGHESTBRRANK: "Höchster BR-Rang",
  T_46_META_WS_P_HIGHESTCSRANK: "Höchster CS-Rang",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "Minimale Erhebungswinkel",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "Hochgeschwindigkeits-Lenkbegrenzung",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "Hochgeschwindigkeits-Lenkbegrenzungsschwelle",
  T_46_META_WS_P_HITPOINTEFFECT: "Trefferpunkteffekt",
  T_46_META_WS_P_HORIZONTALBAR: "Horizontale Leiste",
  T_46_META_WS_P_HORIZONTALOFFSET: "Horizontaler Offset",
  T_46_META_WS_P_HOSTILETEAMS: "Feindliche Teams",
  T_46_META_WS_P_HOSTTEAM: "Gastgeberteam",
  T_46_META_WS_P_HP: "HP",
  T_46_META_WS_P_HPMAX: "Max. HP",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "HP-Wiederherstellungsmenge",
  T_46_META_WS_P_HPRECOVERYSPEED: "HP-Wiederherstellungsgeschwindigkeit (ms)",
  T_46_META_WS_P_ICON: "Symbol",
  T_46_META_WS_P_ICONCOLOR: "Symbolfarbe",
  T_46_META_WS_P_ICONNAME: "Name des Symbols",
  T_46_META_WS_P_ICONRESOURCE: "Symbol-Ressource",
  T_46_META_WS_P_ID: "ID",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "Schadensintervall (s)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "Leerlauf-Bremseneingang",
  T_46_META_WS_P_INACTIVATEDALPHA: "Deaktivierte Alpha",
  T_46_META_WS_P_INDEX: "Index",
  T_46_META_WS_P_INITIALMAGCOUNT: "Anfangszahl der Magazine",
  T_46_META_WS_P_INITIALSPEED: "Anfangsgeschwindigkeit",
  T_46_META_WS_P_INITIALVALUE: "Anfangswert",
  T_46_META_WS_P_INITIALWORLDPOSITION: "Anfangsweltposition",
  T_46_META_WS_P_INSCENE: "In Szene",
  T_46_META_WS_P_INSTANCEID: "Instanz-ID",
  T_46_META_WS_P_INTENSITY: "Intensität",
  T_46_META_WS_P_INVERTFILL: "Füllumkehr",
  T_46_META_WS_P_INVINCIBLE: "Unbesiegbar",
  "T_46_META_WS_P_IS SHOW": "Anzeigen",
  T_46_META_WS_P_IS3D: "Ist 3D",
  T_46_META_WS_P_ISACE: "Ist ACE",
  T_46_META_WS_P_ISACED: "Vollständig zerstört",
  T_46_META_WS_P_ISAI: "Ist es KI?",
  T_46_META_WS_P_ISALWAYSINSCREEN: "Immer im Bildschirm",
  T_46_META_WS_P_ISAPPLYSHADOW: "Schatten anwenden",
  T_46_META_WS_P_ISATTACKABLE: "Angriffbar",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "Automatische Verfolgung des Feindes",
  T_46_META_WS_P_ISAUTOPLAY: "Automatisch abspielen",
  T_46_META_WS_P_ISAUTOTELEPORT: "Automatisches Teleportieren",
  T_46_META_WS_P_ISBILLBOARD: "Immer im Videobild",
  T_46_META_WS_P_ISBOLD: "Fett",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "Unten kollidiert",
  T_46_META_WS_P_ISCENTERPOS: "Ist Mittelpunkt",
  T_46_META_WS_P_ISCONSUMEAMMO: "Munition verbrauchen",
  T_46_META_WS_P_ISCONTINUOUS: "Kontinuierlich",
  T_46_META_WS_P_ISCOUNTDOWN: "Countdown",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "Ist die aktuelle Animation Schleife?",
  T_46_META_WS_P_ISDEADDROP: "Todessupport",
  T_46_META_WS_P_ISDEATHTRIGGER: "Todesauslöser",
  T_46_META_WS_P_ISDEBUG: "BTree Debug aktivieren",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "Standard-Spawnpunkt",
  T_46_META_WS_P_ISDROPONELIMINATED: "Beim Ausscheiden verlieren",
  T_46_META_WS_P_ISEND: "Ende",
  T_46_META_WS_P_ISFEBUTTON: "FE-Button",
  T_46_META_WS_P_ISGREY: "Grau?",
  T_46_META_WS_P_ISGROUNDED: "Am Boden",
  T_46_META_WS_P_ISIGNOREDEPTH: "Tiefe ignorieren",
  T_46_META_WS_P_ISINVINCIBLE: "Unbesiegbar",
  T_46_META_WS_P_ISITALIC: "Kursiv",
  T_46_META_WS_P_ISLASTROUND: "Letzte Runde?",
  T_46_META_WS_P_ISLOCALPOS: "Lokales Koordinatensystem aktivieren",
  T_46_META_WS_P_ISLOOP: "Schleifen",
  T_46_META_WS_P_ISMATCHPOINT: "Matchpunkt?",
  T_46_META_WS_P_ISMOVEABLE: "Bewegen erlaubt",
  T_46_META_WS_P_ISOCCUPIED: "Belegt",
  T_46_META_WS_P_ISOPENTWEEN: "HP-Änderungseffekte aktivieren",
  T_46_META_WS_P_ISPLAYING: "Wird abgespielt",
  T_46_META_WS_P_ISPURCHASABLE: "Geschäftselemente",
  T_46_META_WS_P_ISREVERSE: "Umkehren",
  T_46_META_WS_P_ISSERVERDRIVEN: "Server-gesteuert",
  T_46_META_WS_P_ISSHOW: "Anzeigen",
  T_46_META_WS_P_ISSHOWHUDNAME: "HUD-Namen anzeigen",
  T_46_META_WS_P_ISSHOWMAPINFO: "Karteninformation anzeigen",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "Schnelle Nachrichten anzeigen",
  T_46_META_WS_P_ISSHOWSCAN: "Scan anzeigen",
  T_46_META_WS_P_ISSHOWTAG: "Tag anzeigen",
  T_46_META_WS_P_ISSIDECOLLIDING: "Seite kollidiert",
  T_46_META_WS_P_ISSILENCE: "Geräuschlos",
  T_46_META_WS_P_ISSINGLESHOT: "Einzelschuss",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "Stagger-Animation überspringen",
  T_46_META_WS_P_ISSLIDING: "Gleitet",
  T_46_META_WS_P_ISTOPCOLLIDING: "Oben kollidiert",
  T_46_META_WS_P_ISUNDERLINE: "Unterstrichen",
  T_46_META_WS_P_ISVISIBLE: "Sichtbar",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "Item-Hintergrundfarben",
  T_46_META_WS_P_ITEMBACKGROUNDS: "Item-Hintergründe",
  T_46_META_WS_P_ITEMCOUNTS: "Kaufbar",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "Item-Beschreibungen",
  T_46_META_WS_P_ITEMICONS: "Item-Symbole",
  T_46_META_WS_P_ITEMID: "Gegenstands-ID",
  T_46_META_WS_P_ITEMIDS: "Artikel-IDs",
  T_46_META_WS_P_ITEMNAMES: "Item-Namen",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "Verbotsliste für Item-Aufnahme",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "Joystick-Kappe Zieh-Radius",
  T_46_META_WS_P_JOYSTICKIMAGE: "Joystick-Kappe Bild",
  T_46_META_WS_P_JOYSTICKRADIUS: "Joystick-Kappe Radius",
  T_46_META_WS_P_JUMPCD: "Sprung CD",
  T_46_META_WS_P_JUMPHEIGHT: "Sprunghöhe",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "Sprunghöhe-Skala",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "Umwerfschadenbonus",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "Knockdown-Status",
  T_46_META_WS_P_LABEL: "Beschriftung",
  T_46_META_WS_P_LABELCOLOR: "Textfarbe",
  T_46_META_WS_P_LABELKEY: "Beschriftungsschlüssel",
  T_46_META_WS_P_LABELPARAMS: "Beschriftungsparameter",
  T_46_META_WS_P_LASTCHECKPOINTID: "Aktuelle Checkpoint-ID",
  T_46_META_WS_P_LASTSURVIVALTIME: "Letzte Überlebenszeit",
  T_46_META_WS_P_LAYERTYPE: "Schichttyp",
  T_46_META_WS_P_LAYOUTTYPE: "Layouttyp",
  T_46_META_WS_P_LEFTARM: "Linker Arm",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "Hintergrundfarbe links",
  T_46_META_WS_P_LEFTCOLOR: "Linke Farbe",
  T_46_META_WS_P_LEFTDESCRIPTION: "Beschreibung links",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "Linker Effekt aktiv",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "Linker Feuerradiuswinkel",
  T_46_META_WS_P_LEFTFOOT: "Linker Fuß",
  T_46_META_WS_P_LEFTHAND: "Linke Hand",
  T_46_META_WS_P_LEFTICON: "Linkes Symbol",
  T_46_META_WS_P_LEFTICONNAME: "Name des Symbols links",
  T_46_META_WS_P_LEFTLEG: "Linkes Bein",
  T_46_META_WS_P_LEFTPLAYERS: "Linke Spieler",
  T_46_META_WS_P_LEFTSCORE: "Linker Punktestand",
  T_46_META_WS_P_LEFTSCOREAFTER: "Endpunktestand links",
  T_46_META_WS_P_LEFTSCORETEXT: "Linker Punktestand",
  T_46_META_WS_P_LEFTTEAM: "Rechtes Team",
  T_46_META_WS_P_LEFTTEAMINDEX: "Linker Team-Index",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "Anzahl der lebenden Teamkollegen links",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "Flaggenanzahl links",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "Linke Teamstatus",
  T_46_META_WS_P_LEFTTEAMNAME: "Teamname links",
  T_46_META_WS_P_LEFTTEAMSCORE: "Punktestand links",
  T_46_META_WS_P_LEFTTEXT: "Linker Text",
  T_46_META_WS_P_LENGTH: "Länge",
  T_46_META_WS_P_LENSFLARE: "Lensflare",
  T_46_META_WS_P_LEVEL: "Stufe",
  T_46_META_WS_P_LIFETIME: "Lebensdauer (s)",
  T_46_META_WS_P_LIGHTCOLOR: "Lichtfarbe",
  T_46_META_WS_P_LIGHTINTENSITY: "Lichtintensität",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "Gliedmaßen-Schadensfaktor",
  T_46_META_WS_P_LINESPACING: "Zeilenabstand",
  T_46_META_WS_P_LOCALPOSITION: "Lokale Position",
  T_46_META_WS_P_LOCALROTATION: "Lokale Rotation",
  T_46_META_WS_P_LOCALROTATIONQ: "Lokales Rotationsquaternion",
  T_46_META_WS_P_LOCALSCALE: "Lokaler Maßstab",
  T_46_META_WS_P_LOCKEY: "Lokalisierungsschlüssel",
  T_46_META_WS_P_LOOPCOUNT: "Schleifenanzahl",
  T_46_META_WS_P_LOOTSOCCER: "Beute Fußball",
  T_46_META_WS_P_LOSEHPCOLOR: "HP-Verlustfarbe",
  T_46_META_WS_P_LOSEMVPS: "Verlierer MVPs",
  T_46_META_WS_P_LOSETEXT: "Verlust-Text",
  "T_46_META_WS_P_MAIN CAMERA": "Hauptkamera",
  T_46_META_WS_P_MAINCOLOR: "Hauptfarbe",
  T_46_META_WS_P_MAINSCORELIST: "Hauptpunkte",
  T_46_META_WS_P_MAINSCORETITLE: "Hauptpunkt-Titel",
  T_46_META_WS_P_MAINWEAPON: "Hauptwaffe",
  T_46_META_WS_P_MAPSIZE: "Karten Größe",
  T_46_META_WS_P_MASK: "Maske",
  T_46_META_WS_P_MASKNAME: "Maskenname",
  T_46_META_WS_P_MASS: "Masse (kg)",
  T_46_META_WS_P_MATCHTITLELEFT: "Match-Titel Links",
  T_46_META_WS_P_MATCHTITLERIGHT: "Match-Titel Rechts",
  T_46_META_WS_P_MAXCAPACITY: "Maximale Kapazität",
  T_46_META_WS_P_MAXCOUNT: "Max. Anzahl",
  T_46_META_WS_P_MAXDAMAGE: "Maximale Schäden",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "Maximaler Depressionwinkel",
  T_46_META_WS_P_MAXDISPLACEMENT: "Max. Verschiebung",
  T_46_META_WS_P_MAXDISTANCE: "Maximale Entfernung",
  T_46_META_WS_P_MAXDURABILITY: "Maximale Haltbarkeit",
  T_46_META_WS_P_MAXDURABILITYRATIO: "Maximaler Haltbarkeitsfaktor",
  T_46_META_WS_P_MAXENERGY: "Maximale Energie",
  T_46_META_WS_P_MAXEP: "Max. EP",
  T_46_META_WS_P_MAXHP: "Max. HP",
  T_46_META_WS_P_MAXJUMPCOUNT: "Max. Sprunganzahl",
  T_46_META_WS_P_MAXJUMPHEIGHT: "Maximale Sprunghöhe",
  T_46_META_WS_P_MAXLENGTH: "Maximale Länge",
  T_46_META_WS_P_MAXPROGRESS: "Maximaler Fortschritt",
  T_46_META_WS_P_MAXSCATTERRATIO: "Maximales Streuverhältnis",
  T_46_META_WS_P_MAXSPEED: "Max. Geschwindigkeit",
  T_46_META_WS_P_MAXTURRETCOUNT: "Max. Turret-Anzahl",
  T_46_META_WS_P_MAXVALUE: "Maximalwert",
  T_46_META_WS_P_MAXWIDGETID: "MaxWidgetID",
  T_46_META_WS_P_MINDAMAGE: "Minimaler Schaden",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "Mindestschadenreichweite",
  T_46_META_WS_P_MINDISTANCE: "Minimale Entfernung",
  T_46_META_WS_P_MINELEVATIONANGLE: "Minimaler Elevationswinkel",
  T_46_META_WS_P_MINENDHEIGHT: "Minimale Endhöhe",
  T_46_META_WS_P_MINFLYHEIGHT: "Minimale Flughöhe",
  T_46_META_WS_P_MINMOVEDISTANCE: "Minimale Bewegungsdistanz",
  T_46_META_WS_P_MINVALUE: "Minimalwert",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "Raketen-Maximalschaden",
  T_46_META_WS_P_MISSILEMINDAMAGE: "Raketen-Mindestschaden",
  T_46_META_WS_P_MISSILERANGE: "Raketenreichweite",
  T_46_META_WS_P_MODEL: "Modell",
  T_46_META_WS_P_MODELVISIBILITY: "Modell-Sichtbarkeit",
  T_46_META_WS_P_MODELVISIBLE: "Modell sichtbar",
  T_46_META_WS_P_MONEY: "Geld",
  T_46_META_WS_P_MONEYLIST: "Geldliste",
  T_46_META_WS_P_MONEYS: "Gebundenes Wallet",
  T_46_META_WS_P_MONEYTYPE: "Währungsart",
  T_46_META_WS_P_MONSTERTYPE: "Monstertyp",
  T_46_META_WS_P_MOTIONTYPE: "Bewegungstyp",
  T_46_META_WS_P_MOTIONVALUEX: "Bewegungswert X",
  T_46_META_WS_P_MOTIONVALUEY: "Bewegungswert Y",
  T_46_META_WS_P_MOTIONVALUEZ: "Bewegungswert Z",
  T_46_META_WS_P_MOVEMENTDURATION: "Bewegungsdauer",
  T_46_META_WS_P_MULTIPLIER: "Multiplikator",
  T_46_META_WS_P_MUSICELEMENTTYPE: "Musik-Element-Typ",
  T_46_META_WS_P_MUZZLEVELOCITY: "Mündungsgeschwindigkeit",
  T_46_META_WS_P_MVP: "MVP",
  T_46_META_WS_P_NAME: "Name",
  T_46_META_WS_P_NEXTROUNDINDEX: "Nächste Runde Index",
  T_46_META_WS_P_NICKNAME: "Spitzname",
  T_46_META_WS_P_NORMALCOLOR: "Normale Farbe",
  T_46_META_WS_P_NORMALIZEDPOSITION: "Normalisierte Position",
  T_46_META_WS_P_NUMBERINFACTION: "Nummer in der Fraktion",
  T_46_META_WS_P_OBJECTID: "Objekt-ID",
  T_46_META_WS_P_OFFSET: "Offset",
  T_46_META_WS_P_OPTIONS: "Optionen",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "Sonstiger Schadensfaktor",
  T_46_META_WS_P_OUTFIT: "Outfit",
  T_46_META_WS_P_OVERFLOW: "Überlauf",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "Überhöhe Fallgeschwindigkeit",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "Spieler-Konfigurationspriorität",
  T_46_META_WS_P_OWNER: "Eigentümer",
  T_46_META_WS_P_PARAMS: "Parameter",
  T_46_META_WS_P_PARENT: "Eltern",
  T_46_META_WS_P_PARENTID: "Eltern-ID",
  T_46_META_WS_P_PARENTUI: "Übergeordnete UI",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "Eltern-Widget-Entity-ID",
  T_46_META_WS_P_PARENTWIDGETFILEID: "Eltern-Widget-Datei-ID ",
  T_46_META_WS_P_PARTMASKA: "Teilmaske 1",
  T_46_META_WS_P_PASSENGERS: "Passagiere",
  T_46_META_WS_P_PATHID: "Pfad-ID",
  T_46_META_WS_P_PAUSEEVENT: "Ereignis pausieren",
  T_46_META_WS_P_PERSONAID: "Persona-ID",
  T_46_META_WS_P_PHASEDURATION: "Dauer (ms)",
  T_46_META_WS_P_PHASEENDTIME: "Endzeit (ms)",
  T_46_META_WS_P_PHYSICALLAYER: "Physikalische Schicht",
  T_46_META_WS_P_PINID: "Abzeichen-ID",
  T_46_META_WS_P_PITCH: "Neigungswinkel",
  T_46_META_WS_P_PIVOT: "Pivot",
  T_46_META_WS_P_PLAYER: "Spieler",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "Spielerzielgeschwindigkeitsfaktor",
  T_46_META_WS_P_PLAYERLIST: "Spieler-Liste",
  T_46_META_WS_P_PLAYERNAME: "Spielername",
  T_46_META_WS_P_PLAYERRANK: "Spieler-Rang",
  T_46_META_WS_P_PLAYERRANKS: "Spieler-Ränge",
  T_46_META_WS_P_PLAYERS: "Spieler",
  T_46_META_WS_P_PLAYERSCORETYPES: "Spieler-Punktetypen",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "Spieler Geschwindigkeitsfaktor",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "Spieler-Geschwindigkeitsfaktor beim Schießen",
  T_46_META_WS_P_PLAYERSTATUS: "Spielerstatus",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "Spielertraktionsgeschwindigkeit",
  T_46_META_WS_P_PLAYINGSTATUS: "Wiedergabestatus",
  T_46_META_WS_P_PLAYSPEED: "Wiedergabegeschwindigkeit",
  T_46_META_WS_P_POINTPOSITION: "Punktposition",
  T_46_META_WS_P_POINTS: "Punkte",
  T_46_META_WS_P_POSITION: "Position",
  T_46_META_WS_P_PREFABID: "Prefab-ID",
  T_46_META_WS_P_PRESSEDCOLOR: "Gedrückte Farbe",
  T_46_META_WS_P_PRESSEDSPRITE: "Gedrücktes Sprite",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "Gedrücktes Sprite-Typ",
  T_46_META_WS_P_PRICE: "Preis",
  T_46_META_WS_P_PRIORITY: "Priorität",
  T_46_META_WS_P_PROFILEINFO: "Profilinfo",
  T_46_META_WS_P_PROGRESS: "Fortschritt [0,1]",
  T_46_META_WS_P_PROGRESSICON: "Fortschritt-Symbol",
  T_46_META_WS_P_PROGRESSICONNAME: "Fortschritt-Symbol Name",
  T_46_META_WS_P_PROPID: "Prop-ID",
  T_46_META_WS_P_PURCHASELIMIT: "Kaufgrenze",
  T_46_META_WS_P_RADIUS: "Radius",
  T_46_META_WS_P_RANGE: "Reichweite",
  T_46_META_WS_P_RANK: "Rang",
  T_46_META_WS_P_RATIOSELFFACTOR: "Eigenschadensfaktor",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "Teamkollegen-Schadensfaktor",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "Fahrzeugschadensfaktor",
  T_46_META_WS_P_REFRESHTIME: "Buff-Aktualisierungszeit (s)",
  T_46_META_WS_P_RELOADSPEED: "Nachladegeschwindigkeit",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "Nachladegeschwindigkeitsfaktor",
  T_46_META_WS_P_REMAINJUMPCOUNT: "Verbleibende Sprünge",
  T_46_META_WS_P_REMAINQUANTITY: "Verbleibende Menge",
  T_46_META_WS_P_RENDERTYPE: "Rendertyp",
  T_46_META_WS_P_REPEATTIMES: "Wiederholungszeiten",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "Austauschpriorität",
  T_46_META_WS_P_REQUESTEDITEMLIST: "Auslösende Spieler-ID",
  T_46_META_WS_P_REQUESTTYPE: "Angeforderte Artikel-Liste",
  T_46_META_WS_P_RESETPERROUND: "Rücksetzen pro Runde",
  T_46_META_WS_P_RESETPOSITION: "Rücksetzposition",
  T_46_META_WS_P_RESETTIME: "Rücksetzzeit",
  T_46_META_WS_P_RESOURCE: "Ressource",
  T_46_META_WS_P_RESOURCEID: "Ressourcen-ID",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "Innerhalb des Panels einschränken",
  T_46_META_WS_P_RESULT: "Ergebnis",
  T_46_META_WS_P_RESULTTYPE: "Ergebnis-Typ",
  T_46_META_WS_P_REVIVALPOINT: "Wiederbelebungspunkt",
  T_46_META_WS_P_REVIVECD: "Wiederbelebungs-CD",
  T_46_META_WS_P_RIGHT: "Rechts",
  T_46_META_WS_P_RIGHTARM: "Rechter Arm",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "Hintergrundfarbe rechts",
  T_46_META_WS_P_RIGHTCOLOR: "Rechte Farbe",
  T_46_META_WS_P_RIGHTDESCRIPTION: "Beschreibung rechts",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "Rechter Effekt aktiv",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "Rechter Feuerradiuswinkel",
  T_46_META_WS_P_RIGHTFOOT: "Rechter Fuß",
  T_46_META_WS_P_RIGHTHAND: "Rechte Hand",
  T_46_META_WS_P_RIGHTICON: "Rechtes Symbol",
  T_46_META_WS_P_RIGHTICONNAME: "Name des Symbols rechts",
  T_46_META_WS_P_RIGHTLEG: "Rechtes Bein",
  T_46_META_WS_P_RIGHTPLAYERS: "Rechte Spieler",
  T_46_META_WS_P_RIGHTSCORE: "Rechter Punktestand",
  T_46_META_WS_P_RIGHTSCOREAFTER: "Endpunktestand rechts",
  T_46_META_WS_P_RIGHTSCORETEXT: "Rechter Punktestand",
  T_46_META_WS_P_RIGHTTEAM: "Titel",
  T_46_META_WS_P_RIGHTTEAMINDEX: "Rechter Team-Index",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "Anzahl der lebenden Teamkollegen rechts",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "Anzahl der Flaggen des rechten Teamkollegen",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "Rechte Teamstatus",
  T_46_META_WS_P_RIGHTTEAMNAME: "Teamname rechts",
  T_46_META_WS_P_RIGHTTEAMSCORE: "Punktestand rechts",
  T_46_META_WS_P_RIGHTTEXT: "Rechter Text",
  T_46_META_WS_P_RIMALPHA: "Randalpha",
  T_46_META_WS_P_RIMCOLOR: "Randfarbe",
  T_46_META_WS_P_RIMTEXTURE: "Randtextur",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "Rollreibungskoeffizient",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "Rollreibungskoeffizient bei Eile",
  T_46_META_WS_P_ROTATION: "Rotation",
  T_46_META_WS_P_ROTATIONANGLE: "Rotationswinkel",
  T_46_META_WS_P_ROTATIONQ: "Drehquaternion",
  T_46_META_WS_P_ROUNDINCOME: "Rundeneinkommen",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "Runden Einnahme Detail Zahlen",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "Runden Einnahme Detail Titel",
  T_46_META_WS_P_ROUNDINCOMETITLE: "Rundeneinkommen Titel",
  T_46_META_WS_P_ROUNDNUM: "Rundennummer",
  T_46_META_WS_P_ROUNDNUMKEY: "Runde Nummer Schlüssel",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "Runde Nummer Lokalisierungsschlüssel-Parameter",
  T_46_META_WS_P_RUNSPEED: "Lauftempo",
  T_46_META_WS_P_RUNSPEEDSCALE: "Laufgeschwindigkeitsskala",
  T_46_META_WS_P_RUSHDISTANCE: "Rush Entfernung",
  T_46_META_WS_P_RUSHENERGYCOST: "Rush Energieverbrauch",
  T_46_META_WS_P_RUSHVERTICALSPEED: "Rush Vertikale Geschwindigkeit",
  T_46_META_WS_P_SCALE: "Skalierung",
  T_46_META_WS_P_SCATTERINCREASESPEED: "Streuungs-Erhöhungsgeschwindigkeit",
  T_46_META_WS_P_SCATTERMAX: "Maximale Streuung",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "Streuungs-Multiplikator beim Bewegen",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "Streuungs-Wiederherstellungsgeschwindigkeit",
  T_46_META_WS_P_SCATTERSPEED: "Streuungsgeschwindigkeit",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "Streuungsgeschwindigkeit beim Hocken oder Liegen",
  T_46_META_WS_P_SCATTERTHRESHOLD: "Streuschwelle",
  T_46_META_WS_P_SCOPETYPE: "Visier-Typ",
  T_46_META_WS_P_SCORE: "Punkte",
  T_46_META_WS_P_SCORES1: "Punkteliste 1",
  T_46_META_WS_P_SCORES2: "Punkteliste 2",
  T_46_META_WS_P_SCORES3: "Punkteliste 3",
  T_46_META_WS_P_SCORES4: "Punkteliste 4",
  T_46_META_WS_P_SCORES5: "Punkteliste 5",
  T_46_META_WS_P_SCORETEXTKEY: "Score-Text-Schlüssel",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "Score-Text-Schlüssel-Parameter",
  T_46_META_WS_P_SCROLLCONTINUITY: "Scroll-Kontinuität",
  T_46_META_WS_P_SCROLLDIRECTION: "Scroll-Richtung",
  T_46_META_WS_P_SCROLLEFFECT: "Scroll-Effekt",
  T_46_META_WS_P_SCROLLWHEELSPEED: "Scrollrad-Geschwindigkeit",
  T_46_META_WS_P_SECONDSCORETITLE: "Zweiter Punkt Titel",
  T_46_META_WS_P_SECONDSCOREVALUE: "Zweiter Punkt Wert",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "Zweiter Punkt Parameter",
  T_46_META_WS_P_SELECTEDCOLOR: "Ausgewählte Farbe",
  T_46_META_WS_P_SELECTEDINDEX: "Ausgewählter Index",
  T_46_META_WS_P_SELECTEDSPRITE: "Ausgewähltes Sprite",
  T_46_META_WS_P_SELECTEDTYPE: "Ausgewählter Typ",
  T_46_META_WS_P_SELF: "Selbst",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "Selbstschadenfaktor",
  T_46_META_WS_P_SET: "Anzug",
  T_46_META_WS_P_SHADERNAME: "Shader-Name",
  T_46_META_WS_P_SHADOWCOLOR: "Schattenfarbe",
  T_46_META_WS_P_SHADOWOFFSET: "Schattenoffset",
  T_46_META_WS_P_SHADOWSTRENGTH: "Schattenschwäche",
  T_46_META_WS_P_SHELFS: "Manuelles Schließen deaktivieren",
  T_46_META_WS_P_SHOES: "Schuhe",
  T_46_META_WS_P_SHOOTANGLEMAX: "Maximale Schusswinkel",
  T_46_META_WS_P_SHOOTANGLEMIN: "Minimale Schusswinkel",
  T_46_META_WS_P_SHOP: "Geschäft",
  T_46_META_WS_P_SHOPITEMS: "Regale",
  T_46_META_WS_P_SHOWADDFRIEND: "Freund hinzufügen anzeigen",
  T_46_META_WS_P_SHOWATTACKGRENADE: "Angriff-Granate anzeigen",
  T_46_META_WS_P_SHOWBACKGROUND: "Hintergrund anzeigen",
  T_46_META_WS_P_SHOWCROUCH: "Hocke anzeigen",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "Schadenszahl anzeigen",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "Verteidigung-Granate anzeigen",
  T_46_META_WS_P_SHOWECCONOMY: "Wirtschaft anzeigen",
  T_46_META_WS_P_SHOWECONOMY: "Wirtschaft anzeigen",
  T_46_META_WS_P_SHOWFIRE: "Feuer anzeigen",
  T_46_META_WS_P_SHOWFRAME: "Rahmen anzeigen",
  T_46_META_WS_P_SHOWGIFT: "Geschenke anzeigen",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "Trefferpunkteffekt anzeigen",
  T_46_META_WS_P_SHOWJUMP: "Springen anzeigen",
  T_46_META_WS_P_SHOWLIKE: "Like anzeigen",
  T_46_META_WS_P_SHOWLOBBY: "Lobby anzeigen",
  T_46_META_WS_P_SHOWMAPEVALUATE: "Kartenbewertung anzeigen",
  T_46_META_WS_P_SHOWMATCHDETAIL: "Matchdetails anzeigen",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "Joystick-Bewegung anzeigen",
  T_46_META_WS_P_SHOWNAME: "Spitznamen anzeigen",
  T_46_META_WS_P_SHOWPIN: "Pin anzeigen",
  T_46_META_WS_P_SHOWPRONE: "Kriechen anzeigen",
  T_46_META_WS_P_SHOWRANK: "Rang anzeigen",
  T_46_META_WS_P_SHOWREPLAY: "Wiederholung anzeigen",
  T_46_META_WS_P_SHOWREPORT: "Bericht anzeigen",
  T_46_META_WS_P_SHOWSHARE: "Teilen anzeigen",
  T_46_META_WS_P_SHOWSPRINT: "Sprint anzeigen",
  T_46_META_WS_P_SHOWTAG: "Tag anzeigen",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "Teamkollegen-Info anzeigen",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "Teamstatus anzeigen",
  T_46_META_WS_P_SHOWTEAMSCORE: "Team Punktestand anzeigen",
  T_46_META_WS_P_SHOWTIMETYPE: "Zeit Typ anzeigen",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "Zwei Teams Punktestand anzeigen",
  T_46_META_WS_P_SHRINKDURATION: "Schrumpfungsdauer (ms)",
  T_46_META_WS_P_SHRINKENDTIME: "Schrumpf-Endzeit (ms)",
  T_46_META_WS_P_SHRINKSPEED: "Konvergenzrate",
  T_46_META_WS_P_SHRINKSTARTTIME: "Schrumpf-Startzeit (ms)",
  T_46_META_WS_P_SIGHTAIMASSIST: "ADS-Zielhilfe zulassen",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "Zielhilfe-Distanzdämpfungskoeffizient (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "Zielhilfe-Distanzvorrang Wirkungskoeffizient (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "Zielhilfe-Distanzvorrang maximale Entfernung",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "Zielhilfe-Distanzvorrang minimale Entfernung",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "Zielhilfe-Distanzvorrang zulassen",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "Zielhilfe-Fadenkreuz-Bildschirmbereich-Anziehungsrate (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "Sichtvergrößerungsverhältnis",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "FOV-Vergrößerung",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "ADS-Drehempfindlichkeit",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "ADS-Korrekturfaktor für Mindestentfernungsschaden",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "ADS-Vergrößerungszeit (s)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "ADS-Vergrößerung",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "ADS-Erholungszeit (s)",
  T_46_META_WS_P_SIZE: "Größe",
  T_46_META_WS_P_SIZEDELTA: "Größenänderung",
  T_46_META_WS_P_SKELETON: "Skelett",
  T_46_META_WS_P_SKIN: "Haut",
  T_46_META_WS_P_SKINID: "Skin-ID",
  T_46_META_WS_P_SKINWIDTH: "Hautdicke",
  T_46_META_WS_P_SKYBOXENV: "Himmelbox",
  T_46_META_WS_P_SKYBOXRESOURCE: "Himmelbox-Ressource",
  T_46_META_WS_P_SLOPELIMIT: "Steigungsgrenze",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "Sanfter Scrollbeginn",
  T_46_META_WS_P_SOFTNESS: "Weichheit",
  T_46_META_WS_P_SORTTYPE: "Sortierart",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "Spawn-Anzahl pro Welle",
  T_46_META_WS_P_SPAWNPOINT: "Spawnpunkt",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "Spawnpunktanzahl",
  T_46_META_WS_P_SPAWNPOSITION: "Spawn-Position",
  T_46_META_WS_P_SPEED: "Geschwindigkeit",
  T_46_META_WS_P_SPEEDWHILEAIMING: "ADS-Bewegungsgeschwindigkeitsrate",
  T_46_META_WS_P_SPRAYCOLOR: "Sprühfarbe",
  T_46_META_WS_P_SPRINTENERGYCOST: "Sprint Energieverbrauch",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "Sprint Horizontale Geschwindigkeit",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "Sprintgeschwindigkeit-Skalierung",
  T_46_META_WS_P_SPRITENAME: "Sprite-Form",
  T_46_META_WS_P_SPRITERESOURCE: "Sprite-Ressource",
  T_46_META_WS_P_SRCVAL: "Ausgangswert",
  T_46_META_WS_P_STARTDROPTIME: "Start-Fallzeit (ms)",
  T_46_META_WS_P_STARTEVENT: "Ereignis starten",
  T_46_META_WS_P_STARTPOSITION: "Startposition",
  T_46_META_WS_P_STARTRADIUS: "Start-Radius",
  T_46_META_WS_P_STARTSPAWNTIME: "Start Spawn-Zeit (s)",
  T_46_META_WS_P_STARTTIME: "Startzeit",
  T_46_META_WS_P_STARTVALUE: "Startwert",
  T_46_META_WS_P_STATICICONCOLORS: "Statische Symbolfarben",
  T_46_META_WS_P_STATICICONS: "Statische Symbole",
  T_46_META_WS_P_STATUS: "Mini-Sentry-Status",
  T_46_META_WS_P_STEPOFFSET: "Stufenversatz",
  T_46_META_WS_P_STOPDURATION: "Stopp-Dauer",
  T_46_META_WS_P_STOPEVENT: "Ereignis stoppen",
  T_46_META_WS_P_STORE: "Geschäft",
  T_46_META_WS_P_STROPID: "Strop-ID",
  T_46_META_WS_P_STYLE: "Stil",
  T_46_META_WS_P_SUBTITLE: "Untertitel",
  T_46_META_WS_P_SUMMULTIPLIER: "Summen-Multiplikator",
  T_46_META_WS_P_SWINGEXITACCELERATION: "Schwung-Austrittsbeschleunigung",
  T_46_META_WS_P_SWINGINGSPEED: "Schwunggeschwindigkeit",
  T_46_META_WS_P_TAGS: "Tags",
  T_46_META_WS_P_TARGETCHECKPOINTID: "Ziel-Checkpoint-ID",
  T_46_META_WS_P_TARGETICONCOLORS: "Ziel-Symbolfarben",
  T_46_META_WS_P_TARGETICONS: "Ziel-Symbole",
  T_46_META_WS_P_TARGETID: "Ziel-ID",
  T_46_META_WS_P_TARGETITEMID: "Ziel-Item-ID",
  T_46_META_WS_P_TARGETROTATION: "Ziel-Rotation",
  T_46_META_WS_P_TARGETSCALE: "Ziel-Skalierung",
  T_46_META_WS_P_TEAMCOLOR: "Teamfarbe",
  T_46_META_WS_P_TEAMCOLORS: "Team-Farben",
  T_46_META_WS_P_TEAMINDEXS: "Team-Indices",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "Teamschadenfaktor",
  T_46_META_WS_P_TEAMMEMBERNUM: "Teammitgliedanzahl",
  T_46_META_WS_P_TEAMNUM: "Teamanzahl",
  T_46_META_WS_P_TEAMRANK: "Team-Rang",
  T_46_META_WS_P_TEAMRANKDISPLAY: "Team-Rang-Anzeige",
  T_46_META_WS_P_TEAMRANKS: "Team-Ränge",
  T_46_META_WS_P_TEAMSCORES: "Team-Punkte",
  T_46_META_WS_P_TEAMSEQ: "Teamfolge",
  T_46_META_WS_P_TEMPLATEENTITY: "Vorlagen-Entity",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "Temporäre Schildpunkte",
  T_46_META_WS_P_TERRAINWETNESS: "Gelände-Nässe",
  T_46_META_WS_P_TEXT: "Text",
  T_46_META_WS_P_TEXTCOLOR: "Textfarbe",
  T_46_META_WS_P_TEXTKEY: "Text Schlüssel",
  T_46_META_WS_P_TEXTKEYPARAMS: "Text Schlüssel Parameter",
  T_46_META_WS_P_TEXTURERESOURCE: "Texturressource",
  T_46_META_WS_P_THEMECOLOR: "Thema Farbe",
  T_46_META_WS_P_THROWABLETYPE: "Wurfwaffentyp",
  T_46_META_WS_P_THROWINGSPEED: "Wurfgeschwindigkeit",
  T_46_META_WS_P_THROWSPEED: "Wurfgeschwindigkeit",
  T_46_META_WS_P_TICKINTERVAL: "Tick-Intervall",
  T_46_META_WS_P_TIMEREQUIRED: "Erforderliche Zeit (ms)",
  T_46_META_WS_P_TIPSTYPE: "Tipps-Typ",
  T_46_META_WS_P_TITLE: "Titel",
  T_46_META_WS_P_TITLELIST: "Titel",
  T_46_META_WS_P_TITLES: "Punkte 1",
  T_46_META_WS_P_TOP: "Oberteil",
  T_46_META_WS_P_TOPALPHA: "Oben Alpha",
  T_46_META_WS_P_TOTALHP: "Gesamt-HP",
  T_46_META_WS_P_TOTALLEVEL: "Gesamtstufe",
  T_46_META_WS_P_TOTALROUNDCOUNT: "Gesamte Rundenanzahl",
  T_46_META_WS_P_TOWSPEED: "Zuggeschwindigkeit",
  T_46_META_WS_P_TRANSITIONSTAGE: "Übergangsphase",
  T_46_META_WS_P_TRANSITIONTYPE: "Übergangstyp",
  T_46_META_WS_P_TRIGGERPLAYERID: "Währungen",
  T_46_META_WS_P_TRIGGERRADIUS: "Auslösebereich",
  T_46_META_WS_P_TRIGGERRANGE: "Auslösereichweite",
  T_46_META_WS_P_TRIGGERTIME: "Auslösezeit",
  T_46_META_WS_P_TURNSPEED: "Drehgeschwindigkeit",
  T_46_META_WS_P_TWEENERENABLED: "Linkes Team",
  T_46_META_WS_P_TWEENSTYLE: "Tween-Stil",
  T_46_META_WS_P_TYPE: "Typ",
  T_46_META_WS_P_UNSELECTEDCOLOR: "Nicht ausgewählte Farbe",
  T_46_META_WS_P_UNSELECTEDSPRITE: "Nicht ausgewähltes Sprite",
  T_46_META_WS_P_UNSELECTEDTYPE: "Nicht ausgewählter Typ",
  T_46_META_WS_P_UP: "Oben",
  T_46_META_WS_P_UPDATETYPE: "Aktualisierungstyp",
  T_46_META_WS_P_UPENERGYCOST: "Aufwärts Energieverbrauch",
  T_46_META_WS_P_UPSPEED: "Aufwärtsgeschwindigkeit",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "Benutzerdefinierte Schubkraft verwenden",
  T_46_META_WS_P_USECUSTOMRESOURCE: "Benutzerdefinierte Ressource verwenden",
  T_46_META_WS_P_USEDCAPACITY: "Benutzte Kapazität",
  T_46_META_WS_P_USEGRAVITY: "Schwerkraft verwenden",
  T_46_META_WS_P_USEPHYSICALCCT: "Physikalisches CCT verwenden",
  T_46_META_WS_P_USERUID: "Benutzer-ID",
  T_46_META_WS_P_UVOFFSET: "UV-Offset",
  T_46_META_WS_P_UVSIZE: "UV-Größe",
  T_46_META_WS_P_VALUE: "Wert",
  T_46_META_WS_P_VAULTDISTANCE: "Überwindungsdistanz",
  T_46_META_WS_P_VAULTHEIGHT: "Überwindungshöhe",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "Fahrzeugschadenfaktor",
  T_46_META_WS_P_VEHICLESKINID: "Fahrzeug-Skin-ID",
  T_46_META_WS_P_VEHICLESKINIDS: "Fahrzeug-Skin-ID",
  T_46_META_WS_P_VELOCITY: "Geschwindigkeit (m/s)",
  T_46_META_WS_P_VELOCITYXZ: "Geschwindigkeit XZ",
  T_46_META_WS_P_VELOCITYY: "Geschwindigkeit Y",
  T_46_META_WS_P_VERTICALBAR: "Vertikale Leiste",
  T_46_META_WS_P_VERTICALOFFSET: "Vertikaler Offset",
  T_46_META_WS_P_VEST: "Weste",
  T_46_META_WS_P_VFXTEXTURETYPE: "VFX-Texturtyp",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "Sichtwinkelbeschränkung",
  T_46_META_WS_P_VISIBILITYLAYER: "Sichtbarkeitsschicht",
  T_46_META_WS_P_VISIBLE: "Sichtbar",
  T_46_META_WS_P_VISIBLEONBACK: "Auf dem Rücken sichtbar",
  T_46_META_WS_P_VISIBLEPLAYERS: "Sichtbare Spieler",
  T_46_META_WS_P_VOLUME: "Lautstärke",
  T_46_META_WS_P_WALLETID: "Wallet-ID",
  T_46_META_WS_P_WANDERRANGE: "Wanderreichweite",
  T_46_META_WS_P_WAVECOUNT: "Wellenanzahl",
  T_46_META_WS_P_WAVEINTERVAL: "Wellenintervall",
  T_46_META_WS_P_WEAPONDAMAGERATE: "Waffen-Schadenrate",
  T_46_META_WS_P_WEAPONSKINIDS: "Waffenskin-IDs",
  T_46_META_WS_P_WEAPONSUBTYPE: "Waffensubtyp",
  T_46_META_WS_P_WEAPONTYPE: "Waffentyp",
  T_46_META_WS_P_WIDTH: "Breite",
  T_46_META_WS_P_WINMVPS: "Gewinner MVPs",
  T_46_META_WS_P_WINTEXT: "Gewinn-Text",
  T_46_META_WS_P_WORDWRAP: "Wortumbruch",
  T_46_META_WS_P_WORLDPOSITION: "Weltposition",
  T_46_META_WS_P_YAW: "Gierwinkel",
  T_46_META_WS_PATROLALONG: "Patrouille entlang",
  T_46_META_WS_PATROLTO: "Patrouille zu",
  T_46_META_WS_PAUSE: "Pausieren",
  T_46_META_WS_PAUSEEMOTE: "Emote pausieren",
  T_46_META_WS_PAUSEFIXEDUPDATE: "Fixierte Aktualisierung pausieren",
  T_46_META_WS_PHASE: "Phase",
  T_46_META_WS_PLAY: "Abspielen",
  T_46_META_WS_PLAYANIMATION: "Animation abspielen",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "Charakter-Animationsclip abspielen",
  T_46_META_WS_PLAYEMOTE: "Emote abspielen",
  T_46_META_WS_PLAYER: "Spieler",
  T_46_META_WS_PORTAL: "Portal",
  T_46_META_WS_POSE: "Pose",
  T_46_META_WS_POSITION: "Position",
  T_46_META_WS_PREPOSE: "Vor-Pose ",
  T_46_META_WS_PROFANITYFILTER: "Schimpfwortfilter",
  T_46_META_WS_PURSUITTARGET: "Verfolgungsziel",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "Quaternion in Achswinkel umwandeln",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "Quaternion in Euler-Winkel umwandeln",
  T_46_META_WS_QUITCHATCHANNEL: "Chat-Kanal verlassen",
  T_46_META_WS_QUITFACTION: "Fraktion verlassen",
  T_46_META_WS_QUITGAME: "Spiel beenden",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "Gefängnisausbruch-Mini-Spiel verlassen",
  T_46_META_WS_RANDOMFLOAT: "Zufalls-Fließkommazahl",
  T_46_META_WS_RANDOMINT: "Zufalls-Ganzzahl",
  T_46_META_WS_RANK: "Rang",
  T_46_META_WS_READCSV: "CSV lesen",
  T_46_META_WS_READCSVCELL: "CSV-Zelle lesen",
  T_46_META_WS_READCSVCELLBYNAME: "CSV-Zelle nach Zeile und Spaltenname lesen",
  T_46_META_WS_READCSVCELLFROMSERVER: "CSV-Zelle vom Server lesen",
  T_46_META_WS_READCSVCOLUMN: "CSV-Spalte lesen",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "CSV-Spalte vom Server lesen",
  T_46_META_WS_READCSVFROMSERVER: "CSV vom Server lesen",
  T_46_META_WS_READCSVROW: "CSV-Zeile lesen",
  T_46_META_WS_READCSVROWBYKEY: "CSV-Zeile nach Schlüssel lesen",
  T_46_META_WS_READCSVROWFROMSERVER: "CSV-Zeile vom Server lesen",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "Wert aus der kumulierten Datenbank lesen",
  T_46_META_WS_READFROMDATASTORE: "Wert aus der Datenbank lesen",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "Wert aus der Rangliste-Datenbank lesen",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "Wert aus der Rangliste-Datenbank nach Rang lesen",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "AOI Spezialfolge entfernen",
  T_46_META_WS_REMOVEBACKPACKSKIN: "Rucksack-Skin entfernen",
  T_46_META_WS_REMOVEBUFF: "Buff entfernen",
  T_46_META_WS_REMOVECOMPONENT: "Komponente entfernen",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "Formel-Property-Faktor entfernen",
  T_46_META_WS_REMOVEOUTFIT: "Outfit entfernen",
  T_46_META_WS_REMOVESCRIPT: "Script entfernen",
  T_46_META_WS_REMOVEVEHICLESKIN: "Fahrzeug-Skin entfernen",
  T_46_META_WS_REMOVEWEAPONSKIN: "Waffenskin entfernen",
  T_46_META_WS_REPLACE: "Ersetzen",
  T_46_META_WS_REQUESTMATCHMAKING: "Matchmaking-Anfrage",
  T_46_META_WS_RESET: "Zurücksetzen",
  T_46_META_WS_RESETBACKPACKSKIN: "Rucksack-Skin zurücksetzen",
  T_46_META_WS_RESETDYEING: "Färbung zurücksetzen",
  T_46_META_WS_RESETJERSEY: "Trikot zurücksetzen",
  T_46_META_WS_RESETOUTFIT: "Outfit zurücksetzen",
  T_46_META_WS_RESETVEHICLESKIN: "Fahrzeug-Skin zurücksetzen",
  T_46_META_WS_RESETWEAPONSKIN: "Waffenskin zurücksetzen",
  T_46_META_WS_RESUMEFIXEDUPDATE: "Fixierte Aktualisierung fortsetzen",
  T_46_META_WS_REVERSE: "Umkehren",
  T_46_META_WS_REVIVALSOURCE: "Wiederbelebungsquelle",
  T_46_META_WS_REVIVE: "Wiederbeleben",
  T_46_META_WS_ROUND: "Runden",
  T_46_META_WS_ROUNDINDEX: "Rundenindex",
  T_46_META_WS_SAMPLEONCURVE: "Auf Kurve sampeln",
  T_46_META_WS_SCENENAME: "Szenenname",
  T_46_META_WS_SCORE: "Punkte",
  T_46_META_WS_SCORER: "Torschütze",
  T_46_META_WS_SCORETYPE: "Punktetyp",
  T_46_META_WS_SCREENMULTIRAYCAST: "Bildschirm Mehrstrahl",
  T_46_META_WS_SCREENSINGLERAYCAST: "Bildschirm Einzelsichtstrahl",
  T_46_META_WS_SCREENTOUCHRAY: "Bildschirmberührungstrahl",
  T_46_META_WS_SCREENTOWORLDPOINT: "Bildschirm zu Welt",
  T_46_META_WS_SENDEVENT: "Ereignis senden",
  T_46_META_WS_SETACTIVE: "Aktiv setzen",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "Alle Spielerbewegungsstatus festlegen",
  T_46_META_WS_SETATTACKABLEENTITY: "Angriffbare Entität setzen",
  T_46_META_WS_SETATTACKABLEFACTION: "Angriffbare Fraktion setzen",
  T_46_META_WS_SETATTACKABLETEAM: "Angriffbares Team setzen",
  T_46_META_WS_SETBACKPACKSKIN: "Rucksack-Skin setzen",
  T_46_META_WS_SETBEHAVIORSTATUS: "Verhaltensstatus setzen",
  T_46_META_WS_SETBLACKBOARDVALUE: "Blackboard-Wert setzen",
  T_46_META_WS_SETBUNDLE: "Bundle setzen",
  T_46_META_WS_SETCAMERAFOCUS: "Kamera fokussieren setzen",
  T_46_META_WS_SETCAMERAFOLLOW: "Kamera folgen setzen",
  T_46_META_WS_SETCHARACTER: "Charakter setzen",
  T_46_META_WS_SETCULLINGMASK: "Culling-Maske einstellen",
  T_46_META_WS_SETCULLINGMASKLAYER: "Culling-Maske-Schicht einstellen",
  T_46_META_WS_SETDEFAULTUISTATUS: "Standard-UI-Status einstellen",
  T_46_META_WS_SETDROPSTATUS: "Drop-Status setzen",
  T_46_META_WS_SETFALLINGDAMAGE: "Fallschaden einstellen",
  T_46_META_WS_SETFOOTBALLPOSITION: "Fußballposition setzen",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "Formel-Property absolut setzen",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "Formel-Property relativ setzen",
  T_46_META_WS_SETFORWARD: "Ausrichtung setzen",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "Globale Schlafschwelle setzen",
  T_46_META_WS_SETINVINCIBILITY: "Unverwundbarkeitsstatus festlegen",
  T_46_META_WS_SETJERSEY: "Trikot setzen",
  T_46_META_WS_SETOUTFIT: "Outfit setzen",
  T_46_META_WS_SETPARENT: "Elternteil setzen",
  T_46_META_WS_SETPARENTCLIENT: "Elternteil setzen",
  T_46_META_WS_SETPICKUPSTATUS: "Pickup-Status setzen",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "Spieler-Schnellnachrichtenstatus setzen",
  T_46_META_WS_SETPLAYERVOICESTATUS: "Spieler-Sprachstatus setzen",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "Eigenschaft sanft setzen",
  T_46_META_WS_SETSKILLS: "Fähigkeiten setzen",
  T_46_META_WS_SETSKYBOX: "Skybox festlegen",
  T_46_META_WS_SETSLEEPTHRESHOLD: "Schlafschwelle setzen",
  T_46_META_WS_SETSPECIALITEMSTATUS: "Status des Spezialitems festlegen",
  T_46_META_WS_SETVEHICLESKIN: "Fahrzeug-Skin setzen",
  T_46_META_WS_SETWEAPONSKIN: "Waffenskin setzen",
  T_46_META_WS_SETWIDGETPARENT: "Widget-Elternteil setzen",
  T_46_META_WS_SHOPITEM: "Shop-Artikel",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "Erscheinungsbild-Gruppe anzeigen",
  T_46_META_WS_SHUFFLE: "Mischen",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "Einzelstrahl-Raycast",
  T_46_META_WS_SKILL: "Fähigkeit",
  T_46_META_WS_SLEEP: "Schlafen",
  T_46_META_WS_SLERPQUATERNION: "Quaternion-Slerp",
  T_46_META_WS_SPAWNABLES: "Erzeugbare Gegenstände",
  T_46_META_WS_SPAWNEDITEM: "Erzeugter Gegenstand",
  T_46_META_WS_SPAWNNEXTWAVE: "Nächste Welle spawnen",
  T_46_META_WS_SPHERECAST: "Kugel-Cast",
  T_46_META_WS_SPHEREOVERLAP: "Kugel-Überlappung",
  T_46_META_WS_SPLIT: "Teilen",
  T_46_META_WS_SQRT: "Quadratwurzel",
  T_46_META_WS_STARTPARACHUTE: "Fallschirm starten",
  T_46_META_WS_STARTPOSITION: "Startposition",
  T_46_META_WS_STATENAME: "Status-Name",
  T_46_META_WS_STATUS: "Status",
  T_46_META_WS_STRINGTOFLOAT: "String in Float umwandeln",
  T_46_META_WS_STRINGTOINT: "String in Int umwandeln",
  T_46_META_WS_STRIP: "Leerzeichen entfernen",
  T_46_META_WS_SUB: "Subtrahieren",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "AOI-Proxy-Beobachter wechseln",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "Erscheinungsbild-Gruppe wechseln",
  T_46_META_WS_SWITCHAREA: "Bereich wechseln",
  T_46_META_WS_SWITCHCAMERA: "Kamera wechseln",
  T_46_META_WS_SWITCHPHASE: "Phase wechseln",
  T_46_META_WS_SWITCHSCENE: "Szene wechseln",
  T_46_META_WS_SWITCHWEAPON: "Waffe wechseln",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "Ziel",
  T_46_META_WS_TEAM: "Team",
  T_46_META_WS_TELEPORT: "Teleportieren",
  T_46_META_WS_TELEPORTCCT: "CCT teleportieren",
  T_46_META_WS_TEXT: "Text",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "Zeitstempel in Lokalisierungs-String umwandeln",
  T_46_META_WS_TIRE: "Reifen",
  T_46_META_WS_TOLOWER: "In Kleinbuchstaben umwandeln",
  T_46_META_WS_TOSTRING: "In String umwandeln",
  T_46_META_WS_TOUPPER: "In Großbuchstaben umwandeln",
  T_46_META_WS_TRANSFERMONEY: "Geld überweisen",
  T_46_META_WS_TRIGGER: "Auslöser",
  T_46_META_WS_TYPEIS: "Typ ist",
  T_46_META_WS_UNLOADSCENE: "Szene entladen",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "Gefängnisausbruch-Mission aktualisieren",
  T_46_META_WS_UPLOADGAMERESULT: "Spielergebnis hochladen",
  T_46_META_WS_VALUE: "Schaden",
  T_46_META_WS_VECTOR2ANGLE: "2D-Vektor Winkel",
  T_46_META_WS_VECTOR2DISTANCE: "2D-Vektor Abstand",
  T_46_META_WS_VECTOR2DOT: "2D-Vektor Punkt",
  T_46_META_WS_VECTOR2MAGNITUDE: "2D-Vektor Größe",
  T_46_META_WS_VECTOR2NORMALIZE: "2D-Vektor normalisieren",
  T_46_META_WS_VECTOR2REFLECT: "2D-Vektor Reflexion",
  T_46_META_WS_VECTOR2TOVECTOR3: "2D-Vektor in 3D-Vektor umwandeln",
  T_46_META_WS_VECTOR3REFLECT: "3D-Vektor Reflexion",
  T_46_META_WS_VECTOR3TOVECTOR2: "3D-Vektor in 2D-Vektor umwandeln",
  T_46_META_WS_VEHICLE: "Fahrzeug",
  T_46_META_WS_VELOCITY: "Geschwindigkeit",
  T_46_META_WS_WAITFORMILESECOND: "Millisekunden warten",
  T_46_META_WS_WAITFORNEXTFRAME: "Auf den nächsten Frame warten",
  T_46_META_WS_WAKEUP: "Aufwachen",
  T_46_META_WS_WAVES: "Wellen",
  T_46_META_WS_WEAPON: "Waffe",
  T_46_META_WS_WORLDTOSCREENPOINT: "Welt zu Bildschirm",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "In die kumulierte Datenbank schreiben",
  T_46_META_WS_WRITETODATASTORE: "In die Datenbank schreiben",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "In die Rangliste-Datenbank schreiben",
  T_48_META_API_1_D: "Ermittelt alle Spieler im aktuellen Spiel und gibt eine Liste der Spieler zurück.",
  T_48_META_API_1_R_D: "Spielerliste",
  T_48_META_API_10_D: "Abrufen von Szenenobjekten",
  T_48_META_API_10_P0_D: "Welche Arten von Szenenobjekten gefiltert werden sollen",
  T_48_META_API_10_R_D: "Szene Objektliste",
  T_48_META_API_100_D: "Szenarien laden, ohne bereits geladene Szenarien automatisch zu entladen",
  T_48_META_API_100_P0_D: "Zu ladende Szenen-ID",
  T_48_META_API_10000_D: "Gibt die Entität zurück, an die das aktuelle Skript gebunden ist",
  T_48_META_API_10000_R_D: "Die Entität, an die das aktuelle Skript gebunden ist",
  T_48_META_API_10001_D: "Verwenden Sie die Entitäts-ID, um die entsprechende Entität zu finden. Diese API ist nur für die Verwendung durch den Redakteur gedacht, die Verwendung dieser API durch den Benutzer garantiert nicht ihre Kompatibilität, wie z.B. die Entfernung oder Anpass",
  T_48_META_API_10001_P0_D: "Ziel Entität ID",
  T_48_META_API_10001_R_D: "Ding, das eine materielle Existenz hat (im Gegensatz zu einer konzeptionellen, virtuellen oder Online-Existenz)",
  T_48_META_API_10002_D: "Abrufen der globalen Entität für das Spiel",
  T_48_META_API_10002_R_D: "globale Entität",
  T_48_META_API_10003_D: "Teleportiert Spieler zu bestimmten Koordinaten (veraltet, verwenden Sie Teleport)",
  T_48_META_API_10003_P0_D: "Teleportierte Spieler",
  T_48_META_API_10003_P1_D: "Koordinaten des transportierten Punktes",
  T_48_META_API_10004_D: "Ermittelt die Position in der Nähe von Mitspielern, umgeht die Position von Spielern, die nicht stehen können (veraltet, verwenden Sie GetTeammateNearPosition)",
  T_48_META_API_10004_P0_D: "Zielspieler",
  T_48_META_API_10004_R_D: "Koordinaten in der Nähe von Teamkollegen",
  T_48_META_API_10005_D: "Spieler, die zum übernehmenden Unternehmen gehören",
  T_48_META_API_10005_P0_D: "Ziel-Entität, die Entität wird nur mit dem Player synchronisiert, zu dem sie gehört",
  T_48_META_API_10005_R_D: "Spieler, die zur Zielentität gehören",
  T_48_META_API_10006_D: "Den Spieler unbesiegbar machen",
  T_48_META_API_10006_P0_D: "Zielspieler",
  T_48_META_API_10006_P1_D: "Dauer des Unverwundbarkeitseffekts, in Sekunden",
  T_48_META_API_10007_D: "Klonen des ausgewählten Objekts und aller seiner Eigenschaften an der ursprünglichen Position",
  T_48_META_API_10007_P0_D: "Geschaffene Entitäten",
  T_48_META_API_10007_P1_D: "zu klonende Entität",
  T_48_META_API_10008_D: "Dem Spieler Schaden zufügen, wenn keine Schadensquelle ausgewählt ist, erhält das Ziel Schaden vom System",
  T_48_META_API_10008_P0_D: "Geschädigte Spielanbieter",
  T_48_META_API_10008_P1_D: "Spielfiguren, die Schaden verursachen",
  T_48_META_API_10008_P2_D: "Art des Schadens",
  T_48_META_API_10008_P3_D: "Schadenshöhe",
  T_48_META_API_10009_D: "Wiederbelebung eines designierten Spielers",
  T_48_META_API_10009_P0_D: "Wiederauferstandene Spieler",
  T_48_META_API_1001_D: "Wenn die Bedingung erfüllt ist, wird der Knoten unter IF ausgeführt. Wenn die Bedingung nicht erfüllt ist, wird der Knoten unter ELSE ausgeführt, falls es ein ELSE gibt, andernfalls wird die IF-Anweisung beendet.",
  T_48_META_API_1001_P0_D: "Die Bedingungsliste muss mit der Anzahl der Unterprozedurlisten (logische Verzweigungslisten) übereinstimmen.",
  T_48_META_API_10010_D: "Erzeugt ein Element oder eine Liste von Elementen an einem bestimmten Ort.",
  T_48_META_API_10010_P0_D: "Ort der Artikelerstellung",
  T_48_META_API_10010_P1_D: "Erstellte Artikel oder Artikellisten",
  T_48_META_API_10010_P2_D: "Wenn Sie eine Artikelliste erstellen, müssen Sie eine Liste mit der Anzahl der Artikel ausfüllen, die der Reihenfolge der Artikelliste entspricht.",
  T_48_META_API_10011_D: "AI-Einheiten patrouillieren zu Zielpunkten",
  T_48_META_API_10011_P0_D: "Gezielte AI-Einheiten",
  T_48_META_API_10011_P1_D: "Beweglicher Zielpunkt",
  T_48_META_API_10011_P2_D: "Ob man zum Ausgangspunkt zurückkehrt",
  T_48_META_API_10011_P3_D: "ob feindliche Ziele während einer Patrouille entdeckt und angegriffen werden",
  T_48_META_API_10012_D: "AI-Entitäten patrouillieren in der Reihenfolge der Liste der Koordinaten",
  T_48_META_API_10012_P0_D: "Gezielte AI-Einheiten",
  T_48_META_API_10012_P1_D: "Liste der beweglichen Koordinatenpunkte",
  T_48_META_API_10012_P2_D: "Patrouillentyp, mit der Möglichkeit der Einzelfahrt, Rundfahrt oder Zyklus",
  T_48_META_API_10012_P3_D: "ob feindliche Ziele während einer Patrouille entdeckt und angegriffen werden",
  T_48_META_API_10013_D: "Der Generator frischt sofort die nächste Welle von Einheiten auf",
  T_48_META_API_10013_P0_D: "Generatoreinheit",
  T_48_META_API_10014_D: "Fügen Sie einen Faktor für die Berechnung von berechenbaren Attributen hinzu, die durch eine aus Faktoren zusammengesetzte Formel berechnet werden, um das Endergebnis zu erhalten.",
  T_48_META_API_10014_P0_D: "Ziel Entität",
  T_48_META_API_10014_P1_D: "Berechenbare Attributstypen",
  T_48_META_API_10014_P2_D: "Art des Berechnungsfaktors",
  T_48_META_API_10014_P3_D: "Berechnung von Faktorwerten",
  T_48_META_API_10015_D: "Löschen Sie den Berechnungsfaktor für berechenbare Attribute",
  T_48_META_API_10015_P0_D: "Ziel Entität",
  T_48_META_API_10015_P1_D: "Berechenbare Attributstypen",
  T_48_META_API_10016_D: "Löschen aller Berechnungsfaktoren für alle berechenbaren Attribute der Zielentität",
  T_48_META_API_10016_P0_D: "Ziel Entität",
  T_48_META_API_10017_D: "Attribute ändern",
  T_48_META_API_10017_P0_D: "Ziel Entität",
  T_48_META_API_10017_P1_D: "Attribut Typ",
  T_48_META_API_10017_P2_D: "Methode der Modifizierung",
  T_48_META_API_10017_P3_D: "(wert sein)",
  T_48_META_API_10018_D: "Einstellung des Wertes einer berechenbaren Eigenschaft",
  T_48_META_API_10018_P0_D: "Ziel Entität",
  T_48_META_API_10018_P1_D: "Attribut Typ",
  T_48_META_API_10018_P2_D: "(wert sein)",
  T_48_META_API_10019_D: "Bereinigung einzelner berechenbarer Eigenschaftsänderungen",
  T_48_META_API_10019_P0_D: "Ziel Entität",
  T_48_META_API_10019_P1_D: "Attribut Typ",
  T_48_META_API_1002_D: "Der Parameter i beginnt mit dem Mindestwert, und jedes Mal, wenn der darunter liegende Knoten ausgeführt wird, erhöht sich der Schrittwert von i, bis i größer oder gleich dem Höchstwert ist.",
  T_48_META_API_1002_P0_D: "Der Name des zyklischen Indexes, der verwendet werden kann, um den Wert des zyklischen Indexes auf einer lokalen Variablen zu erhalten.",
  T_48_META_API_1002_P1_D: "Zyklischer Ausgangswert",
  T_48_META_API_1002_P2_D: "Zyklusendwert",
  T_48_META_API_1002_P3_D: "Schrittweite der Schleife, wenn der Startwert kleiner als der Endwert ist, sollte die Schrittweite größer als 0 sein; wenn der Startwert größer als der Endwert ist, sollte die Schrittweite kleiner als 0 sein",
  T_48_META_API_10020_D: "Ermittelt alle Entitäten im Spiel, die den Filterkriterien entsprechen",
  T_48_META_API_10020_P0_D: "Das Filterergebnis muss den in diesem Parameter angegebenen Typ enthalten",
  T_48_META_API_10020_P1_D: "Das Filterergebnis darf den in diesem Parameter angegebenen Typ nicht enthalten",
  T_48_META_API_10020_P2_D: "Die Filterergebnisse enthalten mindestens einen der in diesem Parameter angegebenen Typen",
  T_48_META_API_10020_R_D: "Filtern der Liste der resultierenden Entitäten",
  T_48_META_API_10021_D: "Wenn man dem Fußball eine Geschwindigkeit hinzufügt, ändert sich die Geschwindigkeit um die Beschleunigung in dieselbe Richtung",
  T_48_META_API_10021_P0_D: "Fußballtor",
  T_48_META_API_10021_P1_D: "Geschwindigkeit im 3D-Raum hinzugefügt",
  T_48_META_API_10022_D: "Vernichtung von benannten Einrichtungen",
  T_48_META_API_10022_P0_D: "Zu vernichtende Zielobjekte",
  T_48_META_API_10023_D: "Hinzufügen von Beschriftungen zu Entitäten",
  T_48_META_API_10023_P0_D: "Ziel Entität",
  T_48_META_API_10023_P1_D: "Benutzerdefinierte Etiketten",
  T_48_META_API_10024_D: "Entfernen von Beschriftungen für Entitäten",
  T_48_META_API_10024_P0_D: "Ziel Entität",
  T_48_META_API_10024_P1_D: "Benutzerdefinierte Etiketten",
  T_48_META_API_10025_D: "Ermitteln, ob die Zielentität das angegebene Label enthält",
  T_48_META_API_10025_P0_D: "Ziel Entität",
  T_48_META_API_10025_P1_D: "Benutzerdefinierte Etiketten",
  T_48_META_API_10025_R_D: "ob das angegebene Tag einbezogen werden soll oder nicht",
  T_48_META_API_10026_D: "Einstellung der Fußballposition",
  T_48_META_API_10026_P0_D: "Fußballverband",
  T_48_META_API_10026_P1_D: "Platzierung",
  T_48_META_API_10026_P2_D: "Aufrechterhaltung der Geschwindigkeit",
  T_48_META_API_10027_D: "Ermittelt die Kameraeinheit, die der Zielspieler derzeit verwendet",
  T_48_META_API_10027_P0_D: "Zielspieler",
  T_48_META_API_10027_R_D: "Die aktuell verwendete Kameraeinheit",
  T_48_META_API_10028_D: "Wenn Sie die Kamera des Zielspielers auf die Zielkamera umschalten, wird die",
  T_48_META_API_10028_P0_D: "Zielspieler",
  T_48_META_API_10028_P1_D: "Zielkamera",
  T_48_META_API_10028_P2_D: "Bei der Umschaltmethode können Sie wählen, ob Sie die ursprüngliche Logik beibehalten oder progressiv schalten wollen.",
  T_48_META_API_10028_P3_D: "Die Umschaltzeit ist die Zeit für das Umschalten der Kameras im progressiven Modus.",
  T_48_META_API_10029_D: "Eine Kamera erstellen",
  T_48_META_API_10029_P0_D: "Typ der erstellten Kamera",
  T_48_META_API_10029_P1_D: "Erstellte Kamera-Entität",
  T_48_META_API_1003_D: "Implementierung eines Durchlaufs durch einen Datencontainer, um zu jedem Unterelement zu gelangen, das Unterprozeduren enthält; der Schleifenkörper ist die Unterprozedur",
  T_48_META_API_1003_P0_D: "Iteration über den Namen des untergeordneten Elements, der verwendet werden kann, um den Wert des untergeordneten Elements in der lokalen Variablen zu ermitteln",
  T_48_META_API_1003_P1_D: "Der Name des zyklischen Indexes, der verwendet werden kann, um den Wert des zyklischen Indexes auf einer lokalen Variablen zu erhalten.",
  T_48_META_API_1003_P2_D: "Der Datencontainer, der durchlaufen werden soll. Folgende Typen werden derzeit unterstützt: Array-Typ",
  T_48_META_API_10030_D: "Bekämpfbare Einheiten töten",
  T_48_META_API_10030_P0_D: "Zielobjekt, das kampffähig sein muss",
  T_48_META_API_10031_D: "Setzen des aktiven Zustands des Zielobjekts und seiner Kindknoten; Verfügbarkeit, Sichtbarkeit, Kollisionen usw. werden für inaktive Objekte ausgeschaltet",
  T_48_META_API_10031_P0_D: "Ziel Entität",
  T_48_META_API_10031_P1_D: "Aktiv oder inaktiv",
  T_48_META_API_10032_D: "Setzen Sie die Position des Kameraobjekts so, dass es immer dem Zielobjekt folgt",
  T_48_META_API_10032_P0_D: "Zielkamera-Entität",
  T_48_META_API_10032_P1_D: "Zu verfolgende Zielperson",
  T_48_META_API_10032_P2_D: "Abweichung von den Koordinaten des Zielobjekts",
  T_48_META_API_10032_P3_D: "Koordinatensystem für Offsets",
  T_48_META_API_10033_D: "Einstellen der Kamera-Entität so, dass sie immer auf die Ziel-Entität gerichtet ist",
  T_48_META_API_10033_P0_D: "Zielkamera-Entität",
  T_48_META_API_10033_P1_D: "Ziel Entität",
  T_48_META_API_10033_P2_D: "Abweichung des Blickpunkts von den Zielkoordinaten",
  T_48_META_API_10033_P3_D: "Koordinatensystem für Offsets",
  T_48_META_API_10034_D: "Tween erstellen",
  T_48_META_API_10034_P0_D: "Ziel Entität",
  T_48_META_API_10034_P1_D: "Eigenschaft ID",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "DestVal",
  T_48_META_API_10034_P4_D: "Stil",
  T_48_META_API_10034_P5_D: "Kurve",
  T_48_META_API_10034_P6_D: "Dauer",
  T_48_META_API_10034_P7_D: "zwischen Entitäten",
  T_48_META_API_10035_D: "Das Setzen des übergeordneten Knotens setzt voraus, dass sowohl der übergeordnete als auch der untergeordnete Knoten die Komponente Transform haben",
  T_48_META_API_10035_P0_D: "Vaterknoten",
  T_48_META_API_10035_P1_D: "Kindknoten",
  T_48_META_API_10035_P2_D: "Ob die aktuelle Weltposition, Rotation und Skalierung von Kindknoten beibehalten werden soll. Dieses Element ist bei der Einstellung der Benutzeroberfläche ungültig.",
  T_48_META_API_10036_D: "NewCurve (veraltet, bitte CreateTweenCurve verwenden)",
  T_48_META_API_10036_P0_D: "Kontrollpunkte",
  T_48_META_API_10036_R_D: "TwennCurveEntity",
  T_48_META_API_10037_D: "Versucht, das Zielobjekt zu spielen, das eine spielbare Komponente haben muss.",
  T_48_META_API_10037_P0_D: "Ziel spielbare Entität",
  T_48_META_API_10037_P1_D: `Ob die Wiedergabe wiederholt werden soll 
true: Wiederholung 
false: Fortsetzung der Wiedergabe`,
  T_48_META_API_10038_D: "Spielbare Einheiten anhalten",
  T_48_META_API_10038_P0_D: "Ziel spielbare Entität",
  T_48_META_API_10039_D: "Erzeugt eine ballistische Bewegung, die dem Zielobjekt eine Anfangsgeschwindigkeit und -beschleunigung mit Richtung verleiht",
  T_48_META_API_10039_P0_D: "Ziel Entität",
  T_48_META_API_10039_P1_D: "Anfangsgeschwindigkeit",
  T_48_META_API_10039_P2_D: "Bewegungsbeschleunigung",
  T_48_META_API_10039_P3_D: "Maximaler Verlagerungsabstand",
  T_48_META_API_10039_P4_D: "Erstellte ballistische Bewegungseinheiten",
  T_48_META_API_10039_P5_D: "Ob die Wiedergabe nach der Erstellung automatisch beginnt",
  T_48_META_API_1004_D: "Unterbricht den aktuellen Schleifenprozess und verlässt die Schleife",
  T_48_META_API_10040_D: "Erzeugt eine positionsverfolgende Bewegung, bei der das Zielobjekt dem angegebenen Objekt folgt.",
  T_48_META_API_10040_P0_D: "Ziel Entität",
  T_48_META_API_10040_P1_D: "Objektentitäten, die der Bewegung folgen",
  T_48_META_API_10040_P2_D: "Die Entfernung ergibt sich aus dem Offset der Zielkoordinaten",
  T_48_META_API_10040_P3_D: "Verwendetes Koordinatensystem",
  T_48_META_API_10040_P4_D: "Erstellte Follow-Motion-Entität",
  T_48_META_API_10040_P5_D: "Ob die Wiedergabe nach der Erstellung automatisch beginnt",
  T_48_META_API_10041_D: "Erzeugt eine blickfolgende Bewegung, bei der das Zielobjekt auf das angegebene Objekt ausgerichtet bleibt.",
  T_48_META_API_10041_P0_D: "Ziel Entität",
  T_48_META_API_10041_P1_D: "betrachtete Einheit",
  T_48_META_API_10041_P2_D: "Abweichung des Blickpunkts von der Objekteinheit",
  T_48_META_API_10041_P3_D: "Verwendetes Koordinatensystem",
  T_48_META_API_10041_P4_D: "Erstellte blickfolgende Bewegungseinheiten",
  T_48_META_API_10041_P5_D: "Ob die Wiedergabe nach der Erstellung automatisch beginnt",
  T_48_META_API_10042_D: "Verlassen",
  T_48_META_API_10042_P0_D: "Spielereinheit",
  T_48_META_API_10042_P1_D: "Ergebnisse eines Wettbewerbs",
  T_48_META_API_10042_P2_D: "Verlassen",
  T_48_META_API_10042_P3_D: "Verlassen",
  T_48_META_API_10042_P4_D: "Verlassen",
  T_48_META_API_10043_D: "Glättung setzt die Eigenschaften des Zielobjekts, die Eigenschaften ändern sich sofort, aber der Client spielt einen sanften Übergang Leistung",
  T_48_META_API_10043_P0_D: "Ziel Entität",
  T_48_META_API_10043_P1_D: "Ein Attribut der Zielentität",
  T_48_META_API_10043_P2_D: "Der Zielwert, der dem bei der Definition der Eigenschaft geforderten Typ entsprechen muss",
  T_48_META_API_10044_D: "Führt eine Strahlenerkennung durch und gibt das erste getroffene Objekt in Richtung des Strahls zurück; das getroffene Objekt muss eine Kollisionskomponente haben",
  T_48_META_API_10044_P0_D: "Koordinaten der Startposition",
  T_48_META_API_10044_P1_D: "Richtung der Strahlungserkennung",
  T_48_META_API_10044_P2_D: "Strahlungsdistanz, nur positive Werte werden akzeptiert",
  T_48_META_API_10044_P3_D: "Maske der Strahlenerkennungsebene, nur gefüllte Ebenen nehmen an der Prüfung teil, bleibt sie leer, nehmen alle Ebenen an der Prüfung teil",
  T_48_META_API_10044_P4_D: "Ist es möglich, nach Auslösern zu suchen?",
  T_48_META_API_10044_P5_D: "Trefferobjekt",
  T_48_META_API_10044_P6_D: "Trefferpunktkoordinaten",
  T_48_META_API_10044_P7_D: "Entfernung des Trefferpunkts vom Startpunkt",
  T_48_META_API_10044_P8_D: "die Oberflächennormale treffen",
  T_48_META_API_10045_D: "Führt eine einzelne Strahlerfassung durch, die alle in Richtung des Strahls getroffenen Objekte von nah bis fern zurückgibt",
  T_48_META_API_10045_P0_D: "Koordinaten der Startposition",
  T_48_META_API_10045_P1_D: "Richtung der Strahlungserkennung",
  T_48_META_API_10045_P2_D: "Strahlungsdistanz, nur positive Werte werden akzeptiert",
  T_48_META_API_10045_P3_D: "Ebenenmaske, nur gefüllte Ebenen werden gescannt, bleibt sie leer, werden alle Ebenen gescannt",
  T_48_META_API_10045_P4_D: "Ob der Auslöser erkannt werden kann",
  T_48_META_API_10045_P5_D: "Liste der getroffenen Einrichtungen",
  T_48_META_API_10045_P6_D: "Trefferpunktliste",
  T_48_META_API_10045_P7_D: "Liste der Entfernungen der Trefferpunkte vom Startpunkt",
  T_48_META_API_10045_P8_D: "die Oberflächennormale treffen",
  T_48_META_API_10046_D: "Erstellen von Solids für Vorlagen mit vorgefertigten Körpern",
  T_48_META_API_10046_P0_D: "Geschaffene Entitäten",
  T_48_META_API_10046_P1_D: "Vorgefertigter Körper ID",
  T_48_META_API_10047_D: "verfärben",
  T_48_META_API_10047_P0_D: "Objektnormalen einstellen",
  T_48_META_API_10047_P1_D: "Einstellen des Färbepunkts",
  T_48_META_API_10047_P2_D: "Farbe",
  T_48_META_API_10048_D: "Farbe Zustand",
  T_48_META_API_10048_P0_D: "Einstellen des Färbepunkts",
  T_48_META_API_10048_P1_D: "Richtung vorgeben",
  T_48_META_API_10048_P2_D: "Abstand einstellen",
  T_48_META_API_10048_R_D: "ColorDesc",
  T_48_META_API_10049_D: "Färbende Statistik",
  T_48_META_API_10049_P0_D: "Farbe",
  T_48_META_API_10049_R_D: "Anzahl der Farben",
  T_48_META_API_1005_D: "Überspringen Sie den Rest des Schleifenkörpers und fahren Sie direkt mit der nächsten Schleife fort.",
  T_48_META_API_10050_D: "Flat Range Färbung",
  T_48_META_API_10050_P0_D: "Objektnormalen einstellen",
  T_48_META_API_10050_P1_D: "Einstellen des Färbepunkts",
  T_48_META_API_10050_P2_D: "Einstellung des Färbebereichs",
  T_48_META_API_10050_P3_D: "Farbe",
  T_48_META_API_10050_P4_D: "Anzahl der Farben",
  T_48_META_API_10051_D: "regionaler Fleck",
  T_48_META_API_10051_P0_D: "Objektnormalen einstellen",
  T_48_META_API_10051_P1_D: "Einstellen des Färbepunkts",
  T_48_META_API_10051_P2_D: "Einstellung des Färbebereichs",
  T_48_META_API_10051_P3_D: "Farbe",
  T_48_META_API_10051_P4_D: "Feste Färbefläche",
  T_48_META_API_10051_P5_D: "Zufallskoeffizient (math.)",
  T_48_META_API_10051_P6_D: "Zufallsschwächungskoeffizient",
  T_48_META_API_10051_P7_D: "Anzahl der Farben",
  T_48_META_API_10052_D: "Alle Kinder der Ziel-Entität abrufen",
  T_48_META_API_10052_P0_D: "Muttergesellschaft",
  T_48_META_API_10052_R_D: "Unterknotenliste",
  T_48_META_API_10053_D: "Ermitteln des angegebenen untergeordneten Knotens der übergeordneten Ziel-Entität gemäß dem Index",
  T_48_META_API_10053_P0_D: "Muttergesellschaft",
  T_48_META_API_10053_P1_D: "Unterknoten Index",
  T_48_META_API_10053_R_D: "untergeordnete Einheit",
  T_48_META_API_10054_D: "Ermitteln der übergeordneten Entität des untergeordneten Zielobjekts",
  T_48_META_API_10054_P0_D: "untergeordnete Einheit",
  T_48_META_API_10054_R_D: "Muttergesellschaft",
  T_48_META_API_10055_D: "Löscht alle Kindknoten unter der angegebenen übergeordneten Knotenentität; die Knoten müssen die Komponente Transform haben",
  T_48_META_API_10055_P0_D: "Muttergesellschaft",
  T_48_META_API_10056_D: "Teleportiert das Ziel an den angegebenen Ort",
  T_48_META_API_10056_P0_D: "Transporteinheit (z. B. Militär)",
  T_48_META_API_10056_P1_D: "Koordinaten des Übertragungspunktes",
  T_48_META_API_10056_P2_D: "Post-Transfer-Einheit Orientierung",
  T_48_META_API_10057_D: "Erhalte die Position eines zufälligen Mitspielers in der Nähe und kehre zu deinen eigenen Koordinaten in der Nähe zurück, wenn du keinen Mitspieler hast, wodurch die Position von Spielern, die nicht aufstehen können, vermieden wird.",
  T_48_META_API_10057_P0_D: "Zielspieler",
  T_48_META_API_10057_R_D: "Koordinaten in der Nähe der Mannschaftskameraden des Zielspielers",
  T_48_META_API_10058_D: "Klare Färbung Status",
  T_48_META_API_10059_D: "Den angegebenen Soundeffekt abspielen und, falls noch weitere Attribute zu setzen sind, seine Entitätsattribute weiter über die Entität",
  T_48_META_API_10059_P0_D: "Im Code ist der Name des formalen Parameters, der verwendet wird, um die Entität darzustellen, die den Soundeffekt erzeugt, und der entsprechende Wert der lokalen Variablen ist die Entität, die den Soundeffekt erzeugt",
  T_48_META_API_10059_P1_D: "Die Entität des Spielers, zu der er gehört, nur für diesen Spieler sichtbar",
  T_48_META_API_10059_P2_D: "Soundtypen, die Arten von Soundeffekten, aus denen der Spieler wählen kann",
  T_48_META_API_1006_D: "Beenden Sie den aktuellen Ausführungsprozess, kehren Sie direkt zur Aufrufstelle zurück, Sie können die Daten mit der Rückkehr mitnehmen",
  T_48_META_API_1006_P0_D: "Daten, die Sie zum aufrufenden Ort zurückbringen möchten",
  T_48_META_API_10060_D: "Den Zielspieler aus dem Spiel werfen",
  T_48_META_API_10060_P0_D: "Zielspieler",
  T_48_META_API_10060_P1_D: "ob Abrechnungsinformationen angezeigt werden sollen",
  T_48_META_API_10061_D: "Der Zielspieler möchte einer bestimmten Karte zugeordnet werden",
  T_48_META_API_10061_P0_D: "Zielspieler",
  T_48_META_API_10061_P1_D: "Schlachtfeld-Code",
  T_48_META_API_10061_P2_D: "Ob ein Pop-up-Fenster zum Wiedereinstieg in das ursprüngliche Spiel auffordert, wenn ein Spiel abgebrochen wird.",
  T_48_META_API_10062_D: "Unterbrechung der Toneinheit während der Wiedergabe",
  T_48_META_API_10062_P0_D: "Solide Einheiten, die ausgesetzt werden müssen",
  T_48_META_API_10063_D: "Fortgesetzte Wiedergabe von Soundeffekten, wahlweise von Anfang an",
  T_48_META_API_10063_P0_D: "Klangkörper, die nach einer Pause weiter abgespielt werden müssen",
  T_48_META_API_10063_P1_D: "Ob man bei Null anfangen soll",
  T_48_META_API_10064_D: "Erstellen Sie einen Tropfen, der Tropfen hat drei Phasen: 1. bereit, 2. fallend, 3. gelandet, nur im Zustand 1 können die Eigenschaften des Tropfens geändert werden",
  T_48_META_API_10064_P0_D: "Dropbox-Entitäten erstellt",
  T_48_META_API_1007_D: "Implementieren Sie eine Schleife, die je nachdem, ob die Bedingung wahr ist oder nicht, so lange ausgeführt wird, bis die Bedingung falsch ist und die Schleife endet.",
  T_48_META_API_1007_P0_D: "Wenn die Bedingung wahr ist, wird die Schleife fortgesetzt, und wenn die Bedingung falsch ist, wird die Schleife beendet.",
  T_48_META_API_1008_D: `Warten bis zum Beginn des nächsten logischen Frames
Auf dem Server den Modus für niedrige Framerate einschalten, um länger zu warten
Auf dem Client wird die Wartezeit von der Leistung des Geräts und der Komplexität der Logik des aktuellen Frames beeinfl`,
  T_48_META_API_1009_D: "Warten Sie eine bestimmte Zeit, Funktionen, die diese API verwenden, müssen als asynchron deklariert werden.",
  T_48_META_API_1009_P0_D: "Wartezeit in Millisekunden",
  T_48_META_API_101_D: "Deinstallation einer bestimmten Szene",
  T_48_META_API_101_P0_D: "Zu deinstallierende Szenen-ID",
  T_48_META_API_1010: "Event Callback",
  T_48_META_API_1010_D: "Aktionen, die beim Eintreten eines Ereignisses ausgelöst werden",
  T_48_META_API_1010_P0: "Event Parameter Names",
  T_48_META_API_1010_P0_D: "Der Name des formalen Parameters des Ereignisparameters, über den der Wert des realen Parameters auf der lokalen Variablen erhalten werden kann",
  T_48_META_API_1011: "Code Block",
  T_48_META_API_1011_D: "Ein Codeblock zur Bereitstellung einer Kombination von APIs",
  T_48_META_API_1011_P0: "Parameter Names",
  T_48_META_API_1011_P0_D: "Formale Parameternamen, wenn der Codeblock eine benutzerdefinierte Funktion ist",
  T_48_META_API_1012: "Find and Invoke Custom API with Serial",
  T_48_META_API_1012_D: "Ruft benutzerdefinierte Funktionen seriell auf, und wenn es in der benutzerdefinierten Funktion eine Wartezeit gibt, wartet auch die Aufrufstelle",
  T_48_META_API_1012_P0_D: "Die Entität, in der sich die benutzerdefinierte Funktion befindet",
  T_48_META_API_1012_P1: "Graph ID",
  T_48_META_API_1012_P1_D: "Skript-ID des Skripts, in dem sich die benutzerdefinierte Funktion befindet",
  T_48_META_API_1012_P2: "Function ID",
  T_48_META_API_1012_P2_D: "Funktions-ID des Zielaufrufs",
  T_48_META_API_1012_P3_D: "Liste der echten Parameter, die an die benutzerdefinierte Funktion übergeben werden",
  T_48_META_API_1013: "Find and Invoke Custom API with Parallel",
  T_48_META_API_1013_D: "Ruft benutzerdefinierte Funktionen parallel auf und kehrt sofort an die Aufrufstelle zurück, um die Reihe fortzusetzen, unabhängig davon, ob in der benutzerdefinierten Funktion eine Wartezeit besteht oder nicht",
  T_48_META_API_1013_P0_D: "Die Entität, in der sich die benutzerdefinierte Funktion befindet",
  T_48_META_API_1013_P1: "Graph ID",
  T_48_META_API_1013_P1_D: "Skript-ID des Skripts, in dem sich die benutzerdefinierte Funktion befindet",
  T_48_META_API_1013_P2: "Function ID",
  T_48_META_API_1013_P2_D: "Funktions-ID des Zielaufrufs",
  T_48_META_API_1013_P3_D: "Liste der echten Parameter, die an die benutzerdefinierte Funktion übergeben werden",
  T_48_META_API_1014: "Find and Invoke Self Custom API with Serial",
  T_48_META_API_1014_D: "Ruft eine benutzerdefinierte Funktion im aktuellen Skript seriell auf, und wenn in der benutzerdefinierten Funktion eine Wartezeit besteht, wartet auch die Aufrufstelle",
  T_48_META_API_1014_P0: "Function ID",
  T_48_META_API_1014_P0_D: "Funktions-ID des Zielaufrufs",
  T_48_META_API_1014_P1_D: "Liste der echten Parameter, die an die benutzerdefinierte Funktion übergeben werden",
  T_48_META_API_1015: "Find and Invoke Self Custom API with Parallel",
  T_48_META_API_1015_D: "Ruft benutzerdefinierte Funktionen parallel auf und kehrt sofort an die Aufrufstelle zurück, um die Reihe fortzusetzen, unabhängig davon, ob in der benutzerdefinierten Funktion eine Wartezeit besteht oder nicht",
  T_48_META_API_1015_P0: "Set Local Variable by Index",
  T_48_META_API_1015_P0_D: "Funktions-ID des Zielaufrufs",
  T_48_META_API_1015_P1_D: "Liste der echten Parameter, die an die benutzerdefinierte Funktion übergeben werden",
  T_48_META_API_1016_D: "Abrufen des Typs des Ziels beim Aufruf dieser API",
  T_48_META_API_1016_P0_D: "abgefragtes Ziel",
  T_48_META_API_1016_R_D: "Variable Art",
  T_48_META_API_1017_D: "Ermitteln, ob die Zielvariable vom angegebenen Typ ist",
  T_48_META_API_1017_P0_D: "abgefragtes Ziel",
  T_48_META_API_1017_P1_D: "Art des Vergleichs",
  T_48_META_API_1017_R_D: "Konsistenz",
  T_48_META_API_1018_D: "Ermittelt, ob die Zielvariable eine Unterklasse eines bestimmten Typs ist, der Rückgabewert ist ein boolescher Wert",
  T_48_META_API_1018_P0_D: "abgefragte Zielvariable",
  T_48_META_API_1018_P1_D: "Art des Vergleichs",
  T_48_META_API_1018_R_D: "Ob es eine Unterklasse ist",
  T_48_META_API_1019_D: "Bewirkt, dass die Zielentität das angegebene benutzerdefinierte Ereignis auslöst",
  T_48_META_API_1019_P0_D: "Benutzerdefinierte Ereignis-IDs gesendet",
  T_48_META_API_1019_P1_D: "Ziel Entität",
  T_48_META_API_1019_P2_D: "Parameterliste",
  T_48_META_API_102_D: "Wenn Sie zu einer bestimmten Szene wechseln, werden die anderen geladenen Szenen entladen.",
  T_48_META_API_102_P0_D: "Szenen-ID zum Umschalten auf",
  T_48_META_API_1020_D: "Die Implementierung des Durchlaufens eines Containers, um zu jedem Schlüssel-Wert-Paar zu gelangen, enthält Teilprozeduren, wobei der Schleifenkörper die Teilprozedur ist",
  T_48_META_API_1020_P0_D: "Durch Iteration über den Namen eines Schlüssels können Sie den Wert des Schlüssels in einer lokalen Variablen abrufen",
  T_48_META_API_1020_P1_D: "Iterieren über den Namen des Wertes, der verwendet werden kann, um den Wert der lokalen Variablen zu finden",
  T_48_META_API_1020_P2_D: "Zu durchquerende Container",
  T_48_META_API_1021_D: "Bot löschen",
  T_48_META_API_1021_P0_D: "Bot-Player-Entität löschen",
  T_48_META_API_1022_D: "Den Zielspieler zwingen, den Träger zu verlassen",
  T_48_META_API_1022_P0_D: "Zielspieler",
  T_48_META_API_1023_D: "Verletzungsjumper erstellen",
  T_48_META_API_1023_P0_D: "Skip-Word-Inhalt",
  T_48_META_API_1023_P1_D: "Schriftgröße",
  T_48_META_API_1023_P2_D: "Schriftfarbe",
  T_48_META_API_1023_P3_D: "Verweilzeit in Millisekunden",
  T_48_META_API_1023_P4_D: "geschädigte Person",
  T_48_META_API_1023_P5_D: "Offset des Schadenssprungworts relativ zu den Weltkoordinaten des Zielobjekts",
  T_48_META_API_1023_P6_D: "Bereichsgröße der zufälligen Positionskorrekturen an Schadenssprungstellen wieder",
  T_48_META_API_1023_P7_D: "Ob die Ausfüll-Animation ausgeführt werden soll",
  T_48_META_API_1024_D: "Verlassen",
  T_48_META_API_1024_P0_D: "Verlassen",
  T_48_META_API_1024_P1_D: "Ziel Entität",
  T_48_META_API_1024_P2_D: "Wenn er ausgewählt wird, wird er an den Client gesendet, wenn er vom Server aus aufgerufen wird, und an den Server, wenn er vom Client aus aufgerufen wird.",
  T_48_META_API_1024_P3_D: "Parameterliste",
  T_48_META_API_1025_D: "Abfrage des Fortschritts einer benutzerdefinierten Aufgabe",
  T_48_META_API_1025_P0_D: "Zielspieler",
  T_48_META_API_1025_P1_D: "Benutzerdefinierte Aufgaben-ID",
  T_48_META_API_1025_R_D: "Fortschritte der Mission",
  T_48_META_API_1026_D: "Erhalte den Rucksack-Skin des Zielspielers",
  T_48_META_API_1026_P0_D: "Zielspieler",
  T_48_META_API_1026_R_D: "Rucksack Skin ID",
  T_48_META_API_1027_D: "Einstellen des Rucksack-Skins des Zielspielers",
  T_48_META_API_1027_P0_D: "Zielspieler",
  T_48_META_API_1027_P1_D: "Rucksack Skin ID",
  T_48_META_API_1028_D: "Den Rucksack-Skin des Zielspielers auf die Standardkonfiguration außerhalb des Büros zurücksetzen",
  T_48_META_API_1028_P0_D: "Zielspieler",
  T_48_META_API_1029_D: "Den Rucksack-Skin des Zielspielers leeren",
  T_48_META_API_1029_P0_D: "Zielspieler",
  T_48_META_API_103_D: "Ersetzen Sie den Skybox-Umgebungsstil des Spiels durch eine Auswahl von Tag, Dämmerung, Nacht, etc.",
  T_48_META_API_103_P0_D: "Skybox-Typ",
  T_48_META_API_1030_D: "Abrufen des Skelettteils nach Name",
  T_48_META_API_1030_P0_D: "Ziel Entität",
  T_48_META_API_1030_P1_D: "Skeletthängende Punkte Name",
  T_48_META_API_1030_R_D: "Rig-Hakenpunkt",
  T_48_META_API_1031_D: "Legt den übergeordneten Knoten einer Objektentität fest, die Entitäten unterstützt, die über Transform-, SkeletonPart-, Player- und MountPoint-Komponenten verfügen.",
  T_48_META_API_1031_P0_D: "Vaterknoten",
  T_48_META_API_1031_P1_D: "Kindknoten",
  T_48_META_API_1031_P2_D: "Ob die aktuelle Weltposition, Rotation und Skalierung des untergeordneten Knotens beibehalten werden soll, UI-Einstellung ist nicht wirksam",
  T_48_META_API_1032_D: "Spielt einen animierten Symboleffekt ab, bei dem das Symbol in der Wiedergabegeschwindigkeit von der Startposition zur Endposition schwenkt.",
  T_48_META_API_1032_P0_D: "Symbol Ressourcen-ID",
  T_48_META_API_1032_P1_D: "Farbe",
  T_48_META_API_1032_P2_D: "Symbol Zoom",
  T_48_META_API_1032_P3_D: "Ausgangslage Mitte",
  T_48_META_API_1032_P4_D: "Beginn des regionalen Geltungsbereichs",
  T_48_META_API_1032_P5_D: "Endlage Mitte",
  T_48_META_API_1032_P6_D: "Endlagenbereich",
  T_48_META_API_1032_P7_D: "Die Wiedergabegeschwindigkeit, d. h. die Strecke, die das Symbol pro Sekunde zurücklegt",
  T_48_META_API_1033_D: "Führen Sie eine inverse Tangensoperation durch, um den Winkel zu erhalten",
  T_48_META_API_1033_P0_D: "Koordinaten der Y-Achse",
  T_48_META_API_1033_P1_D: "Koordinaten der X-Achse",
  T_48_META_API_1033_R_D: "Winkel, Bereich (-180, 180)",
  T_48_META_API_1034_D: "Hinzufügen von Komponenten zu Entitäten, nur benutzerdefinierte Komponenten werden unterstützt",
  T_48_META_API_1034_P0_D: "Ziel Entität",
  T_48_META_API_1034_P1_D: "Komponententyp-ID, nur vom Benutzer erstellte benutzerdefinierte Komponenten werden unterstützt",
  T_48_META_API_1034_P2_D: "Unabhängig davon, ob die Hinzufügung erfolgreich ist oder nicht, können bestehende oder nicht benutzerdefinierte Komponenten nicht hinzugefügt werden.",
  T_48_META_API_1035_D: "Entfernen von Komponenten aus Entitäten, nur benutzerdefinierte Komponenten werden unterstützt",
  T_48_META_API_1035_P0_D: "Ziel Entität",
  T_48_META_API_1035_P1_D: "Komponententyp-ID, nur vom Benutzer erstellte benutzerdefinierte Komponenten werden unterstützt",
  T_48_META_API_1035_P2_D: "Unabhängig davon, ob die Entfernung erfolgreich war oder nicht, werden nicht vorhandene Komponenten oder nicht benutzerdefinierte Komponenten nicht entfernt.",
  T_48_META_API_1036_D: "Anpassen des Player-Ausgangsbildschirms",
  T_48_META_API_1036_P0_D: "Bildunterschrift",
  T_48_META_API_1036_P1_D: "Element",
  T_48_META_API_1036_P2_D: "Optionen",
  T_48_META_API_1036_P3_D: "Ob Hintergrund angezeigt werden soll",
  T_48_META_API_1037_D: "Alle aktuell geladenen Szenen abrufen",
  T_48_META_API_1037_R_D: "Liste der Schauplätze",
  T_48_META_API_1038_D: "Ermitteln der lokalen Zielrichtung des Spielers",
  T_48_META_API_1038_R_D: "in die richtige Richtung zielen",
  T_48_META_API_1039_D: "Lokalen Zeitstempel abrufen",
  T_48_META_API_1039_R_D: "Zeitstempel",
  T_48_META_API_104_D: "Schaltet den Spieler an eine bestimmte Stelle in einer bestimmten Szene, ungeladene Szenen werden automatisch geladen und bereits geladene Szenen werden nicht automatisch entladen",
  T_48_META_API_104_P0_D: "Spieler",
  T_48_META_API_104_P1_D: "Zu ladende Szenen-ID",
  T_48_META_API_104_P2_D: "Die Position des Spielers im neuen Szenario",
  T_48_META_API_104_P3_D: "Spielerorientierung im neuen Szenario",
  T_48_META_API_1040_D: "Pausieren Sie die Festbildaktualisierung für die aktuelle Plattform, und das Festbildaktereignis für diese Plattform wird nach der Pause nicht mehr ausgelöst.",
  T_48_META_API_1041_D: "Wiederaufnahme der Aktualisierung des festen Rahmens für die aktuelle Plattform, und das Ereignis zur Aktualisierung des festen Rahmens für diese Plattform wird nach der Wiederaufnahme erneut ausgelöst",
  T_48_META_API_1042_D: "Bestimmen Sie die Buddy-Beziehung des Zielspielers mit dem aktuellen Client-Spieler, der aktuelle Client selbst ist kein Buddy des aktuellen Clients",
  T_48_META_API_1042_P0_D: "Zielspieler",
  T_48_META_API_1042_R_D: "ob Sie mit dem aktuellen Kunden befreundet sind oder nicht",
  T_48_META_API_1043_D: "Auslösen von benutzerdefinierten Ereignissen",
  T_48_META_API_1043_P0_D: "Benutzerdefinierte Ereignis-ID",
  T_48_META_API_1043_P1_D: "Ziel Entität",
  T_48_META_API_1043_P2_D: "Läuft auf serverseitigen oder clientseitigen Plattformen",
  T_48_META_API_1043_P3_D: "Parameterliste",
  T_48_META_API_1044_D: "Fallschirmsprung öffnen",
  T_48_META_API_1044_P0_D: "Zielspieler",
  T_48_META_API_1044_P1_D: "Unterhalb dieser Höhe wird der Fallschirm gezwungen, sich zu öffnen.",
  T_48_META_API_1044_P2_D: "Geschwindigkeit beim Gleiten, X-Komponente steht für die horizontale Geschwindigkeit, Y-Komponente für die vertikale Geschwindigkeit; der Spieler landet nach unten, wenn die Y-Komponente negativ ist",
  T_48_META_API_1044_P3_D: "Geschwindigkeit im Sturzflug, X-Komponente steht für die horizontale Geschwindigkeit, Y-Komponente für die vertikale Geschwindigkeit; der Spieler sinkt nach unten, wenn die Y-Komponente negativ ist",
  T_48_META_API_1044_P4_D: "Geschwindigkeit beim Öffnen des Fallschirms, die X-Komponente steht für die horizontale Geschwindigkeit, die Y-Komponente für die vertikale Geschwindigkeit; wenn die Y-Komponente negativ ist, landet der Spieler nach unten",
  T_48_META_API_1045_D: "Liest den Wert, der dem angegebenen Bezeichner in der Datentabelle entspricht.",
  T_48_META_API_1045_P0_D: "Tabellennamen in der Datenbank",
  T_48_META_API_1045_P1_D: "Eindeutige Spieler-ID",
  T_48_META_API_1045_P2_D: "angegebener Bezeichner",
  T_48_META_API_1045_P3_D: "Die Ergebnisse der Lesungen",
  T_48_META_API_1045_P4_D: "Der der Datenbank entsprechende Schlachtfeldcode, der in Leerzeichen ausgefüllt werden kann, stellt den Schlachtfeldcode der aktuellen Karte dar",
  T_48_META_API_1045_P5_D: "Fehlercode",
  T_48_META_API_1046_D: "Abrufen des Wertes, der dem angegebenen Bezeichner in der Datentabelle des Diagramms entspricht",
  T_48_META_API_1046_P0_D: "Name der Leaderboard-Tabelle in der Datenbank",
  T_48_META_API_1046_P1_D: "angegebener Bezeichner",
  T_48_META_API_1046_P2_D: "Die Ergebnisse der Lesungen",
  T_48_META_API_1046_P3_D: "Der der Datenbank entsprechende Schlachtfeldcode, der in Leerzeichen ausgefüllt werden kann, stellt den Schlachtfeldcode der aktuellen Karte dar",
  T_48_META_API_1046_P4_D: "Fehlercode",
  T_48_META_API_1047_D: 'Abrufen des Wertes des angegebenen Rangintervalls in der Datentabelle "Leaderboards',
  T_48_META_API_1047_P0_D: "Name der Leaderboard-Tabelle in der Datenbank",
  T_48_META_API_1047_P1_D: "Der Startrang muss kleiner oder gleich dem Endrang sein und der Rang beginnt bei 1",
  T_48_META_API_1047_P2_D: "Zielposition",
  T_48_META_API_1047_P3_D: "Die Ergebnisse der Lesungen",
  T_48_META_API_1047_P4_D: "Der der Datenbank entsprechende Schlachtfeldcode, der in Leerzeichen ausgefüllt werden kann, stellt den Schlachtfeldcode der aktuellen Karte dar",
  T_48_META_API_1047_P5_D: "Fehlercode",
  T_48_META_API_1048_D: "Liest den Wert, der dem angegebenen Bezeichner in der Tabelle der kumulierten Daten entspricht.",
  T_48_META_API_1048_P0_D: "Name der kumulativen Datentabelle in der Datenbank",
  T_48_META_API_1048_P1_D: "angegebener Bezeichner",
  T_48_META_API_1048_P2_D: "Die Ergebnisse der Lesungen",
  T_48_META_API_1048_P3_D: "Der der Datenbank entsprechende Schlachtfeldcode, der in Leerzeichen ausgefüllt werden kann, stellt den Schlachtfeldcode der aktuellen Karte dar",
  T_48_META_API_1048_P4_D: "Fehlercode",
  T_48_META_API_1049_D: "Schreibt den Wert, der dem angegebenen Bezeichner entspricht, in die Datentabelle.",
  T_48_META_API_1049_P0_D: "Tabellennamen in der Datenbank",
  T_48_META_API_1049_P1_D: "Eindeutige Spieler-ID",
  T_48_META_API_1049_P2_D: "angegebener Bezeichner",
  T_48_META_API_1049_P3_D: "Geschriebener Wert",
  T_48_META_API_1049_P4_D: "Der der Datenbank entsprechende Schlachtfeldcode, der in Leerzeichen ausgefüllt werden kann, stellt den Schlachtfeldcode der aktuellen Karte dar",
  T_48_META_API_1049_P5_D: "Fehlercode",
  T_48_META_API_105_D: "Holen Sie sich die Skybox der Szene",
  T_48_META_API_105_P0_D: "Szene-ID",
  T_48_META_API_105_R_D: "skybox",
  T_48_META_API_1050_D: "Anzahl der Elemente in der Liste ermitteln",
  T_48_META_API_1050_P0_D: "Zielliste",
  T_48_META_API_1050_R_D: "Anzahl der Elemente",
  T_48_META_API_1051_D: "Ermittelt den Wert des Elements mit dem angegebenen Index in der Liste",
  T_48_META_API_1051_P0_D: "Zielliste",
  T_48_META_API_1051_P1_D: "Indexwerte, beginnend mit 0",
  T_48_META_API_1051_R_D: "elementarer Wert",
  T_48_META_API_1052_D: "Setzt den Wert des Elements, das dem angegebenen Index in der Liste entspricht",
  T_48_META_API_1052_P0_D: "Zielliste",
  T_48_META_API_1052_P1_D: "Indexwerte, beginnend mit 0",
  T_48_META_API_1052_P2_D: "elementarer Wert",
  T_48_META_API_1053_D: "Anhängen von Elementen an das Ende der Liste",
  T_48_META_API_1053_P0_D: "Zielliste",
  T_48_META_API_1053_P1_D: "Hinzufügende Elemente",
  T_48_META_API_1054_D: "Entfernt das Element mit dem angegebenen Index aus der Liste",
  T_48_META_API_1054_P0_D: "Zielliste",
  T_48_META_API_1054_P1_D: "Indexwerte, beginnend mit 0",
  T_48_META_API_1055_D: "Leeren Sie die Liste aller Elemente",
  T_48_META_API_1055_P0_D: "Zielliste",
  T_48_META_API_1056_D: "Kehrt die Reihenfolge der Elemente in der angegebenen Liste um.",
  T_48_META_API_1056_P0_D: "Zielliste",
  T_48_META_API_1057_D: "Kopieren einer Liste",
  T_48_META_API_1057_P0_D: "Zielliste",
  T_48_META_API_1057_R_D: "Neue Liste herauskopiert",
  T_48_META_API_1058_D: "Fügt ein neues Element an der angegebenen Indexposition in die Liste ein, und die Elemente an dieser Indexposition und danach werden der Reihe nach um einen Platz nach hinten verschoben.",
  T_48_META_API_1058_P0_D: "Zielliste",
  T_48_META_API_1058_P1_D: "einzufügende Indexposition, Index zählt ab 0",
  T_48_META_API_1058_P2_D: "Der Wert des neu einzufügenden Elements",
  T_48_META_API_1059_D: "Die Elemente der Liste werden neu randomisiert",
  T_48_META_API_1059_P0_D: "Zielliste",
  T_48_META_API_1060_D: "Vergleicht beide Seiten des Arguments und gibt true oder false zurück.",
  T_48_META_API_1060_P0_D: "Der zum Vergleich herangezogene linke Wert",
  T_48_META_API_1060_P1_D: "Die folgenden Vergleichsmethoden werden unterstützt: >,>=,==,! =,<=,<,And(qualifizierter boolscher Typ),Or(qualifizierter boolscher Typ)",
  T_48_META_API_1060_P2_D: "Der zum Vergleich herangezogene linke Wert",
  T_48_META_API_1060_R_D: "Vergleichende Ergebnisse",
  T_48_META_API_1061_D: "Die vier Grundoperationen, einschließlich Addition, Subtraktion, Multiplikation, Division und Rest. Die Restwertoperation unterstützt nur ganze Zahlen, die übrigen Operationen unterstützen ganze Zahlen oder Dezimalzahlen.",
  T_48_META_API_1061_P0_D: "linker Wert einer Operation",
  T_48_META_API_1061_P1_D: "Arten der vier Operationen, einschließlich Addition, Subtraktion, Multiplikation, Division und Rest, die keine Dezimalzahlen unterstützen",
  T_48_META_API_1061_P2_D: "richtiger Wert einer Operation",
  T_48_META_API_1061_R_D: "Berechnungsergebnis",
  T_48_META_API_1062_D: "Erzeugen einer zufälligen Ganzzahl zwischen dem Mindestwert Ganzzahl (enthalten) und dem Höchstwert Ganzzahl (nicht enthalten)",
  T_48_META_API_1062_P0_D: "Zufallsbereich linkes Intervall mit der Möglichkeit, auf den gefüllten Wert zu randomisieren",
  T_48_META_API_1062_P1_D: "Zufallsbereich rechtes Intervall, wird nicht auf den gefüllten Wert randomisiert",
  T_48_META_API_1062_R_D: "Zufälliges Ergebnis, Ganzzahl",
  T_48_META_API_1063_D: "Erzeugen einer zufälligen Dezimalzahl zwischen dem Mindestwert Dezimalzahl (enthalten) und dem Höchstwert Dezimalzahl (nicht enthalten)",
  T_48_META_API_1063_P0_D: "Zufallsbereich linkes Intervall, mit einer kleinen Chance, dass der Zufallswert den eingegebenen Wert erreicht",
  T_48_META_API_1063_P1_D: "Zufallsbereich rechtes Intervall, wird nicht auf den gefüllten Wert randomisiert",
  T_48_META_API_1063_R_D: "Randomisierte Ergebnisse, Dezimalzahlen, bis zu 7 Dezimalstellen",
  T_48_META_API_1064_D: "Feststellen, ob ein Objekt leer ist",
  T_48_META_API_1064_P0_D: "leeres zu beurteilendes Objekt",
  T_48_META_API_1064_R_D: "Ist leer",
  T_48_META_API_1065_D: "Logische Umkehrung, Eingabewert: wahr oder falsch, Rückgabewert: falsch oder wahr",
  T_48_META_API_1065_P0_D: "Werte, die für nicht",
  T_48_META_API_1065_R_D: "Das Ergebnis der Nonce",
  T_48_META_API_1066_D: "Erfasst absolute Werte, unterstützt ganze Zahlen und Dezimalzahlen",
  T_48_META_API_1066_P0_D: "Werte, für die absolute Werte erforderlich sind",
  T_48_META_API_1066_R_D: "Das Ergebnis der Ermittlung der absoluten Werte",
  T_48_META_API_1067_D: "Quadratwurzelberechnung",
  T_48_META_API_1067_P0_D: "Sie müssen nach dem Wert der Quadratwurzel fragen",
  T_48_META_API_1067_R_D: "Das Ergebnis der Suche nach der Quadratwurzel",
  T_48_META_API_1068_D: "Berechnung von negativen Werten",
  T_48_META_API_1068_P0_D: "Negative Werte, die angefordert werden müssen",
  T_48_META_API_1068_R_D: "Negative Ergebnisse",
  T_48_META_API_1069_D: "Verbinden zweier Strings miteinander",
  T_48_META_API_1069_P0_D: "linker Wert einer Zeichenkette",
  T_48_META_API_1069_P1_D: "rechter Wert einer Zeichenkette",
  T_48_META_API_1069_R_D: "Ergebnis der String-Verkettung",
  T_48_META_API_1070_D: "Länge der Zeichenkette ermitteln",
  T_48_META_API_1070_P0_D: "string",
  T_48_META_API_1070_R_D: "Stringlänge",
  T_48_META_API_1071_D: "Rundet den angegebenen Wert auf die nächstliegende ganze Zahl ab.",
  T_48_META_API_1071_P0_D: "Abzurundender Wert",
  T_48_META_API_1071_R_D: "abrundend",
  T_48_META_API_1072_D: "Rundet den angegebenen Wert auf die nächste ganze Zahl auf.",
  T_48_META_API_1072_P0_D: "Aufzurundende Werte",
  T_48_META_API_1072_R_D: "Ergebnisse der Aufrundung",
  T_48_META_API_1073_D: "Rundet den angegebenen Wert auf die nächstliegende ganze Zahl.",
  T_48_META_API_1073_P0_D: "Anzahl der zu rundenden Werte",
  T_48_META_API_1073_R_D: "gerundetes Ergebnis",
  T_48_META_API_1074_D: "Gibt eine neue Zeichenkette aus, nachdem alle angegebenen Zeichenketten in der Zielzeichenkette ersetzt wurden",
  T_48_META_API_1074_P0_D: "Zielzeichenfolge",
  T_48_META_API_1074_P1_D: "Die zu ersetzende alte Zeichenfolge",
  T_48_META_API_1074_P2_D: "Neue Zeichenfolge zum Ersetzen durch",
  T_48_META_API_1074_R_D: "Ersetzung der ausgefüllten Zeichenfolge",
  T_48_META_API_1075_D: "Findet das erste Vorkommen einer angegebenen Zeichenkette in der Zielzeichenkette.",
  T_48_META_API_1075_P0_D: "Zielzeichenfolge",
  T_48_META_API_1075_P1_D: "Die angegebene Zeichenfolge zum Nachschlagen",
  T_48_META_API_1075_P2_D: "Findet die Zeichenkette ab der Startposition, die Position der Zeichenkette wird von 0 an gezählt",
  T_48_META_API_1075_R_D: "Gibt die Position des ersten Vorkommens der Zeichenkette in der Zielzeichenkette an, wobei die Position der Zeichenkette ab 0 gezählt wird.",
  T_48_META_API_1076_D: "Gibt eine neue Zeichenkette aus, nachdem sie eine Zeichenkette einer bestimmten Länge an einer bestimmten Position abgefangen hat.",
  T_48_META_API_1076_P0_D: "Zielzeichenfolge",
  T_48_META_API_1076_P1_D: "Position, an der mit dem Abfangen begonnen werden soll; die Position des Strings wird von 0 an gezählt",
  T_48_META_API_1076_P2_D: "Länge des Abschnitts, standardmäßig bis zum Ende der Zeichenkette.",
  T_48_META_API_1076_R_D: "Abgefangener String",
  T_48_META_API_1077_D: "Vergleichen Sie zwei Listen mit identischen Elementen, die Listengröße hat keinen Einfluss auf das Ergebnis.",
  T_48_META_API_1077_P0_D: "Der linke Wert der zum Vergleich herangezogenen Liste",
  T_48_META_API_1077_P1_D: "Der rechte Wert der zum Vergleich verwendeten Liste",
  T_48_META_API_1077_R_D: "Vergleichen Sie die Ergebnisse: Inhaltskonsistenz ergibt True, Inhaltsinkonsistenz ergibt False.",
  T_48_META_API_1078_D: "Nimmt die angegebene Zeichenkette als Trennzeichen, zerschneidet die Zielzeichenkette in eine Anzahl von Scheiben und gibt die neue Zeichenkette aus. Die N aufeinanderfolgenden Trennzeichen werden in N-1 Leerzeichen halber Breite zerschnitten und die Elem",
  T_48_META_API_1078_P0_D: "Zielzeichenfolge",
  T_48_META_API_1078_P1_D: "Begrenzungszeichenfolge",
  T_48_META_API_1078_R_D: "Gibt eine Liste von Zeichenketten aus, die immer mit einem Leerelement halber Breite endet",
  T_48_META_API_1079_D: "Zeichen aus der Liste der Zeichenkettenpositionen extrahieren und zu einer neuen Zeichenkettenausgabe kombinieren",
  T_48_META_API_1079_P0_D: "Zielzeichenfolge",
  T_48_META_API_1079_P1_D: "Liste von Zeichenkettenpositionen, Zeichenkettenpositionen gezählt ab 0",
  T_48_META_API_1079_R_D: "Ausgabe-String",
  T_48_META_API_1080_D: "Konvertiert alle Zeichen der Zielzeichenkette in Großbuchstaben",
  T_48_META_API_1080_P0_D: "Zielzeichenfolge",
  T_48_META_API_1080_R_D: "Ausgabe-String",
  T_48_META_API_1081_D: "Konvertiert alle Zeichen der Zielzeichenkette in Kleinbuchstaben",
  T_48_META_API_1081_P0_D: "Zielzeichenfolge",
  T_48_META_API_1081_R_D: "Ausgabe-String",
  T_48_META_API_1082_D: "Entfernt alle Leerzeichen vor dem ersten Nicht-Leerzeichen und nach dem letzten Nicht-Leerzeichen der Zielzeichenkette.",
  T_48_META_API_1082_P0_D: "Zielzeichenfolge",
  T_48_META_API_1082_R_D: "Ausgabe-String",
  T_48_META_API_1083_D: "Gibt eine neue Zeichenkette nach der Verknüpfung mit dem angegebenen Bezeichner aus.",
  T_48_META_API_1083_P0_D: "Liste der Zielzeichenfolgen",
  T_48_META_API_1083_P1_D: "Angegebener Bezeichner, der zur Verkettung von Zeichenfolgen verwendet wird",
  T_48_META_API_1083_R_D: "Ausgabe-String",
  T_48_META_API_1084_D: "Schreibt den Wert, der dem angegebenen Bezeichner entspricht, in die Tabelle der Leaderboard-Daten",
  T_48_META_API_1084_P0_D: "Name der Leaderboard-Tabelle in der Datenbank",
  T_48_META_API_1084_P1_D: "angegebener Bezeichner",
  T_48_META_API_1084_P2_D: "Geschriebener Wert",
  T_48_META_API_1084_P3_D: "Der der Datenbank entsprechende Schlachtfeldcode, der in Leerzeichen ausgefüllt werden kann, stellt den Schlachtfeldcode der aktuellen Karte dar",
  T_48_META_API_1084_P4_D: "Fehlercode",
  T_48_META_API_1085_D: "Schreiben des Offset-Wertes, der dem angegebenen Bezeichner entspricht, in die Tabelle der kumulierten Daten",
  T_48_META_API_1085_P0_D: "Name der kumulativen Datentabelle in der Datenbank",
  T_48_META_API_1085_P1_D: "angegebener Bezeichner",
  T_48_META_API_1085_P2_D: "Arten von quadratischen Operationen",
  T_48_META_API_1085_P3_D: "Offsetwert geschrieben",
  T_48_META_API_1085_P4_D: "Der der Datenbank entsprechende Schlachtfeldcode, der in Leerzeichen ausgefüllt werden kann, stellt den Schlachtfeldcode der aktuellen Karte dar",
  T_48_META_API_1085_P5_D: "Fehlercode",
  T_48_META_API_1086_D: "Löscht den Wert, der dem angegebenen Bezeichner in der Datentabelle entspricht.",
  T_48_META_API_1086_P0_D: "Tabellennamen in der Datenbank",
  T_48_META_API_1086_P1_D: "Eindeutige Spieler-ID",
  T_48_META_API_1086_P2_D: "angegebener Bezeichner",
  T_48_META_API_1086_P3_D: "Der der Datenbank entsprechende Schlachtfeldcode, der in Leerzeichen ausgefüllt werden kann, stellt den Schlachtfeldcode der aktuellen Karte dar",
  T_48_META_API_1086_P4_D: "Fehlercode",
  T_48_META_API_1087_D: "Löscht den Wert, der dem angegebenen Bezeichner in der Datentabelle des Diagramms entspricht.",
  T_48_META_API_1087_P0_D: "Name der Leaderboard-Tabelle in der Datenbank",
  T_48_META_API_1087_P1_D: "angegebener Bezeichner",
  T_48_META_API_1087_P2_D: "Der der Datenbank entsprechende Schlachtfeldcode, der in Leerzeichen ausgefüllt werden kann, stellt den Schlachtfeldcode der aktuellen Karte dar",
  T_48_META_API_1087_P3_D: "Fehlercode",
  T_48_META_API_1088_D: "Löscht den Wert, der dem angegebenen Rang in der Leaderboard-Tabelle entspricht.",
  T_48_META_API_1088_P0_D: "Name der Leaderboard-Tabelle in der Datenbank",
  T_48_META_API_1088_P1_D: "einen angesehenen Posten erhalten",
  T_48_META_API_1088_P2_D: "Der der Datenbank entsprechende Schlachtfeldcode, der in Leerzeichen ausgefüllt werden kann, stellt den Schlachtfeldcode der aktuellen Karte dar",
  T_48_META_API_1088_P3_D: "Fehlercode",
  T_48_META_API_1089_D: "Senden Sie eine Benutzernachricht an Persona",
  T_48_META_API_1089_P0_D: "Ziel-PersonaID",
  T_48_META_API_1089_P1_D: "Nachricht",
  T_48_META_API_1090_D: "Senden Sie eine Systemnachricht an Persona",
  T_48_META_API_1090_P0_D: "Ziel-PersonaID",
  T_48_META_API_1090_P1_D: "Nachricht",
  T_48_META_API_1091_D: "Persona's Speicher löschen",
  T_48_META_API_1091_P0_D: "Fehlercode",
  T_48_META_API_1092_D: "Evoke Mitgliederzentrum",
  T_48_META_API_1092_P0_D: "Fehlercode",
  T_48_META_API_1093_D: "Zeitstempel für das Auslaufen eines Mitglieds abrufen",
  T_48_META_API_1093_P0_D: "Zielspieler",
  T_48_META_API_1093_P1_D: "Zeitstempel",
  T_48_META_API_1093_P2_D: "Fehlercode",
  T_48_META_API_1094_D: "Feststellen, ob ein Spieler ein Mitglied ist",
  T_48_META_API_1094_P0_D: "Fehlercode",
  T_48_META_API_1094_P1_D: "Ob Sie ein Mitglied sind",
  T_48_META_API_1095_D: "Zeitstempel für das Auslaufen eines Mitglieds abrufen",
  T_48_META_API_1095_P0_D: "Zeitstempel",
  T_48_META_API_1095_P1_D: "Fehlercode",
  T_48_META_API_1096_D: "Feststellen, ob ein Spieler ein Mitglied ist",
  T_48_META_API_1096_P0_D: "Zielspieler",
  T_48_META_API_1096_P1_D: "Fehlercode",
  T_48_META_API_1096_P2_D: "Ob Sie ein Mitglied sind",
  T_48_META_API_1097_D: "Evoke Mitgliederzentrum",
  T_48_META_API_1097_P0_D: "Zielspieler",
  T_48_META_API_1097_P1_D: "Fehlercode",
  T_48_META_API_1099_D: "Einrichten von Persona-Beobachtern, woraufhin Konversationen mit Persona auch an den Beobachter gesendet werden",
  T_48_META_API_1099_P0_D: "Ziel-PersonaID",
  T_48_META_API_1099_P1_D: "Beobachtungsliste",
  T_48_META_API_11_D: "Beenden Sie die aktuelle Phase und gehen Sie zur nächsten über",
  T_48_META_API_1100_D: "Senden von Benutzernachrichten an Persona mit Streaming",
  T_48_META_API_1100_P0_D: "Ziel-PersonaID",
  T_48_META_API_1100_P1_D: "Nachricht",
  T_48_META_API_1101_D: "Senden von Systemnachrichten an Persona mit Streaming",
  T_48_META_API_1101_P0_D: "Ziel-PersonaID",
  T_48_META_API_1101_P1_D: "Nachricht",
  T_48_META_API_1101_P2_D: "Ob Sie antworten oder nicht",
  T_48_META_API_1103_D: "Erstellen von Zufallsseeds",
  T_48_META_API_1103_P0_D: "torrent",
  T_48_META_API_1103_R_D: "Zufallszahlengenerator",
  T_48_META_API_1104_D: "Ermittelt die nächste Zufallszahl des angegebenen Zufallszahlengenerators, Höchstwert 32767",
  T_48_META_API_1104_P0_D: "Zufallszahlengenerator",
  T_48_META_API_1104_P1_D: "Bereich Minimum",
  T_48_META_API_1104_P2_D: "Reichweite Maximum",
  T_48_META_API_1104_R_D: "Zufallszahl",
  T_48_META_API_1108_D: "Get the client language used by the player ",
  T_48_META_API_12_D: "Drucken von Protokollen auf der Konsole",
  T_48_META_API_12_P0_D: "Was zu drucken ist",
  T_48_META_API_13_D: "Gibt eine Zeichenkette mit Parametern aus",
  T_48_META_API_13_P0_D: "Verwenden Sie den Platzhalter %v für einen Parameter, die Anzahl der %v's und die Anzahl der Parameter müssen übereinstimmen.",
  T_48_META_API_13_P1_D: "Die Liste der an der Ausgabe beteiligten Parameter muss mit der Anzahl der %v in der Formatbeschreibung übereinstimmen",
  T_48_META_API_13_R_D: "Ausgabe-String",
  T_48_META_API_14_D: "Bereinigung der Rückstände von Kartenobjekten, einschließlich Todeskästchen, erstellter Objekte, platzierter Objekte, Projektilrückstände usw.",
  T_48_META_API_15_D: "Benutzerdefinierte Bestattungsprotokolle für die Analyse von Nutzererfahrungsdaten",
  T_48_META_API_15_P0_D: "Liste der zu meldenden Feldnamen",
  T_48_META_API_15_P1_D: "Liste der zu meldenden Feldwerte",
  T_48_META_API_1500_D: "Ermittelt die X-Komponente des 3D-Vektors",
  T_48_META_API_1500_P0_D: "3D-Vektor",
  T_48_META_API_1500_R_D: "3D-Vektor x-Komponente",
  T_48_META_API_1501_D: "Ermittelt die y-Komponente des 3D-Vektors",
  T_48_META_API_1501_P0_D: "3D-Vektor",
  T_48_META_API_1501_R_D: "Y-Komponente des 3D-Vektors",
  T_48_META_API_1502_D: "Ermittelt die Z-Komponente des 3D-Vektors",
  T_48_META_API_1502_P0_D: "3D-Vektor",
  T_48_META_API_1502_R_D: "Dreidimensionaler Vektor z-Komponente",
  T_48_META_API_1503_D: "Einstellen der x-Komponente des 3D-Vektors",
  T_48_META_API_1503_P0_D: "3D-Vektor",
  T_48_META_API_1503_P1_D: "X-Komponente",
  T_48_META_API_1504_D: "Einstellen der Y-Komponente des 3D-Vektors",
  T_48_META_API_1504_P0_D: "3D-Vektor",
  T_48_META_API_1504_P1_D: "Y-Komponente",
  T_48_META_API_1505_D: "Einstellen der Z-Komponente des 3D-Vektors",
  T_48_META_API_1505_P0_D: "3D-Vektor",
  T_48_META_API_1505_P1_D: "Z-Komponente",
  T_48_META_API_1506_D: "Zwei 3D-Vektoren zusammenfügen",
  T_48_META_API_1506_P0_D: "linke Operand",
  T_48_META_API_1506_P1_D: "rechte Operand",
  T_48_META_API_1506_R_D: "Ergebnis der 3D-Vektorsumme",
  T_48_META_API_1507_D: "Subtrahieren zweier 3D-Vektoren",
  T_48_META_API_1507_P0_D: "linke Operand",
  T_48_META_API_1507_P1_D: "rechte Operand",
  T_48_META_API_1507_R_D: "Das Ergebnis der Subtraktion des rechten Wertes vom linken Wert des 3D-Vektors",
  T_48_META_API_1508_D: "Skalierung von 3D-Vektoren",
  T_48_META_API_1508_P0_D: "Zu skalierende 3D-Vektoren",
  T_48_META_API_1508_P1_D: "3D-Vektor-Deflation",
  T_48_META_API_1508_R_D: "Ergebnisse der 3D-Vektorskalierung",
  T_48_META_API_1509_D: "Punktweise Multiplikation zweier 3D-Vektoren; das Ergebnis der punktweisen Multiplikation ist ein Skalar",
  T_48_META_API_1509_P0_D: "linke Operand",
  T_48_META_API_1509_P1_D: "rechte Operand",
  T_48_META_API_1509_R_D: "Ergebnis des Punktprodukts",
  T_48_META_API_1510_D: "Kreuzmultiplikation zweier 3D-Vektoren; das Ergebnis der Kreuzmultiplikation ist ein Vektor, der senkrecht auf der Ebene steht, in der die beiden Vektoren liegen",
  T_48_META_API_1510_P0_D: "linke Operand",
  T_48_META_API_1510_P1_D: "rechte Operand",
  T_48_META_API_1510_R_D: "Das Ergebnis des Kreuzprodukts, das senkrecht zu der Ebene ausgerichtet ist, in der sich die beiden an der Operation beteiligten Vektoren befinden",
  T_48_META_API_1511_D: "Normalisierung von 3D-Vektoren",
  T_48_META_API_1511_P0_D: "3D-Vektor",
  T_48_META_API_1511_R_D: "Gibt einen neuen normalisierten Vektor zurück. Die Modullänge ist 1",
  T_48_META_API_1512_D: "Modellierung von 3D-Vektoren",
  T_48_META_API_1512_P0_D: "3D-Vektor",
  T_48_META_API_1512_R_D: "Das Ergebnis der Modellierung, die Länge des Vektormoduls",
  T_48_META_API_1513_D: "Berechnen des euklidischen Abstands zwischen zwei 3D-Vektoren",
  T_48_META_API_1513_P0_D: "linke Operand",
  T_48_META_API_1513_P1_D: "rechte Operand",
  T_48_META_API_1513_R_D: "Nach der Subtraktion zweier Vektoren ist der Modulus des resultierenden Vektors",
  T_48_META_API_1514_D: "Berechnen des Winkels zwischen zwei 3D-Vektoren",
  T_48_META_API_1514_P0_D: "linke Operand",
  T_48_META_API_1514_P1_D: "rechte Operand",
  T_48_META_API_1514_R_D: "Vektorwinkel, Winkelbereich 0-180",
  T_48_META_API_1515_D: "Einen 3D-Vektor erstellen",
  T_48_META_API_1515_P0_D: "X-Komponente eines 3D-Vektors",
  T_48_META_API_1515_P1_D: "Y-Komponente eines 3D-Vektors",
  T_48_META_API_1515_P2_D: "Z-Komponente eines 3D-Vektors",
  T_48_META_API_1515_R_D: "Erstellte 3D-Vektoren",
  T_48_META_API_1516_D: "Ermittelt den Orientierungspunkt eines neuen Konstrukts (veraltet, bitte nicht mehr verwenden)",
  T_48_META_API_1516_P0_D: "Platzierung",
  T_48_META_API_1516_P1_D: "sich zuwenden",
  T_48_META_API_1516_R_D: "DirectPoint",
  T_48_META_API_1517_D: "Position des Richtungspunkts übernehmen (veraltet, bitte nicht verwenden)",
  T_48_META_API_1517_P0_D: "Orientierungspunkt",
  T_48_META_API_1517_R_D: "Position",
  T_48_META_API_1518_D: "Aufnahme von Richtungspunkten (veraltet, bitte nicht verwenden)",
  T_48_META_API_1518_P0_D: "Orientierungspunkt",
  T_48_META_API_1518_R_D: "Weiterleiten",
  T_48_META_API_1519_D: "Eine Liste erstellen",
  T_48_META_API_1519_P0_D: "Die Anfangslänge der Liste, die kleiner oder gleich der Anfangskapazität sein muss",
  T_48_META_API_1519_P1_D: "Die Anfangskapazität der Liste muss größer oder gleich der Anfangslänge sein. Die Kapazität kann dynamisch erweitert werden, was jedoch zu Leistungseinbußen führt, weshalb empfohlen wird, bei der Erstellung einen geeigneten Wert festzulegen.",
  T_48_META_API_1519_R_D: "Erstellen einer Liste",
  T_48_META_API_1520_D: "Prüft, ob die Liste das angegebene Element enthält",
  T_48_META_API_1520_P0_D: "Zielliste",
  T_48_META_API_1520_P1_D: "Das angegebene zu prüfende Element",
  T_48_META_API_1520_R_D: "ob er das angegebene Element enthält oder nicht",
  T_48_META_API_1521_D: "Anhängen mehrerer Elemente an das Ende der Zielliste",
  T_48_META_API_1521_P0_D: "Zielliste",
  T_48_META_API_1521_P1_D: "Ergänzende Liste",
  T_48_META_API_1522_D: "Entfernt das angegebene Element aus der Liste",
  T_48_META_API_1522_P0_D: "Zielliste",
  T_48_META_API_1522_P1_D: "Der Wert des zu entfernenden Elements",
  T_48_META_API_1523_D: "Ermittelt den Index der ersten Position des Elements in der Liste. Wenn es kein Zielelement in der Liste gibt, wird -1 zurückgegeben.",
  T_48_META_API_1523_P0_D: "Zielliste",
  T_48_META_API_1523_P1_D: "elementarer Wert",
  T_48_META_API_1523_R_D: "Ortsindex",
  T_48_META_API_1524_D: "Ermittelt den Index der letzten Position des Elements in der Liste; wenn es kein Zielelement in der Liste gibt, wird -1 zurückgegeben.",
  T_48_META_API_1524_P0_D: "Zielliste",
  T_48_META_API_1524_P1_D: "elementarer Wert",
  T_48_META_API_1524_R_D: "Ortsindex",
  T_48_META_API_1525_D: "Finden Sie den Sinus des Winkels",
  T_48_META_API_1525_P0_D: "Winkel, 360 für 360 Grad",
  T_48_META_API_1525_R_D: "Sinus",
  T_48_META_API_1526_D: "Ermittlung des Kosinus eines Winkels",
  T_48_META_API_1526_P0_D: "Winkel, 360 für 360 Grad",
  T_48_META_API_1526_R_D: "Kosinus",
  T_48_META_API_1527_D: "Ermitteln des Tangens eines Winkels",
  T_48_META_API_1527_P0_D: "Winkel, 360 für 360 Grad",
  T_48_META_API_1527_R_D: "tangiert",
  T_48_META_API_1528_D: "Konstruieren Sie einen Farbwert mit einer auf 255 festgelegten Transparenz, wandeln Sie den Kanal zunächst in eine Binärzahl um, wobei alle 8 Bits einen Kanal darstellen, der nach R, G, B und Transparenz aufgeteilt ist, und konvertieren Sie diese Binärzah",
  T_48_META_API_1528_P0_D: "Der Wert des Rotkanals der Farbe, im Bereich [0,255], wenn er diesen Bereich überschreitet, wird er auf den zulässigen Wert geklemmt.",
  T_48_META_API_1528_P1_D: "Der Wert des Grünkanals der Farbe, im Bereich [0,255], wenn er diesen Bereich überschreitet, wird er auf den zulässigen Wert geklemmt.",
  T_48_META_API_1528_P2_D: "Der Wert des blauen Kanals der Farbe, im Bereich [0,255], wenn er diesen Bereich überschreitet, wird er auf den zulässigen Wert geklemmt.",
  T_48_META_API_1528_R_D: "Konstruierte Farbwerte",
  T_48_META_API_1529_D: "Führen Sie eine inverse Sinusoperation durch, um den Winkel zu erhalten",
  T_48_META_API_1529_P0_D: "Der Wert, für den die Operation des inversen Sinus durchgeführt wird, im Bereich [-1,1].",
  T_48_META_API_1529_R_D: "Perspektiven",
  T_48_META_API_1530_D: "Führen Sie die umgekehrte Kosinusoperation durch, um den Winkel zu erhalten",
  T_48_META_API_1530_P0_D: "Der Wert der inversen Kosinus-Operation, im Bereich [-1,1].",
  T_48_META_API_1530_R_D: "Perspektiven",
  T_48_META_API_1531_D: "Führen Sie eine inverse Tangensoperation durch, um den Winkel zu erhalten",
  T_48_META_API_1531_P0_D: "Der Wert, für den die Arkustangens-Operation durchgeführt wird",
  T_48_META_API_1531_R_D: "Perspektiven",
  T_48_META_API_1532_D: "Ermittelt, ob sich das Zielobjekt innerhalb der angegebenen Sphäre befindet; wenn das Objekt keine Positionsattribute hat, wird false zurückgegeben",
  T_48_META_API_1532_P0_D: "Ziel Entität",
  T_48_META_API_1532_P1_D: "Bestimmen Sie den Mittelpunkt der Kugel",
  T_48_META_API_1532_P2_D: "Geben Sie den Radius der Kugel an",
  T_48_META_API_1532_R_D: "Fundstücke",
  T_48_META_API_1533_D: "Ermittelt, ob sich das Zielobjekt innerhalb des angegebenen Zylinderbereichs befindet; wenn das Objekt kein Ortsattribut hat, wird false zurückgegeben",
  T_48_META_API_1533_P0_D: "Ziel Entität",
  T_48_META_API_1533_P1_D: "Geben Sie den Mittelpunkt des Zylinders an",
  T_48_META_API_1533_P2_D: "Geben Sie den Radius des Querschnitts des Zylinders an",
  T_48_META_API_1533_P3_D: "Geben Sie die Höhe des Zylinders an",
  T_48_META_API_1533_P4_D: "Angabe des Eulerwinkels eines Zylinders, der sich in drei Dimensionen um seinen Mittelpunkt dreht",
  T_48_META_API_1533_R_D: "Fundstücke",
  T_48_META_API_1534_D: "Ermitteln, ob sich das Zielobjekt innerhalb des angegebenen Würfelbereichs befindet",
  T_48_META_API_1534_P0_D: "Ziel Entität",
  T_48_META_API_1534_P1_D: "Bestimmen Sie den Mittelpunkt des Würfels",
  T_48_META_API_1534_P2_D: "Geben Sie die Länge des Würfels an",
  T_48_META_API_1534_P3_D: "Geben Sie die Breite des Würfels an",
  T_48_META_API_1534_P4_D: "Geben Sie die Höhe des Würfels an",
  T_48_META_API_1534_P5_D: "Geben Sie die Euler-Winkel für die dreidimensionale Drehung des Würfels um seinen Mittelpunkt an",
  T_48_META_API_1534_R_D: "Fundstücke",
  T_48_META_API_1535_D: "Ermitteln, ob sich das Zielobjekt innerhalb der angegebenen Sektorspalten befindet",
  T_48_META_API_1535_P0_D: "Ziel Entität",
  T_48_META_API_1535_P1_D: "Bestimmen Sie den Mittelpunkt des Kreises des mittleren Abschnitts einer sektorförmigen Säule",
  T_48_META_API_1535_P2_D: "Bestimmen Sie den Radius des Mittelteils einer sektorförmigen Säule",
  T_48_META_API_1535_P3_D: "Der Radius des Querschnitts der Fächersäule, der nicht erfasst wird, mit dem Mittelpunkt als Kreis, wird in diesem kleinen Fächersäulenbereich nicht erfasst, nur die Differenz zwischen der vorgeschriebenen Fächersäule und dem kleinen Fächerthema wird erfa",
  T_48_META_API_1535_P4_D: "Geben Sie die Höhe der fächerförmigen Säule an",
  T_48_META_API_1535_P5_D: "Erkennung der fächerförmigen zylindrischen Querschnitt des Schwerpunkts Winkel, größer als 360, wenn die Erkennung von zylindrischen, weniger als 0, wenn die Größe des Erfassungsbereichs ist 0",
  T_48_META_API_1535_P6_D: "Geben Sie den Euler'schen Drehwinkel der fächerförmigen Säule um den Mittelpunkt an drei Stellen an",
  T_48_META_API_1535_R_D: "Fundstücke",
  T_48_META_API_1536_D: "Vergleicht den Wert von zwei Zahlen und gibt die größere zurück",
  T_48_META_API_1536_P0_D: "linke Operand",
  T_48_META_API_1536_P1_D: "rechte Operand",
  T_48_META_API_1536_R_D: "größere Zahl",
  T_48_META_API_1537_D: "Gibt den Höchstwert in der Liste zurück",
  T_48_META_API_1537_P0_D: "Zielliste, akzeptiert nur Listenelemente vom Typ numerisch",
  T_48_META_API_1537_P1_D: "Vergleichen Sie die Ergebnisse. Wenn die Liste keine Zahlen enthält, schlägt der Vergleich fehl und gibt false zurück.",
  T_48_META_API_1537_P2_D: "Gibt den größten Wert in der Liste zurück, wenn der Vergleich erfolgreich ist, oder 0, wenn der Vergleich fehlschlägt.",
  T_48_META_API_1538_D: "Vergleicht den Wert von zwei Zahlen und gibt die kleinere zurück",
  T_48_META_API_1538_P0_D: "linke Operand",
  T_48_META_API_1538_P1_D: "rechte Operand",
  T_48_META_API_1538_R_D: "Kleinere Zahlen",
  T_48_META_API_1539_D: "Gibt den kleinsten Wert in der Liste zurück.",
  T_48_META_API_1539_P0_D: "Zielliste, akzeptiert nur Listenelemente vom Typ numerisch",
  T_48_META_API_1539_P1_D: "Vergleichen Sie die Ergebnisse. Wenn die Liste keine Zahlen enthält, schlägt der Vergleich fehl und gibt false zurück.",
  T_48_META_API_1539_P2_D: "Gibt den kleinsten Wert in der Liste zurück, wenn der Vergleich erfolgreich ist, oder 0, wenn der Vergleich fehlschlägt.",
  T_48_META_API_1540_D: "Lineare Interpolation, Rückgabe des Wertes, der dem Interpolationsfortschritt zwischen dem Startwert und dem Zielwert entspricht, Interpolationskoeffizienten [0,1]",
  T_48_META_API_1540_P0_D: "Startwert der linearen Interpolation, der zurückgegeben wird, wenn der Interpolationsfortschritt 0 ist.",
  T_48_META_API_1540_P1_D: "Zielwert der linearen Interpolation, der zurückgegeben wird, wenn der Interpolationsfortschritt 1 beträgt",
  T_48_META_API_1540_P2_D: "Interpolationsfortschritt, Wertebereich [0,1], Wert 0 für die Rückkehr zum Startwert, Wert 1 für die Rückkehr zum Zielwert, Wert 0,5 für die Rückkehr zum Mittelwert aus Startwert und Zielwert",
  T_48_META_API_1540_R_D: "Rückgabewert der linearen Interpolation",
  T_48_META_API_1541_D: "Begrenzen Sie den Bereich der Zielwert, erhalten Sie den Wert in der Mitte der drei Eingänge; seine Rolle ist es, den Zielwert auf den angegebenen Bereich zu begrenzen, ist der Zielwert kleiner als der minimale Wert auf den kleinsten Wert zurück, größer a",
  T_48_META_API_1541_P0_D: "Zielwert",
  T_48_META_API_1541_P1_D: "Mindestwert des Grenzbereichs",
  T_48_META_API_1541_P2_D: "Maximalwert des Grenzbereichs",
  T_48_META_API_1541_R_D: "Rückgabewert nach Einschränkung",
  T_48_META_API_1542_D: "Abrufen der Kanalwerte der Zielfarbe",
  T_48_META_API_1542_P0_D: "Zielfarbe",
  T_48_META_API_1542_P1_D: "R-Wert der Farbe, im Bereich [0 , 255].",
  T_48_META_API_1542_P2_D: "G-Wert der Farbe, Bereich [0 , 255].",
  T_48_META_API_1542_P3_D: "B-Wert der Farbe, Bereich [0 , 255].",
  T_48_META_API_1542_P4_D: "A-Wert der Farbe, im Bereich [0 , 255].",
  T_48_META_API_1543_D: "der Strombetrieb",
  T_48_META_API_1543_P0_D: "Basis",
  T_48_META_API_1543_P1_D: "Exponenten",
  T_48_META_API_1543_R_D: "Berechnungsergebnis",
  T_48_META_API_1544_D: "logarithmische Operation",
  T_48_META_API_1544_P0_D: "Basis",
  T_48_META_API_1544_P1_D: "Logarithmus",
  T_48_META_API_1544_R_D: "Berechnungsergebnis",
  T_48_META_API_1545_D: "Richtungsvektor zu Euler-Winkel",
  T_48_META_API_1545_P0_D: "Richtungsvektor",
  T_48_META_API_1545_R_D: "Eulerscher Winkel",
  T_48_META_API_1546_D: "Euler-Winkel-Drehungsrichtungsvektor",
  T_48_META_API_1546_P0_D: "Eulerscher Winkel",
  T_48_META_API_1546_R_D: "Richtungsvektor",
  T_48_META_API_1547_D: "Ganzzahl in Gleitkommazahl",
  T_48_META_API_1547_P0_D: "Ganzzahl",
  T_48_META_API_1547_R_D: "Fließkomma",
  T_48_META_API_1548_D: "Drehen Sie den Zielvektor entsprechend dem Quaternion",
  T_48_META_API_1548_P0_D: "Zielvektor",
  T_48_META_API_1548_P1_D: "rotierendes Quaternion",
  T_48_META_API_1548_R_D: "gedrehter Vektor",
  T_48_META_API_1549_D: "Zielnummer in String umwandeln",
  T_48_META_API_1549_P0_D: "Zielnummer der zu konvertierenden Zeichenkette",
  T_48_META_API_1549_P1_D: "Numerisches String-Format ausgeben",
  T_48_META_API_1549_R_D: "string",
  T_48_META_API_1598_D: "Zeitstempel des Servers abrufen",
  T_48_META_API_1598_R_D: "Gibt die Anzahl der Sekunden von 0:0:0 am 1. Januar 1970 zurück",
  T_48_META_API_1599_D: "Serverbereich abrufen",
  T_48_META_API_1599_R_D: "Zurück zu den regionalen Abkürzungen (BR,SAC,ID,NA,US,IND,SG,BD,VN,TH,ME,RU,EU,PK,TW)",
  T_48_META_API_16_D: "Benutzerdefinierte Bestattungsprotokolle für die Analyse von Benutzererfahrungsdaten",
  T_48_META_API_16_P0_D: "Um gemeldete Spieler zu verfolgen",
  T_48_META_API_16_P1_D: "Liste der zu meldenden Feldnamen",
  T_48_META_API_16_P2_D: "Liste der zu meldenden Feldwerte",
  T_48_META_API_1601_D: "Ein Wörterbuch erstellen",
  T_48_META_API_1601_R_D: "Das erstellte Wörterbuch",
  T_48_META_API_1602_D: "Ermittelt den Wert, der dem angegebenen Schlüssel im Wörterbuch entspricht",
  T_48_META_API_1602_P0_D: "Zielwörterbuch",
  T_48_META_API_1602_P1_D: "Schlüssel",
  T_48_META_API_1602_R_D: "Wert",
  T_48_META_API_1603_D: "Setzt den Wert, der dem angegebenen Schlüssel im Wörterbuch entspricht",
  T_48_META_API_1603_P0_D: "Zielwörterbuch",
  T_48_META_API_1603_P1_D: "Schlüssel",
  T_48_META_API_1603_P2_D: "Wert",
  T_48_META_API_1604_D: "Entfernt das angegebene Schlüssel/Wert-Paar aus dem Wörterbuch",
  T_48_META_API_1604_P0_D: "Zielwörterbuch",
  T_48_META_API_1604_P1_D: "Schlüssel",
  T_48_META_API_1605_D: "Alle Schlüssel-Wert-Paare im Wörterbuch löschen",
  T_48_META_API_1605_P0_D: "Zielwörterbuch",
  T_48_META_API_1606_D: "Anzahl der Schlüssel-Wert-Paare im Wörterbuch ermitteln",
  T_48_META_API_1606_P0_D: "Zielwörterbuch",
  T_48_META_API_1606_R_D: "Länge des Wörterbuchs",
  T_48_META_API_1607_D: "Feststellen, ob ein Schlüssel in einem Wörterbuch existiert",
  T_48_META_API_1607_P0_D: "Zielwörterbuch",
  T_48_META_API_1607_P1_D: "Schlüssel",
  T_48_META_API_1607_R_D: "Existiert es",
  T_48_META_API_1608_D: "Ermittelt alle Schlüssel des Wörterbuchs und gibt sie als Liste zurück.",
  T_48_META_API_1608_P0_D: "Zielwörterbuch",
  T_48_META_API_1608_R_D: "Liste aller Schlüsselwerte",
  T_48_META_API_17_D: "Die Erkennung erfolgt mit Hilfe eines sich linear bewegenden Kastenbereichs, wobei alle Objekte, die auf der Route des Kastenbereichs angetroffen werden, von nah nach fern zurückkehren, d. h. zunächst nicht erkannt werden, wenn sie sich innerhalb des Kast",
  T_48_META_API_17_P0_D: "Die Hälfte der Länge der drei Seiten des umrahmten Bereichs, es werden nur positive Werte akzeptiert",
  T_48_META_API_17_P1_D: "Mittelpunkt des umrahmten Bereichs",
  T_48_META_API_17_P2_D: "Rotation der Boxfläche",
  T_48_META_API_17_P3_D: "Fahrtrichtung im umrahmten Bereich",
  T_48_META_API_17_P4_D: "Im umrahmten Bereich zurückgelegte Strecke, nur positive Werte werden akzeptiert",
  T_48_META_API_17_P5_D: "Ebenenmaske, nur gefüllte Ebenen werden gescannt, bleibt sie leer, werden alle Ebenen gescannt",
  T_48_META_API_17_P6_D: "Ob der Auslöser erkannt werden kann",
  T_48_META_API_17_P7_D: "Liste der getroffenen Einrichtungen",
  T_48_META_API_1700_D: "Umwandlung einer Zeichenkette in eine Ganzzahl",
  T_48_META_API_1700_P0_D: "Zielzeichenfolge",
  T_48_META_API_1700_P1_D: "resultierende Ganzzahl",
  T_48_META_API_1700_P2_D: "ob die Umwandlung erfolgreich war oder nicht",
  T_48_META_API_1701_D: "Konvertieren einer Zeichenkette in eine Gleitkommazahl",
  T_48_META_API_1701_P0_D: "Zielzeichenfolge",
  T_48_META_API_1701_P1_D: "resultierender Schwimmer",
  T_48_META_API_1701_P2_D: "ob die Umwandlung erfolgreich war oder nicht",
  T_48_META_API_18_D: "Die Erkennung erfolgt mit Hilfe eines sich linear bewegenden kugelförmigen Bereichs, wobei alle auf dem Weg des kugelförmigen Bereichs angetroffenen Objekte, die sich ursprünglich innerhalb des kugelförmigen Bereichs befanden und nicht erkannt wurden, von",
  T_48_META_API_18_P0_D: "Radius der kugelförmigen Region, es werden nur positive Werte akzeptiert",
  T_48_META_API_18_P1_D: "Mittelpunkt der sphärischen Fläche",
  T_48_META_API_18_P2_D: "Bewegungsrichtung im Kugelbereich",
  T_48_META_API_18_P3_D: "Kugelförmige Fläche, die sich bewegt, es werden nur positive Werte akzeptiert",
  T_48_META_API_18_P4_D: "Ebenenmaske, nur gefüllte Ebenen werden gescannt, bleibt sie leer, werden alle Ebenen gescannt",
  T_48_META_API_18_P5_D: "Ob der Auslöser erkannt werden kann",
  T_48_META_API_18_P6_D: "Liste der getroffenen Einrichtungen",
  T_48_META_API_19_D: "Die Erkennung erfolgt mit Hilfe einer sich linear bewegenden Kapselregion, die alle Entitäten, die entlang der Route der Kapselregion angetroffen werden, zunächst innerhalb der Kapselregion, die nicht erkannt werden, von nah bis fern zurückgibt.",
  T_48_META_API_19_P0_D: "Radius der Halbkugel an jedem Ende der Kapselkörperregion, nur positive Werte zulässig",
  T_48_META_API_19_P1_D: "Der Abstand zwischen den Kugelmittelpunkten der Halbkugeln an jedem Ende des Kapselkörperbereichs, der größer sein muss als das Zweifache des Radius der Halbkugeln an jedem Ende",
  T_48_META_API_19_P2_D: "Mittelpunkt des Kapselkörperbereichs",
  T_48_META_API_19_P3_D: "Drehung der Kapselkörperregion",
  T_48_META_API_19_P4_D: "Fahrtrichtung im Bereich des Kapselkörpers",
  T_48_META_API_19_P5_D: "Die im Kapselbereich zurückgelegte Distanz, nur positive Werte werden akzeptiert",
  T_48_META_API_19_P6_D: "Ebenenmaske, nur gefüllte Ebenen werden gescannt, bleibt sie leer, werden alle Ebenen gescannt",
  T_48_META_API_19_P7_D: "Ob der Auslöser erkannt werden kann",
  T_48_META_API_19_P8_D: "Liste der getroffenen Einrichtungen",
  T_48_META_API_2_D: "Ermittelt alle Mannschaften im aktuellen Spiel und gibt die Liste der Mannschaften zurück.",
  T_48_META_API_2_R_D: "Mannschaftsliste",
  T_48_META_API_20_D: "Verwendung einer stationären Box-Region zur Erkennung, Rückgabe aller Objekte innerhalb der Box-Region",
  T_48_META_API_20_P0_D: "Die Hälfte der Länge der drei Seiten des umrahmten Bereichs, es werden nur positive Werte akzeptiert",
  T_48_META_API_20_P1_D: "Mittelpunkt des umrahmten Bereichs",
  T_48_META_API_20_P2_D: "Rotation der Boxfläche",
  T_48_META_API_20_P3_D: "Ebenenmaske, nur gefüllte Ebenen werden gescannt, bleibt sie leer, werden alle Ebenen gescannt",
  T_48_META_API_20_P4_D: "Ob der Auslöser erkannt werden kann",
  T_48_META_API_20_P5_D: "Liste der getroffenen Einrichtungen",
  T_48_META_API_2000_D: "Das Setzen des Wertes eines Attributs der Zielentität setzt voraus, dass das Attribut bereits definiert wurde.",
  T_48_META_API_2000_P0_D: "Ziel Entität",
  T_48_META_API_2000_P1_D: "Ein Attribut der Zielentität",
  T_48_META_API_2000_P2_D: "Der Zielwert, der dem bei der Definition der Eigenschaft geforderten Typ entsprechen muss",
  T_48_META_API_2000_P3_D: "Alle Typen unterstützen Zuweisungen, und numerische Typen unterstützen Selbst-Addition, Selbst-Minus, Selbst-Multiplikation, Selbst-Division und Selbst-Restriktion.",
  T_48_META_API_2001_D: "Abrufen des Wertes eines Attributs einer Entität",
  T_48_META_API_2001_P0_D: "Ziel Entität",
  T_48_META_API_2001_P1_D: "Die ID eines Attributs dieser Entität",
  T_48_META_API_2001_R_D: "Wert eines Attributs",
  T_48_META_API_2002: "Set Graph Property",
  T_48_META_API_2002_D: "Skript-Variablen einstellen",
  T_48_META_API_2002_P0_D: "Ziel Entität",
  T_48_META_API_2002_P1: "Graph ID",
  T_48_META_API_2002_P1_D: "Ziel-Skript-ID",
  T_48_META_API_2002_P2: "Property ID",
  T_48_META_API_2002_P2_D: "ID der im Skript definierten Mitgliedseigenschaft",
  T_48_META_API_2002_P3: "Property Value",
  T_48_META_API_2002_P3_D: "Der Zielwert, der dem bei der Definition der Eigenschaft geforderten Typ entsprechen muss",
  T_48_META_API_2002_P4_D: "Alle Typen unterstützen Zuweisungen, und numerische Typen unterstützen Selbst-Addition, Selbst-Minus, Selbst-Multiplikation, Selbst-Division und Selbst-Restriktion.",
  T_48_META_API_2003: "Get Graph Property",
  T_48_META_API_2003_D: "Skript-Variablen abrufen",
  T_48_META_API_2003_P0_D: "Ziel Entität",
  T_48_META_API_2003_P1: "Graph ID",
  T_48_META_API_2003_P1_D: "Ziel-Skript-ID",
  T_48_META_API_2003_P2: "Property ID",
  T_48_META_API_2003_P2_D: "Ziel-Attribut-ID",
  T_48_META_API_2003_R_D: "Wert eines Attributs",
  T_48_META_API_2004_D: "Definieren und initialisieren Sie eine lokale Variable, die von der Deklarationsposition bis zum Ende des Anweisungsblocks, in dem sie sich befindet, skaliert wird.",
  T_48_META_API_2004_P0_D: "Variablenname",
  T_48_META_API_2004_P1_D: "variabler Anfangswert",
  T_48_META_API_2004_P2_D: "Typ der Variablendeklaration, Zuweisung muss mit dem deklarierten Typ übereinstimmen",
  T_48_META_API_2005_D: "Setzen des Wertes einer lokalen Variablen, die von der Deklarationsposition bis zum Ende des Anweisungsblocks, in dem sie sich befindet, skaliert wird",
  T_48_META_API_2005_P0_D: "Variablenname",
  T_48_META_API_2005_P1: "Variable Value",
  T_48_META_API_2005_P1_D: "variabler Wert",
  T_48_META_API_2005_P2_D: "Alle Typen unterstützen Zuweisungen, und numerische Typen unterstützen Selbst-Addition, Selbst-Minus, Selbst-Multiplikation, Selbst-Division und Selbst-Restriktion.",
  T_48_META_API_2006: "Get Local Variable",
  T_48_META_API_2006_D: "Ermittelt den Wert einer lokalen Variablen, die von der Deklarationsposition bis zum Ende des Anweisungsblocks skaliert ist.",
  T_48_META_API_2006_P0: "Variable Name",
  T_48_META_API_2006_P0_D: "Variablenname",
  T_48_META_API_2006_R_D: "variabler Wert",
  T_48_META_API_2009: "Find and Invoke Global Custom API with Serial",
  T_48_META_API_2009_D: "Ruft globale benutzerdefinierte Funktionen seriell auf, und wenn in der benutzerdefinierten Funktion eine Wartezeit besteht, wartet auch die Aufrufstelle",
  T_48_META_API_2009_P0: "Graph ID",
  T_48_META_API_2009_P0_D: "Skript-ID des Skripts, in dem sich die benutzerdefinierte Funktion befindet",
  T_48_META_API_2009_P1: "Function ID",
  T_48_META_API_2009_P1_D: "ID der benutzerdefinierten Funktion namens",
  T_48_META_API_2009_P2_D: "Liste der Argumente, die an die benutzerdefinierte Funktion übergeben werden",
  T_48_META_API_2010: "Find and Invoke Global Custom API with Parallel",
  T_48_META_API_2010_D: "Ruft globale benutzerdefinierte Funktionen parallel auf und kehrt sofort an die Aufrufstelle zurück, um die Reihe fortzusetzen, unabhängig davon, ob in der benutzerdefinierten Funktion eine Wartezeit besteht oder nicht",
  T_48_META_API_2010_P0: "Graph ID",
  T_48_META_API_2010_P0_D: "Skript-ID des Skripts, in dem sich die benutzerdefinierte Funktion befindet",
  T_48_META_API_2010_P1: "Function ID",
  T_48_META_API_2010_P1_D: "ID der benutzerdefinierten Funktion namens",
  T_48_META_API_2010_P2_D: "Liste der Argumente, die an die benutzerdefinierte Funktion übergeben werden",
  T_48_META_API_2013: "Set Self Graph Property",
  T_48_META_API_2013_D: "Variablen für das aktuelle Skript setzen",
  T_48_META_API_2013_P0: "Property ID",
  T_48_META_API_2013_P0_D: "Ziel-Attribut-ID",
  T_48_META_API_2013_P1: "Property Value",
  T_48_META_API_2013_P1_D: "Zielwert",
  T_48_META_API_2013_P2_D: "Alle Typen unterstützen Zuweisungen, und numerische Typen unterstützen Selbst-Addition, Selbst-Minus, Selbst-Multiplikation, Selbst-Division und Selbst-Restriktion.",
  T_48_META_API_2014: "Get Self Graph Property",
  T_48_META_API_2014_D: "Abrufen von Variablen für das aktuelle Skript",
  T_48_META_API_2014_P0: "Property ID",
  T_48_META_API_2014_P0_D: "Ziel-Attribut-ID",
  T_48_META_API_2014_R_D: "Wert eines Attributs",
  T_48_META_API_21_D: "Verwendung einer stationären sphärischen Region für die Erkennung, Rückgabe aller Objekte innerhalb der sphärischen Region",
  T_48_META_API_21_P0_D: "Radius der kugelförmigen Region, es werden nur positive Werte akzeptiert",
  T_48_META_API_21_P1_D: "Mittelpunkt der sphärischen Fläche",
  T_48_META_API_21_P2_D: "Ebenenmaske, nur gefüllte Ebenen werden gescannt, bleibt sie leer, werden alle Ebenen gescannt",
  T_48_META_API_21_P3_D: "Ob der Auslöser erkannt werden kann",
  T_48_META_API_21_P4_D: "Liste der getroffenen Einrichtungen",
  T_48_META_API_22_D: "Erkennung mit Hilfe einer stationären Kapselkörperregion, Rückgabe aller Objekte innerhalb der Kapselkörperregion",
  T_48_META_API_22_P0_D: "Radius der Halbkugel an jedem Ende der Kapselkörperregion, nur positive Werte zulässig",
  T_48_META_API_22_P1_D: "Der Abstand zwischen den Kugelmittelpunkten der Halbkugeln an jedem Ende des Kapselkörperbereichs, der größer sein muss als das Zweifache des Radius der Halbkugeln an jedem Ende",
  T_48_META_API_22_P2_D: "Mittelpunkt des Kapselkörperbereichs",
  T_48_META_API_22_P3_D: "Drehung der Kapselkörperregion",
  T_48_META_API_22_P4_D: "Ebenenmaske, nur gefüllte Ebenen werden gescannt, bleibt sie leer, werden alle Ebenen gescannt",
  T_48_META_API_22_P5_D: "Ob der Auslöser erkannt werden kann",
  T_48_META_API_22_P6_D: "Liste der getroffenen Einrichtungen",
  T_48_META_API_23_D: "Legen Sie den Status des Spezialgegenstands für den Spieler fest. Spezialgegenstände können nur einen Status haben.",
  T_48_META_API_23_P0_D: "Spieler",
  T_48_META_API_23_P1_D: "Artikel-ID",
  T_48_META_API_23_P2_D: "Ob das Element aktiviert werden soll",
  T_48_META_API_23_P3_D: "spezielle Substanz",
  T_48_META_API_24_D: "Wenden Sie eine Kraft auf das Ziel an, das ein physisches Objekt sein muss.",
  T_48_META_API_24_P0_D: "physisches Zielobjekt",
  T_48_META_API_24_P1_D: "Kraftvektor",
  T_48_META_API_24_P2_D: "Art der Kraft",
  T_48_META_API_25_D: "Eine Kraft einmal auf einen Punkt anwenden, das Ziel muss ein starrer Körper sein",
  T_48_META_API_25_P0_D: "starrer Zielkörper",
  T_48_META_API_25_P1_D: "Kraftvektor",
  T_48_META_API_25_P2_D: "Position der Kraftaufbringung",
  T_48_META_API_25_P3_D: "Art der Kraft",
  T_48_META_API_26_D: "Wenden Sie ein Drehmoment auf die Zielscheibe an, die starr sein muss.",
  T_48_META_API_26_P0_D: "starrer Zielkörper",
  T_48_META_API_26_P1_D: "Torsion",
  T_48_META_API_26_P2_D: "Art der angewandten Kraft",
  T_48_META_API_27_D: "Bewegen des starren Zielkörpers an die angegebene Position",
  T_48_META_API_27_P0_D: "starrer Zielkörper",
  T_48_META_API_27_P1_D: "vorgesehener Ort",
  T_48_META_API_28_D: "Drehen des starren Zielkörpers",
  T_48_META_API_28_P0_D: "starrer Zielkörper",
  T_48_META_API_28_P1_D: "rotierendes Quaternion",
  T_48_META_API_29_D: "Erzeugt eine interpolierte Bewegung, bei der die angegebenen Eigenschaften des Zielobjekts entsprechend den Einstellungen geglättet werden.",
  T_48_META_API_29_P0_D: "Ziel Entität",
  T_48_META_API_29_P1_D: "Attribut-IDs, die Bewegungsänderungen erfordern",
  T_48_META_API_29_P2_D: "Attribut Anfangswert",
  T_48_META_API_29_P3_D: "Attribut Endwert",
  T_48_META_API_29_P4_D: `Es kann zwischen Einzel, Schleife und reziprok gewählt werden. 
Zyklisch bedeutet, dass sich die Einheit nach Abschluss jeder Bewegung erneut vom Startwert aus bewegt. Reziprok bedeutet, dass sich die Einheit nach Abschluss der Bewegung vom Startwert zu`,
  T_48_META_API_29_P5_D: "Kontrollpunkt der Bessel-Kurve",
  T_48_META_API_29_P6_D: "Dauer einer Änderung in Millisekunden",
  T_48_META_API_29_P7_D: "Erstellte interpolierte Bewegungseinheiten",
  T_48_META_API_29_P8_D: "Ob die Wiedergabe nach der Erstellung automatisch beginnt",
  T_48_META_API_3_D: "Wechselt das Spiel in die Zielphase, ist die Runde ebenfalls eine Sonderphase. Beim Wechsel zu einer Etappe in einer Runde wird der Rundenzähler auf 0 gesetzt.",
  T_48_META_API_3_P0_D: "Index der Zielrunde oder -phase",
  T_48_META_API_30_D: "Zwingt den Zielspieler, das angegebene Fahrzeug zu betreten",
  T_48_META_API_30_P0_D: "Zielspieler",
  T_48_META_API_30_P1_D: "Trägerunternehmen",
  T_48_META_API_30_P2_D: "Sitznummer",
  T_48_META_API_30_P3_D: "Ob der Spieler erfolgreich in das Fahrzeug einsteigen konnte",
  T_48_META_API_3001_D: "Der Zielspieler muss einen Gegenstand ablegen",
  T_48_META_API_3001_P0_D: "Zielspieler",
  T_48_META_API_3001_P1_D: "physische Entität",
  T_48_META_API_3002_D: "Ermittelt die Koordinaten innerhalb des aktuell verfügbaren zufälligen Geburtspunkts, der nicht vollständig belegt ist (veraltet, bitte GetRandomSpawnPosition verwenden)",
  T_48_META_API_3002_P0_D: "Spieler, denen ein Geburtsort zugewiesen werden muss",
  T_48_META_API_3002_R_D: "Zufällig zugewiesene Punktkoordinaten",
  T_48_META_API_3003_D: "Ermittelt die Gesamtpunktzahl des Spielers für den angegebenen Punktetyp",
  T_48_META_API_3003_P0_D: "Spieler",
  T_48_META_API_3003_P1_D: "Art der Punkte",
  T_48_META_API_3003_R_D: "Punktwert",
  T_48_META_API_3004_D: "Festlegen des Rundenergebnisses für einen bestimmten Punktetyp eines Spielers",
  T_48_META_API_3004_P0_D: "Spielereinheit",
  T_48_META_API_3004_P1_D: "Art der Punkte",
  T_48_META_API_3004_P2_D: "Punktwert",
  T_48_META_API_3005_D: "Ermittelt die Gesamtpunktzahl des Teams für den angegebenen Punktetyp",
  T_48_META_API_3005_P0_D: "Team-Einheit",
  T_48_META_API_3005_P1_D: "Art der Punkte",
  T_48_META_API_3005_R_D: "Punktwert",
  T_48_META_API_3006_D: "Festlegen des Rundenergebnisses für den angegebenen Punktetyp einer Mannschaft",
  T_48_META_API_3006_P0_D: "Team-Einheit",
  T_48_META_API_3006_P1_D: "Art der Punkte",
  T_48_META_API_3006_P2_D: "Punktwert",
  T_48_META_API_3007_D: "Ermittelt den Punktestand des Spielers für die angegebene Runde und den angegebenen Punktetyp",
  T_48_META_API_3007_P0_D: "Spielereinheit",
  T_48_META_API_3007_P1_D: "Runder Index",
  T_48_META_API_3007_P2_D: "Art der Punkte",
  T_48_META_API_3007_R_D: "Punktwert",
  T_48_META_API_3008_D: "Abrufen des Mannschaftsergebnisses für die angegebene Runde, Punktetyp",
  T_48_META_API_3008_P0_D: "Team-Einheit",
  T_48_META_API_3008_P1_D: "Runder Index",
  T_48_META_API_3008_P2_D: "Art der Punkte",
  T_48_META_API_3008_R_D: "Punktwert",
  T_48_META_API_3009_D: "Die Gesamtwertung des Spielers abrufen",
  T_48_META_API_3009_P0_D: "Spielereinheit",
  T_48_META_API_3009_R_D: "Position in einer Rangliste von Namen",
  T_48_META_API_3011_D: "Die Gesamtwertung des Spiels der Mannschaft abrufen",
  T_48_META_API_3011_P0_D: "Verlassen",
  T_48_META_API_3011_R_D: "Position in einer Rangliste von Namen",
  T_48_META_API_3013_D: "Ermittelt den Rang des Spielers für eine bestimmte Runde",
  T_48_META_API_3013_P0_D: "Spielereinheit",
  T_48_META_API_3013_P1_D: "Runder Index",
  T_48_META_API_3013_R_D: "Position in einer Rangliste von Namen",
  T_48_META_API_3014_D: "Mannschaftsranglisten für eine bestimmte Runde abrufen",
  T_48_META_API_3014_P0_D: "Verlassen",
  T_48_META_API_3014_P1_D: "Runder Index",
  T_48_META_API_3014_R_D: "Position in einer Rangliste von Namen",
  T_48_META_API_3015_D: "Abrufen der Brieftasche des Zielobjekts",
  T_48_META_API_3015_P0_D: "Ziel Entität",
  T_48_META_API_3015_P1_D: "Vorhandensein einer Brieftasche",
  T_48_META_API_3015_P2_D: "Erworbene Brieftascheneinheiten",
  T_48_META_API_3016_D: "Erstellt eine Brieftasche für den Zielspieler, nicht gültig, wenn der Spieler bereits eine Brieftasche hat.",
  T_48_META_API_3016_P0_D: "Zielspieler",
  T_48_META_API_3016_P1_D: "Brieftaschen-gebundene Entität, Besitzer der Brieftasche",
  T_48_META_API_3016_P2_D: "Wallet-Entität",
  T_48_META_API_3017_D: "Währung zu einer bestimmten Brieftasche hinzufügen",
  T_48_META_API_3017_P0_D: "Ziel-Brieftasche",
  T_48_META_API_3017_P1_D: "Art der hinzugefügten Währung",
  T_48_META_API_3017_P2_D: "Zunahme der Zahl der Währungen",
  T_48_META_API_3018_D: "Währungsreduktion für eine bestimmte Brieftasche",
  T_48_META_API_3018_P0_D: "Ziel-Brieftasche",
  T_48_META_API_3018_P1_D: "Ermäßigter Währungstyp",
  T_48_META_API_3018_P2_D: "Geringere Anzahl von Währungen",
  T_48_META_API_3019_D: "Übertragen von Währungen von einer Brieftasche zu einer anderen Brieftasche",
  T_48_META_API_3019_P0_D: "Brieftasche zum Übertragen von Währungen",
  T_48_META_API_3019_P1_D: "Arten von Geldtransfers",
  T_48_META_API_3019_P2_D: "Anzahl der übertragenen Währungen",
  T_48_META_API_3019_P3_D: "Wallet, auf die die Währung übertragen wird",
  T_48_META_API_3020_D: "Ermittelt die Anzahl der Währungen eines bestimmten Typs in einer bestimmten Brieftasche",
  T_48_META_API_3020_P0_D: "Ziel-Brieftasche",
  T_48_META_API_3020_P1_D: "Währung Art der Anfrage",
  T_48_META_API_3020_R_D: "Betrag der Währung",
  T_48_META_API_3021_D: "Abrufen der Entitäten des angegebenen Währungstyps in der angegebenen Brieftasche",
  T_48_META_API_3021_P0_D: "Ziel-Brieftasche",
  T_48_META_API_3021_P1_D: "Währung Art der Anfrage",
  T_48_META_API_3021_R_D: "Monetäre Einheiten",
  T_48_META_API_3022_D: "Alle Geschäfte im Spiel abrufen und als Liste zurückgeben",
  T_48_META_API_3022_R_D: "Liste der Geschäftseinheiten",
  T_48_META_API_3023_D: "Ersetzt die Form des Zielplayers durch die Form eines angegebenen Szenenobjekts.",
  T_48_META_API_3023_P0_D: "Zielspieler",
  T_48_META_API_3023_P1_D: "Zielszenenobjekte für die Ersetzung",
  T_48_META_API_3023_P2_D: "Ersetzung der Player-Transformations-Tarnkomponente, die nach der",
  T_48_META_API_3024_D: "Hebt den Tarnungsstatus des Spielers auf",
  T_48_META_API_3024_P0_D: "Zielspieler",
  T_48_META_API_3025_D: "Erstelle ein Alter Ego in Form einer Szenenentität beim Zielspieler",
  T_48_META_API_3025_P0_D: "Zielspieler",
  T_48_META_API_3025_P1_D: "Szeneneinheiten für geteilte Bilder",
  T_48_META_API_3025_P2_D: "Erstellte bilokale Einheiten",
  T_48_META_API_3026_D: "Erlangung der getarnten Entität des Spielers",
  T_48_META_API_3026_P0_D: "Spieler",
  T_48_META_API_3026_R_D: "Spieler, die Entitäten tarnen",
  T_48_META_API_3027_D: "Chat-Kanal-Entität nach Index abrufen",
  T_48_META_API_3027_P0_D: "Chat-Kanal-Index, Bereich [1,8]",
  T_48_META_API_3027_R_D: "Chat-Kanal-Einheiten",
  T_48_META_API_3028_D: "Ruft die Chat-Kanal-Entität ab, in der sich der angegebene Spieler gerade befindet",
  T_48_META_API_3028_P0_D: "Zielspieler",
  T_48_META_API_3028_R_D: "Chat-Kanal-Einheiten",
  T_48_META_API_3029_D: "Ermöglicht es den Spielern, dem vorgesehenen Chat-Kanal beizutreten und in den Ziel-Kanal zu wechseln, wenn die Spieler bereits in anderen Chat-Kanälen sind.",
  T_48_META_API_3029_P0_D: "Zielspieler",
  T_48_META_API_3029_P1_D: "Chat-Kanal-Einheiten",
  T_48_META_API_3030_D: "Bewirkt, dass der Spieler den Kanal, in dem er sich gerade befindet, verlässt und in einem Zustand ist, in dem er sich danach in keinem Chat-Kanal mehr befindet",
  T_48_META_API_3030_P0_D: "Zielspieler",
  T_48_META_API_3031_D: "Verlassen",
  T_48_META_API_3031_P0_D: "Chat-Kanal-Entität, leer, wenn kein Spieler im Kanal ist",
  T_48_META_API_3032_D: "Einstellung des Verhaltensstatus des Spielers",
  T_48_META_API_3032_P0_D: "Zielspieler",
  T_48_META_API_3032_P1_D: "Arten des Spielerverhaltens",
  T_48_META_API_3032_P2_D: `Aktiviert: HUD-Schaltfläche ist verfügbar, normalerweise verfügbar
 Deaktiviert: HUD-Schaltfläche ist deaktiviert, kann weder aktiv noch passiv auf den Verhaltensstatus zugreifen
 Blockiert: HUD-Schaltfläche ist ausgeblendet, kann nicht aktiv auf den Ve`,
  T_48_META_API_3033_D: "Der Spieler verwandelt sich in ein Objekt in einer bestimmten Szene",
  T_48_META_API_3033_P0_D: "Zielspieler",
  T_48_META_API_3033_P1_D: "Objekt umgewandelt werden in",
  T_48_META_API_3033_P2_D: "Nach der Umwandlung geschaffene Entitäten",
  T_48_META_API_3034_D: "Der Spieler erschafft ein Alter Ego mit seinem eigenen Aussehen",
  T_48_META_API_3034_P0_D: "Zielspieler",
  T_48_META_API_3034_P1_D: "Alter Ego-Entitäten geschaffen",
  T_48_META_API_3035_D: "Erstellen Sie einen benutzerdefinierten Shop mit Regalen als nächste Ebene des Shops",
  T_48_META_API_3035_P0_D: "Shop-Einheiten erstellt",
  T_48_META_API_3036_D: "Erstellen Sie ein benutzerdefiniertes Regal, bei dem die obere Ebene des Regals der Shop ist und die untere Ebene die Produkte",
  T_48_META_API_3036_P0_D: "Geschaffene Regaleinheiten",
  T_48_META_API_3037_D: "Erstellen Sie ein benutzerdefiniertes Produkt, das Artikel hinzufügen kann",
  T_48_META_API_3037_P0_D: "Geschaffene Wareneinheiten",
  T_48_META_API_3038_D: "Das Hinzufügen von Artikeln zu einem Produkt ermöglicht es Ihnen, mehrere Artikel zu einem Produkt hinzuzufügen, indem Sie das Element mehrfach verwenden.",
  T_48_META_API_3038_P0_D: "Grundstoffunternehmen",
  T_48_META_API_3038_P1_D: "Hinzufügende Elemente",
  T_48_META_API_3038_P2_D: "Anzahl der Artikel",
  T_48_META_API_3039_D: "Jailbreak-Belohnungen geben",
  T_48_META_API_3039_P0_D: "Spielereinheit",
  T_48_META_API_3039_P1_D: "Mengen",
  T_48_META_API_3039_P2_D: "echtes Geld",
  T_48_META_API_3040_D: "Aktualisierte Jailbreak-Aufgaben",
  T_48_META_API_3040_P0_D: "Spielereinheit",
  T_48_META_API_3040_P1_D: "Aufgaben-ID",
  T_48_META_API_3040_P2_D: "(wert sein)",
  T_48_META_API_3041_D: "Ermittelt die Koordinaten eines zufälligen Geburtsortes, und zwar nur von verfügbaren Geburtsorten, die nicht vollständig belegt sind.",
  T_48_META_API_3041_P0_D: "Zielspieler",
  T_48_META_API_3041_R_D: "Die Koordinaten des Geburtsortes werden nach dem Zufallsprinzip bestimmt. Wenn es keinen Geburtsort gibt, der den Kriterien entspricht, wird ein Ort in der Nähe von (0, 0, 0) zurückgegeben.",
  T_48_META_API_3042_D: "Jailbreak-Spiel beenden",
  T_48_META_API_3042_P0_D: "Spielereinheit",
  T_48_META_API_3042_P1_D: "Aufgaben-ID",
  T_48_META_API_3043_D: "Basierend auf Jailbreak-Requisiten",
  T_48_META_API_3043_P0_D: "Spielereinheit",
  T_48_META_API_3043_P1_D: "Art der Requisiten",
  T_48_META_API_3043_P2_D: "Requisiten-ID",
  T_48_META_API_31_D: "Erzeugt eine Bewegung relativ zu sich selbst, bei der sich das Zielobjekt jedes Mal relativ zu seinen aktuellen Attributwerten verändert",
  T_48_META_API_31_P0_D: "Ziel Entität",
  T_48_META_API_31_P1_D: "Eigenschaften, die Bewegungsänderungen erfordern",
  T_48_META_API_31_P2_D: "Betrag der Veränderung pro Bewegung",
  T_48_META_API_31_P3_D: "Kontrollpunkt der Bessel-Kurve",
  T_48_META_API_31_P4_D: `Einmalig: Die Bewegung stoppt, wenn sich das Attribut um den Betrag Delta ändert 
 Zyklisch: Die Bewegung wird jedes Mal wiederholt, wenn sich das Attribut um den Betrag Delta ändert`,
  T_48_META_API_31_P5_D: "Dauer einer Änderung in Millisekunden",
  T_48_META_API_31_P6_D: "Erstellte Objekte, die sich relativ zu sich selbst bewegen",
  T_48_META_API_31_P7_D: "Ob die Wiedergabe nach der Erstellung automatisch beginnt",
  T_48_META_API_3100_D: "Das Ziel spielt die Animation in dem angegebenen Zustand ab",
  T_48_META_API_3100_P0_D: "Entitätskomponenten, die Animationen mit montierbaren Animationscontrollern abspielen",
  T_48_META_API_3100_P1_D: "Der angegebene Zustand des Animationscontrollers",
  T_48_META_API_3100_P2_D: "Skalierung der Wiedergabegeschwindigkeit von Animationen",
  T_48_META_API_3100_P3_D: "Schleifen-Typ: Sie können die ursprüngliche Logik der Animation beibehalten, sie nur einmal abspielen oder sie in einer Schleife wiederholen.",
  T_48_META_API_3101_D: "Charakteranimation abspielen, Unterstützung benutzerdefinierter Animationsressourcen",
  T_48_META_API_3101_P0_D: "Zielspieler",
  T_48_META_API_3101_P1_D: "Benutzerdefinierte Animations-Ressourcen-ID",
  T_48_META_API_3101_P2_D: "Ob Schleife oder nicht",
  T_48_META_API_3102_D: "Einstellung der Charakterressourcen für einen bestimmten Spieler",
  T_48_META_API_3102_P0_D: "Zielspieler",
  T_48_META_API_3102_P1_D: "Benutzerdefinierte Rolle Ressourcen-ID",
  T_48_META_API_3109_D: "Durch das Einschalten wird die Bewegung bis zum Ende der Sicherheitszone geglättet",
  T_48_META_API_3109_P0_D: "Ausgangslage der Sicherheitszone",
  T_48_META_API_3109_P1_D: "Lage des Endes der Sicherheitszone",
  T_48_META_API_3109_P2_D: "Anfangsradius der Sicherheitszone",
  T_48_META_API_3109_P3_D: "Endradius der Sicherheitszone",
  T_48_META_API_3109_P4_D: "Zeit in Sekunden, bis die Sicherheitszone ihren Endzustand erreicht hat",
  T_48_META_API_3109_P5_D: "Höhe des Schadens pro Sekunde, der außerhalb der Sicherheitszone erlitten wird",
  T_48_META_API_3110_D: "Umschalten von Gruppen für das Erscheinungsbild von Zeichen",
  T_48_META_API_3110_P0_D: "Ziele",
  T_48_META_API_3110_P1_D: "Erscheinungsbild der Gruppe",
  T_48_META_API_3111_D: 'Gruppe "Rollenerscheinung anzeigen',
  T_48_META_API_3111_P0_D: "Ziele",
  T_48_META_API_3111_P1_D: "Erscheinungsbild der Gruppe",
  T_48_META_API_3112_D: "Versteckte Zeichen Erscheinungsbild Gruppe",
  T_48_META_API_3112_P0_D: "Ziele",
  T_48_META_API_3112_P1_D: "Erscheinungsbild der Gruppe",
  T_48_META_API_3121_D: "Senden von Assertion-Ergebnissen an Craftland Studio PC Statistical Usage",
  T_48_META_API_3121_P0_D: "Behauptungsausdruck",
  T_48_META_API_3121_P1_D: "auf etw. aufmerksam machen",
  T_48_META_API_32_D: "Abrufen der heutigen Token-Daten des Spielers",
  T_48_META_API_32_P0_D: "Zielspieler",
  T_48_META_API_32_P1_D: "tokenID",
  T_48_META_API_32_P2_D: "Anzahl der Token",
  T_48_META_API_32_P3_D: "ob das Tupel erfolgreich aufgerufen wurde oder nicht",
  T_48_META_API_3200_D: "Fügt dem Player Elemente hinzu und gibt eine Liste der ausgegebenen Elemente zurück",
  T_48_META_API_3200_P0_D: "Spieler",
  T_48_META_API_3200_P1_D: "Artikel-ID",
  T_48_META_API_3200_P2_D: "Anzahl der Artikel",
  T_48_META_API_3200_P3_D: "Eine Liste der für den Spieler hinzugefügten Elemente, auch wenn nur ein Element hinzugefügt wurde, wird es als Liste zurückgegeben.",
  T_48_META_API_3201_D: "Stellt dem benannten Spieler Blut wieder zur Verfügung, ohne die Blutmenge zu überschreiten",
  T_48_META_API_3201_P0_D: "Zielspieler",
  T_48_META_API_3201_P1_D: "Ein Wert, der dem Spieler Blut hinzufügt. Es werden nur positive Zahlen akzeptiert.",
  T_48_META_API_3202_D: "Einstellen der Fertigkeitsliste des Zielspielers",
  T_48_META_API_3202_P0_D: "Zielspieler",
  T_48_META_API_3202_P1_D: "Liste der Fertigkeiten",
  T_48_META_API_3203_D: "Eine Liste der Fähigkeiten des Zielspielers erhalten",
  T_48_META_API_3203_P0_D: "Zielspieler",
  T_48_META_API_3203_R_D: "Liste der Fertigkeiten",
  T_48_META_API_3205_D: "Löschen einer bestimmten Anzahl von Gegenständen aus dem Player",
  T_48_META_API_3205_P0_D: "Zielspieler",
  T_48_META_API_3205_P1_D: "Art des zu löschenden Elements",
  T_48_META_API_3205_P2_D: "Die Anzahl der zu löschenden Gegenstände, wenn sie die Anzahl der vom Spieler gehaltenen Gegenstände übersteigt, werden nur die gehaltenen Gegenstände gelöscht",
  T_48_META_API_3206_D: "Abrufen der angegebenen Anzahl von Gegenständen, die ein Spieler besitzt",
  T_48_META_API_3206_P0_D: "Zielspieler",
  T_48_META_API_3206_P1_D: "Art des Items",
  T_48_META_API_3206_R_D: "Anzahl von Spielerbetrieben",
  T_48_META_API_3207_D: "Erkennen, ob der Spieler den aktuellen Checkpoint auslösen kann",
  T_48_META_API_3207_P0_D: "Zielspieler",
  T_48_META_API_3207_P1_D: "Auslöser",
  T_48_META_API_3207_R_D: "True: kann ausgelöst werden, False: kann nicht ausgelöst werden",
  T_48_META_API_3208_D: "Infektionsmodus Zombie Evolution",
  T_48_META_API_3208_P0_D: "Zielspieler",
  T_48_META_API_3209_D: "AI-Entität stoppt/erzwingt Standardverhaltensbaum",
  T_48_META_API_3209_P0_D: "Um das Ziel des Verhaltensbaums zu ermöglichen",
  T_48_META_API_3209_P1_D: "ob der Standard-Verhaltensbaum implementiert werden soll",
  T_48_META_API_3210_D: "AI-Einheit, die ein bestimmtes Ziel verfolgt",
  T_48_META_API_3210_P0_D: "KI-Entitäten bei der Verfolgung",
  T_48_META_API_3210_P1_D: "Ziel",
  T_48_META_API_3211_D: "Spielergegenstände zerstören (veraltet, verwenden Sie DeleteEquipment)",
  T_48_META_API_3211_P0_D: "Der Spieler, dessen Gegenstand zerstört wurde",
  T_48_META_API_3211_P1_D: "Art des vernichteten Gegenstands",
  T_48_META_API_3211_P2_D: "Waffenslot, nur Waffe.",
  T_48_META_API_3212_D: "Wechsel der Trikots",
  T_48_META_API_3212_P0_D: "Zielspieler",
  T_48_META_API_3212_P1_D: "Kleidung Stil",
  T_48_META_API_3212_P2_D: "Hauptfarben I",
  T_48_META_API_3212_P3_D: "Hauptfarbe II",
  T_48_META_API_3212_P4_D: "konfigurieren.",
  T_48_META_API_3213_D: "Das Trikot des Spielers in seinen ursprünglichen Zustand zurückversetzen",
  T_48_META_API_3213_P0_D: "Zielspieler",
  T_48_META_API_3214_D: "Switch Player Sprachchat",
  T_48_META_API_3214_P0_D: "Zielspieler",
  T_48_META_API_3214_P1_D: "Ob der Sprachchat geschlossen werden soll, True:Close False:Open",
  T_48_META_API_3215_D: "Spieler wechseln Schnell-Chat",
  T_48_META_API_3215_P0_D: "Zielspieler",
  T_48_META_API_3215_P1_D: "Ob der Quick Chat geschlossen werden soll, True:Close False:Open",
  T_48_META_API_3216_D: "Legt fest, ob der Zielspieler Gegenstände aufheben kann",
  T_48_META_API_3216_P0_D: "Zielspieler",
  T_48_META_API_3216_P1_D: "Ob das Aufnehmen von Gegenständen verboten ist oder nicht, true: Aufnehmen ist verboten false: Aufnehmen ist erlaubt",
  T_48_META_API_3217_D: "Legt fest, ob der Zielspieler Gegenstände ablegen kann",
  T_48_META_API_3217_P0_D: "Zielspieler",
  T_48_META_API_3217_P1_D: "Ob das Fallenlassen von Gegenständen verboten ist oder nicht, true: Aufnehmen ist verboten false: Aufnehmen ist möglich",
  T_48_META_API_3218_D: "Zerstört eine Waffe in dem vom Spieler gewählten Slot",
  T_48_META_API_3218_P0_D: "Zielspieler",
  T_48_META_API_3218_P1_D: "Zu zerstörende Waffenfächer",
  T_48_META_API_3218_P2_D: "Zu vernichtende Anzahl",
  T_48_META_API_3218_P3_D: "Erfolgreiche Zerstörung oder nicht, die Zerstörung schlägt fehl, wenn keine Waffe im Waffensteckplatz ausgerüstet ist",
  T_48_META_API_3219_D: "Leert den Rucksack des Zielspielers von allen Gegenständen, einschließlich ausgerüsteter Gegenstände.",
  T_48_META_API_3219_P0_D: "Zielspieler",
  T_48_META_API_3220_D: "Einstellen der Player-Ausrichtung",
  T_48_META_API_3220_P0_D: "Zielspieler",
  T_48_META_API_3220_P1_D: "Orientierung der Spieler",
  T_48_META_API_3221_D: "<Player>(veraltet, nicht verwenden, siehe Attribut :Skeleton für Informationen)",
  T_48_META_API_3221_P0_D: "Spielereinheit",
  T_48_META_API_3221_P1_D: "Zoombereich",
  T_48_META_API_3221_P2_D: "Zoomwert",
  T_48_META_API_3222_D: "Gewähren Sie einem Spieler einen Rückstoßeffekt, der Zielspieler fällt mit fester Beschleunigung und der Rückstoß wird bei einer Luftkolision gezwungen gestoppt",
  T_48_META_API_3222_P0_D: "Zielspieler",
  T_48_META_API_3222_P1_D: "Knockout-Richtung",
  T_48_META_API_3222_P2_D: "Zeit der Fahrerflucht",
  T_48_META_API_3222_P3_D: "Anfangsgeschwindigkeit der Y-Achse beim Aufprall",
  T_48_META_API_3222_P4_D: "Anfangsgeschwindigkeit in der XZ-Ebene beim Aufprall",
  T_48_META_API_3222_P5_D: "Ob die Ausrichtung des Players geändert werden soll",
  T_48_META_API_3223_D: "Ermittelt die Kostüm-ID des Zielspielers oder NPCs",
  T_48_META_API_3223_P0_D: "Zielspieler oder NPC",
  T_48_META_API_3223_P1_D: "Art der Kleidung",
  T_48_META_API_3223_R_D: "Kleidung ID",
  T_48_META_API_3224_D: "Einstellen der Kostüm-ID des Zielspielers oder NPCs",
  T_48_META_API_3224_P0_D: "Zielspieler oder NPC",
  T_48_META_API_3224_P1_D: "Kleidung ID",
  T_48_META_API_3225_D: "Stellt die Standardkleidung des Zielspielers wieder her, kann nicht auf NSCs angewendet werden.",
  T_48_META_API_3225_P0_D: "Zielspieler",
  T_48_META_API_3226_D: "AI-Entität greift designiertes Ziel an",
  T_48_META_API_3226_P0_D: "Die KI-Einheit, die den Angriff durchführt",
  T_48_META_API_3226_P1_D: "Ziel",
  T_48_META_API_3227_D: "Wechselt die Waffe des Spielers auf die Waffe im angegebenen Steckplatz",
  T_48_META_API_3227_P0_D: "Zielspieler",
  T_48_META_API_3227_P1_D: "Zu wechselnder Waffenslot",
  T_48_META_API_3227_P2_D: "Unabhängig davon, ob der Wechsel erfolgreich ist oder nicht, schlägt der Wechsel fehl, wenn sich keine Waffe im Waffenplatz befindet.",
  T_48_META_API_3228_D: "Waffen-Skins für Zielspieler oder NPCs erhalten",
  T_48_META_API_3228_P0_D: "Zielspieler oder NPC",
  T_48_META_API_3228_P1_D: "Waffe Skin ID",
  T_48_META_API_3228_R_D: "Waffe Skin ID",
  T_48_META_API_3229_D: "Einstellen des Waffenskins des Zielspielers oder NPCs",
  T_48_META_API_3229_P0_D: "Zielspieler oder NPC",
  T_48_META_API_3229_P1_D: "Waffe Skin ID",
  T_48_META_API_3230_D: "Stellt den Standardwaffen-Skin des Zielspielers wieder her, der nicht auf NSCs angewendet werden kann.",
  T_48_META_API_3230_P0_D: "Zielspieler",
  T_48_META_API_3230_P1_D: "Waffen-ID",
  T_48_META_API_3231_D: "Einrichten des Anzugs des Spielers",
  T_48_META_API_3231_P0_D: "Zielspieler",
  T_48_META_API_3231_P1_D: "Kleidung Liste",
  T_48_META_API_3232_D: "Entfernt alle Kostüme des angegebenen Kostümtyps vom Zielspieler oder NPC",
  T_48_META_API_3232_P0_D: "Zielspieler oder NPC",
  T_48_META_API_3232_P1_D: "Art der Kleidung",
  T_48_META_API_3233_D: "Entferne den Skin einer bestimmten Waffe eines Spielers oder NPCs",
  T_48_META_API_3233_P0_D: "Zielspieler oder NPC",
  T_48_META_API_3233_P1_D: "Waffen-ID",
  T_48_META_API_3234_D: "Fügt dem Ziel Verstärkungen zu",
  T_48_META_API_3234_P0_D: "Ziel-Entität, muss eine Entität sein, der Buffs hinzugefügt werden können",
  T_48_META_API_3234_P1_D: "Büffel-ID",
  T_48_META_API_3235_D: "Stärkungszauber vom Ziel entfernen",
  T_48_META_API_3235_P0_D: "Ziel-Entität, muss eine Entität sein, der Buffs hinzugefügt werden können",
  T_48_META_API_3235_P1_D: "Büffel-ID",
  T_48_META_API_3236_D: "Ermittelt den aktuellen Buff des Ziels",
  T_48_META_API_3236_P0_D: "Ziel-Entität, muss eine Entität sein, der Buffs hinzugefügt werden können",
  T_48_META_API_3236_R_D: "Buff-Liste",
  T_48_META_API_3237_D: "Holt die Gegenstände aus der Requisitenleiste im Rucksack des Zielspielers.",
  T_48_META_API_3237_P0_D: "Zielspieler",
  T_48_META_API_3237_P1_D: "Requisitenliste",
  T_48_META_API_3238_D: "Hinzufügen von Zubehör zum angegebenen Steckplatz der Waffe; Zubehör, das nicht zum Steckplatz passt, schlägt fehl; passendes, aber doppeltes Zubehör ersetzt das ursprüngliche Zubehör, das ursprüngliche Zubehör wird in den Rucksack des Spielers geschickt,",
  T_48_META_API_3238_P0_D: "Zielspieler",
  T_48_META_API_3238_P1_D: "Geräteschlitz",
  T_48_META_API_3238_P2_D: "Ersatz (Teile)",
  T_48_META_API_3238_P3_D: `Ob das Accessoire erfolgreich hinzugefügt wurde oder nicht
 True: Das Accessoire wurde an der Waffe im entsprechenden Slot angebracht
 False: Das Accessoire konnte nicht hinzugefügt werden und erscheint nicht im Rucksack des Spielers`,
  T_48_META_API_3238_P4_D: "Zusätzliches Zubehör, null bei Fehlschlag",
  T_48_META_API_3239_D: 'Die Ausrüstung in der Spalte "Rucksackausrüstung" erhalten',
  T_48_META_API_3239_P0_D: "Zielspieler",
  T_48_META_API_3239_P1_D: "Geräteschlitz",
  T_48_META_API_3239_P2_D: "Ausrüstung auf dem angegebenen Steckplatz, leer, wenn nicht ausgestattet",
  T_48_META_API_3239_P3_D: "Alle Zubehörteile für dieses Gerät",
  T_48_META_API_3240_D: "Ein 2D-Vektor nimmt die x-Komponente",
  T_48_META_API_3240_P0_D: "zweidimensionaler Vektor",
  T_48_META_API_3240_R_D: "2D-Vektor x-Komponente",
  T_48_META_API_3241_D: "Zweidimensionale Vektoren haben die y-Komponente",
  T_48_META_API_3241_P0_D: "zweidimensionaler Vektor",
  T_48_META_API_3241_R_D: "Y-Komponente eines 2D-Vektors",
  T_48_META_API_3242_D: "2D-Vektoreinstellung x-Komponente",
  T_48_META_API_3242_P0_D: "zweidimensionaler Vektor",
  T_48_META_API_3242_P1_D: "2D-Vektor x-Komponente",
  T_48_META_API_3243_D: "2D-Vektor Einstellung y-Komponente",
  T_48_META_API_3243_P0_D: "zweidimensionaler Vektor",
  T_48_META_API_3243_P1_D: "Y-Komponente eines 2D-Vektors",
  T_48_META_API_3244_D: "Zwei 2D-Vektoren zusammenzählen",
  T_48_META_API_3244_P0_D: "linke Operand",
  T_48_META_API_3244_P1_D: "rechte Operand",
  T_48_META_API_3244_R_D: "2D-Vektorsummenergebnis",
  T_48_META_API_3245_D: "Subtraktion zweier 2D-Vektoren",
  T_48_META_API_3245_P0_D: "linke Operand",
  T_48_META_API_3245_P1_D: "rechte Operand",
  T_48_META_API_3245_R_D: "Ergebnis der 2D-Vektorsubtraktion",
  T_48_META_API_3246_D: "Multiplizieren Sie die zweidimensionalen Vektoren mit",
  T_48_META_API_3246_P0_D: "zweidimensionaler Vektor",
  T_48_META_API_3246_P1_D: "2D-Vektorskalierungswerte",
  T_48_META_API_3246_R_D: "Ergebnis der 2D-Vektormultiplikation",
  T_48_META_API_3247_D: "Punktweise Multiplikation zweier 2D-Vektoren; das Ergebnis der punktweisen Multiplikation ist ein Skalar, der den Winkel zwischen den beiden Vektoren beschreibt",
  T_48_META_API_3247_P0_D: "linke Operand",
  T_48_META_API_3247_P1_D: "rechte Operand",
  T_48_META_API_3247_R_D: "Ergebnis des Punktprodukts",
  T_48_META_API_3248_D: "Berechnen des euklidischen Abstands zwischen zwei 2D-Vektoren",
  T_48_META_API_3248_P0_D: "linke Operand",
  T_48_META_API_3248_P1_D: "rechte Operand",
  T_48_META_API_3248_R_D: "Nach der Subtraktion zweier Vektoren ist der Modulus des resultierenden Vektors",
  T_48_META_API_3249_D: "Berechnen des Winkels zwischen zwei 2D-Vektoren",
  T_48_META_API_3249_P0_D: "linke Operand",
  T_48_META_API_3249_P1_D: "rechte Operand",
  T_48_META_API_3249_R_D: "Vektorwinkel, Winkelbereich 0-180",
  T_48_META_API_3250_D: "Normalisieren des 2D-Vektors",
  T_48_META_API_3250_P0_D: "zweidimensionaler Vektor",
  T_48_META_API_3250_R_D: "Normalisiertes Ergebnis für Vektoren mit der Länge 1m in der gleichen Richtung wie der Vektor",
  T_48_META_API_3251_D: "Modellierung eines 2D-Vektors",
  T_48_META_API_3251_P0_D: "zweidimensionaler Vektor",
  T_48_META_API_3251_R_D: "Das Ergebnis der Modellierung in Form einer Vektorlänge",
  T_48_META_API_3252_D: "Berechnen des Vektors eines 2D-Vektors nach der Spiegelung an einer senkrechten Linie",
  T_48_META_API_3252_P0_D: "einfallender 2D-Vektor",
  T_48_META_API_3252_P1_D: "Normaler 2D-Vektor",
  T_48_META_API_3252_R_D: "Reflektierender 2D-Vektor",
  T_48_META_API_3253_D: "Berechnung von 3D-Vektoren nach Spiegelung an einer senkrechten Ebene",
  T_48_META_API_3253_P0_D: "einfallender 3D-Vektor",
  T_48_META_API_3253_P1_D: "Normaler 3D-Vektor",
  T_48_META_API_3253_R_D: "reflektierender 3D-Vektor",
  T_48_META_API_3254_D: "Umwandlung eines 3D-Vektors in einen 2D-Vektor, Entfernen der Z-Komponente des 3D-Vektors",
  T_48_META_API_3254_P0_D: "Ziel 3D-Vektor",
  T_48_META_API_3254_R_D: "Konvertierter 2D-Vektor",
  T_48_META_API_3255_D: "2D-Vektor zu 3D-Vektor, Z-Komponente des 3D-Vektors wird auf 0 gesetzt",
  T_48_META_API_3255_P0_D: "Ziel-2D-Vektor",
  T_48_META_API_3255_R_D: "Konvertierter 3D-Vektor",
  T_48_META_API_3256_D: "Erstellen eines 2D-Vektors",
  T_48_META_API_3256_P0_D: "Die x-Komponente eines 2D-Vektors",
  T_48_META_API_3256_P1_D: "Y-Komponente eines 2D-Vektors",
  T_48_META_API_3256_R_D: "Der erzeugte 2D-Vektor",
  T_48_META_API_3257_D: "Benutzerdefinierte Bestattungsprotokolle für die Analyse von Nutzererfahrungsdaten",
  T_48_META_API_3257_P0_D: "log",
  T_48_META_API_3258_D: "Benutzerdefinierte Bestattungsprotokolle für die Analyse von Nutzererfahrungsdaten",
  T_48_META_API_3258_P0_D: "Um gemeldete Spieler zu verfolgen",
  T_48_META_API_3258_P1_D: "log",
  T_48_META_API_33_D: "Filter für Schimpfwörter",
  T_48_META_API_33_P0_D: "Originaltext mit Schmutzwortfilterung",
  T_48_META_API_33_R_D: "Gefilterter Text",
  T_48_META_API_3301_D: "Eine Lagereinheit erstellen",
  T_48_META_API_3301_P0_D: "Gründung von Unternehmen",
  T_48_META_API_3302_D: "Zielperson schließt sich dem benannten Lager an",
  T_48_META_API_3302_P0_D: "Ziel Entität",
  T_48_META_API_3302_P1_D: "Gründung von Unternehmen",
  T_48_META_API_3303_D: "Lager für angreifbare Lager erhalten",
  T_48_META_API_3303_P0_D: "Angriffslager",
  T_48_META_API_3303_R_D: "Liste der Lagereinrichtungen",
  T_48_META_API_3304_D: "Angreifbare Lager zur Errichtung von Lagern",
  T_48_META_API_3304_P0_D: "Angriffslager",
  T_48_META_API_3304_P1_D: "Ziellager",
  T_48_META_API_3304_P2_D: "Angreifbarkeit",
  T_48_META_API_3305_D: "Angreifbare Spieler aufstellen",
  T_48_META_API_3305_P0_D: "Spieler",
  T_48_META_API_3305_P1_D: "Angreifbare Spieler",
  T_48_META_API_3305_P2_D: "Angreifbarkeit",
  T_48_META_API_3306_D: "Einstellung der angreifbaren Mannschaft",
  T_48_META_API_3306_P0_D: "Stoßtrupp",
  T_48_META_API_3306_P1_D: "Zielgruppe",
  T_48_META_API_3306_P2_D: "Angreifbarkeit",
  T_48_META_API_3307_D: "Verlassen",
  T_48_META_API_3307_P0_D: "Verlassen",
  T_48_META_API_3307_R_D: "Liste der Spieler-Entitäten",
  T_48_META_API_3308_D: "Rückzug der benannten Einrichtung aus dem aktuellen Lager",
  T_48_META_API_3308_P0_D: "Ziel Entität",
  T_48_META_API_3309_D: "Die Besitztümer des Ziels ermitteln",
  T_48_META_API_3309_P0_D: "Ziel Entität",
  T_48_META_API_3309_R_D: "Gründung von Unternehmen",
  T_48_META_API_3310_D: "Feststellen, ob das Ziel angegriffen werden kann",
  T_48_META_API_3310_P0_D: "Angreifer",
  T_48_META_API_3310_P1_D: "Ziel Entität",
  T_48_META_API_3310_R_D: "Angreifbarkeit",
  T_48_META_API_3311_D: "Einrichten der angreifbaren Ziele einer Entität",
  T_48_META_API_3311_P0_D: "Angreifer",
  T_48_META_API_3311_P1_D: "Ziel Entität",
  T_48_META_API_3311_P2_D: "Angreifbarkeit",
  T_48_META_API_3312_D: "Erfassung der angreifbaren Ziele eines Unternehmens",
  T_48_META_API_3312_P0_D: "Angreifer",
  T_48_META_API_3312_R_D: "Liste der angreifbaren Einheiten",
  T_48_META_API_34_D: "Ermitteln, ob eine Komponente für die Zielentität existiert",
  T_48_META_API_34_P0_D: "Ziel Entität",
  T_48_META_API_34_P1_D: "Bauteil-Typ",
  T_48_META_API_34_R_D: "Existiert es",
  T_48_META_API_35_D: "Bot hinzufügen",
  T_48_META_API_35_P0_D: "Bot-Schwierigkeitsgrad",
  T_48_META_API_35_P1_D: "Bots Team",
  T_48_META_API_35_P2_D: "Erstellte Bot-Spieler-Entität",
  T_48_META_API_3500_D: "Spieler-Token-Daten abrufen",
  T_48_META_API_3500_P0_D: "Zielspieler",
  T_48_META_API_3500_P1_D: "tokenID",
  T_48_META_API_3500_P2_D: "Anzahl der Token",
  T_48_META_API_3500_P3_D: "Erfolg oder Misserfolg",
  T_48_META_API_3501_D: "Hinzufügen von Token-Daten zum Player",
  T_48_META_API_3501_P0_D: "Zielspieler",
  T_48_META_API_3501_P1_D: "tokenID",
  T_48_META_API_3501_P2_D: "Anzahl der Token",
  T_48_META_API_3501_P3_D: "Ob der Block erfolgreich aufgerufen wurde oder nicht",
  T_48_META_API_3502_D: "Zielspielermarke verbrauchen",
  T_48_META_API_3502_P0_D: "Zielspieler",
  T_48_META_API_3502_P1_D: "tokenID",
  T_48_META_API_3502_P2_D: "Anzahl der Token",
  T_48_META_API_3502_P3_D: "ob das Tupel erfolgreich aufgerufen wurde oder nicht",
  T_48_META_API_3503_D: "Hinzufügen eines Tokens an den angegebenen Ort",
  T_48_META_API_3503_P0_D: "Platzierung",
  T_48_META_API_3503_P1_D: "tokenID",
  T_48_META_API_3503_P2_D: "Anzahl der Token",
  T_48_META_API_3503_P3_D: "ob das Tupel erfolgreich aufgerufen wurde oder nicht",
  T_48_META_API_3504_D: "Die Ziel-KI gibt die angegebene Fähigkeit frei",
  T_48_META_API_3504_P0_D: "Ziel-KI",
  T_48_META_API_3504_P1_D: "Technik",
  T_48_META_API_3504_P2_D: "Qualifikationsziel",
  T_48_META_API_3504_P3_D: "ob die Fähigkeit erfolgreich freigesetzt wird oder nicht",
  T_48_META_API_3505_D: "Erstellt Pfadfindungspfade von Anfang bis Ende, die Blöcke umgehen und für die KI-Pfadfindung verwendet werden können",
  T_48_META_API_3505_P0_D: "Koordinaten des Ausgangspunkts",
  T_48_META_API_3505_P1_D: "Koordinaten des Ziels",
  T_48_META_API_3505_P2_D: "ob der Pfadfindungspfad erfolgreich erstellt wurde oder nicht",
  T_48_META_API_3505_P3_D: "Pfadfindungspunkt Montage",
  T_48_META_API_3506_D: "Einstellung der Blackboard-Variable Behaviour Tree",
  T_48_META_API_3506_P0_D: "Ziel-Verhaltensbaum",
  T_48_META_API_3506_P1_D: "Variablenname",
  T_48_META_API_3506_P2_D: "variabler Wert",
  T_48_META_API_3507_D: "Abrufen der Variablen für die Verhaltensbaumtafel",
  T_48_META_API_3507_P0_D: "Ziel-Verhaltensbaum",
  T_48_META_API_3507_P1_D: "Variablenname",
  T_48_META_API_3507_P2_D: "variabler Wert",
  T_48_META_API_3508_D: "Parameter für Verhaltensbaumknoten abrufen",
  T_48_META_API_3508_P0_D: "Zielverhalten Baumknoten",
  T_48_META_API_3508_P1_D: "Parametername",
  T_48_META_API_3508_P2_D: "Parameterwert",
  T_48_META_API_3509_D: "Holen Sie sich den Träger-Skin des Zielspielers",
  T_48_META_API_3509_P0_D: "Zielspieler",
  T_48_META_API_3509_P1_D: "Träger-ID",
  T_48_META_API_3509_R_D: "Träger Skin",
  T_48_META_API_3510_D: "Einstellen des Trägerskins des Zielspielers",
  T_48_META_API_3510_P0_D: "Zielspieler",
  T_48_META_API_3510_P1_D: "Träger Skin ID",
  T_48_META_API_3511_D: "Löschen Sie die Haut des angegebenen Fahrzeugs des Zielspielers",
  T_48_META_API_3511_P0_D: "Zielspieler",
  T_48_META_API_3511_P1_D: "Träger-ID",
  T_48_META_API_3512_D: "Den Standard-Träger-Skin des Zielspielers wiederherstellen",
  T_48_META_API_3512_P0_D: "Zielspieler",
  T_48_META_API_3512_P1_D: "Träger-ID",
  T_48_META_API_36_D: "Ruhendes Ziel, kann nur für Starrkörper vom Typ Dynamisch verwendet werden.",
  T_48_META_API_36_P0_D: "starrer Zielkörper",
  T_48_META_API_37_D: "Ziel aufwecken, kann nur bei starren Körpern vom Typ Dynamisch verwendet werden.",
  T_48_META_API_37_P0_D: "starrer Zielkörper",
  T_48_META_API_38_D: "Prüfen, ob der Ziel-Starrkörper inaktiv ist",
  T_48_META_API_38_P0_D: "starrer Zielkörper",
  T_48_META_API_38_R_D: "Ob es sich im Winterschlaf befindet oder nicht",
  T_48_META_API_39_D: "Einstellung der Ruhezustandsschwelle",
  T_48_META_API_39_P0_D: "starrer Zielkörper",
  T_48_META_API_39_P1_D: "Dormant Schwelle, die Bewegung und Rotation des starren Körpers ist weniger als dieser Wert für einen Zeitraum von Zeit, um den ruhenden Zustand, den ruhenden Zustand des starren Körpers wird nicht mehr die Durchführung von physikalischen Berechnungen",
  T_48_META_API_4_D: "Festlegen, ob alle Spieler sich bewegen können",
  T_48_META_API_4_P0_D: `Richtig: kann verschoben werden 
 Falsch: kann nicht verschoben werden`,
  T_48_META_API_40_D: "Schwellenwert für den Ruhezustand abrufen",
  T_48_META_API_40_P0_D: "starrer Zielkörper",
  T_48_META_API_40_R_D: "Dormant Schwelle, die Bewegung und Rotation des starren Körpers ist weniger als dieser Wert für einen Zeitraum von Zeit, um den ruhenden Zustand, den ruhenden Zustand des starren Körpers wird nicht mehr die Durchführung von physikalischen Berechnungen",
  T_48_META_API_4000_D: "Liest den Inhalt der gesamten Tabelle und gibt ein zweidimensionales Array in Zeilenreihenfolge zurück",
  T_48_META_API_4000_P0_D: "Tabellenname",
  T_48_META_API_4000_R_D: "Inhalt der Tabelle",
  T_48_META_API_4001_D: "Liest eine Zeile einer Tabelle und gibt ein Array zurück",
  T_48_META_API_4001_P0_D: "Tabellenname",
  T_48_META_API_4001_P1_D: "Anzahl der zu lesenden Zeilen, von 1 an gerechnet",
  T_48_META_API_4001_R_D: "Tabelle gibt den Inhalt einer Zeile an",
  T_48_META_API_4002_D: "Liest den Inhalt einer Spalte einer Tabelle und gibt ein Array zurück",
  T_48_META_API_4002_P0_D: "Tabellenname",
  T_48_META_API_4002_P1_D: "Anzahl der zu lesenden Spalten, von 1 an gerechnet",
  T_48_META_API_4002_R_D: "Tabelle gibt den Inhalt einer Spalte an",
  T_48_META_API_4003_D: "Lesen des Inhalts einer Zelle in einer Tabelle",
  T_48_META_API_4003_P0_D: "Tabellenname",
  T_48_META_API_4003_P1_D: "Anzahl der zu lesenden Zeilen, von 1 an gerechnet",
  T_48_META_API_4003_P2_D: "Anzahl der zu lesenden Spalten, von 1 an gerechnet",
  T_48_META_API_4003_R_D: "Der Inhalt der angegebenen Zelle in der Tabelle",
  T_48_META_API_4004_D: "Lesen des Inhalts einer Zelle in einer Tabelle nach Zeilen- und Spaltennamen",
  T_48_META_API_4004_P0_D: "Tabellenname",
  T_48_META_API_4004_P1_D: "Anzahl der zu lesenden Zeilen, von 1 an gerechnet",
  T_48_META_API_4004_P2_D: "Der Name der zu lesenden Spalte",
  T_48_META_API_4004_R_D: "Der Inhalt der angegebenen Zelle in der Tabelle",
  T_48_META_API_4005_D: "Liest den Inhalt der gesamten Tabelle und gibt ein zweidimensionales Array zurück",
  T_48_META_API_4005_P0_D: "Tabellenname",
  T_48_META_API_4005_R_D: "Der Inhalt der Tabelle, ein zweidimensionales Array",
  T_48_META_API_4006_D: "Liest eine Zeile einer Tabelle und gibt ein Array zurück.",
  T_48_META_API_4006_P0_D: "Tabellenname",
  T_48_META_API_4006_P1_D: "Anzahl der zu lesenden Zeilen, von 1 an gerechnet",
  T_48_META_API_4006_R_D: "Tabelle gibt den Inhalt einer Zeile an, ein Array",
  T_48_META_API_4007_D: "Lesen des Inhalts einer Spalte der gesamten Tabelle, Rückgabe eines Arrays",
  T_48_META_API_4007_P0_D: "Tabellenname",
  T_48_META_API_4007_P1_D: "Anzahl der zu lesenden Spalten, von 1 an gerechnet",
  T_48_META_API_4007_R_D: "Tabelle spezifiziert den Inhalt einer Spalte, eines Arrays",
  T_48_META_API_4008_D: "Lesen des Inhalts einer Zelle in einer Tabelle",
  T_48_META_API_4008_P0_D: "Tabellenname",
  T_48_META_API_4008_P1_D: "Anzahl der zu lesenden Zeilen, von 1 an gerechnet",
  T_48_META_API_4008_P2_D: "Anzahl der zu lesenden Spalten, von 1 an gerechnet",
  T_48_META_API_4008_R_D: "Der Inhalt der angegebenen Zelle in der Tabelle",
  T_48_META_API_4009_D: "Findet die angegebene Zeile anhand der Anzahl der Spalten und des Wertes der Zelle.",
  T_48_META_API_4009_P0_D: "Tabellenname",
  T_48_META_API_4009_P1_D: "Anzahl der zu lesenden Spalten",
  T_48_META_API_4009_P2_D: "Zu suchender Zellenwert",
  T_48_META_API_4009_R_D: "Inhalt der gefundenen Zeilen, Array",
  T_48_META_API_4010_D: "Spaltennummer nach Spaltenname abrufen",
  T_48_META_API_4010_P0_D: "Tabellenname",
  T_48_META_API_4010_P1_D: "Name der Spalte für die Suche nach der Seriennummer",
  T_48_META_API_4010_R_D: "Spalten, gezählt von 1",
  T_48_META_API_41_D: "Legt den globalen Schwellenwert für den Ruhezustand fest, der nur für neu erzeugte Starrkörper des Typs Dynamisch gilt.",
  T_48_META_API_41_P0_D: "Dormant Schwelle, die Bewegung und Rotation des starren Körpers ist weniger als dieser Wert für einen Zeitraum von Zeit, um den ruhenden Zustand, den ruhenden Zustand des starren Körpers wird nicht mehr die Durchführung von physikalischen Berechnungen",
  T_48_META_API_42_D: "Globalen Schwellenwert für den Ruhezustand abrufen",
  T_48_META_API_42_R_D: "Dormant Schwellenwert, Standardwert ist 0,005, die Bewegung und Rotation des starren Körpers ist weniger als dieser Wert für einen Zeitraum von Zeit, um den ruhenden Zustand, der ruhenden starren Körper wird nicht mehr durchführen physikalischen Berechnun",
  T_48_META_API_43_D: "Konvertiert die gegebene Quaternion in einen Euler-Winkel, die Rotationsordnung des Euler-Winkels ist YXZ, wenn die eingehende Quaternion nicht legal ist, wird (0,0,0) zurückgegeben",
  T_48_META_API_43_P0_D: "Die eingegebene Quaternion",
  T_48_META_API_43_R_D: "Zurückgegebene Euler-Winkel",
  T_48_META_API_44_D: "Umwandlung eines gegebenen Euler-Winkels in ein Quaternion",
  T_48_META_API_44_P0_D: "Eingabe Euler-Winkel",
  T_48_META_API_44_R_D: "Zurückgegebenes Quaternion",
  T_48_META_API_45_D: "Umwandlung von Drehungen der Achsenwinkeldarstellungen in Quaternionen",
  T_48_META_API_45_P0_D: "Drehachse",
  T_48_META_API_45_P1_D: "Winkel der Drehung im Uhrzeigersinn um die Drehachse",
  T_48_META_API_45_R_D: "Zurückgegebenes Quaternion",
  T_48_META_API_46_D: "Umwandlung von Quaternionen in Achsenwinkeldarstellungen",
  T_48_META_API_46_P0_D: "Die eingegebene Quaternion",
  T_48_META_API_46_P1_D: "Drehachse",
  T_48_META_API_46_P2_D: "Winkel der Drehung im Uhrzeigersinn um die Drehachse",
  T_48_META_API_47_D: "Einrichten eines benutzerdefinierten Fortschritts der Aufgabenerledigung",
  T_48_META_API_47_P0_D: "Zielspieler",
  T_48_META_API_47_P1_D: "Aufgaben-ID",
  T_48_META_API_47_P2_D: "Fortschritte bei der Fertigstellung, keine negativen Zahlen erlaubt",
  T_48_META_API_48_D: "Erzeugt eine Bezier-Kurve, die zur Interpolation von Bewegungen verwendet werden kann",
  T_48_META_API_48_P0_D: "Kurvenkontrollpunkt",
  T_48_META_API_48_R_D: "Bessel-Kurve",
  T_48_META_API_49_D: "Szenenabbild-ID abrufen",
  T_48_META_API_49_P0_D: "Szene-ID",
  T_48_META_API_49_R_D: "Karten-ID",
  T_48_META_API_5_D: "Löschen platzierter Objekte in der Szene (veraltet, verwenden Sie DeleteEntity)",
  T_48_META_API_5_P0_D: "Zu löschende Objekteinheiten",
  T_48_META_API_50_D: "Erzeugt in jedem Frame eine Bewegung relativ zu sich selbst, wobei das Zielobjekt seine eigenen Attribute einmal pro Frame ändert, jedes Mal relativ zu seinen aktuellen Attributwerten",
  T_48_META_API_50_P0_D: "Ziel Entität",
  T_48_META_API_50_P1_D: "Eigenschaften, die Bewegungsänderungen erfordern",
  T_48_META_API_50_P2_D: "Betrag der Veränderung pro Bewegung",
  T_48_META_API_50_P3_D: `Konfiguration bei Verwendung in Kombination mit anderen Bewegungsarten
 Richtig: kann in Kombination mit relativer Bewegung verwendet werden
 Falsch: kann in Kombination mit absoluter Bewegung verwendet werden`,
  T_48_META_API_50_P4_D: "Erstellte Bewegungseinheiten pro Frame relativ zu sich selbst",
  T_48_META_API_50_P5_D: "Ob die Wiedergabe nach der Erstellung automatisch beginnt",
  T_48_META_API_5000_D: "Lesen des Wertes, der einem Schlüssel in einer Tabelle in der Datenbank entspricht.",
  T_48_META_API_5000_P0_D: "Tabellennamen in der Datenbank",
  T_48_META_API_5000_P1_D: "Markierung von Spielern, Handhabung von Gleichzeitigkeit",
  T_48_META_API_5000_P2_D: "Benutzerdefinierter Name, der zur Identifizierung der Daten verwendet wird",
  T_48_META_API_5000_P3_D: "Gibt das Ergebnis der Lesung zurück",
  T_48_META_API_5000_P4_D: "Schlachtfeldcode, der der Datenbank entspricht",
  T_48_META_API_5001_D: "Schreiben Sie den Wert, der einem Schlüssel in einer Tabelle in der Datenbank entspricht.",
  T_48_META_API_5001_P0_D: "Tabellennamen in der Datenbank",
  T_48_META_API_5001_P1_D: "Markierung von Spielern, Handhabung von Gleichzeitigkeit",
  T_48_META_API_5001_P2_D: "Benutzerdefinierter Name, der zur Identifizierung der Daten verwendet wird",
  T_48_META_API_5001_P3_D: "Geschriebener Wert",
  T_48_META_API_5001_P4_D: "Der der Datenbank entsprechende Schlachtfeldcode, der in Leerzeichen ausgefüllt werden kann, stellt den Schlachtfeldcode der aktuellen Karte dar",
  T_48_META_API_5002_D: "Löschen Sie den Wert, der einem Schlüssel in einer Tabelle in der Datenbank entspricht.",
  T_48_META_API_5002_P0_D: "Tabellennamen in der Datenbank",
  T_48_META_API_5002_P1_D: "Markierung von Spielern, Handhabung von Gleichzeitigkeit",
  T_48_META_API_5002_P2_D: "Benutzerdefinierter Name, der zur Identifizierung der Daten verwendet wird",
  T_48_META_API_5002_P3_D: "Schlachtfeldcode, der der Datenbank entspricht",
  T_48_META_API_5003_D: "Abrufen des Wertes eines Schlüssels in einer Tabelle der Datenbank.",
  T_48_META_API_5003_P0_D: "Name der Leaderboard-Tabelle in der Datenbank",
  T_48_META_API_5003_P1_D: "Benutzerdefinierter Name, der zur Identifizierung der Daten verwendet wird",
  T_48_META_API_5003_P2_D: "Gibt das Ergebnis der Lesung zurück",
  T_48_META_API_5003_P3_D: "Schlachtfeldcode, der der Datenbank entspricht",
  T_48_META_API_5004_D: "Schreiben Sie den Wert, der einem Schlüssel in einer der Diagrammtabellen in der Datenbank entspricht.",
  T_48_META_API_5004_P0_D: "Name der Leaderboard-Tabelle in der Datenbank",
  T_48_META_API_5004_P1_D: "Benutzerdefinierter Name, der zur Identifizierung der Daten verwendet wird",
  T_48_META_API_5004_P2_D: "Geschriebener Wert",
  T_48_META_API_5004_P3_D: "Schlachtfeldcode, der der Datenbank entspricht",
  T_48_META_API_5005_D: "Löschen Sie den Wert, der einem Schlüssel in einer Diagrammtabelle in der Datenbank entspricht.",
  T_48_META_API_5005_P0_D: "Tabellennamen in der Datenbank",
  T_48_META_API_5005_P1_D: "Benutzerdefinierter Name, der zur Identifizierung der Daten verwendet wird",
  T_48_META_API_5005_P2_D: "Schlachtfeldcode, der der Datenbank entspricht",
  T_48_META_API_5006_D: "Löschen Sie den Wert, der einem Rang in einer Rangtabelle in der Datenbank entspricht.",
  T_48_META_API_5006_P0_D: "Tabellennamen in der Datenbank",
  T_48_META_API_5006_P1_D: "Rangfolge in der Rangliste",
  T_48_META_API_5006_P2_D: "Schlachtfeldcode, der der Datenbank entspricht",
  T_48_META_API_5007_D: "Lesen Sie die Werte von einem bestimmten Rang bis zu einem bestimmten Rang in einer Diagrammtabelle in der Datenbank.",
  T_48_META_API_5007_P0_D: "Tabellennamen in der Datenbank",
  T_48_META_API_5007_P1_D: "Ausgangsposition",
  T_48_META_API_5007_P2_D: "Zielposition",
  T_48_META_API_5007_P3_D: "Gibt das Ergebnis der Lesung zurück",
  T_48_META_API_5007_P4_D: "Schlachtfeldcode, der der Datenbank entspricht",
  T_48_META_API_5008_D: "Lesen des Wertes, der einem Schlüssel in einer Tabelle der kumulativen Datenbank entspricht.",
  T_48_META_API_5008_P0_D: "Tabellennamen in der Datenbank",
  T_48_META_API_5008_P1_D: "Benutzerdefinierter Name, der zur Identifizierung der Daten verwendet wird",
  T_48_META_API_5008_P2_D: "Gibt das Ergebnis der Lesung zurück",
  T_48_META_API_5008_P3_D: "Schlachtfeldcode, der der Datenbank entspricht",
  T_48_META_API_5009_D: "Schreiben des einem Schlüssel entsprechenden Offset-Wertes in eine Tabelle der kumulativen Datenbank",
  T_48_META_API_5009_P0_D: "Tabellennamen in der Datenbank",
  T_48_META_API_5009_P1_D: "Benutzerdefinierter Name, der zur Identifizierung der Daten verwendet wird",
  T_48_META_API_5009_P2_D: "Die Typen der vier Operationen unterstützen derzeit die folgenden Typen: Typ Int unterstützt Addition, Subtraktion, Multiplikation, Division und Rest; Typ Float unterstützt Addition, Subtraktion, Multiplikation und Division",
  T_48_META_API_5009_P3_D: "Offsetwert geschrieben",
  T_48_META_API_5009_P4_D: "Schlachtfeldcode, der der Datenbank entspricht",
  T_48_META_API_51_D: "Abspielbare Entität zurücksetzen, setzt die abspielbare Entität in ihre ursprüngliche Form zurück, ohne den Abspielstatus zu ändern",
  T_48_META_API_51_P0_D: "Ziel spielbare Entität",
  T_48_META_API_52_D: "Die Multiplikation zweier Quaternionen, A*B, bedeutet, dass zuerst A und dann B gedreht wird.",
  T_48_META_API_52_P0_D: "linkswertiges Quaternion",
  T_48_META_API_52_P1_D: "rechtswertiges Quaternion",
  T_48_META_API_52_R_D: "Resultierende Quaternion",
  T_48_META_API_53_D: "Erzeugt ein rotierendes Quaternion, das in eine bestimmte Richtung zeigt",
  T_48_META_API_53_P0_D: "Richtung angeben",
  T_48_META_API_53_P1_D: "nach oben",
  T_48_META_API_53_R_D: "Der Betrag der Drehung, der erforderlich ist, um sich in der angegebenen Richtung auszurichten.",
  T_48_META_API_54_D: "Quaternionische sphärische Interpolation von A nach B",
  T_48_META_API_54_P0_D: "A-Wert",
  T_48_META_API_54_P1_D: "B-Wert",
  T_48_META_API_54_P2_D: "Interpolationsfortschritt, der Wertebereich [0,1], der Wert 0 für die Rückkehr zum Anfang des Wertes, der Wert 1 für die Rückkehr zum Zielwert",
  T_48_META_API_54_R_D: "Resultierende Quaternion",
  T_48_META_API_57_D: "Gibt die Zieldaten als Warnung auf der Konsole aus",
  T_48_META_API_57_P0_D: "Was zu drucken ist",
  T_48_META_API_58_D: "Gibt die Zieldaten als Fehlermeldung auf der Konsole aus.",
  T_48_META_API_58_P0_D: "Was zu drucken ist",
  T_48_META_API_59_D: "Ermittlung des Wertes auf der Kurve",
  T_48_META_API_59_P0_D: "auf Umwegen",
  T_48_META_API_59_P1_D: "Abtastpunkt, Wertebereich [0,1]",
  T_48_META_API_59_R_D: "am Ende",
  T_48_META_API_6_D: "Erzeugt Szenenobjekte zu den angegebenen Koordinaten",
  T_48_META_API_6_P0_D: "Erstellte Szenenobjekt-Elemente",
  T_48_META_API_6_P1_D: "Standort der Objekterzeugung",
  T_48_META_API_6_P2_D: "Die ID des erstellten Objekttyps, der für die Verwendung in Codeskripten zuvor in der Asset-Registrierung registriert werden muss.",
  T_48_META_API_60_D: "Interpolation auf der Grundlage von Kurven",
  T_48_META_API_60_P0_D: "Werttyp",
  T_48_META_API_60_P1_D: "Startwert",
  T_48_META_API_60_P2_D: "Zielwert",
  T_48_META_API_60_P3_D: "auf Umwegen",
  T_48_META_API_60_P4_D: "Abtastpunkt, Wertebereich [0,1]",
  T_48_META_API_60_R_D: "am Ende",
  T_48_META_API_6000_D: "Hinzufügen von Skripten zu Zielentitäten",
  T_48_META_API_6000_P0_D: "Ziel Entität",
  T_48_META_API_6000_P1_D: "Skript-ID",
  T_48_META_API_6001_D: "Entladen von Skripten für Zielentitäten",
  T_48_META_API_6001_P0_D: "Ziel Entität",
  T_48_META_API_6001_P1_D: "Skript-ID",
  T_48_META_API_6002_D: "Prüft, ob das angegebene Skript für die Zielentität existiert",
  T_48_META_API_6002_P0_D: "Ziel Entität",
  T_48_META_API_6002_P1_D: "Skript-ID",
  T_48_META_API_6002_R_D: "Vorhandensein des angegebenen Skripts",
  T_48_META_API_61_D: "Einstellen des übergeordneten Knotens eines UI-Controls",
  T_48_META_API_61_P0_D: "Übergeordneter Knoten, kann UI-Control oder benutzerdefinierte UI angeben",
  T_48_META_API_61_P1_D: "Kindknoten",
  T_48_META_API_62_D: "Verlassen",
  T_48_META_API_62_P0_D: "Verlassen",
  T_48_META_API_62_P1_D: "Verlassen",
  T_48_META_API_62_P2_D: "Verlassen",
  T_48_META_API_62_P3_D: "Verlassen",
  T_48_META_API_62_P4_D: "Verlassen",
  T_48_META_API_63_D: "Erstellen eines Strahls von der aktuellen Kamera zum Berührungspunkt des Bildschirms",
  T_48_META_API_63_P0_D: "Bildschirmkontakt",
  T_48_META_API_63_P1_D: "Schwellenwert",
  T_48_META_API_63_P2_D: "Strahlenrichtung",
  T_48_META_API_64_D: "Hochladen individueller Rechnungsinformationen",
  T_48_META_API_64_P0_D: "Spielereinheit",
  T_48_META_API_64_P1_D: "Ergebnisse eines Wettbewerbs",
  T_48_META_API_64_P2_D: "Integraler Titel (Rechnen)",
  T_48_META_API_64_P3_D: "Punktwert",
  T_48_META_API_65_D: "Spielen Sie den angegebenen Soundeffekt ab und legen Sie seine Entity-Eigenschaften fest, wenn Sie weitere Eigenschaften einstellen möchten.",
  T_48_META_API_65_P0_D: "Erstellte Klangkörper",
  T_48_META_API_65_P1_D: "Zielspieler, nur der Zielspieler kann die Soundeffekte hören",
  T_48_META_API_65_P2_D: "Art des Soundeffekts",
  T_48_META_API_65_P3_D: "Typ der Schleife",
  T_48_META_API_65_P4_D: "Ob sofort spielen oder nicht",
  T_48_META_API_66_D: "Erzeugt den angegebenen visuellen Effekt und legt seine Entitätseigenschaften fest, wenn es noch weitere Eigenschaften gibt, die festgelegt werden müssen.",
  T_48_META_API_66_P0_D: "Erstellte Spezialeffekte",
  T_48_META_API_66_P1_D: "Gezielte Spieler, sichtbar nur für gezielte Spieler",
  T_48_META_API_66_P2_D: "Art des Spezialeffekts",
  T_48_META_API_66_P3_D: "Typ der Schleife",
  T_48_META_API_66_P4_D: "Ob sofort spielen oder nicht",
  T_48_META_API_67_D: "Erzeugt den angegebenen Soundeffekt und legt seine Entity-Eigenschaften fest, falls es noch weitere Eigenschaften gibt, die festgelegt werden müssen.",
  T_48_META_API_67_P0_D: "Erstellte Klangkörper",
  T_48_META_API_67_P1_D: "Art des Soundeffekts",
  T_48_META_API_67_P2_D: "Typ der Schleife",
  T_48_META_API_67_P3_D: "Ob sofort spielen oder nicht",
  T_48_META_API_68_D: "Weltkoordinaten in Bildschirmkoordinaten umgerechnet",
  T_48_META_API_68_P0_D: "Weltkoordinate",
  T_48_META_API_68_P1_D: "ob es innerhalb des Bildschirms abgebildet ist oder nicht",
  T_48_META_API_68_P2_D: "Mapping-Position",
  T_48_META_API_69_D: "Bildschirmkoordinaten in Weltkoordinaten",
  T_48_META_API_69_P0_D: "Bildschirmkoordinate",
  T_48_META_API_69_P1_D: "Entfernung vom Bildschirm",
  T_48_META_API_69_P2_D: "Weltkoordinate",
  T_48_META_API_7_D: "Zielwert in String umwandeln",
  T_48_META_API_7_P0_D: "Zielwert der zu konvertierenden Zeichenkette",
  T_48_META_API_7_R_D: "string",
  T_48_META_API_70_D: "Die Strahlenerkennung durch Berührung des Bildschirms liefert das erste getroffene Objekt",
  T_48_META_API_70_P0_D: "Startbildschirm Kontakte",
  T_48_META_API_70_P1_D: "Erkennungsabstand",
  T_48_META_API_70_P2_D: "Ebenenmaske, nur gefüllte Ebenen werden gescannt, bleibt sie leer, werden alle Ebenen gescannt",
  T_48_META_API_70_P3_D: "Ob der Auslöser erkannt werden kann",
  T_48_META_API_70_P4_D: "Trefferobjekt",
  T_48_META_API_70_P5_D: "Trefferpunktkoordinaten",
  T_48_META_API_70_P6_D: "Entfernung des Trefferpunkts vom Startpunkt",
  T_48_META_API_70_P7_D: "die Oberflächennormale treffen",
  T_48_META_API_71_D: "Strahlenerkennung durch Bildschirmberührung, liefert alle getroffenen Objekte",
  T_48_META_API_71_P0_D: "Startbildschirm Kontakte",
  T_48_META_API_71_P1_D: "Erkennungsabstand",
  T_48_META_API_71_P2_D: "Ebenenmaske, nur gefüllte Ebenen werden gescannt, bleibt sie leer, werden alle Ebenen gescannt",
  T_48_META_API_71_P3_D: "Ob der Auslöser erkannt werden kann",
  T_48_META_API_71_P4_D: "Liste der getroffenen Einrichtungen",
  T_48_META_API_71_P5_D: "Liste der Trefferpunktkoordinaten",
  T_48_META_API_71_P6_D: "Liste der Entfernungen zwischen dem Trefferpunkt und dem Startpunkt",
  T_48_META_API_71_P7_D: "Liste der getroffenen Oberflächennormalen",
  T_48_META_API_72_D: "Erzeugt den angegebenen visuellen Effekt und legt seine Entitätseigenschaften fest, wenn es noch weitere Eigenschaften gibt, die festgelegt werden müssen.",
  T_48_META_API_72_P0_D: "Erstellte Spezialeffekte",
  T_48_META_API_72_P1_D: "Art des Spezialeffekts",
  T_48_META_API_72_P2_D: "Typ der Schleife",
  T_48_META_API_72_P3_D: "Ob sofort spielen oder nicht",
  T_48_META_API_73_D: "Erstellen einer integrierten Benutzeroberfläche, die nicht mit anderen Clients synchronisiert wird",
  T_48_META_API_73_P0_D: "Eingebaute UI-Entitäten erstellt",
  T_48_META_API_73_P1_D: "Eingebaute UI-Typen",
  T_48_META_API_74_D: "Erstellen einer benutzerdefinierten Benutzeroberfläche, die nicht mit anderen Clients synchronisiert wird",
  T_48_META_API_74_P0_D: "Benutzerdefinierte UI-Entitäten erstellt",
  T_48_META_API_74_P1_D: "Benutzerdefinierter UI-Index",
  T_48_META_API_75_D: "Abrufen des entsprechenden Spielers des aktuellen Kunden",
  T_48_META_API_75_R_D: "Spielereinheit",
  T_48_META_API_76_D: "Erstellen von AI-Monstern",
  T_48_META_API_76_P0_D: "Ziel-KI",
  T_48_META_API_76_P1_D: "Standort erstellen",
  T_48_META_API_76_P2_D: "AI-Typ",
  T_48_META_API_76_P3_D: "angegliedertes Team",
  T_48_META_API_76_P4_D: "ob der Feind automatisch beansprucht werden soll oder nicht",
  T_48_META_API_76_P5_D: "Angriffsmodus",
  T_48_META_API_76_P6_D: "Reiseroute",
  T_48_META_API_77_D: "Setzen der ersten Komponente des Vektors",
  T_48_META_API_77_P0_D: "Vektoren",
  T_48_META_API_77_P1_D: "Erster Komponentenwert",
  T_48_META_API_77_R_D: "Vektor nach Änderung der ersten Komponente",
  T_48_META_API_78_D: "Legen Sie die zweite Komponente des Vektors fest",
  T_48_META_API_78_P0_D: "Vektoren",
  T_48_META_API_78_P1_D: "Zweiter Komponentenwert",
  T_48_META_API_78_R_D: "Vektor nach Änderung der zweiten Komponente",
  T_48_META_API_79_D: "Legen Sie die dritte Komponente des Vektors fest",
  T_48_META_API_79_P0_D: "Vektoren",
  T_48_META_API_79_P1_D: "Wert der dritten Komponente",
  T_48_META_API_79_R_D: "Vektor nach Änderung der dritten Komponente",
  T_48_META_API_8_D: "Öffnen Sie die Sicherheitszone, die sich auf den mittleren Koordinatenpunkt verkleinert.",
  T_48_META_API_8_P0_D: "Zentraler Punkt der Sicherheitszone",
  T_48_META_API_8_P1_D: "Radius der Sicherheitszone",
  T_48_META_API_8_P2_D: "Wartezeit in Sekunden, nach deren Ablauf die Sicherheitszone in Richtung des Mittelpunkts zu schrumpfen beginnt",
  T_48_META_API_8_P3_D: "Zeit, die benötigt wird, um die Sicherheitszone auf den Mittelpunkt zu verkleinern, in Sekunden",
  T_48_META_API_8_P4_D: "Höhe des Schadens pro Sekunde, der außerhalb der Sicherheitszone erlitten wird",
  T_48_META_API_80_D: "Setzen der ersten Komponente des 2D-Vektors",
  T_48_META_API_80_P0_D: "zweidimensionaler Vektor",
  T_48_META_API_80_P1_D: "Erster Komponentenwert",
  T_48_META_API_80_R_D: "Der 2D-Vektor nach Änderung der ersten Komponente",
  T_48_META_API_81_D: "Setzen der zweiten Komponente des 2D-Vektors",
  T_48_META_API_81_P0_D: "zweidimensionaler Vektor",
  T_48_META_API_81_P1_D: "Zweiter Komponentenwert",
  T_48_META_API_81_R_D: "Der 2D-Vektor nach Änderung der zweiten Komponente",
  T_48_META_API_82_D: "Bewegt den Charakter-Controller an die angegebene Stelle. Wirkt er auf den Spieler, muss dieser den Player-Controller einschalten, der den Physikeffekt verwendet, damit er wirksam wird.",
  T_48_META_API_82_P0_D: "Zielrolle Controller",
  T_48_META_API_82_P1_D: "vorgesehener Ort",
  T_48_META_API_83_D: "Abrufen des angegebenen untergeordneten Knotens der übergeordneten Zielentität nach Namen",
  T_48_META_API_83_P0_D: "Muttergesellschaft",
  T_48_META_API_83_P1_D: "Name des Unterknotens",
  T_48_META_API_83_R_D: "untergeordnete Einheit",
  T_48_META_API_84_D: "AOI besondere Aufmerksamkeit schenken und unabhängig von der Entfernung immer synchronisieren",
  T_48_META_API_84_P0_D: "Ziele für besondere Aufmerksamkeit",
  T_48_META_API_84_P1_D: "Beobachter",
  T_48_META_API_85_D: "Entfernen Sie die AOI-Sonderbehandlung und brechen Sie die AOI-Synchronisierung außerhalb des Sichtbereichs ab.",
  T_48_META_API_85_P0_D: "Ziele für besondere Aufmerksamkeit",
  T_48_META_API_85_P1_D: "Beobachter",
  T_48_META_API_86_D: "Beseitigt alle AOI-Sonderprobleme für das angegebene Ziel.",
  T_48_META_API_86_P0_D: "Ziele für besondere Aufmerksamkeit",
  T_48_META_API_87_D: "Feststellen, ob ein AOI von besonderem Interesse ist",
  T_48_META_API_87_P0_D: "Ziele für besondere Aufmerksamkeit",
  T_48_META_API_87_P1_D: "Verlassen",
  T_48_META_API_87_R_D: "Existiert es",
  T_48_META_API_88_D: "Umschalten des Proxy-Beobachters des Spielers",
  T_48_META_API_88_P0_D: "Spieler",
  T_48_META_API_88_P1_D: "stellvertretender Beobachter",
  T_48_META_API_89_D: "Verschiebt den Charakter-Controller einmal, und wenn er auf den Spieler einwirkt, muss der Spieler den Spieler-Controller einschalten, der den Physikeffekt verwendet, damit er wirksam wird",
  T_48_META_API_89_P0_D: "Das Zielobjekt, oder im Falle eines Spielers, der Spieler muss einen Player-Controller haben, der physische Effekte verwendet, damit der Effekt wirksam wird",
  T_48_META_API_89_P1_D: "Verschiebungsvektor",
  T_48_META_API_9_D: "Schalten Sie den Mechanismus der sicheren Zone aus. Wenn die sichere Zone auf ein Minimum reduziert ist, erleiden die Spieler außerhalb der sicheren Zone weiterhin Schaden; nachdem der Mechanismus der sicheren Zone ausgeschaltet wurde, kehren die Spieler ",
  T_48_META_API_90_D: "Einstellen, ob der Spieler frei aufhören kann",
  T_48_META_API_90_P0_D: "Zielspieler",
  T_48_META_API_90_P1_D: "Freiheit zum Rückzug",
  T_48_META_API_9000_D: "Erstellen einer integrierten Benutzeroberfläche, die nur von bestimmten Spielern gesehen werden kann",
  T_48_META_API_9000_P0_D: "Eingebaute UI-Entitäten erstellt",
  T_48_META_API_9000_P1_D: "Die Spielerentität, zu der die Benutzeroberfläche gehört und die nur für diesen Spieler sichtbar ist",
  T_48_META_API_9000_P2_D: "Eingebaute UI-Typen",
  T_48_META_API_9001_D: "Integrierte Spiel-UI entfernen",
  T_48_META_API_9001_P0_D: "Eingebaute UI-Entitäten, die entfernt werden sollen",
  T_48_META_API_9002_D: "Erstellt ein Icon mit dem angegebenen Icon-Typ, und wenn es mehr Eigenschaften zu setzen gibt, setzt es seine Entitätseigenschaften über die Entität weiter (veraltet, verwenden Sie CreateLevelObject)",
  T_48_META_API_9002_P0_D: "Im Code ist der Name des formalen Parameters, der verwendet wird, um die Entität darzustellen, die das Symbol erstellt, und der entsprechende Wert der lokalen Variable ist die Entität, die das Symbol erstellt",
  T_48_META_API_9002_P1_D: "Die Entität des Spielers, zu der er gehört, nur für diesen Spieler sichtbar",
  T_48_META_API_9002_P2_D: "Ressourcenpfad, der Ressourcenpfad, der dem vom Spieler ausgewählten Symbol entspricht",
  T_48_META_API_9003_D: "Das angegebene Symbol entfernen (veraltet, DeleteEntity verwenden)",
  T_48_META_API_9003_P0_D: "Die zu entfernende Icon-Entität",
  T_48_META_API_9004_D: "Erzeugt einen Text mit dem angegebenen Textinhalt, und wenn es mehr Attribute zu setzen gibt, setzt er seine Entitätsattribute durch die Entität weiter (veraltet, bitte CreateLevelObject verwenden)",
  T_48_META_API_9004_P0_D: "Im Code ist der Name des formalen Parameters, der verwendet wird, um die Entität darzustellen, die den Text erstellt, und der entsprechende Wert der lokalen Variablen ist die Entität, die den Text erstellt",
  T_48_META_API_9004_P1_D: "Die Entität des Spielers, zu der er gehört, nur für diesen Spieler sichtbar",
  T_48_META_API_9004_P2_D: "Zu präsentierender Textinhalt",
  T_48_META_API_9005_D: "Den angegebenen Text entfernen (veraltet, DeleteEntity verwenden)",
  T_48_META_API_9005_P0_D: "Zu entfernende Texteinheiten",
  T_48_META_API_9006_D: "Erzeugt ein Icon mit dem angegebenen Effekttyp, und wenn es mehr Eigenschaften gibt, die gesetzt werden müssen, setzt es seine Entity-Eigenschaften weiter über das Entity (veraltet, bitte CreateEffect verwenden)",
  T_48_META_API_9006_P0_D: "Im Code ist der Name des formalen Parameters, der die Entität darstellt, die den Effekt erzeugt, und der entsprechende Wert der lokalen Variablen ist die Entität, die den Effekt erzeugt",
  T_48_META_API_9006_P1_D: "Die Entität des Spielers, zu der er gehört, nur für diesen Spieler sichtbar",
  T_48_META_API_9006_P2_D: "Effekttypen, die Arten von Effekten, aus denen Spieler wählen können",
  T_48_META_API_9007_D: "Entfernt den angegebenen Effekt (veraltet, verwenden Sie DeleteEntity)",
  T_48_META_API_9007_P0_D: "Die zu entfernende Wirkungseinheit",
  T_48_META_API_9008_D: "Erstellen einer benutzerdefinierten Benutzeroberfläche, die nur von bestimmten Spielern gesehen werden kann",
  T_48_META_API_9008_P0_D: "Benutzerdefinierte UI-Entitäten erstellt",
  T_48_META_API_9008_P1_D: "Die Spielerentität, zu der die Benutzeroberfläche gehört und die nur für diesen Spieler sichtbar ist",
  T_48_META_API_9008_P2_D: "Benutzerdefinierter UI-Index",
  T_48_META_API_9009_D: "Benutzerdefinierte Spiel-UI entfernen",
  T_48_META_API_9009_P0_D: "Zu entfernende benutzerdefinierte UI-Entitäten",
  T_48_META_API_9010_D: "Abrufen von UI-Steuerelementen aus einer benutzerdefinierten UI",
  T_48_META_API_9010_P0_D: "Spielerentität, zu der die UI gehört",
  T_48_META_API_9010_P1_D: "Benutzerdefinierte UI-Entitäten",
  T_48_META_API_9010_P2_D: "Kontrolle Eindeutiger Index",
  T_48_META_API_9010_R_D: "UI-Steuerungseinheit",
  T_48_META_API_9011_D: "Spielt den angegebenen Sound ab, und wenn es weitere Eigenschaften gibt, die eingestellt werden müssen, dann werden die Entitätseigenschaften über die Entität weiter eingestellt (veraltet, bitte CreateSound verwenden)",
  T_48_META_API_9011_P0_D: "Im Code ist der Name des formalen Parameters, der verwendet wird, um die Entität darzustellen, die den Soundeffekt erzeugt, und der entsprechende Wert der lokalen Variablen ist die Entität, die den Soundeffekt erzeugt",
  T_48_META_API_9011_P1_D: "Die Entität des Spielers, zu der er gehört, nur für diesen Spieler sichtbar",
  T_48_META_API_9011_P2_D: "Soundtypen, die Arten von Soundeffekten, aus denen der Spieler wählen kann",
  T_48_META_API_9012_D: "Entfernen des angegebenen Soundeffekts (veraltet, verwenden Sie DeleteEntity)",
  T_48_META_API_9012_P0_D: "Zu entfernende Klangkörper",
  T_48_META_API_9013_D: "Abrufen eines UI-Steuerelements aus einer benutzerdefinierten Benutzeroberfläche über einen Pfad",
  T_48_META_API_9013_P0_D: "Spielerentität, zu der die UI gehört",
  T_48_META_API_9013_P1_D: "Benutzerdefinierte UI",
  T_48_META_API_9013_P2_D: "Kontrollpfad",
  T_48_META_API_9013_R_D: "UI-Steuerungseinheit",
  T_48_META_API_9014_D: "Sound Entity in der Unterbrechungswiedergabe (veraltet, verwenden Sie PauseSound)",
  T_48_META_API_9014_P0_D: "Solide Einheiten, die ausgesetzt werden müssen",
  T_48_META_API_9015_D: "Fortsetzen der Tonwiedergabe, optional von Anfang an (veraltet, verwenden Sie ResumeSound)",
  T_48_META_API_9015_P0_D: "Klangkörper, die nach einer Pause weiter abgespielt werden müssen",
  T_48_META_API_9015_P1_D: "Ob man bei Null anfangen soll",
  T_48_META_API_9016_D: "Benutzerdefinierte UI-Steuerelemente erstellen",
  T_48_META_API_9016_P0_D: "Benutzerdefinierte Steuerelemente erstellt",
  T_48_META_API_9016_P1_D: "Art der erstellten Kontrolle",
  T_48_META_API_9016_P2_D: "Verbundene UI-Einheiten",
  T_48_META_API_9016_P3_D: "Übergeordnetes Steuerelement, wenn nicht ausgefüllt, dann ist die UI-Entität der übergeordnete Knoten.",
  T_48_META_API_9017_D: "Einstellen der Maske der Zielkameraebene",
  T_48_META_API_9017_P0_D: "Zielkamera-Entität",
  T_48_META_API_9017_P1_D: "Ebenenmaske, nur gefüllte Ebenen werden in der Zielkamera angezeigt, bleibt sie leer, werden alle Ebenen angezeigt.",
  T_48_META_API_9018_D: "Zielkamera-Ebenenmaske abrufen",
  T_48_META_API_9018_P0_D: "Zielkamera-Entität",
  T_48_META_API_9018_R_D: "Ebenenmaske, nur Ebenen innerhalb der Ebenenmaske werden in der Zielkamera angezeigt",
  T_48_META_API_9019_D: "Legt fest, ob die angegebene Ebene für die Zielkamera sichtbar ist",
  T_48_META_API_9019_P0_D: "Zielkamera-Entität",
  T_48_META_API_9019_P1_D: "Hierarchie der Sichtbarkeit",
  T_48_META_API_9019_P2_D: "Sichtbarkeit",
  T_48_META_API_9020_D: "Einstellen des standardmäßigen Schnittstellenstatus des Zielplayers",
  T_48_META_API_9020_P0_D: "Zielspieler",
  T_48_META_API_9020_P1_D: "Player-Schnittstellentypen, d. h. UI-Elemente, mit denen der Player und spielerbezogene Inhalte bearbeitet werden können",
  T_48_META_API_9020_P2_D: "Schalterwert, bestimmt die Sichtbarkeit der Spieleroberfläche",
  T_48_META_API_9021_D: "Erstellen einer Zeitstempel-Lokalisierungszeichenfolge",
  T_48_META_API_9021_P0_D: "Zeitstempel",
  T_48_META_API_9021_P1_D: "Formatierungsstile",
  T_48_META_API_9021_R_D: "Zeitstempel Lokalisierungszeichenfolge",
  T_48_META_API_9022_D: "Erstellen eines Minikartensymbols",
  T_48_META_API_9022_P0_D: "Mindmap-Symbol-Entitäten erstellt",
  T_48_META_API_9022_P1_D: "Der Spieler, zu dem Sie gehören, erstellt ein Minikartensymbol, das nur für diesen Spieler sichtbar ist.",
  T_48_META_API_9022_P2_D: "Mindmap-Symbol Ressourcenpfad",
  T_48_META_API_9023_D: "Erzeugt ein Symbol mit dem angegebenen Effekttyp und legt seine Entitätseigenschaften über die Entität fest, wenn es noch weitere Eigenschaften gibt, die festgelegt werden müssen.",
  T_48_META_API_9023_P0_D: "Im Code ist der Name des formalen Parameters, der die Entität darstellt, die den Effekt erzeugt, und der entsprechende Wert der lokalen Variablen ist die Entität, die den Effekt erzeugt",
  T_48_META_API_9023_P1_D: "Die Entität des Spielers, zu der er gehört, nur für diesen Spieler sichtbar",
  T_48_META_API_9023_P2_D: "Effekttypen, die Arten von Effekten, aus denen Spieler wählen können",
  T_48_META_API_9024_D: "Entfernt den angegebenen Effekt (veraltet, verwenden Sie DeleteEntity)",
  T_48_META_API_9024_P0_D: "Die zu entfernende Wirkungseinheit",
  T_48_META_API_9025_D: "Erzeugt statische Pixel auf der Karte für das Zielobjekt, die sich nicht mit dem Zielobjekt bewegen.",
  T_48_META_API_9025_P0_D: "Statische Pixel-Entitäten erstellt",
  T_48_META_API_9025_P1_D: "Der Spieler, zu dem er gehört, erstellt statische Pixel, die nur für diesen Spieler sichtbar sind.",
  T_48_META_API_9025_P2_D: "Zielobjekt Entität",
  T_48_META_API_9026_D: "Abrufen der Minikarteneinheit des Zielspielers",
  T_48_META_API_9026_P0_D: "Zielspieler",
  T_48_META_API_9026_R_D: "Aktuelle Spieler-Minikarte",
  T_48_META_API_9027_D: "Legen Sie den Spieler fallen Schaden, können verschiedene Schäden nach der Höhe Segmente setzen",
  T_48_META_API_9027_P0_D: "Zielspieler",
  T_48_META_API_9027_P1_D: "Höhe Segmentierte Liste",
  T_48_META_API_9027_P2_D: "Liste der Schadenssegmente",
  T_48_META_API_91_D: "Das Hinzufügen einer Zielperson zu einem bestimmten Team führt dazu, dass die Zielperson das Team verlässt, dem sie zuvor angehörte.",
  T_48_META_API_91_P0_D: "Ziele, die dem Team hinzugefügt werden müssen",
  T_48_META_API_91_P1_D: "Treten Sie dem Team bei",
  T_48_META_API_91_P2_D: "Erfolg oder Misserfolg",
  T_48_META_API_92_D: "Das Hinzufügen einer Zielperson zu einem neu erstellten Team führt dazu, dass die Zielperson aus dem Team ausscheidet, in dem sie zuvor war.",
  T_48_META_API_92_P0_D: "Ziele, die dem Team hinzugefügt werden müssen",
  T_48_META_API_92_P1_D: "Name des neuen Teams",
  T_48_META_API_92_P2_D: "Erfolg oder Misserfolg",
  T_48_META_API_94_D: "Set the value of a local variable by index; before setting, the variable must be defined in the current call process ",
  T_48_META_API_94_P0: "Index",
  T_48_META_API_94_P0_D: "Get a variable by index ",
  T_48_META_API_94_P1: "Variable Value",
  T_48_META_API_94_P1_D: "Target variable value ",
  T_48_META_API_94_P2: "Arithmetic Type",
  T_48_META_API_94_P2_D: "Operation method; all types support assignment, and numeric types also support increment, decrement, multiplication, division, and modulus operations ",
  T_48_META_API_94_P3: "Variable Name",
  T_48_META_API_94_P3_D: "Target variable name. Used only for error output ",
  T_48_META_API_95: "Get Local Variable by Index",
  T_48_META_API_95_D: "Get the value of a local variable; before getting, the variable must be defined in the current call process ",
  T_48_META_API_95_P0: "Index",
  T_48_META_API_95_P0_D: "Variable index ",
  T_48_META_API_95_P1: "Variable Name",
  T_48_META_API_95_P1_D: "Target variable name. Used only for error output ",
  T_48_META_API_9500_D: "Client-seitige Wiedergabeeffekte, die den Zielplayer benachrichtigen",
  T_48_META_API_9500_P0_D: "Zielspieler",
  T_48_META_API_9500_P1_D: "Ressourcenpfad für Spezialeffekte",
  T_48_META_API_9500_P2_D: "Farbe",
  T_48_META_API_9500_P3_D: "Zoomgröße, Standardwert ist 1",
  T_48_META_API_9500_P4_D: "Gebundenes Objekt, an das Effekte als untergeordnete Knoten angehängt werden",
  T_48_META_API_9500_P5_D: "Offset in Weltkoordinaten relativ zum gebundenen Objekt",
  T_48_META_API_9501_D: "Den Client des Zielspielers benachrichtigen, um einen Soundeffekt abzuspielen",
  T_48_META_API_9501_P0_D: "Zielspieler",
  T_48_META_API_9501_P1_D: "Art des Soundeffekts",
  T_48_META_API_9502_D: "Benachrichtigen Sie den Client des Zielspielers, dass er schwebende Zeichen anzeigen soll",
  T_48_META_API_9502_P0_D: "Zielspieler",
  T_48_META_API_9502_P1_D: 'Der Inhalt des Wortes "float',
  T_48_META_API_9502_P2_D: "Farbe des fließenden Zeichens, Schriftfarbe",
  T_48_META_API_9502_P3_D: "Fließtextdauer in Millisekunden",
  T_48_META_API_9503_D: "Lasse die Zieleinheit einmal einen Emote-Aktionsausdruck spielen",
  T_48_META_API_9503_P0_D: "Ziele von Emote spielen",
  T_48_META_API_9503_P1_D: "Emote-Typ",
  T_48_META_API_9504_D: "Die Emote-Bewegungsäußerung der Einheit anhalten/fortsetzen",
  T_48_META_API_9504_P0_D: "Ziele von Emote aussetzen/fortsetzen",
  T_48_META_API_9504_P1_D: "True: Wiedergabe anhalten, False: Wiedergabe fortsetzen",
  T_48_META_EVT_1_D: "Wird zu Beginn des Spiels ausgelöst, ist der Server einige Zeit vor dem Client bereit.",
  T_48_META_EVT_10_D: "Wird ausgelöst, bevor die aktuelle Entität Schaden nimmt",
  T_48_META_EVT_10_P0_D: "Angreifer-Entität, möglicherweise null",
  T_48_META_EVT_10_P1_D: "Art des Schadens",
  T_48_META_EVT_10_P2_D: "Höhe des entstandenen Schadens",
  T_48_META_EVT_10_P3_D: "verletzter Teil",
  T_48_META_EVT_1000_D: "Ausgelöst, wenn sich Spielerpunkte ändern",
  T_48_META_EVT_1000_P0_D: "Spieler mit Änderungen in den Punkten",
  T_48_META_EVT_1000_P1_D: "Arten von Änderungspunkten",
  T_48_META_EVT_1000_P2_D: "Integralwert nach Integraländerung",
  T_48_META_EVT_1001_D: "Ausgelöst, wenn sich Teampunkte ändern",
  T_48_META_EVT_1001_P0_D: "Teams mit Änderungen in den Punkten",
  T_48_META_EVT_1001_P1_D: "Arten von Änderungspunkten",
  T_48_META_EVT_1001_P2_D: "Integralwert nach Integraländerung",
  T_48_META_EVT_1002_D: "Ausgelöst, wenn sich der Spielerrang ändert",
  T_48_META_EVT_1002_P0_D: "Spieler mit Ranglistenänderungen",
  T_48_META_EVT_1002_P1_D: "Rangfolge nach Änderung der Rangfolge",
  T_48_META_EVT_1003_D: "Verlassen",
  T_48_META_EVT_1003_P0_D: "Verlassen",
  T_48_META_EVT_1003_P1_D: "Rangfolge nach Änderung der Rangfolge",
  T_48_META_EVT_11_D: "Wird ausgelöst, wenn der Spieler den Raum verlässt",
  T_48_META_EVT_11_P0_D: "Zurückgezogene Spieler",
  T_48_META_EVT_12_D: "Wird ausgelöst, wenn der Spieler-Controller ein Objekt berührt, und nur ausgelöst, wenn der Controller aktiv eine Bewegung ausführt",
  T_48_META_EVT_12_P0_D: "Angetroffene Einrichtungen",
  T_48_META_EVT_13_D: "Wird ausgelöst, bevor die aktuelle Entität Schaden verursacht",
  T_48_META_EVT_13_P0_D: "Einrichtungen, die einen Schaden erlitten haben",
  T_48_META_EVT_13_P1_D: "Art des Schadens",
  T_48_META_EVT_13_P2_D: "Höhe des entstandenen Schadens",
  T_48_META_EVT_13_P3_D: "verletzter Teil",
  T_48_META_EVT_14_D: "Dieses Ereignis wird jedes Mal ausgelöst, wenn eine abspielbare Entität einen Zyklus durchläuft. Es funktioniert nur auf der Client-Seite, wenn die abspielbare Entität eine Sound-, Effekt- usw. Entität ist.",
  T_48_META_EVT_2_D: "Wird ausgelöst, wenn der Logikrahmen aktualisiert wird. Je nach Plattform und Einstellungen kann die Häufigkeit dieses Ereignisses variieren.",
  T_48_META_EVT_2002_D: "Ausgelöst beim Tod des Spielers",
  T_48_META_EVT_2002_P0_D: "Tote Spieler",
  T_48_META_EVT_2003_D: "Ausgelöst durch Spielerassists",
  T_48_META_EVT_2003_P0_D: "Spieler mit Assists",
  T_48_META_EVT_2003_P1_D: "Getötete Spieler",
  T_48_META_EVT_2004_D: "Wird ausgelöst, wenn der Spieler Schaden verursacht",
  T_48_META_EVT_2004_P0_D: "Der Spieler, der den Schaden verursacht hat",
  T_48_META_EVT_2004_P1_D: "beschädigter Player",
  T_48_META_EVT_2004_P2_D: "Art des Schadens",
  T_48_META_EVT_2004_P3_D: "Schadenshöhe",
  T_48_META_EVT_2004_P4_D: "verletzter Teil",
  T_48_META_EVT_2005_D: "Wird ausgelöst, wenn ein Spieler einen Kill zugefügt hat",
  T_48_META_EVT_2005_P0_D: "Spieler, der einen Treffer verursacht hat",
  T_48_META_EVT_2005_P1_D: "Getötete Spieler",
  T_48_META_EVT_2005_P2_D: "Art des Schadens",
  T_48_META_EVT_2006_D: "Wird ausgelöst, wenn ein Spieler dem Spiel beitritt",
  T_48_META_EVT_2006_P0_D: "Spieler, die dem Spiel beitreten",
  T_48_META_EVT_2007_D: "Wird ausgelöst, wenn der Spieler wiederbelebt wird",
  T_48_META_EVT_2007_P0_D: "Wiederauferstandene Spieler",
  T_48_META_EVT_2007_P1_D: "Quellen für die Auferstehung",
  T_48_META_EVT_2008_D: "Wird ausgelöst, wenn ein Spieler niedergeschlagen wird",
  T_48_META_EVT_2008_P0_D: "K.o.-Spieler",
  T_48_META_EVT_2008_P1_D: "Angreifer",
  T_48_META_EVT_2009_D: "Ausgelöst, wenn der Spieler die Verbindung trennt",
  T_48_META_EVT_2009_P0_D: "Nicht angeschlossene Spieler",
  T_48_META_EVT_2010_D: "Wird ausgelöst, wenn der Spieler die Verbindung wiederherstellt",
  T_48_META_EVT_2010_P0_D: "Wiederverbundene Spieler",
  T_48_META_EVT_2100_D: "Ausgelöst, wenn das Team entfernt wird",
  T_48_META_EVT_2100_P0_D: "Entfernte Teams",
  T_48_META_EVT_2101_D: "Wird beim Hinzufügen eines Teams ausgelöst",
  T_48_META_EVT_2101_P0_D: "Hinzugefügte Teams",
  T_48_META_EVT_2102_D: "Ausgelöst, wenn das Team von der Gruppe zerstört wird",
  T_48_META_EVT_2102_P0_D: "Das Team, das vom Regiment zerstört wurde",
  T_48_META_EVT_3_D: "Ausgelöst am Ende des Spiels und vor dem Spielende auf dem Server",
  T_48_META_EVT_30_D: "Ausgelöst, wenn die Szene erfolgreich geladen wurde",
  T_48_META_EVT_30_P0_D: "Szenenname",
  T_48_META_EVT_3000_D: "Ausgelöst, nachdem die aktuelle Entität erstellt wurde",
  T_48_META_EVT_3001_D: "Ausgelöst, bevor die aktuelle Entität zerstört wird",
  T_48_META_EVT_3002_D: "Ausgelöst, wenn der Spieler den Trigger betritt",
  T_48_META_EVT_3002_P0_D: "Spieler, die den Auslöser betätigen",
  T_48_META_EVT_3003_D: "Wird ausgelöst, wenn der Spieler den Auslöser verlässt",
  T_48_META_EVT_3003_P0_D: "Spieler, die den Auslöser verlassen",
  T_48_META_EVT_3004_D: "Ausgelöst nach Anklicken des UI-Button-Controls",
  T_48_META_EVT_3004_P0_D: "Klickende Spieler",
  T_48_META_EVT_3005_D: "Ausgelöst durch Anklicken einer Schaltfläche in der integrierten Benutzeroberfläche",
  T_48_META_EVT_3005_P0_D: "Name der anzuklickenden Schaltflächensteuerung",
  T_48_META_EVT_3006_D: "Wird ausgelöst, wenn der Spieler Wasserski benutzt",
  T_48_META_EVT_3007_D: "Ausgelöst, nachdem die aktuelle Entität verfügbar ist",
  T_48_META_EVT_3008_D: "Wird ausgelöst, wenn die aktuelle Entität nicht mehr verfügbar ist",
  T_48_META_EVT_3009_D: "Ausgelöst, wenn eine Entität einen Auslöser betritt, erhalten beide Parteien das Ereignis, wenn es ausgelöst wird, wobei eine von ihnen ein starrer Körper und die andere ein Auslöser sein muss",
  T_48_META_EVT_3009_P0_D: "Widersprechende Stelle zum Zeitpunkt des auslösenden Ereignisses",
  T_48_META_EVT_3010_D: "Ausgelöst, wenn eine Entität den Auslöser verlässt, beide Parteien erhalten das Ereignis, wenn es ausgelöst wird, eine von ihnen muss ein starrer Körper und die andere ein Auslöser sein",
  T_48_META_EVT_3010_P0_D: "Widersprechende Stelle zum Zeitpunkt des auslösenden Ereignisses",
  T_48_META_EVT_3011_D: "Wird ausgelöst, wenn die aktuelle Entität zerstört wird",
  T_48_META_EVT_3011_P0_D: "Angreifer-Entität, möglicherweise null",
  T_48_META_EVT_3011_P1_D: "Art des Schadens",
  T_48_META_EVT_3011_P2_D: "verletzter Teil",
  T_48_META_EVT_3012_D: "Ausgelöst, nachdem die aktuelle Entität angegriffen wurde",
  T_48_META_EVT_3012_P0_D: "Angreifer-Entität, möglicherweise null",
  T_48_META_EVT_3012_P1_D: "Art des Schadens",
  T_48_META_EVT_3012_P2_D: "Höhe des entstandenen Schadens",
  T_48_META_EVT_3012_P3_D: "verletzter Teil",
  T_48_META_EVT_3013_D: "Wird ausgelöst, nachdem die aktuelle Entität Schaden verursacht hat",
  T_48_META_EVT_3013_P0_D: "Einrichtungen, die einen Schaden erlitten haben",
  T_48_META_EVT_3013_P1_D: "Art des Schadens",
  T_48_META_EVT_3013_P2_D: "Höhe des entstandenen Schadens",
  T_48_META_EVT_3013_P3_D: "verletzter Teil",
  T_48_META_EVT_3014_D: "Wird ausgelöst, nachdem die aktuelle Entität eine andere Entität vernichtet hat",
  T_48_META_EVT_3014_P0_D: "Eliminierte Einheiten",
  T_48_META_EVT_3014_P1_D: "verletzter Teil",
  T_48_META_EVT_3015_D: "Wird ausgelöst, wenn dieser Spieler wiederbelebt wird",
  T_48_META_EVT_3015_P0_D: "Art des Spielers Quelle der Wiederauferstehung",
  T_48_META_EVT_3016_D: "Wird ausgelöst, wenn der Generator eine Entität erzeugt",
  T_48_META_EVT_3016_P0_D: "Liste der erzeugten Entitäten",
  T_48_META_EVT_3016_P1_D: "Wellenzahl",
  T_48_META_EVT_3017_D: "Wird aufgerufen, wenn der Spieler die Knockout-Knieposition einnimmt.",
  T_48_META_EVT_3018_D: "Ausgelöst, wenn alle Teammitglieder tot sind",
  T_48_META_EVT_3019_D: "Wird ausgelöst, wenn er mit einem Helm, einer Körperpanzerung oder einem Rucksack ausgerüstet ist.",
  T_48_META_EVT_3019_P0_D: "Geräte-ID",
  T_48_META_EVT_3020_D: "Wird ausgelöst, wenn eine Primär-, Sekundär- oder Nahkampfwaffe gehalten wird, auch beim Wechsel zur Faust",
  T_48_META_EVT_3020_P0_D: "Zum Zeitpunkt der Auslösung ausgerüstete Waffeneinheit",
  T_48_META_EVT_3021_D: "Wird nach der Verwendung von Requisiten ausgelöst. Requisiten, die eine gewisse Zeit für die Verwendung benötigen, lösen dieses Ereignis aus, nachdem die Verwendung abgeschlossen ist.",
  T_48_META_EVT_3021_P0_D: "Requisiten-ID",
  T_48_META_EVT_3021_P1_D: "Requisiten-Entität, möglicherweise null",
  T_48_META_EVT_3021_P2_D: "Neue Requisiteneinheit, die mit Hilfe von Requisiten erstellt wurde, kann leer sein",
  T_48_META_EVT_3022_D: "Wird ausgelöst, wenn ein Gegenstand erworben wird",
  T_48_META_EVT_3022_P0_D: "Art der Position",
  T_48_META_EVT_3022_P1_D: "Objekt Entität, möglicherweise null",
  T_48_META_EVT_3023_D: "Ausgelöst, wenn sich Entitätspunkte ändern",
  T_48_META_EVT_3023_P0_D: "Arten von Änderungspunkten",
  T_48_META_EVT_3023_P1_D: "Integralwert nach Integraländerung",
  T_48_META_EVT_3024_D: "Ausgelöst, wenn sich der Rang der Entität ändert",
  T_48_META_EVT_3024_P0_D: "Rangfolge nach Änderung der Rangfolge",
  T_48_META_EVT_3025_D: "Ausgelöst durch einen Assistenten",
  T_48_META_EVT_3025_P0_D: "treffen.",
  T_48_META_EVT_3026_D: "Wird ausgelöst, wenn eine Person ein Fahrzeug betritt, auch als Fahrer und Beifahrer",
  T_48_META_EVT_3026_P0_D: "Einrichtungen, die das Luftfahrtunternehmen betreten",
  T_48_META_EVT_3026_P1_D: "Eingetragene Beförderer",
  T_48_META_EVT_3027_D: "Ausgelöst, wenn die Entität den Träger verlässt",
  T_48_META_EVT_3027_P0_D: "Einrichtungen, die das Luftfahrtunternehmen verlassen",
  T_48_META_EVT_3027_P1_D: "Abfliegende Fluggesellschaften",
  T_48_META_EVT_3028_D: "Ausgelöst, wenn ein Träger physisch gefahren wird, wenn man sich als Fahrer in einem Auto befindet",
  T_48_META_EVT_3028_P0_D: "Unternehmen, das das Verkehrsunternehmen betreibt",
  T_48_META_EVT_3028_P1_D: "Angetriebene Fahrzeuge",
  T_48_META_EVT_3029_D: "Ausgelöst, wenn der Träger physisch betreten wird",
  T_48_META_EVT_3029_P0_D: "auslösende Stelle",
  T_48_META_EVT_3030_D: "Ausgelöst, wenn der Beförderer abfährt",
  T_48_META_EVT_3030_P0_D: "auslösende Stelle",
  T_48_META_EVT_3031_D: "Wird ausgelöst, wenn das Fahrzeug von einer Entität gefahren wird",
  T_48_META_EVT_3031_P0_D: "auslösende Stelle",
  T_48_META_EVT_3032_D: "Wird ausgelöst, nachdem eine Teleportation stattfindet, wenn eine Entität ein Portal benutzt (veraltet, verwenden Sie OnBouncesOffTire)",
  T_48_META_EVT_3032_P0_D: "Einrichtungen, die das Portal nutzen",
  T_48_META_EVT_3032_P1_D: "Verwendetes Portal",
  T_48_META_EVT_3033_D: "Ausgelöst, wenn Entität abprallt",
  T_48_META_EVT_3033_P0_D: "auslösende Stelle",
  T_48_META_EVT_3033_P1_D: "Verwendete hüpfende Objekte",
  T_48_META_EVT_3034_D: "Wird ausgelöst, nachdem das Portal der Entität die Teleportation ermöglicht",
  T_48_META_EVT_3034_P0_D: "übermittelnde Stelle",
  T_48_META_EVT_3035_D: "Wird ausgelöst, wenn der Reifen die Einheit aufprallt",
  T_48_META_EVT_3035_P0_D: "Popup-Entität",
  T_48_META_EVT_3036_D: "Ausgelöst, wenn eine Maschine eine Entität in die Luft schickt",
  T_48_META_EVT_3036_P0_D: "Entität, die weggeschlagen wird",
  T_48_META_EVT_3036_P1_D: "maschinengeneriertes Objekt",
  T_48_META_EVT_3037_D: "Wird ausgelöst, wenn die Entität den Trigger betritt",
  T_48_META_EVT_3037_P0_D: "Auslöser für die Einreise",
  T_48_META_EVT_3038_D: "Wird ausgelöst, wenn die Entität den Auslöser verlässt",
  T_48_META_EVT_3038_P0_D: "Auslöser zum Verlassen",
  T_48_META_EVT_3039_D: "Wird beim Erwerb einer Waffeneinheit ausgelöst",
  T_48_META_EVT_3039_P0_D: "Rüstungsunternehmen",
  T_48_META_EVT_3040_D: "Ausgelöst, wenn eine Entität von einer Maschine weggeschlagen wird",
  T_48_META_EVT_3040_P0_D: "Entität, die weggeschlagen wird",
  T_48_META_EVT_3040_P1_D: "maschinengeneriertes Objekt",
  T_48_META_EVT_3041_D: "Wird ausgelöst, wenn ein anvisierbares Objekt anvisiert wird",
  T_48_META_EVT_3041_P0_D: "Zielgebietseinheiten",
  T_48_META_EVT_3042_D: "Wird ausgelöst, wenn er von einem Spieler anvisiert wird",
  T_48_META_EVT_3042_P0_D: "Spieler anvisieren",
  T_48_META_EVT_3043_D: "Ausgelöst, wenn das Geschoss das Ziel trifft",
  T_48_META_EVT_3043_P0_D: "treffen.",
  T_48_META_EVT_3043_P1_D: "Weltkoordinaten der Einschlagstellen der Kugeln",
  T_48_META_EVT_3044_D: "Wird ausgelöst, wenn er von einer Waffe getroffen wird",
  T_48_META_EVT_3044_P0_D: "Waffen",
  T_48_META_EVT_3044_P1_D: "Weltkoordinaten des Trefferbereichs",
  T_48_META_EVT_3045_D: "Wird ausgelöst, wenn der Spieler sich in ein Objekt für dieses Level verwandelt",
  T_48_META_EVT_3045_P0_D: "Der Spieler verwandelt sich in eine Entität, nicht in das Szenenobjekt selbst",
  T_48_META_EVT_3046_D: "Wird ausgelöst, wenn ein Spieler an diesem Wiederbelebungspunkt wiederbelebt wird",
  T_48_META_EVT_3046_P0_D: "Spieler, die an diesem Auferstehungspunkt wiederbelebt werden",
  T_48_META_EVT_3047_D: "Wird ausgelöst, wenn ein Spieler eine Waffe ablegt",
  T_48_META_EVT_3047_P0_D: "Abgeworfene Waffeneinheiten",
  T_48_META_EVT_3048_D: "Wird ausgelöst, wenn ein Spieler einen anderen Gegenstand als eine Waffe abwirft.",
  T_48_META_EVT_3048_P0_D: "Art der Position",
  T_48_META_EVT_3048_P1_D: "Objekt Entität, möglicherweise null",
  T_48_META_EVT_3049_D: "Ausgelöst durch einen Treffer mit einer Fußballkanone",
  T_48_META_EVT_3049_P0_D: "Spieler",
  T_48_META_EVT_3049_P1_D: "Geschwindigkeit nach dem Aufprall",
  T_48_META_EVT_3050_D: "Ausgelöst bei Kollision zwischen Fußball und Festkörper",
  T_48_META_EVT_3050_P0_D: "Kollisionsobjekt",
  T_48_META_EVT_3050_P1_D: "Geschwindigkeit nach dem Aufprall",
  T_48_META_EVT_3051_D: "Ausgelöst, wenn ein Spieler erfolgreich einem Sprachkanal beitritt",
  T_48_META_EVT_3051_P0_D: "Sprachkanal-Entität",
  T_48_META_EVT_3052_D: "Ausgelöst, wenn ein Spieler einem Sprachkanal nicht beitreten kann",
  T_48_META_EVT_3052_P0_D: "Sprachkanal-Entität",
  T_48_META_EVT_3053_D: "Ausgelöst, wenn ein Spieler einen Sprachkanal verlässt",
  T_48_META_EVT_3053_P0_D: "Sprachkanal-Entität",
  T_48_META_EVT_3054_D: "Ausgelöst, wenn der Ball ins Tor geht",
  T_48_META_EVT_3054_P0_D: "Torraum",
  T_48_META_EVT_3054_P1_D: "Torschütze, der letzte Spieler, der den Ball berührt, bevor er ins Tor geht",
  T_48_META_EVT_3054_P2_D: "Assistenten, vorletzter Spieler, der den Ball berührt, bevor das Tor fällt",
  T_48_META_EVT_3055_D: "Ausgelöst, wenn der Spieler die Feuertaste drückt",
  T_48_META_EVT_3056_D: "Wird ausgelöst, wenn der Spieler springt",
  T_48_META_EVT_3057_D: "Wird ausgelöst, wenn der Spieler in die Hocke geht",
  T_48_META_EVT_3058_D: "Ausgelöst, wenn der Spieler zu Boden geht",
  T_48_META_EVT_3059_D: "Wird ausgelöst, wenn der Spieler sprintet",
  T_48_META_EVT_3060_D: "Wird ausgelöst, wenn ein Artikel erfolgreich im Shop gekauft wurde",
  T_48_META_EVT_3060_P0_D: "Spieler, die Waren kaufen",
  T_48_META_EVT_3060_P1_D: "Ware",
  T_48_META_EVT_3061_D: "Wird ausgelöst, wenn die Waffe vom Spieler ausgerüstet wird.",
  T_48_META_EVT_3061_P0_D: "Mit Waffen ausgerüstete Spieler",
  T_48_META_EVT_3062_D: "Wird ausgelöst, wenn eine Einheit mit dieser Waffe getötet wird",
  T_48_META_EVT_3062_P0_D: "Getötete Personen",
  T_48_META_EVT_3063_D: "Wird ausgelöst, wenn mit dieser Waffe einer Einheit Schaden zugefügt wird.",
  T_48_META_EVT_3063_P0_D: "geschädigte Person",
  T_48_META_EVT_3063_P1_D: "Schadenshöhe",
  T_48_META_EVT_3064_D: "Wird ausgelöst, wenn die Waffe die Geschosse wechselt",
  T_48_META_EVT_3065_D: "Ausgelöst, wenn eine Person das Verkehrsunternehmen betritt, entweder als Fahrer oder als Fahrgast",
  T_48_META_EVT_3065_P0_D: "Eingetragene Beförderer",
  T_48_META_EVT_3066_D: "Ausgelöst, wenn die Entität den Träger verlässt",
  T_48_META_EVT_3066_P0_D: "Abfliegende Fluggesellschaften",
  T_48_META_EVT_3067_D: "Ausgelöst während der physischen Fahrt des Fahrzeugs",
  T_48_META_EVT_3067_P0_D: "Angetriebene Fahrzeuge",
  T_48_META_EVT_3068_D: "Wird ausgelöst, nachdem eine Teleportation stattgefunden hat, wenn eine Entität ein Portal benutzt",
  T_48_META_EVT_3068_P0_D: "Verwendetes Portal",
  T_48_META_EVT_3069_D: "Ausgelöst, wenn ein Objekt von einem Reifen getroffen wird",
  T_48_META_EVT_3069_P0_D: "Verwendete Reifen",
  T_48_META_EVT_3070_D: "Ausgelöst, wenn eine Entität von einer Maschine weggeschlagen wird",
  T_48_META_EVT_3070_P0_D: "maschinengeneriertes Objekt",
  T_48_META_EVT_3071_D: "Wird ausgelöst, wenn eine UI-Schaltfläche vom Spieler gedrückt wird.",
  T_48_META_EVT_3071_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3072_D: "Wird ausgelöst, wenn das UI-Button-Control angehoben wird",
  T_48_META_EVT_3072_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3073_D: "Wird ausgelöst, nachdem der Spieler auf eine UI-Schaltfläche doppelgeklickt hat.",
  T_48_META_EVT_3073_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3074_D: "Start des Jailbreak-Bereichs",
  T_48_META_EVT_3075_D: "Ausbruchsbereich geschlossen",
  T_48_META_EVT_3076_D: "Wird ausgelöst, wenn der Spieler aufhört, die Wasserskier zu benutzen.",
  T_48_META_EVT_3077_D: "Wird ausgelöst, wenn der Textinhalt des UI-Eingabefeld-Steuerelements vom Spieler geändert wird",
  T_48_META_EVT_3077_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3077_P1_D: "Geänderter Textinhalt",
  T_48_META_EVT_3078_D: "Wird ausgelöst, wenn die spielbare Einheit zu spielen beginnt",
  T_48_META_EVT_3078_P0_D: "spielbare Einheit",
  T_48_META_EVT_3079_D: "Dieses Ereignis wird ausgelöst, wenn eine abspielbare Entität die Wiedergabe beendet. Es funktioniert nur auf der Client-Seite, wenn die abspielbare Entität eine Sound-, Effekt- usw. Entität ist.",
  T_48_META_EVT_3079_P0_D: "spielbare Einheit",
  T_48_META_EVT_3080_D: "Wird ausgelöst, wenn die spielbare Einheit weiter spielt",
  T_48_META_EVT_3080_P0_D: "spielbare Einheit",
  T_48_META_EVT_3081_D: "Wird ausgelöst, wenn ein abspielbares Objekt die Wiedergabe unterbricht",
  T_48_META_EVT_3081_P0_D: "spielbare Einheit",
  T_48_META_EVT_3082_D: "Jailbreak-Spieler treten bei",
  T_48_META_EVT_3082_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3083_D: "Jailbreak-Spieler kündigen",
  T_48_META_EVT_3083_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3084_D: "Ausgelöst am Ende des Countdowns",
  T_48_META_EVT_3084_P0_D: "angegliedertes Unternehmen",
  T_48_META_EVT_3085_D: "Ausgelöst, wenn ein Gegenstand aufgenommen wird",
  T_48_META_EVT_3085_P0_D: "Spieler, die Gegenstände aufheben",
  T_48_META_EVT_3086_D: "Ausgelöst, wenn ein Gegenstand weggeworfen wird",
  T_48_META_EVT_3086_P0_D: "Der Spieler, der den Gegenstand fallen gelassen hat",
  T_48_META_EVT_3087_D: "Wird ausgelöst, wenn dieser Gegenstand ausgerüstet ist",
  T_48_META_EVT_3088_D: "Wird ausgelöst, wenn das Objekt gestartet wird, nachdem die Mine erstellt wurde",
  T_48_META_EVT_3089_D: "Ausgelöst, wenn das Objekt nach der Erstellung der Mine ausgelöst wird",
  T_48_META_EVT_3089_P0_D: "Anvisieren von Objekten nach der Minenerstellung wird ausgelöst",
  T_48_META_EVT_3090_D: "Ausgelöst vor dem Kauf eines Artikels in einem Geschäft",
  T_48_META_EVT_3090_P0_D: "Spieler, die Waren kaufen",
  T_48_META_EVT_3090_P1_D: "Ware",
  T_48_META_EVT_3091_D: "Wird ausgelöst, wenn dieses Gerät verwendet wird",
  T_48_META_EVT_3092_D: "Wird ausgelöst, wenn die Hooklock-Pistole abgefeuert wird",
  T_48_META_EVT_3093_D: "Wird ausgelöst, wenn das Projektil nach dem Wurf explodiert.",
  T_48_META_EVT_3093_P0_D: "Explosionspunkt",
  T_48_META_EVT_3094_D: "Ausgelöst durch einen Treffer mit einer Paintball-Pistole",
  T_48_META_EVT_3094_P0_D: "Lackierpistolen-Einheiten",
  T_48_META_EVT_3094_P1_D: "Trefferpunkt",
  T_48_META_EVT_3094_P2_D: "die Ziellinie treffen",
  T_48_META_EVT_3095_D: "Ausgelöst bei Treffer mit Farbpistole",
  T_48_META_EVT_3095_P0_D: "Objekt treffen",
  T_48_META_EVT_3095_P1_D: "Trefferpunkt",
  T_48_META_EVT_3095_P2_D: "die Ziellinie treffen",
  T_48_META_EVT_3096_D: "Ausgelöst, wenn ein Träger oder ein Färbeeimer explodiert",
  T_48_META_EVT_3096_P0_D: "Der Spieler, der die Explosion verursacht hat",
  T_48_META_EVT_3096_P1_D: "Liste der von der Explosion betroffenen Spieler",
  T_48_META_EVT_3097_D: "Wird ausgelöst, wenn die Waffe nicht mehr feuert",
  T_48_META_EVT_3097_P0_D: "Aktuelle Magazinkapazität zum Zeitpunkt des Waffenstillstands",
  T_48_META_EVT_3098_D: "Wird ausgelöst, wenn das verfolgende Ziel den Verfolgungsbereich betritt",
  T_48_META_EVT_3099_D: "Ausgelöst, wenn das verfolgende Ziel den Verfolgungsbereich verlässt",
  T_48_META_EVT_31_D: "Ausgelöst bei erfolgreichem Szenenwechsel",
  T_48_META_EVT_31_P0_D: "Szenenname",
  T_48_META_EVT_3100_D: "Wird ausgelöst, wenn das Ziel des Angriffs den Angriffsbereich betritt",
  T_48_META_EVT_3101_D: "Wird ausgelöst, wenn sich das Ziel des Angriffs außerhalb der Reichweite befindet.",
  T_48_META_EVT_3102_D: "Ausgelöst, wenn die Kamera-Strahlenerkennung durch ein Client-Klick-Ereignis ausgelöst wird",
  T_48_META_EVT_3102_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3102_P1_D: "Ob der Kamerastrahl das Objekt trifft",
  T_48_META_EVT_3102_P2_D: "Position des Kamerastrahlen-Treffers",
  T_48_META_EVT_3102_P3_D: "Ausrichtung der Client-Kamera",
  T_48_META_EVT_3102_P4_D: "Client-Kameraposition",
  T_48_META_EVT_3102_P5_D: "das Ziel treffen",
  T_48_META_EVT_3103_D: "Ausgelöst, wenn der Shop-Bildschirm geöffnet wird",
  T_48_META_EVT_3103_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3104_D: "Ausgelöst, wenn der Shop-Bildschirm geschlossen wird",
  T_48_META_EVT_3104_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3105_D: "Ausgelöst, wenn die Logik des Verhaltensbaums den Knoten betritt",
  T_48_META_EVT_3105_P0_D: "Name des Knotens",
  T_48_META_EVT_3105_P1_D: "angegliedertes Unternehmen",
  T_48_META_EVT_3106_D: "Ausgelöst, wenn die Logik des Verhaltensbaums den Knoten verlässt",
  T_48_META_EVT_3106_P0_D: "Name des Knotens",
  T_48_META_EVT_3106_P1_D: "angegliedertes Unternehmen",
  T_48_META_EVT_3107_D: "Ausgelöst, wenn ein starrer Körper geweckt wird",
  T_48_META_EVT_3108_D: "Ausgelöst, wenn der starre Körper in den Ruhezustand übergeht",
  T_48_META_EVT_3109_D: "Ausgelöst, wenn sich der Spieler bewegt",
  T_48_META_EVT_3109_P0_D: "Haltung",
  T_48_META_EVT_3110_D: "Wird ausgelöst, wenn sich der Player im Standby-Modus befindet.",
  T_48_META_EVT_3110_P0_D: "Haltung",
  T_48_META_EVT_3111_D: "Wird ausgelöst, wenn der Spieler eine Fertigkeit einsetzt",
  T_48_META_EVT_3111_P0_D: "Verwendete Fertigkeiten",
  T_48_META_EVT_3112_D: "Ausgelöst, wenn der Spieler den Sprint beendet",
  T_48_META_EVT_3113_D: "Wird ausgelöst, wenn das Element, das dem Steckplatz unter der Aufzählung SwitchEquipSlot entspricht, erworben wird.",
  T_48_META_EVT_3113_P0_D: "Erworbene Posteneinheiten",
  T_48_META_EVT_3114_D: "Auslöser beim Wechsel von Handgeräten, auch beim Wechsel zu Fäusten",
  T_48_META_EVT_3114_P0_D: "Nach dem Wechsel gehaltene Posteneinheiten",
  T_48_META_EVT_3115_D: "Wird ausgelöst, wenn ein Spieler im Laden jemanden auffordert, einen Gegenstand zu kaufen",
  T_48_META_EVT_3115_P0_D: "Spieler, die Merchandisingartikel anfordern",
  T_48_META_EVT_3115_P1_D: "Ware",
  T_48_META_EVT_3116_D: "Wird ausgelöst, wenn ein Spieler in einem Geschäft einen Gegenstand anfordert und die Anforderung angenommen wird.",
  T_48_META_EVT_3116_P0_D: "Hilfe für gekaufte Spieler",
  T_48_META_EVT_3116_P1_D: "Spieler, die um Hilfe bei ihren Einkäufen bitten",
  T_48_META_EVT_3116_P2_D: "Ware",
  T_48_META_EVT_3117_D: "Ausgelöst bei festen Bildaktualisierungen mit einer festen Frequenz von 30 Mal pro Sekunde",
  T_48_META_EVT_3118_D: "Ausgelöst nach einem Aufruf der Pause Game API",
  T_48_META_EVT_3119_D: "Ausgelöst nach einem Aufruf der Restore Game API",
  T_48_META_EVT_3120_D: "Ausgelöst, wenn ein Spieler einen Freund hinzufügt oder löscht",
  T_48_META_EVT_3121_D: "Ausgelöst beim Empfang einer Persona-Nachricht",
  T_48_META_EVT_3121_P0_D: "Inhalt der Informationen",
  T_48_META_EVT_3121_P1_D: "Absender Persona",
  T_48_META_EVT_3122_D: "Ausgelöst am Ende des Sprungs eines Spielers",
  T_48_META_EVT_3123_D: "Ausgelöst, wenn der Spieler fällt",
  T_48_META_EVT_3124_D: "Ausgelöst am Ende des Sturzes eines Spielers",
  T_48_META_EVT_3125_D: "Ausgelöst durch den Empfang von Persona-Verhalten",
  T_48_META_EVT_3125_P0_D: "Verhalten",
  T_48_META_EVT_3125_P1_D: "Absender Persona",
  T_48_META_EVT_3126_D: "Ausgelöst, wenn sich Mitgliederinformationen ändern",
  T_48_META_EVT_3126_P0_D: "Geänderter Status des Mitglieds",
  T_48_META_EVT_3127_D: "Ausgelöst beim Betreten des Mitgliederzentrums",
  T_48_META_EVT_3128_D: "Ausgelöst beim Verlassen des Mitgliederzentrums",
  T_48_META_EVT_3129_D: 'Wird ausgelöst, wenn der Spieler den Zustand "Niedergeschlagen" erreicht',
  T_48_META_EVT_3129_P0_D: "Angreifer-Entität, möglicherweise null",
  T_48_META_EVT_3130_D: "Ausgelöst, wenn der Persona-Status empfangen wird",
  T_48_META_EVT_3130_P0_D: "Absender Persona",
  T_48_META_EVT_3130_P1_D: "Fehlercode",
  T_48_META_EVT_3131_D: "Wird ausgelöst, wenn eine Nachricht an Persona über die Benutzeroberfläche gesendet wird",
  T_48_META_EVT_3131_P0_D: "Inhalt der Informationen",
  T_48_META_EVT_3131_P1_D: "Absender Persona",
  T_48_META_EVT_3132_D: "Ausgelöst am Ende des Empfangs von Persona",
  T_48_META_EVT_3132_P0_D: "Absender Persona",
  T_48_META_EVT_3132_P1_D: "Fehlercode",
  T_48_META_EVT_32_D: "Ausgelöst, wenn der Spieler die Szene wechselt",
  T_48_META_EVT_32_P0_D: "Szenenname",
  T_48_META_EVT_3200_D: "Ausgelöst, wenn die Wiedergabe des Animationsclips beendet ist",
  T_48_META_EVT_3200_P0_D: "Name des animierten Segments",
  T_48_META_EVT_3201_D: "Ausgelöst, wenn der Animationszustand beendet ist",
  T_48_META_EVT_3201_P0_D: "Name des Animationsstatus",
  T_48_META_EVT_3204_D: "Wird ausgelöst, wenn sich der Zustand des Toggle-Controls ändert.",
  T_48_META_EVT_3204_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3204_P1_D: "Stand der Dinge",
  T_48_META_EVT_3260_D: "Wird ausgelöst, wenn das Touchpad vom Spieler gedrückt wird",
  T_48_META_EVT_3260_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3260_P1_D: "Position der Presse",
  T_48_META_EVT_3261_D: "Ausgelöst, wenn das Touchpad angehoben wird",
  T_48_META_EVT_3261_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3261_P1_D: "Position heben",
  T_48_META_EVT_3262_D: "Ausgelöst, wenn das Touchpad zu gleiten beginnt",
  T_48_META_EVT_3262_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3262_P1_D: "Start Slide Position",
  T_48_META_EVT_3263_D: "Ausgelöst bei einem Touchpad-Slide, wird dieses Ereignis einmal pro Frame während des Slide ausgelöst",
  T_48_META_EVT_3263_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3263_P1_D: "Start Slide Position",
  T_48_META_EVT_3263_P2_D: "Verschiebung",
  T_48_META_EVT_3264_D: "Ausgelöst am Ende eines Touchpad-Slides",
  T_48_META_EVT_3264_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3264_P1_D: "Endposition des Schlittens",
  T_48_META_EVT_3265_D: "Ausgelöst, wenn der JoyStick gedrückt wird",
  T_48_META_EVT_3265_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3266_D: "Ausgelöst, wenn der JoyStick angehoben wird",
  T_48_META_EVT_3266_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3267_D: "Ausgelöst bei Verwendung des JoySticks",
  T_48_META_EVT_3267_P0_D: "Trigger-Spieler",
  T_48_META_EVT_3267_P1_D: "Ausgang Verdrängung",
  T_48_META_EVT_3268_D: "Wird ausgelöst, wenn der Spieler aus einer anderen Position aufsteht",
  T_48_META_EVT_3268_P0_D: "Die Haltung des Spielers vor dem Aufstehen",
  T_48_META_EVT_3269_D: "Ausgelöst, wenn die Waffe abgefeuert wird",
  T_48_META_EVT_4_D: "Ausgelöst zu Beginn eines jeden Zuges",
  T_48_META_EVT_4_P0_D: "Runder Index, von 0 an zählend",
  T_48_META_EVT_5_D: "Ausgelöst am Ende jeder Runde",
  T_48_META_EVT_5_P0_D: "Runder Index, von 0 an zählend",
  T_48_META_EVT_6_D: "Wird ausgelöst, wenn ein Objekt kollidiert ist. Wird nur von Objekten unterstützt, die eine Rigid Body Komponente montiert haben.",
  T_48_META_EVT_6_P0_D: "Angetroffene Einrichtungen",
  T_48_META_EVT_7_D: "Ausgelöst zu Beginn einer jeden Phase",
  T_48_META_EVT_7_P0_D: "step entity",
  T_48_META_EVT_8_D: "Ausgelöst am Ende einer jeden Phase",
  T_48_META_EVT_8_P0_D: "step entity",
  T_48_META_EVT_9_D: "Wird am Ende einer Entity-Kollision ausgelöst, wird nur von Entities unterstützt, die eine Rigid Body-Komponente tragen.",
  T_48_META_EVT_9_P0_D: "Angetroffene Einrichtungen",
  T_49_META_TYP_10_I1_D: "Tag List",
  T_49_META_TYP_10_I2_D: "Is it available for itself",
  T_49_META_TYP_10_I3_D: "Available in all parents",
  T_49_META_TYP_10_I4_D: "Whether it is available in the Scene or not",
  T_49_META_TYP_10_I5_D: "Whether logic update is turned on, when it is turned off, the script on this entity stops updating every frame",
  T_49_META_TYP_10_I6_D: "Entity name",
  T_49_META_TYP_10_I7_D: "Region filtering options, 0 for automatic calculation of controlled or uncontrolled, 1 for uncontrolled always synchronized, 2 for controlled",
  T_49_META_TYP_100_I0_D: "Setting the trigger range",
  T_49_META_TYP_100_I1_D: "Model Visibility",
  T_49_META_TYP_101_I0_D: "Player",
  T_49_META_TYP_101_I1_D: "TargetItemID",
  T_49_META_TYP_101_I2_D: "TargetRotation",
  T_49_META_TYP_101_I3_D: "TargetScale",
  T_49_META_TYP_1010_I1_D: "Timing duration in seconds",
  T_49_META_TYP_1010_I2_D: "The start time of the timings, in seconds of the game moment",
  T_49_META_TYP_1010_I3_D: "The update type of the timer, see `EUITimeUpdateType`, can be static, timed, or countdown.",
  T_49_META_TYP_1010_I4_D: "Display position, when there is a target to follow, it is the offset relative to the target origin, when there is no target to follow, it is the screen coordinates.",
  T_49_META_TYP_1011_I10_D: "Progress Icon Name",
  T_49_META_TYP_1011_I2_D: "Theme Color",
  T_49_META_TYP_1011_I3_D: "Whether to enable localized display",
  T_49_META_TYP_1011_I4_D: "Title",
  T_49_META_TYP_1011_I5_D: "Description",
  T_49_META_TYP_1011_I6_D: "Icon resource name",
  T_49_META_TYP_1011_I7_D: "Max Progress",
  T_49_META_TYP_1011_I8_D: "Current Progress",
  T_49_META_TYP_1011_I9_D: "Progress Icon",
  T_49_META_TYP_1012_I1_D: "Enable or disable localization",
  T_49_META_TYP_1012_I2_D: "Number of rounds text",
  T_49_META_TYP_1012_I3_D: "Round Num LocKey Params",
  T_49_META_TYP_1012_I5_D: "LeftColor",
  T_49_META_TYP_1012_I6_D: "RightColor",
  T_49_META_TYP_1013_I2_D: "Round Count Text",
  T_49_META_TYP_1013_I3_D: "Round Num LocKey Params",
  T_49_META_TYP_1014_I2_D: "First Score Title Text",
  T_49_META_TYP_1014_I3_D: "First Score",
  T_49_META_TYP_1014_I4_D: "First Score Params",
  T_49_META_TYP_1014_I5_D: "Title of the second score",
  T_49_META_TYP_1014_I6_D: "Second score value",
  T_49_META_TYP_1014_I7_D: "Second Score Value Params",
  T_49_META_TYP_1016_I1_D: "Show the corresponding status according to the value, Victory (1), Defeat (2), Tie (3), Booyah (4)",
  T_49_META_TYP_1016_I2_D: "Show if the score of 2 teams is true, otherwise hidden",
  T_49_META_TYP_1016_I3_D: "Left Team Score",
  T_49_META_TYP_1016_I4_D: "Right Team Score",
  T_49_META_TYP_1016_I5_D: "Phase end timestamps",
  T_49_META_TYP_1017_I1_D: "Left Team Name",
  T_49_META_TYP_1017_I2_D: "Left Description",
  T_49_META_TYP_1017_I3_D: "Right Team Name",
  T_49_META_TYP_1017_I4_D: "Right Description",
  T_49_META_TYP_1018_I1_D: "Round Num",
  T_49_META_TYP_1018_I4_D: "Left team score",
  T_49_META_TYP_1018_I6_D: "Score of the right team",
  T_49_META_TYP_1019_I1_D: "1 2 3 for win/loss/tie",
  T_49_META_TYP_102_I0_D: "Resurrection source type, player resurrects from death",
  T_49_META_TYP_102_I1_D: "Resurrection source type, player resurrects from downed state",
  T_49_META_TYP_1020_I2_D: "Text key to be displayed",
  T_49_META_TYP_1020_I3_D: "Array of parameters corresponding to the text key",
  T_49_META_TYP_1021_I1_D: "Base time in seconds",
  T_49_META_TYP_1021_I2_D: "Duration in seconds",
  T_49_META_TYP_1021_I3_D: "Display position, when there is a target to follow, it is the offset of the target origin, when there is no target to follow, it is the screen coordinate, default is Vector3(0).",
  T_49_META_TYP_1022_I2_D: "the key of the text to be displayed",
  T_49_META_TYP_1022_I3_D: "Array of parameters corresponding to the text key.",
  T_49_META_TYP_1023_I1_D: "show team score if it is true, otherwise it will be closed.",
  T_49_META_TYP_1023_I4_D: "If the status of the team is true, then display, otherwise it will be closed.",
  T_49_META_TYP_1023_I5_D: "Left player status array, 0: alive, 1: dead, 2: down.",
  T_49_META_TYP_1023_I6_D: "Right player status array, 0: alive, 1: dead, 2: down.",
  T_49_META_TYP_1023_I7_D: "Left Teammate Flag Count",
  T_49_META_TYP_1023_I8_D: "Right Teammate Flag Count",
  T_49_META_TYP_1024_I2_D: "Offset",
  T_49_META_TYP_1024_I3_D: "Rank",
  T_49_META_TYP_1024_I4_D: "Team Color",
  T_49_META_TYP_1024_I5_D: "Icon Name",
  T_49_META_TYP_1024_I6_D: "Displayed if border is true, otherwise it is off.",
  T_49_META_TYP_1024_I7_D: "Score Text Key",
  T_49_META_TYP_1024_I8_D: "Score Text Key Params",
  T_49_META_TYP_1028_I1_D: "Left Teammate Alive Num",
  T_49_META_TYP_1028_I2_D: "Right Teammate Alive Num",
  T_49_META_TYP_1028_I3_D: "Left Background Color",
  T_49_META_TYP_1028_I4_D: "Right Background Color",
  T_49_META_TYP_1028_I5_D: "Left Icon Name",
  T_49_META_TYP_1028_I6_D: "Right Icon Name",
  T_49_META_TYP_1029_I1_D: "Icon Name",
  T_49_META_TYP_1029_I2_D: "Background Icon Name",
  T_49_META_TYP_103_I0_D: "Primary Weapon A",
  T_49_META_TYP_103_I1_D: "Primary WeaponB",
  T_49_META_TYP_103_I10_D: "Freeze Bomb",
  T_49_META_TYP_103_I11_D: "Ice Wall",
  T_49_META_TYP_103_I12_D: "Landmine",
  T_49_META_TYP_103_I13_D: "Auto Turret",
  T_49_META_TYP_103_I14_D: "DummyGrenade",
  T_49_META_TYP_103_I16_D: "Skateboard, Camo ....",
  T_49_META_TYP_103_I2_D: "Secondary Weapon",
  T_49_META_TYP_103_I3_D: "Blast Weapon",
  T_49_META_TYP_103_I5_D: "HeavyWeapon",
  T_49_META_TYP_1030_I3_D: "Left Teammate Alive Num",
  T_49_META_TYP_1030_I4_D: "Right Teammate Alive Num",
  T_49_META_TYP_1030_I5_D: "Left team icon name",
  T_49_META_TYP_1030_I6_D: "Right team icon name",
  T_49_META_TYP_1031_I2_D: "Description of the message",
  T_49_META_TYP_1031_I3_D: "Countdown start timestamp, in seconds",
  T_49_META_TYP_1031_I4_D: "Description Params",
  T_49_META_TYP_1032_I1_D: "Tips Type",
  T_49_META_TYP_1032_I3_D: "Params",
  T_49_META_TYP_1033_I1_D: "Toggles phases, 0 for current round and 1 for next round",
  T_49_META_TYP_1033_I10_D: "Defeat prompt text, not filled in as default",
  T_49_META_TYP_1033_I11_D: "Round Income Title",
  T_49_META_TYP_1033_I12_D: "Round Income",
  T_49_META_TYP_1033_I13_D: "Round Income Detail Titles",
  T_49_META_TYP_1033_I14_D: "Round revenue value detail list, corresponding to the above detail title list one by one",
  T_49_META_TYP_1033_I15_D: "MVP Player Nickname",
  T_49_META_TYP_1033_I16_D: "Next Round Index",
  T_49_META_TYP_1033_I17_D: "Is Match Point",
  T_49_META_TYP_1033_I18_D: "Is Last Round",
  T_49_META_TYP_1033_I6_D: "Left team icon name",
  T_49_META_TYP_1033_I7_D: "Right team icon name",
  T_49_META_TYP_1033_I8_D: "Depending on the value, the corresponding status will be displayed, Victory (1), Defeat (2).",
  T_49_META_TYP_1033_I9_D: "Victory prompt text, default if not filled in",
  T_49_META_TYP_1036_I1_D: "Indicates how many levels there are in total",
  T_49_META_TYP_1036_I2_D: "Indicates the current bot level",
  T_49_META_TYP_1037_I1_D: "Indicates how many points are displayed",
  T_49_META_TYP_1039_I3_D: "Countdown start timestamp, in seconds",
  T_49_META_TYP_104_I0_D: "Style A",
  T_49_META_TYP_104_I1_D: "Style B",
  T_49_META_TYP_104_I2_D: "Style C",
  T_49_META_TYP_1040_I10_D: "ItemDescriptions",
  T_49_META_TYP_1040_I11_D: "Index of the selected item, start from 0, less than 0 means deselected.",
  T_49_META_TYP_1040_I12_D: "ButtonNames",
  T_49_META_TYP_1040_I13_D: "ButtonColors",
  T_49_META_TYP_1040_I2_D: "Count Down Key",
  T_49_META_TYP_1040_I3_D: "Countdown Time",
  T_49_META_TYP_1040_I4_D: "Description Key",
  T_49_META_TYP_1040_I5_D: "Array of description parameters",
  T_49_META_TYP_1040_I6_D: "ItemBackgrounds",
  T_49_META_TYP_1040_I7_D: "ItemBackgroundColors",
  T_49_META_TYP_1040_I8_D: "ItemIcons",
  T_49_META_TYP_1040_I9_D: "ItemNames",
  T_49_META_TYP_1041_I2_D: "Position",
  T_49_META_TYP_1041_I3_D: "Icon",
  T_49_META_TYP_1041_I4_D: "Label",
  T_49_META_TYP_1041_I5_D: "Background Color",
  T_49_META_TYP_1042_I1_D: "Local Position",
  T_49_META_TYP_1043_I4_D: "Color",
  T_49_META_TYP_1043_I5_D: "Label Key",
  T_49_META_TYP_1043_I6_D: "Label Params",
  T_49_META_TYP_1045_I2_D: "Button icon",
  T_49_META_TYP_1045_I3_D: "Icon Color",
  T_49_META_TYP_1045_I4_D: "Size, same width and height",
  T_49_META_TYP_1045_I5_D: "Position of the button relative to the anchor point in the lower right corner.",
  T_49_META_TYP_1045_I6_D: "Number of charge, less than 0 means hidden",
  T_49_META_TYP_1045_I7_D: "CD start time, in milliseconds",
  T_49_META_TYP_1045_I8_D: "CD duration, in milliseconds",
  T_49_META_TYP_1045_I9_D: "True, the button will be grayed out, False, it will be restored.",
  T_49_META_TYP_106_I1_D: "Enable",
  T_49_META_TYP_106_I2_D: "Disable",
  T_49_META_TYP_109_I0_D: "Chat Channel ID",
  T_49_META_TYP_109_I1_D: "Player List",
  T_49_META_TYP_11_I0_D: "Whether the current game is in illegal state, when it is in illegal state, it means the game has lost the value of confrontation, so it is recommended to end the game directly.",
  T_49_META_TYP_11_I1_D: "The length of the current game, in milliseconds.",
  T_49_META_TYP_11_I10_D: "Whether or not to reset equipment every round",
  T_49_META_TYP_11_I11_D: "Whether or not to enable out-of-zone mechanic",
  T_49_META_TYP_11_I12_D: "Safe Zone Size",
  T_49_META_TYP_11_I13_D: "Shrinking Start Time",
  T_49_META_TYP_11_I14_D: "Shrinking Duration",
  T_49_META_TYP_11_I15_D: "Out-of-Zone Damage",
  T_49_META_TYP_11_I18_D: "Revival Type",
  T_49_META_TYP_11_I2_D: "Current round index, through this value you can get the current round entity.",
  T_49_META_TYP_11_I27_D: "Total Round Count",
  T_49_META_TYP_11_I3_D: "Current phase index, by this value you can get the current phase entity.",
  T_49_META_TYP_11_I32_D: "Number of coins gained at the start of the round",
  T_49_META_TYP_11_I33_D: "Number of coins at kill",
  T_49_META_TYP_11_I34_D: "Number of coins when you win",
  T_49_META_TYP_11_I35_D: "Whether to show wallet UI",
  T_49_META_TYP_11_I36_D: "Skybox Entity",
  T_49_META_TYP_11_I37_D: "Cumulative running frames since game start",
  T_49_META_TYP_11_I38_D: "Enable Move",
  T_49_META_TYP_11_I39_D: "Whether to customize the settlement",
  T_49_META_TYP_11_I4_D: "Preset template ID for UGC mode.",
  T_49_META_TYP_11_I40_D: "Whether to allow joining in the middle of the game",
  T_49_META_TYP_11_I41_D: "Enable low frame rate mode, the game will run at 15FPS, otherwise 30FPS",
  T_49_META_TYP_11_I42_D: "Logical frame update interval between two game server updates",
  T_49_META_TYP_11_I43_D: "Fixed frame update interval in milliseconds",
  T_49_META_TYP_11_I5_D: "Disable player resurrection if off",
  T_49_META_TYP_11_I6_D: "Disable Bot resurrection if off",
  T_49_META_TYP_11_I7_D: "Resurrection time in seconds",
  T_49_META_TYP_11_I8_D: "Total number of teams in the game",
  T_49_META_TYP_11_I9_D: "Number of members in each team",
  T_49_META_TYP_110_I0_D: "ChannelA",
  T_49_META_TYP_110_I1_D: "ChannelB",
  T_49_META_TYP_110_I2_D: "ChannelC",
  T_49_META_TYP_110_I3_D: "ChannelD",
  T_49_META_TYP_110_I4_D: "ChannelE",
  T_49_META_TYP_110_I5_D: "ChannelF",
  T_49_META_TYP_111_I1_D: "Sprint",
  T_49_META_TYP_111_I2_D: "Attack",
  T_49_META_TYP_111_I3_D: "Jump",
  T_49_META_TYP_111_I4_D: "Window Jump",
  T_49_META_TYP_111_I5_D: "Drive",
  T_49_META_TYP_111_I6_D: "Enter Vehicle",
  T_49_META_TYP_111_I7_D: "Exit Vehicle",
  T_49_META_TYP_111_I8_D: "Dirve Vehicle",
  T_49_META_TYP_112_I0_D: "Enable",
  T_49_META_TYP_112_I1_D: "Disable",
  T_49_META_TYP_112_I2_D: "Invisible",
  T_49_META_TYP_117_I0_D: "Claps",
  T_49_META_TYP_117_I1_D: "Hihats",
  T_49_META_TYP_117_I2_D: "Kick",
  T_49_META_TYP_117_I3_D: "OpenHihats",
  T_49_META_TYP_117_I4_D: "Rides",
  T_49_META_TYP_117_I5_D: "Snares",
  T_49_META_TYP_118_I0_D: "Whether all members of the camp are in death",
  T_49_META_TYP_118_I1_D: "List of all team members",
  T_49_META_TYP_118_I2_D: "Allied Factions",
  T_49_META_TYP_118_I3_D: "Attackable Factions",
  T_49_META_TYP_118_I4_D: "Whether to show UI name",
  T_49_META_TYP_118_I5_D: "Whether to show map information",
  T_49_META_TYP_118_I6_D: 'Whether to "show" or not',
  T_49_META_TYP_118_I7_D: 'Whether to "show" or not',
  T_49_META_TYP_118_I8_D: "All Members",
  T_49_META_TYP_118_I9_D: "Is Show Quick Message",
  T_49_META_TYP_119_I0_D: "Yes",
  T_49_META_TYP_119_I1_D: "No",
  T_49_META_TYP_120_I1_D: "Target entity to follow, default is empty",
  T_49_META_TYP_120_I2_D: "UI color",
  T_49_META_TYP_120_I3_D: "UI length",
  T_49_META_TYP_120_I4_D: "Current progress value,0 to 1.0",
  T_49_META_TYP_120_I5_D: "Display position, when there is a target to follow, it is the offset relative to the target origin, when there is no target to follow, it is the screen coordinate, default is Vector3(0)",
  T_49_META_TYP_121_I0_D: "3s",
  T_49_META_TYP_121_I1_D: "5s",
  T_49_META_TYP_121_I2_D: "10s",
  T_49_META_TYP_121_I3_D: "15s",
  T_49_META_TYP_121_I4_D: "30s",
  T_49_META_TYP_121_I5_D: "9999s",
  T_49_META_TYP_122_I0_D: "Skybox Resource",
  T_49_META_TYP_122_I1_D: "Light Color",
  T_49_META_TYP_122_I10_D: "The GUID of the sub-scene it belongs to",
  T_49_META_TYP_122_I11_D: "Fog function switch",
  T_49_META_TYP_122_I12_D: "Fog Effect Mode",
  T_49_META_TYP_122_I13_D: "Exponential fog density",
  T_49_META_TYP_122_I14_D: "Start distance of linear fog",
  T_49_META_TYP_122_I15_D: "End distance of linear fog",
  T_49_META_TYP_122_I16_D: "Turn on the fog effect feature",
  T_49_META_TYP_122_I17_D: "Rotation angle of main light source",
  T_49_META_TYP_122_I18_D: "Enable the main light source rotation angle feature",
  T_49_META_TYP_122_I2_D: "Light Intensity",
  T_49_META_TYP_122_I3_D: "Darkness",
  T_49_META_TYP_122_I4_D: "Shadow Strength",
  T_49_META_TYP_122_I5_D: "Terrain Wetness",
  T_49_META_TYP_122_I6_D: "Lens Flare",
  T_49_META_TYP_122_I7_D: "Fog Color",
  T_49_META_TYP_122_I8_D: "Ambient Color",
  T_49_META_TYP_123_I0_D: "Day",
  T_49_META_TYP_123_I1_D: "Night",
  T_49_META_TYP_123_I2_D: "Dusk",
  T_49_META_TYP_123_I3_D: "City View",
  T_49_META_TYP_123_I4_D: "Colorful Sky",
  T_49_META_TYP_123_I5_D: "Frost Moon",
  T_49_META_TYP_124_I0_D: "Close Range",
  T_49_META_TYP_124_I1_D: "Medium Range",
  T_49_META_TYP_124_I2_D: "Long range",
  T_49_META_TYP_125_I0_D: "Diffuse Color",
  T_49_META_TYP_125_I2_D: "Diffuse Texture",
  T_49_META_TYP_125_I4_D: "Diffuse Alpha",
  T_49_META_TYP_126_I1_D: "Name",
  T_49_META_TYP_126_I2_D: "Current progress value",
  T_49_META_TYP_126_I3_D: "Maximum progress value",
  T_49_META_TYP_126_I4_D: "Screen coordinate, default is Vector3(0).",
  T_49_META_TYP_126_I5_D: "length of the progress bar, default is the length of the UI on the prefab.",
  T_49_META_TYP_127_I0_D: "Panning along an axis can be combined with three axes.",
  T_49_META_TYP_127_I1_D: "Rotate along an axis, three combinations possible",
  T_49_META_TYP_127_I2_D: "Zoom along an axis, three combinations possible",
  T_49_META_TYP_128_I0_D: "Bushes",
  T_49_META_TYP_128_I1_D: "Pumpkin",
  T_49_META_TYP_128_I2_D: "Scarecrow",
  T_49_META_TYP_128_I3_D: "Cabinet",
  T_49_META_TYP_129_I0_D: "Random Loot",
  T_49_META_TYP_129_I1_D: "AR Ammo",
  T_49_META_TYP_129_I2_D: "SMG Ammo",
  T_49_META_TYP_129_I3_D: "SN Ammo",
  T_49_META_TYP_129_I4_D: "HG Ammo",
  T_49_META_TYP_129_I5_D: "SG Bullets",
  T_49_META_TYP_129_I6_D: "Bow Ammo",
  T_49_META_TYP_13_I1_D: "Anchor coordinates relative to the parent node.",
  T_49_META_TYP_13_I10_D: "Widget and anchor frame size difference",
  T_49_META_TYP_13_I11_D: "Pivot",
  T_49_META_TYP_13_I12_D: "Depth",
  T_49_META_TYP_13_I14_D: "Order of all children in the same parent node",
  T_49_META_TYP_13_I15_D: "ParentID",
  T_49_META_TYP_13_I16_D: "UniqueID",
  T_49_META_TYP_13_I17_D: "Priority",
  T_49_META_TYP_13_I18_D: "Actual Position",
  T_49_META_TYP_13_I2_D: "Width",
  T_49_META_TYP_13_I4_D: "Z-axis rotation angle",
  T_49_META_TYP_13_I6_D: "Internal ID of the widget in the prefab",
  T_49_META_TYP_13_I7_D: "UI entity where it is located",
  T_49_META_TYP_13_I8_D: "Anchor Min",
  T_49_META_TYP_13_I9_D: "Anchor Max",
  T_49_META_TYP_130_I0_D: "Random Consumable Loot",
  T_49_META_TYP_130_I1_D: "MedKit",
  T_49_META_TYP_130_I2_D: "Repair Kit",
  T_49_META_TYP_130_I3_D: "Horizaline",
  T_49_META_TYP_130_I4_D: "Inhaler",
  T_49_META_TYP_131_I0_D: "Random Armor Loot",
  T_49_META_TYP_131_I1_D: "Level 1 Armor",
  T_49_META_TYP_131_I2_D: "Class II Armor",
  T_49_META_TYP_131_I3_D: "Tier 3 Armor",
  T_49_META_TYP_132_I0_D: "Random Throwing Object Loot",
  T_49_META_TYP_132_I1_D: "Grenade",
  T_49_META_TYP_132_I4_D: "Flash Freeze",
  T_49_META_TYP_133_I0_D: "Random Multiplier Loot",
  T_49_META_TYP_133_I1_D: "2x Scope",
  T_49_META_TYP_133_I2_D: "4x Scope",
  T_49_META_TYP_133_I3_D: "Thermal Scope",
  T_49_META_TYP_134_I0_D: "Random Weapon Loot",
  T_49_META_TYP_134_I5_D: "Shotgun",
  T_49_META_TYP_134_I8_D: "Football Gun",
  T_49_META_TYP_135_I0_D: "Loot bullet points",
  T_49_META_TYP_136_I0_D: "Loot Consumable Points",
  T_49_META_TYP_137_I0_D: "Loot Consumable Points",
  T_49_META_TYP_138_I0_D: "Loot Multiplier Points",
  T_49_META_TYP_139_I0_D: "Loot Armor Points",
  T_49_META_TYP_14_I0_D: "Player's current blood level",
  T_49_META_TYP_14_I1_D: "Player's current blood maximum",
  T_49_META_TYP_14_I11_D: "The player's camp",
  T_49_META_TYP_14_I12_D: "The player's damage multiplier, e.g. 2x configured as 2.0",
  T_49_META_TYP_14_I13_D: "Use the exact same rig as the male or female character, 0 means no model replacement",
  T_49_META_TYP_14_I14_D: "Does not conflict with existing velocity scaling",
  T_49_META_TYP_14_I15_D: "Does not conflict with existing jump height scaling",
  T_49_META_TYP_14_I16_D: "Identity,0 Normal Player,1 Hunter,2 Matrix Zombie,3 Normal Zombie,4 Evolved Zombie Type 1, 5 Evolved Zombie Type 2,6 Evolved Zombie Type 3",
  T_49_META_TYP_14_I17_D: "Zombie level, 1~3",
  T_49_META_TYP_14_I19_D: "Player's nickname",
  T_49_META_TYP_14_I2_D: "Determine the current player is AI player, AI is usually NPC or PVE monster",
  T_49_META_TYP_14_I20_D: "Percentage of damage dealt when taking damage, can be reduced or increased",
  T_49_META_TYP_14_I21_D: "Player's current EP",
  T_49_META_TYP_14_I22_D: "Player's maximum EP",
  T_49_META_TYP_14_I23_D: "Primary weapon currently in hand.",
  T_49_META_TYP_14_I24_D: "Is Drop on Eliminated",
  T_49_META_TYP_14_I26_D: "Aim Assist Type",
  T_49_META_TYP_14_I27_D: "Allow Lock by Aim Assist",
  T_49_META_TYP_14_I28_D: "Switch voice chat on/off: true to turn off voice, false to turn on voice",
  T_49_META_TYP_14_I29_D: "Switch quick chat: trueClose voice, falseOpen voice",
  T_49_META_TYP_14_I3_D: "Player Status",
  T_49_META_TYP_14_I30_D: "Channel",
  T_49_META_TYP_14_I35_D: "Switch pickup: trueCan't pickup, falseCan pickup",
  T_49_META_TYP_14_I36_D: "Toggle Discard Item: trueCan't discard, falseCan discard",
  T_49_META_TYP_14_I37_D: "Attackable Targets",
  T_49_META_TYP_14_I38_D: "Friendly Players",
  T_49_META_TYP_14_I39_D: "Faction",
  T_49_META_TYP_14_I4_D: "The player's survival time, if the player dies, the time will be recalculated.",
  T_49_META_TYP_14_I40_D: "Number in Faction",
  T_49_META_TYP_14_I41_D: "Camera the player is using",
  T_49_META_TYP_14_I42_D: "Custom Gravity",
  T_49_META_TYP_14_I43_D: "Helmet",
  T_49_META_TYP_14_I44_D: "Vest",
  T_49_META_TYP_14_I5_D: "Player's invincibility",
  T_49_META_TYP_14_I52_D: "User UID",
  T_49_META_TYP_14_I53_D: "Headshot Damage Reduction",
  T_49_META_TYP_14_I54_D: "AVATAR the player is bound to",
  T_49_META_TYP_14_I55_D: "Gender",
  T_49_META_TYP_14_I56_D: "Weapon Skin IDs",
  T_49_META_TYP_14_I57_D: "Player's spwan point",
  T_49_META_TYP_14_I58_D: "Player's resurrection point, if no checkpoints are recorded then the spwan point is used, otherwise checkpoints are used",
  T_49_META_TYP_14_I59_D: "Player's current position",
  T_49_META_TYP_14_I6_D: "The entity of the team the player belongs to",
  T_49_META_TYP_14_I60_D: "The player's current orientation",
  T_49_META_TYP_14_I61_D: "The node used to access the skinned rigs",
  T_49_META_TYP_14_I62_D: "Backpack",
  T_49_META_TYP_14_I63_D: "Temporary Shield Points",
  T_49_META_TYP_14_I64_D: "Vehicle Skin ID",
  T_49_META_TYP_14_I65_D: "Is Skip Stagger Animation",
  T_49_META_TYP_14_I66_D: "Is No Fall Damage",
  T_49_META_TYP_14_I67_D: "Current Handheld Item",
  T_49_META_TYP_14_I68_D: "Item Pickup Banlist",
  T_49_META_TYP_14_I69_D: "Player's resource ID",
  T_49_META_TYP_14_I7_D: "Current checkpoint ID",
  T_49_META_TYP_14_I70_D: "The target to which the Request Purchase message was sent",
  T_49_META_TYP_14_I71_D: "The resource ID of the currently playing Emote",
  T_49_META_TYP_14_I72_D: "Whether the currently playing Emote is looping or not",
  T_49_META_TYP_14_I73_D: "Handling of knockdown status",
  T_49_META_TYP_14_I74_D: "Whether to enable damage skipping, the default is True, which means it's enabled.",
  T_49_META_TYP_14_I76_D: "Whether to quit in the middle of the game",
  T_49_META_TYP_14_I77_D: "Clothing information to be kept when the player transforms into another character",
  T_49_META_TYP_14_I8_D: "ID of the checkpoint the target is traveling to",
  T_49_META_TYP_140_I0_D: "Wave 1",
  T_49_META_TYP_140_I1_D: "Wave 2",
  T_49_META_TYP_140_I2_D: "Wave 3",
  T_49_META_TYP_140_I3_D: "Continuous",
  T_49_META_TYP_141_I0_D: "Loot Soccer Random",
  T_49_META_TYP_141_I1_D: "Loot Soccer Shield",
  T_49_META_TYP_141_I2_D: "Freezing Grenade",
  T_49_META_TYP_142_I0_D: "Loot Soccer",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF Classic (Shooting)",
  T_49_META_TYP_147_I1_D: "Third Person",
  T_49_META_TYP_147_I2_D: "First Person (Shooting)",
  T_49_META_TYP_147_I3_D: "Top-down perspective",
  T_49_META_TYP_147_I4_D: "Horizontal Scroll",
  T_49_META_TYP_147_I5_D: "Custom",
  T_49_META_TYP_147_I6_D: "Backchase",
  T_49_META_TYP_147_I7_D: "Player-controlled, free-moving camera",
  T_49_META_TYP_147_I8_D: "New version of the first person view camera",
  T_49_META_TYP_148_I0_D: "Provide many preset camera types and customized camera types.",
  T_49_META_TYP_148_I1_D: "Field of view is the camera's viewing angle",
  T_49_META_TYP_148_I10_D: "Camera Switch Animation Type",
  T_49_META_TYP_148_I11_D: "Transition time to this camera in milliseconds, only if the switch type is smooth.",
  T_49_META_TYP_148_I12_D: "Motion mode of the camera when there is an occlusion between the camera and the target.",
  T_49_META_TYP_148_I13_D: "How the camera renders the screen",
  T_49_META_TYP_148_I14_D: "Follow object offset reference coordinate system",
  T_49_META_TYP_148_I15_D: "Observing object offset reference coordinate system",
  T_49_META_TYP_148_I16_D: "The camera's rendering layer mask, which allows filtering the camera's rendered objects by visibility level",
  T_49_META_TYP_148_I17_D: "Viewing Angle Restriction",
  T_49_META_TYP_148_I2_D: "Generally refers to the offset of the camera's position from the player's home position, with different meanings for different camera types.",
  T_49_META_TYP_148_I3_D: "FOV is the offset of the camera's focus point from the player's home position, which varies by camera type.",
  T_49_META_TYP_148_I4_D: "Angle of rotation of the camera in the vertical direction",
  T_49_META_TYP_148_I5_D: "The angle of rotation of the camera in the horizontal direction.",
  T_49_META_TYP_148_I7_D: "The target that the camera is following",
  T_49_META_TYP_148_I8_D: "The target that the camera is looking at",
  T_49_META_TYP_148_I9_D: "The player who is using the camera",
  T_49_META_TYP_15_I0_D: "Whether all players in the team are currently dead",
  T_49_META_TYP_15_I1_D: "List of all players in the team",
  T_49_META_TYP_15_I3_D: "Hostile team list",
  T_49_META_TYP_15_I4_D: "List of friendly teams",
  T_49_META_TYP_15_I5_D: "Team number",
  T_49_META_TYP_150_I0_D: "Durability",
  T_49_META_TYP_150_I1_D: "The radius of the hemispheres at the ends of the capsule body.",
  T_49_META_TYP_150_I2_D: "Damage Factor",
  T_49_META_TYP_152_I1_D: "Custom Gravity",
  T_49_META_TYP_152_I2_D: "If or not need to show the trigger, True is show.",
  T_49_META_TYP_154_I0_D: "Cannot be dual-wielded",
  T_49_META_TYP_154_I1_D: "Can only be dual-wielded in combination with the same gun",
  T_49_META_TYP_154_I2_D: "Can be combo dual-wielded with another weapon as well as yourself",
  T_49_META_TYP_155_I0_D: "Level",
  T_49_META_TYP_155_I1_D: "Max. Durability",
  T_49_META_TYP_155_I2_D: "Current Durability",
  T_49_META_TYP_155_I3_D: "Damage Reduction Factor",
  T_49_META_TYP_155_I4_D: "Explode Damage Reduction Factor",
  T_49_META_TYP_155_I5_D: "Can Cost Durability",
  T_49_META_TYP_155_I6_D: "Can Destroy",
  T_49_META_TYP_156_I1_D: "Max. Durability",
  T_49_META_TYP_156_I2_D: "Current Durability",
  T_49_META_TYP_156_I3_D: "Damage Reduction Factor",
  T_49_META_TYP_156_I4_D: "Explode Damage Reduction Factor",
  T_49_META_TYP_156_I5_D: "Can Cost Durability",
  T_49_META_TYP_156_I6_D: "Can Destroy",
  T_49_META_TYP_157_I0_D: "No Animation",
  T_49_META_TYP_157_I1_D: "Smooth",
  T_49_META_TYP_158_I2_D: "UI anchor type enumeration, default value is 9 (Center)",
  T_49_META_TYP_158_I6_D: "Label Key",
  T_49_META_TYP_158_I7_D: "Label Params",
  T_49_META_TYP_158_I8_D: "Tweener Enabled",
  T_49_META_TYP_16_I1_D: "Item ID of the entity",
  T_49_META_TYP_16_I2_D: "Only for static loading of objects, to determine if the NavMesh is statically generated.",
  T_49_META_TYP_16_I3_D: "Whether it is dynamic blocking of NavMesh or not",
  T_49_META_TYP_16_I4_D: "Asynchronous loading",
  T_49_META_TYP_160_I0_D: "Brick A",
  T_49_META_TYP_160_I1_D: "Tile A",
  T_49_META_TYP_160_I10_D: "Sand A",
  T_49_META_TYP_160_I11_D: "Snow A",
  T_49_META_TYP_160_I12_D: "Wood A",
  T_49_META_TYP_160_I13_D: "Stone A",
  T_49_META_TYP_160_I14_D: "Lawn B",
  T_49_META_TYP_160_I15_D: "Brick B",
  T_49_META_TYP_160_I16_D: "Brick C",
  T_49_META_TYP_160_I17_D: "Clear",
  T_49_META_TYP_160_I2_D: "Tile B",
  T_49_META_TYP_160_I3_D: "Tile C",
  T_49_META_TYP_160_I4_D: "Bamboo A",
  T_49_META_TYP_160_I5_D: "Cement A",
  T_49_META_TYP_160_I6_D: "Container A",
  T_49_META_TYP_160_I7_D: "Lawn A",
  T_49_META_TYP_160_I8_D: "Ice A",
  T_49_META_TYP_160_I9_D: "Magma A",
  T_49_META_TYP_165_I0_D: "Whether to enable collision",
  T_49_META_TYP_165_I1_D: "Whether or not to act as a trigger",
  T_49_META_TYP_165_I2_D: "Physical layers, configure layers in the physics module, up to 16.",
  T_49_META_TYP_166_I0_D: "Emote1",
  T_49_META_TYP_166_I1_D: "Emote2",
  T_49_META_TYP_166_I2_D: "Emote3",
  T_49_META_TYP_166_I3_D: "Emote4",
  T_49_META_TYP_166_I4_D: "Emote5",
  T_49_META_TYP_167_I0_D: "VFX Texture Type",
  T_49_META_TYP_170_I0_D: "Visible or not, client stops rendering the target when it is not visible.",
  T_49_META_TYP_170_I1_D: "Visibility level, value in the range [0,15], affects the visibility in the camera.",
  T_49_META_TYP_171_I0_D: "Energy",
  T_49_META_TYP_172_I0_D: "Number of bullets",
  T_49_META_TYP_173_I0_D: "Extra Backpack Capacity",
  T_49_META_TYP_173_I1_D: "Priority of Skin configuration outside of the player's station.",
  T_49_META_TYP_173_I2_D: "Skin ID of the backpack, Skin configuration of the backpack itself",
  T_49_META_TYP_174_I2_D: "Max. Damage",
  T_49_META_TYP_174_I4_D: "Throw Speed",
  T_49_META_TYP_174_I5_D: "Explosion delay, in seconds",
  T_49_META_TYP_174_I6_D: "Self-Damage Factor",
  T_49_META_TYP_174_I7_D: "Friendly Fire DMG Coeff.",
  T_49_META_TYP_174_I8_D: "Ratio Vehicle Factor",
  T_49_META_TYP_174_I9_D: "Skin",
  T_49_META_TYP_175_I0_D: "Freeze Zone Radius",
  T_49_META_TYP_175_I1_D: "Frozen area duration in seconds",
  T_49_META_TYP_176_I0_D: "Weapon's primary type",
  T_49_META_TYP_176_I1_D: "Weapon Subtype",
  T_49_META_TYP_177_I0_D: "When there is an obstacle between the camera and the object to be followed, the camera will not change.",
  T_49_META_TYP_177_I1_D: "When there is an obstacle between the camera and the object to follow, the camera will be pushed closer to the object to follow.",
  T_49_META_TYP_177_I2_D: "When there is an occlusion between the camera and the object, the occlusion will become translucent.",
  T_49_META_TYP_178_I0_D: "When the camera looks at the object, the near object is big and the far object is small",
  T_49_META_TYP_178_I1_D: "Near and far objects are the same size when the camera is looking at them.",
  T_49_META_TYP_184_I0_D: "The UUID of the resource to be rendered.",
  T_49_META_TYP_185_I0_D: "Model mesh to use for rendering",
  T_49_META_TYP_185_I1_D: "The list of materials to use for rendering",
  T_49_META_TYP_187_I0_D: "Item ID",
  T_49_META_TYP_190_I0_D: "Open status",
  T_49_META_TYP_190_I1_D: "Match result",
  T_49_META_TYP_190_I10_D: "Scores1",
  T_49_META_TYP_190_I11_D: "Scores2",
  T_49_META_TYP_190_I12_D: "Scores3",
  T_49_META_TYP_190_I13_D: "Win MVPs",
  T_49_META_TYP_190_I14_D: "Lose MVPs",
  T_49_META_TYP_190_I15_D: "Show Match Details",
  T_49_META_TYP_190_I16_D: "Show Map Ratings",
  T_49_META_TYP_190_I17_D: "Show Gift",
  T_49_META_TYP_190_I18_D: "Show Report",
  T_49_META_TYP_190_I19_D: "Show Replay",
  T_49_META_TYP_190_I20_D: "Show Share",
  T_49_META_TYP_190_I21_D: "Show Lobby",
  T_49_META_TYP_190_I22_D: "Show Like",
  T_49_META_TYP_190_I23_D: "Show Add Friend",
  T_49_META_TYP_190_I24_D: "Show Ecconomy",
  T_49_META_TYP_190_I4_D: "Left Team",
  T_49_META_TYP_190_I5_D: "Right Team",
  T_49_META_TYP_190_I6_D: "Player Rank",
  T_49_META_TYP_190_I9_D: "Titles",
  T_49_META_TYP_191_I0_D: "Center Range",
  T_49_META_TYP_191_I4_D: "Center flash duration in milliseconds",
  T_49_META_TYP_191_I5_D: "Edge flash duration in milliseconds",
  T_49_META_TYP_191_I6_D: "Flashbang Hit Effect Switch",
  T_49_META_TYP_192_I3_D: "Duration of effect, in seconds",
  T_49_META_TYP_193_I1_D: "Match Title Left",
  T_49_META_TYP_193_I10_D: "Scores1",
  T_49_META_TYP_193_I11_D: "Scores2",
  T_49_META_TYP_193_I12_D: "Scores3",
  T_49_META_TYP_193_I13_D: "Scores4",
  T_49_META_TYP_193_I14_D: "Scores5",
  T_49_META_TYP_193_I15_D: "Win MVPs",
  T_49_META_TYP_193_I16_D: "Lose MVPs",
  T_49_META_TYP_193_I17_D: "Show Match Details",
  T_49_META_TYP_193_I18_D: "Show Map Ratings",
  T_49_META_TYP_193_I19_D: "Show Gift",
  T_49_META_TYP_193_I2_D: "Match Title Right",
  T_49_META_TYP_193_I20_D: "Show Report",
  T_49_META_TYP_193_I21_D: "Show Replay",
  T_49_META_TYP_193_I22_D: "Show Share",
  T_49_META_TYP_193_I23_D: "Show Lobby",
  T_49_META_TYP_193_I24_D: "Show Like",
  T_49_META_TYP_193_I25_D: "Show Add Friend",
  T_49_META_TYP_193_I26_D: "Show Ecconomy",
  T_49_META_TYP_193_I3_D: "Match result",
  T_49_META_TYP_193_I4_D: "Team Rank",
  T_49_META_TYP_193_I5_D: "Player Rank",
  T_49_META_TYP_193_I6_D: "Name of the team",
  T_49_META_TYP_193_I7_D: "Main Score Title",
  T_49_META_TYP_193_I8_D: "Main Scores",
  T_49_META_TYP_193_I9_D: "Titles",
  T_49_META_TYP_194_I0_D: "Time for the mine to take effect, in seconds",
  T_49_META_TYP_194_I1_D: "Trigger radius",
  T_49_META_TYP_194_I2_D: "Length of time it takes to trigger a mine within the mine's range, in seconds",
  T_49_META_TYP_194_I3_D: "Can Self Trigger",
  T_49_META_TYP_194_I4_D: "Can Teammates Trigger",
  T_49_META_TYP_194_I5_D: "Can Triggered by Vehicle",
  T_49_META_TYP_194_I6_D: "Duration of the mine's existence, which automatically explodes when it ends, from the time it is dropped, in units of seconds",
  T_49_META_TYP_194_I7_D: "Is Attackable",
  T_49_META_TYP_194_I8_D: "Life value",
  T_49_META_TYP_195_I0_D: "Once",
  T_49_META_TYP_195_I2_D: "Reciprocation",
  T_49_META_TYP_197_I0_D: "Whether the wave is playing or not",
  T_49_META_TYP_197_I1_D: "Flag bit",
  T_49_META_TYP_197_I2_D: "If checked, it will be played automatically upon creation.",
  T_49_META_TYP_198_I0_D: "The prop id of the accessory.",
  T_49_META_TYP_199_I0_D: "Max EP",
  T_49_META_TYP_199_I1_D: "Energy Cost",
  T_49_META_TYP_199_I10_D: "Fall Damage Ratio",
  T_49_META_TYP_199_I11_D: "Current Energy",
  T_49_META_TYP_199_I2_D: "UpEnergy Cost",
  T_49_META_TYP_199_I3_D: "Sprint Energy Cost",
  T_49_META_TYP_199_I4_D: "Rush Energy Cost",
  T_49_META_TYP_199_I5_D: "Base Horizontal Speed",
  T_49_META_TYP_199_I6_D: "Sprint Horizontal Speed",
  T_49_META_TYP_199_I7_D: "Base Vertical Speed",
  T_49_META_TYP_199_I8_D: "Sprint Vertical Speed",
  T_49_META_TYP_199_I9_D: "Sprint Distance",
  T_49_META_TYP_200_I0_D: "Area ID",
  T_49_META_TYP_200_I1_D: "Game ID",
  T_49_META_TYP_201_I0_D: "Percentage of slowdown: Percentage of slowdown of movement speed in open water for water objects",
  T_49_META_TYP_203_I0_D: "target entity",
  T_49_META_TYP_203_I1_D: "Prop ID",
  T_49_META_TYP_203_I10_D: "The moment when the game server starts ticking",
  T_49_META_TYP_203_I11_D: "Start Value",
  T_49_META_TYP_203_I12_D: "End Value",
  T_49_META_TYP_203_I13_D: "Percentage passed",
  T_49_META_TYP_203_I4_D: "Tween Style",
  T_49_META_TYP_203_I6_D: "Duration (s)",
  T_49_META_TYP_203_I7_D: "Is Reverse",
  T_49_META_TYP_203_I8_D: "Control Points",
  T_49_META_TYP_203_I9_D: "Forced synchronization of the game server state",
  T_49_META_TYP_204_I0_D: "Max. Double Jump Height",
  T_49_META_TYP_204_I1_D: "Fall Damage Percentage",
  T_49_META_TYP_204_I2_D: "Energy Recovery",
  T_49_META_TYP_204_I3_D: "Energy consumption",
  T_49_META_TYP_204_I4_D: "Max. Energy",
  T_49_META_TYP_205_I0_D: "Min. Fly Height",
  T_49_META_TYP_205_I1_D: "Min. End Height",
  T_49_META_TYP_205_I2_D: "Horizontal Glide Speed",
  T_49_META_TYP_205_I3_D: "Vertical Glide Speed",
  T_49_META_TYP_205_I4_D: "Fall Speed",
  T_49_META_TYP_205_I5_D: "Turning Speed",
  T_49_META_TYP_205_I6_D: "Fly Max. Height",
  T_49_META_TYP_205_I7_D: "Overheight Fall Speed",
  T_49_META_TYP_205_I8_D: "Speed change acceleration",
  T_49_META_TYP_206_I0_D: "Velocity",
  T_49_META_TYP_206_I1_D: "Acceleration",
  T_49_META_TYP_206_I10_D: "Maximum steering angle at high speed",
  T_49_META_TYP_206_I11_D: "Tween base rate of high speed steering angle",
  T_49_META_TYP_206_I2_D: "Sprint Speed",
  T_49_META_TYP_206_I3_D: "Duration of sprint, in seconds",
  T_49_META_TYP_206_I4_D: "Sprint cooldown, in seconds",
  T_49_META_TYP_206_I6_D: "Jump CD, in seconds",
  T_49_META_TYP_206_I7_D: "Sprint CD after boarding, in seconds",
  T_49_META_TYP_206_I8_D: "Get On Boost CD Switch",
  T_49_META_TYP_206_I9_D: "Get on board CD, in seconds",
  T_49_META_TYP_207_I1_D: "Start Index",
  T_49_META_TYP_207_I2_D: "End Position",
  T_49_META_TYP_207_I3_D: "Slide ID",
  T_49_META_TYP_207_I4_D: "Group ID",
  T_49_META_TYP_207_I5_D: "End or not",
  T_49_META_TYP_21_I0_D: "The base level of the UI",
  T_49_META_TYP_210_I1_D: "Initial Velocity",
  T_49_META_TYP_210_I2_D: "Acceleration",
  T_49_META_TYP_210_I3_D: "Max. Displacement",
  T_49_META_TYP_210_I4_D: "InitialWorldPosition",
  T_49_META_TYP_210_I5_D: "Forced synchronization of position information by game server",
  T_49_META_TYP_211_I0_D: "Local Position",
  T_49_META_TYP_211_I1_D: "World Position",
  T_49_META_TYP_212_I0_D: "Self",
  T_49_META_TYP_212_I2_D: "Offset coordinate",
  T_49_META_TYP_213_I0_D: "Self",
  T_49_META_TYP_213_I2_D: "Offset coordinate",
  T_49_META_TYP_215_I0_D: "Victory",
  T_49_META_TYP_215_I1_D: "Defeat",
  T_49_META_TYP_215_I2_D: "Booyah",
  T_49_META_TYP_215_I3_D: "Draw",
  T_49_META_TYP_218_I0_D: "Intensity",
  T_49_META_TYP_218_I1_D: "Range",
  T_49_META_TYP_218_I2_D: "Light color",
  T_49_META_TYP_22_I0_D: "Displayed if on is true, off otherwise",
  T_49_META_TYP_22_I1_D: "Prefab ID",
  T_49_META_TYP_22_I2_D: "The ID of the current largest widget",
  T_49_META_TYP_22_I3_D: "Base level of UI",
  T_49_META_TYP_22_I4_D: "Enable Player View",
  T_49_META_TYP_22_I5_D: "World Position",
  T_49_META_TYP_22_I6_D: "Whether or not it is in the Scene",
  T_49_META_TYP_22_I7_D: "Rotation in the world coordinate system",
  T_49_META_TYP_22_I8_D: "Zoom in the world coordinate system",
  T_49_META_TYP_221_I0_D: "The larger the value, the slower the speed of gear change.",
  T_49_META_TYP_222_I0_D: "Gear switching delay, the larger this value is, the slower the gear changes.",
  T_49_META_TYP_225_I0_D: "Turret Damage",
  T_49_META_TYP_225_I1_D: "Damage Interval (s)",
  T_49_META_TYP_225_I10_D: "Fire only at an angle",
  T_49_META_TYP_225_I11_D: "Damage Reduction Rate",
  T_49_META_TYP_225_I12_D: "Armor Penetration",
  T_49_META_TYP_225_I2_D: "Accuracy",
  T_49_META_TYP_225_I3_D: "Range",
  T_49_META_TYP_225_I4_D: "Angular Speed",
  T_49_META_TYP_225_I5_D: "Angle Up",
  T_49_META_TYP_225_I6_D: "Angle Down",
  T_49_META_TYP_225_I7_D: "Max. HP",
  T_49_META_TYP_225_I8_D: "Life Time (s)",
  T_49_META_TYP_225_I9_D: "Max. Turret Count",
  T_49_META_TYP_226_I0_D: "Turret current life value",
  T_49_META_TYP_226_I1_D: "Enable Attack",
  T_49_META_TYP_227_I0_D: "Simple Widget",
  T_49_META_TYP_227_I1_D: "Image Widget",
  T_49_META_TYP_227_I10_D: "Texture Widget",
  T_49_META_TYP_227_I11_D: "Profile Widget",
  T_49_META_TYP_227_I12_D: "Toggle Widget",
  T_49_META_TYP_227_I13_D: "Touch Pad Widget",
  T_49_META_TYP_227_I14_D: "Joystick Widget",
  T_49_META_TYP_227_I15_D: "Social Button Widget",
  T_49_META_TYP_227_I2_D: "Label Widget",
  T_49_META_TYP_227_I3_D: "Button Widget",
  T_49_META_TYP_227_I4_D: "Input Label Widget",
  T_49_META_TYP_227_I5_D: "Panel",
  T_49_META_TYP_227_I6_D: "Scroll Panel",
  T_49_META_TYP_227_I7_D: "Grid",
  T_49_META_TYP_227_I8_D: "Layout Widget",
  T_49_META_TYP_227_I9_D: "Container Widget",
  T_49_META_TYP_231_I0_D: "Durability Recovery",
  T_49_META_TYP_231_I1_D: "Effective time interval, in seconds",
  T_49_META_TYP_233_I2_D: "Time to expiration, in seconds",
  T_49_META_TYP_233_I4_D: "Icon resource name",
  T_49_META_TYP_234_I0_D: "Trigger time, in seconds",
  T_49_META_TYP_234_I1_D: "Can Self Trigger",
  T_49_META_TYP_234_I10_D: "Current life value",
  T_49_META_TYP_234_I2_D: "Can Teammates Trigger",
  T_49_META_TYP_234_I3_D: "Can Triggered by Vehicle",
  T_49_META_TYP_234_I4_D: "Duration in seconds",
  T_49_META_TYP_234_I5_D: "Is Attackable",
  T_49_META_TYP_234_I6_D: "Life value",
  T_49_META_TYP_235_I0_D: "Maximum life value",
  T_49_META_TYP_235_I2_D: "Max. Count",
  T_49_META_TYP_237_I0_D: "Throw Speed",
  T_49_META_TYP_237_I1_D: "Player Traction Speed",
  T_49_META_TYP_238_I0_D: "Spray Color",
  T_49_META_TYP_239_I0_D: "Initial speed",
  T_49_META_TYP_239_I1_D: "Acceleration speed (e.g. gravity)",
  T_49_META_TYP_24_I0_D: "Melee",
  T_49_META_TYP_24_I1_D: "Gun",
  T_49_META_TYP_24_I10_D: "Airdrop hit damage, monster suicide damage",
  T_49_META_TYP_24_I11_D: "Burning Damage on Vehicle Explosion",
  T_49_META_TYP_24_I12_D: "Oil Drum Explosion",
  T_49_META_TYP_24_I13_D: "Missile-Type Weapon",
  T_49_META_TYP_24_I14_D: "Monster",
  T_49_META_TYP_24_I15_D: "Damage Zone",
  T_49_META_TYP_24_I17_D: "Character Skill",
  T_49_META_TYP_24_I2_D: "Throw Attack",
  T_49_META_TYP_24_I3_D: "Safe Zone",
  T_49_META_TYP_24_I4_D: "Vehicle",
  T_49_META_TYP_24_I5_D: "Falling",
  T_49_META_TYP_24_I6_D: "KillZone",
  T_49_META_TYP_24_I7_D: "Exit",
  T_49_META_TYP_24_I8_D: "Disconnect",
  T_49_META_TYP_24_I9_D: "Vehicle Explosion",
  T_49_META_TYP_241_I0_D: "Traction speed",
  T_49_META_TYP_241_I1_D: "Swing speed",
  T_49_META_TYP_241_I2_D: "Turn on traction button",
  T_49_META_TYP_241_I3_D: "Turn on swing button",
  T_49_META_TYP_241_I4_D: "Motion anchor point",
  T_49_META_TYP_241_I5_D: "Swing Exit Acceleration",
  T_49_META_TYP_242_I2_D: "Left Effect Active",
  T_49_META_TYP_242_I3_D: "Right Effect Active",
  T_49_META_TYP_242_I4_D: "Central Line Active",
  T_49_META_TYP_242_I5_D: "Value",
  T_49_META_TYP_242_I7_D: "UI position, only the XY component is active",
  T_49_META_TYP_242_I8_D: "Position of the median [0,1]",
  T_49_META_TYP_243_I0_D: "Top Wear",
  T_49_META_TYP_243_I1_D: "Bottom Wear",
  T_49_META_TYP_243_I2_D: "Shoes",
  T_49_META_TYP_243_I3_D: "Facepaint",
  T_49_META_TYP_243_I4_D: "Headwear",
  T_49_META_TYP_243_I5_D: "Bodysuit",
  T_49_META_TYP_243_I6_D: "Facepaint",
  T_49_META_TYP_244_I0_D: "Text content to be displayed",
  T_49_META_TYP_244_I10_D: "List of players who can see this entity",
  T_49_META_TYP_244_I11_D: "Display level",
  T_49_META_TYP_244_I2_D: "Follow Target",
  T_49_META_TYP_244_I3_D: "When depth is ignored it can be displayed through the wall, otherwise it won't work",
  T_49_META_TYP_244_I4_D: "Always Facing Camera",
  T_49_META_TYP_244_I5_D: "When set to true, when the position is outside the screen, it will be displayed inside the screen.",
  T_49_META_TYP_244_I6_D: "Font Style",
  T_49_META_TYP_244_I7_D: "Font type",
  T_49_META_TYP_244_I8_D: "Font size",
  T_49_META_TYP_245_I0_D: "Effect Resource Path",
  T_49_META_TYP_245_I11_D: "Display Layers",
  T_49_META_TYP_245_I3_D: "When ignore depth, it can be displayed through the wall, otherwise it won't work.",
  T_49_META_TYP_245_I4_D: "When set to true, when the position is outside the screen, it will be displayed inside the screen.",
  T_49_META_TYP_245_I5_D: "Always Facing Camera",
  T_49_META_TYP_245_I6_D: "Render Type",
  T_49_META_TYP_245_I7_D: "Width",
  T_49_META_TYP_246_I0_D: "Orange",
  T_49_META_TYP_246_I1_D: "Purple",
  T_49_META_TYP_246_I2_D: "Red",
  T_49_META_TYP_246_I3_D: "Green",
  T_49_META_TYP_246_I4_D: "Blue",
  T_49_META_TYP_247_I1_D: "Sprint",
  T_49_META_TYP_247_I14_D: "Emote",
  T_49_META_TYP_247_I15_D: "Quick Chat",
  T_49_META_TYP_247_I16_D: "Pickups",
  T_49_META_TYP_247_I17_D: "Quick Chat Show",
  T_49_META_TYP_247_I18_D: "HP",
  T_49_META_TYP_247_I19_D: "EP",
  T_49_META_TYP_247_I2_D: "Attack",
  T_49_META_TYP_247_I20_D: "Armor",
  T_49_META_TYP_247_I21_D: "Reload",
  T_49_META_TYP_247_I22_D: "Quick Change Button",
  T_49_META_TYP_247_I23_D: "Carrier Speaker Button",
  T_49_META_TYP_247_I24_D: "Enable/disable voice (microphone) button",
  T_49_META_TYP_247_I25_D: "Enable/disable marker button",
  T_49_META_TYP_247_I27_D: "Enable/disable network signal button",
  T_49_META_TYP_247_I28_D: "Active Skill",
  T_49_META_TYP_247_I29_D: "Crosshair",
  T_49_META_TYP_247_I3_D: "Jump",
  T_49_META_TYP_247_I30_D: "Passive Skill",
  T_49_META_TYP_247_I4_D: "Killing Tips",
  T_49_META_TYP_247_I5_D: "Weapon Slot",
  T_49_META_TYP_247_I6_D: "Mini Map",
  T_49_META_TYP_247_I7_D: "Backpack UI",
  T_49_META_TYP_247_I8_D: "Medical Items",
  T_49_META_TYP_247_I9_D: "Displayed when True, otherwise turned off",
  T_49_META_TYP_249_I3_D: "Demolition weapons",
  T_49_META_TYP_249_I5_D: "HeavyWeapon",
  T_49_META_TYP_249_I8_D: "Freeze Bomb",
  T_49_META_TYP_249_I9_D: "DummyGrenade",
  T_49_META_TYP_25_I0_D: "Index of the current phase, corresponding to the index in the flow editor",
  T_49_META_TYP_25_I1_D: "Start time of the current phase, in ms.",
  T_49_META_TYP_25_I2_D: "The end time of the current phase in ms.",
  T_49_META_TYP_25_I3_D: "Duration of the current phase in ms.",
  T_49_META_TYP_250_I1_D: "Special effect color, RGBA four channels, single channel value range 0~255, stored in an Int32.",
  T_49_META_TYP_250_I3_D: "VFX Texture Type",
  T_49_META_TYP_250_I4_D: "Diffuse Alpha",
  T_49_META_TYP_2500_I1_D: "Is Default Spawn Point",
  T_49_META_TYP_2500_I3_D: "Whether or not a player has already been born in the birth point area.",
  T_49_META_TYP_2500_I4_D: "The coordinates of the currently assignable birth point location",
  T_49_META_TYP_2502_I0_D: "Whether it is a death trigger, when it is not a death trigger it is an invincibility trigger. (This is a legacy issue from OB32, please split the function in the future!)",
  T_49_META_TYP_2502_I1_D: "Whether to show trigger border, true for show",
  T_49_META_TYP_2503_I0_D: "Checkpoint ID",
  T_49_META_TYP_2503_I2_D: "Location of checkpoints",
  T_49_META_TYP_2507_I0_D: "Which camp the tower belongs to, if it is the same as the player, it won't attack the player.",
  T_49_META_TYP_2507_I1_D: "HP",
  T_49_META_TYP_2507_I10_D: "Object ID",
  T_49_META_TYP_2507_I2_D: "Max. HP",
  T_49_META_TYP_2507_I3_D: "Attack damage, the damage that can be done to the player by a single attack.",
  T_49_META_TYP_2507_I4_D: "The interval between attacks, in seconds.",
  T_49_META_TYP_2507_I5_D: "Attacks can be made in a radius from the center of the tower.",
  T_49_META_TYP_2507_I6_D: "Damage reduction rate, a decimal number less than 1, the final damage is the damage multiplied by (1 - damage reduction rate)",
  T_49_META_TYP_2507_I7_D: "Attack Target",
  T_49_META_TYP_2507_I8_D: "Angle",
  T_49_META_TYP_2507_I9_D: "Mini Sentry Status",
  T_49_META_TYP_2508_I0_D: "How many zombies will be spawned in each wave",
  T_49_META_TYP_2508_I1_D: "How many waves of zombies will be spawned in total",
  T_49_META_TYP_2508_I2_D: "Whether to spawn continuously, but there will be an upper limit for the same screen.",
  T_49_META_TYP_2508_I3_D: "How many waves will be spawned in the current wave?",
  T_49_META_TYP_2508_I5_D: "What kind of zombies are spawned in the current wave",
  T_49_META_TYP_2508_I6_D: "Whether the AI drops equipment or items when it dies.",
  T_49_META_TYP_2508_I7_D: "Start Spawn Time (s)",
  T_49_META_TYP_2508_I8_D: "The time interval between the next wave and the previous wave.",
  T_49_META_TYP_2509_I0_D: "The number of unit bodies that will be generated in each wave",
  T_49_META_TYP_2509_I1_D: "How many waves of unit generators will be generated in total",
  T_49_META_TYP_2509_I2_D: "How many waves are currently generated",
  T_49_META_TYP_2509_I4_D: "Which entity will be used as a template for each wave of generation",
  T_49_META_TYP_2509_I5_D: "When the units will start generating",
  T_49_META_TYP_2509_I6_D: "Whether or not to spawn consecutively, but there will be an upper limit of the same screen",
  T_49_META_TYP_2509_I7_D: "The time interval between the next wave and the previous wave.",
  T_49_META_TYP_2509_I8_D: "The prefabID of the template",
  T_49_META_TYP_2510_I0_D: "Spawn Point Count",
  T_49_META_TYP_252_I1_D: "Left Icon",
  T_49_META_TYP_252_I2_D: "Left Text",
  T_49_META_TYP_252_I3_D: "Left Score",
  T_49_META_TYP_252_I5_D: "Right Icon",
  T_49_META_TYP_252_I6_D: "Right Text",
  T_49_META_TYP_252_I7_D: "Right Score",
  T_49_META_TYP_252_I8_D: "Progress [0,1]",
  T_49_META_TYP_253_I0_D: "Select Icon",
  T_49_META_TYP_253_I1_D: "Text",
  T_49_META_TYP_253_I2_D: "Show Effect",
  T_49_META_TYP_253_I3_D: "UI position",
  T_49_META_TYP_254_I1_D: "For example, 1.25 means 1.25 times the normal speed.",
  T_49_META_TYP_254_I2_D: "Color",
  T_49_META_TYP_256_I0_D: "Completely stationary. Minimum Performance",
  T_49_META_TYP_256_I1_D: "Normal force application. Least performance",
  T_49_META_TYP_256_I2_D: "Motion can be controlled by scripting and can be considered as mass infinite",
  T_49_META_TYP_257_I0_D: "Functions of different types of rigid bodies",
  T_49_META_TYP_257_I1_D: "Use Gravity",
  T_49_META_TYP_257_I2_D: "Mass (kg), the minimum effective mass is 0.001kg, if it is 0, then it is infinite mass and will not move under force.",
  T_49_META_TYP_257_I3_D: "Position of the center of gravity, local coordinate system",
  T_49_META_TYP_257_I4_D: "Linear velocity of rigid body motion",
  T_49_META_TYP_257_I5_D: "Angular velocity of rigid body motion",
  T_49_META_TYP_257_I6_D: "Coefficient of natural decay of linear velocity, the larger the coefficient, the faster the decay of velocity.",
  T_49_META_TYP_257_I7_D: "Angular velocity natural decay coefficient, the larger the coefficient, the faster the velocity decays.",
  T_49_META_TYP_257_I8_D: "The constraints imposed on the rigid body, a collection of RigidbodyConstrainType.",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "Background",
  T_49_META_TYP_259_I1_D: "Text",
  T_49_META_TYP_259_I2_D: "UI position",
  T_49_META_TYP_259_I4_D: "Text Color",
  T_49_META_TYP_260_I0_D: "Select Icon",
  T_49_META_TYP_260_I1_D: "Progress bar color",
  T_49_META_TYP_260_I2_D: "Value",
  T_49_META_TYP_260_I3_D: "Speed in m/s",
  T_49_META_TYP_260_I4_D: "Whether to display special effects",
  T_49_META_TYP_260_I5_D: "UI position [0,1].",
  T_49_META_TYP_260_I6_D: "Initial progress of the skill, value [0, 1], the progress will be synchronized to the current progress immediately after the UI is created.",
  T_49_META_TYP_260_I7_D: "Effect Color",
  T_49_META_TYP_260_I8_D: "Set the object scaling value",
  T_49_META_TYP_265_I1_D: "Background fill or not",
  T_49_META_TYP_265_I2_D: "Background Name",
  T_49_META_TYP_265_I3_D: "Background Color",
  T_49_META_TYP_265_I5_D: "BgAlpha",
  T_49_META_TYP_265_I6_D: "Crop type",
  T_49_META_TYP_265_I7_D: "Mask type is the name of the image selected for masking",
  T_49_META_TYP_265_I8_D: "Edge softening unit",
  T_49_META_TYP_267_I0_D: "Scroll start point, default is top left corner.",
  T_49_META_TYP_267_I1_D: "Support multiple scrolling directions",
  T_49_META_TYP_267_I10_D: "Horizontal Bar",
  T_49_META_TYP_267_I11_D: "Show position",
  T_49_META_TYP_267_I2_D: "XY direction drag component",
  T_49_META_TYP_267_I3_D: "Support multiple dragging effects",
  T_49_META_TYP_267_I4_D: "Scroll factor, the larger the value, the faster the scrolling.",
  T_49_META_TYP_267_I5_D: "Inertia factor, the larger the value, the larger the inertia when scrolling.",
  T_49_META_TYP_267_I6_D: "If or not the drag is limited to the viewport, default is checked.",
  T_49_META_TYP_267_I7_D: "When checked, the drag will start to move slowly, if unchecked, the drag will start to move at the speed of the mouse.",
  T_49_META_TYP_267_I8_D: "Exit dragging when it fits in the viewport.",
  T_49_META_TYP_267_I9_D: "Vertical Bar",
  T_49_META_TYP_268_I0_D: "Default",
  T_49_META_TYP_268_I1_D: "Close",
  T_49_META_TYP_268_I2_D: "Show",
  T_49_META_TYP_269_I0_D: "Owner",
  T_49_META_TYP_269_I1_D: "Set ID",
  T_49_META_TYP_269_I2_D: "Headwear ID",
  T_49_META_TYP_269_I3_D: "Face ID",
  T_49_META_TYP_269_I4_D: "Makeup ID",
  T_49_META_TYP_269_I5_D: "Upper Body ID",
  T_49_META_TYP_269_I6_D: "Bottom ID",
  T_49_META_TYP_269_I7_D: "Shoe ID",
  T_49_META_TYP_272_I0_D: "Female",
  T_49_META_TYP_272_I1_D: "Male",
  T_49_META_TYP_273_I0_D: "World coordinates of the center of the mini-map",
  T_49_META_TYP_273_I1_D: "Size of the mini-map, same width and height",
  T_49_META_TYP_273_I2_D: "Enable or disable the depth map display mode of the mini-map",
  T_49_META_TYP_274_I1_D: "Zoom size",
  T_49_META_TYP_274_I4_D: "Icon display level",
  T_49_META_TYP_275_I0_D: "Skeleton Scale",
  T_49_META_TYP_275_I1_D: "World coordinates of rig nodes",
  T_49_META_TYP_276_I0_D: "Head",
  T_49_META_TYP_276_I1_D: "Left Arm",
  T_49_META_TYP_276_I2_D: "Left Hand",
  T_49_META_TYP_276_I3_D: "Right Arm",
  T_49_META_TYP_276_I4_D: "Right Hand",
  T_49_META_TYP_276_I5_D: "Torso",
  T_49_META_TYP_276_I6_D: "Left Leg",
  T_49_META_TYP_276_I7_D: "Left Foot",
  T_49_META_TYP_276_I8_D: "Right Leg",
  T_49_META_TYP_276_I9_D: "Right Foot",
  T_49_META_TYP_277_I1_D: "Distance for camera ray detection",
  T_49_META_TYP_277_I2_D: "Collision layer mask for camera ray detection",
  T_49_META_TYP_277_I3_D: "Button position offset",
  T_49_META_TYP_277_I4_D: "Icon resource ID",
  T_49_META_TYP_277_I5_D: "Click area size",
  T_49_META_TYP_277_I6_D: "Whether objects are displayed at the target point",
  T_49_META_TYP_277_I7_D: "Objects displayed at the target point",
  T_49_META_TYP_278_I0_D: "Target entity for generating map pixels",
  T_49_META_TYP_28_I0_D: "Whether or not the team can reset every round.",
  T_49_META_TYP_280_I0_D: "Sphere radius",
  T_49_META_TYP_281_I0_D: "The radius of the hemispheres at both ends of the capsule.",
  T_49_META_TYP_29_I0_D: "Sphere",
  T_49_META_TYP_29_I1_D: "Light Beam",
  T_49_META_TYP_29_I10_D: "A pillar of light under the feet, now used for feedback when entering the finish line",
  T_49_META_TYP_29_I11_D: "Freeze",
  T_49_META_TYP_29_I12_D: "Light",
  T_49_META_TYP_29_I13_D: "Updraft",
  T_49_META_TYP_29_I14_D: "Gas Explosion",
  T_49_META_TYP_29_I15_D: "Hider Eliminated",
  T_49_META_TYP_29_I16_D: "Rampage",
  T_49_META_TYP_29_I17_D: "Clone Death",
  T_49_META_TYP_29_I18_D: "Shooting Feedback",
  T_49_META_TYP_29_I19_D: "Clone Death",
  T_49_META_TYP_29_I2_D: "Boom",
  T_49_META_TYP_29_I20_D: "Clone",
  T_49_META_TYP_29_I21_D: "Portal",
  T_49_META_TYP_29_I22_D: "Flashbang Smoke",
  T_49_META_TYP_29_I23_D: "Fireball",
  T_49_META_TYP_29_I24_D: "Burning in a Loop",
  T_49_META_TYP_29_I25_D: "Poison Gas",
  T_49_META_TYP_29_I26_D: "Heart",
  T_49_META_TYP_29_I29_D: "Door",
  T_49_META_TYP_29_I30_D: "Fireworks",
  T_49_META_TYP_29_I31_D: "Running Shoes VFX",
  T_49_META_TYP_29_I32_D: "Explosion VFX",
  T_49_META_TYP_29_I33_D: "Spawn Point VFX",
  T_49_META_TYP_29_I34_D: "Laser VFX",
  T_49_META_TYP_29_I35_D: "Skill Cast VFX",
  T_49_META_TYP_29_I36_D: "Bullet VFX",
  T_49_META_TYP_29_I37_D: "Bullet Hit VFX",
  T_49_META_TYP_29_I38_D: "Shooting VFX",
  T_49_META_TYP_29_I39_D: "Skill VFX",
  T_49_META_TYP_29_I40_D: "Halo",
  T_49_META_TYP_29_I41_D: "Bubbles",
  T_49_META_TYP_29_I42_D: "Smoke and Dust",
  T_49_META_TYP_29_I43_D: "Flying Debris",
  T_49_META_TYP_29_I44_D: "Lines",
  T_49_META_TYP_29_I45_D: "Flicker",
  T_49_META_TYP_29_I47_D: "Rising Particles",
  T_49_META_TYP_29_I48_D: "Smoke",
  T_49_META_TYP_29_I49_D: "Talisman",
  T_49_META_TYP_29_I50_D: "Frozen Area",
  T_49_META_TYP_29_I51_D: "Fog",
  T_49_META_TYP_29_I52_D: "Snowflake",
  T_49_META_TYP_29_I53_D: "Fire",
  T_49_META_TYP_29_I54_D: "Light Beam",
  T_49_META_TYP_29_I55_D: "Diffusing Poison Gas",
  T_49_META_TYP_29_I56_D: "Poison Gas",
  T_49_META_TYP_29_I57_D: "Explosion Flames",
  T_49_META_TYP_29_I58_D: "Light Effect",
  T_49_META_TYP_29_I59_D: "Star",
  T_49_META_TYP_29_I6_D: "Foot Halo",
  T_49_META_TYP_29_I60_D: "Blazing Bonfire",
  T_49_META_TYP_29_I61_D: "Water Splash",
  T_49_META_TYP_29_I62_D: "Electric Shock",
  T_49_META_TYP_29_I63_D: "Ink VFX",
  T_49_META_TYP_29_I64_D: "Blackhole VFX",
  T_49_META_TYP_29_I65_D: "Blackhole Explosion VFX",
  T_49_META_TYP_29_I66_D: "Crystal Ball VFX",
  T_49_META_TYP_29_I67_D: "Laser bullet effect",
  T_49_META_TYP_29_I68_D: "Drag effects",
  T_49_META_TYP_29_I69_D: "Clouds",
  T_49_META_TYP_29_I7_D: "Ground Marker",
  T_49_META_TYP_29_I8_D: "Smoke",
  T_49_META_TYP_29_I9_D: "Talisman Explosion",
  T_49_META_TYP_290_I0_D: "Refresh interval, the larger the number, the slower the refresh, in milliseconds.",
  T_49_META_TYP_290_I1_D: "Whether to enable debugging",
  T_49_META_TYP_291_I0_D: "Condition Node",
  T_49_META_TYP_291_I1_D: "Action Node",
  T_49_META_TYP_293_I0_D: "Behavior Tree ID",
  T_49_META_TYP_293_I1_D: "Attach Target",
  T_49_META_TYP_294_I1_D: "Layout Type",
  T_49_META_TYP_294_I10_D: "Sort Order",
  T_49_META_TYP_294_I2_D: "Content Origin",
  T_49_META_TYP_294_I3_D: "Alignment direction",
  T_49_META_TYP_294_I4_D: "Width and height of the sub-item grid",
  T_49_META_TYP_294_I5_D: "Cell Space",
  T_49_META_TYP_294_I6_D: "Constraint",
  T_49_META_TYP_294_I7_D: "Constraint Count",
  T_49_META_TYP_294_I8_D: "Vertical offset",
  T_49_META_TYP_294_I9_D: "Horizontal offset",
  T_49_META_TYP_295_I2_D: "Play Speed",
  T_49_META_TYP_296_I1_D: "Clip Length",
  T_49_META_TYP_297_I0_D: "Bound objects",
  T_49_META_TYP_297_I4_D: "Resource ID",
  T_49_META_TYP_298_I0_D: "Default",
  T_49_META_TYP_298_I2_D: "Once",
  T_49_META_TYP_30_I0_D: "Square",
  T_49_META_TYP_30_I1_D: "Quadrilateral",
  T_49_META_TYP_30_I10_D: "Arrow",
  T_49_META_TYP_30_I11_D: "Callout",
  T_49_META_TYP_30_I12_D: "Rock",
  T_49_META_TYP_30_I13_D: "Scissors",
  T_49_META_TYP_30_I14_D: "Paper",
  T_49_META_TYP_30_I15_D: "Like",
  T_49_META_TYP_30_I16_D: "Right",
  T_49_META_TYP_30_I17_D: "Wrong",
  T_49_META_TYP_30_I18_D: "Plus",
  T_49_META_TYP_30_I19_D: "Lightning",
  T_49_META_TYP_30_I2_D: "Right-Angled Trapezoid",
  T_49_META_TYP_30_I20_D: "Hearts",
  T_49_META_TYP_30_I21_D: "Star",
  T_49_META_TYP_30_I22_D: "Moon",
  T_49_META_TYP_30_I23_D: "Sun",
  T_49_META_TYP_30_I24_D: "Glasses",
  T_49_META_TYP_30_I25_D: "Key",
  T_49_META_TYP_30_I26_D: "Trophy",
  T_49_META_TYP_30_I27_D: "Flag",
  T_49_META_TYP_30_I28_D: "Hourglass",
  T_49_META_TYP_30_I29_D: "Folder",
  T_49_META_TYP_30_I3_D: "Trapezoid",
  T_49_META_TYP_30_I30_D: "Open Folder",
  T_49_META_TYP_30_I31_D: "House",
  T_49_META_TYP_30_I32_D: "Rest",
  T_49_META_TYP_30_I33_D: "Refresh",
  T_49_META_TYP_30_I34_D: "Loop",
  T_49_META_TYP_30_I35_D: "Magnifier",
  T_49_META_TYP_30_I36_D: "Trash Can",
  T_49_META_TYP_30_I37_D: "Return",
  T_49_META_TYP_30_I38_D: "Diamond",
  T_49_META_TYP_30_I39_D: "Swim Ring",
  T_49_META_TYP_30_I4_D: "Hexagon",
  T_49_META_TYP_30_I40_D: "Money",
  T_49_META_TYP_30_I41_D: "Lock",
  T_49_META_TYP_30_I42_D: "Settings",
  T_49_META_TYP_30_I43_D: "Exit",
  T_49_META_TYP_30_I44_D: "Dialogue",
  T_49_META_TYP_30_I45_D: "Crosshairs",
  T_49_META_TYP_30_I46_D: "Guns",
  T_49_META_TYP_30_I47_D: "Sword",
  T_49_META_TYP_30_I48_D: "Explosion",
  T_49_META_TYP_30_I49_D: "Aim",
  T_49_META_TYP_30_I5_D: "Circles",
  T_49_META_TYP_30_I50_D: "Cross",
  T_49_META_TYP_30_I51_D: "Defense",
  T_49_META_TYP_30_I52_D: "Zombie",
  T_49_META_TYP_30_I53_D: "Recycle",
  T_49_META_TYP_30_I54_D: "Gift",
  T_49_META_TYP_30_I55_D: "Clothes",
  T_49_META_TYP_30_I56_D: "Game",
  T_49_META_TYP_30_I57_D: "Player",
  T_49_META_TYP_30_I58_D: "Store",
  T_49_META_TYP_30_I59_D: "Exit",
  T_49_META_TYP_30_I6_D: "Triangle",
  T_49_META_TYP_30_I60_D: "Warning",
  T_49_META_TYP_30_I61_D: "Text",
  T_49_META_TYP_30_I62_D: "Timer Objects",
  T_49_META_TYP_30_I63_D: "Bell",
  T_49_META_TYP_30_I64_D: "Pet",
  T_49_META_TYP_30_I65_D: "Bomb",
  T_49_META_TYP_30_I66_D: "Repair",
  T_49_META_TYP_30_I67_D: "Smiling Face",
  T_49_META_TYP_30_I68_D: "Speaker",
  T_49_META_TYP_30_I7_D: "Exclamation Mark",
  T_49_META_TYP_30_I70_D: "Crown",
  T_49_META_TYP_30_I71_D: "Battle",
  T_49_META_TYP_30_I72_D: "Guild",
  T_49_META_TYP_30_I73_D: "Heartbeat",
  T_49_META_TYP_30_I74_D: "Music",
  T_49_META_TYP_30_I75_D: "Vehicle",
  T_49_META_TYP_30_I76_D: "Melee",
  T_49_META_TYP_30_I77_D: "Pistol",
  T_49_META_TYP_30_I78_D: "Rifle",
  T_49_META_TYP_30_I79_D: "Sniper Rifle",
  T_49_META_TYP_30_I8_D: "Question Mark",
  T_49_META_TYP_30_I80_D: "Shotgun",
  T_49_META_TYP_30_I81_D: "SMG",
  T_49_META_TYP_30_I82_D: "Healing Gun",
  T_49_META_TYP_30_I83_D: "Shatter Armor",
  T_49_META_TYP_30_I84_D: "Headshot",
  T_49_META_TYP_30_I85_D: "Skill 1",
  T_49_META_TYP_30_I86_D: "Skill 2",
  T_49_META_TYP_30_I87_D: "Skill 3",
  T_49_META_TYP_30_I88_D: "Skill 4",
  T_49_META_TYP_30_I89_D: "Skill 5",
  T_49_META_TYP_30_I9_D: "Mark",
  T_49_META_TYP_30_I90_D: "Skill 6",
  T_49_META_TYP_30_I91_D: "Skill 7",
  T_49_META_TYP_30_I92_D: "Skill 8",
  T_49_META_TYP_30_I93_D: "Skill 9",
  T_49_META_TYP_30_I94_D: "Skill 10",
  T_49_META_TYP_300_I0_D: "Resource ID",
  T_49_META_TYP_300_I2_D: "Rotation",
  T_49_META_TYP_300_I3_D: "Created Entity",
  T_49_META_TYP_301_I1_D: "Self-Destruct",
  T_49_META_TYP_301_I2_D: "Dash Attack",
  T_49_META_TYP_301_I3_D: "Shock Wave",
  T_49_META_TYP_301_I4_D: "Tornado Attack",
  T_49_META_TYP_301_I5_D: "Jump Attack",
  T_49_META_TYP_301_I6_D: "Shield Up",
  T_49_META_TYP_301_I7_D: "Shield Broken",
  T_49_META_TYP_302_I5_D: "Backpack",
  T_49_META_TYP_302_I7_D: "Skateboard, Camo ....",
  T_49_META_TYP_303_I0_D: "Add Max. Player HP",
  T_49_META_TYP_303_I1_D: "Restore Player HP Continuously",
  T_49_META_TYP_305_I0_D: "Finish",
  T_49_META_TYP_305_I1_D: "Running",
  T_49_META_TYP_307_I0_D: "Exp Per Damage",
  T_49_META_TYP_307_I1_D: "Exp Per Move Mile",
  T_49_META_TYP_307_I2_D: "EXP per Second",
  T_49_META_TYP_307_I3_D: "Chip Exp",
  T_49_META_TYP_307_I4_D: "Charge Max",
  T_49_META_TYP_308_I0_D: "Gel Maker",
  T_49_META_TYP_31_I0_D: "Grenade Explosion",
  T_49_META_TYP_31_I1_D: "Gun Sound",
  T_49_META_TYP_31_I10_D: "Hit Damage Sound",
  T_49_META_TYP_31_I11_D: "Upgrade Sound",
  T_49_META_TYP_31_I12_D: "Weakness hit sound effect",
  T_49_META_TYP_31_I13_D: "Player stepping sound effect",
  T_49_META_TYP_31_I14_D: "Equipment Repair Sound Effect",
  T_49_META_TYP_31_I15_D: "Equipment repair sound effect",
  T_49_META_TYP_31_I16_D: "Missing or lost sound effect",
  T_49_META_TYP_31_I17_D: "Reminder Sound",
  T_49_META_TYP_31_I18_D: "Soccer Ball Landing Sound Effect",
  T_49_META_TYP_31_I19_D: "Cheers Sound Effect",
  T_49_META_TYP_31_I2_D: "Countdown Beep",
  T_49_META_TYP_31_I20_D: "Bomb Alert Sound Effect",
  T_49_META_TYP_31_I21_D: "Bomb Before Explosion Sound Effect",
  T_49_META_TYP_31_I22_D: "Hunter Appearance Sound Effect",
  T_49_META_TYP_31_I23_D: "Final BGM Sound Effect",
  T_49_META_TYP_31_I24_D: "Resupply Box Refresh Sound Effect",
  T_49_META_TYP_31_I25_D: "Accelerator sound effect",
  T_49_META_TYP_31_I26_D: "Disappearing Sound",
  T_49_META_TYP_31_I27_D: "Visual Effects",
  T_49_META_TYP_31_I28_D: "Night Bugs",
  T_49_META_TYP_31_I29_D: "Dull percussion sound effect",
  T_49_META_TYP_31_I3_D: "UI Tap",
  T_49_META_TYP_31_I30_D: "Response Sound Effect",
  T_49_META_TYP_31_I31_D: "Discovery Surprise sound effect",
  T_49_META_TYP_31_I32_D: "Ghosts playing sound effect",
  T_49_META_TYP_31_I33_D: "Phase Start Sound Effect",
  T_49_META_TYP_31_I34_D: "Zombie sound effect",
  T_49_META_TYP_31_I35_D: "Scary sound effect",
  T_49_META_TYP_31_I36_D: "Transformation sound effect",
  T_49_META_TYP_31_I37_D: "Fast Heartbeat Sound Effect",
  T_49_META_TYP_31_I38_D: "Medium Heartbeat",
  T_49_META_TYP_31_I39_D: "Slow heartbeat sound effect",
  T_49_META_TYP_31_I4_D: "Female Screaming on Hit",
  T_49_META_TYP_31_I40_D: "Stampede sound effect",
  T_49_META_TYP_31_I41_D: "Clicking Sound",
  T_49_META_TYP_31_I42_D: "Skill Recovery Sound",
  T_49_META_TYP_31_I43_D: "Join Game Sound Effects",
  T_49_META_TYP_31_I44_D: "Mechanism Echo Sound",
  T_49_META_TYP_31_I45_D: "Mosquito sound effect",
  T_49_META_TYP_31_I46_D: "Clank 1 sound effect",
  T_49_META_TYP_31_I47_D: "Clank 2 sound effect",
  T_49_META_TYP_31_I48_D: "Mechanism opening sound effect",
  T_49_META_TYP_31_I49_D: "Energy Charge 1 sound effect",
  T_49_META_TYP_31_I5_D: "Male Screaming on Hit",
  T_49_META_TYP_31_I50_D: "Footsteps sound effect",
  T_49_META_TYP_31_I51_D: "Mission Success 1 sound effect",
  T_49_META_TYP_31_I52_D: "Danger Tone 1 sound effect",
  T_49_META_TYP_31_I53_D: "Danger tone 2 sound effect",
  T_49_META_TYP_31_I54_D: "Countdown 3 sound effect",
  T_49_META_TYP_31_I55_D: "Show Tips sound effect",
  T_49_META_TYP_31_I56_D: "Crow cawing ambient sound effect",
  T_49_META_TYP_31_I57_D: "Sound effect of teleporting to the wrong area with a teleport point",
  T_49_META_TYP_31_I58_D: "Sound effect of teleporting to the right area with a teleport point",
  T_49_META_TYP_31_I59_D: "Teleport sound effect",
  T_49_META_TYP_31_I6_D: "Gold Pickup Sound",
  T_49_META_TYP_31_I60_D: "Electric shock sound effect",
  T_49_META_TYP_31_I61_D: "Consumable sound effect",
  T_49_META_TYP_31_I62_D: "Electronic Fantasy Cute Background Music Sound Effects",
  T_49_META_TYP_31_I63_D: "Casual Game Background Music Sound Effects",
  T_49_META_TYP_31_I64_D: "Open Box",
  T_49_META_TYP_31_I65_D: "Level Up",
  T_49_META_TYP_31_I66_D: "Max. Level",
  T_49_META_TYP_31_I67_D: "Tap Button",
  T_49_META_TYP_31_I68_D: "Countdown",
  T_49_META_TYP_31_I69_D: "Defeat Enemy",
  T_49_META_TYP_31_I7_D: "Race past the finish line trigger sound effect",
  T_49_META_TYP_31_I70_D: "End",
  T_49_META_TYP_31_I71_D: "Forward",
  T_49_META_TYP_31_I72_D: "Victory",
  T_49_META_TYP_31_I73_D: "Training Base Checkpoints",
  T_49_META_TYP_31_I74_D: "Countdown",
  T_49_META_TYP_31_I75_D: "Game Start",
  T_49_META_TYP_31_I76_D: "Get Big Gold",
  T_49_META_TYP_31_I77_D: "Get Medium Gold",
  T_49_META_TYP_31_I78_D: "Get Small Gold",
  T_49_META_TYP_31_I79_D: "Join the Fray",
  T_49_META_TYP_31_I8_D: "Trigger Trigger Sound",
  T_49_META_TYP_31_I80_D: "Guild Supply",
  T_49_META_TYP_31_I81_D: "Speaker",
  T_49_META_TYP_31_I82_D: "Impeach Guild Leader",
  T_49_META_TYP_31_I83_D: "Save Warehouse",
  T_49_META_TYP_31_I84_D: "Special Gun Sound",
  T_49_META_TYP_31_I85_D: "Bullet Hit",
  T_49_META_TYP_31_I86_D: "Move",
  T_49_META_TYP_31_I87_D: "Tap Disable Button",
  T_49_META_TYP_31_I88_D: "Skill Charge Complete",
  T_49_META_TYP_31_I89_D: "Laser Skill",
  T_49_META_TYP_31_I9_D: "Degradation Sound",
  T_49_META_TYP_31_I90_D: "Get Consumable 2",
  T_49_META_TYP_31_I91_D: "Countdown 3",
  T_49_META_TYP_31_I92_D: "Game Over 2",
  T_49_META_TYP_31_I93_D: "Elimination Prompt",
  T_49_META_TYP_31_I94_D: "Explosion",
  T_49_META_TYP_31_I95_D: "Energy Orb Skill",
  T_49_META_TYP_31_I96_D: "Crimson Pool Skill",
  T_49_META_TYP_311_I1_D: "Max. Damage",
  T_49_META_TYP_311_I3_D: "The speed of the projectile after it is released, in m/s.",
  T_49_META_TYP_311_I4_D: "The time interval between when the projectile is released and when it takes effect, in seconds.",
  T_49_META_TYP_313_I0_D: "Zone Radius",
  T_49_META_TYP_313_I1_D: "Duration of countermeasure area, in seconds",
  T_49_META_TYP_314_I0_D: "Animation controller resource ID.",
  T_49_META_TYP_314_I1_D: "Animation Controller",
  T_49_META_TYP_315_I0_D: "The owner of the backpack.",
  T_49_META_TYP_315_I1_D: "The space of the backpack.",
  T_49_META_TYP_315_I2_D: "Used Capacity",
  T_49_META_TYP_315_I3_D: "All Supplies",
  T_49_META_TYP_316_I0_D: "Texture Resource",
  T_49_META_TYP_316_I1_D: "Shader Name",
  T_49_META_TYP_316_I11_D: "Flip method",
  T_49_META_TYP_316_I2_D: "UV Offset",
  T_49_META_TYP_316_I3_D: "UV Size",
  T_49_META_TYP_316_I4_D: "Fill Type",
  T_49_META_TYP_316_I5_D: "Border Left Right",
  T_49_META_TYP_316_I6_D: "Border Top Bottom",
  T_49_META_TYP_317_I0_D: "None",
  T_49_META_TYP_317_I1_D: "Freeze Position X",
  T_49_META_TYP_317_I2_D: "Freeze Position Y",
  T_49_META_TYP_317_I3_D: "Freeze Position Z",
  T_49_META_TYP_317_I4_D: "Restricted rotation around X-axis",
  T_49_META_TYP_317_I5_D: "Restriction of rotation around the Y-axis",
  T_49_META_TYP_317_I6_D: "Limit rotation around the Z-axis",
  T_49_META_TYP_317_I7_D: "Freeze Position",
  T_49_META_TYP_317_I8_D: "Freeze Rotation",
  T_49_META_TYP_317_I9_D: "Freeze All",
  T_49_META_TYP_318_I0_D: "Range",
  T_49_META_TYP_318_I1_D: "Full Damage Distance",
  T_49_META_TYP_318_I10_D: "Player Aiming Speed Factor",
  T_49_META_TYP_318_I11_D: "Scope Zoom-In Factor",
  T_49_META_TYP_318_I12_D: "FOV Magnification",
  T_49_META_TYP_318_I13_D: "ADS Magnification",
  T_49_META_TYP_318_I14_D: "ADS Magnification Time (s)",
  T_49_META_TYP_318_I15_D: "ADS Recovery Time (s)",
  T_49_META_TYP_318_I16_D: "Scope Min Damage Distance correction factor.",
  T_49_META_TYP_318_I17_D: "Allow ADS Aim Assist",
  T_49_META_TYP_318_I18_D: "Aim Assist Crosshairs Screen Range Attraction Ratio (0-1)",
  T_49_META_TYP_318_I19_D: "Aim Assist Distance Attenuation Coefficient (0-1)",
  T_49_META_TYP_318_I2_D: "Min. Damage Distance",
  T_49_META_TYP_318_I20_D: "Allow Aim Assist Distance First",
  T_49_META_TYP_318_I21_D: "Aim Assist Distance Priority Min. Distance",
  T_49_META_TYP_318_I22_D: "Aim Assist Distance Priority Max. Distance",
  T_49_META_TYP_318_I23_D: "Aim Assist Distance Priority Impact Coefficient (>=1)",
  T_49_META_TYP_318_I24_D: "ADS Rotation Sensitivity",
  T_49_META_TYP_318_I25_D: "Shrink Speed",
  T_49_META_TYP_318_I3_D: "Ammo Clip Size",
  T_49_META_TYP_318_I4_D: "Attack Interval",
  T_49_META_TYP_318_I5_D: "Reload Speed",
  T_49_META_TYP_318_I6_D: "Auto Reload Speed",
  T_49_META_TYP_318_I7_D: "Scatter Speed",
  T_49_META_TYP_318_I8_D: "Scattering rate when crouching and lying down, per 0.1 means 10% range increase per bullet aiming",
  T_49_META_TYP_318_I9_D: "Max. Spread",
  T_49_META_TYP_319_I0_D: "Simple",
  T_49_META_TYP_319_I1_D: "Sliced",
  T_49_META_TYP_319_I2_D: "Tiled",
  T_49_META_TYP_319_I3_D: "Filled",
  T_49_META_TYP_319_I4_D: "Fit",
  T_49_META_TYP_32_I0_D: "Player in normal active state",
  T_49_META_TYP_32_I1_D: "Player is knocked down",
  T_49_META_TYP_32_I2_D: "Player is dead",
  T_49_META_TYP_320_I0_D: "Horizontal",
  T_49_META_TYP_320_I1_D: "Vertical",
  T_49_META_TYP_320_I2_D: "Radial 90°",
  T_49_META_TYP_320_I3_D: "Radial 180°",
  T_49_META_TYP_320_I4_D: "Radial 360°",
  T_49_META_TYP_321_I0_D: "The maximum distance at which the targeting assist will be triggered.",
  T_49_META_TYP_321_I1_D: "The offset of the collimator when triggering targeting, if the offset point is not in the solid, the targeting will be disabled.",
  T_49_META_TYP_322_I0_D: "No",
  T_49_META_TYP_322_I1_D: "Head",
  T_49_META_TYP_322_I2_D: "Body",
  T_49_META_TYP_322_I3_D: "Limb",
  T_49_META_TYP_323_I0_D: "Scale",
  T_49_META_TYP_323_I1_D: "Account ID",
  T_49_META_TYP_323_I2_D: "Player Profile Information",
  T_49_META_TYP_323_I3_D: "Style",
  T_49_META_TYP_323_I4_D: "Show Rank",
  T_49_META_TYP_323_I5_D: "Show Pin",
  T_49_META_TYP_323_I6_D: "Show Nickname",
  T_49_META_TYP_324_I0_D: "Generate a specified amount of force",
  T_49_META_TYP_324_I1_D: "Generate an acceleration of a specified magnitude",
  T_49_META_TYP_324_I2_D: "Generate an impulse of a specified magnitude",
  T_49_META_TYP_324_I3_D: "Generate a specified amount of velocity",
  T_49_META_TYP_326_I0_D: "Account ID",
  T_49_META_TYP_326_I1_D: "Avatar ID",
  T_49_META_TYP_326_I2_D: "Banner ID",
  T_49_META_TYP_326_I3_D: "Pin ID",
  T_49_META_TYP_326_I4_D: "Player's nickname",
  T_49_META_TYP_326_I5_D: "BR Rank",
  T_49_META_TYP_326_I6_D: "Highest BR rank",
  T_49_META_TYP_326_I7_D: "CS Rank",
  T_49_META_TYP_326_I8_D: "Highest CS rank",
  T_49_META_TYP_327_I0_D: "Resource ID",
  T_49_META_TYP_327_I1_D: "Part Mask 1",
  T_49_META_TYP_327_I2_D: "Part Mask 2",
  T_49_META_TYP_327_I3_D: "Part Mask 3",
  T_49_META_TYP_327_I4_D: "Part Mask 4",
  T_49_META_TYP_329_I0_D: "Driver",
  T_49_META_TYP_329_I1_D: "Passenger A",
  T_49_META_TYP_329_I2_D: "Passenger B",
  T_49_META_TYP_329_I3_D: "Passenger C",
  T_49_META_TYP_33_I0_D: "Ascending order ignores zero values, zero values come last",
  T_49_META_TYP_33_I1_D: "Descending order, large to small",
  T_49_META_TYP_33_I2_D: "Ascending, smallest to largest",
  T_49_META_TYP_330_I4_D: "Duration of invincibility effect (in s)",
  T_49_META_TYP_330_I5_D: "Control Points",
  T_49_META_TYP_330_I8_D: "Delta Value",
  T_49_META_TYP_332_I0_D: "Is Loop",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "SimplifiedArabic",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "Supermarket",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "Resource path, default is empty",
  T_49_META_TYP_335_I1_D: "Play count, default is 1",
  T_49_META_TYP_335_I2_D: "Volume, default is 50",
  T_49_META_TYP_335_I3_D: "Max. Distance",
  T_49_META_TYP_335_I4_D: "Min. Distance",
  T_49_META_TYP_335_I5_D: "Whether the music is 3D or not",
  T_49_META_TYP_335_I6_D: "Priority",
  T_49_META_TYP_335_I7_D: "Wait time before start, in seconds",
  T_49_META_TYP_335_I8_D: "Is Playing",
  T_49_META_TYP_338_I0_D: "Movement status",
  T_49_META_TYP_338_I1_D: "Sprint",
  T_49_META_TYP_338_I2_D: "Attack",
  T_49_META_TYP_338_I3_D: "Jump",
  T_49_META_TYP_338_I4_D: "Overrun",
  T_49_META_TYP_338_I5_D: "Enter vehicle (driver)",
  T_49_META_TYP_338_I6_D: "Enter Carrier (Passenger)",
  T_49_META_TYP_338_I7_D: "Exit Vehicle",
  T_49_META_TYP_338_I8_D: "Drive",
  T_49_META_TYP_339_I0_D: "Damage Ratio Limb",
  T_49_META_TYP_339_I1_D: "Headshot DMG Coefficient",
  T_49_META_TYP_339_I2_D: "Max. Durability Multiplier",
  T_49_META_TYP_339_I3_D: "Extra HP Ratio",
  T_49_META_TYP_339_I4_D: "Additional Blast Damage Reduction Factor (%)",
  T_49_META_TYP_339_I5_D: "Extra Backpack Capacity",
  T_49_META_TYP_339_I6_D: "Replacement Priority",
  T_49_META_TYP_34_I0_D: "Default Fist",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "Famas-I",
  T_49_META_TYP_34_I101_D: "Groza-X",
  T_49_META_TYP_34_I102_D: "SVD-Y",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "Shotgun",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "Hand Cannon",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "Shield Gun",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "Shield Gun",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "Kar98K-II",
  T_49_META_TYP_34_I126_D: "Kar98K-III",
  T_49_META_TYP_34_I127_D: "Kar98K-III",
  T_49_META_TYP_34_I128_D: "Kar98K-Ⅲ - Kar98K-III",
  T_49_META_TYP_34_I129_D: "Famas-III",
  T_49_META_TYP_34_I13_D: "Flame Grenade Gun",
  T_49_META_TYP_34_I133_D: "Flashbang",
  T_49_META_TYP_34_I134_D: "Smoke Grenade",
  T_49_META_TYP_34_I135_D: "Freezing Grenade",
  T_49_META_TYP_34_I136_D: "Bulletproof Vest Lv1",
  T_49_META_TYP_34_I137_D: "Body armor Lv2",
  T_49_META_TYP_34_I138_D: "Body armor Lv3",
  T_49_META_TYP_34_I139_D: "Helmet Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "Helmet Lv2",
  T_49_META_TYP_34_I141_D: "Helmet Lv3",
  T_49_META_TYP_34_I142_D: "Explosion-proof Armor",
  T_49_META_TYP_34_I143_D: "Backpack Lv1",
  T_49_META_TYP_34_I144_D: "Backpack Lv2",
  T_49_META_TYP_34_I145_D: "Backpack Lv3",
  T_49_META_TYP_34_I146_D: "Muzzle Lv1",
  T_49_META_TYP_34_I147_D: "Muzzle Lv2",
  T_49_META_TYP_34_I148_D: "Muzzle Lv3",
  T_49_META_TYP_34_I149_D: "Silencer",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "Assault Muzzle",
  T_49_META_TYP_34_I151_D: "Wide Muzzle",
  T_49_META_TYP_34_I152_D: "Magazine Lv1",
  T_49_META_TYP_34_I153_D: "Magazine Lv2",
  T_49_META_TYP_34_I154_D: "Magazine Lv3",
  T_49_META_TYP_34_I155_D: "Double Bundle Magazine",
  T_49_META_TYP_34_I156_D: "Chain Magazine",
  T_49_META_TYP_34_I157_D: "Grip Lv1",
  T_49_META_TYP_34_I158_D: "Grip Lv2",
  T_49_META_TYP_34_I159_D: "Grip Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "Folding Bracket",
  T_49_META_TYP_34_I161_D: "Shooter's Rifle Grip",
  T_49_META_TYP_34_I162_D: "Shotgun Stocks",
  T_49_META_TYP_34_I163_D: "Sniper Stocks",
  T_49_META_TYP_34_I164_D: "Thermal Imaging Scope",
  T_49_META_TYP_34_I165_D: "Stock Lv1",
  T_49_META_TYP_34_I166_D: "Stock Lv2",
  T_49_META_TYP_34_I167_D: "Stock Lv3",
  T_49_META_TYP_34_I168_D: "Shield Expander",
  T_49_META_TYP_34_I169_D: "Full Body Armor",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "Excess Jacket",
  T_49_META_TYP_34_I171_D: "Explosion-proof Jacket",
  T_49_META_TYP_34_I172_D: "Backpack Expander",
  T_49_META_TYP_34_I173_D: "Healing Breather",
  T_49_META_TYP_34_I174_D: "Horizaline",
  T_49_META_TYP_34_I175_D: "MedKit",
  T_49_META_TYP_34_I176_D: "Armor Repair Kit",
  T_49_META_TYP_34_I177_D: "An AI sentry tower made of high-tech materials that actively searches and attacks enemies within a certain range",
  T_49_META_TYP_34_I178_D: "Level 1 Mushroom",
  T_49_META_TYP_34_I179_D: "Level 2 Mushroom",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "Level 3 Mushroom",
  T_49_META_TYP_34_I181_D: "Level 4 Mushroom",
  T_49_META_TYP_34_I182_D: "Personal UAV",
  T_49_META_TYP_34_I184_D: "Sensor Mines",
  T_49_META_TYP_34_I185_D: "Jet Flying Shoes",
  T_49_META_TYP_34_I186_D: "Bouncing Power Shoes",
  T_49_META_TYP_34_I187_D: "Glider",
  T_49_META_TYP_34_I188_D: "Bait Grenade",
  T_49_META_TYP_34_I189_D: "Maglev Skateboard",
  T_49_META_TYP_34_I19_D: "Desert Eagle",
  T_49_META_TYP_34_I190_D: "Bomb Disposal Pliers",
  T_49_META_TYP_34_I191_D: "Gun Upgrader",
  T_49_META_TYP_34_I192_D: "Rifle Ammo",
  T_49_META_TYP_34_I193_D: "Pistol Ammo",
  T_49_META_TYP_34_I194_D: "Sniper Rifle Ammo",
  T_49_META_TYP_34_I195_D: "Shotgun Ammo",
  T_49_META_TYP_34_I196_D: "SMG Ammo",
  T_49_META_TYP_34_I197_D: "Arrows",
  T_49_META_TYP_34_I198_D: "M79 Grenade",
  T_49_META_TYP_34_I199_D: "Flamethrower Bullets",
  T_49_META_TYP_34_I2_D: "CROSSBOW",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "THROWINGKNIFE2",
  T_49_META_TYP_34_I201_D: "Hook",
  T_49_META_TYP_34_I202_D: "Football Gun",
  T_49_META_TYP_34_I203_D: "Boxing",
  T_49_META_TYP_34_I204_D: "Flamethrower",
  T_49_META_TYP_34_I205_D: "MonkeygodCard",
  T_49_META_TYP_34_I206_D: "MadeManACard",
  T_49_META_TYP_34_I207_D: "DjmaleCard",
  T_49_META_TYP_34_I208_D: "GraffitistCard",
  T_49_META_TYP_34_I209_D: "DetectiveCard",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "ProfessorCard",
  T_49_META_TYP_34_I211_D: "BountyHunterCard",
  T_49_META_TYP_34_I212_D: "SuperstarCard",
  T_49_META_TYP_34_I213_D: "XtremeCard",
  T_49_META_TYP_34_I214_D: "MusicBroCard",
  T_49_META_TYP_34_I215_D: "KentaCard",
  T_49_META_TYP_34_I216_D: "TRACKERCard",
  T_49_META_TYP_34_I217_D: "CrazygirlCard",
  T_49_META_TYP_34_I218_D: "RunSpeedUpCard",
  T_49_META_TYP_34_I219_D: "SantinoCard",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "VillainCard",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "SCAR-I",
  T_49_META_TYP_34_I25_D: "SCAR-II",
  T_49_META_TYP_34_I26_D: "SCAR-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "Loot Soccer Shield",
  T_49_META_TYP_34_I30_D: "Superheated Energy Gun",
  T_49_META_TYP_34_I31_D: "Superheated Gun-I",
  T_49_META_TYP_34_I32_D: "Superheat Gun-II",
  T_49_META_TYP_34_I33_D: "Superheat Gun-III",
  T_49_META_TYP_34_I34_D: "PLASMA-X",
  T_49_META_TYP_34_I35_D: "Heal Pistol-Y",
  T_49_META_TYP_34_I36_D: "Heal Sniper",
  T_49_META_TYP_34_I37_D: "Heal Pistol",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "Groza",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "Groza",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "Pan",
  T_49_META_TYP_34_I44_D: "Machete",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "Baseball Bat",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "Samurai Sword",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "Gatling",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "Power Hook Gun",
  T_49_META_TYP_34_I71_D: "FF Knife",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "1887 with 3 bullets",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "Woodpecker",
  T_49_META_TYP_34_I83_D: "VECTOR",
  T_49_META_TYP_34_I84_D: "MAG-7",
  T_49_META_TYP_34_I85_D: "MAG-7",
  T_49_META_TYP_34_I86_D: "Scythe",
  T_49_META_TYP_34_I87_D: "Big Head Hammer",
  T_49_META_TYP_34_I88_D: "Flying Dagger (pickable)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "USP-2",
  T_49_META_TYP_34_I92_D: "Kingfisher",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "MP5-I",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "Kar98K-I",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "Easy",
  T_49_META_TYP_340_I1_D: "Simple",
  T_49_META_TYP_340_I2_D: "Normal",
  T_49_META_TYP_340_I3_D: "Moderate",
  T_49_META_TYP_340_I4_D: "Hard",
  T_49_META_TYP_340_I5_D: "Inferno",
  T_49_META_TYP_342_I0_D: "Start Event",
  T_49_META_TYP_342_I1_D: "Stop Event",
  T_49_META_TYP_342_I2_D: "Pause Event",
  T_49_META_TYP_342_I3_D: "How long to wait after being created to start the timer, in milliseconds",
  T_49_META_TYP_342_I4_D: "Loop Count",
  T_49_META_TYP_342_I5_D: "Events",
  T_49_META_TYP_342_I6_D: "Countdown or positive timing",
  T_49_META_TYP_342_I7_D: "Player Status",
  T_49_META_TYP_342_I8_D: "Timing end time in seconds",
  T_49_META_TYP_345_I10_D: "Hand Cannon",
  T_49_META_TYP_345_I12_D: "Ice Wall Gun",
  T_49_META_TYP_345_I13_D: "Flamethrower",
  T_49_META_TYP_345_I4_D: "Shotgun",
  T_49_META_TYP_345_I6_D: "Special Gun",
  T_49_META_TYP_345_I8_D: "Accumulator",
  T_49_META_TYP_346_I0_D: "Rifle Ammo",
  T_49_META_TYP_346_I1_D: "Pistol Ammo",
  T_49_META_TYP_346_I2_D: "Sniper Rifle Ammo",
  T_49_META_TYP_346_I3_D: "Shotgun Ammo",
  T_49_META_TYP_346_I4_D: "SMG Ammo",
  T_49_META_TYP_346_I5_D: "Arrows",
  T_49_META_TYP_346_I6_D: "M79 Grenade",
  T_49_META_TYP_346_I7_D: "Hook",
  T_49_META_TYP_346_I8_D: "M79 Specialized Grenade",
  T_49_META_TYP_347_I3_D: "Can be combined with Relative Motion if true, must be combined with Absolute Motion if false, otherwise the property will not take effect correctly.",
  T_49_META_TYP_347_I6_D: "Delta Value",
  T_49_META_TYP_350_I0_D: "Sports Car",
  T_49_META_TYP_350_I1_D: "Motorbike",
  T_49_META_TYP_350_I2_D: "Jeep",
  T_49_META_TYP_350_I3_D: "SUV",
  T_49_META_TYP_350_I4_D: "Monster Truck",
  T_49_META_TYP_350_I5_D: "Mutant Truck",
  T_49_META_TYP_352_I1_D: "Unselected Sprite",
  T_49_META_TYP_352_I2_D: "Unchecked image type",
  T_49_META_TYP_352_I3_D: "Unselected Color",
  T_49_META_TYP_352_I4_D: "Selected Sprite",
  T_49_META_TYP_352_I5_D: "Selected Image Type",
  T_49_META_TYP_352_I6_D: "Selected Color",
  T_49_META_TYP_353_I0_D: "HP Recovery Amount",
  T_49_META_TYP_353_I1_D: "HP Recovery Speed (ms)",
  T_49_META_TYP_353_I2_D: "Time Required (ms)",
  T_49_META_TYP_354_I0_D: "EP Recovery Amount",
  T_49_META_TYP_355_I0_D: "HP Recovery Amount",
  T_49_META_TYP_355_I1_D: "EP Recovery Amount",
  T_49_META_TYP_355_I2_D: "Time Required (ms)",
  T_49_META_TYP_356_I0_D: "Drop Items",
  T_49_META_TYP_356_I1_D: "Drop box drop time ms",
  T_49_META_TYP_356_I2_D: "Airdrop State",
  T_49_META_TYP_357_I0_D: "Surface",
  T_49_META_TYP_357_I1_D: "Boundary",
  T_49_META_TYP_359_I0_D: "Whether to use a player controller with physics effects",
  T_49_META_TYP_359_I1_D: "Placed on a slope above this angle, it will slide downward",
  T_49_META_TYP_359_I10_D: "This gravity acceleration is only applied to this player's controller.",
  T_49_META_TYP_359_I11_D: "Mass in kg",
  T_49_META_TYP_359_I12_D: "If the slope exceeds the maximum uphill angle, the capsule will slide downward.",
  T_49_META_TYP_359_I16_D: "When enabled, movement is controlled by server-side blocks or scripts.",
  T_49_META_TYP_359_I17_D: "When enabled, the force applied when the character pushes on a rigid body can be customized.",
  T_49_META_TYP_359_I18_D: "The amount of force applied when the character pushes the rigid body",
  T_49_META_TYP_359_I19_D: "True when the lower part of the body touches the collision body, usually used to determine if the player is on the ground.",
  T_49_META_TYP_359_I2_D: "Only obstacles above this height will have a blocking effect, in the range [0,Height]",
  T_49_META_TYP_359_I20_D: "Customizable physics level, value [0,15].",
  T_49_META_TYP_359_I21_D: "Enable Rotate With Gravity",
  T_49_META_TYP_359_I3_D: "Allows embedding to change the depth of the capsule body. It can prevent the character from getting stuck or shaking, and is not recommended to be changed without special needs. Value range (0,Radius]",
  T_49_META_TYP_359_I4_D: "Minimum movement distance, any movement less than this value will not be executed. If there is no special need, it is recommended to keep it at 0.",
  T_49_META_TYP_359_I5_D: "The offset of the center of the collision box from the local coordinate origin.",
  T_49_META_TYP_359_I6_D: "Radius of the capsule, minimum value 0.01.",
  T_49_META_TYP_359_I7_D: "Total height of the capsule, including the upper and lower hemispheres, min. 2*Radius",
  T_49_META_TYP_359_I8_D: "Current linear velocity, in m/s",
  T_49_META_TYP_360_I0_D: "Left Firing Arc Angle",
  T_49_META_TYP_360_I1_D: "Right Firing Arc Angle",
  T_49_META_TYP_360_I2_D: "Min. Elevation Angle",
  T_49_META_TYP_360_I3_D: "Max. Depression Angle",
  T_49_META_TYP_360_I4_D: "Muzzle Velocity",
  T_49_META_TYP_362_I0_D: "Freeze time caused by hitting the player, in seconds",
  T_49_META_TYP_363_I0_D: "Disable Hud Request Purchase",
  T_49_META_TYP_363_I1_D: "Request help from team to buy",
  T_49_META_TYP_363_I2_D: "Purchase by requesting help from a camp",
  T_49_META_TYP_364_I0_D: "Is Center Position",
  T_49_META_TYP_364_I1_D: "Whether to loop playback",
  T_49_META_TYP_364_I2_D: "Animation name",
  T_49_META_TYP_364_I3_D: "Whether or not to autoplay",
  T_49_META_TYP_364_I4_D: "Use Custom Resource",
  T_49_META_TYP_366_I0_D: "Specifies the UUID of the Batch resource to render.",
  T_49_META_TYP_367_I1_D: "Show Tag",
  T_49_META_TYP_367_I2_D: "Icon style for marker targets",
  T_49_META_TYP_367_I3_D: "Overlay color of icons displayed on marked targets",
  T_49_META_TYP_367_I4_D: "Icon style displayed on a scale",
  T_49_META_TYP_367_I5_D: "Overlay color of the icon displayed on a scale",
  T_49_META_TYP_367_I6_D: "Always Show Mark",
  T_49_META_TYP_370_I0_D: "Main title",
  T_49_META_TYP_370_I1_D: "Subtitle",
  T_49_META_TYP_370_I2_D: "Upper background color",
  T_49_META_TYP_370_I3_D: "Bottom background color",
  T_49_META_TYP_371_I2_D: "Left Score",
  T_49_META_TYP_371_I3_D: "Right Score",
  T_49_META_TYP_371_I4_D: "The last score on the left, used to play the score switching Animation",
  T_49_META_TYP_371_I5_D: "The last score on the right, used to play the score toggle Animation",
  T_49_META_TYP_372_I0_D: "Standing",
  T_49_META_TYP_372_I1_D: "Show Crouch",
  T_49_META_TYP_372_I10_D: "High fall",
  T_49_META_TYP_372_I11_D: "Low fall, e.g. jumping",
  T_49_META_TYP_372_I12_D: "Flying shoes",
  T_49_META_TYP_372_I13_D: "Two jump jumps",
  T_49_META_TYP_372_I14_D: "Sitting on a chair",
  T_49_META_TYP_372_I15_D: "Ejected by catapult",
  T_49_META_TYP_372_I16_D: "Catapult preparation phase",
  T_49_META_TYP_372_I17_D: "Gliding on the consumable",
  T_49_META_TYP_372_I18_D: "Gliding prop drop",
  T_49_META_TYP_372_I19_D: "Bounced by tires",
  T_49_META_TYP_372_I2_D: "Running",
  T_49_META_TYP_372_I20_D: "Bounced by human tires",
  T_49_META_TYP_372_I21_D: "An Animation in the Party Zone",
  T_49_META_TYP_372_I22_D: "Ride a Flying Machine",
  T_49_META_TYP_372_I23_D: "Entering a Cannon",
  T_49_META_TYP_372_I24_D: "This is the state when coming out of a Cannon, Carrier, etc. if the ride object is flying",
  T_49_META_TYP_372_I25_D: "After jumping from a springboard",
  T_49_META_TYP_372_I26_D: "After getting off the zipline",
  T_49_META_TYP_372_I27_D: "Not used",
  T_49_META_TYP_372_I3_D: "Down and Crawl",
  T_49_META_TYP_372_I4_D: "Swimming",
  T_49_META_TYP_372_I5_D: "Falling vertically",
  T_49_META_TYP_372_I6_D: "Over the wall",
  T_49_META_TYP_372_I7_D: "Unused",
  T_49_META_TYP_372_I8_D: "Knocked down but not dead",
  T_49_META_TYP_372_I9_D: "Water Skateboarding",
  T_49_META_TYP_374_I0_D: "Life, level and stroke colors",
  T_49_META_TYP_374_I1_D: "When the life value decreases, the lost portion is briefly shown in this color.",
  T_49_META_TYP_374_I10_D: "Offset relative to the target to be followed",
  T_49_META_TYP_374_I11_D: "The amount of life between each line, if less than or equal to 0, it will not be shown.",
  T_49_META_TYP_374_I12_D: "Total HP",
  T_49_META_TYP_374_I13_D: "Current HP",
  T_49_META_TYP_374_I14_D: "When enabled, blood changes will be colored differently.",
  T_49_META_TYP_374_I15_D: "When enabled, the offset property is transferred to the world coordinate system using the local coordinate system.",
  T_49_META_TYP_374_I2_D: "When the life value increases, the increased part is briefly displayed in this color.",
  T_49_META_TYP_374_I3_D: "The color of the life value border and the bottom of the vignette.",
  T_49_META_TYP_374_I4_D: "Range 0~1, the transparency of the overall UI.",
  T_49_META_TYP_374_I5_D: "Determines the overall UI scaling, and the font will be scaled as well.",
  T_49_META_TYP_374_I6_D: "Indicates the name of the current blood bar owner",
  T_49_META_TYP_374_I8_D: "The length of the bloodstain portion on the screen",
  T_49_META_TYP_374_I9_D: "Must follow an entity with a Transform component.",
  T_49_META_TYP_375_I1_D: "Battle Entity",
  T_49_META_TYP_376_I1_D: "Battle Entity",
  T_49_META_TYP_38_I0_D: "Alpha",
  T_49_META_TYP_382_I0_D: "Default",
  T_49_META_TYP_382_I1_D: "Skip the knockdown state and just die",
  T_49_META_TYP_382_I2_D: "No Skip Knockdown",
  T_49_META_TYP_387_I1_D: "Allow Pressed Outside",
  T_49_META_TYP_389_I0_D: "Default offset of the base",
  T_49_META_TYP_389_I1_D: "Background Sprite",
  T_49_META_TYP_389_I10_D: "Inactivated Alpha",
  T_49_META_TYP_389_I2_D: "Background Radius",
  T_49_META_TYP_389_I3_D: "Joystick Cap Image",
  T_49_META_TYP_389_I4_D: "Joystick Cap Radius",
  T_49_META_TYP_389_I5_D: "Joystick Cap Drag Radius",
  T_49_META_TYP_389_I6_D: "Arrow Sprite",
  T_49_META_TYP_389_I7_D: "Arrow Size",
  T_49_META_TYP_389_I8_D: "Arrow Offset",
  T_49_META_TYP_389_I9_D: "Activated Alpha",
  T_49_META_TYP_39_I1_D: "Sprite Shape",
  T_49_META_TYP_39_I10_D: "Gradient Top",
  T_49_META_TYP_39_I11_D: "Gradient Bottom",
  T_49_META_TYP_39_I12_D: "Top Alpha",
  T_49_META_TYP_39_I13_D: "Bottom Alpha",
  T_49_META_TYP_39_I3_D: "Flip",
  T_49_META_TYP_39_I4_D: "Filled",
  T_49_META_TYP_39_I5_D: "Center Invisible",
  T_49_META_TYP_39_I6_D: "Fill Direction",
  T_49_META_TYP_39_I7_D: "Fill Value",
  T_49_META_TYP_39_I8_D: "Invert Fill",
  T_49_META_TYP_39_I9_D: "Gradient",
  T_49_META_TYP_392_I0_D: "Default is 0, unit is ms.",
  T_49_META_TYP_392_I1_D: "The time it takes to shrink the circle, in ms",
  T_49_META_TYP_392_I10_D: "The end time of the reduced circle, in ms",
  T_49_META_TYP_392_I12_D: "Radius of out-of-zone end circle.",
  T_49_META_TYP_392_I13_D: "Shrinking Start Time",
  T_49_META_TYP_392_I14_D: "Damage Interval (ms)",
  T_49_META_TYP_392_I3_D: "The amount of damage done to players in the out-of-zone in a single turn.",
  T_49_META_TYP_392_I4_D: "List of players in the safe zone",
  T_49_META_TYP_392_I5_D: "Safe zone disappearance time, no safe zone will be generated when the safe zone disappearance time is less than the effective time.",
  T_49_META_TYP_392_I6_D: "Group ID",
  T_49_META_TYP_392_I7_D: "Radius of the out-of-zone starting circle",
  T_49_META_TYP_392_I8_D: "End state",
  T_49_META_TYP_392_I9_D: "Status",
  T_49_META_TYP_394_I0_D: "Value is about 3.1416",
  T_49_META_TYP_394_I1_D: "Value about 2.7183",
  T_49_META_TYP_396_I0_D: "Title",
  T_49_META_TYP_396_I1_D: "Content",
  T_49_META_TYP_396_I2_D: "Options",
  T_49_META_TYP_396_I3_D: "ShowBackground",
  T_49_META_TYP_399_I0_D: "Jump Height",
  T_49_META_TYP_399_I1_D: "The number of consecutive jumps that can be performed before landing",
  T_49_META_TYP_399_I2_D: "How many jumps can be performed before landing",
  T_49_META_TYP_399_I3_D: "Enable Move In Midair",
  T_49_META_TYP_40_I1_D: "Label",
  T_49_META_TYP_40_I10_D: "Line Spacing",
  T_49_META_TYP_40_I11_D: "Overflow method",
  T_49_META_TYP_40_I12_D: "Font Style",
  T_49_META_TYP_40_I13_D: "Is Apply Shadow",
  T_49_META_TYP_40_I14_D: "Shadow Color",
  T_49_META_TYP_40_I15_D: "Shadow Offset",
  T_49_META_TYP_40_I3_D: "Localized Key, can be used in multiple languages",
  T_49_META_TYP_40_I5_D: "Alignment method",
  T_49_META_TYP_40_I6_D: "Alignment Vertical",
  T_49_META_TYP_40_I7_D: "Is Bold",
  T_49_META_TYP_40_I8_D: "Is Italic",
  T_49_META_TYP_40_I9_D: "Is Underline",
  T_49_META_TYP_400_I0_D: "Active",
  T_49_META_TYP_400_I1_D: "Passive",
  T_49_META_TYP_400_I2_D: "No Attack",
  T_49_META_TYP_401_I0_D: "Cannot fire.",
  T_49_META_TYP_401_I1_D: "Can fire continuously",
  T_49_META_TYP_401_I2_D: "Fires once per attack command",
  T_49_META_TYP_401_I3_D: "Three times per attack command.",
  T_49_META_TYP_401_I4_D: "Fires twice per attack command",
  T_49_META_TYP_401_I5_D: "Parry",
  T_49_META_TYP_402_I0_D: "Targets to friend",
  T_49_META_TYP_402_I1_D: "Function Type",
  T_49_META_TYP_402_I2_D: "Style",
  T_49_META_TYP_403_I0_D: "Add Friend",
  T_49_META_TYP_403_I1_D: "Report",
  T_49_META_TYP_404_I0_D: "Light",
  T_49_META_TYP_404_I1_D: "Dark",
  T_49_META_TYP_405_I0_D: "By Hierarchy",
  T_49_META_TYP_405_I1_D: "By Priority High To Low",
  T_49_META_TYP_405_I2_D: "By Priority Low To High",
  T_49_META_TYP_406_I0_D: "Control the distance of player's Animation.",
  T_49_META_TYP_406_I1_D: "Controls the height of the player's body during the move.",
  T_49_META_TYP_407_I0_D: "Local",
  T_49_META_TYP_407_I1_D: "Client",
  T_49_META_TYP_407_I2_D: "Server",
  T_49_META_TYP_407_I3_D: "Both",
  T_49_META_TYP_409_I0_D: "No errors",
  T_49_META_TYP_409_I1_D: "Data storage timeout, mainly for read operations",
  T_49_META_TYP_409_I10_D: "Failed team change - invalid target team",
  T_49_META_TYP_409_I11_D: "Failed team change - Dead player not allowed to change teams",
  T_49_META_TYP_409_I12_D: "Failed team change - not allowed to change team in vehicle",
  T_49_META_TYP_409_I2_D: "Data storage read/write frequency exceeds the limit",
  T_49_META_TYP_409_I3_D: "Parameter exceptions",
  T_49_META_TYP_409_I4_D: "Room creation failed: no valid PersonaIDs available",
  T_49_META_TYP_409_I5_D: "Undefined error status",
  T_49_META_TYP_409_I6_D: "Commercialization service shut down, users can no longer use the developer's service",
  T_49_META_TYP_409_I7_D: "Failed to change team - mode not supported",
  T_49_META_TYP_409_I8_D: "Failed to change team-Currently already in target team",
  T_49_META_TYP_409_I9_D: "Queue change failed-invalid target",
  T_49_META_TYP_41_I0_D: "Sprite Shape",
  T_49_META_TYP_41_I19_D: "Disable collision box",
  T_49_META_TYP_41_I3_D: "Disable Color",
  T_49_META_TYP_41_I4_D: "Pressed Color",
  T_49_META_TYP_41_I5_D: "Fill Type",
  T_49_META_TYP_41_I6_D: "Is FE Button",
  T_49_META_TYP_41_I7_D: "Pressed Sprite",
  T_49_META_TYP_41_I8_D: "Pressed Sprite Type",
  T_49_META_TYP_41_I9_D: "Flip Type",
  T_49_META_TYP_411_I0_D: "Forward Speed",
  T_49_META_TYP_411_I1_D: "Backward Speed",
  T_49_META_TYP_411_I2_D: "Up Speed",
  T_49_META_TYP_411_I3_D: "Down Speed",
  T_49_META_TYP_411_I4_D: "Grenade Min Damage",
  T_49_META_TYP_411_I5_D: "Grenade Max Damage",
  T_49_META_TYP_411_I6_D: "Grenade Range",
  T_49_META_TYP_412_I0_D: "Horsepower gained by the vehicle when using the gas button",
  T_49_META_TYP_412_I1_D: "Horsepower gained by the vehicle when using the reverse/brake button",
  T_49_META_TYP_412_I2_D: "Maximum steering angle at high speed",
  T_49_META_TYP_412_I3_D: "Speed threshold applied to the maximum steering angle at high speeds",
  T_49_META_TYP_412_I4_D: "After reaching the maximum speed, the carrier does not provide any more horsepower, but the carrier may exceed that maximum speed (e.g. through a downhill)",
  T_49_META_TYP_412_I5_D: "When the carrier is not being maneuvered, decelerate the carrier by multiplying IdleBrakeInput by BrakeTorque",
  T_49_META_TYP_412_I6_D: "Damage calculation for crashes, applying the parameters of the damage formula",
  T_49_META_TYP_412_I7_D: "Damage calculation for crashing, damage will not be increased even if the speed is exceeded.",
  T_49_META_TYP_412_I8_D: "Damage calculation for ramming, minimum damage",
  T_49_META_TYP_412_I9_D: "Damage calculation for ramming, maximum damage",
  T_49_META_TYP_413_I0_D: "Player (NPC) transformed costume",
  T_49_META_TYP_414_I1_D: "Wide Range",
  T_49_META_TYP_415_I0_D: "Persona ID",
  T_49_META_TYP_415_I1_D: "Nickname",
  T_49_META_TYP_415_I2_D: "Avatar",
  T_49_META_TYP_416_I1_D: "The Persona to which it is bound.",
  T_49_META_TYP_416_I2_D: "Offset",
  T_49_META_TYP_416_I3_D: "Height",
  T_49_META_TYP_416_I4_D: "Whether to reply to system messages",
  T_49_META_TYP_416_I5_D: "Persona nickname",
  T_49_META_TYP_416_I6_D: "PersonaAvatar",
  T_49_META_TYP_416_I7_D: "Nickname of the user",
  T_49_META_TYP_416_I8_D: "User Avatar",
  T_49_META_TYP_417_I0_D: "Resource ID",
  T_49_META_TYP_418_I0_D: "Membership expiration",
  T_49_META_TYP_418_I1_D: "Become a member",
  T_49_META_TYP_418_I2_D: "Renew membership",
  T_49_META_TYP_42_I0_D: "Default Text",
  T_49_META_TYP_42_I1_D: "Active Text",
  T_49_META_TYP_42_I10_D: "Max Length",
  T_49_META_TYP_42_I14_D: "Pressed Color",
  T_49_META_TYP_42_I16_D: "Localized Key, available in multiple languages",
  T_49_META_TYP_42_I3_D: "Alignment method",
  T_49_META_TYP_42_I4_D: "Alignment Vertical",
  T_49_META_TYP_42_I5_D: "Is Bold",
  T_49_META_TYP_42_I6_D: "Is Italic",
  T_49_META_TYP_42_I7_D: "Is Underline",
  T_49_META_TYP_42_I8_D: "Line Spacing",
  T_49_META_TYP_42_I9_D: "Word Wrap",
  T_49_META_TYP_424_I0_D: "Linear Fog",
  T_49_META_TYP_424_I1_D: "Exponential Fog",
  T_49_META_TYP_424_I2_D: "Exponential Square Fog",
  T_49_META_TYP_426_I0_D: "Intensity",
  T_49_META_TYP_426_I1_D: "Range",
  T_49_META_TYP_426_I2_D: "The angle of the cone in degrees.",
  T_49_META_TYP_426_I3_D: "Light color",
  T_49_META_TYP_428_I0_D: "Weapon Skin IDs",
  T_49_META_TYP_428_I2_D: "Suit ID",
  T_49_META_TYP_428_I3_D: "Headwear ID",
  T_49_META_TYP_428_I4_D: "Face ID",
  T_49_META_TYP_428_I5_D: "Makeup ID",
  T_49_META_TYP_428_I6_D: "Upper Body ID",
  T_49_META_TYP_428_I7_D: "Bottom ID",
  T_49_META_TYP_428_I8_D: "Shoe ID",
  T_49_META_TYP_431_I1_D: "The trajectory of the target entity",
  T_49_META_TYP_431_I3_D: "Movement speed, unit m/s",
  T_49_META_TYP_431_I4_D: `Whether the movement is toward the tangent line of the path or not 
Default is False, the movement of the object will not change the direction 
 If True, the movement of the object will face the path forward direction`,
  T_49_META_TYP_431_I5_D: "Played Percentage",
  T_49_META_TYP_432_I0_D: "Rollover angle, affects the radial rotation of the path from both sides of this point",
  T_49_META_TYP_432_I1_D: "The relative position of the tangent control point to the waypoint, which determines the path tangent.",
  T_49_META_TYP_433_I0_D: "Tween straight lines between path points",
  T_49_META_TYP_433_I1_D: "Tween curves between path points for smooth motion.",
  T_49_META_TYP_433_I2_D: "Supports manual adjustment of tangents to curve points",
  T_49_META_TYP_434_I0_D: "Path type",
  T_49_META_TYP_434_I1_D: "Total length of the path",
  T_49_META_TYP_434_I2_D: "Whether the path begins and ends at the same time",
  T_49_META_TYP_434_I3_D: "Collection of waypoints",
  T_49_META_TYP_437_I3_D: "Left Players",
  T_49_META_TYP_437_I4_D: "Right Players",
  T_49_META_TYP_437_I5_D: "Array of points type names",
  T_49_META_TYP_437_I6_D: "Left points array (List 1D: player; List 2D: points data filled according to customized points type)",
  T_49_META_TYP_437_I7_D: "Array of points on the right (List 1D: players; List 2D: points data filled in according to customized points types)",
  T_49_META_TYP_438_I1_D: "Grouped players array",
  T_49_META_TYP_438_I2_D: "Grouped Ranking Array",
  T_49_META_TYP_438_I3_D: "Array of grouped scores",
  T_49_META_TYP_438_I4_D: "Array of point type names",
  T_49_META_TYP_438_I5_D: "Grouped colors array",
  T_49_META_TYP_438_I6_D: "Array of players' points (corresponding to their order when not grouped)",
  T_49_META_TYP_442_I1_D: "Left Score",
  T_49_META_TYP_442_I10_D: "Right death icon",
  T_49_META_TYP_442_I2_D: "Right Score",
  T_49_META_TYP_442_I3_D: "Number of survivors on the left",
  T_49_META_TYP_442_I4_D: "Survivors on the right",
  T_49_META_TYP_442_I5_D: "Left Dead",
  T_49_META_TYP_442_I6_D: "Right Deaths",
  T_49_META_TYP_442_I7_D: "Left survivor icon",
  T_49_META_TYP_442_I8_D: "Right Survival Icon",
  T_49_META_TYP_442_I9_D: "Left Dead Icon",
  T_49_META_TYP_444_I0_D: "English",
  T_49_META_TYP_444_I1_D: "Simplified Chinese",
  T_49_META_TYP_444_I10_D: "French",
  T_49_META_TYP_444_I11_D: "German",
  T_49_META_TYP_444_I12_D: "Turkish",
  T_49_META_TYP_444_I13_D: "Hindi",
  T_49_META_TYP_444_I14_D: "Japanese",
  T_49_META_TYP_444_I15_D: "Romanian",
  T_49_META_TYP_444_I16_D: "Romanian",
  T_49_META_TYP_444_I17_D: "Burmese",
  T_49_META_TYP_444_I18_D: "Urdu",
  T_49_META_TYP_444_I19_D: "Bengali",
  T_49_META_TYP_444_I2_D: "Traditional Chinese",
  T_49_META_TYP_444_I3_D: "Thai",
  T_49_META_TYP_444_I4_D: "Vietnamese",
  T_49_META_TYP_444_I5_D: "Indonesian",
  T_49_META_TYP_444_I6_D: "Chinese (Simplified)",
  T_49_META_TYP_444_I7_D: "Spanish",
  T_49_META_TYP_444_I8_D: "Russian",
  T_49_META_TYP_444_I9_D: "Korean",
  T_49_META_TYP_51_I0_D: "Normal Zombie",
  T_49_META_TYP_51_I1_D: "Axe Zombie",
  T_49_META_TYP_51_I10_D: "Fly Bomb Bee",
  T_49_META_TYP_51_I11_D: "Zombie Dragon",
  T_49_META_TYP_51_I2_D: "Tossing Zombie",
  T_49_META_TYP_51_I3_D: "Self-Explode Zombie",
  T_49_META_TYP_51_I4_D: "Tyrant Zombie",
  T_49_META_TYP_51_I5_D: "Throw Red Zombie",
  T_49_META_TYP_51_I6_D: "MrV",
  T_49_META_TYP_51_I7_D: "Tank Zombie",
  T_49_META_TYP_51_I8_D: "Drill Zombie",
  T_49_META_TYP_51_I9_D: "Samurai",
  T_49_META_TYP_56_I10_D: "Explosion Delay",
  T_49_META_TYP_56_I11_D: "Explosion Range",
  T_49_META_TYP_56_I12_D: "Explosion Damage",
  T_49_META_TYP_56_I13_D: "Burning Time",
  T_49_META_TYP_56_I14_D: "Burning Damage",
  T_49_META_TYP_56_I15_D: "Burning Damage Interval",
  T_49_META_TYP_56_I17_D: "Vehicle Pilot",
  T_49_META_TYP_56_I18_D: "All passengers on the vehicle",
  T_49_META_TYP_56_I19_D: "Vehicle Skin ID",
  T_49_META_TYP_56_I20_D: "Prioritize Player Configuration",
  T_49_META_TYP_56_I21_D: "Max. HP",
  T_49_META_TYP_56_I22_D: "HP",
  T_49_META_TYP_57_I0_D: "Whether to teleport manually or automatically (default is manual)",
  T_49_META_TYP_58_I0_D: "Type of buff generated",
  T_49_META_TYP_58_I1_D: "The time in seconds from when the buff is picked up to when the next buff is generated.",
  T_49_META_TYP_59_I0_D: "Motion Type",
  T_49_META_TYP_59_I1_D: "Motion Value X",
  T_49_META_TYP_59_I2_D: "Motion Value Y",
  T_49_META_TYP_59_I3_D: "Motion Value Z",
  T_49_META_TYP_59_I4_D: "Movement Duration",
  T_49_META_TYP_59_I5_D: "Stop Duration",
  T_49_META_TYP_59_I6_D: "Disable Reciprocating",
  T_49_META_TYP_60_I0_D: "Loot weapon points",
  T_49_META_TYP_61_I0_D: "Bound Store",
  T_49_META_TYP_61_I1_D: "Setting the trigger range",
  T_49_META_TYP_61_I2_D: "Model Visibility",
  T_49_META_TYP_62_I0_D: "Velocity XZ",
  T_49_META_TYP_62_I1_D: "Velocity Y",
  T_49_META_TYP_64_I0_D: "Music component type",
  T_49_META_TYP_66_I0_D: "InstanceID",
  T_49_META_TYP_66_I1_D: "Path Point",
  T_49_META_TYP_68_I0_D: "AI's current blood level",
  T_49_META_TYP_68_I1_D: "AI's current maximum blood level",
  T_49_META_TYP_68_I10_D: "Whether the AI drops equipment or items when it dies.",
  T_49_META_TYP_68_I11_D: "Whether the AI is currently invincible",
  T_49_META_TYP_68_I12_D: "Percentage of damage dealt to the AI when it takes damage, can be reduced or increased",
  T_49_META_TYP_68_I13_D: "Type of AI",
  T_49_META_TYP_68_I14_D: "Whether to automatically search for enemies",
  T_49_META_TYP_68_I15_D: "0 is auto attack, 1 is defense attack, 2 is no attack at all.",
  T_49_META_TYP_68_I16_D: "Path ID",
  T_49_META_TYP_68_I17_D: "Chase Target",
  T_49_META_TYP_68_I18_D: "Attack Target",
  T_49_META_TYP_68_I19_D: "AI's birth point coordinates",
  T_49_META_TYP_68_I2_D: "Get the entity of the AI's team.",
  T_49_META_TYP_68_I20_D: "The team's camp number",
  T_49_META_TYP_68_I4_D: "Can only modify the attack power of normal attacks, skill attacks don't count.",
  T_49_META_TYP_68_I7_D: "AI's free movement range, can only modify the base value, if there is extra bonus, it will be added on top of that value.",
  T_49_META_TYP_68_I8_D: "AI's range to detect enemies, can only modify the base value, if there is an extra bonus, it will be added on top of that value.",
  T_49_META_TYP_68_I9_D: "True movement speed, if there is a skill acceleration it will be multiplied by it.",
  T_49_META_TYP_70_I0_D: "ID of the target entity that the formula works on, used by internal implementations, invisible to the player.",
  T_49_META_TYP_70_I1_D: "ID of the target entity property on which the formula works, used by internal implementations, not visible to the player",
  T_49_META_TYP_70_I2_D: "Minimum value allowed",
  T_49_META_TYP_70_I3_D: "Maximum value allowed",
  T_49_META_TYP_70_I4_D: "Base Coefficient",
  T_49_META_TYP_70_I5_D: "Pre-Accumulator",
  T_49_META_TYP_70_I6_D: "Multiplier",
  T_49_META_TYP_70_I7_D: "Multiply Accumulate",
  T_49_META_TYP_70_I8_D: "Post-Accumulator",
  T_49_META_TYP_71_I0_D: "Shop item number",
  T_49_META_TYP_71_I1_D: "Price",
  T_49_META_TYP_71_I10_D: "Is Purchasable",
  T_49_META_TYP_71_I2_D: "Money Type",
  T_49_META_TYP_71_I3_D: "Overall limit",
  T_49_META_TYP_71_I4_D: "Current overall limit",
  T_49_META_TYP_71_I5_D: "Shop item name",
  T_49_META_TYP_71_I6_D: "Shop Item Description",
  T_49_META_TYP_71_I7_D: "Shop Item List",
  T_49_META_TYP_71_I8_D: "ItemCounts",
  T_49_META_TYP_71_I9_D: "Resource path, empty by default",
  T_49_META_TYP_72_I1_D: "Shop Items",
  T_49_META_TYP_73_I1_D: "Shelfs",
  T_49_META_TYP_74_I0_D: "Weapon",
  T_49_META_TYP_74_I1_D: "Helmet",
  T_49_META_TYP_74_I2_D: "Vest",
  T_49_META_TYP_74_I3_D: "Grenade",
  T_49_META_TYP_75_I0_D: "One Way",
  T_49_META_TYP_75_I1_D: "Back And Forth",
  T_49_META_TYP_76_I0_D: "Patrols only, no attacks on targets along the way",
  T_49_META_TYP_76_I1_D: "Patrol While Attack",
  T_49_META_TYP_79_I0_D: "Weapon Attack Power",
  T_49_META_TYP_79_I1_D: "Attack Range",
  T_49_META_TYP_79_I10_D: "Bullet Spread Start Count",
  T_49_META_TYP_79_I11_D: "Weapon ID",
  T_49_META_TYP_79_I12_D: "Minimum wait time in seconds between shots, multiple bullets may be fired per shot depending on shot type",
  T_49_META_TYP_79_I13_D: "The player who owns the weapon",
  T_49_META_TYP_79_I14_D: "Is Consume Ammo",
  T_49_META_TYP_79_I15_D: "Dual wielding type (0 not dual wielding 1 and self 2 and any weapon)",
  T_49_META_TYP_79_I16_D: "Armor damage factor",
  T_49_META_TYP_79_I17_D: "Player movement speed effects",
  T_49_META_TYP_79_I18_D: "Damage percentage for hitting the torso",
  T_49_META_TYP_79_I19_D: "Percentage of damage that hits the head",
  T_49_META_TYP_79_I2_D: "The length of time to wait between bullets, in seconds.",
  T_49_META_TYP_79_I20_D: "Damage percentage for hitting limbs",
  T_49_META_TYP_79_I21_D: "Extra Damage Ratio (Vehicle, Oil Drum, Ice Wall)",
  T_49_META_TYP_79_I22_D: "Visible On Back",
  T_49_META_TYP_79_I23_D: "Extra damage for hitting the ground",
  T_49_META_TYP_79_I24_D: "Ammo per Shot",
  T_49_META_TYP_79_I25_D: "Bullet change speed (base speed * factor)",
  T_49_META_TYP_79_I26_D: "Current Ammo Count",
  T_49_META_TYP_79_I27_D: "Gunskin ID",
  T_49_META_TYP_79_I28_D: "When player configuration is prioritized, the gun skin configuration on the player overrides the gun skin property of the weapon itself",
  T_49_META_TYP_79_I29_D: "When writing in the gun skin's properties for a weapon, the weapon's base value is affected by the gun skin",
  T_49_META_TYP_79_I3_D: "Ammo Mag Size",
  T_49_META_TYP_79_I30_D: "Diffusion Increase Speed (0.1 = 10% expansion for each additional burst of collision)",
  T_49_META_TYP_79_I31_D: "Diffusion recovery speed",
  T_49_META_TYP_79_I32_D: "Player speed effect when firing",
  T_49_META_TYP_79_I33_D: "Diffusion size in case of movement (1.5 = 1.5 * basic collimator size)",
  T_49_META_TYP_79_I34_D: "Weapon Type",
  T_49_META_TYP_79_I36_D: "Fire Type",
  T_49_META_TYP_79_I37_D: "Is Single Shot",
  T_49_META_TYP_79_I38_D: "Is Silenced",
  T_49_META_TYP_79_I39_D: "ADS Sensitivity Multiplier",
  T_49_META_TYP_79_I4_D: "Initial Mag Count",
  T_49_META_TYP_79_I5_D: "Armor Penetration",
  T_49_META_TYP_79_I6_D: "Full Damage Distance",
  T_49_META_TYP_79_I7_D: "Min. Damage Distance",
  T_49_META_TYP_79_I8_D: "Min. Damage",
  T_49_META_TYP_79_I9_D: "The number of bullets that can be fired before the scattering begins",
  T_49_META_TYP_80_I1_D: "When true, manual disable is disabled.",
  T_49_META_TYP_80_I2_D: "Bound shop entities",
  T_49_META_TYP_80_I4_D: "Bound Money List",
  T_49_META_TYP_80_I5_D: "Bound Wallet ID",
  T_49_META_TYP_80_I6_D: "The type of the current UI player request target",
  T_49_META_TYP_80_I7_D: "Requested Item List",
  T_49_META_TYP_81_I0_D: "Random Buff",
  T_49_META_TYP_81_I1_D: "HP Buff",
  T_49_META_TYP_81_I2_D: "Bullet Buff",
  T_49_META_TYP_81_I3_D: "Armor Buff",
  T_49_META_TYP_82_I1_D: "Button icon",
  T_49_META_TYP_82_I3_D: "Position relative to the anchor point",
  T_49_META_TYP_83_I1_D: "TriggerPlayerID",
  T_49_META_TYP_83_I2_D: "Passed parameters",
  T_49_META_TYP_86_I0_D: "Min",
  T_49_META_TYP_86_I1_D: "Max",
  T_49_META_TYP_86_I2_D: "Base coefficient, multiplied by the original value before all calculations are performed.",
  T_49_META_TYP_86_I3_D: "Pre-accumulator, accumulates before multiplication, participates in multiplication calculations",
  T_49_META_TYP_86_I4_D: "Consecutive multipliers, for example (reduced to 90%, strengthened to 110%) have the effect of Value*90%*110%.",
  T_49_META_TYP_86_I5_D: "The effect of a multiplication accumulator, e.g. (add 10%, add 5%) is Value*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "Post accumulator, not involved in multiplication calculations, stacked at the end",
  T_49_META_TYP_88_I0_D: "Base type, the most basic in-game currency, the type of pricing for general shop items in the current version",
  T_49_META_TYP_89_I0_D: "Only base currency is available in the current version",
  T_49_META_TYP_89_I1_D: "Amount of currency",
  T_49_META_TYP_89_I2_D: "Currency icon",
  T_49_META_TYP_89_I3_D: "Currency icon color",
  T_49_META_TYP_90_I0_D: "The contents of the wallet are a bunch of currencies",
  T_49_META_TYP_92_I0_D: "Square Wooden Crate",
  T_49_META_TYP_92_I1_D: "Long Wooden Crate",
  T_49_META_TYP_92_I10_D: "Turret",
  T_49_META_TYP_92_I100_D: "Stairs",
  T_49_META_TYP_92_I101_D: "Stair Landing B",
  T_49_META_TYP_92_I102_D: "Stair Landing A",
  T_49_META_TYP_92_I103_D: "Phone Booth",
  T_49_META_TYP_92_I104_D: "BIS Themed Wall",
  T_49_META_TYP_92_I105_D: "BIS Themed Flower Bed",
  T_49_META_TYP_92_I106_D: "Vending Machine",
  T_49_META_TYP_92_I107_D: "Monster Entities",
  T_49_META_TYP_92_I108_D: "Unit Generator",
  T_49_META_TYP_92_I109_D: "Sports Car",
  T_49_META_TYP_92_I11_D: "Guardhouse",
  T_49_META_TYP_92_I110_D: "Tuk Tuk",
  T_49_META_TYP_92_I111_D: "Destructible Wooden Crate",
  T_49_META_TYP_92_I112_D: "SUV",
  T_49_META_TYP_92_I113_D: "Motorbike",
  T_49_META_TYP_92_I114_D: "Monster Truck",
  T_49_META_TYP_92_I115_D: "Coin Generator",
  T_49_META_TYP_92_I116_D: "Stair Landing C",
  T_49_META_TYP_92_I117_D: "Sign",
  T_49_META_TYP_92_I118_D: "Fence",
  T_49_META_TYP_92_I119_D: "Jersey Machine",
  T_49_META_TYP_92_I12_D: "Two-Story House",
  T_49_META_TYP_92_I121_D: "Concrete Pillar",
  T_49_META_TYP_92_I122_D: "Loot Soccer Item Box",
  T_49_META_TYP_92_I123_D: "Oil Drum",
  T_49_META_TYP_92_I124_D: "Low-Gravity Area",
  T_49_META_TYP_92_I125_D: "Weapon",
  T_49_META_TYP_92_I126_D: "Fence B",
  T_49_META_TYP_92_I127_D: "Small House A",
  T_49_META_TYP_92_I128_D: "Damaged Truck",
  T_49_META_TYP_92_I129_D: "Basic Sphere",
  T_49_META_TYP_92_I13_D: "Sand Sculpture",
  T_49_META_TYP_92_I130_D: "Basic Cone",
  T_49_META_TYP_92_I131_D: "Basic Cylinder",
  T_49_META_TYP_92_I132_D: "Consumable Generator",
  T_49_META_TYP_92_I133_D: "Custom Water Body",
  T_49_META_TYP_92_I134_D: "Arrow",
  T_49_META_TYP_92_I135_D: "Dyed Block",
  T_49_META_TYP_92_I136_D: "Dyed Oil Drum",
  T_49_META_TYP_92_I137_D: "Text",
  T_49_META_TYP_92_I138_D: "Icon",
  T_49_META_TYP_92_I139_D: "Ice Doll",
  T_49_META_TYP_92_I14_D: "Fountain",
  T_49_META_TYP_92_I140_D: "Capsule Trigger",
  T_49_META_TYP_92_I141_D: "Sphere Collision Trigger",
  T_49_META_TYP_92_I142_D: "Reflective Solid Color Basic Block 1",
  T_49_META_TYP_92_I143_D: "Bumper Car Manufacturer",
  T_49_META_TYP_92_I144_D: "Checkered Amusement Park Block",
  T_49_META_TYP_92_I145_D: "Large Screen",
  T_49_META_TYP_92_I146_D: "Podium",
  T_49_META_TYP_92_I147_D: "Giant Lollipop",
  T_49_META_TYP_92_I148_D: "Food Truck B",
  T_49_META_TYP_92_I15_D: "Cherry Blossom",
  T_49_META_TYP_92_I16_D: "One-Story House",
  T_49_META_TYP_92_I17_D: "Three-Story House",
  T_49_META_TYP_92_I18_D: "Banana Tree",
  T_49_META_TYP_92_I19_D: "Toilet",
  T_49_META_TYP_92_I2_D: "Bush-Covered Long Wooden Crate",
  T_49_META_TYP_92_I20_D: "Fence",
  T_49_META_TYP_92_I21_D: "Destructible Container",
  T_49_META_TYP_92_I22_D: "Destructible Fence",
  T_49_META_TYP_92_I23_D: "Tire",
  T_49_META_TYP_92_I24_D: "Bumper Car",
  T_49_META_TYP_92_I25_D: "Amphibious Vehicle",
  T_49_META_TYP_92_I26_D: "Jeep",
  T_49_META_TYP_92_I27_D: "Trash Can",
  T_49_META_TYP_92_I28_D: "Medical Tent",
  T_49_META_TYP_92_I29_D: "Garage",
  T_49_META_TYP_92_I3_D: "Haystack",
  T_49_META_TYP_92_I30_D: "Painted Wall",
  T_49_META_TYP_92_I31_D: "Torii",
  T_49_META_TYP_92_I32_D: "Iron Platform",
  T_49_META_TYP_92_I33_D: "Container House",
  T_49_META_TYP_92_I34_D: "Trailer",
  T_49_META_TYP_92_I35_D: "Wall A",
  T_49_META_TYP_92_I36_D: "Musical Notes - Piano",
  T_49_META_TYP_92_I37_D: "Musical Notes - Piano",
  T_49_META_TYP_92_I38_D: "Musical Notes - Drum",
  T_49_META_TYP_92_I39_D: "Musical Notes - Drum",
  T_49_META_TYP_92_I4_D: "Wrecked Car",
  T_49_META_TYP_92_I40_D: "Musical Notes - Synthesizer A",
  T_49_META_TYP_92_I41_D: "Musical Notes - Synthesizer A",
  T_49_META_TYP_92_I42_D: "Musical Notes - Synthesizer B",
  T_49_META_TYP_92_I43_D: "Musical Notes - Synthesizer B",
  T_49_META_TYP_92_I44_D: "Musical Notes - Synthesizer C",
  T_49_META_TYP_92_I45_D: "Musical Notes - Synthesizer C",
  T_49_META_TYP_92_I46_D: "Buff Generator",
  T_49_META_TYP_92_I47_D: "Propeller Mechanisms",
  T_49_META_TYP_92_I48_D: "Pan Loot",
  T_49_META_TYP_92_I49_D: "Cube Loot",
  T_49_META_TYP_92_I5_D: "Wrecked Bus",
  T_49_META_TYP_92_I50_D: "Circle Loot",
  T_49_META_TYP_92_I51_D: "Mallet Machine",
  T_49_META_TYP_92_I52_D: "Moving Board",
  T_49_META_TYP_92_I53_D: "Moving Target",
  T_49_META_TYP_92_I54_D: "Retractable Wall",
  T_49_META_TYP_92_I55_D: "Loot Point Weapon Component",
  T_49_META_TYP_92_I56_D: "Loot Point Bullet Component",
  T_49_META_TYP_92_I57_D: "Loot Point Expendable Item Component",
  T_49_META_TYP_92_I58_D: "Loot Point Thrown Item Component",
  T_49_META_TYP_92_I59_D: "Loot Point Multiplier Component",
  T_49_META_TYP_92_I6_D: "Container A",
  T_49_META_TYP_92_I60_D: "Loot Point Armor Component",
  T_49_META_TYP_92_I61_D: "I Pipe",
  T_49_META_TYP_92_I62_D: "T Pipe",
  T_49_META_TYP_92_I63_D: "Cross Pipe",
  T_49_META_TYP_92_I64_D: "Elbow Pipe",
  T_49_META_TYP_92_I65_D: "Giant Mushroom Cluster",
  T_49_META_TYP_92_I66_D: "Drying Rack",
  T_49_META_TYP_92_I67_D: "Plank Bridge",
  T_49_META_TYP_92_I68_D: "Lattice Screen",
  T_49_META_TYP_92_I69_D: "Concrete Column",
  T_49_META_TYP_92_I7_D: "Shipping Container B",
  T_49_META_TYP_92_I70_D: "Cactus",
  T_49_META_TYP_92_I71_D: "Dead Wood",
  T_49_META_TYP_92_I72_D: "Stone Lantern",
  T_49_META_TYP_92_I73_D: "Streetlight",
  T_49_META_TYP_92_I74_D: "Solar Panel",
  T_49_META_TYP_92_I75_D: "Air Conditioner",
  T_49_META_TYP_92_I76_D: "Square",
  T_49_META_TYP_92_I77_D: "Slope",
  T_49_META_TYP_92_I78_D: "Food Truck",
  T_49_META_TYP_92_I79_D: "Death or Invincibility Trigger",
  T_49_META_TYP_92_I8_D: "Shipping Container C",
  T_49_META_TYP_92_I80_D: "Checkpoint",
  T_49_META_TYP_92_I81_D: "End Position",
  T_49_META_TYP_92_I82_D: "Dice",
  T_49_META_TYP_92_I83_D: "Bench",
  T_49_META_TYP_92_I84_D: "Bus Stop",
  T_49_META_TYP_92_I85_D: "Dog House",
  T_49_META_TYP_92_I86_D: "Ad Board",
  T_49_META_TYP_92_I87_D: "Refinery Tank",
  T_49_META_TYP_92_I88_D: "Graffiti Wall",
  T_49_META_TYP_92_I89_D: "Stable",
  T_49_META_TYP_92_I9_D: "Cabin",
  T_49_META_TYP_92_I90_D: "Stone Arch Bridge",
  T_49_META_TYP_92_I91_D: "Patio Set With Umbrella",
  T_49_META_TYP_92_I92_D: "Finish Banner",
  T_49_META_TYP_92_I93_D: "Fortress",
  T_49_META_TYP_92_I94_D: "Monster Spawn Point",
  T_49_META_TYP_92_I95_D: "Mark",
  T_49_META_TYP_92_I97_D: "Custom Trigger",
  T_49_META_TYP_92_I98_D: "Double Door",
  T_49_META_TYP_92_I99_D: "Barricade",
  T_49_META_TYP_94_I0_D: "Add",
  T_49_META_TYP_94_I1_D: "Multiply",
  T_49_META_TYP_95_I0_D: "Money Type",
  T_49_META_TYP_95_I1_D: "Amount of currency",
  T_49_META_TYP_96_I0_D: "Get Wallet",
  T_49_META_TYP_96_I1_D: "Display position (anchor is top right corner)",
  T_49_META_TYP_97_I0_D: "Position in the world coordinate system",
  T_49_META_TYP_97_I1_D: "Rotation angle in the world coordinate system, XYZ components are pitch, yaw, and roll, respectively, and rotation order YXZ.",
  T_49_META_TYP_97_I10_D: "Local coordinate axis x-axis orientation",
  T_49_META_TYP_97_I11_D: "Local axis z-axis orientation",
  T_49_META_TYP_97_I2_D: "Zoom size in the world coordinate system",
  T_49_META_TYP_97_I3_D: "Parent node of this node",
  T_49_META_TYP_97_I4_D: "Rotation in the world coordinate system, expressed in quaternions",
  T_49_META_TYP_97_I5_D: "Position in local coordinate system",
  T_49_META_TYP_97_I6_D: "Rotation in the local coordinate system, expressed in quaternions",
  T_49_META_TYP_97_I7_D: "Rotation angle in the local coordinate system, with XYZ components for pitch, yaw, and roll, respectively, and rotation order YXZ.",
  T_49_META_TYP_97_I8_D: "Scaling dimension in the local coordinate system",
  T_49_META_TYP_97_I9_D: "Local coordinate axis y-axis orientation",
  T_49_META_TYP_99_I0_D: "Radius of the soccer ball",
  T_49_META_TYP_99_I1_D: "Friction coefficient at normal condition",
  T_49_META_TYP_99_I2_D: "Impact Friction",
  T_49_META_TYP_99_I3_D: "Min. Shooting Angle",
  T_49_META_TYP_99_I4_D: "Min. Elevation Angle",
  T_49_META_TYP_99_I5_D: "Reset Time",
  T_49_META_TYP_99_I6_D: "Max. Shooting Angle",
  T_49_META_TYP_99_I7_D: "Reset Position",
  T_49_META_TYPE_0_D: "Object, the root of the type hierarchy",
  T_49_META_TYPE_1_D: "A container for a set of data in a list",
  T_49_META_TYPE_10_D: "Entity base component, all components will combine this component",
  T_49_META_TYPE_100_D: "JerseyMachine",
  T_49_META_TYPE_101_D: "Morph Object",
  T_49_META_TYPE_1010_D: "Timer Info",
  T_49_META_TYPE_1011_D: "Opening Banner",
  T_49_META_TYPE_1012_D: "Banner entities start in two-team rounds, and modifying entity properties affects the display on the corresponding UI.",
  T_49_META_TYPE_1013_D: "General round start banner entity, modifying entity properties affects display content on corresponding UIs",
  T_49_META_TYPE_1014_D: "Team round score banner entity, modifying entity properties affects the display on the corresponding UI.",
  T_49_META_TYPE_1015_D: "Checkpoint Manager entity, modifying the entity properties will affect the display on the corresponding UI.",
  T_49_META_TYPE_1016_D: "End of round display entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1017_D: "If there are two teams at the start of the round, display the two teams' rivalry banner",
  T_49_META_TYPE_1018_D: "Score of the round between the two teams",
  T_49_META_TYPE_1019_D: "The final result is a tie",
  T_49_META_TYPE_102_D: "Resurrection source type: death, fall down",
  T_49_META_TYPE_1020_D: "Round count entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1021_D: "Phase countdown entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_1022_D: "Match information subheading entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1023_D: "Two teams match information entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_1024_D: "Team match information UI entity, modify the entity property to affect the display content on the corresponding UI",
  T_49_META_TYPE_1027_D: "Describes the type of the type and returns that type when Typeof is used",
  T_49_META_TYPE_1028_D: "Camp information entity, modify the entity properties to affect the display content of the corresponding UI.",
  T_49_META_TYPE_1029_D: "The icon hint information entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_103_D: "Enumeration of item slots",
  T_49_META_TYPE_1030_D: "Short version of the two teams' match information entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_1031_D: "Timing prompt UI entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1032_D: "Floating word prompt entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1033_D: "Round switching entity, including current round settlement and next round start information, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1035_D: "Open scoreboard button UI entity, modifying entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1036_D: "Infected mode, display the UI of current zombie level.",
  T_49_META_TYPE_1037_D: "Add points animation UI entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_1038_D: "Infected mode zombie UI effects",
  T_49_META_TYPE_1039_D: "Countdown prompt entity, modifying the entity properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_104_D: "Jersey Style",
  T_49_META_TYPE_1040_D: "UI Card Selection Panel",
  T_49_META_TYPE_1041_D: "UI Identity Notification",
  T_49_META_TYPE_1042_D: "UI Countdown 5s",
  T_49_META_TYPE_1043_D: "UI Title Banner",
  T_49_META_TYPE_1044_D: "UI Built-In Switch",
  T_49_META_TYPE_1045_D: "UI Skill Button",
  T_49_META_TYPE_105_D: "Football Goal",
  T_49_META_TYPE_106_D: "Aiming aid type",
  T_49_META_TYPE_107_D: "Entities that can be targeted and hit, but not necessarily harmed",
  T_49_META_TYPE_108_D: "Integer types, 64-bit signed integers",
  T_49_META_TYPE_109_D: "The chat channel entity is a container that contains its channel ID and players.",
  T_49_META_TYPE_11_D: "Global entity, unique for the entire game",
  T_49_META_TYPE_110_D: "Idle chat channel",
  T_49_META_TYPE_111_D: "Behavior types",
  T_49_META_TYPE_112_D: "Player Behavior Status Type",
  T_49_META_TYPE_113_D: "Drum Music",
  T_49_META_TYPE_114_D: "Lead1 Music",
  T_49_META_TYPE_115_D: "Lead2 Music",
  T_49_META_TYPE_116_D: "Lead3 Music",
  T_49_META_TYPE_117_D: "Drumbeat music component type",
  T_49_META_TYPE_118_D: "Faction",
  T_49_META_TYPE_119_D: "Attackable options",
  T_49_META_TYPE_12_D: "Combat entities, can attack, take hits, kill, etc.",
  T_49_META_TYPE_120_D: "UI Progress Bar",
  T_49_META_TYPE_121_D: "Interval between waves",
  T_49_META_TYPE_122_D: "Skybox",
  T_49_META_TYPE_123_D: "Enumeration of skybox base types",
  T_49_META_TYPE_124_D: "Claim Range",
  T_49_META_TYPE_125_D: "Can modify the base appearance of objects, such as mapping and transparency",
  T_49_META_TYPE_126_D: "Health Bar",
  T_49_META_TYPE_127_D: "How to move objects",
  T_49_META_TYPE_128_D: "Morphable Object",
  T_49_META_TYPE_129_D: "Loot Ammo Type",
  T_49_META_TYPE_13_D: "UI Widget Entity",
  T_49_META_TYPE_130_D: "Loot Consumable Type",
  T_49_META_TYPE_131_D: "Loot Armor Type",
  T_49_META_TYPE_132_D: "Loot Throwable Type",
  T_49_META_TYPE_133_D: "Loot Scope Type",
  T_49_META_TYPE_134_D: "Loot Weapon Type",
  T_49_META_TYPE_135_D: "Generates ammo drops of the selected type",
  T_49_META_TYPE_136_D: "Generates a consumable drop of the selected type.",
  T_49_META_TYPE_137_D: "Generates a selected type of projectile drop",
  T_49_META_TYPE_138_D: "Spawns a scope drop of the selected type",
  T_49_META_TYPE_139_D: "Generates the selected type of armor drop.",
  T_49_META_TYPE_14_D: "In-game player entities, one per user",
  T_49_META_TYPE_140_D: "Wave",
  T_49_META_TYPE_141_D: "Loot Soccer Type",
  T_49_META_TYPE_142_D: "Loot Soccer Item Box",
  T_49_META_TYPE_143_D: "Lead1 music component type",
  T_49_META_TYPE_144_D: "Lead2 Music Component Type",
  T_49_META_TYPE_145_D: "Lead3 Music Component Type",
  T_49_META_TYPE_146_D: "Key Music Component Type",
  T_49_META_TYPE_147_D: "Multiple preset camera types available, as well as custom camera types",
  T_49_META_TYPE_148_D: "Camera components",
  T_49_META_TYPE_149_D: "Localization Key",
  T_49_META_TYPE_15_D: "In-game team entities, one per team",
  T_49_META_TYPE_150_D: "Oil Drum",
  T_49_META_TYPE_151_D: "Quaternion is a special four-dimensional vector used only to represent rotations",
  T_49_META_TYPE_152_D: "Low-Gravity Area",
  T_49_META_TYPE_153_D: "Entity containers that generate entities of the corresponding type at the location.",
  T_49_META_TYPE_154_D: "Dual-Wield Weapon Type",
  T_49_META_TYPE_155_D: "Helmet entity",
  T_49_META_TYPE_156_D: "Body armor",
  T_49_META_TYPE_157_D: "Camera Transition Type",
  T_49_META_TYPE_158_D: "Text prompt UI",
  T_49_META_TYPE_159_D: "Vector2",
  T_49_META_TYPE_16_D: "Level object entities",
  T_49_META_TYPE_160_D: "Texture Types",
  T_49_META_TYPE_161_D: "Un Replaceable Texture VFX",
  T_49_META_TYPE_162_D: "Type List",
  T_49_META_TYPE_163_D: "Type or Type List",
  T_49_META_TYPE_164_D: "Component is the base class of all entity components or specific component classes.",
  T_49_META_TYPE_165_D: "Collision box component",
  T_49_META_TYPE_166_D: "Emote",
  T_49_META_TYPE_167_D: "Special effect entity represents a displayed special effect (deleted, reusable).",
  T_49_META_TYPE_17_D: "Level Object List",
  T_49_META_TYPE_170_D: "Indicates whether visibility can be set",
  T_49_META_TYPE_171_D: "Mushroom",
  T_49_META_TYPE_172_D: "Ammo",
  T_49_META_TYPE_173_D: "Backpack",
  T_49_META_TYPE_174_D: "Grenade component",
  T_49_META_TYPE_175_D: "Freezing Grenade",
  T_49_META_TYPE_176_D: "Weapon Generator",
  T_49_META_TYPE_177_D: "Motion mode of the camera when there is an obstruction between the camera and the object it is following",
  T_49_META_TYPE_178_D: "Camera's imaging style when rendering a screen",
  T_49_META_TYPE_179_D: "Basic Sphere",
  T_49_META_TYPE_18_D: "(Deprecated, please do not use)",
  T_49_META_TYPE_180_D: "refers to a property of a component",
  T_49_META_TYPE_181_D: "Types used to describe mesh assets",
  T_49_META_TYPE_182_D: "A type used to describe a material asset",
  T_49_META_TYPE_183_D: "A type to describe a texture asset",
  T_49_META_TYPE_184_D: "Bridge rendering component for rendering with built-in model resources",
  T_49_META_TYPE_185_D: "Custom rendering component for rendering with custom model resources",
  T_49_META_TYPE_186_D: "A blank object component that can be used in conjunction with a renderer component, collider component, etc.",
  T_49_META_TYPE_187_D: "Container",
  T_49_META_TYPE_188_D: "Basic Cylinder",
  T_49_META_TYPE_189_D: "List of localized strings",
  T_49_META_TYPE_19_D: "A list template, where the type of content can be specified via T.",
  T_49_META_TYPE_190_D: "Two Team Score Panel",
  T_49_META_TYPE_191_D: "Tactical thrown weapon that blinds enemies within a certain range for a short period of time.",
  T_49_META_TYPE_192_D: "When used, it creates smoke that obscures events, which is a useful tool for interrupting enemy attacks.",
  T_49_META_TYPE_193_D: "Multi-Team Result Panel",
  T_49_META_TYPE_194_D: "Sensor mines that can be placed on the ground and will explode when an enemy approaches, be careful not to step on them yourself",
  T_49_META_TYPE_195_D: "Tween Campaign Playing Style",
  T_49_META_TYPE_197_D: "Playable Components",
  T_49_META_TYPE_198_D: "Item Base",
  T_49_META_TYPE_199_D: "Auxiliary equipment for aerial combat, but you need to keep an eye on the energy consumption at all times",
  T_49_META_TYPE_2_D: "Boolean types, to indicate true, false, or yes/no",
  T_49_META_TYPE_20_D: "A built-in enumeration of UI types, which is automatically generated by the type system.",
  T_49_META_TYPE_200_D: "Jailbreak area",
  T_49_META_TYPE_201_D: "Areas where you can swim after entering",
  T_49_META_TYPE_202_D: "ColliderID",
  T_49_META_TYPE_203_D: "Tween Movement",
  T_49_META_TYPE_204_D: "Shoes fitted with technological power-ups that allow you to jump in the air in two stages",
  T_49_META_TYPE_205_D: "A glider that can fly in the sky, use it to land from a high place to move farther away",
  T_49_META_TYPE_206_D: "Skateboard",
  T_49_META_TYPE_207_D: "Zipline",
  T_49_META_TYPE_208_D: "List of Playables",
  T_49_META_TYPE_209_D: "Playable or List of Playables",
  T_49_META_TYPE_21_D: "Built-in UI entities, which encapsulate specific functionality.",
  T_49_META_TYPE_210_D: "Trajectory Animation is an animation that simulates Trajectory movement.",
  T_49_META_TYPE_211_D: "Coordinate System",
  T_49_META_TYPE_212_D: "One object follows another object",
  T_49_META_TYPE_213_D: "An object's front face is always facing the other object.",
  T_49_META_TYPE_214_D: "An ID that describes a gallery sprite asset",
  T_49_META_TYPE_215_D: "results of a competition",
  T_49_META_TYPE_216_D: "Dictionary data container, the data elements are a pair of Key, Value.",
  T_49_META_TYPE_217_D: "Dictionary data template, can be specified by T1, T2 type of content",
  T_49_META_TYPE_218_D: "A type of light source that emits light of equal intensity in all directions from the position of the light source.",
  T_49_META_TYPE_219_D: "Motorcycle Carrier",
  T_49_META_TYPE_22_D: "Custom UIs, created by the player through the UI editor.",
  T_49_META_TYPE_220_D: "Assault vehicle (tricycle) carrier",
  T_49_META_TYPE_221_D: "Amphibious/Machine Gun Motorcycle Vehicle",
  T_49_META_TYPE_222_D: "Four-wheeled vehicle",
  T_49_META_TYPE_224_D: "Skill Type List",
  T_49_META_TYPE_225_D: "Artificial Intelligence Turret made of high-tech materials that actively searches for and attacks enemies within a certain range.",
  T_49_META_TYPE_226_D: "Turret generated by using turret consumable.",
  T_49_META_TYPE_227_D: "Custom UI widgets type enumeration",
  T_49_META_TYPE_23_D: "An enumeration of the level's object types, which is automatically generated by the system based on the type.",
  T_49_META_TYPE_231_D: "Repair Kit",
  T_49_META_TYPE_233_D: "Progress Circle",
  T_49_META_TYPE_234_D: "Landmine Created",
  T_49_META_TYPE_235_D: "Gloo Wall",
  T_49_META_TYPE_236_D: "Ice Wall Created",
  T_49_META_TYPE_237_D: "Hook Gun",
  T_49_META_TYPE_238_D: "Rainbow Paint Gun",
  T_49_META_TYPE_239_D: "Spray Rifle",
  T_49_META_TYPE_24_D: "Current system-defined damage types",
  T_49_META_TYPE_240_D: "Entities are the carriers of all components, components must be attached to entities to produce instances",
  T_49_META_TYPE_241_D: "Power Hook Gun",
  T_49_META_TYPE_242_D: "Score Bar",
  T_49_META_TYPE_243_D: "Clothing slots",
  T_49_META_TYPE_244_D: "Text entity represents a displayed text",
  T_49_META_TYPE_245_D: "Icon entity represents a displayed icon",
  T_49_META_TYPE_246_D: "Spray Color",
  T_49_META_TYPE_247_D: "Player UI type",
  T_49_META_TYPE_248_D: "General UI switch entity",
  T_49_META_TYPE_249_D: "Switch Equip Slot",
  T_49_META_TYPE_25_D: "Phases of the game, such as game start, game preparation, game end, etc.",
  T_49_META_TYPE_250_D: "Effects entity represents a displayed effect",
  T_49_META_TYPE_2500_D: "The player's birth point",
  T_49_META_TYPE_2501_D: "Triggers for triggering the player's (or other object's) entry and exit events",
  T_49_META_TYPE_2502_D: "Death or invulnerability triggers that control whether the player is dead or invulnerable effects when entering based on properties",
  T_49_META_TYPE_2503_D: "Race mode checkpoints",
  T_49_META_TYPE_2504_D: "Typically used in Race Mode to recognize when a player has entered a specified finish line. This is a specific trigger, custom triggers will be opened later, this endpoint is just a wrapper for custom triggers.",
  T_49_META_TYPE_2505_D: "Fence around the birth point, close it to leave the birth point",
  T_49_META_TYPE_2507_D: "Turret",
  T_49_META_TYPE_2508_D: "Monster Spawn",
  T_49_META_TYPE_2509_D: "Instances of the type can be generated on demand",
  T_49_META_TYPE_251_D: "Effect Container",
  T_49_META_TYPE_2510_D: "Player birth area (rectangle)",
  T_49_META_TYPE_252_D: "Spray Result UI",
  T_49_META_TYPE_253_D: "Hint Button",
  T_49_META_TYPE_254_D: "Heartbeat Effect",
  T_49_META_TYPE_255_D: "Timestamp Localization String",
  T_49_META_TYPE_256_D: "Rigidbody Type",
  T_49_META_TYPE_257_D: "Rigid body components",
  T_49_META_TYPE_258_D: "Timestamp Format Style Type",
  T_49_META_TYPE_259_D: "Tips",
  T_49_META_TYPE_26_D: "Rounds in a game, often a small game with several phases.",
  T_49_META_TYPE_260_D: "Progress Skill Button",
  T_49_META_TYPE_261_D: "Unique ID",
  T_49_META_TYPE_262_D: "Weapon Skin ID",
  T_49_META_TYPE_263_D: "Clothing ID",
  T_49_META_TYPE_264_D: "Consumable ID, when the version only has the weapon ID",
  T_49_META_TYPE_265_D: "UI panel entity",
  T_49_META_TYPE_267_D: "UI scroll view entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_268_D: "A switch with three states, with the option to keep the original logic except for on and off.",
  T_49_META_TYPE_269_D: "The player's equipment.",
  T_49_META_TYPE_270_D: "Entity or Prefab ID",
  T_49_META_TYPE_271_D: "UI panel entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_272_D: "Gender enumeration",
  T_49_META_TYPE_273_D: "Minimap",
  T_49_META_TYPE_274_D: "Icon displayed on the mini-map to follow the target",
  T_49_META_TYPE_275_D: "Individual part nodes in the skeleton",
  T_49_META_TYPE_276_D: "Nodes used to access skinned rigs",
  T_49_META_TYPE_277_D: "Client-side camera ray detection",
  T_49_META_TYPE_278_D: "Pixel blocks displayed on the mini-map, representing the collision size of the object at that location.",
  T_49_META_TYPE_279_D: "Color Drum",
  T_49_META_TYPE_28_D: "Reset at the beginning of each round.",
  T_49_META_TYPE_280_D: "Sphere Trigger",
  T_49_META_TYPE_281_D: "Capsule Trigger",
  T_49_META_TYPE_282_D: "Type describing the asset configuration ID, used to indicate that the parent package comes with the asset configuration ID, which needs to be parsed through the configuration table before loading",
  T_49_META_TYPE_283_D: "Describe the type of asset, used to indicate the identifier of the asset, can be loaded directly.",
  T_49_META_TYPE_284_D: "Indicates a humanoid model resource, which can be replaced with a player character.",
  T_49_META_TYPE_285_D: "A list or dictionary that can be traversed in a loop.",
  T_49_META_TYPE_286_D: "ID to describe the script asset",
  T_49_META_TYPE_287_D: "to describe the ID of a static script asset",
  T_49_META_TYPE_288_D: "to describe the ID of a custom UI asset",
  T_49_META_TYPE_289_D: "ID for describing the body of a preconfigured asset",
  T_49_META_TYPE_29_D: "Special effects",
  T_49_META_TYPE_290_D: "Behavior Tree",
  T_49_META_TYPE_291_D: "Behavior Tree Node Type",
  T_49_META_TYPE_292_D: "Behavior Tree Custom Node",
  T_49_META_TYPE_293_D: "Behavior Tree Attachable",
  T_49_META_TYPE_294_D: "UI layout entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_295_D: "State",
  T_49_META_TYPE_296_D: "Animation Clip",
  T_49_META_TYPE_297_D: "Animation Controller",
  T_49_META_TYPE_298_D: "Loop Type",
  T_49_META_TYPE_3_D: "Integer types, 32-bit signed integers",
  T_49_META_TYPE_30_D: "Icon",
  T_49_META_TYPE_300_D: "UI3DContainer entity, UI edited by the player via the UI Editor",
  T_49_META_TYPE_301_D: "AI Skill Type",
  T_49_META_TYPE_302_D: "Enumeration of equipment slots.",
  T_49_META_TYPE_303_D: "Corresponds to the Id column in BuffData.csv, please check with GPP before adding new items.",
  T_49_META_TYPE_304_D: "Buff Type List",
  T_49_META_TYPE_305_D: "Behavior Tree Node Status",
  T_49_META_TYPE_306_D: "Add buffs, remove buffs, and get a list of buffs already added.",
  T_49_META_TYPE_307_D: "Gloo Maker",
  T_49_META_TYPE_308_D: "Special Item ID Type",
  T_49_META_TYPE_309_D: "Thrown Object Props",
  T_49_META_TYPE_31_D: "Sound Effects",
  T_49_META_TYPE_310_D: "Crossbow",
  T_49_META_TYPE_311_D: "Grenade Base",
  T_49_META_TYPE_312_D: "Throwable props",
  T_49_META_TYPE_313_D: "Grenade DeIce Wall",
  T_49_META_TYPE_314_D: "Managing Animation Controllers and Resources",
  T_49_META_TYPE_315_D: "Player Backpack",
  T_49_META_TYPE_316_D: "UITexture entity, the UI edited by the player through the UI editor",
  T_49_META_TYPE_317_D: "Rigid body motion constraints, each of which can be used in combination",
  T_49_META_TYPE_318_D: "Attachment",
  T_49_META_TYPE_319_D: "Fill type enumeration",
  T_49_META_TYPE_32_D: "Player state type",
  T_49_META_TYPE_320_D: "Fill direction",
  T_49_META_TYPE_321_D: "Entities that can be target-assisted",
  T_49_META_TYPE_322_D: "Damaged Body Part Type",
  T_49_META_TYPE_323_D: "UIProfileInfo entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_324_D: "Several different effects of rigid body forces. Note that this only works for Dynamic types.",
  T_49_META_TYPE_325_D: "to describe the ID of a widget in a custom UI asset",
  T_49_META_TYPE_326_D: "Player profile information",
  T_49_META_TYPE_327_D: "Configure dressing according to each component",
  T_49_META_TYPE_328_D: "Behavior Tree ID",
  T_49_META_TYPE_329_D: "Seat Type",
  T_49_META_TYPE_33_D: "Sort by: ascending ignore zero value, descending, ascending",
  T_49_META_TYPE_330_D: "Self-relative movement",
  T_49_META_TYPE_331_D: "Bezier Curve",
  T_49_META_TYPE_332_D: "Loopable component",
  T_49_META_TYPE_333_D: "Font Type",
  T_49_META_TYPE_334_D: "Vehicle Skin ID",
  T_49_META_TYPE_335_D: "The sound entity represents a playing sound effect.",
  T_49_META_TYPE_336_D: "Sound Effect List",
  T_49_META_TYPE_337_D: "Sound Effect or Sound Effect List",
  T_49_META_TYPE_338_D: "Player behavior property synchronization entity",
  T_49_META_TYPE_339_D: "Equipment Accessory",
  T_49_META_TYPE_34_D: "Item ID",
  T_49_META_TYPE_340_D: "Bot Difficulty Type",
  T_49_META_TYPE_341_D: "Dictionary of integers",
  T_49_META_TYPE_342_D: "Timer objects",
  T_49_META_TYPE_343_D: "Flying Daggers (pickable)",
  T_49_META_TYPE_344_D: "Throwing Knife",
  T_49_META_TYPE_345_D: "Weapon Type",
  T_49_META_TYPE_346_D: "Ammo Type",
  T_49_META_TYPE_347_D: "Frame Self Relative",
  T_49_META_TYPE_348_D: "Function pointer to a function instance, used to implement dummy functions or delegate mechanism.",
  T_49_META_TYPE_349_D: "A handle to a concurrent program, which can be used to perform some handle operations.",
  T_49_META_TYPE_350_D: "Vehicle enumeration",
  T_49_META_TYPE_351_D: "Describes the type of the object",
  T_49_META_TYPE_352_D: "UIToggle entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_353_D: "MedKit",
  T_49_META_TYPE_354_D: "Inhaler",
  T_49_META_TYPE_355_D: "Horizaline",
  T_49_META_TYPE_356_D: "Airdrops, will start dropping from a high place after the preparation time is over",
  T_49_META_TYPE_357_D: "Descriptive colors for objects, such as borders, surfaces, etc. (deleted, reusable)",
  T_49_META_TYPE_358_D: "Refers to an event",
  T_49_META_TYPE_359_D: "Player controller with physics effects to apply forces.",
  T_49_META_TYPE_360_D: "Launch Pad",
  T_49_META_TYPE_361_D: "Folded cannon, when unfolded it can be used to launch people out, be careful not to launch yourself out of the safe zone!",
  T_49_META_TYPE_362_D: "Snowball fight! Punch it!",
  T_49_META_TYPE_363_D: "Shop request purchase",
  T_49_META_TYPE_364_D: "AnimationTrigger",
  T_49_META_TYPE_365_D: "Animation Trigger UI Component",
  T_49_META_TYPE_366_D: "Batch Combine Render",
  T_49_META_TYPE_367_D: "Top Compass",
  T_49_META_TYPE_368_D: "Custom character resource ID",
  T_49_META_TYPE_369_D: "Custom animation resource ID",
  T_49_META_TYPE_370_D: "Information displayed at the start of a round",
  T_49_META_TYPE_371_D: "At the end of each round, the results are displayed.",
  T_49_META_TYPE_372_D: "Player Stance Types",
  T_49_META_TYPE_373_D: "Collection ID, used for resource information collection",
  T_49_META_TYPE_374_D: "Follow Health Bar",
  T_49_META_TYPE_375_D: "Monster target type",
  T_49_META_TYPE_376_D: "Defense tower attack target type",
  T_49_META_TYPE_377_D: "Alias to refer to player entity, vehicle entity type",
  T_49_META_TYPE_378_D: "to describe the ID of an audio asset",
  T_49_META_TYPE_379_D: "ID to describe the configuration table asset",
  T_49_META_TYPE_38_D: "UI Empty Widget entity, UI edited by the player through the UI editor.",
  T_49_META_TYPE_380_D: "ID to describe the effects asset",
  T_49_META_TYPE_381_D: "ID to describe the Animation Controller asset",
  T_49_META_TYPE_382_D: "How knockdown status is handled",
  T_49_META_TYPE_383_D: "Surface or decorations on the map itself",
  T_49_META_TYPE_384_D: "Items",
  T_49_META_TYPE_385_D: "Character Skill ID",
  T_49_META_TYPE_386_D: "Skill ID List",
  T_49_META_TYPE_387_D: "UITouchPad entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_388_D: "Backpack Skin ID",
  T_49_META_TYPE_389_D: "Joystick entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_39_D: "UI image entity, the UI edited by the player through the UI editor.",
  T_49_META_TYPE_390_D: "Hierarchical",
  T_49_META_TYPE_391_D: "Custom UI or Widget",
  T_49_META_TYPE_392_D: "Placeable out-of-zone objects",
  T_49_META_TYPE_393_D: "Entities with PhysicalCCT or Rigidbody component",
  T_49_META_TYPE_394_D: "Mathematical constants",
  T_49_META_TYPE_395_D: "Entities with PhysicalCCT or PlayerCCT components can move along with them.",
  T_49_META_TYPE_396_D: "Mid-Game Exit Configuration",
  T_49_META_TYPE_397_D: "Components used to describe collision shapes",
  T_49_META_TYPE_398_D: "String or Localization String",
  T_49_META_TYPE_399_D: "Character Controller with Physical Effects, for FF characters only.",
  T_49_META_TYPE_4_D: "Floating-point type, 32-bit single-precision floating-point number",
  T_49_META_TYPE_40_D: "UI Text entity, the UI edited by the player through the UI editor.",
  T_49_META_TYPE_400_D: "How to perform the attack behavior",
  T_49_META_TYPE_401_D: "Fire Type",
  T_49_META_TYPE_402_D: "Social Button Widget",
  T_49_META_TYPE_403_D: "Social Button Types",
  T_49_META_TYPE_404_D: "Social Button Styles",
  T_49_META_TYPE_405_D: "Layout Sort Type",
  T_49_META_TYPE_406_D: "Can be triggered to go over obstacles",
  T_49_META_TYPE_407_D: "Platform Type",
  T_49_META_TYPE_408_D: "Base Data Alias",
  T_49_META_TYPE_409_D: "Error code enumeration",
  T_49_META_TYPE_41_D: "UI button entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_410_D: "Alias that refers to a player entity or Transform entity type",
  T_49_META_TYPE_411_D: "Helicopter Carrier",
  T_49_META_TYPE_412_D: "Vehicle component, which is an extension of the Carrier component.",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "Limits the range of camera rotation angles",
  T_49_META_TYPE_415_D: "Persona",
  T_49_META_TYPE_416_D: "Persona Chat Window UI",
  T_49_META_TYPE_417_D: "Particle entity component",
  T_49_META_TYPE_418_D: "Member status enumeration",
  T_49_META_TYPE_419_D: "Gun Skin Type",
  T_49_META_TYPE_42_D: "UI input entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_420_D: "Vehicle Skin Types",
  T_49_META_TYPE_421_D: "Skin",
  T_49_META_TYPE_422_D: "Backpack Skin Types",
  T_49_META_TYPE_423_D: "Persona ID",
  T_49_META_TYPE_424_D: "Fog effect base type",
  T_49_META_TYPE_425_D: "Particle asset ID",
  T_49_META_TYPE_426_D: "A type of light source that emits a cone of light in the negative Y-axis direction from the light source, defaulting to the ground.",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "Clothing information to be retained when the player transforms into another character.",
  T_49_META_TYPE_429_D: "Player or NPC entities",
  T_49_META_TYPE_43_D: "List of element types that must be player entities",
  T_49_META_TYPE_430_D: "Random Number Generator",
  T_49_META_TYPE_431_D: "Motion objects moving along a customized path",
  T_49_META_TYPE_432_D: "Custom Curve Path Waypoints",
  T_49_META_TYPE_433_D: "Custom curve path waypoint types",
  T_49_META_TYPE_434_D: "Custom Curve Paths",
  T_49_META_TYPE_435_D: "List of unique player identifiers",
  T_49_META_TYPE_436_D: "Error code list",
  T_49_META_TYPE_437_D: "Two teams match details UI entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_438_D: "Multi-team match details UI entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_439_D: "Combine",
  T_49_META_TYPE_44_D: "A list of entities whose element types must be team entities",
  T_49_META_TYPE_440_D: "Timeline",
  T_49_META_TYPE_441_D: "Timeline Resource ID",
  T_49_META_TYPE_442_D: "New two-team match information short version entity component, supports fully customizable headcount display",
  T_49_META_TYPE_443_D: "Dialog stream asset ID",
  T_49_META_TYPE_444_D: "Language Type",
  T_49_META_TYPE_45_D: "Bool List",
  T_49_META_TYPE_46_D: "Int List",
  T_49_META_TYPE_47_D: "Float List",
  T_49_META_TYPE_48_D: "String List",
  T_49_META_TYPE_49_D: "Vector3 List",
  T_49_META_TYPE_5_D: "String type, value is text content",
  T_49_META_TYPE_50_D: "A list of entities whose element types must be entities",
  T_49_META_TYPE_51_D: "Zombie Types",
  T_49_META_TYPE_53_D: "Common Level Object",
  T_49_META_TYPE_54_D: "Destructible Object",
  T_49_META_TYPE_55_D: "General Spawn Point",
  T_49_META_TYPE_56_D: "Vehicle",
  T_49_META_TYPE_57_D: "Players can be teleported to a specific location upon entry",
  T_49_META_TYPE_58_D: "Buffs can be generated on demand",
  T_49_META_TYPE_59_D: "Moving Platform",
  T_49_META_TYPE_6_D: "Three-dimensional vectors, which can represent spatial coordinates or spatial directions",
  T_49_META_TYPE_60_D: "Generates a weapon drop of the selected type.",
  T_49_META_TYPE_61_D: "Entering the trigger range opens the Bound Shop.",
  T_49_META_TYPE_62_D: "Bouncy Dice",
  T_49_META_TYPE_63_D: "Players step on them and they will be bounced to a specific location.",
  T_49_META_TYPE_64_D: "Players will make a sound when stepping on them",
  T_49_META_TYPE_65_D: "Basic Scalable",
  T_49_META_TYPE_66_D: "Custom Path",
  T_49_META_TYPE_67_D: "Path Point",
  T_49_META_TYPE_68_D: "AI monster entities, such as zombies",
  T_49_META_TYPE_69_D: "Large numbers are high precision floating point numbers",
  T_49_META_TYPE_7_D: "Numbers are type aliases that refer to integer, 64-bit integer, or floating-point types",
  T_49_META_TYPE_70_D: "Property formulas are used to calculate entity property values, only some player properties and weapon properties are supported for now.",
  T_49_META_TYPE_71_D: "Only used for entities sold in the shop, the concept of shop items is different from that of items purchased.",
  T_49_META_TYPE_72_D: "Contains several shop items.",
  T_49_META_TYPE_73_D: "Contains several shelves.",
  T_49_META_TYPE_74_D: "Item ID",
  T_49_META_TYPE_75_D: "Come Back",
  T_49_META_TYPE_76_D: "Patrol style",
  T_49_META_TYPE_77_D: "A generator entity that can generate and refresh objects.",
  T_49_META_TYPE_78_D: "A unit entity that can be used by the unit generator to absorb and generate units in batches.",
  T_49_META_TYPE_79_D: "Weapon",
  T_49_META_TYPE_8_D: "Conditionals are special Bool types",
  T_49_META_TYPE_80_D: "UI of the shop",
  T_49_META_TYPE_81_D: "Buff Type",
  T_49_META_TYPE_82_D: "UI Heartbeat",
  T_49_META_TYPE_83_D: "Interaction Button",
  T_49_META_TYPE_84_D: "Rankable entity, capable of being ranked",
  T_49_META_TYPE_85_D: "Scoreable entity, has its own score",
  T_49_META_TYPE_86_D: "Property formula factor type",
  T_49_META_TYPE_87_D: "Describes the type of RGBA color, the range of value is 0~255 for each channel.",
  T_49_META_TYPE_88_D: "Currency type, currently only the base currency type",
  T_49_META_TYPE_89_D: "Currency entity, which describes the type and amount of currency.",
  T_49_META_TYPE_9_D: "A set of conditions",
  T_49_META_TYPE_90_D: "Wallet entities are containers for a bunch of currency entities",
  T_49_META_TYPE_91_D: "Indicates an integer or integer array type.",
  T_49_META_TYPE_92_D: "Dynamic Create Level Object Type",
  T_49_META_TYPE_93_D: "Entities with formulable properties",
  T_49_META_TYPE_94_D: "Property modification",
  T_49_META_TYPE_95_D: "Coin Generator",
  T_49_META_TYPE_96_D: "Wallet",
  T_49_META_TYPE_97_D: "Position rotation and scaling, supports parent-child structure",
  T_49_META_TYPE_98_D: "List all available types",
  T_49_META_TYPE_99_D: "Football"
};
export {
  _ as default
};
